/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 8318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function(self) {
    'use strict';

    var nativeURLSearchParams = (self.URLSearchParams && self.URLSearchParams.prototype.get) ? self.URLSearchParams : null,
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
        __URLSearchParams__ = "__URLSearchParams__",
        // Fix bug in Edge which cannot encode ' &' correctly
        encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
            var ampersandTest = new nativeURLSearchParams();
            ampersandTest.append('s', ' &');
            return ampersandTest.toString() === 's=+%26';
        })() : true,
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }
        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype['delete'] = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return name in this [__URLSearchParams__];
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy);
    /*
     * Apply polifill to global object and append other prototype into it
     */
    Object.defineProperty(self, 'URLSearchParams', {
        value: (useProxy ?
            // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
            new Proxy(nativeURLSearchParams, {
                construct: function(target, args) {
                    return new target((new URLSearchParamsPolyfill(args[0]).toString()));
                }
            }) :
            URLSearchParamsPolyfill)
    });

    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this['delete'](keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }


    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return str
            .replace(/[ +]/g, '%20')
            .replace(/(%[a-f0-9]{2})+/ig, function(match) {
                return decodeURIComponent(match);
            });
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            // if `search` is an array, treat it as a sequence
            if (isArray(search)) {
                for (var i = 0; i < search.length; i++) {
                    var item = search[i];
                    if (isArray(item) && item.length === 2) {
                        appendTo(dict, item[0], item[1]);
                    } else {
                        throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
                    }
                }

            } else {
                for (var key in search) {
                    if (search.hasOwnProperty(key)) {
                        appendTo(dict, key, search[key]);
                    }
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : (
            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
        )

        if (name in dict) {
            dict[name].push(val);
        } else {
            dict[name] = [val];
        }
    }

    function isArray(val) {
        return !!val && '[object Array]' === Object.prototype.toString.call(val);
    }

})(typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : (typeof window !== 'undefined' ? window : this));


/***/ }),

/***/ 5679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./i18n.json": 6029,
	"./i18n_da.json": 8917,
	"./i18n_de.json": 6657,
	"./i18n_en-GB.json": 9789,
	"./i18n_en.json": 1445,
	"./i18n_es.json": 5246,
	"./i18n_fr.json": 8214,
	"./i18n_nl.json": 4312,
	"./i18n_sv.json": 4207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5679;

/***/ }),

/***/ 904:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ 3076:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
  0;
})((function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get.bind();
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }

        return desc.value;
      };
    }

    return _get.apply(this, arguments);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function () {};

        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function () {
        it = it.call(o);
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  var Emitter = /*#__PURE__*/function () {
    function Emitter() {
      _classCallCheck(this, Emitter);

      Object.defineProperty(this, 'listeners', {
        value: {},
        writable: true,
        configurable: true
      });
    }

    _createClass(Emitter, [{
      key: "addEventListener",
      value: function addEventListener(type, callback, options) {
        if (!(type in this.listeners)) {
          this.listeners[type] = [];
        }

        this.listeners[type].push({
          callback: callback,
          options: options
        });
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(type, callback) {
        if (!(type in this.listeners)) {
          return;
        }

        var stack = this.listeners[type];

        for (var i = 0, l = stack.length; i < l; i++) {
          if (stack[i].callback === callback) {
            stack.splice(i, 1);
            return;
          }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (!(event.type in this.listeners)) {
          return;
        }

        var stack = this.listeners[event.type];
        var stackToCall = stack.slice();

        for (var i = 0, l = stackToCall.length; i < l; i++) {
          var listener = stackToCall[i];

          try {
            listener.callback.call(this, event);
          } catch (e) {
            Promise.resolve().then(function () {
              throw e;
            });
          }

          if (listener.options && listener.options.once) {
            this.removeEventListener(event.type, listener.callback);
          }
        }

        return !event.defaultPrevented;
      }
    }]);

    return Emitter;
  }();

  var AbortSignal = /*#__PURE__*/function (_Emitter) {
    _inherits(AbortSignal, _Emitter);

    var _super = _createSuper(AbortSignal);

    function AbortSignal() {
      var _this;

      _classCallCheck(this, AbortSignal);

      _this = _super.call(this); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
      // constructor has failed to run, then "this.listeners" will still be undefined and then we call
      // the parent constructor directly instead as a workaround. For general details, see babel bug:
      // https://github.com/babel/babel/issues/3041
      // This hack was added as a fix for the issue described here:
      // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042

      if (!_this.listeners) {
        Emitter.call(_assertThisInitialized(_this));
      } // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl


      Object.defineProperty(_assertThisInitialized(_this), 'aborted', {
        value: false,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this), 'onabort', {
        value: null,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this), 'reason', {
        value: undefined,
        writable: true,
        configurable: true
      });
      return _this;
    }

    _createClass(AbortSignal, [{
      key: "toString",
      value: function toString() {
        return '[object AbortSignal]';
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (event.type === 'abort') {
          this.aborted = true;

          if (typeof this.onabort === 'function') {
            this.onabort.call(this, event);
          }
        }

        _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
      }
      /**
       * @see {@link https://developer.mozilla.org/zh-CN/docs/Web/API/AbortSignal/throwIfAborted}
       */

    }, {
      key: "throwIfAborted",
      value: function throwIfAborted() {
        var aborted = this.aborted,
            _this$reason = this.reason,
            reason = _this$reason === void 0 ? 'Aborted' : _this$reason;
        if (!aborted) return;
        throw reason;
      }
      /**
       * @see {@link https://developer.mozilla.org/zh-CN/docs/Web/API/AbortSignal/timeout_static}
       * @param {number} time The "active" time in milliseconds before the returned {@link AbortSignal} will abort.
       *                      The value must be within range of 0 and {@link Number.MAX_SAFE_INTEGER}.
       * @returns {AbortSignal} The signal will abort with its {@link AbortSignal.reason} property set to a `TimeoutError` {@link DOMException} on timeout,
       *                        or an `AbortError` {@link DOMException} if the operation was user-triggered.
       */

    }], [{
      key: "timeout",
      value: function timeout(time) {
        var controller = new AbortController();
        setTimeout(function () {
          return controller.abort(new DOMException("This signal is timeout in ".concat(time, "ms"), 'TimeoutError'));
        }, time);
        return controller.signal;
      }
      /**
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/any_static}
       * @param {Iterable<AbortSignal>} iterable An {@link Iterable} (such as an {@link Array}) of abort signals.
       * @returns {AbortSignal} - **Already aborted**, if any of the abort signals given is already aborted.
       *                          The returned {@link AbortSignal}'s reason will be already set to the `reason` of the first abort signal that was already aborted.
       *                        - **Asynchronously aborted**, when any abort signal in `iterable` aborts.
       *                          The `reason` will be set to the reason of the first abort signal that is aborted.
       */

    }, {
      key: "any",
      value: function any(iterable) {
        var controller = new AbortController();
        /**
         * @this AbortSignal
         */

        function abort() {
          controller.abort(this.reason);
          clean();
        }

        function clean() {
          var _iterator = _createForOfIteratorHelper(iterable),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var signal = _step.value;
              signal.removeEventListener('abort', abort);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        var _iterator2 = _createForOfIteratorHelper(iterable),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var signal = _step2.value;

            if (signal.aborted) {
              controller.abort(signal.reason);
              break;
            } else signal.addEventListener('abort', abort);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return controller.signal;
      }
    }]);

    return AbortSignal;
  }(Emitter);
  var AbortController = /*#__PURE__*/function () {
    function AbortController() {
      _classCallCheck(this, AbortController);

      // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController()) to be [] for compat with the native impl
      Object.defineProperty(this, 'signal', {
        value: new AbortSignal(),
        writable: true,
        configurable: true
      });
    }

    _createClass(AbortController, [{
      key: "abort",
      value: function abort(reason) {
        var event;

        try {
          event = new Event('abort');
        } catch (e) {
          if (typeof document !== 'undefined') {
            if (!document.createEvent) {
              // For Internet Explorer 8:
              event = document.createEventObject();
              event.type = 'abort';
            } else {
              // For Internet Explorer 11:
              event = document.createEvent('Event');
              event.initEvent('abort', false, false);
            }
          } else {
            // Fallback where document isn't available:
            event = {
              type: 'abort',
              bubbles: false,
              cancelable: false
            };
          }
        }

        var signalReason = reason;

        if (signalReason === undefined) {
          if (typeof document === 'undefined') {
            signalReason = new Error('This operation was aborted');
            signalReason.name = 'AbortError';
          } else {
            try {
              signalReason = new DOMException('signal is aborted without reason');
              signalReason.name = 'AbortError';
            } catch (err) {
              // IE 11 does not support calling the DOMException constructor, use a
              // regular error object on it instead.
              signalReason = new Error('This operation was aborted');
              signalReason.name = 'AbortError';
            }
          }
        }

        this.signal.reason = signalReason;
        this.signal.dispatchEvent(event);
      }
    }, {
      key: "toString",
      value: function toString() {
        return '[object AbortController]';
      }
    }]);

    return AbortController;
  }();

  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    // These are necessary to make sure that we get correct output for:
    // Object.prototype.toString.call(new AbortController())
    AbortController.prototype[Symbol.toStringTag] = 'AbortController';
    AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
  }

  function polyfillNeeded(self) {
    if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
      return true;
    } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // so the below feature detection needs the !self.AbortController part.
    // The Request.prototype check is also needed because Safari versions 11.1.2
    // up to and including 12.1.x has a window.AbortController present but still
    // does NOT correctly implement abortable fetch:
    // https://bugs.webkit.org/show_bug.cgi?id=174980#c2


    return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
  }

  /**
   * Note: the "fetch.Request" default value is available for fetch imported from
   * the "node-fetch" package and not in browsers. This is OK since browsers
   * will be importing umd-polyfill.js from that path "self" is passed the
   * decorator so the default value will not be used (because browsers that define
   * fetch also has Request). One quirky setup where self.fetch exists but
   * self.Request does not is when the "unfetch" minimal fetch polyfill is used
   * on top of IE11; for this case the browser will try to use the fetch.Request
   * default value which in turn will be undefined but then then "if (Request)"
   * will ensure that you get a patched fetch but still no Request (as expected).
   * @param {fetch, Request = fetch.Request}
   * @returns {fetch: abortableFetch, Request: AbortableRequest}
   */

  function abortableFetchDecorator(patchTargets) {
    if ('function' === typeof patchTargets) {
      patchTargets = {
        fetch: patchTargets
      };
    }

    var _patchTargets = patchTargets,
        fetch = _patchTargets.fetch,
        _patchTargets$Request = _patchTargets.Request,
        NativeRequest = _patchTargets$Request === void 0 ? fetch.Request : _patchTargets$Request,
        NativeAbortController = _patchTargets.AbortController,
        _patchTargets$__FORCE = _patchTargets.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,
        __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL = _patchTargets$__FORCE === void 0 ? false : _patchTargets$__FORCE;

    if (!polyfillNeeded({
      fetch: fetch,
      Request: NativeRequest,
      AbortController: NativeAbortController,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL
    })) {
      return {
        fetch: fetch,
        Request: Request
      };
    }

    var Request = NativeRequest; // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // hence we only patch it if it's available. Also we don't patch it if signal
    // is already available on the Request prototype because in this case support
    // is present and the patching below can cause a crash since it assigns to
    // request.signal which is technically a read-only property. This latter error
    // happens when you run the main5.js node-fetch example in the repo
    // "abortcontroller-polyfill-examples". The exact error is:
    //   request.signal = init.signal;
    //   ^
    // TypeError: Cannot set property signal of #<Request> which has only a getter

    if (Request && !Request.prototype.hasOwnProperty('signal') || __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      Request = function Request(input, init) {
        var signal;

        if (init && init.signal) {
          signal = init.signal; // Never pass init.signal to the native Request implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to construct 'Request': member signal is not of type AbortSignal.

          delete init.signal;
        }

        var request = new NativeRequest(input, init);

        if (signal) {
          Object.defineProperty(request, 'signal', {
            writable: false,
            enumerable: false,
            configurable: true,
            value: signal
          });
        }

        return request;
      };

      Request.prototype = NativeRequest.prototype;
    }

    var realFetch = fetch;

    var abortableFetch = function abortableFetch(input, init) {
      var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;

      if (signal) {
        var abortError;

        try {
          abortError = new DOMException('Aborted', 'AbortError');
        } catch (err) {
          // IE 11 does not support calling the DOMException constructor, use a
          // regular error object on it instead.
          abortError = new Error('Aborted');
          abortError.name = 'AbortError';
        } // Return early if already aborted, thus avoiding making an HTTP request


        if (signal.aborted) {
          return Promise.reject(abortError);
        } // Turn an event into a promise, reject it once `abort` is dispatched


        var cancellation = new Promise(function (_, reject) {
          signal.addEventListener('abort', function () {
            return reject(abortError);
          }, {
            once: true
          });
        });

        if (init && init.signal) {
          // Never pass .signal to the native implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to execute 'fetch' on 'Window': member signal is not of type AbortSignal.
          delete init.signal;
        } // Return the fastest promise (don't need to wait for request to finish)


        return Promise.race([cancellation, realFetch(input, init)]);
      }

      return realFetch(input, init);
    };

    return {
      fetch: abortableFetch,
      Request: Request
    };
  }

  (function (self) {

    if (!polyfillNeeded(self)) {
      return;
    }

    if (!self.fetch) {
      console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
      return;
    }

    var _abortableFetch = abortableFetchDecorator(self),
        fetch = _abortableFetch.fetch,
        Request = _abortableFetch.Request;

    self.fetch = fetch;
    self.Request = Request;
    Object.defineProperty(self, 'AbortController', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortController
    });
    Object.defineProperty(self, 'AbortSignal', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortSignal
    });
  })(typeof self !== 'undefined' ? self : __webpack_require__.g);

}));


/***/ }),

/***/ 2743:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 1743:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _regeneratorRuntime=(__webpack_require__(1981)["default"]);var _createForOfIteratorHelper=(__webpack_require__(1119)["default"]);var _asyncToGenerator=(__webpack_require__(9049)["default"]);var _slicedToArray=(__webpack_require__(839)["default"]);var _objectSpread=(__webpack_require__(3378)["default"]);var _toConsumableArray=(__webpack_require__(4728)["default"]);var _defineProperty2=(__webpack_require__(3665)["default"]);var _typeof2=(__webpack_require__(6446)["default"]);__webpack_require__(8070);__webpack_require__(3510);__webpack_require__(2432);__webpack_require__(5307);__webpack_require__(9392);__webpack_require__(7107);__webpack_require__(6411);__webpack_require__(5305);__webpack_require__(3252);__webpack_require__(1875);__webpack_require__(2234);__webpack_require__(3873);__webpack_require__(4147);__webpack_require__(8981);__webpack_require__(9375);__webpack_require__(6569);__webpack_require__(3975);__webpack_require__(8803);__webpack_require__(595);__webpack_require__(3277);__webpack_require__(1402);__webpack_require__(4727);__webpack_require__(8794);__webpack_require__(8470);__webpack_require__(1806);__webpack_require__(7324);__webpack_require__(3185);__webpack_require__(7403);__webpack_require__(7050);__webpack_require__(7678);__webpack_require__(6963);__webpack_require__(2380);__webpack_require__(2082);__webpack_require__(8291);__webpack_require__(7265);__webpack_require__(1280);__webpack_require__(630);__webpack_require__(865);__webpack_require__(7212);__webpack_require__(2283);__webpack_require__(7087);__webpack_require__(8697);__webpack_require__(8096);__webpack_require__(8376);__webpack_require__(7146);__webpack_require__(206);__webpack_require__(6929);__webpack_require__(568);__webpack_require__(5668);__webpack_require__(9033);__webpack_require__(8903);__webpack_require__(1018);__webpack_require__(1415);__webpack_require__(4448);__webpack_require__(8871);__webpack_require__(6539);__webpack_require__(3536);__webpack_require__(7748);__webpack_require__(1011);__webpack_require__(9428);__webpack_require__(3498);__webpack_require__(4293);__webpack_require__(8225);__webpack_require__(6741);__webpack_require__(2273);__webpack_require__(1045);__webpack_require__(163);__webpack_require__(5950);__webpack_require__(5350);__webpack_require__(4915);__webpack_require__(5367);__webpack_require__(8867);__webpack_require__(7010);__webpack_require__(5960);/******/(function(){// webpackBootstrap
/******/var __webpack_modules__={/***/5679:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_4799__){var map={"./i18n.json":6029,"./i18n_da.json":8917,"./i18n_de.json":6657,"./i18n_en-GB.json":9789,"./i18n_en.json":1445,"./i18n_es.json":5246,"./i18n_fr.json":8214,"./i18n_nl.json":4312,"./i18n_sv.json":4207};function webpackContext(req){var id=webpackContextResolve(req);return __nested_webpack_require_4799__(id);}function webpackContextResolve(req){if(!__nested_webpack_require_4799__.o(map,req)){var e=new Error("Cannot find module '"+req+"'");e.code='MODULE_NOT_FOUND';throw e;}return map[req];}webpackContext.keys=function webpackContextKeys(){return Object.keys(map);};webpackContext.resolve=webpackContextResolve;module.exports=webpackContext;webpackContext.id=5679;/***/}),/***/904:(/***/function _(module,exports){var __WEBPACK_AMD_DEFINE_FACTORY__,__WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill
// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505
(function(root,factory){if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__=[],__WEBPACK_AMD_DEFINE_FACTORY__=factory,__WEBPACK_AMD_DEFINE_RESULT__=typeof __WEBPACK_AMD_DEFINE_FACTORY__==='function'?__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__):__WEBPACK_AMD_DEFINE_FACTORY__,__WEBPACK_AMD_DEFINE_RESULT__!==undefined&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__));}else{}})(typeof self!=='undefined'?self:this,function(){function getCurrentScript(){var descriptor=Object.getOwnPropertyDescriptor(document,'currentScript');// for chrome
if(!descriptor&&'currentScript'in document&&document.currentScript){return document.currentScript;}// for other browsers with native support for currentScript
if(descriptor&&descriptor.get!==getCurrentScript&&document.currentScript){return document.currentScript;}// IE 8-10 support script readyState
// IE 11+ & Firefox support stack trace
try{throw new Error();}catch(err){// Find the second match for the "at" string to get file src url from stack.
var ieStackRegExp=/.*at [^(]*\((.*):(.+):(.+)\)$/ig,ffStackRegExp=/@([^@]*):(\d+):(\d+)\s*$/ig,stackDetails=ieStackRegExp.exec(err.stack)||ffStackRegExp.exec(err.stack),scriptLocation=stackDetails&&stackDetails[1]||false,line=stackDetails&&stackDetails[2]||false,currentLocation=document.location.href.replace(document.location.hash,''),pageSource,inlineScriptSourceRegExp,inlineScriptSource,scripts=document.getElementsByTagName('script');// Live NodeList collection
if(scriptLocation===currentLocation){pageSource=document.documentElement.outerHTML;inlineScriptSourceRegExp=new RegExp('(?:[^\\n]+?\\n){0,'+(line-2)+'}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*','i');inlineScriptSource=pageSource.replace(inlineScriptSourceRegExp,'$1').trim();}for(var i=0;i<scripts.length;i++){// If ready state is interactive, return the script tag
if(scripts[i].readyState==='interactive'){return scripts[i];}// If src matches, return the script tag
if(scripts[i].src===scriptLocation){return scripts[i];}// If inline source matches, return the script tag
if(scriptLocation===currentLocation&&scripts[i].innerHTML&&scripts[i].innerHTML.trim()===inlineScriptSource){return scripts[i];}}// If no match, return null
return null;}};return getCurrentScript;});/***/}),/***/2743:(/***/function _(module){"use strict";var isMergeableObject=function isMergeableObject(value){return isNonNullObject(value)&&!isSpecial(value);};function isNonNullObject(value){return!!value&&_typeof2(value)==='object';}function isSpecial(value){var stringValue=Object.prototype.toString.call(value);return stringValue==='[object RegExp]'||stringValue==='[object Date]'||isReactElement(value);}// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol=typeof Symbol==='function'&&Symbol.for;var REACT_ELEMENT_TYPE=canUseSymbol?Symbol.for('react.element'):0xeac7;function isReactElement(value){return value.$$typeof===REACT_ELEMENT_TYPE;}function emptyTarget(val){return Array.isArray(val)?[]:{};}function cloneUnlessOtherwiseSpecified(value,options){return options.clone!==false&&options.isMergeableObject(value)?deepmerge(emptyTarget(value),value,options):value;}function defaultArrayMerge(target,source,options){return target.concat(source).map(function(element){return cloneUnlessOtherwiseSpecified(element,options);});}function getMergeFunction(key,options){if(!options.customMerge){return deepmerge;}var customMerge=options.customMerge(key);return typeof customMerge==='function'?customMerge:deepmerge;}function getEnumerableOwnPropertySymbols(target){return Object.getOwnPropertySymbols?Object.getOwnPropertySymbols(target).filter(function(symbol){return Object.propertyIsEnumerable.call(target,symbol);}):[];}function getKeys(target){return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));}function propertyIsOnObject(object,property){try{return property in object;}catch(_){return false;}}// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target,key){return propertyIsOnObject(target,key)// Properties are safe to merge if they don't exist in the target yet,
&&!(Object.hasOwnProperty.call(target,key)// unsafe if they exist up the prototype chain,
&&Object.propertyIsEnumerable.call(target,key));// and also unsafe if they're nonenumerable.
}function mergeObject(target,source,options){var destination={};if(options.isMergeableObject(target)){getKeys(target).forEach(function(key){destination[key]=cloneUnlessOtherwiseSpecified(target[key],options);});}getKeys(source).forEach(function(key){if(propertyIsUnsafe(target,key)){return;}if(propertyIsOnObject(target,key)&&options.isMergeableObject(source[key])){destination[key]=getMergeFunction(key,options)(target[key],source[key],options);}else{destination[key]=cloneUnlessOtherwiseSpecified(source[key],options);}});return destination;}function deepmerge(target,source,options){options=options||{};options.arrayMerge=options.arrayMerge||defaultArrayMerge;options.isMergeableObject=options.isMergeableObject||isMergeableObject;// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
// implementations can use it. The caller may not replace it.
options.cloneUnlessOtherwiseSpecified=cloneUnlessOtherwiseSpecified;var sourceIsArray=Array.isArray(source);var targetIsArray=Array.isArray(target);var sourceAndTargetTypesMatch=sourceIsArray===targetIsArray;if(!sourceAndTargetTypesMatch){return cloneUnlessOtherwiseSpecified(source,options);}else if(sourceIsArray){return options.arrayMerge(target,source,options);}else{return mergeObject(target,source,options);}}deepmerge.all=function deepmergeAll(array,options){if(!Array.isArray(array)){throw new Error('first argument should be an array');}return array.reduce(function(prev,next){return deepmerge(prev,next,options);},{});};var deepmerge_1=deepmerge;module.exports=deepmerge_1;/***/}),/***/4977:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_11873__){"use strict";var isCallable=__nested_webpack_require_11873__(4188);var tryToString=__nested_webpack_require_11873__(3174);var $TypeError=TypeError;// `Assert: IsCallable(argument) is true`
module.exports=function(argument){if(isCallable(argument))return argument;throw new $TypeError(tryToString(argument)+' is not a function');};/***/}),/***/1361:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_12265__){"use strict";var isConstructor=__nested_webpack_require_12265__(866);var tryToString=__nested_webpack_require_12265__(3174);var $TypeError=TypeError;// `Assert: IsConstructor(argument) is true`
module.exports=function(argument){if(isConstructor(argument))return argument;throw new $TypeError(tryToString(argument)+' is not a constructor');};/***/}),/***/4121:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_12668__){"use strict";var isPossiblePrototype=__nested_webpack_require_12668__(6712);var $String=String;var $TypeError=TypeError;module.exports=function(argument){if(isPossiblePrototype(argument))return argument;throw new $TypeError("Can't set "+$String(argument)+' as a prototype');};/***/}),/***/5458:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_13019__){"use strict";var wellKnownSymbol=__nested_webpack_require_13019__(4282);var create=__nested_webpack_require_13019__(7065);var defineProperty=__nested_webpack_require_13019__(4466).f;var UNSCOPABLES=wellKnownSymbol('unscopables');var ArrayPrototype=Array.prototype;// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if(ArrayPrototype[UNSCOPABLES]===undefined){defineProperty(ArrayPrototype,UNSCOPABLES,{configurable:true,value:create(null)});}// add a key to Array.prototype[@@unscopables]
module.exports=function(key){ArrayPrototype[UNSCOPABLES][key]=true;};/***/}),/***/154:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_13670__){"use strict";var charAt=__nested_webpack_require_13670__(4212).charAt;// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports=function(S,index,unicode){return index+(unicode?charAt(S,index).length:1);};/***/}),/***/286:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_13999__){"use strict";var isPrototypeOf=__nested_webpack_require_13999__(4578);var $TypeError=TypeError;module.exports=function(it,Prototype){if(isPrototypeOf(Prototype,it))return it;throw new $TypeError('Incorrect invocation');};/***/}),/***/3770:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_14295__){"use strict";var isObject=__nested_webpack_require_14295__(831);var $String=String;var $TypeError=TypeError;// `Assert: Type(argument) is Object`
module.exports=function(argument){if(isObject(argument))return argument;throw new $TypeError($String(argument)+' is not an object');};/***/}),/***/7500:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_14650__){"use strict";var $forEach=__nested_webpack_require_14650__(4104).forEach;var arrayMethodIsStrict=__nested_webpack_require_14650__(5397);var STRICT_METHOD=arrayMethodIsStrict('forEach');// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports=!STRICT_METHOD?function forEach(callbackfn/* , thisArg */){return $forEach(this,callbackfn,arguments.length>1?arguments[1]:undefined);// eslint-disable-next-line es/no-array-prototype-foreach -- safe
}:[].forEach;/***/}),/***/1458:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_15232__){"use strict";var toIndexedObject=__nested_webpack_require_15232__(380);var toAbsoluteIndex=__nested_webpack_require_15232__(675);var lengthOfArrayLike=__nested_webpack_require_15232__(9389);// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod=function createMethod(IS_INCLUDES){return function($this,el,fromIndex){var O=toIndexedObject($this);var length=lengthOfArrayLike(O);if(length===0)return!IS_INCLUDES&&-1;var index=toAbsoluteIndex(fromIndex,length);var value;// Array#includes uses SameValueZero equality algorithm
// eslint-disable-next-line no-self-compare -- NaN check
if(IS_INCLUDES&&el!==el)while(length>index){value=O[index++];// eslint-disable-next-line no-self-compare -- NaN check
if(value!==value)return true;// Array#indexOf ignores holes, Array#includes - not
}else for(;length>index;index++){if((IS_INCLUDES||index in O)&&O[index]===el)return IS_INCLUDES||index||0;}return!IS_INCLUDES&&-1;};};module.exports={// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
includes:createMethod(true),// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
indexOf:createMethod(false)};/***/}),/***/4104:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_16483__){"use strict";var bind=__nested_webpack_require_16483__(5821);var uncurryThis=__nested_webpack_require_16483__(6881);var IndexedObject=__nested_webpack_require_16483__(7568);var toObject=__nested_webpack_require_16483__(3628);var lengthOfArrayLike=__nested_webpack_require_16483__(9389);var arraySpeciesCreate=__nested_webpack_require_16483__(5022);var push=uncurryThis([].push);// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod=function createMethod(TYPE){var IS_MAP=TYPE===1;var IS_FILTER=TYPE===2;var IS_SOME=TYPE===3;var IS_EVERY=TYPE===4;var IS_FIND_INDEX=TYPE===6;var IS_FILTER_REJECT=TYPE===7;var NO_HOLES=TYPE===5||IS_FIND_INDEX;return function($this,callbackfn,that,specificCreate){var O=toObject($this);var self=IndexedObject(O);var length=lengthOfArrayLike(self);var boundFunction=bind(callbackfn,that);var index=0;var create=specificCreate||arraySpeciesCreate;var target=IS_MAP?create($this,length):IS_FILTER||IS_FILTER_REJECT?create($this,0):undefined;var value,result;for(;length>index;index++)if(NO_HOLES||index in self){value=self[index];result=boundFunction(value,index,O);if(TYPE){if(IS_MAP)target[index]=result;// map
else if(result)switch(TYPE){case 3:return true;// some
case 5:return value;// find
case 6:return index;// findIndex
case 2:push(target,value);// filter
}else switch(TYPE){case 4:return false;// every
case 7:push(target,value);// filterReject
}}}return IS_FIND_INDEX?-1:IS_SOME||IS_EVERY?IS_EVERY:target;};};module.exports={// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
forEach:createMethod(0),// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
map:createMethod(1),// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
filter:createMethod(2),// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
some:createMethod(3),// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
every:createMethod(4),// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
find:createMethod(5),// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findIndex
findIndex:createMethod(6),// `Array.prototype.filterReject` method
// https://github.com/tc39/proposal-array-filtering
filterReject:createMethod(7)};/***/}),/***/5397:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_18934__){"use strict";var fails=__nested_webpack_require_18934__(5234);module.exports=function(METHOD_NAME,argument){var method=[][METHOD_NAME];return!!method&&fails(function(){// eslint-disable-next-line no-useless-call -- required for testing
method.call(null,argument||function(){return 1;},1);});};/***/}),/***/7825:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_19302__){"use strict";var uncurryThis=__nested_webpack_require_19302__(6881);module.exports=uncurryThis([].slice);/***/}),/***/9980:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_19482__){"use strict";var isArray=__nested_webpack_require_19482__(6719);var isConstructor=__nested_webpack_require_19482__(866);var isObject=__nested_webpack_require_19482__(831);var wellKnownSymbol=__nested_webpack_require_19482__(4282);var SPECIES=wellKnownSymbol('species');var $Array=Array;// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports=function(originalArray){var C;if(isArray(originalArray)){C=originalArray.constructor;// cross-realm fallback
if(isConstructor(C)&&(C===$Array||isArray(C.prototype)))C=undefined;else if(isObject(C)){C=C[SPECIES];if(C===null)C=undefined;}}return C===undefined?$Array:C;};/***/}),/***/5022:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_20192__){"use strict";var arraySpeciesConstructor=__nested_webpack_require_20192__(9980);// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports=function(originalArray,length){return new(arraySpeciesConstructor(originalArray))(length===0?0:length);};/***/}),/***/7283:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_20561__){"use strict";var wellKnownSymbol=__nested_webpack_require_20561__(4282);var ITERATOR=wellKnownSymbol('iterator');var SAFE_CLOSING=false;try{var called=0;var iteratorWithReturn={next:function next(){return{done:!!called++};},'return':function _return(){SAFE_CLOSING=true;}};iteratorWithReturn[ITERATOR]=function(){return this;};// eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
Array.from(iteratorWithReturn,function(){throw 2;});}catch(error){/* empty */}module.exports=function(exec,SKIP_CLOSING){try{if(!SKIP_CLOSING&&!SAFE_CLOSING)return false;}catch(error){return false;}// workaround of old WebKit + `eval` bug
var ITERATION_SUPPORT=false;try{var object={};object[ITERATOR]=function(){return{next:function next(){return{done:ITERATION_SUPPORT=true};}};};exec(object);}catch(error){/* empty */}return ITERATION_SUPPORT;};/***/}),/***/8689:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_21498__){"use strict";var uncurryThis=__nested_webpack_require_21498__(6881);var toString=uncurryThis({}.toString);var stringSlice=uncurryThis(''.slice);module.exports=function(it){return stringSlice(toString(it),8,-1);};/***/}),/***/5438:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_21785__){"use strict";var TO_STRING_TAG_SUPPORT=__nested_webpack_require_21785__(9345);var isCallable=__nested_webpack_require_21785__(4188);var classofRaw=__nested_webpack_require_21785__(8689);var wellKnownSymbol=__nested_webpack_require_21785__(4282);var TO_STRING_TAG=wellKnownSymbol('toStringTag');var $Object=Object;// ES3 wrong here
var CORRECT_ARGUMENTS=classofRaw(function(){return arguments;}())==='Arguments';// fallback for IE11 Script Access Denied error
var tryGet=function tryGet(it,key){try{return it[key];}catch(error){/* empty */}};// getting tag from ES6+ `Object.prototype.toString`
module.exports=TO_STRING_TAG_SUPPORT?classofRaw:function(it){var O,tag,result;return it===undefined?'Undefined':it===null?'Null'// @@toStringTag case
:typeof(tag=tryGet(O=$Object(it),TO_STRING_TAG))=='string'?tag// builtinTag case
:CORRECT_ARGUMENTS?classofRaw(O)// ES3 arguments fallback
:(result=classofRaw(O))==='Object'&&isCallable(O.callee)?'Arguments':result;};/***/}),/***/8657:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_22782__){"use strict";var hasOwn=__nested_webpack_require_22782__(4418);var ownKeys=__nested_webpack_require_22782__(3168);var getOwnPropertyDescriptorModule=__nested_webpack_require_22782__(9304);var definePropertyModule=__nested_webpack_require_22782__(4466);module.exports=function(target,source,exceptions){var keys=ownKeys(source);var defineProperty=definePropertyModule.f;var getOwnPropertyDescriptor=getOwnPropertyDescriptorModule.f;for(var i=0;i<keys.length;i++){var key=keys[i];if(!hasOwn(target,key)&&!(exceptions&&hasOwn(exceptions,key))){defineProperty(target,key,getOwnPropertyDescriptor(source,key));}}};/***/}),/***/680:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_23426__){"use strict";var fails=__nested_webpack_require_23426__(5234);module.exports=!fails(function(){function F(){/* empty */}F.prototype.constructor=null;// eslint-disable-next-line es/no-object-getprototypeof -- required for testing
return Object.getPrototypeOf(new F())!==F.prototype;});/***/}),/***/6224:(/***/function _(module){"use strict";// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports=function(value,done){return{value:value,done:done};};/***/}),/***/8088:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_24011__){"use strict";var DESCRIPTORS=__nested_webpack_require_24011__(6893);var definePropertyModule=__nested_webpack_require_24011__(4466);var createPropertyDescriptor=__nested_webpack_require_24011__(9123);module.exports=DESCRIPTORS?function(object,key,value){return definePropertyModule.f(object,key,createPropertyDescriptor(1,value));}:function(object,key,value){object[key]=value;return object;};/***/}),/***/9123:(/***/function _(module){"use strict";module.exports=function(bitmap,value){return{enumerable:!(bitmap&1),configurable:!(bitmap&2),writable:!(bitmap&4),value:value};};/***/}),/***/4417:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_24638__){"use strict";var DESCRIPTORS=__nested_webpack_require_24638__(6893);var definePropertyModule=__nested_webpack_require_24638__(4466);var createPropertyDescriptor=__nested_webpack_require_24638__(9123);module.exports=function(object,key,value){if(DESCRIPTORS)definePropertyModule.f(object,key,createPropertyDescriptor(0,value));else object[key]=value;};/***/}),/***/8089:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_25038__){"use strict";var anObject=__nested_webpack_require_25038__(3770);var ordinaryToPrimitive=__nested_webpack_require_25038__(2287);var $TypeError=TypeError;// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports=function(hint){anObject(this);if(hint==='string'||hint==='default')hint='string';else if(hint!=='number')throw new $TypeError('Incorrect hint');return ordinaryToPrimitive(this,hint);};/***/}),/***/997:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_25575__){"use strict";var makeBuiltIn=__nested_webpack_require_25575__(4530);var defineProperty=__nested_webpack_require_25575__(4466);module.exports=function(target,name,descriptor){if(descriptor.get)makeBuiltIn(descriptor.get,name,{getter:true});if(descriptor.set)makeBuiltIn(descriptor.set,name,{setter:true});return defineProperty.f(target,name,descriptor);};/***/}),/***/7509:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_25991__){"use strict";var isCallable=__nested_webpack_require_25991__(4188);var definePropertyModule=__nested_webpack_require_25991__(4466);var makeBuiltIn=__nested_webpack_require_25991__(4530);var defineGlobalProperty=__nested_webpack_require_25991__(4798);module.exports=function(O,key,value,options){if(!options)options={};var simple=options.enumerable;var name=options.name!==undefined?options.name:key;if(isCallable(value))makeBuiltIn(value,name,options);if(options.global){if(simple)O[key]=value;else defineGlobalProperty(key,value);}else{try{if(!options.unsafe)delete O[key];else if(O[key])simple=true;}catch(error){/* empty */}if(simple)O[key]=value;else definePropertyModule.f(O,key,{value:value,enumerable:false,configurable:!options.nonConfigurable,writable:!options.nonWritable});}return O;};/***/}),/***/4798:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_26823__){"use strict";var globalThis=__nested_webpack_require_26823__(9117);// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty=Object.defineProperty;module.exports=function(key,value){try{defineProperty(globalThis,key,{value:value,configurable:true,writable:true});}catch(error){globalThis[key]=value;}return value;};/***/}),/***/6893:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_27238__){"use strict";var fails=__nested_webpack_require_27238__(5234);// Detect IE8's incomplete defineProperty implementation
module.exports=!fails(function(){// eslint-disable-next-line es/no-object-defineproperty -- required for testing
return Object.defineProperty({},1,{get:function get(){return 7;}})[1]!==7;});/***/}),/***/5926:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_27622__){"use strict";var globalThis=__nested_webpack_require_27622__(9117);var isObject=__nested_webpack_require_27622__(831);var document=globalThis.document;// typeof document.createElement is 'object' in old IE
var EXISTS=isObject(document)&&isObject(document.createElement);module.exports=function(it){return EXISTS?document.createElement(it):{};};/***/}),/***/9429:(/***/function _(module){"use strict";// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0};/***/}),/***/7463:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_28709__){"use strict";// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement=__nested_webpack_require_28709__(5926);var classList=documentCreateElement('span').classList;var DOMTokenListPrototype=classList&&classList.constructor&&classList.constructor.prototype;module.exports=DOMTokenListPrototype===Object.prototype?undefined:DOMTokenListPrototype;/***/}),/***/1274:(/***/function _(module){"use strict";// IE8- don't enum bug keys
module.exports=['constructor','hasOwnProperty','isPrototypeOf','propertyIsEnumerable','toLocaleString','toString','valueOf'];/***/}),/***/6168:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_29396__){"use strict";var userAgent=__nested_webpack_require_29396__(8060);module.exports=/ipad|iphone|ipod/i.test(userAgent)&&typeof Pebble!='undefined';/***/}),/***/6347:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_29616__){"use strict";var userAgent=__nested_webpack_require_29616__(8060);// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports=/(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);/***/}),/***/3940:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_29881__){"use strict";var ENVIRONMENT=__nested_webpack_require_29881__(1078);module.exports=ENVIRONMENT==='NODE';/***/}),/***/1129:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_30060__){"use strict";var userAgent=__nested_webpack_require_30060__(8060);module.exports=/web0s(?!.*chrome)/i.test(userAgent);/***/}),/***/8060:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_30253__){"use strict";var globalThis=__nested_webpack_require_30253__(9117);var navigator=globalThis.navigator;var userAgent=navigator&&navigator.userAgent;module.exports=userAgent?String(userAgent):'';/***/}),/***/3008:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_30521__){"use strict";var globalThis=__nested_webpack_require_30521__(9117);var userAgent=__nested_webpack_require_30521__(8060);var process=globalThis.process;var Deno=globalThis.Deno;var versions=process&&process.versions||Deno&&Deno.version;var v8=versions&&versions.v8;var match,version;if(v8){match=v8.split('.');// in old Chrome, versions of V8 isn't V8 = Chrome / 10
// but their correct versions are not interesting for us
version=match[0]>0&&match[0]<4?1:+(match[0]+match[1]);}// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if(!version&&userAgent){match=userAgent.match(/Edge\/(\d+)/);if(!match||match[1]>=74){match=userAgent.match(/Chrome\/(\d+)/);if(match)version=+match[1];}}module.exports=version;/***/}),/***/1078:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_31359__){"use strict";/* global Bun, Deno -- detection */var globalThis=__nested_webpack_require_31359__(9117);var userAgent=__nested_webpack_require_31359__(8060);var classof=__nested_webpack_require_31359__(8689);var userAgentStartsWith=function userAgentStartsWith(string){return userAgent.slice(0,string.length)===string;};module.exports=function(){if(userAgentStartsWith('Bun/'))return'BUN';if(userAgentStartsWith('Cloudflare-Workers'))return'CLOUDFLARE';if(userAgentStartsWith('Deno/'))return'DENO';if(userAgentStartsWith('Node.js/'))return'NODE';if(globalThis.Bun&&typeof Bun.version=='string')return'BUN';if(globalThis.Deno&&_typeof2(Deno.version)=='object')return'DENO';if(classof(globalThis.process)==='process')return'NODE';if(globalThis.window&&globalThis.document)return'BROWSER';return'REST';}();/***/}),/***/7308:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_32209__){"use strict";var uncurryThis=__nested_webpack_require_32209__(6881);var $Error=Error;var replace=uncurryThis(''.replace);var TEST=function(arg){return String(new $Error(arg).stack);}('zxcasd');// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var V8_OR_CHAKRA_STACK_ENTRY=/\n\s*at [^:]*:[^\n]*/;var IS_V8_OR_CHAKRA_STACK=V8_OR_CHAKRA_STACK_ENTRY.test(TEST);module.exports=function(stack,dropEntries){if(IS_V8_OR_CHAKRA_STACK&&typeof stack=='string'&&!$Error.prepareStackTrace){while(dropEntries--)stack=replace(stack,V8_OR_CHAKRA_STACK_ENTRY,'');}return stack;};/***/}),/***/5382:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_32872__){"use strict";var createNonEnumerableProperty=__nested_webpack_require_32872__(8088);var clearErrorStack=__nested_webpack_require_32872__(7308);var ERROR_STACK_INSTALLABLE=__nested_webpack_require_32872__(4582);// non-standard V8
var captureStackTrace=Error.captureStackTrace;module.exports=function(error,C,stack,dropEntries){if(ERROR_STACK_INSTALLABLE){if(captureStackTrace)captureStackTrace(error,C);else createNonEnumerableProperty(error,'stack',clearErrorStack(stack,dropEntries));}};/***/}),/***/4582:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_33409__){"use strict";var fails=__nested_webpack_require_33409__(5234);var createPropertyDescriptor=__nested_webpack_require_33409__(9123);module.exports=!fails(function(){var error=new Error('a');if(!('stack'in error))return true;// eslint-disable-next-line es/no-object-defineproperty -- safe
Object.defineProperty(error,'stack',createPropertyDescriptor(1,7));return error.stack!==7;});/***/}),/***/5613:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_33850__){"use strict";var globalThis=__nested_webpack_require_33850__(9117);var getOwnPropertyDescriptor=__nested_webpack_require_33850__(9304).f;var createNonEnumerableProperty=__nested_webpack_require_33850__(8088);var defineBuiltIn=__nested_webpack_require_33850__(7509);var defineGlobalProperty=__nested_webpack_require_33850__(4798);var copyConstructorProperties=__nested_webpack_require_33850__(8657);var isForced=__nested_webpack_require_33850__(8489);/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/module.exports=function(options,source){var TARGET=options.target;var GLOBAL=options.global;var STATIC=options.stat;var FORCED,target,key,targetProperty,sourceProperty,descriptor;if(GLOBAL){target=globalThis;}else if(STATIC){target=globalThis[TARGET]||defineGlobalProperty(TARGET,{});}else{target=globalThis[TARGET]&&globalThis[TARGET].prototype;}if(target)for(key in source){sourceProperty=source[key];if(options.dontCallGetSet){descriptor=getOwnPropertyDescriptor(target,key);targetProperty=descriptor&&descriptor.value;}else targetProperty=target[key];FORCED=isForced(GLOBAL?key:TARGET+(STATIC?'.':'#')+key,options.forced);// contained in target
if(!FORCED&&targetProperty!==undefined){if(_typeof2(sourceProperty)==_typeof2(targetProperty))continue;copyConstructorProperties(sourceProperty,targetProperty);}// add a flag to not completely full polyfills
if(options.sham||targetProperty&&targetProperty.sham){createNonEnumerableProperty(sourceProperty,'sham',true);}defineBuiltIn(target,key,sourceProperty,options);}};/***/}),/***/5234:(/***/function _(module){"use strict";module.exports=function(exec){try{return!!exec();}catch(error){return true;}};/***/}),/***/467:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_36404__){"use strict";// TODO: Remove from `core-js@4` since it's moved to entry points
__nested_webpack_require_36404__(8376);var call=__nested_webpack_require_36404__(9944);var defineBuiltIn=__nested_webpack_require_36404__(7509);var regexpExec=__nested_webpack_require_36404__(9342);var fails=__nested_webpack_require_36404__(5234);var wellKnownSymbol=__nested_webpack_require_36404__(4282);var createNonEnumerableProperty=__nested_webpack_require_36404__(8088);var SPECIES=wellKnownSymbol('species');var RegExpPrototype=RegExp.prototype;module.exports=function(KEY,exec,FORCED,SHAM){var SYMBOL=wellKnownSymbol(KEY);var DELEGATES_TO_SYMBOL=!fails(function(){// String methods call symbol-named RegExp methods
var O={};O[SYMBOL]=function(){return 7;};return''[KEY](O)!==7;});var DELEGATES_TO_EXEC=DELEGATES_TO_SYMBOL&&!fails(function(){// Symbol-named RegExp methods call .exec
var execCalled=false;var re=/a/;if(KEY==='split'){// We can't use real regex here since it causes deoptimization
// and serious performance degradation in V8
// https://github.com/zloirock/core-js/issues/306
re={};// RegExp[@@split] doesn't call the regex's exec method, but first creates
// a new one. We need to return the patched regex when creating the new one.
re.constructor={};re.constructor[SPECIES]=function(){return re;};re.flags='';re[SYMBOL]=/./[SYMBOL];}re.exec=function(){execCalled=true;return null;};re[SYMBOL]('');return!execCalled;});if(!DELEGATES_TO_SYMBOL||!DELEGATES_TO_EXEC||FORCED){var nativeRegExpMethod=/./[SYMBOL];var methods=exec(SYMBOL,''[KEY],function(nativeMethod,regexp,str,arg2,forceStringMethod){var $exec=regexp.exec;if($exec===regexpExec||$exec===RegExpPrototype.exec){if(DELEGATES_TO_SYMBOL&&!forceStringMethod){// The native String method already delegates to @@method (this
// polyfilled function), leasing to infinite recursion.
// We avoid it by directly calling the native @@method method.
return{done:true,value:call(nativeRegExpMethod,regexp,str,arg2)};}return{done:true,value:call(nativeMethod,str,regexp,arg2)};}return{done:false};});defineBuiltIn(String.prototype,KEY,methods[0]);defineBuiltIn(RegExpPrototype,SYMBOL,methods[1]);}if(SHAM)createNonEnumerableProperty(RegExpPrototype[SYMBOL],'sham',true);};/***/}),/***/646:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_38622__){"use strict";var NATIVE_BIND=__nested_webpack_require_38622__(9055);var FunctionPrototype=Function.prototype;var apply=FunctionPrototype.apply;var call=FunctionPrototype.call;// eslint-disable-next-line es/no-reflect -- safe
module.exports=(typeof Reflect==="undefined"?"undefined":_typeof2(Reflect))=='object'&&Reflect.apply||(NATIVE_BIND?call.bind(apply):function(){return call.apply(apply,arguments);});/***/}),/***/5821:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_39103__){"use strict";var uncurryThis=__nested_webpack_require_39103__(5691);var aCallable=__nested_webpack_require_39103__(4977);var NATIVE_BIND=__nested_webpack_require_39103__(9055);var bind=uncurryThis(uncurryThis.bind);// optional / simple context binding
module.exports=function(fn,that){aCallable(fn);return that===undefined?fn:NATIVE_BIND?bind(fn,that):function/* ...args */(){return fn.apply(that,arguments);};};/***/}),/***/9055:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_39564__){"use strict";var fails=__nested_webpack_require_39564__(5234);module.exports=!fails(function(){// eslint-disable-next-line es/no-function-prototype-bind -- safe
var test=function(){/* empty */}.bind();// eslint-disable-next-line no-prototype-builtins -- safe
return typeof test!='function'||test.hasOwnProperty('prototype');});/***/}),/***/9944:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_39966__){"use strict";var NATIVE_BIND=__nested_webpack_require_39966__(9055);var call=Function.prototype.call;module.exports=NATIVE_BIND?call.bind(call):function(){return call.apply(call,arguments);};/***/}),/***/2735:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_40232__){"use strict";var DESCRIPTORS=__nested_webpack_require_40232__(6893);var hasOwn=__nested_webpack_require_40232__(4418);var FunctionPrototype=Function.prototype;// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor=DESCRIPTORS&&Object.getOwnPropertyDescriptor;var EXISTS=hasOwn(FunctionPrototype,'name');// additional protection from minified / mangled / dropped function names
var PROPER=EXISTS&&function something(){/* empty */}.name==='something';var CONFIGURABLE=EXISTS&&(!DESCRIPTORS||DESCRIPTORS&&getDescriptor(FunctionPrototype,'name').configurable);module.exports={EXISTS:EXISTS,PROPER:PROPER,CONFIGURABLE:CONFIGURABLE};/***/}),/***/1025:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_40958__){"use strict";var uncurryThis=__nested_webpack_require_40958__(6881);var aCallable=__nested_webpack_require_40958__(4977);module.exports=function(object,key,method){try{// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object,key)[method]));}catch(error){/* empty */}};/***/}),/***/5691:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_41373__){"use strict";var classofRaw=__nested_webpack_require_41373__(8689);var uncurryThis=__nested_webpack_require_41373__(6881);module.exports=function(fn){// Nashorn bug:
//   https://github.com/zloirock/core-js/issues/1128
//   https://github.com/zloirock/core-js/issues/1130
if(classofRaw(fn)==='Function')return uncurryThis(fn);};/***/}),/***/6881:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_41763__){"use strict";var NATIVE_BIND=__nested_webpack_require_41763__(9055);var FunctionPrototype=Function.prototype;var call=FunctionPrototype.call;var uncurryThisWithBind=NATIVE_BIND&&FunctionPrototype.bind.bind(call,call);module.exports=NATIVE_BIND?uncurryThisWithBind:function(fn){return function(){return call.apply(fn,arguments);};};/***/}),/***/5604:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_42169__){"use strict";var globalThis=__nested_webpack_require_42169__(9117);var isCallable=__nested_webpack_require_42169__(4188);var aFunction=function aFunction(argument){return isCallable(argument)?argument:undefined;};module.exports=function(namespace,method){return arguments.length<2?aFunction(globalThis[namespace]):globalThis[namespace]&&globalThis[namespace][method];};/***/}),/***/6002:(/***/function _(module){"use strict";// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
module.exports=function(obj){return{iterator:obj,next:obj.next,done:false};};/***/}),/***/9874:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_42848__){"use strict";var classof=__nested_webpack_require_42848__(5438);var getMethod=__nested_webpack_require_42848__(2913);var isNullOrUndefined=__nested_webpack_require_42848__(4318);var Iterators=__nested_webpack_require_42848__(9164);var wellKnownSymbol=__nested_webpack_require_42848__(4282);var ITERATOR=wellKnownSymbol('iterator');module.exports=function(it){if(!isNullOrUndefined(it))return getMethod(it,ITERATOR)||getMethod(it,'@@iterator')||Iterators[classof(it)];};/***/}),/***/2350:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_43340__){"use strict";var call=__nested_webpack_require_43340__(9944);var aCallable=__nested_webpack_require_43340__(4977);var anObject=__nested_webpack_require_43340__(3770);var tryToString=__nested_webpack_require_43340__(3174);var getIteratorMethod=__nested_webpack_require_43340__(9874);var $TypeError=TypeError;module.exports=function(argument,usingIterator){var iteratorMethod=arguments.length<2?getIteratorMethod(argument):usingIterator;if(aCallable(iteratorMethod))return anObject(call(iteratorMethod,argument));throw new $TypeError(tryToString(argument)+' is not iterable');};/***/}),/***/8254:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_43939__){"use strict";var uncurryThis=__nested_webpack_require_43939__(6881);var isArray=__nested_webpack_require_43939__(6719);var isCallable=__nested_webpack_require_43939__(4188);var classof=__nested_webpack_require_43939__(8689);var toString=__nested_webpack_require_43939__(2618);var push=uncurryThis([].push);module.exports=function(replacer){if(isCallable(replacer))return replacer;if(!isArray(replacer))return;var rawLength=replacer.length;var keys=[];for(var i=0;i<rawLength;i++){var element=replacer[i];if(typeof element=='string')push(keys,element);else if(typeof element=='number'||classof(element)==='Number'||classof(element)==='String')push(keys,toString(element));}var keysLength=keys.length;var root=true;return function(key,value){if(root){root=false;return value;}if(isArray(this))return value;for(var j=0;j<keysLength;j++)if(keys[j]===key)return value;};};/***/}),/***/2913:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_44829__){"use strict";var aCallable=__nested_webpack_require_44829__(4977);var isNullOrUndefined=__nested_webpack_require_44829__(4318);// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports=function(V,P){var func=V[P];return isNullOrUndefined(func)?undefined:aCallable(func);};/***/}),/***/9117:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_45196__){"use strict";var check=function check(it){return it&&it.Math===Math&&it;};// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports=// eslint-disable-next-line es/no-global-this -- safe
check((typeof globalThis==="undefined"?"undefined":_typeof2(globalThis))=='object'&&globalThis)||check((typeof window==="undefined"?"undefined":_typeof2(window))=='object'&&window)||// eslint-disable-next-line no-restricted-globals -- safe
check((typeof self==="undefined"?"undefined":_typeof2(self))=='object'&&self)||check(_typeof2(__nested_webpack_require_45196__.g)=='object'&&__nested_webpack_require_45196__.g)||check(_typeof2(this)=='object'&&this)||// eslint-disable-next-line no-new-func -- fallback
function(){return this;}()||Function('return this')();/***/}),/***/4418:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_46036__){"use strict";var uncurryThis=__nested_webpack_require_46036__(6881);var toObject=__nested_webpack_require_46036__(3628);var hasOwnProperty=uncurryThis({}.hasOwnProperty);// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports=Object.hasOwn||function hasOwn(it,key){return hasOwnProperty(toObject(it),key);};/***/}),/***/7588:(/***/function _(module){"use strict";module.exports={};/***/}),/***/3306:(/***/function _(module){"use strict";module.exports=function(a,b){try{// eslint-disable-next-line no-console -- safe
arguments.length===1?void 0:void 0;}catch(error){/* empty */}};/***/}),/***/7458:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_46779__){"use strict";var getBuiltIn=__nested_webpack_require_46779__(5604);module.exports=getBuiltIn('document','documentElement');/***/}),/***/9622:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_46977__){"use strict";var DESCRIPTORS=__nested_webpack_require_46977__(6893);var fails=__nested_webpack_require_46977__(5234);var createElement=__nested_webpack_require_46977__(5926);// Thanks to IE8 for its funny defineProperty
module.exports=!DESCRIPTORS&&!fails(function(){// eslint-disable-next-line es/no-object-defineproperty -- required for testing
return Object.defineProperty(createElement('div'),'a',{get:function get(){return 7;}}).a!==7;});/***/}),/***/7568:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_47469__){"use strict";var uncurryThis=__nested_webpack_require_47469__(6881);var fails=__nested_webpack_require_47469__(5234);var classof=__nested_webpack_require_47469__(8689);var $Object=Object;var split=uncurryThis(''.split);// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports=fails(function(){// throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
// eslint-disable-next-line no-prototype-builtins -- safe
return!$Object('z').propertyIsEnumerable(0);})?function(it){return classof(it)==='String'?split(it,''):$Object(it);}:$Object;/***/}),/***/4166:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_48098__){"use strict";var isCallable=__nested_webpack_require_48098__(4188);var isObject=__nested_webpack_require_48098__(831);var setPrototypeOf=__nested_webpack_require_48098__(5054);// makes subclassing work correct for wrapped built-ins
module.exports=function($this,dummy,Wrapper){var NewTarget,NewTargetPrototype;if(// it can work only with native `setPrototypeOf`
setPrototypeOf&&// we haven't completely correct pre-ES6 way for getting `new.target`, so use this
isCallable(NewTarget=dummy.constructor)&&NewTarget!==Wrapper&&isObject(NewTargetPrototype=NewTarget.prototype)&&NewTargetPrototype!==Wrapper.prototype)setPrototypeOf($this,NewTargetPrototype);return $this;};/***/}),/***/3029:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_48815__){"use strict";var uncurryThis=__nested_webpack_require_48815__(6881);var isCallable=__nested_webpack_require_48815__(4188);var store=__nested_webpack_require_48815__(2694);var functionToString=uncurryThis(Function.toString);// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if(!isCallable(store.inspectSource)){store.inspectSource=function(it){return functionToString(it);};}module.exports=store.inspectSource;/***/}),/***/8257:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_49303__){"use strict";var isObject=__nested_webpack_require_49303__(831);var createNonEnumerableProperty=__nested_webpack_require_49303__(8088);// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports=function(O,options){if(isObject(options)&&'cause'in options){createNonEnumerableProperty(O,'cause',options.cause);}};/***/}),/***/3086:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_49752__){"use strict";var NATIVE_WEAK_MAP=__nested_webpack_require_49752__(5945);var globalThis=__nested_webpack_require_49752__(9117);var isObject=__nested_webpack_require_49752__(831);var createNonEnumerableProperty=__nested_webpack_require_49752__(8088);var hasOwn=__nested_webpack_require_49752__(4418);var shared=__nested_webpack_require_49752__(2694);var sharedKey=__nested_webpack_require_49752__(168);var hiddenKeys=__nested_webpack_require_49752__(7588);var OBJECT_ALREADY_INITIALIZED='Object already initialized';var TypeError=globalThis.TypeError;var WeakMap=globalThis.WeakMap;var set,get,has;var enforce=function enforce(it){return has(it)?get(it):set(it,{});};var getterFor=function getterFor(TYPE){return function(it){var state;if(!isObject(it)||(state=get(it)).type!==TYPE){throw new TypeError('Incompatible receiver, '+TYPE+' required');}return state;};};if(NATIVE_WEAK_MAP||shared.state){var store=shared.state||(shared.state=new WeakMap());/* eslint-disable no-self-assign -- prototype methods protection */store.get=store.get;store.has=store.has;store.set=store.set;/* eslint-enable no-self-assign -- prototype methods protection */set=function set(it,metadata){if(store.has(it))throw new TypeError(OBJECT_ALREADY_INITIALIZED);metadata.facade=it;store.set(it,metadata);return metadata;};get=function get(it){return store.get(it)||{};};has=function has(it){return store.has(it);};}else{var STATE=sharedKey('state');hiddenKeys[STATE]=true;set=function set(it,metadata){if(hasOwn(it,STATE))throw new TypeError(OBJECT_ALREADY_INITIALIZED);metadata.facade=it;createNonEnumerableProperty(it,STATE,metadata);return metadata;};get=function get(it){return hasOwn(it,STATE)?it[STATE]:{};};has=function has(it){return hasOwn(it,STATE);};}module.exports={set:set,get:get,has:has,enforce:enforce,getterFor:getterFor};/***/}),/***/8146:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_51551__){"use strict";var wellKnownSymbol=__nested_webpack_require_51551__(4282);var Iterators=__nested_webpack_require_51551__(9164);var ITERATOR=wellKnownSymbol('iterator');var ArrayPrototype=Array.prototype;// check on default Array iterator
module.exports=function(it){return it!==undefined&&(Iterators.Array===it||ArrayPrototype[ITERATOR]===it);};/***/}),/***/6719:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_51956__){"use strict";var classof=__nested_webpack_require_51956__(8689);// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports=Array.isArray||function isArray(argument){return classof(argument)==='Array';};/***/}),/***/4188:(/***/function _(module){"use strict";// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll=(typeof document==="undefined"?"undefined":_typeof2(document))=='object'&&document.all;// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports=typeof documentAll=='undefined'&&documentAll!==undefined?function(argument){return typeof argument=='function'||argument===documentAll;}:function(argument){return typeof argument=='function';};/***/}),/***/866:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_52897__){"use strict";var uncurryThis=__nested_webpack_require_52897__(6881);var fails=__nested_webpack_require_52897__(5234);var isCallable=__nested_webpack_require_52897__(4188);var classof=__nested_webpack_require_52897__(5438);var getBuiltIn=__nested_webpack_require_52897__(5604);var inspectSource=__nested_webpack_require_52897__(3029);var noop=function noop(){/* empty */};var construct=getBuiltIn('Reflect','construct');var constructorRegExp=/^\s*(?:class|function)\b/;var exec=uncurryThis(constructorRegExp.exec);var INCORRECT_TO_STRING=!constructorRegExp.test(noop);var isConstructorModern=function isConstructor(argument){if(!isCallable(argument))return false;try{construct(noop,[],argument);return true;}catch(error){return false;}};var isConstructorLegacy=function isConstructor(argument){if(!isCallable(argument))return false;switch(classof(argument)){case'AsyncFunction':case'GeneratorFunction':case'AsyncGeneratorFunction':return false;}try{// we can't check .prototype since constructors produced by .bind haven't it
// `Function#toString` throws on some built-it function in some legacy engines
// (for example, `DOMQuad` and similar in FF41-)
return INCORRECT_TO_STRING||!!exec(constructorRegExp,inspectSource(argument));}catch(error){return true;}};isConstructorLegacy.sham=true;// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports=!construct||fails(function(){var called;return isConstructorModern(isConstructorModern.call)||!isConstructorModern(Object)||!isConstructorModern(function(){called=true;})||called;})?isConstructorLegacy:isConstructorModern;/***/}),/***/8489:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_54518__){"use strict";var fails=__nested_webpack_require_54518__(5234);var isCallable=__nested_webpack_require_54518__(4188);var replacement=/#|\.prototype\./;var isForced=function isForced(feature,detection){var value=data[normalize(feature)];return value===POLYFILL?true:value===NATIVE?false:isCallable(detection)?fails(detection):!!detection;};var normalize=isForced.normalize=function(string){return String(string).replace(replacement,'.').toLowerCase();};var data=isForced.data={};var NATIVE=isForced.NATIVE='N';var POLYFILL=isForced.POLYFILL='P';module.exports=isForced;/***/}),/***/4318:(/***/function _(module){"use strict";// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports=function(it){return it===null||it===undefined;};/***/}),/***/831:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_55396__){"use strict";var isCallable=__nested_webpack_require_55396__(4188);module.exports=function(it){return _typeof2(it)=='object'?it!==null:isCallable(it);};/***/}),/***/6712:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_55623__){"use strict";var isObject=__nested_webpack_require_55623__(831);module.exports=function(argument){return isObject(argument)||argument===null;};/***/}),/***/1942:(/***/function _(module){"use strict";module.exports=false;/***/}),/***/6032:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_55918__){"use strict";var getBuiltIn=__nested_webpack_require_55918__(5604);var isCallable=__nested_webpack_require_55918__(4188);var isPrototypeOf=__nested_webpack_require_55918__(4578);var USE_SYMBOL_AS_UID=__nested_webpack_require_55918__(9809);var $Object=Object;module.exports=USE_SYMBOL_AS_UID?function(it){return _typeof2(it)=='symbol';}:function(it){var $Symbol=getBuiltIn('Symbol');return isCallable($Symbol)&&isPrototypeOf($Symbol.prototype,$Object(it));};/***/}),/***/8873:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_56411__){"use strict";var bind=__nested_webpack_require_56411__(5821);var call=__nested_webpack_require_56411__(9944);var anObject=__nested_webpack_require_56411__(3770);var tryToString=__nested_webpack_require_56411__(3174);var isArrayIteratorMethod=__nested_webpack_require_56411__(8146);var lengthOfArrayLike=__nested_webpack_require_56411__(9389);var isPrototypeOf=__nested_webpack_require_56411__(4578);var getIterator=__nested_webpack_require_56411__(2350);var getIteratorMethod=__nested_webpack_require_56411__(9874);var iteratorClose=__nested_webpack_require_56411__(8500);var $TypeError=TypeError;var Result=function Result(stopped,result){this.stopped=stopped;this.result=result;};var ResultPrototype=Result.prototype;module.exports=function(iterable,unboundFunction,options){var that=options&&options.that;var AS_ENTRIES=!!(options&&options.AS_ENTRIES);var IS_RECORD=!!(options&&options.IS_RECORD);var IS_ITERATOR=!!(options&&options.IS_ITERATOR);var INTERRUPTED=!!(options&&options.INTERRUPTED);var fn=bind(unboundFunction,that);var iterator,iterFn,index,length,result,next,step;var stop=function stop(condition){if(iterator)iteratorClose(iterator,'normal',condition);return new Result(true,condition);};var callFn=function callFn(value){if(AS_ENTRIES){anObject(value);return INTERRUPTED?fn(value[0],value[1],stop):fn(value[0],value[1]);}return INTERRUPTED?fn(value,stop):fn(value);};if(IS_RECORD){iterator=iterable.iterator;}else if(IS_ITERATOR){iterator=iterable;}else{iterFn=getIteratorMethod(iterable);if(!iterFn)throw new $TypeError(tryToString(iterable)+' is not iterable');// optimisation for array iterators
if(isArrayIteratorMethod(iterFn)){for(index=0,length=lengthOfArrayLike(iterable);length>index;index++){result=callFn(iterable[index]);if(result&&isPrototypeOf(ResultPrototype,result))return result;}return new Result(false);}iterator=getIterator(iterable,iterFn);}next=IS_RECORD?iterable.next:iterator.next;while(!(step=call(next,iterator)).done){try{result=callFn(step.value);}catch(error){iteratorClose(iterator,'throw',error);}if(_typeof2(result)=='object'&&result&&isPrototypeOf(ResultPrototype,result))return result;}return new Result(false);};/***/}),/***/8500:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_58536__){"use strict";var call=__nested_webpack_require_58536__(9944);var anObject=__nested_webpack_require_58536__(3770);var getMethod=__nested_webpack_require_58536__(2913);module.exports=function(iterator,kind,value){var innerResult,innerError;anObject(iterator);try{innerResult=getMethod(iterator,'return');if(!innerResult){if(kind==='throw')throw value;return value;}innerResult=call(innerResult,iterator);}catch(error){innerError=true;innerResult=error;}if(kind==='throw')throw value;if(innerError)throw innerResult;anObject(innerResult);return value;};/***/}),/***/9383:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_59135__){"use strict";var IteratorPrototype=__nested_webpack_require_59135__(2037).IteratorPrototype;var create=__nested_webpack_require_59135__(7065);var createPropertyDescriptor=__nested_webpack_require_59135__(9123);var setToStringTag=__nested_webpack_require_59135__(3754);var Iterators=__nested_webpack_require_59135__(9164);var returnThis=function returnThis(){return this;};module.exports=function(IteratorConstructor,NAME,next,ENUMERABLE_NEXT){var TO_STRING_TAG=NAME+' Iterator';IteratorConstructor.prototype=create(IteratorPrototype,{next:createPropertyDescriptor(+!ENUMERABLE_NEXT,next)});setToStringTag(IteratorConstructor,TO_STRING_TAG,false,true);Iterators[TO_STRING_TAG]=returnThis;return IteratorConstructor;};/***/}),/***/3217:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_59874__){"use strict";var $=__nested_webpack_require_59874__(5613);var call=__nested_webpack_require_59874__(9944);var IS_PURE=__nested_webpack_require_59874__(1942);var FunctionName=__nested_webpack_require_59874__(2735);var isCallable=__nested_webpack_require_59874__(4188);var createIteratorConstructor=__nested_webpack_require_59874__(9383);var getPrototypeOf=__nested_webpack_require_59874__(1786);var setPrototypeOf=__nested_webpack_require_59874__(5054);var setToStringTag=__nested_webpack_require_59874__(3754);var createNonEnumerableProperty=__nested_webpack_require_59874__(8088);var defineBuiltIn=__nested_webpack_require_59874__(7509);var wellKnownSymbol=__nested_webpack_require_59874__(4282);var Iterators=__nested_webpack_require_59874__(9164);var IteratorsCore=__nested_webpack_require_59874__(2037);var PROPER_FUNCTION_NAME=FunctionName.PROPER;var CONFIGURABLE_FUNCTION_NAME=FunctionName.CONFIGURABLE;var IteratorPrototype=IteratorsCore.IteratorPrototype;var BUGGY_SAFARI_ITERATORS=IteratorsCore.BUGGY_SAFARI_ITERATORS;var ITERATOR=wellKnownSymbol('iterator');var KEYS='keys';var VALUES='values';var ENTRIES='entries';var returnThis=function returnThis(){return this;};module.exports=function(Iterable,NAME,IteratorConstructor,next,DEFAULT,IS_SET,FORCED){createIteratorConstructor(IteratorConstructor,NAME,next);var getIterationMethod=function getIterationMethod(KIND){if(KIND===DEFAULT&&defaultIterator)return defaultIterator;if(!BUGGY_SAFARI_ITERATORS&&KIND&&KIND in IterablePrototype)return IterablePrototype[KIND];switch(KIND){case KEYS:return function keys(){return new IteratorConstructor(this,KIND);};case VALUES:return function values(){return new IteratorConstructor(this,KIND);};case ENTRIES:return function entries(){return new IteratorConstructor(this,KIND);};}return function(){return new IteratorConstructor(this);};};var TO_STRING_TAG=NAME+' Iterator';var INCORRECT_VALUES_NAME=false;var IterablePrototype=Iterable.prototype;var nativeIterator=IterablePrototype[ITERATOR]||IterablePrototype['@@iterator']||DEFAULT&&IterablePrototype[DEFAULT];var defaultIterator=!BUGGY_SAFARI_ITERATORS&&nativeIterator||getIterationMethod(DEFAULT);var anyNativeIterator=NAME==='Array'?IterablePrototype.entries||nativeIterator:nativeIterator;var CurrentIteratorPrototype,methods,KEY;// fix native
if(anyNativeIterator){CurrentIteratorPrototype=getPrototypeOf(anyNativeIterator.call(new Iterable()));if(CurrentIteratorPrototype!==Object.prototype&&CurrentIteratorPrototype.next){if(!IS_PURE&&getPrototypeOf(CurrentIteratorPrototype)!==IteratorPrototype){if(setPrototypeOf){setPrototypeOf(CurrentIteratorPrototype,IteratorPrototype);}else if(!isCallable(CurrentIteratorPrototype[ITERATOR])){defineBuiltIn(CurrentIteratorPrototype,ITERATOR,returnThis);}}// Set @@toStringTag to native iterators
setToStringTag(CurrentIteratorPrototype,TO_STRING_TAG,true,true);if(IS_PURE)Iterators[TO_STRING_TAG]=returnThis;}}// fix Array.prototype.{ values, @@iterator }.name in V8 / FF
if(PROPER_FUNCTION_NAME&&DEFAULT===VALUES&&nativeIterator&&nativeIterator.name!==VALUES){if(!IS_PURE&&CONFIGURABLE_FUNCTION_NAME){createNonEnumerableProperty(IterablePrototype,'name',VALUES);}else{INCORRECT_VALUES_NAME=true;defaultIterator=function values(){return call(nativeIterator,this);};}}// export additional methods
if(DEFAULT){methods={values:getIterationMethod(VALUES),keys:IS_SET?defaultIterator:getIterationMethod(KEYS),entries:getIterationMethod(ENTRIES)};if(FORCED)for(KEY in methods){if(BUGGY_SAFARI_ITERATORS||INCORRECT_VALUES_NAME||!(KEY in IterablePrototype)){defineBuiltIn(IterablePrototype,KEY,methods[KEY]);}}else $({target:NAME,proto:true,forced:BUGGY_SAFARI_ITERATORS||INCORRECT_VALUES_NAME},methods);}// define iterator
if((!IS_PURE||FORCED)&&IterablePrototype[ITERATOR]!==defaultIterator){defineBuiltIn(IterablePrototype,ITERATOR,defaultIterator,{name:DEFAULT});}Iterators[NAME]=defaultIterator;return methods;};/***/}),/***/2037:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_63691__){"use strict";var fails=__nested_webpack_require_63691__(5234);var isCallable=__nested_webpack_require_63691__(4188);var isObject=__nested_webpack_require_63691__(831);var create=__nested_webpack_require_63691__(7065);var getPrototypeOf=__nested_webpack_require_63691__(1786);var defineBuiltIn=__nested_webpack_require_63691__(7509);var wellKnownSymbol=__nested_webpack_require_63691__(4282);var IS_PURE=__nested_webpack_require_63691__(1942);var ITERATOR=wellKnownSymbol('iterator');var BUGGY_SAFARI_ITERATORS=false;// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype,PrototypeOfArrayIteratorPrototype,arrayIterator;/* eslint-disable es/no-array-prototype-keys -- safe */if([].keys){arrayIterator=[].keys();// Safari 8 has buggy iterators w/o `next`
if(!('next'in arrayIterator))BUGGY_SAFARI_ITERATORS=true;else{PrototypeOfArrayIteratorPrototype=getPrototypeOf(getPrototypeOf(arrayIterator));if(PrototypeOfArrayIteratorPrototype!==Object.prototype)IteratorPrototype=PrototypeOfArrayIteratorPrototype;}}var NEW_ITERATOR_PROTOTYPE=!isObject(IteratorPrototype)||fails(function(){var test={};// FF44- legacy iterators case
return IteratorPrototype[ITERATOR].call(test)!==test;});if(NEW_ITERATOR_PROTOTYPE)IteratorPrototype={};else if(IS_PURE)IteratorPrototype=create(IteratorPrototype);// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if(!isCallable(IteratorPrototype[ITERATOR])){defineBuiltIn(IteratorPrototype,ITERATOR,function(){return this;});}module.exports={IteratorPrototype:IteratorPrototype,BUGGY_SAFARI_ITERATORS:BUGGY_SAFARI_ITERATORS};/***/}),/***/9164:(/***/function _(module){"use strict";module.exports={};/***/}),/***/9389:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_65413__){"use strict";var toLength=__nested_webpack_require_65413__(7611);// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports=function(obj){return toLength(obj.length);};/***/}),/***/4530:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_65704__){"use strict";var uncurryThis=__nested_webpack_require_65704__(6881);var fails=__nested_webpack_require_65704__(5234);var isCallable=__nested_webpack_require_65704__(4188);var hasOwn=__nested_webpack_require_65704__(4418);var DESCRIPTORS=__nested_webpack_require_65704__(6893);var CONFIGURABLE_FUNCTION_NAME=__nested_webpack_require_65704__(2735).CONFIGURABLE;var inspectSource=__nested_webpack_require_65704__(3029);var InternalStateModule=__nested_webpack_require_65704__(3086);var enforceInternalState=InternalStateModule.enforce;var getInternalState=InternalStateModule.get;var $String=String;// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty=Object.defineProperty;var stringSlice=uncurryThis(''.slice);var replace=uncurryThis(''.replace);var join=uncurryThis([].join);var CONFIGURABLE_LENGTH=DESCRIPTORS&&!fails(function(){return defineProperty(function(){/* empty */},'length',{value:8}).length!==8;});var TEMPLATE=String(String).split('String');var makeBuiltIn=module.exports=function(value,name,options){if(stringSlice($String(name),0,7)==='Symbol('){name='['+replace($String(name),/^Symbol\(([^)]*)\).*$/,'$1')+']';}if(options&&options.getter)name='get '+name;if(options&&options.setter)name='set '+name;if(!hasOwn(value,'name')||CONFIGURABLE_FUNCTION_NAME&&value.name!==name){if(DESCRIPTORS)defineProperty(value,'name',{value:name,configurable:true});else value.name=name;}if(CONFIGURABLE_LENGTH&&options&&hasOwn(options,'arity')&&value.length!==options.arity){defineProperty(value,'length',{value:options.arity});}try{if(options&&hasOwn(options,'constructor')&&options.constructor){if(DESCRIPTORS)defineProperty(value,'prototype',{writable:false});// in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
}else if(value.prototype)value.prototype=undefined;}catch(error){/* empty */}var state=enforceInternalState(value);if(!hasOwn(state,'source')){state.source=join(TEMPLATE,typeof name=='string'?name:'');}return value;};// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString=makeBuiltIn(function toString(){return isCallable(this)&&getInternalState(this).source||inspectSource(this);},'toString');/***/}),/***/142:(/***/function _(module){"use strict";var ceil=Math.ceil;var floor=Math.floor;// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports=Math.trunc||function trunc(x){var n=+x;return(n>0?floor:ceil)(n);};/***/}),/***/1982:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_68309__){"use strict";var globalThis=__nested_webpack_require_68309__(9117);var safeGetBuiltIn=__nested_webpack_require_68309__(5268);var bind=__nested_webpack_require_68309__(5821);var macrotask=__nested_webpack_require_68309__(3474).set;var Queue=__nested_webpack_require_68309__(8648);var IS_IOS=__nested_webpack_require_68309__(6347);var IS_IOS_PEBBLE=__nested_webpack_require_68309__(6168);var IS_WEBOS_WEBKIT=__nested_webpack_require_68309__(1129);var IS_NODE=__nested_webpack_require_68309__(3940);var MutationObserver=globalThis.MutationObserver||globalThis.WebKitMutationObserver;var document=globalThis.document;var process=globalThis.process;var Promise=globalThis.Promise;var microtask=safeGetBuiltIn('queueMicrotask');var notify,toggle,node,promise,then;// modern engines have queueMicrotask method
if(!microtask){var queue=new Queue();var flush=function flush(){var parent,fn;if(IS_NODE&&(parent=process.domain))parent.exit();while(fn=queue.get())try{fn();}catch(error){if(queue.head)notify();throw error;}if(parent)parent.enter();};// browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
// also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
if(!IS_IOS&&!IS_NODE&&!IS_WEBOS_WEBKIT&&MutationObserver&&document){toggle=true;node=document.createTextNode('');new MutationObserver(flush).observe(node,{characterData:true});notify=function notify(){node.data=toggle=!toggle;};// environments with maybe non-completely correct, but existent Promise
}else if(!IS_IOS_PEBBLE&&Promise&&Promise.resolve){// Promise.resolve without an argument throws an error in LG WebOS 2
promise=Promise.resolve(undefined);// workaround of WebKit ~ iOS Safari 10.1 bug
promise.constructor=Promise;then=bind(promise.then,promise);notify=function notify(){then(flush);};// Node.js without promises
}else if(IS_NODE){notify=function notify(){process.nextTick(flush);};// for other environments - macrotask based on:
// - setImmediate
// - MessageChannel
// - window.postMessage
// - onreadystatechange
// - setTimeout
}else{// `webpack` dev server bug on IE global methods - use bind(fn, global)
macrotask=bind(macrotask,globalThis);notify=function notify(){macrotask(flush);};}microtask=function microtask(fn){if(!queue.head)notify();queue.add(fn);};}module.exports=microtask;/***/}),/***/9444:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_70594__){"use strict";var aCallable=__nested_webpack_require_70594__(4977);var $TypeError=TypeError;var PromiseCapability=function PromiseCapability(C){var resolve,reject;this.promise=new C(function($$resolve,$$reject){if(resolve!==undefined||reject!==undefined)throw new $TypeError('Bad Promise constructor');resolve=$$resolve;reject=$$reject;});this.resolve=aCallable(resolve);this.reject=aCallable(reject);};// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f=function(C){return new PromiseCapability(C);};/***/}),/***/9866:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_71232__){"use strict";var toString=__nested_webpack_require_71232__(2618);module.exports=function(argument,$default){return argument===undefined?arguments.length<2?'':$default:toString(argument);};/***/}),/***/9456:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_71495__){"use strict";var DESCRIPTORS=__nested_webpack_require_71495__(6893);var uncurryThis=__nested_webpack_require_71495__(6881);var call=__nested_webpack_require_71495__(9944);var fails=__nested_webpack_require_71495__(5234);var objectKeys=__nested_webpack_require_71495__(7137);var getOwnPropertySymbolsModule=__nested_webpack_require_71495__(156);var propertyIsEnumerableModule=__nested_webpack_require_71495__(4416);var toObject=__nested_webpack_require_71495__(3628);var IndexedObject=__nested_webpack_require_71495__(7568);// eslint-disable-next-line es/no-object-assign -- safe
var $assign=Object.assign;// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty=Object.defineProperty;var concat=uncurryThis([].concat);// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports=!$assign||fails(function(){// should have correct order of operations (Edge bug)
if(DESCRIPTORS&&$assign({b:1},$assign(defineProperty({},'a',{enumerable:true,get:function get(){defineProperty(this,'b',{value:3,enumerable:false});}}),{b:2})).b!==1)return true;// should work with symbols and should have deterministic property order (V8 bug)
var A={};var B={};// eslint-disable-next-line es/no-symbol -- safe
var symbol=Symbol('assign detection');var alphabet='abcdefghijklmnopqrst';A[symbol]=7;alphabet.split('').forEach(function(chr){B[chr]=chr;});return $assign({},A)[symbol]!==7||objectKeys($assign({},B)).join('')!==alphabet;})?function assign(target,source){// eslint-disable-line no-unused-vars -- required for `.length`
var T=toObject(target);var argumentsLength=arguments.length;var index=1;var getOwnPropertySymbols=getOwnPropertySymbolsModule.f;var propertyIsEnumerable=propertyIsEnumerableModule.f;while(argumentsLength>index){var S=IndexedObject(arguments[index++]);var keys=getOwnPropertySymbols?concat(objectKeys(S),getOwnPropertySymbols(S)):objectKeys(S);var length=keys.length;var j=0;var key;while(length>j){key=keys[j++];if(!DESCRIPTORS||call(propertyIsEnumerable,S,key))T[key]=S[key];}}return T;}:$assign;/***/}),/***/7065:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_73537__){"use strict";/* global ActiveXObject -- old IE, WSH */var anObject=__nested_webpack_require_73537__(3770);var definePropertiesModule=__nested_webpack_require_73537__(30);var enumBugKeys=__nested_webpack_require_73537__(1274);var hiddenKeys=__nested_webpack_require_73537__(7588);var html=__nested_webpack_require_73537__(7458);var documentCreateElement=__nested_webpack_require_73537__(5926);var sharedKey=__nested_webpack_require_73537__(168);var GT='>';var LT='<';var PROTOTYPE='prototype';var SCRIPT='script';var IE_PROTO=sharedKey('IE_PROTO');var EmptyConstructor=function EmptyConstructor(){/* empty */};var scriptTag=function scriptTag(content){return LT+SCRIPT+GT+content+LT+'/'+SCRIPT+GT;};// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX=function NullProtoObjectViaActiveX(activeXDocument){activeXDocument.write(scriptTag(''));activeXDocument.close();var temp=activeXDocument.parentWindow.Object;// eslint-disable-next-line no-useless-assignment -- avoid memory leak
activeXDocument=null;return temp;};// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame=function NullProtoObjectViaIFrame(){// Thrash, waste and sodomy: IE GC bug
var iframe=documentCreateElement('iframe');var JS='java'+SCRIPT+':';var iframeDocument;iframe.style.display='none';html.appendChild(iframe);// https://github.com/zloirock/core-js/issues/475
iframe.src=String(JS);iframeDocument=iframe.contentWindow.document;iframeDocument.open();iframeDocument.write(scriptTag('document.F=Object'));iframeDocument.close();return iframeDocument.F;};// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;var _NullProtoObject=function NullProtoObject(){try{activeXDocument=new ActiveXObject('htmlfile');}catch(error){/* ignore */}_NullProtoObject=typeof document!='undefined'?document.domain&&activeXDocument?NullProtoObjectViaActiveX(activeXDocument)// old IE
:NullProtoObjectViaIFrame():NullProtoObjectViaActiveX(activeXDocument);// WSH
var length=enumBugKeys.length;while(length--)delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];return _NullProtoObject();};hiddenKeys[IE_PROTO]=true;// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports=Object.create||function create(O,Properties){var result;if(O!==null){EmptyConstructor[PROTOTYPE]=anObject(O);result=new EmptyConstructor();EmptyConstructor[PROTOTYPE]=null;// add "__proto__" for Object.getPrototypeOf polyfill
result[IE_PROTO]=O;}else result=_NullProtoObject();return Properties===undefined?result:definePropertiesModule.f(result,Properties);};/***/}),/***/30:(/***/function _(__unused_webpack_module,exports,__nested_webpack_require_76464__){"use strict";var DESCRIPTORS=__nested_webpack_require_76464__(6893);var V8_PROTOTYPE_DEFINE_BUG=__nested_webpack_require_76464__(3315);var definePropertyModule=__nested_webpack_require_76464__(4466);var anObject=__nested_webpack_require_76464__(3770);var toIndexedObject=__nested_webpack_require_76464__(380);var objectKeys=__nested_webpack_require_76464__(7137);// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f=DESCRIPTORS&&!V8_PROTOTYPE_DEFINE_BUG?Object.defineProperties:function defineProperties(O,Properties){anObject(O);var props=toIndexedObject(Properties);var keys=objectKeys(Properties);var length=keys.length;var index=0;var key;while(length>index)definePropertyModule.f(O,key=keys[index++],props[key]);return O;};/***/}),/***/4466:(/***/function _(__unused_webpack_module,exports,__nested_webpack_require_77317__){"use strict";var DESCRIPTORS=__nested_webpack_require_77317__(6893);var IE8_DOM_DEFINE=__nested_webpack_require_77317__(9622);var V8_PROTOTYPE_DEFINE_BUG=__nested_webpack_require_77317__(3315);var anObject=__nested_webpack_require_77317__(3770);var toPropertyKey=__nested_webpack_require_77317__(2344);var $TypeError=TypeError;// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty=Object.defineProperty;// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor=Object.getOwnPropertyDescriptor;var ENUMERABLE='enumerable';var CONFIGURABLE='configurable';var WRITABLE='writable';// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f=DESCRIPTORS?V8_PROTOTYPE_DEFINE_BUG?function defineProperty(O,P,Attributes){anObject(O);P=toPropertyKey(P);anObject(Attributes);if(typeof O==='function'&&P==='prototype'&&'value'in Attributes&&WRITABLE in Attributes&&!Attributes[WRITABLE]){var current=$getOwnPropertyDescriptor(O,P);if(current&&current[WRITABLE]){O[P]=Attributes.value;Attributes={configurable:CONFIGURABLE in Attributes?Attributes[CONFIGURABLE]:current[CONFIGURABLE],enumerable:ENUMERABLE in Attributes?Attributes[ENUMERABLE]:current[ENUMERABLE],writable:false};}}return $defineProperty(O,P,Attributes);}:$defineProperty:function defineProperty(O,P,Attributes){anObject(O);P=toPropertyKey(P);anObject(Attributes);if(IE8_DOM_DEFINE)try{return $defineProperty(O,P,Attributes);}catch(error){/* empty */}if('get'in Attributes||'set'in Attributes)throw new $TypeError('Accessors not supported');if('value'in Attributes)O[P]=Attributes.value;return O;};/***/}),/***/9304:(/***/function _(__unused_webpack_module,exports,__nested_webpack_require_79006__){"use strict";var DESCRIPTORS=__nested_webpack_require_79006__(6893);var call=__nested_webpack_require_79006__(9944);var propertyIsEnumerableModule=__nested_webpack_require_79006__(4416);var createPropertyDescriptor=__nested_webpack_require_79006__(9123);var toIndexedObject=__nested_webpack_require_79006__(380);var toPropertyKey=__nested_webpack_require_79006__(2344);var hasOwn=__nested_webpack_require_79006__(4418);var IE8_DOM_DEFINE=__nested_webpack_require_79006__(9622);// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor=Object.getOwnPropertyDescriptor;// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f=DESCRIPTORS?$getOwnPropertyDescriptor:function getOwnPropertyDescriptor(O,P){O=toIndexedObject(O);P=toPropertyKey(P);if(IE8_DOM_DEFINE)try{return $getOwnPropertyDescriptor(O,P);}catch(error){/* empty */}if(hasOwn(O,P))return createPropertyDescriptor(!call(propertyIsEnumerableModule.f,O,P),O[P]);};/***/}),/***/3701:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_80019__){"use strict";/* eslint-disable es/no-object-getownpropertynames -- safe */var classof=__nested_webpack_require_80019__(8689);var toIndexedObject=__nested_webpack_require_80019__(380);var $getOwnPropertyNames=__nested_webpack_require_80019__(5629).f;var arraySlice=__nested_webpack_require_80019__(7825);var windowNames=(typeof window==="undefined"?"undefined":_typeof2(window))=='object'&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];var getWindowNames=function getWindowNames(it){try{return $getOwnPropertyNames(it);}catch(error){return arraySlice(windowNames);}};// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f=function getOwnPropertyNames(it){return windowNames&&classof(it)==='Window'?getWindowNames(it):$getOwnPropertyNames(toIndexedObject(it));};/***/}),/***/5629:(/***/function _(__unused_webpack_module,exports,__nested_webpack_require_80881__){"use strict";var internalObjectKeys=__nested_webpack_require_80881__(1843);var enumBugKeys=__nested_webpack_require_80881__(1274);var hiddenKeys=enumBugKeys.concat('length','prototype');// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f=Object.getOwnPropertyNames||function getOwnPropertyNames(O){return internalObjectKeys(O,hiddenKeys);};/***/}),/***/156:(/***/function _(__unused_webpack_module,exports){"use strict";// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f=Object.getOwnPropertySymbols;/***/}),/***/1786:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_81598__){"use strict";var hasOwn=__nested_webpack_require_81598__(4418);var isCallable=__nested_webpack_require_81598__(4188);var toObject=__nested_webpack_require_81598__(3628);var sharedKey=__nested_webpack_require_81598__(168);var CORRECT_PROTOTYPE_GETTER=__nested_webpack_require_81598__(680);var IE_PROTO=sharedKey('IE_PROTO');var $Object=Object;var ObjectPrototype=$Object.prototype;// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports=CORRECT_PROTOTYPE_GETTER?$Object.getPrototypeOf:function(O){var object=toObject(O);if(hasOwn(object,IE_PROTO))return object[IE_PROTO];var constructor=object.constructor;if(isCallable(constructor)&&object instanceof constructor){return constructor.prototype;}return object instanceof $Object?ObjectPrototype:null;};/***/}),/***/4578:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_82482__){"use strict";var uncurryThis=__nested_webpack_require_82482__(6881);module.exports=uncurryThis({}.isPrototypeOf);/***/}),/***/1843:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_82670__){"use strict";var uncurryThis=__nested_webpack_require_82670__(6881);var hasOwn=__nested_webpack_require_82670__(4418);var toIndexedObject=__nested_webpack_require_82670__(380);var indexOf=__nested_webpack_require_82670__(1458).indexOf;var hiddenKeys=__nested_webpack_require_82670__(7588);var push=uncurryThis([].push);module.exports=function(object,names){var O=toIndexedObject(object);var i=0;var result=[];var key;for(key in O)!hasOwn(hiddenKeys,key)&&hasOwn(O,key)&&push(result,key);// Don't enum bug & hidden keys
while(names.length>i)if(hasOwn(O,key=names[i++])){~indexOf(result,key)||push(result,key);}return result;};/***/}),/***/7137:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_83318__){"use strict";var internalObjectKeys=__nested_webpack_require_83318__(1843);var enumBugKeys=__nested_webpack_require_83318__(1274);// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports=Object.keys||function keys(O){return internalObjectKeys(O,enumBugKeys);};/***/}),/***/4416:(/***/function _(__unused_webpack_module,exports){"use strict";var $propertyIsEnumerable={}.propertyIsEnumerable;// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor=Object.getOwnPropertyDescriptor;// Nashorn ~ JDK8 bug
var NASHORN_BUG=getOwnPropertyDescriptor&&!$propertyIsEnumerable.call({1:2},1);// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f=NASHORN_BUG?function propertyIsEnumerable(V){var descriptor=getOwnPropertyDescriptor(this,V);return!!descriptor&&descriptor.enumerable;}:$propertyIsEnumerable;/***/}),/***/5054:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_84391__){"use strict";/* eslint-disable no-proto -- safe */var uncurryThisAccessor=__nested_webpack_require_84391__(1025);var isObject=__nested_webpack_require_84391__(831);var requireObjectCoercible=__nested_webpack_require_84391__(9509);var aPossiblePrototype=__nested_webpack_require_84391__(4121);// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports=Object.setPrototypeOf||('__proto__'in{}?function(){var CORRECT_SETTER=false;var test={};var setter;try{setter=uncurryThisAccessor(Object.prototype,'__proto__','set');setter(test,[]);CORRECT_SETTER=test instanceof Array;}catch(error){/* empty */}return function setPrototypeOf(O,proto){requireObjectCoercible(O);aPossiblePrototype(proto);if(!isObject(O))return O;if(CORRECT_SETTER)setter(O,proto);else O.__proto__=proto;return O;};}():undefined);/***/}),/***/2244:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_85404__){"use strict";var TO_STRING_TAG_SUPPORT=__nested_webpack_require_85404__(9345);var classof=__nested_webpack_require_85404__(5438);// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports=TO_STRING_TAG_SUPPORT?{}.toString:function toString(){return'[object '+classof(this)+']';};/***/}),/***/2287:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_85812__){"use strict";var call=__nested_webpack_require_85812__(9944);var isCallable=__nested_webpack_require_85812__(4188);var isObject=__nested_webpack_require_85812__(831);var $TypeError=TypeError;// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports=function(input,pref){var fn,val;if(pref==='string'&&isCallable(fn=input.toString)&&!isObject(val=call(fn,input)))return val;if(isCallable(fn=input.valueOf)&&!isObject(val=call(fn,input)))return val;if(pref!=='string'&&isCallable(fn=input.toString)&&!isObject(val=call(fn,input)))return val;throw new $TypeError("Can't convert object to primitive value");};/***/}),/***/3168:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_86519__){"use strict";var getBuiltIn=__nested_webpack_require_86519__(5604);var uncurryThis=__nested_webpack_require_86519__(6881);var getOwnPropertyNamesModule=__nested_webpack_require_86519__(5629);var getOwnPropertySymbolsModule=__nested_webpack_require_86519__(156);var anObject=__nested_webpack_require_86519__(3770);var concat=uncurryThis([].concat);// all object keys, includes non-enumerable and symbols
module.exports=getBuiltIn('Reflect','ownKeys')||function ownKeys(it){var keys=getOwnPropertyNamesModule.f(anObject(it));var getOwnPropertySymbols=getOwnPropertySymbolsModule.f;return getOwnPropertySymbols?concat(keys,getOwnPropertySymbols(it)):keys;};/***/}),/***/9120:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_87196__){"use strict";var globalThis=__nested_webpack_require_87196__(9117);module.exports=globalThis;/***/}),/***/6042:(/***/function _(module){"use strict";module.exports=function(exec){try{return{error:false,value:exec()};}catch(error){return{error:true,value:error};}};/***/}),/***/7301:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_87535__){"use strict";var globalThis=__nested_webpack_require_87535__(9117);var NativePromiseConstructor=__nested_webpack_require_87535__(6453);var isCallable=__nested_webpack_require_87535__(4188);var isForced=__nested_webpack_require_87535__(8489);var inspectSource=__nested_webpack_require_87535__(3029);var wellKnownSymbol=__nested_webpack_require_87535__(4282);var ENVIRONMENT=__nested_webpack_require_87535__(1078);var IS_PURE=__nested_webpack_require_87535__(1942);var V8_VERSION=__nested_webpack_require_87535__(3008);var NativePromisePrototype=NativePromiseConstructor&&NativePromiseConstructor.prototype;var SPECIES=wellKnownSymbol('species');var SUBCLASSING=false;var NATIVE_PROMISE_REJECTION_EVENT=isCallable(globalThis.PromiseRejectionEvent);var FORCED_PROMISE_CONSTRUCTOR=isForced('Promise',function(){var PROMISE_CONSTRUCTOR_SOURCE=inspectSource(NativePromiseConstructor);var GLOBAL_CORE_JS_PROMISE=PROMISE_CONSTRUCTOR_SOURCE!==String(NativePromiseConstructor);// V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
// https://bugs.chromium.org/p/chromium/issues/detail?id=830565
// We can't detect it synchronously, so just check versions
if(!GLOBAL_CORE_JS_PROMISE&&V8_VERSION===66)return true;// We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
if(IS_PURE&&!(NativePromisePrototype['catch']&&NativePromisePrototype['finally']))return true;// We can't use @@species feature detection in V8 since it causes
// deoptimization and performance degradation
// https://github.com/zloirock/core-js/issues/679
if(!V8_VERSION||V8_VERSION<51||!/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)){// Detect correctness of subclassing with @@species support
var promise=new NativePromiseConstructor(function(resolve){resolve(1);});var FakePromise=function FakePromise(exec){exec(function(){/* empty */},function(){/* empty */});};var constructor=promise.constructor={};constructor[SPECIES]=FakePromise;SUBCLASSING=promise.then(function(){/* empty */})instanceof FakePromise;if(!SUBCLASSING)return true;// Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
}return!GLOBAL_CORE_JS_PROMISE&&(ENVIRONMENT==='BROWSER'||ENVIRONMENT==='DENO')&&!NATIVE_PROMISE_REJECTION_EVENT;});module.exports={CONSTRUCTOR:FORCED_PROMISE_CONSTRUCTOR,REJECTION_EVENT:NATIVE_PROMISE_REJECTION_EVENT,SUBCLASSING:SUBCLASSING};/***/}),/***/6453:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_89895__){"use strict";var globalThis=__nested_webpack_require_89895__(9117);module.exports=globalThis.Promise;/***/}),/***/8787:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_90071__){"use strict";var anObject=__nested_webpack_require_90071__(3770);var isObject=__nested_webpack_require_90071__(831);var newPromiseCapability=__nested_webpack_require_90071__(9444);module.exports=function(C,x){anObject(C);if(isObject(x)&&x.constructor===C)return x;var promiseCapability=newPromiseCapability.f(C);var resolve=promiseCapability.resolve;resolve(x);return promiseCapability.promise;};/***/}),/***/6292:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_90516__){"use strict";var NativePromiseConstructor=__nested_webpack_require_90516__(6453);var checkCorrectnessOfIteration=__nested_webpack_require_90516__(7283);var FORCED_PROMISE_CONSTRUCTOR=__nested_webpack_require_90516__(7301).CONSTRUCTOR;module.exports=FORCED_PROMISE_CONSTRUCTOR||!checkCorrectnessOfIteration(function(iterable){NativePromiseConstructor.all(iterable).then(undefined,function(){/* empty */});});/***/}),/***/8679:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_90972__){"use strict";var defineProperty=__nested_webpack_require_90972__(4466).f;module.exports=function(Target,Source,key){key in Target||defineProperty(Target,key,{configurable:true,get:function get(){return Source[key];},set:function set(it){Source[key]=it;}});};/***/}),/***/8648:(/***/function _(module){"use strict";var Queue=function Queue(){this.head=null;this.tail=null;};Queue.prototype={add:function add(item){var entry={item:item,next:null};var tail=this.tail;if(tail)tail.next=entry;else this.head=entry;this.tail=entry;},get:function get(){var entry=this.head;if(entry){var next=this.head=entry.next;if(next===null)this.tail=null;return entry.item;}}};module.exports=Queue;/***/}),/***/4721:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_91726__){"use strict";var call=__nested_webpack_require_91726__(9944);var anObject=__nested_webpack_require_91726__(3770);var isCallable=__nested_webpack_require_91726__(4188);var classof=__nested_webpack_require_91726__(8689);var regexpExec=__nested_webpack_require_91726__(9342);var $TypeError=TypeError;// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports=function(R,S){var exec=R.exec;if(isCallable(exec)){var result=call(exec,R,S);if(result!==null)anObject(result);return result;}if(classof(R)==='RegExp')return call(regexpExec,R,S);throw new $TypeError('RegExp#exec called on incompatible receiver');};/***/}),/***/9342:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_92388__){"use strict";/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing *//* eslint-disable regexp/no-useless-quantifier -- testing */var call=__nested_webpack_require_92388__(9944);var uncurryThis=__nested_webpack_require_92388__(6881);var toString=__nested_webpack_require_92388__(2618);var regexpFlags=__nested_webpack_require_92388__(4932);var stickyHelpers=__nested_webpack_require_92388__(5976);var shared=__nested_webpack_require_92388__(746);var create=__nested_webpack_require_92388__(7065);var getInternalState=__nested_webpack_require_92388__(3086).get;var UNSUPPORTED_DOT_ALL=__nested_webpack_require_92388__(6676);var UNSUPPORTED_NCG=__nested_webpack_require_92388__(4609);var nativeReplace=shared('native-string-replace',String.prototype.replace);var nativeExec=RegExp.prototype.exec;var patchedExec=nativeExec;var charAt=uncurryThis(''.charAt);var indexOf=uncurryThis(''.indexOf);var replace=uncurryThis(''.replace);var stringSlice=uncurryThis(''.slice);var UPDATES_LAST_INDEX_WRONG=function(){var re1=/a/;var re2=/b*/g;call(nativeExec,re1,'a');call(nativeExec,re2,'a');return re1.lastIndex!==0||re2.lastIndex!==0;}();var UNSUPPORTED_Y=stickyHelpers.BROKEN_CARET;// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED=/()??/.exec('')[1]!==undefined;var PATCH=UPDATES_LAST_INDEX_WRONG||NPCG_INCLUDED||UNSUPPORTED_Y||UNSUPPORTED_DOT_ALL||UNSUPPORTED_NCG;if(PATCH){patchedExec=function exec(string){var re=this;var state=getInternalState(re);var str=toString(string);var raw=state.raw;var result,reCopy,lastIndex,match,i,object,group;if(raw){raw.lastIndex=re.lastIndex;result=call(patchedExec,raw,str);re.lastIndex=raw.lastIndex;return result;}var groups=state.groups;var sticky=UNSUPPORTED_Y&&re.sticky;var flags=call(regexpFlags,re);var source=re.source;var charsAdded=0;var strCopy=str;if(sticky){flags=replace(flags,'y','');if(indexOf(flags,'g')===-1){flags+='g';}strCopy=stringSlice(str,re.lastIndex);// Support anchored sticky behavior.
if(re.lastIndex>0&&(!re.multiline||re.multiline&&charAt(str,re.lastIndex-1)!=='\n')){source='(?: '+source+')';strCopy=' '+strCopy;charsAdded++;}// ^(? + rx + ) is needed, in combination with some str slicing, to
// simulate the 'y' flag.
reCopy=new RegExp('^(?:'+source+')',flags);}if(NPCG_INCLUDED){reCopy=new RegExp('^'+source+'$(?!\\s)',flags);}if(UPDATES_LAST_INDEX_WRONG)lastIndex=re.lastIndex;match=call(nativeExec,sticky?reCopy:re,strCopy);if(sticky){if(match){match.input=stringSlice(match.input,charsAdded);match[0]=stringSlice(match[0],charsAdded);match.index=re.lastIndex;re.lastIndex+=match[0].length;}else re.lastIndex=0;}else if(UPDATES_LAST_INDEX_WRONG&&match){re.lastIndex=re.global?match.index+match[0].length:lastIndex;}if(NPCG_INCLUDED&&match&&match.length>1){// Fix browsers whose `exec` methods don't consistently return `undefined`
// for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
call(nativeReplace,match[0],reCopy,function(){for(i=1;i<arguments.length-2;i++){if(arguments[i]===undefined)match[i]=undefined;}});}if(match&&groups){match.groups=object=create(null);for(i=0;i<groups.length;i++){group=groups[i];object[group[0]]=match[group[1]];}}return match;};}module.exports=patchedExec;/***/}),/***/4932:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_95609__){"use strict";var anObject=__nested_webpack_require_95609__(3770);// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports=function(){var that=anObject(this);var result='';if(that.hasIndices)result+='d';if(that.global)result+='g';if(that.ignoreCase)result+='i';if(that.multiline)result+='m';if(that.dotAll)result+='s';if(that.unicode)result+='u';if(that.unicodeSets)result+='v';if(that.sticky)result+='y';return result;};/***/}),/***/5976:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_96171__){"use strict";var fails=__nested_webpack_require_96171__(5234);var globalThis=__nested_webpack_require_96171__(9117);// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp=globalThis.RegExp;var UNSUPPORTED_Y=fails(function(){var re=$RegExp('a','y');re.lastIndex=2;return re.exec('abcd')!==null;});// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY=UNSUPPORTED_Y||fails(function(){return!$RegExp('a','y').sticky;});var BROKEN_CARET=UNSUPPORTED_Y||fails(function(){// https://bugzilla.mozilla.org/show_bug.cgi?id=773687
var re=$RegExp('^r','gy');re.lastIndex=2;return re.exec('str')!==null;});module.exports={BROKEN_CARET:BROKEN_CARET,MISSED_STICKY:MISSED_STICKY,UNSUPPORTED_Y:UNSUPPORTED_Y};/***/}),/***/6676:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_97014__){"use strict";var fails=__nested_webpack_require_97014__(5234);var globalThis=__nested_webpack_require_97014__(9117);// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp=globalThis.RegExp;module.exports=fails(function(){var re=$RegExp('.','s');return!(re.dotAll&&re.test('\n')&&re.flags==='s');});/***/}),/***/4609:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_97430__){"use strict";var fails=__nested_webpack_require_97430__(5234);var globalThis=__nested_webpack_require_97430__(9117);// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp=globalThis.RegExp;module.exports=fails(function(){var re=$RegExp('(?<a>b)','g');return re.exec('b').groups.a!=='b'||'b'.replace(re,'$<a>c')!=='bc';});/***/}),/***/9509:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_97881__){"use strict";var isNullOrUndefined=__nested_webpack_require_97881__(4318);var $TypeError=TypeError;// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports=function(it){if(isNullOrUndefined(it))throw new $TypeError("Can't call method on "+it);return it;};/***/}),/***/5268:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_98271__){"use strict";var globalThis=__nested_webpack_require_98271__(9117);var DESCRIPTORS=__nested_webpack_require_98271__(6893);// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor=Object.getOwnPropertyDescriptor;// Avoid NodeJS experimental warning
module.exports=function(name){if(!DESCRIPTORS)return globalThis[name];var descriptor=getOwnPropertyDescriptor(globalThis,name);return descriptor&&descriptor.value;};/***/}),/***/3900:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_98792__){"use strict";var getBuiltIn=__nested_webpack_require_98792__(5604);var defineBuiltInAccessor=__nested_webpack_require_98792__(997);var wellKnownSymbol=__nested_webpack_require_98792__(4282);var DESCRIPTORS=__nested_webpack_require_98792__(6893);var SPECIES=wellKnownSymbol('species');module.exports=function(CONSTRUCTOR_NAME){var Constructor=getBuiltIn(CONSTRUCTOR_NAME);if(DESCRIPTORS&&Constructor&&!Constructor[SPECIES]){defineBuiltInAccessor(Constructor,SPECIES,{configurable:true,get:function get(){return this;}});}};/***/}),/***/3754:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_99350__){"use strict";var defineProperty=__nested_webpack_require_99350__(4466).f;var hasOwn=__nested_webpack_require_99350__(4418);var wellKnownSymbol=__nested_webpack_require_99350__(4282);var TO_STRING_TAG=wellKnownSymbol('toStringTag');module.exports=function(target,TAG,STATIC){if(target&&!STATIC)target=target.prototype;if(target&&!hasOwn(target,TO_STRING_TAG)){defineProperty(target,TO_STRING_TAG,{configurable:true,value:TAG});}};/***/}),/***/168:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_99827__){"use strict";var shared=__nested_webpack_require_99827__(746);var uid=__nested_webpack_require_99827__(6209);var keys=shared('keys');module.exports=function(key){return keys[key]||(keys[key]=uid(key));};/***/}),/***/2694:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_100092__){"use strict";var IS_PURE=__nested_webpack_require_100092__(1942);var globalThis=__nested_webpack_require_100092__(9117);var defineGlobalProperty=__nested_webpack_require_100092__(4798);var SHARED='__core-js_shared__';var store=module.exports=globalThis[SHARED]||defineGlobalProperty(SHARED,{});(store.versions||(store.versions=[])).push({version:'3.39.0',mode:IS_PURE?'pure':'global',copyright:'© 2014-2024 Denis Pushkarev (zloirock.ru)',license:'https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE',source:'https://github.com/zloirock/core-js'});/***/}),/***/746:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_100689__){"use strict";var store=__nested_webpack_require_100689__(2694);module.exports=function(key,value){return store[key]||(store[key]=value||{});};/***/}),/***/7964:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_100905__){"use strict";var anObject=__nested_webpack_require_100905__(3770);var aConstructor=__nested_webpack_require_100905__(1361);var isNullOrUndefined=__nested_webpack_require_100905__(4318);var wellKnownSymbol=__nested_webpack_require_100905__(4282);var SPECIES=wellKnownSymbol('species');// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports=function(O,defaultConstructor){var C=anObject(O).constructor;var S;return C===undefined||isNullOrUndefined(S=anObject(C)[SPECIES])?defaultConstructor:aConstructor(S);};/***/}),/***/4212:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_101498__){"use strict";var uncurryThis=__nested_webpack_require_101498__(6881);var toIntegerOrInfinity=__nested_webpack_require_101498__(6744);var toString=__nested_webpack_require_101498__(2618);var requireObjectCoercible=__nested_webpack_require_101498__(9509);var charAt=uncurryThis(''.charAt);var charCodeAt=uncurryThis(''.charCodeAt);var stringSlice=uncurryThis(''.slice);var createMethod=function createMethod(CONVERT_TO_STRING){return function($this,pos){var S=toString(requireObjectCoercible($this));var position=toIntegerOrInfinity(pos);var size=S.length;var first,second;if(position<0||position>=size)return CONVERT_TO_STRING?'':undefined;first=charCodeAt(S,position);return first<0xD800||first>0xDBFF||position+1===size||(second=charCodeAt(S,position+1))<0xDC00||second>0xDFFF?CONVERT_TO_STRING?charAt(S,position):first:CONVERT_TO_STRING?stringSlice(S,position,position+2):(first-0xD800<<10)+(second-0xDC00)+0x10000;};};module.exports={// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
codeAt:createMethod(false),// `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at
charAt:createMethod(true)};/***/}),/***/2771:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_102711__){"use strict";var uncurryThis=__nested_webpack_require_102711__(6881);var requireObjectCoercible=__nested_webpack_require_102711__(9509);var toString=__nested_webpack_require_102711__(2618);var whitespaces=__nested_webpack_require_102711__(9209);var replace=uncurryThis(''.replace);var ltrim=RegExp('^['+whitespaces+']+');var rtrim=RegExp('(^|[^'+whitespaces+'])['+whitespaces+']+$');// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod=function createMethod(TYPE){return function($this){var string=toString(requireObjectCoercible($this));if(TYPE&1)string=replace(string,ltrim,'');if(TYPE&2)string=replace(string,rtrim,'$1');return string;};};module.exports={// `String.prototype.{ trimLeft, trimStart }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
start:createMethod(1),// `String.prototype.{ trimRight, trimEnd }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimend
end:createMethod(2),// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
trim:createMethod(3)};/***/}),/***/8944:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_103835__){"use strict";/* eslint-disable es/no-symbol -- required for testing */var V8_VERSION=__nested_webpack_require_103835__(3008);var fails=__nested_webpack_require_103835__(5234);var globalThis=__nested_webpack_require_103835__(9117);var $String=globalThis.String;// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports=!!Object.getOwnPropertySymbols&&!fails(function(){var symbol=Symbol('symbol detection');// Chrome 38 Symbol has incorrect toString conversion
// `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
// nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
// of course, fail.
return!$String(symbol)||!(Object(symbol)instanceof Symbol)||// Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
!Symbol.sham&&V8_VERSION&&V8_VERSION<41;});/***/}),/***/7093:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_104785__){"use strict";var call=__nested_webpack_require_104785__(9944);var getBuiltIn=__nested_webpack_require_104785__(5604);var wellKnownSymbol=__nested_webpack_require_104785__(4282);var defineBuiltIn=__nested_webpack_require_104785__(7509);module.exports=function(){var _Symbol=getBuiltIn('Symbol');var SymbolPrototype=_Symbol&&_Symbol.prototype;var valueOf=SymbolPrototype&&SymbolPrototype.valueOf;var TO_PRIMITIVE=wellKnownSymbol('toPrimitive');if(SymbolPrototype&&!SymbolPrototype[TO_PRIMITIVE]){// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
// eslint-disable-next-line no-unused-vars -- required for .length
defineBuiltIn(SymbolPrototype,TO_PRIMITIVE,function(hint){return call(valueOf,this);},{arity:1});}};/***/}),/***/6577:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_105585__){"use strict";var NATIVE_SYMBOL=__nested_webpack_require_105585__(8944);/* eslint-disable es/no-symbol -- safe */module.exports=NATIVE_SYMBOL&&!!Symbol['for']&&!!Symbol.keyFor;/***/}),/***/3474:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_105834__){"use strict";var globalThis=__nested_webpack_require_105834__(9117);var apply=__nested_webpack_require_105834__(646);var bind=__nested_webpack_require_105834__(5821);var isCallable=__nested_webpack_require_105834__(4188);var hasOwn=__nested_webpack_require_105834__(4418);var fails=__nested_webpack_require_105834__(5234);var html=__nested_webpack_require_105834__(7458);var arraySlice=__nested_webpack_require_105834__(7825);var createElement=__nested_webpack_require_105834__(5926);var validateArgumentsLength=__nested_webpack_require_105834__(9445);var IS_IOS=__nested_webpack_require_105834__(6347);var IS_NODE=__nested_webpack_require_105834__(3940);var set=globalThis.setImmediate;var clear=globalThis.clearImmediate;var process=globalThis.process;var Dispatch=globalThis.Dispatch;var Function=globalThis.Function;var MessageChannel=globalThis.MessageChannel;var String=globalThis.String;var counter=0;var queue={};var ONREADYSTATECHANGE='onreadystatechange';var $location,defer,channel,port;fails(function(){// Deno throws a ReferenceError on `location` access without `--location` flag
$location=globalThis.location;});var run=function run(id){if(hasOwn(queue,id)){var fn=queue[id];delete queue[id];fn();}};var runner=function runner(id){return function(){run(id);};};var eventListener=function eventListener(event){run(event.data);};var globalPostMessageDefer=function globalPostMessageDefer(id){// old engines have not location.origin
globalThis.postMessage(String(id),$location.protocol+'//'+$location.host);};// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!set||!clear){set=function setImmediate(handler){validateArgumentsLength(arguments.length,1);var fn=isCallable(handler)?handler:Function(handler);var args=arraySlice(arguments,1);queue[++counter]=function(){apply(fn,undefined,args);};defer(counter);return counter;};clear=function clearImmediate(id){delete queue[id];};// Node.js 0.8-
if(IS_NODE){defer=function defer(id){process.nextTick(runner(id));};// Sphere (JS game engine) Dispatch API
}else if(Dispatch&&Dispatch.now){defer=function defer(id){Dispatch.now(runner(id));};// Browsers with MessageChannel, includes WebWorkers
// except iOS - https://github.com/zloirock/core-js/issues/624
}else if(MessageChannel&&!IS_IOS){channel=new MessageChannel();port=channel.port2;channel.port1.onmessage=eventListener;defer=bind(port.postMessage,port);// Browsers with postMessage, skip WebWorkers
// IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
}else if(globalThis.addEventListener&&isCallable(globalThis.postMessage)&&!globalThis.importScripts&&$location&&$location.protocol!=='file:'&&!fails(globalPostMessageDefer)){defer=globalPostMessageDefer;globalThis.addEventListener('message',eventListener,false);// IE8-
}else if(ONREADYSTATECHANGE in createElement('script')){defer=function defer(id){html.appendChild(createElement('script'))[ONREADYSTATECHANGE]=function(){html.removeChild(this);run(id);};};// Rest old browsers
}else{defer=function defer(id){setTimeout(runner(id),0);};}}module.exports={set:set,clear:clear};/***/}),/***/5881:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_108827__){"use strict";var uncurryThis=__nested_webpack_require_108827__(6881);// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports=uncurryThis(1.0.valueOf);/***/}),/***/675:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_109097__){"use strict";var toIntegerOrInfinity=__nested_webpack_require_109097__(6744);var max=Math.max;var min=Math.min;// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports=function(index,length){var integer=toIntegerOrInfinity(index);return integer<0?max(integer+length,0):min(integer,length);};/***/}),/***/380:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_109611__){"use strict";// toObject with fallback for non-array-like ES3 strings
var IndexedObject=__nested_webpack_require_109611__(7568);var requireObjectCoercible=__nested_webpack_require_109611__(9509);module.exports=function(it){return IndexedObject(requireObjectCoercible(it));};/***/}),/***/6744:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_109945__){"use strict";var trunc=__nested_webpack_require_109945__(142);// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports=function(argument){var number=+argument;// eslint-disable-next-line no-self-compare -- NaN check
return number!==number||number===0?0:trunc(number);};/***/}),/***/7611:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_110342__){"use strict";var toIntegerOrInfinity=__nested_webpack_require_110342__(6744);var min=Math.min;// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports=function(argument){var len=toIntegerOrInfinity(argument);return len>0?min(len,0x1FFFFFFFFFFFFF):0;// 2 ** 53 - 1 == 9007199254740991
};/***/}),/***/3628:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_110734__){"use strict";var requireObjectCoercible=__nested_webpack_require_110734__(9509);var $Object=Object;// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports=function(argument){return $Object(requireObjectCoercible(argument));};/***/}),/***/290:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_111065__){"use strict";var call=__nested_webpack_require_111065__(9944);var isObject=__nested_webpack_require_111065__(831);var isSymbol=__nested_webpack_require_111065__(6032);var getMethod=__nested_webpack_require_111065__(2913);var ordinaryToPrimitive=__nested_webpack_require_111065__(2287);var wellKnownSymbol=__nested_webpack_require_111065__(4282);var $TypeError=TypeError;var TO_PRIMITIVE=wellKnownSymbol('toPrimitive');// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports=function(input,pref){if(!isObject(input)||isSymbol(input))return input;var exoticToPrim=getMethod(input,TO_PRIMITIVE);var result;if(exoticToPrim){if(pref===undefined)pref='default';result=call(exoticToPrim,input,pref);if(!isObject(result)||isSymbol(result))return result;throw new $TypeError("Can't convert object to primitive value");}if(pref===undefined)pref='number';return ordinaryToPrimitive(input,pref);};/***/}),/***/2344:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_111993__){"use strict";var toPrimitive=__nested_webpack_require_111993__(290);var isSymbol=__nested_webpack_require_111993__(6032);// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports=function(argument){var key=toPrimitive(argument,'string');return isSymbol(key)?key:key+'';};/***/}),/***/9345:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_112365__){"use strict";var wellKnownSymbol=__nested_webpack_require_112365__(4282);var TO_STRING_TAG=wellKnownSymbol('toStringTag');var test={};test[TO_STRING_TAG]='z';module.exports=String(test)==='[object z]';/***/}),/***/2618:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_112640__){"use strict";var classof=__nested_webpack_require_112640__(5438);var $String=String;module.exports=function(argument){if(classof(argument)==='Symbol')throw new TypeError('Cannot convert a Symbol value to a string');return $String(argument);};/***/}),/***/3174:(/***/function _(module){"use strict";var $String=String;module.exports=function(argument){try{return $String(argument);}catch(error){return'Object';}};/***/}),/***/6209:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_113126__){"use strict";var uncurryThis=__nested_webpack_require_113126__(6881);var id=0;var postfix=Math.random();var toString=uncurryThis(1.0.toString);module.exports=function(key){return'Symbol('+(key===undefined?'':key)+')_'+toString(++id+postfix,36);};/***/}),/***/9809:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_113446__){"use strict";/* eslint-disable es/no-symbol -- required for testing */var NATIVE_SYMBOL=__nested_webpack_require_113446__(8944);module.exports=NATIVE_SYMBOL&&!Symbol.sham&&_typeof2(Symbol.iterator)=='symbol';/***/}),/***/3315:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_113728__){"use strict";var DESCRIPTORS=__nested_webpack_require_113728__(6893);var fails=__nested_webpack_require_113728__(5234);// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports=DESCRIPTORS&&fails(function(){// eslint-disable-next-line es/no-object-defineproperty -- required for testing
return Object.defineProperty(function(){/* empty */},'prototype',{value:42,writable:false}).prototype!==42;});/***/}),/***/9445:(/***/function _(module){"use strict";var $TypeError=TypeError;module.exports=function(passed,required){if(passed<required)throw new $TypeError('Not enough arguments');return passed;};/***/}),/***/5945:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_114419__){"use strict";var globalThis=__nested_webpack_require_114419__(9117);var isCallable=__nested_webpack_require_114419__(4188);var WeakMap=globalThis.WeakMap;module.exports=isCallable(WeakMap)&&/native code/.test(String(WeakMap));/***/}),/***/2860:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_114705__){"use strict";var path=__nested_webpack_require_114705__(9120);var hasOwn=__nested_webpack_require_114705__(4418);var wrappedWellKnownSymbolModule=__nested_webpack_require_114705__(346);var defineProperty=__nested_webpack_require_114705__(4466).f;module.exports=function(NAME){var _Symbol2=path.Symbol||(path.Symbol={});if(!hasOwn(_Symbol2,NAME))defineProperty(_Symbol2,NAME,{value:wrappedWellKnownSymbolModule.f(NAME)});};/***/}),/***/346:(/***/function _(__unused_webpack_module,exports,__nested_webpack_require_115158__){"use strict";var wellKnownSymbol=__nested_webpack_require_115158__(4282);exports.f=wellKnownSymbol;/***/}),/***/4282:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_115331__){"use strict";var globalThis=__nested_webpack_require_115331__(9117);var shared=__nested_webpack_require_115331__(746);var hasOwn=__nested_webpack_require_115331__(4418);var uid=__nested_webpack_require_115331__(6209);var NATIVE_SYMBOL=__nested_webpack_require_115331__(8944);var USE_SYMBOL_AS_UID=__nested_webpack_require_115331__(9809);var _Symbol3=globalThis.Symbol;var WellKnownSymbolsStore=shared('wks');var createWellKnownSymbol=USE_SYMBOL_AS_UID?_Symbol3['for']||_Symbol3:_Symbol3&&_Symbol3.withoutSetter||uid;module.exports=function(name){if(!hasOwn(WellKnownSymbolsStore,name)){WellKnownSymbolsStore[name]=NATIVE_SYMBOL&&hasOwn(_Symbol3,name)?_Symbol3[name]:createWellKnownSymbol('Symbol.'+name);}return WellKnownSymbolsStore[name];};/***/}),/***/9209:(/***/function _(module){"use strict";// a string of all valid unicode whitespaces
module.exports="\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002"+"\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";/***/}),/***/6208:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_116324__){"use strict";var getBuiltIn=__nested_webpack_require_116324__(5604);var hasOwn=__nested_webpack_require_116324__(4418);var createNonEnumerableProperty=__nested_webpack_require_116324__(8088);var isPrototypeOf=__nested_webpack_require_116324__(4578);var setPrototypeOf=__nested_webpack_require_116324__(5054);var copyConstructorProperties=__nested_webpack_require_116324__(8657);var proxyAccessor=__nested_webpack_require_116324__(8679);var inheritIfRequired=__nested_webpack_require_116324__(4166);var normalizeStringArgument=__nested_webpack_require_116324__(9866);var installErrorCause=__nested_webpack_require_116324__(8257);var installErrorStack=__nested_webpack_require_116324__(5382);var DESCRIPTORS=__nested_webpack_require_116324__(6893);var IS_PURE=__nested_webpack_require_116324__(1942);module.exports=function(FULL_NAME,wrapper,FORCED,IS_AGGREGATE_ERROR){var STACK_TRACE_LIMIT='stackTraceLimit';var OPTIONS_POSITION=IS_AGGREGATE_ERROR?2:1;var path=FULL_NAME.split('.');var ERROR_NAME=path[path.length-1];var OriginalError=getBuiltIn.apply(null,path);if(!OriginalError)return;var OriginalErrorPrototype=OriginalError.prototype;// V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
if(!IS_PURE&&hasOwn(OriginalErrorPrototype,'cause'))delete OriginalErrorPrototype.cause;if(!FORCED)return OriginalError;var BaseError=getBuiltIn('Error');var WrappedError=wrapper(function(a,b){var message=normalizeStringArgument(IS_AGGREGATE_ERROR?b:a,undefined);var result=IS_AGGREGATE_ERROR?new OriginalError(a):new OriginalError();if(message!==undefined)createNonEnumerableProperty(result,'message',message);installErrorStack(result,WrappedError,result.stack,2);if(this&&isPrototypeOf(OriginalErrorPrototype,this))inheritIfRequired(result,this,WrappedError);if(arguments.length>OPTIONS_POSITION)installErrorCause(result,arguments[OPTIONS_POSITION]);return result;});WrappedError.prototype=OriginalErrorPrototype;if(ERROR_NAME!=='Error'){if(setPrototypeOf)setPrototypeOf(WrappedError,BaseError);else copyConstructorProperties(WrappedError,BaseError,{name:true});}else if(DESCRIPTORS&&STACK_TRACE_LIMIT in OriginalError){proxyAccessor(WrappedError,OriginalError,STACK_TRACE_LIMIT);proxyAccessor(WrappedError,OriginalError,'prepareStackTrace');}copyConstructorProperties(WrappedError,OriginalError);if(!IS_PURE)try{// Safari 13- bug: WebAssembly errors does not have a proper `.name`
if(OriginalErrorPrototype.name!==ERROR_NAME){createNonEnumerableProperty(OriginalErrorPrototype,'name',ERROR_NAME);}OriginalErrorPrototype.constructor=WrappedError;}catch(error){/* empty */}return WrappedError;};/***/}),/***/3873:(/***/function _(module,__unused_webpack_exports,__nested_webpack_require_118833__){"use strict";var toIndexedObject=__nested_webpack_require_118833__(380);var addToUnscopables=__nested_webpack_require_118833__(5458);var Iterators=__nested_webpack_require_118833__(9164);var InternalStateModule=__nested_webpack_require_118833__(3086);var defineProperty=__nested_webpack_require_118833__(4466).f;var defineIterator=__nested_webpack_require_118833__(3217);var createIterResultObject=__nested_webpack_require_118833__(6224);var IS_PURE=__nested_webpack_require_118833__(1942);var DESCRIPTORS=__nested_webpack_require_118833__(6893);var ARRAY_ITERATOR='Array Iterator';var setInternalState=InternalStateModule.set;var getInternalState=InternalStateModule.getterFor(ARRAY_ITERATOR);// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports=defineIterator(Array,'Array',function(iterated,kind){setInternalState(this,{type:ARRAY_ITERATOR,target:toIndexedObject(iterated),// target
index:0,// next index
kind:kind// kind
});// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
},function(){var state=getInternalState(this);var target=state.target;var index=state.index++;if(!target||index>=target.length){state.target=null;return createIterResultObject(undefined,true);}switch(state.kind){case'keys':return createIterResultObject(index,false);case'values':return createIterResultObject(target[index],false);}return createIterResultObject([index,target[index]],false);},'values');// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values=Iterators.Arguments=Iterators.Array;// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');addToUnscopables('values');addToUnscopables('entries');// V8 ~ Chrome 45- bug
if(!IS_PURE&&DESCRIPTORS&&values.name!=='values')try{defineProperty(values,'name',{value:'values'});}catch(error){/* empty */}/***/}),/***/595:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_121179__){"use strict";var hasOwn=__nested_webpack_require_121179__(4418);var defineBuiltIn=__nested_webpack_require_121179__(7509);var dateToPrimitive=__nested_webpack_require_121179__(8089);var wellKnownSymbol=__nested_webpack_require_121179__(4282);var TO_PRIMITIVE=wellKnownSymbol('toPrimitive');var DatePrototype=Date.prototype;// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if(!hasOwn(DatePrototype,TO_PRIMITIVE)){defineBuiltIn(DatePrototype,TO_PRIMITIVE,dateToPrimitive);}/***/}),/***/7107:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_121753__){"use strict";/* eslint-disable no-unused-vars -- required for functions `.length` */var $=__nested_webpack_require_121753__(5613);var globalThis=__nested_webpack_require_121753__(9117);var apply=__nested_webpack_require_121753__(646);var wrapErrorConstructorWithCause=__nested_webpack_require_121753__(6208);var WEB_ASSEMBLY='WebAssembly';var WebAssembly=globalThis[WEB_ASSEMBLY];// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED=new Error('e',{cause:7}).cause!==7;var exportGlobalErrorCauseWrapper=function exportGlobalErrorCauseWrapper(ERROR_NAME,wrapper){var O={};O[ERROR_NAME]=wrapErrorConstructorWithCause(ERROR_NAME,wrapper,FORCED);$({global:true,constructor:true,arity:1,forced:FORCED},O);};var exportWebAssemblyErrorCauseWrapper=function exportWebAssemblyErrorCauseWrapper(ERROR_NAME,wrapper){if(WebAssembly&&WebAssembly[ERROR_NAME]){var O={};O[ERROR_NAME]=wrapErrorConstructorWithCause(WEB_ASSEMBLY+'.'+ERROR_NAME,wrapper,FORCED);$({target:WEB_ASSEMBLY,stat:true,constructor:true,arity:1,forced:FORCED},O);}};// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error',function(init){return function Error(message){return apply(init,this,arguments);};});exportGlobalErrorCauseWrapper('EvalError',function(init){return function EvalError(message){return apply(init,this,arguments);};});exportGlobalErrorCauseWrapper('RangeError',function(init){return function RangeError(message){return apply(init,this,arguments);};});exportGlobalErrorCauseWrapper('ReferenceError',function(init){return function ReferenceError(message){return apply(init,this,arguments);};});exportGlobalErrorCauseWrapper('SyntaxError',function(init){return function SyntaxError(message){return apply(init,this,arguments);};});exportGlobalErrorCauseWrapper('TypeError',function(init){return function TypeError(message){return apply(init,this,arguments);};});exportGlobalErrorCauseWrapper('URIError',function(init){return function URIError(message){return apply(init,this,arguments);};});exportWebAssemblyErrorCauseWrapper('CompileError',function(init){return function CompileError(message){return apply(init,this,arguments);};});exportWebAssemblyErrorCauseWrapper('LinkError',function(init){return function LinkError(message){return apply(init,this,arguments);};});exportWebAssemblyErrorCauseWrapper('RuntimeError',function(init){return function RuntimeError(message){return apply(init,this,arguments);};});/***/}),/***/3277:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_124235__){"use strict";var DESCRIPTORS=__nested_webpack_require_124235__(6893);var FUNCTION_NAME_EXISTS=__nested_webpack_require_124235__(2735).EXISTS;var uncurryThis=__nested_webpack_require_124235__(6881);var defineBuiltInAccessor=__nested_webpack_require_124235__(997);var FunctionPrototype=Function.prototype;var functionToString=uncurryThis(FunctionPrototype.toString);var nameRE=/function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;var regExpExec=uncurryThis(nameRE.exec);var NAME='name';// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if(DESCRIPTORS&&!FUNCTION_NAME_EXISTS){defineBuiltInAccessor(FunctionPrototype,NAME,{configurable:true,get:function get(){try{return regExpExec(nameRE,functionToString(this))[1];}catch(error){return'';}}});}/***/}),/***/2438:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_125084__){"use strict";var $=__nested_webpack_require_125084__(5613);var globalThis=__nested_webpack_require_125084__(9117);var anInstance=__nested_webpack_require_125084__(286);var anObject=__nested_webpack_require_125084__(3770);var isCallable=__nested_webpack_require_125084__(4188);var getPrototypeOf=__nested_webpack_require_125084__(1786);var defineBuiltInAccessor=__nested_webpack_require_125084__(997);var createProperty=__nested_webpack_require_125084__(4417);var fails=__nested_webpack_require_125084__(5234);var hasOwn=__nested_webpack_require_125084__(4418);var wellKnownSymbol=__nested_webpack_require_125084__(4282);var IteratorPrototype=__nested_webpack_require_125084__(2037).IteratorPrototype;var DESCRIPTORS=__nested_webpack_require_125084__(6893);var IS_PURE=__nested_webpack_require_125084__(1942);var CONSTRUCTOR='constructor';var ITERATOR='Iterator';var TO_STRING_TAG=wellKnownSymbol('toStringTag');var $TypeError=TypeError;var NativeIterator=globalThis[ITERATOR];// FF56- have non-standard global helper `Iterator`
var FORCED=IS_PURE||!isCallable(NativeIterator)||NativeIterator.prototype!==IteratorPrototype// FF44- non-standard `Iterator` passes previous tests
||!fails(function(){NativeIterator({});});var IteratorConstructor=function Iterator(){anInstance(this,IteratorPrototype);if(getPrototypeOf(this)===IteratorPrototype)throw new $TypeError('Abstract class Iterator not directly constructable');};var defineIteratorPrototypeAccessor=function defineIteratorPrototypeAccessor(key,value){if(DESCRIPTORS){defineBuiltInAccessor(IteratorPrototype,key,{configurable:true,get:function get(){return value;},set:function set(replacement){anObject(this);if(this===IteratorPrototype)throw new $TypeError("You can't redefine this property");if(hasOwn(this,key))this[key]=replacement;else createProperty(this,key,replacement);}});}else IteratorPrototype[key]=value;};if(!hasOwn(IteratorPrototype,TO_STRING_TAG))defineIteratorPrototypeAccessor(TO_STRING_TAG,ITERATOR);if(FORCED||!hasOwn(IteratorPrototype,CONSTRUCTOR)||IteratorPrototype[CONSTRUCTOR]===Object){defineIteratorPrototypeAccessor(CONSTRUCTOR,IteratorConstructor);}IteratorConstructor.prototype=IteratorPrototype;// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$({global:true,constructor:true,forced:FORCED},{Iterator:IteratorConstructor});/***/}),/***/7327:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_127319__){"use strict";var $=__nested_webpack_require_127319__(5613);var iterate=__nested_webpack_require_127319__(8873);var aCallable=__nested_webpack_require_127319__(4977);var anObject=__nested_webpack_require_127319__(3770);var getIteratorDirect=__nested_webpack_require_127319__(6002);// `Iterator.prototype.forEach` method
// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
$({target:'Iterator',proto:true,real:true},{forEach:function forEach(fn){anObject(this);aCallable(fn);var record=getIteratorDirect(this);var counter=0;iterate(record,function(value){fn(value,counter++);},{IS_RECORD:true});}});/***/}),/***/4727:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_127958__){"use strict";var $=__nested_webpack_require_127958__(5613);var getBuiltIn=__nested_webpack_require_127958__(5604);var apply=__nested_webpack_require_127958__(646);var call=__nested_webpack_require_127958__(9944);var uncurryThis=__nested_webpack_require_127958__(6881);var fails=__nested_webpack_require_127958__(5234);var isCallable=__nested_webpack_require_127958__(4188);var isSymbol=__nested_webpack_require_127958__(6032);var arraySlice=__nested_webpack_require_127958__(7825);var getReplacerFunction=__nested_webpack_require_127958__(8254);var NATIVE_SYMBOL=__nested_webpack_require_127958__(8944);var $String=String;var $stringify=getBuiltIn('JSON','stringify');var exec=uncurryThis(/./.exec);var charAt=uncurryThis(''.charAt);var charCodeAt=uncurryThis(''.charCodeAt);var replace=uncurryThis(''.replace);var numberToString=uncurryThis(1.0.toString);var tester=/[\uD800-\uDFFF]/g;var low=/^[\uD800-\uDBFF]$/;var hi=/^[\uDC00-\uDFFF]$/;var WRONG_SYMBOLS_CONVERSION=!NATIVE_SYMBOL||fails(function(){var symbol=getBuiltIn('Symbol')('stringify detection');// MS Edge converts symbol values to JSON as {}
return $stringify([symbol])!=='[null]'// WebKit converts symbol values to JSON as null
||$stringify({a:symbol})!=='{}'// V8 throws on boxed symbols
||$stringify(Object(symbol))!=='{}';});// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE=fails(function(){return $stringify("\uDF06\uD834")!=="\"\\udf06\\ud834\""||$stringify("\uDEAD")!=="\"\\udead\"";});var stringifyWithSymbolsFix=function stringifyWithSymbolsFix(it,replacer){var args=arraySlice(arguments);var $replacer=getReplacerFunction(replacer);if(!isCallable($replacer)&&(it===undefined||isSymbol(it)))return;// IE8 returns string on undefined
args[1]=function(key,value){// some old implementations (like WebKit) could pass numbers as keys
if(isCallable($replacer))value=call($replacer,this,$String(key),value);if(!isSymbol(value))return value;};return apply($stringify,null,args);};var fixIllFormed=function fixIllFormed(match,offset,string){var prev=charAt(string,offset-1);var next=charAt(string,offset+1);if(exec(low,match)&&!exec(hi,next)||exec(hi,match)&&!exec(low,prev)){return"\\u"+numberToString(charCodeAt(match,0),16);}return match;};if($stringify){// `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$({target:'JSON',stat:true,arity:3,forced:WRONG_SYMBOLS_CONVERSION||ILL_FORMED_UNICODE},{// eslint-disable-next-line no-unused-vars -- required for `.length`
stringify:function stringify(it,replacer,space){var args=arraySlice(arguments);var result=apply(WRONG_SYMBOLS_CONVERSION?stringifyWithSymbolsFix:$stringify,null,args);return ILL_FORMED_UNICODE&&typeof result=='string'?replace(result,tester,fixIllFormed):result;}});}/***/}),/***/3185:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_130662__){"use strict";var $=__nested_webpack_require_130662__(5613);var IS_PURE=__nested_webpack_require_130662__(1942);var DESCRIPTORS=__nested_webpack_require_130662__(6893);var globalThis=__nested_webpack_require_130662__(9117);var path=__nested_webpack_require_130662__(9120);var uncurryThis=__nested_webpack_require_130662__(6881);var isForced=__nested_webpack_require_130662__(8489);var hasOwn=__nested_webpack_require_130662__(4418);var inheritIfRequired=__nested_webpack_require_130662__(4166);var isPrototypeOf=__nested_webpack_require_130662__(4578);var isSymbol=__nested_webpack_require_130662__(6032);var toPrimitive=__nested_webpack_require_130662__(290);var fails=__nested_webpack_require_130662__(5234);var getOwnPropertyNames=__nested_webpack_require_130662__(5629).f;var getOwnPropertyDescriptor=__nested_webpack_require_130662__(9304).f;var defineProperty=__nested_webpack_require_130662__(4466).f;var thisNumberValue=__nested_webpack_require_130662__(5881);var trim=__nested_webpack_require_130662__(2771).trim;var NUMBER='Number';var NativeNumber=globalThis[NUMBER];var PureNumberNamespace=path[NUMBER];var NumberPrototype=NativeNumber.prototype;var TypeError=globalThis.TypeError;var stringSlice=uncurryThis(''.slice);var charCodeAt=uncurryThis(''.charCodeAt);// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric=function toNumeric(value){var primValue=toPrimitive(value,'number');return typeof primValue=='bigint'?primValue:toNumber(primValue);};// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber=function toNumber(argument){var it=toPrimitive(argument,'number');var first,third,radix,maxCode,digits,length,index,code;if(isSymbol(it))throw new TypeError('Cannot convert a Symbol value to a number');if(typeof it=='string'&&it.length>2){it=trim(it);first=charCodeAt(it,0);if(first===43||first===45){third=charCodeAt(it,2);if(third===88||third===120)return NaN;// Number('+0x1') should be NaN, old V8 fix
}else if(first===48){switch(charCodeAt(it,1)){// fast equal of /^0b[01]+$/i
case 66:case 98:radix=2;maxCode=49;break;// fast equal of /^0o[0-7]+$/i
case 79:case 111:radix=8;maxCode=55;break;default:return+it;}digits=stringSlice(it,2);length=digits.length;for(index=0;index<length;index++){code=charCodeAt(digits,index);// parseInt parses a string to a first unavailable symbol
// but ToNumber should return NaN if a string contains unavailable symbols
if(code<48||code>maxCode)return NaN;}return parseInt(digits,radix);}}return+it;};var FORCED=isForced(NUMBER,!NativeNumber(' 0o1')||!NativeNumber('0b1')||NativeNumber('+0x1'));var calledWithNew=function calledWithNew(dummy){// includes check on 1..constructor(foo) case
return isPrototypeOf(NumberPrototype,dummy)&&fails(function(){thisNumberValue(dummy);});};// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper=function Number(value){var n=arguments.length<1?0:NativeNumber(toNumeric(value));return calledWithNew(this)?inheritIfRequired(Object(n),this,NumberWrapper):n;};NumberWrapper.prototype=NumberPrototype;if(FORCED&&!IS_PURE)NumberPrototype.constructor=NumberWrapper;$({global:true,constructor:true,wrap:true,forced:FORCED},{Number:NumberWrapper});// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties=function copyConstructorProperties(target,source){for(var keys=DESCRIPTORS?getOwnPropertyNames(source):(// ES3:
'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,'+// ES2015 (in case, if modules with ES2015 Number statics required before):
'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,'+// ESNext
'fromString,range').split(','),j=0,key;keys.length>j;j++){if(hasOwn(source,key=keys[j])&&!hasOwn(target,key)){defineProperty(target,key,getOwnPropertyDescriptor(source,key));}}};if(IS_PURE&&PureNumberNamespace)copyConstructorProperties(path[NUMBER],PureNumberNamespace);if(FORCED||IS_PURE)copyConstructorProperties(path[NUMBER],NativeNumber);/***/}),/***/7050:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_134556__){"use strict";var $=__nested_webpack_require_134556__(5613);var assign=__nested_webpack_require_134556__(9456);// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({target:'Object',stat:true,arity:2,forced:Object.assign!==assign},{assign:assign});/***/}),/***/3786:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_134972__){"use strict";var $=__nested_webpack_require_134972__(5613);var NATIVE_SYMBOL=__nested_webpack_require_134972__(8944);var fails=__nested_webpack_require_134972__(5234);var getOwnPropertySymbolsModule=__nested_webpack_require_134972__(156);var toObject=__nested_webpack_require_134972__(3628);// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED=!NATIVE_SYMBOL||fails(function(){getOwnPropertySymbolsModule.f(1);});// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({target:'Object',stat:true,forced:FORCED},{getOwnPropertySymbols:function getOwnPropertySymbols(it){var $getOwnPropertySymbols=getOwnPropertySymbolsModule.f;return $getOwnPropertySymbols?$getOwnPropertySymbols(toObject(it)):[];}});/***/}),/***/8291:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_135845__){"use strict";var $=__nested_webpack_require_135845__(5613);var toObject=__nested_webpack_require_135845__(3628);var nativeKeys=__nested_webpack_require_135845__(7137);var fails=__nested_webpack_require_135845__(5234);var FAILS_ON_PRIMITIVES=fails(function(){nativeKeys(1);});// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({target:'Object',stat:true,forced:FAILS_ON_PRIMITIVES},{keys:function keys(it){return nativeKeys(toObject(it));}});/***/}),/***/630:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_136353__){"use strict";var TO_STRING_TAG_SUPPORT=__nested_webpack_require_136353__(9345);var defineBuiltIn=__nested_webpack_require_136353__(7509);var toString=__nested_webpack_require_136353__(2244);// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if(!TO_STRING_TAG_SUPPORT){defineBuiltIn(Object.prototype,'toString',toString,{unsafe:true});}/***/}),/***/5528:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_136796__){"use strict";var $=__nested_webpack_require_136796__(5613);var call=__nested_webpack_require_136796__(9944);var aCallable=__nested_webpack_require_136796__(4977);var newPromiseCapabilityModule=__nested_webpack_require_136796__(9444);var perform=__nested_webpack_require_136796__(6042);var iterate=__nested_webpack_require_136796__(8873);var PROMISE_STATICS_INCORRECT_ITERATION=__nested_webpack_require_136796__(6292);// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({target:'Promise',stat:true,forced:PROMISE_STATICS_INCORRECT_ITERATION},{all:function all(iterable){var C=this;var capability=newPromiseCapabilityModule.f(C);var resolve=capability.resolve;var reject=capability.reject;var result=perform(function(){var $promiseResolve=aCallable(C.resolve);var values=[];var counter=0;var remaining=1;iterate(iterable,function(promise){var index=counter++;var alreadyCalled=false;remaining++;call($promiseResolve,C,promise).then(function(value){if(alreadyCalled)return;alreadyCalled=true;values[index]=value;--remaining||resolve(values);},reject);});--remaining||resolve(values);});if(result.error)reject(result.value);return capability.promise;}});/***/}),/***/4348:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_137971__){"use strict";var $=__nested_webpack_require_137971__(5613);var IS_PURE=__nested_webpack_require_137971__(1942);var FORCED_PROMISE_CONSTRUCTOR=__nested_webpack_require_137971__(7301).CONSTRUCTOR;var NativePromiseConstructor=__nested_webpack_require_137971__(6453);var getBuiltIn=__nested_webpack_require_137971__(5604);var isCallable=__nested_webpack_require_137971__(4188);var defineBuiltIn=__nested_webpack_require_137971__(7509);var NativePromisePrototype=NativePromiseConstructor&&NativePromiseConstructor.prototype;// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({target:'Promise',proto:true,forced:FORCED_PROMISE_CONSTRUCTOR,real:true},{'catch':function _catch(onRejected){return this.then(undefined,onRejected);}});// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if(!IS_PURE&&isCallable(NativePromiseConstructor)){var method=getBuiltIn('Promise').prototype['catch'];if(NativePromisePrototype['catch']!==method){defineBuiltIn(NativePromisePrototype,'catch',method,{unsafe:true});}}/***/}),/***/4267:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_139066__){"use strict";var $=__nested_webpack_require_139066__(5613);var IS_PURE=__nested_webpack_require_139066__(1942);var IS_NODE=__nested_webpack_require_139066__(3940);var globalThis=__nested_webpack_require_139066__(9117);var call=__nested_webpack_require_139066__(9944);var defineBuiltIn=__nested_webpack_require_139066__(7509);var setPrototypeOf=__nested_webpack_require_139066__(5054);var setToStringTag=__nested_webpack_require_139066__(3754);var setSpecies=__nested_webpack_require_139066__(3900);var aCallable=__nested_webpack_require_139066__(4977);var isCallable=__nested_webpack_require_139066__(4188);var isObject=__nested_webpack_require_139066__(831);var anInstance=__nested_webpack_require_139066__(286);var speciesConstructor=__nested_webpack_require_139066__(7964);var task=__nested_webpack_require_139066__(3474).set;var microtask=__nested_webpack_require_139066__(1982);var hostReportErrors=__nested_webpack_require_139066__(3306);var perform=__nested_webpack_require_139066__(6042);var Queue=__nested_webpack_require_139066__(8648);var InternalStateModule=__nested_webpack_require_139066__(3086);var NativePromiseConstructor=__nested_webpack_require_139066__(6453);var PromiseConstructorDetection=__nested_webpack_require_139066__(7301);var newPromiseCapabilityModule=__nested_webpack_require_139066__(9444);var PROMISE='Promise';var FORCED_PROMISE_CONSTRUCTOR=PromiseConstructorDetection.CONSTRUCTOR;var NATIVE_PROMISE_REJECTION_EVENT=PromiseConstructorDetection.REJECTION_EVENT;var NATIVE_PROMISE_SUBCLASSING=PromiseConstructorDetection.SUBCLASSING;var getInternalPromiseState=InternalStateModule.getterFor(PROMISE);var setInternalState=InternalStateModule.set;var NativePromisePrototype=NativePromiseConstructor&&NativePromiseConstructor.prototype;var PromiseConstructor=NativePromiseConstructor;var PromisePrototype=NativePromisePrototype;var TypeError=globalThis.TypeError;var document=globalThis.document;var process=globalThis.process;var newPromiseCapability=newPromiseCapabilityModule.f;var newGenericPromiseCapability=newPromiseCapability;var DISPATCH_EVENT=!!(document&&document.createEvent&&globalThis.dispatchEvent);var UNHANDLED_REJECTION='unhandledrejection';var REJECTION_HANDLED='rejectionhandled';var PENDING=0;var FULFILLED=1;var REJECTED=2;var HANDLED=1;var UNHANDLED=2;var Internal,OwnPromiseCapability,PromiseWrapper,nativeThen;// helpers
var isThenable=function isThenable(it){var then;return isObject(it)&&isCallable(then=it.then)?then:false;};var callReaction=function callReaction(reaction,state){var value=state.value;var ok=state.state===FULFILLED;var handler=ok?reaction.ok:reaction.fail;var resolve=reaction.resolve;var reject=reaction.reject;var domain=reaction.domain;var result,then,exited;try{if(handler){if(!ok){if(state.rejection===UNHANDLED)onHandleUnhandled(state);state.rejection=HANDLED;}if(handler===true)result=value;else{if(domain)domain.enter();result=handler(value);// can throw
if(domain){domain.exit();exited=true;}}if(result===reaction.promise){reject(new TypeError('Promise-chain cycle'));}else if(then=isThenable(result)){call(then,result,resolve,reject);}else resolve(result);}else reject(value);}catch(error){if(domain&&!exited)domain.exit();reject(error);}};var notify=function notify(state,isReject){if(state.notified)return;state.notified=true;microtask(function(){var reactions=state.reactions;var reaction;while(reaction=reactions.get()){callReaction(reaction,state);}state.notified=false;if(isReject&&!state.rejection)onUnhandled(state);});};var dispatchEvent=function dispatchEvent(name,promise,reason){var event,handler;if(DISPATCH_EVENT){event=document.createEvent('Event');event.promise=promise;event.reason=reason;event.initEvent(name,false,true);globalThis.dispatchEvent(event);}else event={promise:promise,reason:reason};if(!NATIVE_PROMISE_REJECTION_EVENT&&(handler=globalThis['on'+name]))handler(event);else if(name===UNHANDLED_REJECTION)hostReportErrors('Unhandled promise rejection',reason);};var onUnhandled=function onUnhandled(state){call(task,globalThis,function(){var promise=state.facade;var value=state.value;var IS_UNHANDLED=isUnhandled(state);var result;if(IS_UNHANDLED){result=perform(function(){if(IS_NODE){process.emit('unhandledRejection',value,promise);}else dispatchEvent(UNHANDLED_REJECTION,promise,value);});// Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
state.rejection=IS_NODE||isUnhandled(state)?UNHANDLED:HANDLED;if(result.error)throw result.value;}});};var isUnhandled=function isUnhandled(state){return state.rejection!==HANDLED&&!state.parent;};var onHandleUnhandled=function onHandleUnhandled(state){call(task,globalThis,function(){var promise=state.facade;if(IS_NODE){process.emit('rejectionHandled',promise);}else dispatchEvent(REJECTION_HANDLED,promise,state.value);});};var bind=function bind(fn,state,unwrap){return function(value){fn(state,value,unwrap);};};var internalReject=function internalReject(state,value,unwrap){if(state.done)return;state.done=true;if(unwrap)state=unwrap;state.value=value;state.state=REJECTED;notify(state,true);};var _internalResolve=function internalResolve(state,value,unwrap){if(state.done)return;state.done=true;if(unwrap)state=unwrap;try{if(state.facade===value)throw new TypeError("Promise can't be resolved itself");var then=isThenable(value);if(then){microtask(function(){var wrapper={done:false};try{call(then,value,bind(_internalResolve,wrapper,state),bind(internalReject,wrapper,state));}catch(error){internalReject(wrapper,error,state);}});}else{state.value=value;state.state=FULFILLED;notify(state,false);}}catch(error){internalReject({done:false},error,state);}};// constructor polyfill
if(FORCED_PROMISE_CONSTRUCTOR){// 25.4.3.1 Promise(executor)
PromiseConstructor=function Promise(executor){anInstance(this,PromisePrototype);aCallable(executor);call(Internal,this);var state=getInternalPromiseState(this);try{executor(bind(_internalResolve,state),bind(internalReject,state));}catch(error){internalReject(state,error);}};PromisePrototype=PromiseConstructor.prototype;// eslint-disable-next-line no-unused-vars -- required for `.length`
Internal=function Promise(executor){setInternalState(this,{type:PROMISE,done:false,notified:false,parent:false,reactions:new Queue(),rejection:false,state:PENDING,value:null});};// `Promise.prototype.then` method
// https://tc39.es/ecma262/#sec-promise.prototype.then
Internal.prototype=defineBuiltIn(PromisePrototype,'then',function then(onFulfilled,onRejected){var state=getInternalPromiseState(this);var reaction=newPromiseCapability(speciesConstructor(this,PromiseConstructor));state.parent=true;reaction.ok=isCallable(onFulfilled)?onFulfilled:true;reaction.fail=isCallable(onRejected)&&onRejected;reaction.domain=IS_NODE?process.domain:undefined;if(state.state===PENDING)state.reactions.add(reaction);else microtask(function(){callReaction(reaction,state);});return reaction.promise;});OwnPromiseCapability=function OwnPromiseCapability(){var promise=new Internal();var state=getInternalPromiseState(promise);this.promise=promise;this.resolve=bind(_internalResolve,state);this.reject=bind(internalReject,state);};newPromiseCapabilityModule.f=newPromiseCapability=function newPromiseCapability(C){return C===PromiseConstructor||C===PromiseWrapper?new OwnPromiseCapability(C):newGenericPromiseCapability(C);};if(!IS_PURE&&isCallable(NativePromiseConstructor)&&NativePromisePrototype!==Object.prototype){nativeThen=NativePromisePrototype.then;if(!NATIVE_PROMISE_SUBCLASSING){// make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
defineBuiltIn(NativePromisePrototype,'then',function then(onFulfilled,onRejected){var that=this;return new PromiseConstructor(function(resolve,reject){call(nativeThen,that,resolve,reject);}).then(onFulfilled,onRejected);// https://github.com/zloirock/core-js/issues/640
},{unsafe:true});}// make `.constructor === Promise` work for native promise-based APIs
try{delete NativePromisePrototype.constructor;}catch(error){/* empty */}// make `instanceof Promise` work for native promise-based APIs
if(setPrototypeOf){setPrototypeOf(NativePromisePrototype,PromisePrototype);}}}// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$({global:true,constructor:true,wrap:true,forced:FORCED_PROMISE_CONSTRUCTOR},{Promise:PromiseConstructor});setToStringTag(PromiseConstructor,PROMISE,false,true);setSpecies(PROMISE);/***/}),/***/865:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_147277__){"use strict";// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__nested_webpack_require_147277__(4267);__nested_webpack_require_147277__(5528);__nested_webpack_require_147277__(4348);__nested_webpack_require_147277__(7174);__nested_webpack_require_147277__(4168);__nested_webpack_require_147277__(8235);/***/}),/***/7174:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_147637__){"use strict";var $=__nested_webpack_require_147637__(5613);var call=__nested_webpack_require_147637__(9944);var aCallable=__nested_webpack_require_147637__(4977);var newPromiseCapabilityModule=__nested_webpack_require_147637__(9444);var perform=__nested_webpack_require_147637__(6042);var iterate=__nested_webpack_require_147637__(8873);var PROMISE_STATICS_INCORRECT_ITERATION=__nested_webpack_require_147637__(6292);// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({target:'Promise',stat:true,forced:PROMISE_STATICS_INCORRECT_ITERATION},{race:function race(iterable){var C=this;var capability=newPromiseCapabilityModule.f(C);var reject=capability.reject;var result=perform(function(){var $promiseResolve=aCallable(C.resolve);iterate(iterable,function(promise){call($promiseResolve,C,promise).then(capability.resolve,reject);});});if(result.error)reject(result.value);return capability.promise;}});/***/}),/***/4168:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_148565__){"use strict";var $=__nested_webpack_require_148565__(5613);var newPromiseCapabilityModule=__nested_webpack_require_148565__(9444);var FORCED_PROMISE_CONSTRUCTOR=__nested_webpack_require_148565__(7301).CONSTRUCTOR;// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({target:'Promise',stat:true,forced:FORCED_PROMISE_CONSTRUCTOR},{reject:function reject(r){var capability=newPromiseCapabilityModule.f(this);var capabilityReject=capability.reject;capabilityReject(r);return capability.promise;}});/***/}),/***/8235:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_149146__){"use strict";var $=__nested_webpack_require_149146__(5613);var getBuiltIn=__nested_webpack_require_149146__(5604);var IS_PURE=__nested_webpack_require_149146__(1942);var NativePromiseConstructor=__nested_webpack_require_149146__(6453);var FORCED_PROMISE_CONSTRUCTOR=__nested_webpack_require_149146__(7301).CONSTRUCTOR;var promiseResolve=__nested_webpack_require_149146__(8787);var PromiseConstructorWrapper=getBuiltIn('Promise');var CHECK_WRAPPER=IS_PURE&&!FORCED_PROMISE_CONSTRUCTOR;// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({target:'Promise',stat:true,forced:IS_PURE||FORCED_PROMISE_CONSTRUCTOR},{resolve:function resolve(x){return promiseResolve(CHECK_WRAPPER&&this===PromiseConstructorWrapper?NativePromiseConstructor:this,x);}});/***/}),/***/8376:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_149937__){"use strict";var $=__nested_webpack_require_149937__(5613);var exec=__nested_webpack_require_149937__(9342);// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({target:'RegExp',proto:true,forced:/./.exec!==exec},{exec:exec});/***/}),/***/1011:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_150277__){"use strict";var charAt=__nested_webpack_require_150277__(4212).charAt;var toString=__nested_webpack_require_150277__(2618);var InternalStateModule=__nested_webpack_require_150277__(3086);var defineIterator=__nested_webpack_require_150277__(3217);var createIterResultObject=__nested_webpack_require_150277__(6224);var STRING_ITERATOR='String Iterator';var setInternalState=InternalStateModule.set;var getInternalState=InternalStateModule.getterFor(STRING_ITERATOR);// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String,'String',function(iterated){setInternalState(this,{type:STRING_ITERATOR,string:toString(iterated),index:0});// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
},function next(){var state=getInternalState(this);var string=state.string;var index=state.index;var point;if(index>=string.length)return createIterResultObject(undefined,true);point=charAt(string,index);state.index+=point.length;return createIterResultObject(point,false);});/***/}),/***/9428:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_151390__){"use strict";var call=__nested_webpack_require_151390__(9944);var fixRegExpWellKnownSymbolLogic=__nested_webpack_require_151390__(467);var anObject=__nested_webpack_require_151390__(3770);var isNullOrUndefined=__nested_webpack_require_151390__(4318);var toLength=__nested_webpack_require_151390__(7611);var toString=__nested_webpack_require_151390__(2618);var requireObjectCoercible=__nested_webpack_require_151390__(9509);var getMethod=__nested_webpack_require_151390__(2913);var advanceStringIndex=__nested_webpack_require_151390__(154);var regExpExec=__nested_webpack_require_151390__(4721);// @@match logic
fixRegExpWellKnownSymbolLogic('match',function(MATCH,nativeMatch,maybeCallNative){return[// `String.prototype.match` method
// https://tc39.es/ecma262/#sec-string.prototype.match
function match(regexp){var O=requireObjectCoercible(this);var matcher=isNullOrUndefined(regexp)?undefined:getMethod(regexp,MATCH);return matcher?call(matcher,regexp,O):new RegExp(regexp)[MATCH](toString(O));},// `RegExp.prototype[@@match]` method
// https://tc39.es/ecma262/#sec-regexp.prototype-@@match
function(string){var rx=anObject(this);var S=toString(string);var res=maybeCallNative(nativeMatch,rx,S);if(res.done)return res.value;if(!rx.global)return regExpExec(rx,S);var fullUnicode=rx.unicode;rx.lastIndex=0;var A=[];var n=0;var result;while((result=regExpExec(rx,S))!==null){var matchStr=toString(result[0]);A[n]=matchStr;if(matchStr==='')rx.lastIndex=advanceStringIndex(S,toLength(rx.lastIndex),fullUnicode);n++;}return n===0?null:A;}];});/***/}),/***/7152:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_152895__){"use strict";var $=__nested_webpack_require_152895__(5613);var globalThis=__nested_webpack_require_152895__(9117);var call=__nested_webpack_require_152895__(9944);var uncurryThis=__nested_webpack_require_152895__(6881);var IS_PURE=__nested_webpack_require_152895__(1942);var DESCRIPTORS=__nested_webpack_require_152895__(6893);var NATIVE_SYMBOL=__nested_webpack_require_152895__(8944);var fails=__nested_webpack_require_152895__(5234);var hasOwn=__nested_webpack_require_152895__(4418);var isPrototypeOf=__nested_webpack_require_152895__(4578);var anObject=__nested_webpack_require_152895__(3770);var toIndexedObject=__nested_webpack_require_152895__(380);var toPropertyKey=__nested_webpack_require_152895__(2344);var $toString=__nested_webpack_require_152895__(2618);var createPropertyDescriptor=__nested_webpack_require_152895__(9123);var nativeObjectCreate=__nested_webpack_require_152895__(7065);var objectKeys=__nested_webpack_require_152895__(7137);var getOwnPropertyNamesModule=__nested_webpack_require_152895__(5629);var getOwnPropertyNamesExternal=__nested_webpack_require_152895__(3701);var getOwnPropertySymbolsModule=__nested_webpack_require_152895__(156);var getOwnPropertyDescriptorModule=__nested_webpack_require_152895__(9304);var definePropertyModule=__nested_webpack_require_152895__(4466);var definePropertiesModule=__nested_webpack_require_152895__(30);var propertyIsEnumerableModule=__nested_webpack_require_152895__(4416);var defineBuiltIn=__nested_webpack_require_152895__(7509);var defineBuiltInAccessor=__nested_webpack_require_152895__(997);var shared=__nested_webpack_require_152895__(746);var sharedKey=__nested_webpack_require_152895__(168);var hiddenKeys=__nested_webpack_require_152895__(7588);var uid=__nested_webpack_require_152895__(6209);var wellKnownSymbol=__nested_webpack_require_152895__(4282);var wrappedWellKnownSymbolModule=__nested_webpack_require_152895__(346);var defineWellKnownSymbol=__nested_webpack_require_152895__(2860);var defineSymbolToPrimitive=__nested_webpack_require_152895__(7093);var setToStringTag=__nested_webpack_require_152895__(3754);var InternalStateModule=__nested_webpack_require_152895__(3086);var $forEach=__nested_webpack_require_152895__(4104).forEach;var HIDDEN=sharedKey('hidden');var SYMBOL='Symbol';var PROTOTYPE='prototype';var setInternalState=InternalStateModule.set;var getInternalState=InternalStateModule.getterFor(SYMBOL);var ObjectPrototype=Object[PROTOTYPE];var $Symbol=globalThis.Symbol;var SymbolPrototype=$Symbol&&$Symbol[PROTOTYPE];var RangeError=globalThis.RangeError;var TypeError=globalThis.TypeError;var QObject=globalThis.QObject;var nativeGetOwnPropertyDescriptor=getOwnPropertyDescriptorModule.f;var nativeDefineProperty=definePropertyModule.f;var nativeGetOwnPropertyNames=getOwnPropertyNamesExternal.f;var nativePropertyIsEnumerable=propertyIsEnumerableModule.f;var push=uncurryThis([].push);var AllSymbols=shared('symbols');var ObjectPrototypeSymbols=shared('op-symbols');var WellKnownSymbolsStore=shared('wks');// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER=!QObject||!QObject[PROTOTYPE]||!QObject[PROTOTYPE].findChild;// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty=function fallbackDefineProperty(O,P,Attributes){var ObjectPrototypeDescriptor=nativeGetOwnPropertyDescriptor(ObjectPrototype,P);if(ObjectPrototypeDescriptor)delete ObjectPrototype[P];nativeDefineProperty(O,P,Attributes);if(ObjectPrototypeDescriptor&&O!==ObjectPrototype){nativeDefineProperty(ObjectPrototype,P,ObjectPrototypeDescriptor);}};var setSymbolDescriptor=DESCRIPTORS&&fails(function(){return nativeObjectCreate(nativeDefineProperty({},'a',{get:function get(){return nativeDefineProperty(this,'a',{value:7}).a;}})).a!==7;})?fallbackDefineProperty:nativeDefineProperty;var wrap=function wrap(tag,description){var symbol=AllSymbols[tag]=nativeObjectCreate(SymbolPrototype);setInternalState(symbol,{type:SYMBOL,tag:tag,description:description});if(!DESCRIPTORS)symbol.description=description;return symbol;};var $defineProperty=function defineProperty(O,P,Attributes){if(O===ObjectPrototype)$defineProperty(ObjectPrototypeSymbols,P,Attributes);anObject(O);var key=toPropertyKey(P);anObject(Attributes);if(hasOwn(AllSymbols,key)){if(!Attributes.enumerable){if(!hasOwn(O,HIDDEN))nativeDefineProperty(O,HIDDEN,createPropertyDescriptor(1,nativeObjectCreate(null)));O[HIDDEN][key]=true;}else{if(hasOwn(O,HIDDEN)&&O[HIDDEN][key])O[HIDDEN][key]=false;Attributes=nativeObjectCreate(Attributes,{enumerable:createPropertyDescriptor(0,false)});}return setSymbolDescriptor(O,key,Attributes);}return nativeDefineProperty(O,key,Attributes);};var $defineProperties=function defineProperties(O,Properties){anObject(O);var properties=toIndexedObject(Properties);var keys=objectKeys(properties).concat($getOwnPropertySymbols(properties));$forEach(keys,function(key){if(!DESCRIPTORS||call($propertyIsEnumerable,properties,key))$defineProperty(O,key,properties[key]);});return O;};var $create=function create(O,Properties){return Properties===undefined?nativeObjectCreate(O):$defineProperties(nativeObjectCreate(O),Properties);};var $propertyIsEnumerable=function propertyIsEnumerable(V){var P=toPropertyKey(V);var enumerable=call(nativePropertyIsEnumerable,this,P);if(this===ObjectPrototype&&hasOwn(AllSymbols,P)&&!hasOwn(ObjectPrototypeSymbols,P))return false;return enumerable||!hasOwn(this,P)||!hasOwn(AllSymbols,P)||hasOwn(this,HIDDEN)&&this[HIDDEN][P]?enumerable:true;};var $getOwnPropertyDescriptor=function getOwnPropertyDescriptor(O,P){var it=toIndexedObject(O);var key=toPropertyKey(P);if(it===ObjectPrototype&&hasOwn(AllSymbols,key)&&!hasOwn(ObjectPrototypeSymbols,key))return;var descriptor=nativeGetOwnPropertyDescriptor(it,key);if(descriptor&&hasOwn(AllSymbols,key)&&!(hasOwn(it,HIDDEN)&&it[HIDDEN][key])){descriptor.enumerable=true;}return descriptor;};var $getOwnPropertyNames=function getOwnPropertyNames(O){var names=nativeGetOwnPropertyNames(toIndexedObject(O));var result=[];$forEach(names,function(key){if(!hasOwn(AllSymbols,key)&&!hasOwn(hiddenKeys,key))push(result,key);});return result;};var $getOwnPropertySymbols=function $getOwnPropertySymbols(O){var IS_OBJECT_PROTOTYPE=O===ObjectPrototype;var names=nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE?ObjectPrototypeSymbols:toIndexedObject(O));var result=[];$forEach(names,function(key){if(hasOwn(AllSymbols,key)&&(!IS_OBJECT_PROTOTYPE||hasOwn(ObjectPrototype,key))){push(result,AllSymbols[key]);}});return result;};// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if(!NATIVE_SYMBOL){$Symbol=function _Symbol4(){if(isPrototypeOf(SymbolPrototype,this))throw new TypeError('Symbol is not a constructor');var description=!arguments.length||arguments[0]===undefined?undefined:$toString(arguments[0]);var tag=uid(description);var _setter=function setter(value){var $this=this===undefined?globalThis:this;if($this===ObjectPrototype)call(_setter,ObjectPrototypeSymbols,value);if(hasOwn($this,HIDDEN)&&hasOwn($this[HIDDEN],tag))$this[HIDDEN][tag]=false;var descriptor=createPropertyDescriptor(1,value);try{setSymbolDescriptor($this,tag,descriptor);}catch(error){if(!(error instanceof RangeError))throw error;fallbackDefineProperty($this,tag,descriptor);}};if(DESCRIPTORS&&USE_SETTER)setSymbolDescriptor(ObjectPrototype,tag,{configurable:true,set:_setter});return wrap(tag,description);};SymbolPrototype=$Symbol[PROTOTYPE];defineBuiltIn(SymbolPrototype,'toString',function toString(){return getInternalState(this).tag;});defineBuiltIn($Symbol,'withoutSetter',function(description){return wrap(uid(description),description);});propertyIsEnumerableModule.f=$propertyIsEnumerable;definePropertyModule.f=$defineProperty;definePropertiesModule.f=$defineProperties;getOwnPropertyDescriptorModule.f=$getOwnPropertyDescriptor;getOwnPropertyNamesModule.f=getOwnPropertyNamesExternal.f=$getOwnPropertyNames;getOwnPropertySymbolsModule.f=$getOwnPropertySymbols;wrappedWellKnownSymbolModule.f=function(name){return wrap(wellKnownSymbol(name),name);};if(DESCRIPTORS){// https://github.com/tc39/proposal-Symbol-description
defineBuiltInAccessor(SymbolPrototype,'description',{configurable:true,get:function description(){return getInternalState(this).description;}});if(!IS_PURE){defineBuiltIn(ObjectPrototype,'propertyIsEnumerable',$propertyIsEnumerable,{unsafe:true});}}}$({global:true,constructor:true,wrap:true,forced:!NATIVE_SYMBOL,sham:!NATIVE_SYMBOL},{Symbol:$Symbol});$forEach(objectKeys(WellKnownSymbolsStore),function(name){defineWellKnownSymbol(name);});$({target:SYMBOL,stat:true,forced:!NATIVE_SYMBOL},{useSetter:function useSetter(){USE_SETTER=true;},useSimple:function useSimple(){USE_SETTER=false;}});$({target:'Object',stat:true,forced:!NATIVE_SYMBOL,sham:!DESCRIPTORS},{// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
create:$create,// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
defineProperty:$defineProperty,// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
defineProperties:$defineProperties,// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
getOwnPropertyDescriptor:$getOwnPropertyDescriptor});$({target:'Object',stat:true,forced:!NATIVE_SYMBOL},{// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
getOwnPropertyNames:$getOwnPropertyNames});// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol,SYMBOL);hiddenKeys[HIDDEN]=true;/***/}),/***/3510:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_162291__){"use strict";// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
var $=__nested_webpack_require_162291__(5613);var DESCRIPTORS=__nested_webpack_require_162291__(6893);var globalThis=__nested_webpack_require_162291__(9117);var uncurryThis=__nested_webpack_require_162291__(6881);var hasOwn=__nested_webpack_require_162291__(4418);var isCallable=__nested_webpack_require_162291__(4188);var isPrototypeOf=__nested_webpack_require_162291__(4578);var toString=__nested_webpack_require_162291__(2618);var defineBuiltInAccessor=__nested_webpack_require_162291__(997);var copyConstructorProperties=__nested_webpack_require_162291__(8657);var NativeSymbol=globalThis.Symbol;var SymbolPrototype=NativeSymbol&&NativeSymbol.prototype;if(DESCRIPTORS&&isCallable(NativeSymbol)&&(!('description'in SymbolPrototype)||// Safari 12 bug
NativeSymbol().description!==undefined)){var EmptyStringDescriptionStore={};// wrap Symbol constructor for correct work with undefined description
var SymbolWrapper=function _Symbol5(){var description=arguments.length<1||arguments[0]===undefined?undefined:toString(arguments[0]);var result=isPrototypeOf(SymbolPrototype,this)// eslint-disable-next-line sonarjs/inconsistent-function-call -- ok
?new NativeSymbol(description)// in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
:description===undefined?NativeSymbol():NativeSymbol(description);if(description==='')EmptyStringDescriptionStore[result]=true;return result;};copyConstructorProperties(SymbolWrapper,NativeSymbol);SymbolWrapper.prototype=SymbolPrototype;SymbolPrototype.constructor=SymbolWrapper;var NATIVE_SYMBOL=String(NativeSymbol('description detection'))==='Symbol(description detection)';var thisSymbolValue=uncurryThis(SymbolPrototype.valueOf);var symbolDescriptiveString=uncurryThis(SymbolPrototype.toString);var regexp=/^Symbol\((.*)\)[^)]+$/;var replace=uncurryThis(''.replace);var stringSlice=uncurryThis(''.slice);defineBuiltInAccessor(SymbolPrototype,'description',{configurable:true,get:function description(){var symbol=thisSymbolValue(this);if(hasOwn(EmptyStringDescriptionStore,symbol))return'';var string=symbolDescriptiveString(symbol);var desc=NATIVE_SYMBOL?stringSlice(string,7,-1):replace(string,regexp,'$1');return desc===''?undefined:desc;}});$({global:true,constructor:true,forced:true},{Symbol:SymbolWrapper});}/***/}),/***/691:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_164632__){"use strict";var $=__nested_webpack_require_164632__(5613);var getBuiltIn=__nested_webpack_require_164632__(5604);var hasOwn=__nested_webpack_require_164632__(4418);var toString=__nested_webpack_require_164632__(2618);var shared=__nested_webpack_require_164632__(746);var NATIVE_SYMBOL_REGISTRY=__nested_webpack_require_164632__(6577);var StringToSymbolRegistry=shared('string-to-symbol-registry');var SymbolToStringRegistry=shared('symbol-to-string-registry');// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({target:'Symbol',stat:true,forced:!NATIVE_SYMBOL_REGISTRY},{'for':function _for(key){var string=toString(key);if(hasOwn(StringToSymbolRegistry,string))return StringToSymbolRegistry[string];var symbol=getBuiltIn('Symbol')(string);StringToSymbolRegistry[string]=symbol;SymbolToStringRegistry[symbol]=string;return symbol;}});/***/}),/***/2432:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_165505__){"use strict";var defineWellKnownSymbol=__nested_webpack_require_165505__(2860);// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');/***/}),/***/8070:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_165796__){"use strict";// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__nested_webpack_require_165796__(7152);__nested_webpack_require_165796__(691);__nested_webpack_require_165796__(6965);__nested_webpack_require_165796__(4727);__nested_webpack_require_165796__(3786);/***/}),/***/6965:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_166129__){"use strict";var $=__nested_webpack_require_166129__(5613);var hasOwn=__nested_webpack_require_166129__(4418);var isSymbol=__nested_webpack_require_166129__(6032);var tryToString=__nested_webpack_require_166129__(3174);var shared=__nested_webpack_require_166129__(746);var NATIVE_SYMBOL_REGISTRY=__nested_webpack_require_166129__(6577);var SymbolToStringRegistry=shared('symbol-to-string-registry');// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({target:'Symbol',stat:true,forced:!NATIVE_SYMBOL_REGISTRY},{keyFor:function keyFor(sym){if(!isSymbol(sym))throw new TypeError(tryToString(sym)+' is not a symbol');if(hasOwn(SymbolToStringRegistry,sym))return SymbolToStringRegistry[sym];}});/***/}),/***/5307:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_166863__){"use strict";var defineWellKnownSymbol=__nested_webpack_require_166863__(2860);var defineSymbolToPrimitive=__nested_webpack_require_166863__(7093);// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();/***/}),/***/1045:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_167350__){"use strict";// TODO: Remove from `core-js@4`
__nested_webpack_require_167350__(2438);/***/}),/***/5350:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_167527__){"use strict";// TODO: Remove from `core-js@4`
__nested_webpack_require_167527__(7327);/***/}),/***/8867:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_167704__){"use strict";var globalThis=__nested_webpack_require_167704__(9117);var DOMIterables=__nested_webpack_require_167704__(9429);var DOMTokenListPrototype=__nested_webpack_require_167704__(7463);var forEach=__nested_webpack_require_167704__(7500);var createNonEnumerableProperty=__nested_webpack_require_167704__(8088);var handlePrototype=function handlePrototype(CollectionPrototype){// some Chrome versions have non-configurable methods on DOMTokenList
if(CollectionPrototype&&CollectionPrototype.forEach!==forEach)try{createNonEnumerableProperty(CollectionPrototype,'forEach',forEach);}catch(error){CollectionPrototype.forEach=forEach;}};for(var COLLECTION_NAME in DOMIterables){if(DOMIterables[COLLECTION_NAME]){handlePrototype(globalThis[COLLECTION_NAME]&&globalThis[COLLECTION_NAME].prototype);}}handlePrototype(DOMTokenListPrototype);/***/}),/***/7010:(/***/function _(__unused_webpack_module,__unused_webpack_exports,__nested_webpack_require_168576__){"use strict";var globalThis=__nested_webpack_require_168576__(9117);var DOMIterables=__nested_webpack_require_168576__(9429);var DOMTokenListPrototype=__nested_webpack_require_168576__(7463);var ArrayIteratorMethods=__nested_webpack_require_168576__(3873);var createNonEnumerableProperty=__nested_webpack_require_168576__(8088);var setToStringTag=__nested_webpack_require_168576__(3754);var wellKnownSymbol=__nested_webpack_require_168576__(4282);var ITERATOR=wellKnownSymbol('iterator');var ArrayValues=ArrayIteratorMethods.values;var handlePrototype=function handlePrototype(CollectionPrototype,COLLECTION_NAME){if(CollectionPrototype){// some Chrome versions have non-configurable methods on DOMTokenList
if(CollectionPrototype[ITERATOR]!==ArrayValues)try{createNonEnumerableProperty(CollectionPrototype,ITERATOR,ArrayValues);}catch(error){CollectionPrototype[ITERATOR]=ArrayValues;}setToStringTag(CollectionPrototype,COLLECTION_NAME,true);if(DOMIterables[COLLECTION_NAME])for(var METHOD_NAME in ArrayIteratorMethods){// some Chrome versions have non-configurable methods on DOMTokenList
if(CollectionPrototype[METHOD_NAME]!==ArrayIteratorMethods[METHOD_NAME])try{createNonEnumerableProperty(CollectionPrototype,METHOD_NAME,ArrayIteratorMethods[METHOD_NAME]);}catch(error){CollectionPrototype[METHOD_NAME]=ArrayIteratorMethods[METHOD_NAME];}}}};for(var COLLECTION_NAME in DOMIterables){handlePrototype(globalThis[COLLECTION_NAME]&&globalThis[COLLECTION_NAME].prototype,COLLECTION_NAME);}handlePrototype(DOMTokenListPrototype,'DOMTokenList');/***/}),/***/6029:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"","AccountBox_tooltip_real":"","chargeAccount":"","chargeAccountDM":"","chargeAccountPS":"","chargeAccountPSDM":"","friendsOnline":"","gratisBonus":"","inbox":"","logout":"","myChallenges":"","myFriends":"","myProfile":"","nlPromoAlertButtonText":"","nlPromoAlertHeadline":"","nlPromoAlertText":"","noFriendOnline":"","paymentAlertHeadline":"","paymentAlertLinkName":"","paymentAlert_1":"","paymentAlert_2":"","paymentAlert_3":"","rommeMastersPromoAlert":"","rommeMastersPromoAlert1":"","rommeMastersPromoAlertButtonText":"","rommeMastersPromoAlertHeadline":"","rommePromoButtonText":"","rommePromoHeadlineText":"","rommePromoText":"","skatPromoButtonText":"","skatPromoHeadlineText":"","skatPromoText":""}}}');/***/}),/***/8917:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"Gratis-bonus:","AccountBox_tooltip_real":"Beløb til udbetaling:","chargeAccount":"Indbetal til Konto","chargeAccountDM":"Acheter des Diamants","chargeAccountPS":"Indbetal til Konto","chargeAccountPSDM":"Acheter des Diamants","friendsOnline":"{friendsOnlineCount} ven/ner online","gratisBonus":"Indløs din gratis bonus","inbox":"Indbakke","logout":"Log ud","myChallenges":"Mine Udfordringer","myFriends":"Mine venner","myProfile":"Min Spillerprofil","nlPromoAlertButtonText":"Tilmeld dig nu","nlPromoAlertHeadline":"Dit nyhedsbrev","nlPromoAlertText":"Hold dig opdateret nemt og bekvemt via e-mail. Læs mere om vores <strong>nye spil</strong> og deltag i <strong>sjove konkurrencer</strong>.","noFriendOnline":"Ingen venner online","paymentAlertHeadline":"Information","paymentAlertLinkName":"\\" name","paymentAlert_1":"Du har mindre end {0} din spillekonto. Oplad","paymentAlert_2":"din konto","paymentAlert_3":"nu for at spille videre!","rommeMastersPromoAlert":"Diese Woche startet das ","rommeMastersPromoAlert1":". Rommé Masters Qualifikationsturnier. Wieder werden 2 Finaltickets für die Bestplatzierten vergeben.","rommeMastersPromoAlertButtonText":"Jetzt Anmelden","rommeMastersPromoAlertHeadline":"Rommé Masters","rommePromoButtonText":"Alle Infos hier","rommePromoHeadlineText":"Rommé Masters","rommePromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Rommé Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!","skatPromoButtonText":"Alle Infos hier","skatPromoHeadlineText":"Skat Masters","skatPromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Skat Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!"}}}');/***/}),/***/6657:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"Gratis-Bonus:","AccountBox_tooltip_real":"Auszahlbarer Betrag:","chargeAccount":"Konto aufladen","chargeAccountDM":"Acheter des Diamants","chargeAccountPS":"Konto aufladen","chargeAccountPSDM":"Acheter des Diamants","friendsOnline":"{friendsOnlineCount} Freund/e online","gratisBonus":"Gratis-Bonus einlösen","inbox":"Posteingang","logout":"Logout","myChallenges":"Meine Herausforderungen","myFriends":"Meine Freunde","myProfile":"Mein Spieler-Profil","nlPromoAlertButtonText":"Jetzt anmelden","nlPromoAlertHeadline":"Ihr Newsletter","nlPromoAlertText":"Informieren Sie sich ganz leicht und bequem per E-Mail über alle <strong>neuen Spiele</strong> und nehmen Sie an <strong>tollen Gewinnspielen</strong> teil.","noFriendOnline":"Kein Freund online","paymentAlertHeadline":"Information","paymentAlertLinkName":"\\" name","paymentAlert_1":"Ihr Kontostand beträgt weniger als {0}. Laden Sie jetzt schnell","paymentAlert_2":"Ihr Konto","paymentAlert_3":"auf und spielen Sie weiter!","rommeMastersPromoAlert":"Diese Woche startet das ","rommeMastersPromoAlert1":". Rommé Masters Qualifikationsturnier. Wieder werden 2 Finaltickets für die Bestplatzierten vergeben.","rommeMastersPromoAlertButtonText":"Jetzt Anmelden","rommeMastersPromoAlertHeadline":"Rommé Masters","rommePromoButtonText":"Alle Infos hier","rommePromoHeadlineText":"Rommé Masters","rommePromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Rommé Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!","skatPromoButtonText":"Alle Infos hier","skatPromoHeadlineText":"Skat Masters","skatPromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Skat Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!"}}}');/***/}),/***/9789:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"Free bonus:","AccountBox_tooltip_real":"Withdrawable amount:","chargeAccount":"Deposit funds","chargeAccountDM":"Acheter des Diamants","chargeAccountPS":"Deposit funds","chargeAccountPSDM":"Acheter des Diamants","friendsOnline":"{friendsOnlineCount} friend(s) online","gratisBonus":"Upgrade your account","inbox":"Inbox","logout":"Logout","myChallenges":"My Challenges","myFriends":"My buddies","myProfile":"My Player Profile","nlPromoAlertButtonText":"Sign up now","nlPromoAlertHeadline":"Your newsletter","nlPromoAlertText":"Get the latest news on all <strong>new games</strong> quickly and easily via email and participate in our <strong>fun competitions</strong>.","noFriendOnline":"No friends online","paymentAlertHeadline":"Information","paymentAlertLinkName":"\\" name","paymentAlert_1":"Your account balance is less than {0}. Charge","paymentAlert_2":"your account","paymentAlert_3":"now to continue to play great games for money.","rommeMastersPromoAlert":"Diese Woche startet das ","rommeMastersPromoAlert1":". Rommé Masters Qualifikationsturnier. Wieder werden 2 Finaltickets für die Bestplatzierten vergeben.","rommeMastersPromoAlertButtonText":"Jetzt Anmelden","rommeMastersPromoAlertHeadline":"Rommé Masters","rommePromoButtonText":"Alle Infos hier","rommePromoHeadlineText":"Rommé Masters","rommePromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Rommé Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!","skatPromoButtonText":"Alle Infos hier","skatPromoHeadlineText":"Skat Masters","skatPromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Skat Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!"}}}');/***/}),/***/1445:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"Free bonus:","AccountBox_tooltip_real":"Withdrawable amount:","chargeAccount":"Deposit funds","chargeAccountDM":"Acheter des Diamants","chargeAccountPS":"Deposit funds","chargeAccountPSDM":"Acheter des Diamants","friendsOnline":"{friendsOnlineCount} friend(s) online","gratisBonus":"Upgrade your account","inbox":"Inbox","logout":"Logout","myChallenges":"My Challenges","myFriends":"My buddies","myProfile":"My Player Profile","nlPromoAlertButtonText":"Sign up now","nlPromoAlertHeadline":"Your newsletter","nlPromoAlertText":"Get the latest news on all <strong>new games</strong> quickly and easily via email and participate in our <strong>fun competitions</strong>.","noFriendOnline":"No friends online","paymentAlertHeadline":"Information","paymentAlertLinkName":"\\" name","paymentAlert_1":"Your account balance is less than {0}. Charge","paymentAlert_2":"your account","paymentAlert_3":"now to continue to play great games for money.","rommeMastersPromoAlert":"Diese Woche startet das ","rommeMastersPromoAlert1":". Rommé Masters Qualifikationsturnier. Wieder werden 2 Finaltickets für die Bestplatzierten vergeben.","rommeMastersPromoAlertButtonText":"Jetzt Anmelden","rommeMastersPromoAlertHeadline":"Rommé Masters","rommePromoButtonText":"Alle Infos hier","rommePromoHeadlineText":"Rommé Masters","rommePromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Rommé Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!","skatPromoButtonText":"Alle Infos hier","skatPromoHeadlineText":"Skat Masters","skatPromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Skat Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!"}}}');/***/}),/***/5246:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"Bonus gratis:","AccountBox_tooltip_real":"Cantidad reintegrable:","chargeAccount":"Recargar la cuenta","chargeAccountDM":"Acheter des Diamants","chargeAccountPS":"Recargar la cuenta","chargeAccountPSDM":"Acheter des Diamants","friendsOnline":"{friendsOnlineCount} friend(s) online","gratisBonus":"Canjear bono gratis","inbox":"Entrada de mensajes","logout":"Cerrar sesión","myChallenges":"Mis Retos","myFriends":"Mis amigos","myProfile":"Mi perfil de jugador","nlPromoAlertButtonText":"Sign up now","nlPromoAlertHeadline":"Your newsletter","nlPromoAlertText":"Get the latest news on all <strong>new games</strong> quickly and easily via email and participate in our <strong>fun competitions</strong>.","noFriendOnline":"Ningún amigo conectado","paymentAlertHeadline":"Information","paymentAlertLinkName":"\\" name","paymentAlert_1":"Ihr Kontostand beträgt weniger als {0}. Laden Sie jetzt schnell","paymentAlert_2":"Ihr Konto","paymentAlert_3":"auf und spielen Sie weiter!","rommeMastersPromoAlert":"Diese Woche startet das ","rommeMastersPromoAlert1":". Rommé Masters Qualifikationsturnier. Wieder werden 2 Finaltickets für die Bestplatzierten vergeben.","rommeMastersPromoAlertButtonText":"Jetzt Anmelden","rommeMastersPromoAlertHeadline":"Rommé Masters","rommePromoButtonText":"Alle Infos hier","rommePromoHeadlineText":"Rommé Masters","rommePromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Rommé Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!","skatPromoButtonText":"Alle Infos hier","skatPromoHeadlineText":"Skat Masters","skatPromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Skat Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!"}}}');/***/}),/***/8214:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"Bonus Gratuits :","AccountBox_tooltip_real":"Montant du Retrait :","chargeAccount":"Alimenter votre compte","chargeAccountDM":"Acheter des Diamants","chargeAccountPS":"Alimenter votre compte","chargeAccountPSDM":"Acheter des Diamants","friendsOnline":"{friendsOnlineCount} ami(e/s) en ligne","gratisBonus":"Recevoir le bonus","inbox":"Boîte de réception","logout":"Déconnexion","myChallenges":"Mes Défis","myFriends":"Mes amis","myProfile":"Mon profil","nlPromoAlertButtonText":"Souscrire maintenant","nlPromoAlertHeadline":" Newsletter GameDuell","nlPromoAlertText":"Informez-vous tranquillement par e-mail sur tous les <strong>nouveaux jeux</strong> et participez à des <strong>super jeux concours</strong>.","noFriendOnline":"Aucun ami en ligne","paymentAlertHeadline":"Info","paymentAlertLinkName":"\\" name","paymentAlert_1":"Votre solde est inférieur à {0}. Alimentez vite","paymentAlert_2":"votre compte","paymentAlert_3":"pour plus de fun sur GameDuell !","rommeMastersPromoAlert":"Diese Woche startet das ","rommeMastersPromoAlert1":". Rommé Masters Qualifikationsturnier. Wieder werden 2 Finaltickets für die Bestplatzierten vergeben.","rommeMastersPromoAlertButtonText":"Jetzt Anmelden","rommeMastersPromoAlertHeadline":"Rommé Masters","rommePromoButtonText":"Alle Infos hier","rommePromoHeadlineText":"Rommé Masters","rommePromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Rommé Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!","skatPromoButtonText":"Alle Infos hier","skatPromoHeadlineText":"Skat Masters","skatPromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Skat Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!"}}}');/***/}),/***/4312:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"Gratis bonus:","AccountBox_tooltip_real":"Betaalbaar bedrag:","chargeAccount":"Rekening opladen","chargeAccountDM":"Acheter des Diamants","chargeAccountPS":"Rekening opladen","chargeAccountPSDM":"Acheter des Diamants","friendsOnline":"{friendsOnlineCount} Vrienden online","gratisBonus":"Gratis bonus verzilveren","inbox":"Postvak","logout":"Logout","myChallenges":"Mijn Uitdagingen","myFriends":"Mijn vrienden","myProfile":"Mijn spelerprofiel","nlPromoAlertButtonText":"Nu aanmelden","nlPromoAlertHeadline":"Uw Newsletter","nlPromoAlertText":"Informeer u eenvoudig en gemakkelijk per e-mail over alle <strong>nieuwe spellen</strong> en neem deel aan <strong>leuke wedstrijden</strong>.","noFriendOnline":"Geen vrienden online","paymentAlertHeadline":"Let op","paymentAlertLinkName":"\\" name","paymentAlert_1":"Uw saldo is lager dan {0}. Laad hier nu snel","paymentAlert_2":"uw speleraccount","paymentAlert_3":"op en speel verder!","rommeMastersPromoAlert":"Diese Woche startet das ","rommeMastersPromoAlert1":". Rommé Masters Qualifikationsturnier. Wieder werden 2 Finaltickets für die Bestplatzierten vergeben.","rommeMastersPromoAlertButtonText":"Jetzt Anmelden","rommeMastersPromoAlertHeadline":"Rommé Masters","rommePromoButtonText":"Alle Infos hier","rommePromoHeadlineText":"Rommé Masters","rommePromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Rommé Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!","skatPromoButtonText":"Alle Infos hier","skatPromoHeadlineText":"Skat Masters","skatPromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Skat Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!"}}}');/***/}),/***/4207:(/***/function _(module){"use strict";module.exports=/*#__PURE__*/JSON.parse('{"accountbox":{"main":{"AccountBox_tooltip_bonus":"Gratisbonus:","AccountBox_tooltip_real":"Betalbart belopp:","chargeAccount":"Ladda Konto","chargeAccountDM":"Acheter des Diamants","chargeAccountPS":"Ladda Konto","chargeAccountPSDM":"Acheter des Diamants","friendsOnline":"{friendsOnlineCount} vän/ner online","gratisBonus":"Lös in gratisbonus","inbox":"Inbox","logout":"Logout","myChallenges":"Mina utmaningar","myFriends":"Mina vänner","myProfile":"Min spelarprofil","nlPromoAlertButtonText":"Anmäl dig nu","nlPromoAlertHeadline":"Ditt nyhetsbrev","nlPromoAlertText":"Se till att få den senaste informationen om alla <strong>nya spel</strong> per e-mail, samtidigt som du deltar i våra <strong> roliga tävlingar</strong>.","noFriendOnline":"Inga vänner online","paymentAlertHeadline":"Info","paymentAlertLinkName":"\\" name","paymentAlert_1":"Du har mindre än {0} på ditt spelarkonto. Ladda","paymentAlert_2":"ditt konto","paymentAlert_3":"för att kunna spela vidare.","rommeMastersPromoAlert":"Diese Woche startet das ","rommeMastersPromoAlert1":". Rommé Masters Qualifikationsturnier. Wieder werden 2 Finaltickets für die Bestplatzierten vergeben.","rommeMastersPromoAlertButtonText":"Jetzt Anmelden","rommeMastersPromoAlertHeadline":"Rommé Masters","rommePromoButtonText":"Alle Infos hier","rommePromoHeadlineText":"Rommé Masters","rommePromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Rommé Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!","skatPromoButtonText":"Alle Infos hier","skatPromoHeadlineText":"Skat Masters","skatPromoText":"Nutzen Sie jetzt die Gelegenheit und sichern Sie sich ein Finalticket für das Skat Masters Finale 2016. Für dieses Qualifikationsturnier gibt es ein spezielles Angebot!"}}}');/***/})/******/};/************************************************************************//******/// The module cache
/******/var __webpack_module_cache__={};/******//******/// The require function
/******/function __nested_webpack_require_186475__(moduleId){/******/// Check if module is in cache
/******/var cachedModule=__webpack_module_cache__[moduleId];/******/if(cachedModule!==undefined){/******/return cachedModule.exports;/******/}/******/// Create a new module (and put it into the cache)
/******/var module=__webpack_module_cache__[moduleId]={/******/// no module.id needed
/******/// no module.loaded needed
/******/exports:{}/******/};/******//******/// Execute the module function
/******/__webpack_modules__[moduleId].call(module.exports,module,module.exports,__nested_webpack_require_186475__);/******//******/// Return the exports of the module
/******/return module.exports;/******/}/******//************************************************************************//******//* webpack/runtime/compat get default export *//******/!function(){/******/// getDefaultExport function for compatibility with non-harmony modules
/******/__nested_webpack_require_186475__.n=function(module){/******/var getter=module&&module.__esModule?/******/function(){return module['default'];}:/******/function(){return module;};/******/__nested_webpack_require_186475__.d(getter,{a:getter});/******/return getter;/******/};/******/}();/******//******//* webpack/runtime/define property getters *//******/!function(){/******/// define getter functions for harmony exports
/******/__nested_webpack_require_186475__.d=function(exports,definition){/******/for(var key in definition){/******/if(__nested_webpack_require_186475__.o(definition,key)&&!__nested_webpack_require_186475__.o(exports,key)){/******/Object.defineProperty(exports,key,{enumerable:true,get:definition[key]});/******/}/******/}/******/};/******/}();/******//******//* webpack/runtime/global *//******/!function(){/******/__nested_webpack_require_186475__.g=function(){/******/if((typeof globalThis==="undefined"?"undefined":_typeof2(globalThis))==='object')return globalThis;/******/try{/******/return this||new Function('return this')();/******/}catch(e){/******/if((typeof window==="undefined"?"undefined":_typeof2(window))==='object')return window;/******/}/******/}();/******/}();/******//******//* webpack/runtime/hasOwnProperty shorthand *//******/!function(){/******/__nested_webpack_require_186475__.o=function(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop);};/******/}();/******//******//* webpack/runtime/make namespace object *//******/!function(){/******/// define __esModule on exports
/******/__nested_webpack_require_186475__.r=function(exports){/******/if(typeof Symbol!=='undefined'&&Symbol.toStringTag){/******/Object.defineProperty(exports,Symbol.toStringTag,{value:'Module'});/******/}/******/Object.defineProperty(exports,'__esModule',{value:true});/******/};/******/}();/******//******//* webpack/runtime/publicPath *//******/!function(){/******/__nested_webpack_require_186475__.p="";/******/}();/******//************************************************************************/var __nested_webpack_exports__={};// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function(_errorMessages,_vue_i18n_errorMessag,_message_compiler_err,_dist_vue_i18n_errorM){"use strict";// ESM COMPAT FLAG
__nested_webpack_require_186475__.r(__nested_webpack_exports__);// EXPORTS
__nested_webpack_require_186475__.d(__nested_webpack_exports__,{"default":function _default(){return/* binding */entry_lib;}});;// ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */// This file is imported into lib/wc client bundles.
if(typeof window!=='undefined'){var currentScript=window.document.currentScript;if(true){var getCurrentScript=__nested_webpack_require_186475__(904);currentScript=getCurrentScript();// for backward compatibility, because previously we directly included the polyfill
if(!('currentScript'in document)){Object.defineProperty(document,'currentScript',{get:getCurrentScript});}}var src=currentScript&&currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);if(src){__nested_webpack_require_186475__.p=src[1];// eslint-disable-line
}}// Indicate to webpack that this file can be concatenated
/* harmony default export */var setPublicPath=null;// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.function.name.js
var es_function_name=__nested_webpack_require_186475__(3277);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string=__nested_webpack_require_186475__(630);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.promise.js
var es_promise=__nested_webpack_require_186475__(865);;// external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject=__webpack_require__(4100);;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/AvatarImage.vue?vue&type=script&setup=true&lang=ts
var _hoisted_1=["src"];/* harmony default export */var AvatarImagevue_type_script_setup_true_lang_ts=/*@__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({__name:'AvatarImage',props:{avatarUrl:{type:String},imageType:{type:String,default:'PROFILE_185'}},setup:function setup(__props){var props=__props;return function(_ctx,_cache){return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("img",{src:"".concat(__props.avatarUrl,"PROFILE_185.png"),height:"185",width:"140"},null,8,_hoisted_1);};}});;// ./src/components/AvatarImage.vue?vue&type=script&setup=true&lang=ts
;// ./src/components/AvatarImage.vue
var __exports__=AvatarImagevue_type_script_setup_true_lang_ts;/* harmony default export */var AvatarImage=__exports__;// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify=__nested_webpack_require_186475__(4727);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.assign.js
var es_object_assign=__nested_webpack_require_186475__(7050);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.keys.js
var es_object_keys=__nested_webpack_require_186475__(8291);;// ../../libs/storage/dist/SessionStore.js
var SessionStore=/** @class */function(){function SessionStore(_a){var customId=_a.customId;if(customId){this.custom=JSON.parse(sessionStorage.getItem(customId)||'{}');}}SessionStore.prototype.storeCustom=function(id,data){this.custom=Object.assign({},this.custom,data);sessionStorage.setItem(id,JSON.stringify(this.custom));};return SessionStore;}();/* harmony default export */var dist_SessionStore=SessionStore;;// ../../libs/storage/dist/STORE.js
var STORE_NAME;(function(STORE_NAME){// essential
STORE_NAME["ACCESS_TOKEN"]="access_token";STORE_NAME["ACCOUNTBOX"]="accountbox";STORE_NAME["CID"]="cid";STORE_NAME["COOKIE_CONSENT"]="cookieConsent";STORE_NAME["GD"]="gd";STORE_NAME["HOME_ESSENTIAL"]="home-essential";STORE_NAME["JSESSIONID"]="JSESSIONID";STORE_NAME["PHONITAIRE"]="phonitaire";STORE_NAME["SHOP_WEB"]="shop-web";STORE_NAME["SHOP_ESSENTIAL"]="shop-essential";STORE_NAME["SESSION_HOST"]="SESSION_HOST";STORE_NAME["USER"]="user";// functional
STORE_NAME["LOBBY"]="lobby";STORE_NAME["SHOP"]="shop";})(STORE_NAME||(STORE_NAME={}));;// ../../libs/storage/dist/GD.js
/*
 *  Copyright (c) 2003-2019 GameDuell GmbH, All Rights Reserved
 *  This document is strictly confidential and sole property of GameDuell GmbH, Berlin, Germany
 *//**
 * localStorage scope GD
 */var GD=/** @class */function(){function GD(){var gd=JSON.parse(localStorage.getItem('gd')||'{}');this.viewLang=gd.viewLang;this.viewCountry=gd.viewCountry;this.webCtxPath=gd.webCtxPath||'/web';this.mediaUrl=gd.mediaUrl||'//assets.gameduell.de/res/moduleMedia/';this.avatarUrl=gd.avatarUrl||'//assets.gameduell.de/avatar/';this.partner={name:gd.partner&&gd.partner.name||'',url:gd.partner&&gd.partner.url||''};this.supportedLocales=gd.supportedLocales||['en-US','en-GB',// 'es-ES',
// 'fr-FR',
'nl-NL','se-SV','da-DK','de-DE','de-AT'];this.supportedTechs=gd.supportedTechs||['html5_dom'];this.blackRibbon=gd.blackRibbon||false;this.theme=gd.theme||'';this.cookieConsent={consented:gd.cookieConsent&&gd.cookieConsent.consented||false,auto:gd.cookieConsent&&gd.cookieConsent.auto||false,functional:gd.cookieConsent&&gd.cookieConsent.functional||false,marketing:gd.cookieConsent&&gd.cookieConsent.marketing||false,names:gd.cookieConsent&&gd.cookieConsent.names||[STORE_NAME.ACCESS_TOKEN,STORE_NAME.ACCOUNTBOX,STORE_NAME.CID,STORE_NAME.COOKIE_CONSENT,STORE_NAME.GD,STORE_NAME.HOME_ESSENTIAL,STORE_NAME.JSESSIONID,STORE_NAME.PHONITAIRE,STORE_NAME.SHOP_WEB,STORE_NAME.SHOP_ESSENTIAL,STORE_NAME.SESSION_HOST,STORE_NAME.USER]};this.decisions=gd.decisions||[];this.mobileDevice=gd.mobileDevice||false;this.betaMobil=gd.betaMobil||false;this.deviceType=gd.deviceType||'desktop';this.trackingConfig=gd.trackingConfig||[];this.gameNightGametype=gd.gameNightGametype||'';}return GD;}();;// ../../libs/storage/dist/User.js
/*
 *  Copyright (c) 2003-2019 GameDuell GmbH, All Rights Reserved
 *  This document is strictly confidential and sole property of GameDuell GmbH, Berlin, Germany
 *//**
 * localStorage scope GD
 */var User=/** @class */function(){function User(){var user=JSON.parse(localStorage.getItem('user')||'{}');this.id=user.id;this.currency=user.currency;this.name=user.name;this.actorType=user.actorType;this.locale=user.locale;this.loyalty=user.loyalty;this.bonusVisualization=user.bonusVisualization;this.payout=user.payout;this.forcePayout=user.forcePayout||false;this.avatarUrl=user.avatarUrl;}return User;}();;// ../../libs/storage/dist/LocalStore.js
var LocaleStore=/** @class */function(){function LocaleStore(_a){var customId=_a.customId;this.gd=new GD();this.user=new User();if(customId){this.custom=JSON.parse(localStorage.getItem(customId)||'{}');}}LocaleStore.prototype.storeGD=function(gd){this.gd=Object.assign({},this.gd,gd);localStorage.setItem('gd',JSON.stringify(this.gd));};LocaleStore.prototype.storeUser=function(user){this.user=Object.assign({},this.user,user);localStorage.setItem('user',JSON.stringify(this.user));};LocaleStore.prototype.storeCustom=function(id,data){this.custom=Object.assign({},this.custom,data);localStorage.setItem(id,JSON.stringify(this.custom));};return LocaleStore;}();/* harmony default export */var LocalStore=LocaleStore;// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor=__nested_webpack_require_186475__(1045);// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each=__nested_webpack_require_186475__(5350);// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each=__nested_webpack_require_186475__(8867);;// ../../libs/storage/dist/Storage.js
/**
 * Supports read/write localStorage - write works only for cookie consent allowed names (see gd.cookieConsent.names)
 * TODO: refactor too much read and write when creating a instance. The problem on lazy loading/saving the data is
 * too support multiple instances of this Storage object.
 */var Storage=/** @class */function(){/**
   * Initialize defaults
   */function Storage(){this.defaults={};this.defaults.gd=new GD();this.defaults.user=new User();}/**
   * Returns a object from localStorage (already JSON parsed).
   *
   * Will handle default values for GD and User.
   * @param store
   */Storage.prototype.read=function(store){var _this=this;var data=localStorage.getItem(store);var dataObj=JSON.parse(data||'{}');if(this.defaults[store]){Object.keys(this.defaults[store]).forEach(function(key){if(dataObj[key]===undefined){dataObj[key]=_this.defaults[store][key];}});}return dataObj;};/**
   * writes data to locale storage. Only cookies which are accepted in cookieConsent will be saved
   * @param store
   * @param data
   */Storage.prototype.write=function(store,data){// would be great to cache this but if we create multiple instance from Storage it will not work ;)
var gd=this.read(STORE_NAME.GD);if(gd.cookieConsent.names.indexOf(store)===-1){// skip write if cookie names are not part of the cookie consent
return;}var custom=Object.assign({},this.read(store)||{},data);localStorage.setItem(store,JSON.stringify(custom));};return Storage;}();/* harmony default export */var dist_Storage=Storage;;// ../../libs/storage/dist/vuexSessionStore.js
// initial state
var state={storageSessionCustom:{},customSessionId:''};// getters
var getters={storageSessionCustom:function storageSessionCustom(state){return state.storageSessionCustom;}};// actions
var actions={storageSessionInit:function storageSessionInit(_a,_b){var commit=_a.commit;var customId=_b.customId;var sessionStorage=new dist_SessionStore({customId:customId});commit('storageSessionCustom',{id:customId,data:sessionStorage.custom});commit('storageSessionSetCustomId',customId);}};// mutations
var mutations={storageSessionSetCustomId:function storageSessionSetCustomId(state,id){state.customSessionId=id;},/**
   * id is optional - it's using the id from the storageInit: customId as default
   */storageSessionCustom:function storageSessionCustom(state,_a){var id=_a.id,data=_a.data;// TODO: apply deep merge of objects
state.storageSessionCustom=Object.assign({},state.storageSessionCustom,data);sessionStorage.setItem(id||state.customSessionId,JSON.stringify(state.storageSessionCustom));}};/* harmony default export */var vuexSessionStore={state:state,getters:getters,actions:actions,mutations:mutations};;// ../../libs/storage/dist/vuexLocalStore.js
// initial state
var vuexLocalStore_state={storageGD:new LocalStore({}).gd,storageUser:new LocalStore({}).user,storageCustom:{},customId:''};// getters
var vuexLocalStore_getters={storageGD:function storageGD(state){return state.storageGD;},storageUser:function storageUser(state){return state.storageUser;},storageCustom:function storageCustom(state){return state.storageCustom;},webPath:function webPath(state){return state.storageGD.webCtxPath;}};// actions
var vuexLocalStore_actions={storageInit:function storageInit(_a,_b){var commit=_a.commit;var customId=_b.customId;var localStorage=new LocalStore({customId:customId});commit('storageCustom',{id:customId,data:localStorage.custom});commit('storageSetCustomId',customId);}};// mutations
var vuexLocalStore_mutations={storageSetCustomId:function storageSetCustomId(state,id){state.customId=id;},storageGD:function storageGD(state,gdInt){state.storageGD=Object.assign({},state.storageGD,gdInt);localStorage.setItem('gd',JSON.stringify(state.storageGD));},storageUser:function storageUser(state,userInt){state.storageUser=Object.assign({},state.storageUser,userInt);localStorage.setItem('user',JSON.stringify(state.storageUser));},/**
   * id is optional - it's using the id from the storageInit: customId as default
   */storageCustom:function storageCustom(state,_a){var id=_a.id,data=_a.data;// TODO: apply deep merge of objects
state.storageCustom=Object.assign({},state.storageCustom,data);localStorage.setItem(id||state.customId,JSON.stringify(state.storageCustom));}};/* harmony default export */var vuexLocalStore={state:vuexLocalStore_state,getters:vuexLocalStore_getters,actions:vuexLocalStore_actions,mutations:vuexLocalStore_mutations};;// ../../libs/storage/dist/index.js
/**
 * Make all of them public
 */;// ../../node_modules/@intlify/shared/dist/shared.mjs
/*!
  * shared v9.14.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  *//**
 * Original Utilities
 * written by kazuya kawaguchi
 */var shared_inBrowser=typeof window!=='undefined';var mark;var measure;if(false){}var RE_ARGS=/\{([0-9a-zA-Z]+)\}/g;/* eslint-disable */function shared_format(message){for(var _len=arguments.length,args=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}if(args.length===1&&shared_isObject(args[0])){args=args[0];}if(!args||!args.hasOwnProperty){args={};}return message.replace(RE_ARGS,function(match,identifier){return args.hasOwnProperty(identifier)?args[identifier]:'';});}var shared_makeSymbol=function shared_makeSymbol(name){var shareable=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return!shareable?Symbol(name):Symbol.for(name);};var generateFormatCacheKey=function generateFormatCacheKey(locale,key,source){return friendlyJSONstringify({l:locale,k:key,s:source});};var friendlyJSONstringify=function friendlyJSONstringify(json){return JSON.stringify(json).replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029").replace(/\u0027/g,"\\u0027");};var shared_isNumber=function shared_isNumber(val){return typeof val==='number'&&isFinite(val);};var isDate=function isDate(val){return toTypeString(val)==='[object Date]';};var shared_isRegExp=function shared_isRegExp(val){return toTypeString(val)==='[object RegExp]';};var isEmptyObject=function isEmptyObject(val){return shared_isPlainObject(val)&&Object.keys(val).length===0;};var shared_assign=Object.assign;var _globalThis;var getGlobalThis=function getGlobalThis(){// prettier-ignore
return _globalThis||(_globalThis=typeof globalThis!=='undefined'?globalThis:typeof self!=='undefined'?self:typeof window!=='undefined'?window:typeof __webpack_require__.g!=='undefined'?__webpack_require__.g:{});};function escapeHtml(rawText){return rawText.replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&apos;');}var shared_hasOwnProperty=Object.prototype.hasOwnProperty;function hasOwn(obj,key){return shared_hasOwnProperty.call(obj,key);}/* eslint-enable *//**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */var shared_isArray=Array.isArray;var shared_isFunction=function shared_isFunction(val){return typeof val==='function';};var shared_isString=function shared_isString(val){return typeof val==='string';};var shared_isBoolean=function shared_isBoolean(val){return typeof val==='boolean';};var isSymbol=function isSymbol(val){return _typeof2(val)==='symbol';};// eslint-disable-next-line @typescript-eslint/no-explicit-any
var shared_isObject=function shared_isObject(val){return val!==null&&_typeof2(val)==='object';};// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isPromise=function isPromise(val){return shared_isObject(val)&&shared_isFunction(val.then)&&shared_isFunction(val.catch);};var objectToString=Object.prototype.toString;var toTypeString=function toTypeString(value){return objectToString.call(value);};var shared_isPlainObject=function shared_isPlainObject(val){if(!shared_isObject(val))return false;var proto=Object.getPrototypeOf(val);return proto===null||proto.constructor===Object;};// for converting list and named values to displayed strings.
var toDisplayString=function toDisplayString(val){return val==null?'':shared_isArray(val)||shared_isPlainObject(val)&&val.toString===objectToString?JSON.stringify(val,null,2):String(val);};function join(items){var separator=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return items.reduce(function(str,item,index){return index===0?str+item:str+separator+item;},'');}var RANGE=2;function generateCodeFrame(source){var start=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var end=arguments.length>2&&arguments[2]!==undefined?arguments[2]:source.length;var lines=source.split(/\r?\n/);var count=0;var res=[];for(var i=0;i<lines.length;i++){count+=lines[i].length+1;if(count>=start){for(var j=i-RANGE;j<=i+RANGE||end>count;j++){if(j<0||j>=lines.length)continue;var line=j+1;res.push("".concat(line).concat(' '.repeat(3-String(line).length),"|  ").concat(lines[j]));var lineLength=lines[j].length;if(j===i){// push underline
var pad=start-(count-lineLength)+1;var length=Math.max(1,end>count?lineLength-pad:end-start);res.push("   |  "+' '.repeat(pad)+'^'.repeat(length));}else if(j>i){if(end>count){var _length=Math.max(Math.min(end-count,lineLength),1);res.push("   |  "+'^'.repeat(_length));}count+=lineLength+1;}}break;}}return res.join('\n');}function incrementer(code){var current=code;return function(){return++current;};}function shared_warn(msg,err){if(typeof console!=='undefined'){/* istanbul ignore if */if(err){}}}var hasWarned={};function warnOnce(msg){if(!hasWarned[msg]){hasWarned[msg]=true;shared_warn(msg);}}/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 *//**
 * Create a event emitter
 *
 * @returns An event emitter
 */function createEmitter(){var events=new Map();var emitter={events:events,on:function on(event,handler){var handlers=events.get(event);var added=handlers&&handlers.push(handler);if(!added){events.set(event,[handler]);}},off:function off(event,handler){var handlers=events.get(event);if(handlers){handlers.splice(handlers.indexOf(handler)>>>0,1);}},emit:function emit(event,payload){(events.get(event)||[]).slice().map(function(handler){return handler(payload);});(events.get('*')||[]).slice().map(function(handler){return handler(event,payload);});}};return emitter;}var isNotObjectOrIsArray=function isNotObjectOrIsArray(val){return!shared_isObject(val)||shared_isArray(val);};// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function deepCopy(src,des){// src and des should both be objects, and none of them can be a array
if(isNotObjectOrIsArray(src)||isNotObjectOrIsArray(des)){throw new Error('Invalid value');}var stack=[{src:src,des:des}];var _loop=function _loop(){var _stack$pop=stack.pop(),src=_stack$pop.src,des=_stack$pop.des;// using `Object.keys` which skips prototype properties
Object.keys(src).forEach(function(key){// if src[key] is an object/array, set des[key]
// to empty object/array to prevent setting by reference
if(shared_isObject(src[key])&&!shared_isObject(des[key])){des[key]=Array.isArray(src[key])?[]:{};}if(isNotObjectOrIsArray(des[key])||isNotObjectOrIsArray(src[key])){// replace with src[key] when:
// src[key] or des[key] is not an object, or
// src[key] or des[key] is an array
des[key]=src[key];}else{// src[key] and des[key] are both objects, merge them
stack.push({src:src[key],des:des[key]});}});};while(stack.length){_loop();}};// ../../node_modules/@intlify/message-compiler/dist/message-compiler.esm-browser.js
/*!
  * message-compiler v9.14.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */var LOCATION_STUB={start:{line:1,column:1,offset:0},end:{line:1,column:1,offset:0}};function createPosition(line,column,offset){return{line:line,column:column,offset:offset};}function createLocation(start,end,source){var loc={start:start,end:end};if(source!=null){loc.source=source;}return loc;}/**
 * Original Utilities
 * written by kazuya kawaguchi
 */var message_compiler_esm_browser_RE_ARGS=/\{([0-9a-zA-Z]+)\}/g;/* eslint-disable */function message_compiler_esm_browser_format(message){for(var _len2=arguments.length,args=new Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){args[_key2-1]=arguments[_key2];}if(args.length===1&&message_compiler_esm_browser_isObject(args[0])){args=args[0];}if(!args||!args.hasOwnProperty){args={};}return message.replace(message_compiler_esm_browser_RE_ARGS,function(match,identifier){return args.hasOwnProperty(identifier)?args[identifier]:'';});}var message_compiler_esm_browser_assign=Object.assign;var message_compiler_esm_browser_isString=function message_compiler_esm_browser_isString(val){return typeof val==='string';};// eslint-disable-next-line @typescript-eslint/no-explicit-any
var message_compiler_esm_browser_isObject=function message_compiler_esm_browser_isObject(val){return val!==null&&_typeof2(val)==='object';};function message_compiler_esm_browser_join(items){var separator=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return items.reduce(function(str,item,index){return index===0?str+item:str+separator+item;},'');}var message_compiler_esm_browser_CompileWarnCodes={USE_MODULO_SYNTAX:1,__EXTEND_POINT__:2};/** @internal */var warnMessages=_defineProperty2({},message_compiler_esm_browser_CompileWarnCodes.USE_MODULO_SYNTAX,"Use modulo before '{{0}}'.");function createCompileWarn(code,loc){for(var _len3=arguments.length,args=new Array(_len3>2?_len3-2:0),_key3=2;_key3<_len3;_key3++){args[_key3-2]=arguments[_key3];}var msg=message_compiler_esm_browser_format.apply(void 0,[warnMessages[code]||''].concat(_toConsumableArray(args||[])));var message={message:String(msg),code:code};if(loc){message.location=loc;}return message;}var CompileErrorCodes={// tokenizer error codes
EXPECTED_TOKEN:1,INVALID_TOKEN_IN_PLACEHOLDER:2,UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER:3,UNKNOWN_ESCAPE_SEQUENCE:4,INVALID_UNICODE_ESCAPE_SEQUENCE:5,UNBALANCED_CLOSING_BRACE:6,UNTERMINATED_CLOSING_BRACE:7,EMPTY_PLACEHOLDER:8,NOT_ALLOW_NEST_PLACEHOLDER:9,INVALID_LINKED_FORMAT:10,// parser error codes
MUST_HAVE_MESSAGES_IN_PLURAL:11,UNEXPECTED_EMPTY_LINKED_MODIFIER:12,UNEXPECTED_EMPTY_LINKED_KEY:13,UNEXPECTED_LEXICAL_ANALYSIS:14,// generator error codes
UNHANDLED_CODEGEN_NODE_TYPE:15,// minifier error codes
UNHANDLED_MINIFIER_NODE_TYPE:16,// Special value for higher-order compilers to pick up the last code
// to avoid collision of error codes. This should always be kept as the last
// item.
__EXTEND_POINT__:17};/** @internal */var errorMessages=(_errorMessages={},_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_errorMessages,CompileErrorCodes.EXPECTED_TOKEN,"Expected token: '{0}'"),CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER,"Invalid token in placeholder: '{0}'"),CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER,"Unterminated single quote in placeholder"),CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE,"Unknown escape sequence: \\{0}"),CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE,"Invalid unicode escape sequence: {0}"),CompileErrorCodes.UNBALANCED_CLOSING_BRACE,"Unbalanced closing brace"),CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,"Unterminated closing brace"),CompileErrorCodes.EMPTY_PLACEHOLDER,"Empty placeholder"),CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER,"Not allowed nest placeholder"),CompileErrorCodes.INVALID_LINKED_FORMAT,"Invalid linked format"),_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_errorMessages,CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL,"Plural must have messages"),CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER,"Unexpected empty linked modifier"),CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY,"Unexpected empty linked key"),CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,"Unexpected lexical analysis in token: '{0}'"),CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE,"unhandled codegen node type: '{0}'"),CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE,"unhandled mimifier node type: '{0}'"));function createCompileError(code,loc){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var domain=options.domain,messages=options.messages,args=options.args;var msg=message_compiler_esm_browser_format.apply(void 0,[(messages||errorMessages)[code]||''].concat(_toConsumableArray(args||[])));var error=new SyntaxError(String(msg));error.code=code;if(loc){error.location=loc;}error.domain=domain;return error;}/** @internal */function defaultOnError(error){throw error;}// eslint-disable-next-line no-useless-escape
var RE_HTML_TAG=/<\/?[\w\s="/.':;#-\/]+>/;var message_compiler_esm_browser_detectHtmlTag=function message_compiler_esm_browser_detectHtmlTag(source){return RE_HTML_TAG.test(source);};var CHAR_SP=' ';var CHAR_CR='\r';var CHAR_LF='\n';var CHAR_LS=String.fromCharCode(0x2028);var CHAR_PS=String.fromCharCode(0x2029);function createScanner(str){var _buf=str;var _index=0;var _line=1;var _column=1;var _peekOffset=0;var isCRLF=function isCRLF(index){return _buf[index]===CHAR_CR&&_buf[index+1]===CHAR_LF;};var isLF=function isLF(index){return _buf[index]===CHAR_LF;};var isPS=function isPS(index){return _buf[index]===CHAR_PS;};var isLS=function isLS(index){return _buf[index]===CHAR_LS;};var isLineEnd=function isLineEnd(index){return isCRLF(index)||isLF(index)||isPS(index)||isLS(index);};var index=function index(){return _index;};var line=function line(){return _line;};var column=function column(){return _column;};var peekOffset=function peekOffset(){return _peekOffset;};var charAt=function charAt(offset){return isCRLF(offset)||isPS(offset)||isLS(offset)?CHAR_LF:_buf[offset];};var currentChar=function currentChar(){return charAt(_index);};var currentPeek=function currentPeek(){return charAt(_index+_peekOffset);};function next(){_peekOffset=0;if(isLineEnd(_index)){_line++;_column=0;}if(isCRLF(_index)){_index++;}_index++;_column++;return _buf[_index];}function peek(){if(isCRLF(_index+_peekOffset)){_peekOffset++;}_peekOffset++;return _buf[_index+_peekOffset];}function reset(){_index=0;_line=1;_column=1;_peekOffset=0;}function resetPeek(){var offset=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;_peekOffset=offset;}function skipToPeek(){var target=_index+_peekOffset;// eslint-disable-next-line no-unmodified-loop-condition
while(target!==_index){next();}_peekOffset=0;}return{index:index,line:line,column:column,peekOffset:peekOffset,charAt:charAt,currentChar:currentChar,currentPeek:currentPeek,next:next,peek:peek,reset:reset,resetPeek:resetPeek,skipToPeek:skipToPeek};}var EOF=undefined;var DOT='.';var LITERAL_DELIMITER="'";var ERROR_DOMAIN$3='tokenizer';function createTokenizer(source){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var location=options.location!==false;var _scnr=createScanner(source);var currentOffset=function currentOffset(){return _scnr.index();};var currentPosition=function currentPosition(){return createPosition(_scnr.line(),_scnr.column(),_scnr.index());};var _initLoc=currentPosition();var _initOffset=currentOffset();var _context={currentType:14/* TokenTypes.EOF */,offset:_initOffset,startLoc:_initLoc,endLoc:_initLoc,lastType:14/* TokenTypes.EOF */,lastOffset:_initOffset,lastStartLoc:_initLoc,lastEndLoc:_initLoc,braceNest:0,inLinked:false,text:''};var context=function context(){return _context;};var onError=options.onError;function emitError(code,pos,offset){var ctx=context();pos.column+=offset;pos.offset+=offset;if(onError){var loc=location?createLocation(ctx.startLoc,pos):null;for(var _len4=arguments.length,args=new Array(_len4>3?_len4-3:0),_key4=3;_key4<_len4;_key4++){args[_key4-3]=arguments[_key4];}var err=createCompileError(code,loc,{domain:ERROR_DOMAIN$3,args:args});onError(err);}}function getToken(context,type,value){context.endLoc=currentPosition();context.currentType=type;var token={type:type};if(location){token.loc=createLocation(context.startLoc,context.endLoc);}if(value!=null){token.value=value;}return token;}var getEndToken=function getEndToken(context){return getToken(context,14/* TokenTypes.EOF */);};function eat(scnr,ch){if(scnr.currentChar()===ch){scnr.next();return ch;}else{emitError(CompileErrorCodes.EXPECTED_TOKEN,currentPosition(),0,ch);return'';}}function peekSpaces(scnr){var buf='';while(scnr.currentPeek()===CHAR_SP||scnr.currentPeek()===CHAR_LF){buf+=scnr.currentPeek();scnr.peek();}return buf;}function skipSpaces(scnr){var buf=peekSpaces(scnr);scnr.skipToPeek();return buf;}function isIdentifierStart(ch){if(ch===EOF){return false;}var cc=ch.charCodeAt(0);return cc>=97&&cc<=122||// a-z
cc>=65&&cc<=90||// A-Z
cc===95// _
;}function isNumberStart(ch){if(ch===EOF){return false;}var cc=ch.charCodeAt(0);return cc>=48&&cc<=57;// 0-9
}function isNamedIdentifierStart(scnr,context){var currentType=context.currentType;if(currentType!==2/* TokenTypes.BraceLeft */){return false;}peekSpaces(scnr);var ret=isIdentifierStart(scnr.currentPeek());scnr.resetPeek();return ret;}function isListIdentifierStart(scnr,context){var currentType=context.currentType;if(currentType!==2/* TokenTypes.BraceLeft */){return false;}peekSpaces(scnr);var ch=scnr.currentPeek()==='-'?scnr.peek():scnr.currentPeek();var ret=isNumberStart(ch);scnr.resetPeek();return ret;}function isLiteralStart(scnr,context){var currentType=context.currentType;if(currentType!==2/* TokenTypes.BraceLeft */){return false;}peekSpaces(scnr);var ret=scnr.currentPeek()===LITERAL_DELIMITER;scnr.resetPeek();return ret;}function isLinkedDotStart(scnr,context){var currentType=context.currentType;if(currentType!==8/* TokenTypes.LinkedAlias */){return false;}peekSpaces(scnr);var ret=scnr.currentPeek()==="."/* TokenChars.LinkedDot */;scnr.resetPeek();return ret;}function isLinkedModifierStart(scnr,context){var currentType=context.currentType;if(currentType!==9/* TokenTypes.LinkedDot */){return false;}peekSpaces(scnr);var ret=isIdentifierStart(scnr.currentPeek());scnr.resetPeek();return ret;}function isLinkedDelimiterStart(scnr,context){var currentType=context.currentType;if(!(currentType===8/* TokenTypes.LinkedAlias */||currentType===12/* TokenTypes.LinkedModifier */)){return false;}peekSpaces(scnr);var ret=scnr.currentPeek()===":"/* TokenChars.LinkedDelimiter */;scnr.resetPeek();return ret;}function isLinkedReferStart(scnr,context){var currentType=context.currentType;if(currentType!==10/* TokenTypes.LinkedDelimiter */){return false;}var _fn=function fn(){var ch=scnr.currentPeek();if(ch==="{"/* TokenChars.BraceLeft */){return isIdentifierStart(scnr.peek());}else if(ch==="@"/* TokenChars.LinkedAlias */||ch==="%"/* TokenChars.Modulo */||ch==="|"/* TokenChars.Pipe */||ch===":"/* TokenChars.LinkedDelimiter */||ch==="."/* TokenChars.LinkedDot */||ch===CHAR_SP||!ch){return false;}else if(ch===CHAR_LF){scnr.peek();return _fn();}else{// other characters
return isTextStart(scnr,false);}};var ret=_fn();scnr.resetPeek();return ret;}function isPluralStart(scnr){peekSpaces(scnr);var ret=scnr.currentPeek()==="|"/* TokenChars.Pipe */;scnr.resetPeek();return ret;}function detectModuloStart(scnr){var spaces=peekSpaces(scnr);var ret=scnr.currentPeek()==="%"/* TokenChars.Modulo */&&scnr.peek()==="{"/* TokenChars.BraceLeft */;scnr.resetPeek();return{isModulo:ret,hasSpace:spaces.length>0};}function isTextStart(scnr){var reset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var _fn2=function fn(){var hasSpace=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var prev=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var detectModulo=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var ch=scnr.currentPeek();if(ch==="{"/* TokenChars.BraceLeft */){return prev==="%"/* TokenChars.Modulo */?false:hasSpace;}else if(ch==="@"/* TokenChars.LinkedAlias */||!ch){return prev==="%"/* TokenChars.Modulo */?true:hasSpace;}else if(ch==="%"/* TokenChars.Modulo */){scnr.peek();return _fn2(hasSpace,"%"/* TokenChars.Modulo */,true);}else if(ch==="|"/* TokenChars.Pipe */){return prev==="%"/* TokenChars.Modulo */||detectModulo?true:!(prev===CHAR_SP||prev===CHAR_LF);}else if(ch===CHAR_SP){scnr.peek();return _fn2(true,CHAR_SP,detectModulo);}else if(ch===CHAR_LF){scnr.peek();return _fn2(true,CHAR_LF,detectModulo);}else{return true;}};var ret=_fn2();reset&&scnr.resetPeek();return ret;}function takeChar(scnr,fn){var ch=scnr.currentChar();if(ch===EOF){return EOF;}if(fn(ch)){scnr.next();return ch;}return null;}function isIdentifier(ch){var cc=ch.charCodeAt(0);return cc>=97&&cc<=122||// a-z
cc>=65&&cc<=90||// A-Z
cc>=48&&cc<=57||// 0-9
cc===95||// _
cc===36// $
;}function takeIdentifierChar(scnr){return takeChar(scnr,isIdentifier);}function isNamedIdentifier(ch){var cc=ch.charCodeAt(0);return cc>=97&&cc<=122||// a-z
cc>=65&&cc<=90||// A-Z
cc>=48&&cc<=57||// 0-9
cc===95||// _
cc===36||// $
cc===45// -
;}function takeNamedIdentifierChar(scnr){return takeChar(scnr,isNamedIdentifier);}function isDigit(ch){var cc=ch.charCodeAt(0);return cc>=48&&cc<=57;// 0-9
}function takeDigit(scnr){return takeChar(scnr,isDigit);}function isHexDigit(ch){var cc=ch.charCodeAt(0);return cc>=48&&cc<=57||// 0-9
cc>=65&&cc<=70||// A-F
cc>=97&&cc<=102;// a-f
}function takeHexDigit(scnr){return takeChar(scnr,isHexDigit);}function getDigits(scnr){var ch='';var num='';while(ch=takeDigit(scnr)){num+=ch;}return num;}function readModulo(scnr){skipSpaces(scnr);var ch=scnr.currentChar();if(ch!=="%"/* TokenChars.Modulo */){emitError(CompileErrorCodes.EXPECTED_TOKEN,currentPosition(),0,ch);}scnr.next();return"%"/* TokenChars.Modulo */;}function readText(scnr){var buf='';// eslint-disable-next-line no-constant-condition
while(true){var ch=scnr.currentChar();if(ch==="{"/* TokenChars.BraceLeft */||ch==="}"/* TokenChars.BraceRight */||ch==="@"/* TokenChars.LinkedAlias */||ch==="|"/* TokenChars.Pipe */||!ch){break;}else if(ch==="%"/* TokenChars.Modulo */){if(isTextStart(scnr)){buf+=ch;scnr.next();}else{break;}}else if(ch===CHAR_SP||ch===CHAR_LF){if(isTextStart(scnr)){buf+=ch;scnr.next();}else if(isPluralStart(scnr)){break;}else{buf+=ch;scnr.next();}}else{buf+=ch;scnr.next();}}return buf;}function readNamedIdentifier(scnr){skipSpaces(scnr);var ch='';var name='';while(ch=takeNamedIdentifierChar(scnr)){name+=ch;}if(scnr.currentChar()===EOF){emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);}return name;}function readListIdentifier(scnr){skipSpaces(scnr);var value='';if(scnr.currentChar()==='-'){scnr.next();value+="-".concat(getDigits(scnr));}else{value+=getDigits(scnr);}if(scnr.currentChar()===EOF){emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);}return value;}function isLiteral(ch){return ch!==LITERAL_DELIMITER&&ch!==CHAR_LF;}function readLiteral(scnr){skipSpaces(scnr);// eslint-disable-next-line no-useless-escape
eat(scnr,"'");var ch='';var literal='';while(ch=takeChar(scnr,isLiteral)){if(ch==='\\'){literal+=readEscapeSequence(scnr);}else{literal+=ch;}}var current=scnr.currentChar();if(current===CHAR_LF||current===EOF){emitError(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER,currentPosition(),0);// TODO: Is it correct really?
if(current===CHAR_LF){scnr.next();// eslint-disable-next-line no-useless-escape
eat(scnr,"'");}return literal;}// eslint-disable-next-line no-useless-escape
eat(scnr,"'");return literal;}function readEscapeSequence(scnr){var ch=scnr.currentChar();switch(ch){case'\\':case"'":// eslint-disable-line no-useless-escape
scnr.next();return"\\".concat(ch);case'u':return readUnicodeEscapeSequence(scnr,ch,4);case'U':return readUnicodeEscapeSequence(scnr,ch,6);default:emitError(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE,currentPosition(),0,ch);return'';}}function readUnicodeEscapeSequence(scnr,unicode,digits){eat(scnr,unicode);var sequence='';for(var i=0;i<digits;i++){var ch=takeHexDigit(scnr);if(!ch){emitError(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE,currentPosition(),0,"\\".concat(unicode).concat(sequence).concat(scnr.currentChar()));break;}sequence+=ch;}return"\\".concat(unicode).concat(sequence);}function isInvalidIdentifier(ch){return ch!=="{"/* TokenChars.BraceLeft */&&ch!=="}"/* TokenChars.BraceRight */&&ch!==CHAR_SP&&ch!==CHAR_LF;}function readInvalidIdentifier(scnr){skipSpaces(scnr);var ch='';var identifiers='';while(ch=takeChar(scnr,isInvalidIdentifier)){identifiers+=ch;}return identifiers;}function readLinkedModifier(scnr){var ch='';var name='';while(ch=takeIdentifierChar(scnr)){name+=ch;}return name;}function readLinkedRefer(scnr){var _fn3=function fn(buf){var ch=scnr.currentChar();if(ch==="{"/* TokenChars.BraceLeft */||ch==="%"/* TokenChars.Modulo */||ch==="@"/* TokenChars.LinkedAlias */||ch==="|"/* TokenChars.Pipe */||ch==="("/* TokenChars.ParenLeft */||ch===")"/* TokenChars.ParenRight */||!ch){return buf;}else if(ch===CHAR_SP){return buf;}else if(ch===CHAR_LF||ch===DOT){buf+=ch;scnr.next();return _fn3(buf);}else{buf+=ch;scnr.next();return _fn3(buf);}};return _fn3('');}function readPlural(scnr){skipSpaces(scnr);var plural=eat(scnr,"|"/* TokenChars.Pipe */);skipSpaces(scnr);return plural;}// TODO: We need refactoring of token parsing ...
function readTokenInPlaceholder(scnr,context){var token=null;var ch=scnr.currentChar();switch(ch){case"{"/* TokenChars.BraceLeft */:if(context.braceNest>=1){emitError(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER,currentPosition(),0);}scnr.next();token=getToken(context,2/* TokenTypes.BraceLeft */,"{"/* TokenChars.BraceLeft */);skipSpaces(scnr);context.braceNest++;return token;case"}"/* TokenChars.BraceRight */:if(context.braceNest>0&&context.currentType===2/* TokenTypes.BraceLeft */){emitError(CompileErrorCodes.EMPTY_PLACEHOLDER,currentPosition(),0);}scnr.next();token=getToken(context,3/* TokenTypes.BraceRight */,"}"/* TokenChars.BraceRight */);context.braceNest--;context.braceNest>0&&skipSpaces(scnr);if(context.inLinked&&context.braceNest===0){context.inLinked=false;}return token;case"@"/* TokenChars.LinkedAlias */:if(context.braceNest>0){emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);}token=readTokenInLinked(scnr,context)||getEndToken(context);context.braceNest=0;return token;default:{var validNamedIdentifier=true;var validListIdentifier=true;var validLiteral=true;if(isPluralStart(scnr)){if(context.braceNest>0){emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);}token=getToken(context,1/* TokenTypes.Pipe */,readPlural(scnr));// reset
context.braceNest=0;context.inLinked=false;return token;}if(context.braceNest>0&&(context.currentType===5/* TokenTypes.Named */||context.currentType===6/* TokenTypes.List */||context.currentType===7/* TokenTypes.Literal */)){emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);context.braceNest=0;return readToken(scnr,context);}if(validNamedIdentifier=isNamedIdentifierStart(scnr,context)){token=getToken(context,5/* TokenTypes.Named */,readNamedIdentifier(scnr));skipSpaces(scnr);return token;}if(validListIdentifier=isListIdentifierStart(scnr,context)){token=getToken(context,6/* TokenTypes.List */,readListIdentifier(scnr));skipSpaces(scnr);return token;}if(validLiteral=isLiteralStart(scnr,context)){token=getToken(context,7/* TokenTypes.Literal */,readLiteral(scnr));skipSpaces(scnr);return token;}if(!validNamedIdentifier&&!validListIdentifier&&!validLiteral){// TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
token=getToken(context,13/* TokenTypes.InvalidPlace */,readInvalidIdentifier(scnr));emitError(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER,currentPosition(),0,token.value);skipSpaces(scnr);return token;}break;}}return token;}// TODO: We need refactoring of token parsing ...
function readTokenInLinked(scnr,context){var currentType=context.currentType;var token=null;var ch=scnr.currentChar();if((currentType===8/* TokenTypes.LinkedAlias */||currentType===9/* TokenTypes.LinkedDot */||currentType===12/* TokenTypes.LinkedModifier */||currentType===10/* TokenTypes.LinkedDelimiter */)&&(ch===CHAR_LF||ch===CHAR_SP)){emitError(CompileErrorCodes.INVALID_LINKED_FORMAT,currentPosition(),0);}switch(ch){case"@"/* TokenChars.LinkedAlias */:scnr.next();token=getToken(context,8/* TokenTypes.LinkedAlias */,"@"/* TokenChars.LinkedAlias */);context.inLinked=true;return token;case"."/* TokenChars.LinkedDot */:skipSpaces(scnr);scnr.next();return getToken(context,9/* TokenTypes.LinkedDot */,"."/* TokenChars.LinkedDot */);case":"/* TokenChars.LinkedDelimiter */:skipSpaces(scnr);scnr.next();return getToken(context,10/* TokenTypes.LinkedDelimiter */,":"/* TokenChars.LinkedDelimiter */);default:if(isPluralStart(scnr)){token=getToken(context,1/* TokenTypes.Pipe */,readPlural(scnr));// reset
context.braceNest=0;context.inLinked=false;return token;}if(isLinkedDotStart(scnr,context)||isLinkedDelimiterStart(scnr,context)){skipSpaces(scnr);return readTokenInLinked(scnr,context);}if(isLinkedModifierStart(scnr,context)){skipSpaces(scnr);return getToken(context,12/* TokenTypes.LinkedModifier */,readLinkedModifier(scnr));}if(isLinkedReferStart(scnr,context)){skipSpaces(scnr);if(ch==="{"/* TokenChars.BraceLeft */){// scan the placeholder
return readTokenInPlaceholder(scnr,context)||token;}else{return getToken(context,11/* TokenTypes.LinkedKey */,readLinkedRefer(scnr));}}if(currentType===8/* TokenTypes.LinkedAlias */){emitError(CompileErrorCodes.INVALID_LINKED_FORMAT,currentPosition(),0);}context.braceNest=0;context.inLinked=false;return readToken(scnr,context);}}// TODO: We need refactoring of token parsing ...
function readToken(scnr,context){var token={type:14/* TokenTypes.EOF */};if(context.braceNest>0){return readTokenInPlaceholder(scnr,context)||getEndToken(context);}if(context.inLinked){return readTokenInLinked(scnr,context)||getEndToken(context);}var ch=scnr.currentChar();switch(ch){case"{"/* TokenChars.BraceLeft */:return readTokenInPlaceholder(scnr,context)||getEndToken(context);case"}"/* TokenChars.BraceRight */:emitError(CompileErrorCodes.UNBALANCED_CLOSING_BRACE,currentPosition(),0);scnr.next();return getToken(context,3/* TokenTypes.BraceRight */,"}"/* TokenChars.BraceRight */);case"@"/* TokenChars.LinkedAlias */:return readTokenInLinked(scnr,context)||getEndToken(context);default:{if(isPluralStart(scnr)){token=getToken(context,1/* TokenTypes.Pipe */,readPlural(scnr));// reset
context.braceNest=0;context.inLinked=false;return token;}var _detectModuloStart=detectModuloStart(scnr),isModulo=_detectModuloStart.isModulo,hasSpace=_detectModuloStart.hasSpace;if(isModulo){return hasSpace?getToken(context,0/* TokenTypes.Text */,readText(scnr)):getToken(context,4/* TokenTypes.Modulo */,readModulo(scnr));}if(isTextStart(scnr)){return getToken(context,0/* TokenTypes.Text */,readText(scnr));}break;}}return token;}function nextToken(){var currentType=_context.currentType,offset=_context.offset,startLoc=_context.startLoc,endLoc=_context.endLoc;_context.lastType=currentType;_context.lastOffset=offset;_context.lastStartLoc=startLoc;_context.lastEndLoc=endLoc;_context.offset=currentOffset();_context.startLoc=currentPosition();if(_scnr.currentChar()===EOF){return getToken(_context,14/* TokenTypes.EOF */);}return readToken(_scnr,_context);}return{nextToken:nextToken,currentOffset:currentOffset,currentPosition:currentPosition,context:context};}var ERROR_DOMAIN$2='parser';// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
var KNOWN_ESCAPES=/(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;function fromEscapeSequence(match,codePoint4,codePoint6){switch(match){case"\\\\":return"\\";// eslint-disable-next-line no-useless-escape
case"\\'":// eslint-disable-next-line no-useless-escape
return"'";default:{var codePoint=parseInt(codePoint4||codePoint6,16);if(codePoint<=0xd7ff||codePoint>=0xe000){return String.fromCodePoint(codePoint);}// invalid ...
// Replace them with U+FFFD REPLACEMENT CHARACTER.
return'�';}}}function createParser(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var location=options.location!==false;var onError=options.onError,onWarn=options.onWarn;function emitError(tokenzer,code,start,offset){var end=tokenzer.currentPosition();end.offset+=offset;end.column+=offset;if(onError){var loc=location?createLocation(start,end):null;for(var _len5=arguments.length,args=new Array(_len5>4?_len5-4:0),_key5=4;_key5<_len5;_key5++){args[_key5-4]=arguments[_key5];}var err=createCompileError(code,loc,{domain:ERROR_DOMAIN$2,args:args});onError(err);}}function emitWarn(tokenzer,code,start,offset){var end=tokenzer.currentPosition();end.offset+=offset;end.column+=offset;if(onWarn){var loc=location?createLocation(start,end):null;for(var _len6=arguments.length,args=new Array(_len6>4?_len6-4:0),_key6=4;_key6<_len6;_key6++){args[_key6-4]=arguments[_key6];}onWarn(createCompileWarn(code,loc,args));}}function startNode(type,offset,loc){var node={type:type};if(location){node.start=offset;node.end=offset;node.loc={start:loc,end:loc};}return node;}function endNode(node,offset,pos,type){if(type){node.type=type;}if(location){node.end=offset;if(node.loc){node.loc.end=pos;}}}function parseText(tokenizer,value){var context=tokenizer.context();var node=startNode(3/* NodeTypes.Text */,context.offset,context.startLoc);node.value=value;endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseList(tokenizer,index){var context=tokenizer.context();var offset=context.lastOffset,loc=context.lastStartLoc;// get brace left loc
var node=startNode(5/* NodeTypes.List */,offset,loc);node.index=parseInt(index,10);tokenizer.nextToken();// skip brach right
endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseNamed(tokenizer,key,modulo){var context=tokenizer.context();var offset=context.lastOffset,loc=context.lastStartLoc;// get brace left loc
var node=startNode(4/* NodeTypes.Named */,offset,loc);node.key=key;if(modulo===true){node.modulo=true;}tokenizer.nextToken();// skip brach right
endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseLiteral(tokenizer,value){var context=tokenizer.context();var offset=context.lastOffset,loc=context.lastStartLoc;// get brace left loc
var node=startNode(9/* NodeTypes.Literal */,offset,loc);node.value=value.replace(KNOWN_ESCAPES,fromEscapeSequence);tokenizer.nextToken();// skip brach right
endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseLinkedModifier(tokenizer){var token=tokenizer.nextToken();var context=tokenizer.context();var offset=context.lastOffset,loc=context.lastStartLoc;// get linked dot loc
var node=startNode(8/* NodeTypes.LinkedModifier */,offset,loc);if(token.type!==12/* TokenTypes.LinkedModifier */){// empty modifier
emitError(tokenizer,CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER,context.lastStartLoc,0);node.value='';endNode(node,offset,loc);return{nextConsumeToken:token,node:node};}// check token
if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}node.value=token.value||'';endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return{node:node};}function parseLinkedKey(tokenizer,value){var context=tokenizer.context();var node=startNode(7/* NodeTypes.LinkedKey */,context.offset,context.startLoc);node.value=value;endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseLinked(tokenizer){var context=tokenizer.context();var linkedNode=startNode(6/* NodeTypes.Linked */,context.offset,context.startLoc);var token=tokenizer.nextToken();if(token.type===9/* TokenTypes.LinkedDot */){var parsed=parseLinkedModifier(tokenizer);linkedNode.modifier=parsed.node;token=parsed.nextConsumeToken||tokenizer.nextToken();}// asset check token
if(token.type!==10/* TokenTypes.LinkedDelimiter */){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}token=tokenizer.nextToken();// skip brace left
if(token.type===2/* TokenTypes.BraceLeft */){token=tokenizer.nextToken();}switch(token.type){case 11/* TokenTypes.LinkedKey */:if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}linkedNode.key=parseLinkedKey(tokenizer,token.value||'');break;case 5/* TokenTypes.Named */:if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}linkedNode.key=parseNamed(tokenizer,token.value||'');break;case 6/* TokenTypes.List */:if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}linkedNode.key=parseList(tokenizer,token.value||'');break;case 7/* TokenTypes.Literal */:if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}linkedNode.key=parseLiteral(tokenizer,token.value||'');break;default:{// empty key
emitError(tokenizer,CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY,context.lastStartLoc,0);var nextContext=tokenizer.context();var emptyLinkedKeyNode=startNode(7/* NodeTypes.LinkedKey */,nextContext.offset,nextContext.startLoc);emptyLinkedKeyNode.value='';endNode(emptyLinkedKeyNode,nextContext.offset,nextContext.startLoc);linkedNode.key=emptyLinkedKeyNode;endNode(linkedNode,nextContext.offset,nextContext.startLoc);return{nextConsumeToken:token,node:linkedNode};}}endNode(linkedNode,tokenizer.currentOffset(),tokenizer.currentPosition());return{node:linkedNode};}function parseMessage(tokenizer){var context=tokenizer.context();var startOffset=context.currentType===1/* TokenTypes.Pipe */?tokenizer.currentOffset():context.offset;var startLoc=context.currentType===1/* TokenTypes.Pipe */?context.endLoc:context.startLoc;var node=startNode(2/* NodeTypes.Message */,startOffset,startLoc);node.items=[];var nextToken=null;var modulo=null;do{var token=nextToken||tokenizer.nextToken();nextToken=null;switch(token.type){case 0/* TokenTypes.Text */:if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}node.items.push(parseText(tokenizer,token.value||''));break;case 6/* TokenTypes.List */:if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}node.items.push(parseList(tokenizer,token.value||''));break;case 4/* TokenTypes.Modulo */:modulo=true;break;case 5/* TokenTypes.Named */:if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}node.items.push(parseNamed(tokenizer,token.value||'',!!modulo));if(modulo){emitWarn(tokenizer,message_compiler_esm_browser_CompileWarnCodes.USE_MODULO_SYNTAX,context.lastStartLoc,0,getTokenCaption(token));modulo=null;}break;case 7/* TokenTypes.Literal */:if(token.value==null){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,getTokenCaption(token));}node.items.push(parseLiteral(tokenizer,token.value||''));break;case 8/* TokenTypes.LinkedAlias */:{var parsed=parseLinked(tokenizer);node.items.push(parsed.node);nextToken=parsed.nextConsumeToken||null;break;}}}while(context.currentType!==14/* TokenTypes.EOF */&&context.currentType!==1/* TokenTypes.Pipe */);// adjust message node loc
var endOffset=context.currentType===1/* TokenTypes.Pipe */?context.lastOffset:tokenizer.currentOffset();var endLoc=context.currentType===1/* TokenTypes.Pipe */?context.lastEndLoc:tokenizer.currentPosition();endNode(node,endOffset,endLoc);return node;}function parsePlural(tokenizer,offset,loc,msgNode){var context=tokenizer.context();var hasEmptyMessage=msgNode.items.length===0;var node=startNode(1/* NodeTypes.Plural */,offset,loc);node.cases=[];node.cases.push(msgNode);do{var msg=parseMessage(tokenizer);if(!hasEmptyMessage){hasEmptyMessage=msg.items.length===0;}node.cases.push(msg);}while(context.currentType!==14/* TokenTypes.EOF */);if(hasEmptyMessage){emitError(tokenizer,CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL,loc,0);}endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseResource(tokenizer){var context=tokenizer.context();var offset=context.offset,startLoc=context.startLoc;var msgNode=parseMessage(tokenizer);if(context.currentType===14/* TokenTypes.EOF */){return msgNode;}else{return parsePlural(tokenizer,offset,startLoc,msgNode);}}function parse(source){var tokenizer=createTokenizer(source,message_compiler_esm_browser_assign({},options));var context=tokenizer.context();var node=startNode(0/* NodeTypes.Resource */,context.offset,context.startLoc);if(location&&node.loc){node.loc.source=source;}node.body=parseResource(tokenizer);if(options.onCacheKey){node.cacheKey=options.onCacheKey(source);}// assert whether achieved to EOF
if(context.currentType!==14/* TokenTypes.EOF */){emitError(tokenizer,CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,source[context.offset]||'');}endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}return{parse:parse};}function getTokenCaption(token){if(token.type===14/* TokenTypes.EOF */){return'EOF';}var name=(token.value||'').replace(/\r?\n/g,'\\n');return name.length>10?name.slice(0,9)+'…':name;}function createTransformer(ast){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _context={ast:ast,helpers:new Set()};var context=function context(){return _context;};var helper=function helper(name){_context.helpers.add(name);return name;};return{context:context,helper:helper};}function traverseNodes(nodes,transformer){for(var i=0;i<nodes.length;i++){traverseNode(nodes[i],transformer);}}function traverseNode(node,transformer){// TODO: if we need pre-hook of transform, should be implemented to here
switch(node.type){case 1/* NodeTypes.Plural */:traverseNodes(node.cases,transformer);transformer.helper("plural"/* HelperNameMap.PLURAL */);break;case 2/* NodeTypes.Message */:traverseNodes(node.items,transformer);break;case 6/* NodeTypes.Linked */:{var linked=node;traverseNode(linked.key,transformer);transformer.helper("linked"/* HelperNameMap.LINKED */);transformer.helper("type"/* HelperNameMap.TYPE */);break;}case 5/* NodeTypes.List */:transformer.helper("interpolate"/* HelperNameMap.INTERPOLATE */);transformer.helper("list"/* HelperNameMap.LIST */);break;case 4/* NodeTypes.Named */:transformer.helper("interpolate"/* HelperNameMap.INTERPOLATE */);transformer.helper("named"/* HelperNameMap.NAMED */);break;}// TODO: if we need post-hook of transform, should be implemented to here
}// transform AST
function transform(ast){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var transformer=createTransformer(ast);transformer.helper("normalize"/* HelperNameMap.NORMALIZE */);// traverse
ast.body&&traverseNode(ast.body,transformer);// set meta information
var context=transformer.context();ast.helpers=Array.from(context.helpers);}function optimize(ast){var body=ast.body;if(body.type===2/* NodeTypes.Message */){optimizeMessageNode(body);}else{body.cases.forEach(function(c){return optimizeMessageNode(c);});}return ast;}function optimizeMessageNode(message){if(message.items.length===1){var item=message.items[0];if(item.type===3/* NodeTypes.Text */||item.type===9/* NodeTypes.Literal */){message.static=item.value;delete item.value;// optimization for size
}}else{var values=[];for(var i=0;i<message.items.length;i++){var _item=message.items[i];if(!(_item.type===3/* NodeTypes.Text */||_item.type===9/* NodeTypes.Literal */)){break;}if(_item.value==null){break;}values.push(_item.value);}if(values.length===message.items.length){message.static=message_compiler_esm_browser_join(values);for(var _i=0;_i<message.items.length;_i++){var _item2=message.items[_i];if(_item2.type===3/* NodeTypes.Text */||_item2.type===9/* NodeTypes.Literal */){delete _item2.value;// optimization for size
}}}}}var ERROR_DOMAIN$1='minifier';/* eslint-disable @typescript-eslint/no-explicit-any */function minify(node){node.t=node.type;switch(node.type){case 0/* NodeTypes.Resource */:{var resource=node;minify(resource.body);resource.b=resource.body;delete resource.body;break;}case 1/* NodeTypes.Plural */:{var plural=node;var cases=plural.cases;for(var i=0;i<cases.length;i++){minify(cases[i]);}plural.c=cases;delete plural.cases;break;}case 2/* NodeTypes.Message */:{var message=node;var items=message.items;for(var _i2=0;_i2<items.length;_i2++){minify(items[_i2]);}message.i=items;delete message.items;if(message.static){message.s=message.static;delete message.static;}break;}case 3/* NodeTypes.Text */:case 9/* NodeTypes.Literal */:case 8/* NodeTypes.LinkedModifier */:case 7/* NodeTypes.LinkedKey */:{var valueNode=node;if(valueNode.value){valueNode.v=valueNode.value;delete valueNode.value;}break;}case 6/* NodeTypes.Linked */:{var linked=node;minify(linked.key);linked.k=linked.key;delete linked.key;if(linked.modifier){minify(linked.modifier);linked.m=linked.modifier;delete linked.modifier;}break;}case 5/* NodeTypes.List */:{var list=node;list.i=list.index;delete list.index;break;}case 4/* NodeTypes.Named */:{var named=node;named.k=named.key;delete named.key;break;}default:{throw createCompileError(CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE,null,{domain:ERROR_DOMAIN$1,args:[node.type]});}}delete node.type;}/* eslint-enable @typescript-eslint/no-explicit-any */// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
var ERROR_DOMAIN='parser';function createCodeGenerator(ast,options){var sourceMap=options.sourceMap,filename=options.filename,breakLineCode=options.breakLineCode,_needIndent=options.needIndent;var location=options.location!==false;var _context={filename:filename,code:'',column:1,line:1,offset:0,map:undefined,breakLineCode:breakLineCode,needIndent:_needIndent,indentLevel:0};if(location&&ast.loc){_context.source=ast.loc.source;}var context=function context(){return _context;};function push(code,node){_context.code+=code;}function _newline(n){var withBreakLine=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var _breakLineCode=withBreakLine?breakLineCode:'';push(_needIndent?_breakLineCode+"  ".repeat(n):_breakLineCode);}function indent(){var withNewLine=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var level=++_context.indentLevel;withNewLine&&_newline(level);}function deindent(){var withNewLine=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var level=--_context.indentLevel;withNewLine&&_newline(level);}function newline(){_newline(_context.indentLevel);}var helper=function helper(key){return"_".concat(key);};var needIndent=function needIndent(){return _context.needIndent;};return{context:context,push:push,indent:indent,deindent:deindent,newline:newline,helper:helper,needIndent:needIndent};}function generateLinkedNode(generator,node){var helper=generator.helper;generator.push("".concat(helper("linked"/* HelperNameMap.LINKED */),"("));generateNode(generator,node.key);if(node.modifier){generator.push(", ");generateNode(generator,node.modifier);generator.push(", _type");}else{generator.push(", undefined, _type");}generator.push(")");}function generateMessageNode(generator,node){var helper=generator.helper,needIndent=generator.needIndent;generator.push("".concat(helper("normalize"/* HelperNameMap.NORMALIZE */),"(["));generator.indent(needIndent());var length=node.items.length;for(var i=0;i<length;i++){generateNode(generator,node.items[i]);if(i===length-1){break;}generator.push(', ');}generator.deindent(needIndent());generator.push('])');}function generatePluralNode(generator,node){var helper=generator.helper,needIndent=generator.needIndent;if(node.cases.length>1){generator.push("".concat(helper("plural"/* HelperNameMap.PLURAL */),"(["));generator.indent(needIndent());var length=node.cases.length;for(var i=0;i<length;i++){generateNode(generator,node.cases[i]);if(i===length-1){break;}generator.push(', ');}generator.deindent(needIndent());generator.push("])");}}function generateResource(generator,node){if(node.body){generateNode(generator,node.body);}else{generator.push('null');}}function generateNode(generator,node){var helper=generator.helper;switch(node.type){case 0/* NodeTypes.Resource */:generateResource(generator,node);break;case 1/* NodeTypes.Plural */:generatePluralNode(generator,node);break;case 2/* NodeTypes.Message */:generateMessageNode(generator,node);break;case 6/* NodeTypes.Linked */:generateLinkedNode(generator,node);break;case 8/* NodeTypes.LinkedModifier */:generator.push(JSON.stringify(node.value),node);break;case 7/* NodeTypes.LinkedKey */:generator.push(JSON.stringify(node.value),node);break;case 5/* NodeTypes.List */:generator.push("".concat(helper("interpolate"/* HelperNameMap.INTERPOLATE */),"(").concat(helper("list"/* HelperNameMap.LIST */),"(").concat(node.index,"))"),node);break;case 4/* NodeTypes.Named */:generator.push("".concat(helper("interpolate"/* HelperNameMap.INTERPOLATE */),"(").concat(helper("named"/* HelperNameMap.NAMED */),"(").concat(JSON.stringify(node.key),"))"),node);break;case 9/* NodeTypes.Literal */:generator.push(JSON.stringify(node.value),node);break;case 3/* NodeTypes.Text */:generator.push(JSON.stringify(node.value),node);break;default:{throw createCompileError(CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE,null,{domain:ERROR_DOMAIN,args:[node.type]});}}}// generate code from AST
var generate=function generate(ast){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var mode=message_compiler_esm_browser_isString(options.mode)?options.mode:'normal';var filename=message_compiler_esm_browser_isString(options.filename)?options.filename:'message.intl';var sourceMap=!!options.sourceMap;// prettier-ignore
var breakLineCode=options.breakLineCode!=null?options.breakLineCode:mode==='arrow'?';':'\n';var needIndent=options.needIndent?options.needIndent:mode!=='arrow';var helpers=ast.helpers||[];var generator=createCodeGenerator(ast,{mode:mode,filename:filename,sourceMap:sourceMap,breakLineCode:breakLineCode,needIndent:needIndent});generator.push(mode==='normal'?"function __msg__ (ctx) {":"(ctx) => {");generator.indent(needIndent);if(helpers.length>0){generator.push("const { ".concat(message_compiler_esm_browser_join(helpers.map(function(s){return"".concat(s,": _").concat(s);}),', ')," } = ctx"));generator.newline();}generator.push("return ");generateNode(generator,ast);generator.deindent(needIndent);generator.push("}");delete ast.helpers;var _generator$context=generator.context(),code=_generator$context.code,map=_generator$context.map;return{ast:ast,code:code,map:map?map.toJSON():undefined// eslint-disable-line @typescript-eslint/no-explicit-any
};};function baseCompile(source){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var assignedOptions=message_compiler_esm_browser_assign({},options);var jit=!!assignedOptions.jit;var enalbeMinify=!!assignedOptions.minify;var enambeOptimize=assignedOptions.optimize==null?true:assignedOptions.optimize;// parse source codes
var parser=createParser(assignedOptions);var ast=parser.parse(source);if(!jit){// transform ASTs
transform(ast,assignedOptions);// generate javascript codes
return generate(ast,assignedOptions);}else{// optimize ASTs
enambeOptimize&&optimize(ast);// minimize ASTs
enalbeMinify&&minify(ast);// In JIT mode, no ast transform, no code generation.
return{ast:ast,code:''};}};// ../../node_modules/@intlify/core-base/dist/core-base.mjs
/*!
  * core-base v9.14.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  *//**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */function initFeatureFlags(){if(typeof __INTLIFY_PROD_DEVTOOLS__!=='boolean'){getGlobalThis().__INTLIFY_PROD_DEVTOOLS__=false;}if(typeof __INTLIFY_JIT_COMPILATION__!=='boolean'){getGlobalThis().__INTLIFY_JIT_COMPILATION__=false;}if(typeof __INTLIFY_DROP_MESSAGE_COMPILER__!=='boolean'){getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__=false;}}var pathStateMachine=[];pathStateMachine[0/* States.BEFORE_PATH */]=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"w"/* PathCharTypes.WORKSPACE */,[0/* States.BEFORE_PATH */]),"i"/* PathCharTypes.IDENT */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]),"["/* PathCharTypes.LEFT_BRACKET */,[4/* States.IN_SUB_PATH */]),"o"/* PathCharTypes.END_OF_FAIL */,[7/* States.AFTER_PATH */]);pathStateMachine[1/* States.IN_PATH */]=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"w"/* PathCharTypes.WORKSPACE */,[1/* States.IN_PATH */]),"."/* PathCharTypes.DOT */,[2/* States.BEFORE_IDENT */]),"["/* PathCharTypes.LEFT_BRACKET */,[4/* States.IN_SUB_PATH */]),"o"/* PathCharTypes.END_OF_FAIL */,[7/* States.AFTER_PATH */]);pathStateMachine[2/* States.BEFORE_IDENT */]=_defineProperty2(_defineProperty2(_defineProperty2({},"w"/* PathCharTypes.WORKSPACE */,[2/* States.BEFORE_IDENT */]),"i"/* PathCharTypes.IDENT */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]),"0"/* PathCharTypes.ZERO */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]);pathStateMachine[3/* States.IN_IDENT */]=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"i"/* PathCharTypes.IDENT */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]),"0"/* PathCharTypes.ZERO */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]),"w"/* PathCharTypes.WORKSPACE */,[1/* States.IN_PATH */,1/* Actions.PUSH */]),"."/* PathCharTypes.DOT */,[2/* States.BEFORE_IDENT */,1/* Actions.PUSH */]),"["/* PathCharTypes.LEFT_BRACKET */,[4/* States.IN_SUB_PATH */,1/* Actions.PUSH */]),"o"/* PathCharTypes.END_OF_FAIL */,[7/* States.AFTER_PATH */,1/* Actions.PUSH */]);pathStateMachine[4/* States.IN_SUB_PATH */]=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"'"/* PathCharTypes.SINGLE_QUOTE */,[5/* States.IN_SINGLE_QUOTE */,0/* Actions.APPEND */]),"\""/* PathCharTypes.DOUBLE_QUOTE */,[6/* States.IN_DOUBLE_QUOTE */,0/* Actions.APPEND */]),"["/* PathCharTypes.LEFT_BRACKET */,[4/* States.IN_SUB_PATH */,2/* Actions.INC_SUB_PATH_DEPTH */]),"]"/* PathCharTypes.RIGHT_BRACKET */,[1/* States.IN_PATH */,3/* Actions.PUSH_SUB_PATH */]),"o"/* PathCharTypes.END_OF_FAIL */,8),"l"/* PathCharTypes.ELSE */,[4/* States.IN_SUB_PATH */,0/* Actions.APPEND */]);pathStateMachine[5/* States.IN_SINGLE_QUOTE */]=_defineProperty2(_defineProperty2(_defineProperty2({},"'"/* PathCharTypes.SINGLE_QUOTE */,[4/* States.IN_SUB_PATH */,0/* Actions.APPEND */]),"o"/* PathCharTypes.END_OF_FAIL */,8),"l"/* PathCharTypes.ELSE */,[5/* States.IN_SINGLE_QUOTE */,0/* Actions.APPEND */]);pathStateMachine[6/* States.IN_DOUBLE_QUOTE */]=_defineProperty2(_defineProperty2(_defineProperty2({},"\""/* PathCharTypes.DOUBLE_QUOTE */,[4/* States.IN_SUB_PATH */,0/* Actions.APPEND */]),"o"/* PathCharTypes.END_OF_FAIL */,8),"l"/* PathCharTypes.ELSE */,[6/* States.IN_DOUBLE_QUOTE */,0/* Actions.APPEND */]);/**
 * Check if an expression is a literal value.
 */var literalValueRE=/^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;function isLiteral(exp){return literalValueRE.test(exp);}/**
 * Strip quotes from a string
 */function stripQuotes(str){var a=str.charCodeAt(0);var b=str.charCodeAt(str.length-1);return a===b&&(a===0x22||a===0x27)?str.slice(1,-1):str;}/**
 * Determine the type of a character in a keypath.
 */function getPathCharType(ch){if(ch===undefined||ch===null){return"o"/* PathCharTypes.END_OF_FAIL */;}var code=ch.charCodeAt(0);switch(code){case 0x5b:// [
case 0x5d:// ]
case 0x2e:// .
case 0x22:// "
case 0x27:// '
return ch;case 0x5f:// _
case 0x24:// $
case 0x2d:// -
return"i"/* PathCharTypes.IDENT */;case 0x09:// Tab (HT)
case 0x0a:// Newline (LF)
case 0x0d:// Return (CR)
case 0xa0:// No-break space (NBSP)
case 0xfeff:// Byte Order Mark (BOM)
case 0x2028:// Line Separator (LS)
case 0x2029:// Paragraph Separator (PS)
return"w"/* PathCharTypes.WORKSPACE */;}return"i"/* PathCharTypes.IDENT */;}/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */function formatSubPath(path){var trimmed=path.trim();// invalid leading 0
if(path.charAt(0)==='0'&&isNaN(parseInt(path))){return false;}return isLiteral(trimmed)?stripQuotes(trimmed):"*"/* PathCharTypes.ASTARISK */+trimmed;}/**
 * Parse a string path into an array of segments
 */function parse(path){var keys=[];var index=-1;var mode=0/* States.BEFORE_PATH */;var subPathDepth=0;var c;var key;// eslint-disable-line
var newChar;var type;var transition;var action;var typeMap;var actions=[];actions[0/* Actions.APPEND */]=function(){if(key===undefined){key=newChar;}else{key+=newChar;}};actions[1/* Actions.PUSH */]=function(){if(key!==undefined){keys.push(key);key=undefined;}};actions[2/* Actions.INC_SUB_PATH_DEPTH */]=function(){actions[0/* Actions.APPEND */]();subPathDepth++;};actions[3/* Actions.PUSH_SUB_PATH */]=function(){if(subPathDepth>0){subPathDepth--;mode=4/* States.IN_SUB_PATH */;actions[0/* Actions.APPEND */]();}else{subPathDepth=0;if(key===undefined){return false;}key=formatSubPath(key);if(key===false){return false;}else{actions[1/* Actions.PUSH */]();}}};function maybeUnescapeQuote(){var nextChar=path[index+1];if(mode===5/* States.IN_SINGLE_QUOTE */&&nextChar==="'"/* PathCharTypes.SINGLE_QUOTE */||mode===6/* States.IN_DOUBLE_QUOTE */&&nextChar==="\""/* PathCharTypes.DOUBLE_QUOTE */){index++;newChar='\\'+nextChar;actions[0/* Actions.APPEND */]();return true;}}while(mode!==null){index++;c=path[index];if(c==='\\'&&maybeUnescapeQuote()){continue;}type=getPathCharType(c);typeMap=pathStateMachine[mode];transition=typeMap[type]||typeMap["l"/* PathCharTypes.ELSE */]||8/* States.ERROR */;// check parse error
if(transition===8/* States.ERROR */){return;}mode=transition[0];if(transition[1]!==undefined){action=actions[transition[1]];if(action){newChar=c;if(action()===false){return;}}}// check parse finish
if(mode===7/* States.AFTER_PATH */){return keys;}}}// path token cache
var cache=new Map();/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */function resolveWithKeyValue(obj,path){return shared_isObject(obj)?obj[path]:null;}/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */function resolveValue(obj,path){// check object
if(!shared_isObject(obj)){return null;}// parse path
var hit=cache.get(path);if(!hit){hit=parse(path);if(hit){cache.set(path,hit);}}// check hit
if(!hit){return null;}// resolve path value
var len=hit.length;var last=obj;var i=0;while(i<len){var val=last[hit[i]];if(val===undefined){return null;}if(shared_isFunction(last)){return null;}last=val;i++;}return last;}var DEFAULT_MODIFIER=function DEFAULT_MODIFIER(str){return str;};var DEFAULT_MESSAGE=function DEFAULT_MESSAGE(ctx){return'';};// eslint-disable-line
var DEFAULT_MESSAGE_DATA_TYPE='text';var DEFAULT_NORMALIZE=function DEFAULT_NORMALIZE(values){return values.length===0?'':join(values);};var DEFAULT_INTERPOLATE=toDisplayString;function pluralDefault(choice,choicesLength){choice=Math.abs(choice);if(choicesLength===2){// prettier-ignore
return choice?choice>1?1:0:1;}return choice?Math.min(choice,2):0;}function getPluralIndex(options){// prettier-ignore
var index=shared_isNumber(options.pluralIndex)?options.pluralIndex:-1;// prettier-ignore
return options.named&&(shared_isNumber(options.named.count)||shared_isNumber(options.named.n))?shared_isNumber(options.named.count)?options.named.count:shared_isNumber(options.named.n)?options.named.n:index:index;}function normalizeNamed(pluralIndex,props){if(!props.count){props.count=pluralIndex;}if(!props.n){props.n=pluralIndex;}}function createMessageContext(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var locale=options.locale;var pluralIndex=getPluralIndex(options);var pluralRule=shared_isObject(options.pluralRules)&&shared_isString(locale)&&shared_isFunction(options.pluralRules[locale])?options.pluralRules[locale]:pluralDefault;var orgPluralRule=shared_isObject(options.pluralRules)&&shared_isString(locale)&&shared_isFunction(options.pluralRules[locale])?pluralDefault:undefined;var plural=function plural(messages){return messages[pluralRule(pluralIndex,messages.length,orgPluralRule)];};var _list=options.list||[];var list=function list(index){return _list[index];};// eslint-disable-next-line @typescript-eslint/no-explicit-any
var _named=options.named||{};shared_isNumber(options.pluralIndex)&&normalizeNamed(pluralIndex,_named);var named=function named(key){return _named[key];};function message(key){// prettier-ignore
var msg=shared_isFunction(options.messages)?options.messages(key):shared_isObject(options.messages)?options.messages[key]:false;return!msg?options.parent?options.parent.message(key)// resolve from parent messages
:DEFAULT_MESSAGE:msg;}var _modifier=function _modifier(name){return options.modifiers?options.modifiers[name]:DEFAULT_MODIFIER;};var normalize=shared_isPlainObject(options.processor)&&shared_isFunction(options.processor.normalize)?options.processor.normalize:DEFAULT_NORMALIZE;var interpolate=shared_isPlainObject(options.processor)&&shared_isFunction(options.processor.interpolate)?options.processor.interpolate:DEFAULT_INTERPOLATE;var type=shared_isPlainObject(options.processor)&&shared_isString(options.processor.type)?options.processor.type:DEFAULT_MESSAGE_DATA_TYPE;var linked=function linked(key){for(var _len7=arguments.length,args=new Array(_len7>1?_len7-1:0),_key7=1;_key7<_len7;_key7++){args[_key7-1]=arguments[_key7];}var arg1=args[0],arg2=args[1];var type='text';var modifier='';if(args.length===1){if(shared_isObject(arg1)){modifier=arg1.modifier||modifier;type=arg1.type||type;}else if(shared_isString(arg1)){modifier=arg1||modifier;}}else if(args.length===2){if(shared_isString(arg1)){modifier=arg1||modifier;}if(shared_isString(arg2)){type=arg2||type;}}var ret=message(key)(ctx);var msg=// The message in vnode resolved with linked are returned as an array by processor.nomalize
type==='vnode'&&shared_isArray(ret)&&modifier?ret[0]:ret;return modifier?_modifier(modifier)(msg,type):msg;};var ctx=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"list"/* HelperNameMap.LIST */,list),"named"/* HelperNameMap.NAMED */,named),"plural"/* HelperNameMap.PLURAL */,plural),"linked"/* HelperNameMap.LINKED */,linked),"message"/* HelperNameMap.MESSAGE */,message),"type"/* HelperNameMap.TYPE */,type),"interpolate"/* HelperNameMap.INTERPOLATE */,interpolate),"normalize"/* HelperNameMap.NORMALIZE */,normalize),"values"/* HelperNameMap.VALUES */,shared_assign({},_list,_named));return ctx;}var devtools=null;function setDevToolsHook(hook){devtools=hook;}function getDevToolsHook(){return devtools;}function initI18nDevTools(i18n,version,meta){// TODO: queue if devtools is undefined
devtools&&devtools.emit("i18n:init"/* IntlifyDevToolsHooks.I18nInit */,{timestamp:Date.now(),i18n:i18n,version:version,meta:meta});}var translateDevTools=/* #__PURE__*/createDevToolsHook("function:translate"/* IntlifyDevToolsHooks.FunctionTranslate */);function createDevToolsHook(hook){return function(payloads){return devtools&&devtools.emit(hook,payloads);};}var code$1=message_compiler_esm_browser_CompileWarnCodes.__EXTEND_POINT__;var inc$1=incrementer(code$1);var CoreWarnCodes={NOT_FOUND_KEY:code$1,// 2
FALLBACK_TO_TRANSLATE:inc$1(),// 3
CANNOT_FORMAT_NUMBER:inc$1(),// 4
FALLBACK_TO_NUMBER_FORMAT:inc$1(),// 5
CANNOT_FORMAT_DATE:inc$1(),// 6
FALLBACK_TO_DATE_FORMAT:inc$1(),// 7
EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER:inc$1(),// 8
__EXTEND_POINT__:inc$1()// 9
};/** @internal */var core_base_warnMessages=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},CoreWarnCodes.NOT_FOUND_KEY,"Not found '{key}' key in '{locale}' locale messages."),CoreWarnCodes.FALLBACK_TO_TRANSLATE,"Fall back to translate '{key}' key with '{target}' locale."),CoreWarnCodes.CANNOT_FORMAT_NUMBER,"Cannot format a number value due to not supported Intl.NumberFormat."),CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT,"Fall back to number format '{key}' key with '{target}' locale."),CoreWarnCodes.CANNOT_FORMAT_DATE,"Cannot format a date value due to not supported Intl.DateTimeFormat."),CoreWarnCodes.FALLBACK_TO_DATE_FORMAT,"Fall back to datetime format '{key}' key with '{target}' locale."),CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER,"This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.");function getWarnMessage(code){for(var _len8=arguments.length,args=new Array(_len8>1?_len8-1:0),_key8=1;_key8<_len8;_key8++){args[_key8-1]=arguments[_key8];}return format$1.apply(void 0,[core_base_warnMessages[code]].concat(args));}var code=CompileErrorCodes.__EXTEND_POINT__;var inc=incrementer(code);var CoreErrorCodes={INVALID_ARGUMENT:code,// 17
INVALID_DATE_ARGUMENT:inc(),// 18
INVALID_ISO_DATE_ARGUMENT:inc(),// 19
NOT_SUPPORT_NON_STRING_MESSAGE:inc(),// 20
NOT_SUPPORT_LOCALE_PROMISE_VALUE:inc(),// 21
NOT_SUPPORT_LOCALE_ASYNC_FUNCTION:inc(),// 22
NOT_SUPPORT_LOCALE_TYPE:inc(),// 23
__EXTEND_POINT__:inc()// 24
};function createCoreError(code){return createCompileError(code,null, false?0:undefined);}/** @internal */var core_base_errorMessages=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},CoreErrorCodes.INVALID_ARGUMENT,'Invalid arguments'),CoreErrorCodes.INVALID_DATE_ARGUMENT,'The date provided is an invalid Date object.'+'Make sure your Date represents a valid date.'),CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT,'The argument provided is not a valid ISO date string'),CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE,'Not support non-string message'),CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE,'cannot support promise value'),CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION,'cannot support async function'),CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE,'cannot support locale type');/** @internal */function getLocale(context,options){return options.locale!=null?resolveLocale(options.locale):resolveLocale(context.locale);}var _resolveLocale;/** @internal */function resolveLocale(locale){if(shared_isString(locale)){return locale;}else{if(shared_isFunction(locale)){if(locale.resolvedOnce&&_resolveLocale!=null){return _resolveLocale;}else if(locale.constructor.name==='Function'){var resolve=locale();if(isPromise(resolve)){throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE);}return _resolveLocale=resolve;}else{throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);}}else{throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE);}}}/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */function fallbackWithSimple(ctx,fallback,start// eslint-disable-line @typescript-eslint/no-unused-vars
){// prettier-ignore
return _toConsumableArray(new Set([start].concat(_toConsumableArray(shared_isArray(fallback)?fallback:shared_isObject(fallback)?Object.keys(fallback):shared_isString(fallback)?[fallback]:[start]))));}/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */function fallbackWithLocaleChain(ctx,fallback,start){var startLocale=shared_isString(start)?start:core_base_DEFAULT_LOCALE;var context=ctx;if(!context.__localeChainCache){context.__localeChainCache=new Map();}var chain=context.__localeChainCache.get(startLocale);if(!chain){chain=[];// first block defined by start
var block=[start];// while any intervening block found
while(shared_isArray(block)){block=appendBlockToChain(chain,block,fallback);}// prettier-ignore
// last block defined by default
var defaults=shared_isArray(fallback)||!shared_isPlainObject(fallback)?fallback:fallback['default']?fallback['default']:null;// convert defaults to array
block=shared_isString(defaults)?[defaults]:defaults;if(shared_isArray(block)){appendBlockToChain(chain,block,false);}context.__localeChainCache.set(startLocale,chain);}return chain;}function appendBlockToChain(chain,block,blocks){var follow=true;for(var i=0;i<block.length&&shared_isBoolean(follow);i++){var locale=block[i];if(shared_isString(locale)){follow=appendLocaleToChain(chain,block[i],blocks);}}return follow;}function appendLocaleToChain(chain,locale,blocks){var follow;var tokens=locale.split('-');do{var target=tokens.join('-');follow=appendItemToChain(chain,target,blocks);tokens.splice(-1,1);}while(tokens.length&&follow===true);return follow;}function appendItemToChain(chain,target,blocks){var follow=false;if(!chain.includes(target)){follow=true;if(target){follow=target[target.length-1]!=='!';var locale=target.replace(/!/g,'');chain.push(locale);if((shared_isArray(blocks)||shared_isPlainObject(blocks))&&blocks[locale]// eslint-disable-line @typescript-eslint/no-explicit-any
){// eslint-disable-next-line @typescript-eslint/no-explicit-any
follow=blocks[locale];}}}return follow;}/* eslint-disable @typescript-eslint/no-explicit-any *//**
 * Intlify core-base version
 * @internal
 */var VERSION='9.14.1';var NOT_REOSLVED=-1;var core_base_DEFAULT_LOCALE='en-US';var MISSING_RESOLVE_VALUE='';var _capitalize=function capitalize(str){return"".concat(str.charAt(0).toLocaleUpperCase()).concat(str.substr(1));};function getDefaultLinkedModifiers(){return{upper:function upper(val,type){// prettier-ignore
return type==='text'&&shared_isString(val)?val.toUpperCase():type==='vnode'&&shared_isObject(val)&&'__v_isVNode'in val?val.children.toUpperCase():val;},lower:function lower(val,type){// prettier-ignore
return type==='text'&&shared_isString(val)?val.toLowerCase():type==='vnode'&&shared_isObject(val)&&'__v_isVNode'in val?val.children.toLowerCase():val;},capitalize:function capitalize(val,type){// prettier-ignore
return type==='text'&&shared_isString(val)?_capitalize(val):type==='vnode'&&shared_isObject(val)&&'__v_isVNode'in val?_capitalize(val.children):val;}};}var _compiler;function registerMessageCompiler(compiler){_compiler=compiler;}var _resolver;/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */function registerMessageResolver(resolver){_resolver=resolver;}var _fallbacker;/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */function registerLocaleFallbacker(fallbacker){_fallbacker=fallbacker;}// Additional Meta for Intlify DevTools
var _additionalMeta=null;/* #__NO_SIDE_EFFECTS__ */var setAdditionalMeta=function setAdditionalMeta(meta){_additionalMeta=meta;};/* #__NO_SIDE_EFFECTS__ */var getAdditionalMeta=function getAdditionalMeta(){return _additionalMeta;};var _fallbackContext=null;var setFallbackContext=function setFallbackContext(context){_fallbackContext=context;};var getFallbackContext=function getFallbackContext(){return _fallbackContext;};// ID for CoreContext
var _cid=0;function createCoreContext(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};// setup options
var onWarn=shared_isFunction(options.onWarn)?options.onWarn:shared_warn;var version=shared_isString(options.version)?options.version:VERSION;var locale=shared_isString(options.locale)||shared_isFunction(options.locale)?options.locale:core_base_DEFAULT_LOCALE;var _locale=shared_isFunction(locale)?core_base_DEFAULT_LOCALE:locale;var fallbackLocale=shared_isArray(options.fallbackLocale)||shared_isPlainObject(options.fallbackLocale)||shared_isString(options.fallbackLocale)||options.fallbackLocale===false?options.fallbackLocale:_locale;var messages=shared_isPlainObject(options.messages)?options.messages:_defineProperty2({},_locale,{});var datetimeFormats=shared_isPlainObject(options.datetimeFormats)?options.datetimeFormats:_defineProperty2({},_locale,{});var numberFormats=shared_isPlainObject(options.numberFormats)?options.numberFormats:_defineProperty2({},_locale,{});var modifiers=shared_assign({},options.modifiers||{},getDefaultLinkedModifiers());var pluralRules=options.pluralRules||{};var missing=shared_isFunction(options.missing)?options.missing:null;var missingWarn=shared_isBoolean(options.missingWarn)||shared_isRegExp(options.missingWarn)?options.missingWarn:true;var fallbackWarn=shared_isBoolean(options.fallbackWarn)||shared_isRegExp(options.fallbackWarn)?options.fallbackWarn:true;var fallbackFormat=!!options.fallbackFormat;var unresolving=!!options.unresolving;var postTranslation=shared_isFunction(options.postTranslation)?options.postTranslation:null;var processor=shared_isPlainObject(options.processor)?options.processor:null;var warnHtmlMessage=shared_isBoolean(options.warnHtmlMessage)?options.warnHtmlMessage:true;var escapeParameter=!!options.escapeParameter;var messageCompiler=shared_isFunction(options.messageCompiler)?options.messageCompiler:_compiler;if(false){}var messageResolver=shared_isFunction(options.messageResolver)?options.messageResolver:_resolver||resolveWithKeyValue;var localeFallbacker=shared_isFunction(options.localeFallbacker)?options.localeFallbacker:_fallbacker||fallbackWithSimple;var fallbackContext=shared_isObject(options.fallbackContext)?options.fallbackContext:undefined;// setup internal options
var internalOptions=options;var __datetimeFormatters=shared_isObject(internalOptions.__datetimeFormatters)?internalOptions.__datetimeFormatters:new Map();var __numberFormatters=shared_isObject(internalOptions.__numberFormatters)?internalOptions.__numberFormatters:new Map();var __meta=shared_isObject(internalOptions.__meta)?internalOptions.__meta:{};_cid++;var context={version:version,cid:_cid,locale:locale,fallbackLocale:fallbackLocale,messages:messages,modifiers:modifiers,pluralRules:pluralRules,missing:missing,missingWarn:missingWarn,fallbackWarn:fallbackWarn,fallbackFormat:fallbackFormat,unresolving:unresolving,postTranslation:postTranslation,processor:processor,warnHtmlMessage:warnHtmlMessage,escapeParameter:escapeParameter,messageCompiler:messageCompiler,messageResolver:messageResolver,localeFallbacker:localeFallbacker,fallbackContext:fallbackContext,onWarn:onWarn,__meta:__meta};{context.datetimeFormats=datetimeFormats;context.numberFormats=numberFormats;context.__datetimeFormatters=__datetimeFormatters;context.__numberFormatters=__numberFormatters;}// for vue-devtools timeline event
if(false){}// NOTE: experimental !!
if( false||__INTLIFY_PROD_DEVTOOLS__){initI18nDevTools(context,version,__meta);}return context;}/** @internal */function isTranslateFallbackWarn(fallback,key){return fallback instanceof RegExp?fallback.test(key):fallback;}/** @internal */function isTranslateMissingWarn(missing,key){return missing instanceof RegExp?missing.test(key):missing;}/** @internal */function handleMissing(context,key,locale,missingWarn,type){var missing=context.missing,onWarn=context.onWarn;// for vue-devtools timeline event
if(false){}if(missing!==null){var ret=missing(context,locale,key,type);return shared_isString(ret)?ret:key;}else{if(false){}return key;}}/** @internal */function updateFallbackLocale(ctx,locale,fallback){var context=ctx;context.__localeChainCache=new Map();ctx.localeFallbacker(ctx,fallback,locale);}/** @internal */function isAlmostSameLocale(locale,compareLocale){if(locale===compareLocale)return false;return locale.split('-')[0]===compareLocale.split('-')[0];}/** @internal */function isImplicitFallback(targetLocale,locales){var index=locales.indexOf(targetLocale);if(index===-1){return false;}for(var i=index+1;i<locales.length;i++){if(isAlmostSameLocale(targetLocale,locales[i])){return true;}}return false;}/* eslint-enable @typescript-eslint/no-explicit-any */function core_base_format(ast){var msg=function msg(ctx){return formatParts(ctx,ast);};return msg;}function formatParts(ctx,ast){var body=ast.b||ast.body;if((body.t||body.type)===1/* NodeTypes.Plural */){var plural=body;var cases=plural.c||plural.cases;return ctx.plural(cases.reduce(function(messages,c){return[].concat(_toConsumableArray(messages),[formatMessageParts(ctx,c)]);},[]));}else{return formatMessageParts(ctx,body);}}function formatMessageParts(ctx,node){var _static=node.s||node.static;if(_static){return ctx.type==='text'?_static:ctx.normalize([_static]);}else{var messages=(node.i||node.items).reduce(function(acm,c){return[].concat(_toConsumableArray(acm),[formatMessagePart(ctx,c)]);},[]);return ctx.normalize(messages);}}function formatMessagePart(ctx,node){var type=node.t||node.type;switch(type){case 3/* NodeTypes.Text */:{var text=node;return text.v||text.value;}case 9/* NodeTypes.Literal */:{var literal=node;return literal.v||literal.value;}case 4/* NodeTypes.Named */:{var named=node;return ctx.interpolate(ctx.named(named.k||named.key));}case 5/* NodeTypes.List */:{var list=node;return ctx.interpolate(ctx.list(list.i!=null?list.i:list.index));}case 6/* NodeTypes.Linked */:{var linked=node;var modifier=linked.m||linked.modifier;return ctx.linked(formatMessagePart(ctx,linked.k||linked.key),modifier?formatMessagePart(ctx,modifier):undefined,ctx.type);}case 7/* NodeTypes.LinkedKey */:{var linkedKey=node;return linkedKey.v||linkedKey.value;}case 8/* NodeTypes.LinkedModifier */:{var linkedModifier=node;return linkedModifier.v||linkedModifier.value;}default:throw new Error("unhandled node type on format message part: ".concat(type));}}var WARN_MESSAGE=/* unused pure expression or super */null&&0;function checkHtmlMessage(source,warnHtmlMessage){if(warnHtmlMessage&&detectHtmlTag(source)){warn(format$1(WARN_MESSAGE,{source:source}));}}var defaultOnCacheKey=function defaultOnCacheKey(message){return message;};var compileCache=Object.create(null);function onCompileWarn(_warn){if(_warn.code===CompileWarnCodes.USE_MODULO_SYNTAX){warn("The use of named interpolation with modulo syntax is deprecated. "+"It will be removed in v10.\n"+"reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format \n"+"(message compiler warning message: ".concat(_warn.message,")"));}}function clearCompileCache(){compileCache=Object.create(null);}var core_base_isMessageAST=function core_base_isMessageAST(val){return shared_isObject(val)&&(val.t===0||val.type===0)&&('b'in val||'body'in val);};function core_base_baseCompile(message){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// error detecting on compile
var detectError=false;var onError=options.onError||defaultOnError;options.onError=function(err){detectError=true;onError(err);};// compile with mesasge-compiler
return _objectSpread(_objectSpread({},baseCompile(message,options)),{},{detectError:detectError});}/* #__NO_SIDE_EFFECTS__ */var compileToFunction=function compileToFunction(message,context){if(!shared_isString(message)){throw createCoreError(CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE);}// set onWarn
if(false){}{// check HTML message
var warnHtmlMessage=shared_isBoolean(context.warnHtmlMessage)?context.warnHtmlMessage:true; false&&0;// check caches
var onCacheKey=context.onCacheKey||defaultOnCacheKey;var cacheKey=onCacheKey(message);var cached=compileCache[cacheKey];if(cached){return cached;}// compile
var _core_base_baseCompil=core_base_baseCompile(message,context),_code=_core_base_baseCompil.code,detectError=_core_base_baseCompil.detectError;// evaluate function
var msg=new Function("return ".concat(_code))();// if occurred compile error, don't cache
return!detectError?compileCache[cacheKey]=msg:msg;}};function compile(message,context){// set onWarn
if(false){}if(__INTLIFY_JIT_COMPILATION__&&!__INTLIFY_DROP_MESSAGE_COMPILER__&&shared_isString(message)){// check HTML message
var warnHtmlMessage=shared_isBoolean(context.warnHtmlMessage)?context.warnHtmlMessage:true; false&&0;// check caches
var onCacheKey=context.onCacheKey||defaultOnCacheKey;var cacheKey=onCacheKey(message);var cached=compileCache[cacheKey];if(cached){return cached;}// compile with JIT mode
var _core_base_baseCompil2=core_base_baseCompile(message,_objectSpread(_objectSpread({},context),{},{location:"production"!=='production',jit:true})),ast=_core_base_baseCompil2.ast,detectError=_core_base_baseCompil2.detectError;// compose message function from AST
var msg=core_base_format(ast);// if occurred compile error, don't cache
return!detectError?compileCache[cacheKey]=msg:msg;}else{if(false){}// AST case (passed from bundler)
var _cacheKey=message.cacheKey;if(_cacheKey){var _cached=compileCache[_cacheKey];if(_cached){return _cached;}// compose message function from message (AST)
return compileCache[_cacheKey]=core_base_format(message);}else{return core_base_format(message);}}}var NOOP_MESSAGE_FUNCTION=function NOOP_MESSAGE_FUNCTION(){return'';};var isMessageFunction=function isMessageFunction(val){return shared_isFunction(val);};// implementation of `translate` function
function translate(context){var fallbackFormat=context.fallbackFormat,postTranslation=context.postTranslation,unresolving=context.unresolving,messageCompiler=context.messageCompiler,fallbackLocale=context.fallbackLocale,messages=context.messages;for(var _len9=arguments.length,args=new Array(_len9>1?_len9-1:0),_key9=1;_key9<_len9;_key9++){args[_key9-1]=arguments[_key9];}var _parseTranslateArgs=parseTranslateArgs.apply(void 0,args),_parseTranslateArgs2=_slicedToArray(_parseTranslateArgs,2),key=_parseTranslateArgs2[0],options=_parseTranslateArgs2[1];var missingWarn=shared_isBoolean(options.missingWarn)?options.missingWarn:context.missingWarn;var fallbackWarn=shared_isBoolean(options.fallbackWarn)?options.fallbackWarn:context.fallbackWarn;var escapeParameter=shared_isBoolean(options.escapeParameter)?options.escapeParameter:context.escapeParameter;var resolvedMessage=!!options.resolvedMessage;// prettier-ignore
var defaultMsgOrKey=shared_isString(options.default)||shared_isBoolean(options.default)// default by function option
?!shared_isBoolean(options.default)?options.default:!messageCompiler?function(){return key;}:key:fallbackFormat// default by `fallbackFormat` option
?!messageCompiler?function(){return key;}:key:'';var enableDefaultMsg=fallbackFormat||defaultMsgOrKey!=='';var locale=getLocale(context,options);// escape params
escapeParameter&&escapeParams(options);// resolve message format
// eslint-disable-next-line prefer-const
var _ref5=!resolvedMessage?resolveMessageFormat(context,key,locale,fallbackLocale,fallbackWarn,missingWarn):[key,locale,messages[locale]||{}],_ref6=_slicedToArray(_ref5,3),formatScope=_ref6[0],targetLocale=_ref6[1],message=_ref6[2];// NOTE:
//  Fix to work around `ssrTransfrom` bug in Vite.
//  https://github.com/vitejs/vite/issues/4306
//  To get around this, use temporary variables.
//  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
var format=formatScope;// if you use default message, set it as message format!
var cacheBaseKey=key;if(!resolvedMessage&&!(shared_isString(format)||core_base_isMessageAST(format)||isMessageFunction(format))){if(enableDefaultMsg){format=defaultMsgOrKey;cacheBaseKey=format;}}// checking message format and target locale
if(!resolvedMessage&&(!(shared_isString(format)||core_base_isMessageAST(format)||isMessageFunction(format))||!shared_isString(targetLocale))){return unresolving?NOT_REOSLVED:key;}// TODO: refactor
if(false){}// setup compile error detecting
var occurred=false;var onError=function onError(){occurred=true;};// compile message format
var msg=!isMessageFunction(format)?compileMessageFormat(context,key,targetLocale,format,cacheBaseKey,onError):format;// if occurred compile error, return the message format
if(occurred){return format;}// evaluate message with context
var ctxOptions=getMessageContextOptions(context,targetLocale,message,options);var msgContext=createMessageContext(ctxOptions);var messaged=evaluateMessage(context,msg,msgContext);// if use post translation option, proceed it with handler
var ret=postTranslation?postTranslation(messaged,key):messaged;// NOTE: experimental !!
if( false||__INTLIFY_PROD_DEVTOOLS__){// prettier-ignore
var payloads={timestamp:Date.now(),key:shared_isString(key)?key:isMessageFunction(format)?format.key:'',locale:targetLocale||(isMessageFunction(format)?format.locale:''),format:shared_isString(format)?format:isMessageFunction(format)?format.source:'',message:ret};payloads.meta=shared_assign({},context.__meta,getAdditionalMeta()||{});translateDevTools(payloads);}return ret;}function escapeParams(options){if(shared_isArray(options.list)){options.list=options.list.map(function(item){return shared_isString(item)?escapeHtml(item):item;});}else if(shared_isObject(options.named)){Object.keys(options.named).forEach(function(key){if(shared_isString(options.named[key])){options.named[key]=escapeHtml(options.named[key]);}});}}function resolveMessageFormat(context,key,locale,fallbackLocale,fallbackWarn,missingWarn){var messages=context.messages,onWarn=context.onWarn,resolveValue=context.messageResolver,localeFallbacker=context.localeFallbacker;var locales=localeFallbacker(context,fallbackLocale,locale);// eslint-disable-line @typescript-eslint/no-explicit-any
var message={};var targetLocale;var format=null;var from=locale;var to=null;var type='translate';for(var i=0;i<locales.length;i++){targetLocale=to=locales[i];if(false){}// for vue-devtools timeline event
if(false){}message=messages[targetLocale]||{};// for vue-devtools timeline event
var start=null;var startTag=void 0;var endTag=void 0;if(false){}if((format=resolveValue(message,key))===null){// if null, resolve with object key path
format=message[key];// eslint-disable-line @typescript-eslint/no-explicit-any
}// for vue-devtools timeline event
if(false){}if(shared_isString(format)||core_base_isMessageAST(format)||isMessageFunction(format)){break;}if(!isImplicitFallback(targetLocale,locales)){var missingRet=handleMissing(context,// eslint-disable-line @typescript-eslint/no-explicit-any
key,targetLocale,missingWarn,type);if(missingRet!==key){format=missingRet;}}from=to;}return[format,targetLocale,message];}function compileMessageFormat(context,key,targetLocale,format,cacheBaseKey,onError){var messageCompiler=context.messageCompiler,warnHtmlMessage=context.warnHtmlMessage;if(isMessageFunction(format)){var _msg=format;_msg.locale=_msg.locale||targetLocale;_msg.key=_msg.key||key;return _msg;}if(messageCompiler==null){var _msg2=function _msg2(){return format;};_msg2.locale=targetLocale;_msg2.key=key;return _msg2;}// for vue-devtools timeline event
var start=null;var startTag;var endTag;if(false){}var msg=messageCompiler(format,getCompileContext(context,targetLocale,cacheBaseKey,format,warnHtmlMessage,onError));// for vue-devtools timeline event
if(false){}msg.locale=targetLocale;msg.key=key;msg.source=format;return msg;}function evaluateMessage(context,msg,msgCtx){// for vue-devtools timeline event
var start=null;var startTag;var endTag;if(false){}var messaged=msg(msgCtx);// for vue-devtools timeline event
if(false){}return messaged;}/** @internal */function parseTranslateArgs(){for(var _len10=arguments.length,args=new Array(_len10),_key10=0;_key10<_len10;_key10++){args[_key10]=arguments[_key10];}var arg1=args[0],arg2=args[1],arg3=args[2];var options={};if(!shared_isString(arg1)&&!shared_isNumber(arg1)&&!isMessageFunction(arg1)&&!core_base_isMessageAST(arg1)){throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);}// prettier-ignore
var key=shared_isNumber(arg1)?String(arg1):isMessageFunction(arg1)?arg1:arg1;if(shared_isNumber(arg2)){options.plural=arg2;}else if(shared_isString(arg2)){options.default=arg2;}else if(shared_isPlainObject(arg2)&&!isEmptyObject(arg2)){options.named=arg2;}else if(shared_isArray(arg2)){options.list=arg2;}if(shared_isNumber(arg3)){options.plural=arg3;}else if(shared_isString(arg3)){options.default=arg3;}else if(shared_isPlainObject(arg3)){shared_assign(options,arg3);}return[key,options];}function getCompileContext(context,locale,key,source,warnHtmlMessage,_onError){return{locale:locale,key:key,warnHtmlMessage:warnHtmlMessage,onError:function onError(err){_onError&&_onError(err);if(false){}else{throw err;}},onCacheKey:function onCacheKey(source){return generateFormatCacheKey(locale,key,source);}};}function getSourceForCodeFrame(source){if(isString(source)){return source;}else{if(source.loc&&source.loc.source){return source.loc.source;}}}function getMessageContextOptions(context,locale,message,options){var modifiers=context.modifiers,pluralRules=context.pluralRules,resolveValue=context.messageResolver,fallbackLocale=context.fallbackLocale,fallbackWarn=context.fallbackWarn,missingWarn=context.missingWarn,fallbackContext=context.fallbackContext;var resolveMessage=function resolveMessage(key){var val=resolveValue(message,key);// fallback to root context
if(val==null&&fallbackContext){var _resolveMessageFormat=resolveMessageFormat(fallbackContext,key,locale,fallbackLocale,fallbackWarn,missingWarn),_resolveMessageFormat2=_slicedToArray(_resolveMessageFormat,3),_message2=_resolveMessageFormat2[2];val=resolveValue(_message2,key);}if(shared_isString(val)||core_base_isMessageAST(val)){var occurred=false;var onError=function onError(){occurred=true;};var msg=compileMessageFormat(context,key,locale,val,key,onError);return!occurred?msg:NOOP_MESSAGE_FUNCTION;}else if(isMessageFunction(val)){return val;}else{// TODO: should be implemented warning message
return NOOP_MESSAGE_FUNCTION;}};var ctxOptions={locale:locale,modifiers:modifiers,pluralRules:pluralRules,messages:resolveMessage};if(context.processor){ctxOptions.processor=context.processor;}if(options.list){ctxOptions.list=options.list;}if(options.named){ctxOptions.named=options.named;}if(shared_isNumber(options.plural)){ctxOptions.pluralIndex=options.plural;}return ctxOptions;}var intlDefined=typeof Intl!=='undefined';var Availabilities={dateTimeFormat:intlDefined&&typeof Intl.DateTimeFormat!=='undefined',numberFormat:intlDefined&&typeof Intl.NumberFormat!=='undefined'};// implementation of `datetime` function
function datetime(context){var datetimeFormats=context.datetimeFormats,unresolving=context.unresolving,fallbackLocale=context.fallbackLocale,onWarn=context.onWarn,localeFallbacker=context.localeFallbacker;var __datetimeFormatters=context.__datetimeFormatters;if(false){}for(var _len11=arguments.length,args=new Array(_len11>1?_len11-1:0),_key11=1;_key11<_len11;_key11++){args[_key11-1]=arguments[_key11];}var _parseDateTimeArgs=parseDateTimeArgs.apply(void 0,args),_parseDateTimeArgs2=_slicedToArray(_parseDateTimeArgs,4),key=_parseDateTimeArgs2[0],value=_parseDateTimeArgs2[1],options=_parseDateTimeArgs2[2],overrides=_parseDateTimeArgs2[3];var missingWarn=shared_isBoolean(options.missingWarn)?options.missingWarn:context.missingWarn;var fallbackWarn=shared_isBoolean(options.fallbackWarn)?options.fallbackWarn:context.fallbackWarn;var part=!!options.part;var locale=getLocale(context,options);var locales=localeFallbacker(context,// eslint-disable-line @typescript-eslint/no-explicit-any
fallbackLocale,locale);if(!shared_isString(key)||key===''){return new Intl.DateTimeFormat(locale,overrides).format(value);}// resolve format
var datetimeFormat={};var targetLocale;var format=null;var from=locale;var to=null;var type='datetime format';for(var i=0;i<locales.length;i++){targetLocale=to=locales[i];if(false){}// for vue-devtools timeline event
if(false){}datetimeFormat=datetimeFormats[targetLocale]||{};format=datetimeFormat[key];if(shared_isPlainObject(format))break;handleMissing(context,key,targetLocale,missingWarn,type);// eslint-disable-line @typescript-eslint/no-explicit-any
from=to;}// checking format and target locale
if(!shared_isPlainObject(format)||!shared_isString(targetLocale)){return unresolving?NOT_REOSLVED:key;}var id="".concat(targetLocale,"__").concat(key);if(!isEmptyObject(overrides)){id="".concat(id,"__").concat(JSON.stringify(overrides));}var formatter=__datetimeFormatters.get(id);if(!formatter){formatter=new Intl.DateTimeFormat(targetLocale,shared_assign({},format,overrides));__datetimeFormatters.set(id,formatter);}return!part?formatter.format(value):formatter.formatToParts(value);}/** @internal */var DATETIME_FORMAT_OPTIONS_KEYS=['localeMatcher','weekday','era','year','month','day','hour','minute','second','timeZoneName','formatMatcher','hour12','timeZone','dateStyle','timeStyle','calendar','dayPeriod','numberingSystem','hourCycle','fractionalSecondDigits'];/** @internal */function parseDateTimeArgs(){for(var _len12=arguments.length,args=new Array(_len12),_key12=0;_key12<_len12;_key12++){args[_key12]=arguments[_key12];}var arg1=args[0],arg2=args[1],arg3=args[2],arg4=args[3];var options={};var overrides={};var value;if(shared_isString(arg1)){// Only allow ISO strings - other date formats are often supported,
// but may cause different results in different browsers.
var matches=arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);if(!matches){throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);}// Some browsers can not parse the iso datetime separated by space,
// this is a compromise solution by replace the 'T'/' ' with 'T'
var dateTime=matches[3]?matches[3].trim().startsWith('T')?"".concat(matches[1].trim()).concat(matches[3].trim()):"".concat(matches[1].trim(),"T").concat(matches[3].trim()):matches[1].trim();value=new Date(dateTime);try{// This will fail if the date is not valid
value.toISOString();}catch(e){throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);}}else if(isDate(arg1)){if(isNaN(arg1.getTime())){throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);}value=arg1;}else if(shared_isNumber(arg1)){value=arg1;}else{throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);}if(shared_isString(arg2)){options.key=arg2;}else if(shared_isPlainObject(arg2)){Object.keys(arg2).forEach(function(key){if(DATETIME_FORMAT_OPTIONS_KEYS.includes(key)){overrides[key]=arg2[key];}else{options[key]=arg2[key];}});}if(shared_isString(arg3)){options.locale=arg3;}else if(shared_isPlainObject(arg3)){overrides=arg3;}if(shared_isPlainObject(arg4)){overrides=arg4;}return[options.key||'',value,options,overrides];}/** @internal */function clearDateTimeFormat(ctx,locale,format){var context=ctx;for(var key in format){var id="".concat(locale,"__").concat(key);if(!context.__datetimeFormatters.has(id)){continue;}context.__datetimeFormatters.delete(id);}}// implementation of `number` function
function number(context){var numberFormats=context.numberFormats,unresolving=context.unresolving,fallbackLocale=context.fallbackLocale,onWarn=context.onWarn,localeFallbacker=context.localeFallbacker;var __numberFormatters=context.__numberFormatters;if(false){}for(var _len13=arguments.length,args=new Array(_len13>1?_len13-1:0),_key13=1;_key13<_len13;_key13++){args[_key13-1]=arguments[_key13];}var _parseNumberArgs=parseNumberArgs.apply(void 0,args),_parseNumberArgs2=_slicedToArray(_parseNumberArgs,4),key=_parseNumberArgs2[0],value=_parseNumberArgs2[1],options=_parseNumberArgs2[2],overrides=_parseNumberArgs2[3];var missingWarn=shared_isBoolean(options.missingWarn)?options.missingWarn:context.missingWarn;var fallbackWarn=shared_isBoolean(options.fallbackWarn)?options.fallbackWarn:context.fallbackWarn;var part=!!options.part;var locale=getLocale(context,options);var locales=localeFallbacker(context,// eslint-disable-line @typescript-eslint/no-explicit-any
fallbackLocale,locale);if(!shared_isString(key)||key===''){return new Intl.NumberFormat(locale,overrides).format(value);}// resolve format
var numberFormat={};var targetLocale;var format=null;var from=locale;var to=null;var type='number format';for(var i=0;i<locales.length;i++){targetLocale=to=locales[i];if(false){}// for vue-devtools timeline event
if(false){}numberFormat=numberFormats[targetLocale]||{};format=numberFormat[key];if(shared_isPlainObject(format))break;handleMissing(context,key,targetLocale,missingWarn,type);// eslint-disable-line @typescript-eslint/no-explicit-any
from=to;}// checking format and target locale
if(!shared_isPlainObject(format)||!shared_isString(targetLocale)){return unresolving?NOT_REOSLVED:key;}var id="".concat(targetLocale,"__").concat(key);if(!isEmptyObject(overrides)){id="".concat(id,"__").concat(JSON.stringify(overrides));}var formatter=__numberFormatters.get(id);if(!formatter){formatter=new Intl.NumberFormat(targetLocale,shared_assign({},format,overrides));__numberFormatters.set(id,formatter);}return!part?formatter.format(value):formatter.formatToParts(value);}/** @internal */var NUMBER_FORMAT_OPTIONS_KEYS=['localeMatcher','style','currency','currencyDisplay','currencySign','useGrouping','minimumIntegerDigits','minimumFractionDigits','maximumFractionDigits','minimumSignificantDigits','maximumSignificantDigits','compactDisplay','notation','signDisplay','unit','unitDisplay','roundingMode','roundingPriority','roundingIncrement','trailingZeroDisplay'];/** @internal */function parseNumberArgs(){for(var _len14=arguments.length,args=new Array(_len14),_key14=0;_key14<_len14;_key14++){args[_key14]=arguments[_key14];}var arg1=args[0],arg2=args[1],arg3=args[2],arg4=args[3];var options={};var overrides={};if(!shared_isNumber(arg1)){throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);}var value=arg1;if(shared_isString(arg2)){options.key=arg2;}else if(shared_isPlainObject(arg2)){Object.keys(arg2).forEach(function(key){if(NUMBER_FORMAT_OPTIONS_KEYS.includes(key)){overrides[key]=arg2[key];}else{options[key]=arg2[key];}});}if(shared_isString(arg3)){options.locale=arg3;}else if(shared_isPlainObject(arg3)){overrides=arg3;}if(shared_isPlainObject(arg4)){overrides=arg4;}return[options.key||'',value,options,overrides];}/** @internal */function clearNumberFormat(ctx,locale,format){var context=ctx;for(var key in format){var id="".concat(locale,"__").concat(key);if(!context.__numberFormatters.has(id)){continue;}context.__numberFormatters.delete(id);}}{initFeatureFlags();};// ../../node_modules/vue-i18n/dist/vue-i18n.mjs
/*!
  * vue-i18n v9.14.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  *//**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */var vue_i18n_VERSION='9.14.1';/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */function vue_i18n_initFeatureFlags(){if(typeof __VUE_I18N_FULL_INSTALL__!=='boolean'){getGlobalThis().__VUE_I18N_FULL_INSTALL__=true;}if(typeof __VUE_I18N_LEGACY_API__!=='boolean'){getGlobalThis().__VUE_I18N_LEGACY_API__=true;}if(typeof __INTLIFY_JIT_COMPILATION__!=='boolean'){getGlobalThis().__INTLIFY_JIT_COMPILATION__=false;}if(typeof __INTLIFY_DROP_MESSAGE_COMPILER__!=='boolean'){getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__=false;}if(typeof __INTLIFY_PROD_DEVTOOLS__!=='boolean'){getGlobalThis().__INTLIFY_PROD_DEVTOOLS__=false;}}var vue_i18n_code$1=CoreWarnCodes.__EXTEND_POINT__;var vue_i18n_inc$1=incrementer(vue_i18n_code$1);var I18nWarnCodes={FALLBACK_TO_ROOT:vue_i18n_code$1,// 9
NOT_SUPPORTED_PRESERVE:vue_i18n_inc$1(),// 10
NOT_SUPPORTED_FORMATTER:vue_i18n_inc$1(),// 11
NOT_SUPPORTED_PRESERVE_DIRECTIVE:vue_i18n_inc$1(),// 12
NOT_SUPPORTED_GET_CHOICE_INDEX:vue_i18n_inc$1(),// 13
COMPONENT_NAME_LEGACY_COMPATIBLE:vue_i18n_inc$1(),// 14
NOT_FOUND_PARENT_SCOPE:vue_i18n_inc$1(),// 15
IGNORE_OBJ_FLATTEN:vue_i18n_inc$1(),// 16
NOTICE_DROP_ALLOW_COMPOSITION:vue_i18n_inc$1(),// 17
NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG:vue_i18n_inc$1()// 18
};var vue_i18n_warnMessages=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},I18nWarnCodes.FALLBACK_TO_ROOT,"Fall back to {type} '{key}' with root locale."),I18nWarnCodes.NOT_SUPPORTED_PRESERVE,"Not supported 'preserve'."),I18nWarnCodes.NOT_SUPPORTED_FORMATTER,"Not supported 'formatter'."),I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE,"Not supported 'preserveDirectiveContent'."),I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX,"Not supported 'getChoiceIndex'."),I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE,"Component name legacy compatible: '{name}' -> 'i18n'"),I18nWarnCodes.NOT_FOUND_PARENT_SCOPE,"Not found parent scope. use the global scope."),I18nWarnCodes.IGNORE_OBJ_FLATTEN,"Ignore object flatten: '{key}' key has an string value"),I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION,"'allowComposition' option will be dropped in the next major version. For more information, please see \uD83D\uDC49 https://tinyurl.com/2p97mcze"),I18nWarnCodes.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG,"'translateExistCompatible' option will be dropped in the next major version.");function vue_i18n_getWarnMessage(code){for(var _len15=arguments.length,args=new Array(_len15>1?_len15-1:0),_key15=1;_key15<_len15;_key15++){args[_key15-1]=arguments[_key15];}return format.apply(void 0,[vue_i18n_warnMessages[code]].concat(args));}var vue_i18n_code=CoreErrorCodes.__EXTEND_POINT__;var vue_i18n_inc=incrementer(vue_i18n_code);var I18nErrorCodes={// composer module errors
UNEXPECTED_RETURN_TYPE:vue_i18n_code,// 24
// legacy module errors
INVALID_ARGUMENT:vue_i18n_inc(),// 25
// i18n module errors
MUST_BE_CALL_SETUP_TOP:vue_i18n_inc(),// 26
NOT_INSTALLED:vue_i18n_inc(),// 27
NOT_AVAILABLE_IN_LEGACY_MODE:vue_i18n_inc(),// 28
// directive module errors
REQUIRED_VALUE:vue_i18n_inc(),// 29
INVALID_VALUE:vue_i18n_inc(),// 30
// vue-devtools errors
CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN:vue_i18n_inc(),// 31
NOT_INSTALLED_WITH_PROVIDE:vue_i18n_inc(),// 32
// unexpected error
UNEXPECTED_ERROR:vue_i18n_inc(),// 33
// not compatible legacy vue-i18n constructor
NOT_COMPATIBLE_LEGACY_VUE_I18N:vue_i18n_inc(),// 34
// bridge support vue 2.x only
BRIDGE_SUPPORT_VUE_2_ONLY:vue_i18n_inc(),// 35
// need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION:vue_i18n_inc(),// 36
// Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
NOT_AVAILABLE_COMPOSITION_IN_LEGACY:vue_i18n_inc(),// 37
// for enhancement
__EXTEND_POINT__:vue_i18n_inc()// 38
};function createI18nError(code){return createCompileError(code,null, false?0:undefined);}var vue_i18n_errorMessages=(_vue_i18n_errorMessag={},_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_vue_i18n_errorMessag,I18nErrorCodes.UNEXPECTED_RETURN_TYPE,'Unexpected return type in composer'),I18nErrorCodes.INVALID_ARGUMENT,'Invalid argument'),I18nErrorCodes.MUST_BE_CALL_SETUP_TOP,'Must be called at the top of a `setup` function'),I18nErrorCodes.NOT_INSTALLED,'Need to install with `app.use` function'),I18nErrorCodes.UNEXPECTED_ERROR,'Unexpected error'),I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE,'Not available in legacy mode'),I18nErrorCodes.REQUIRED_VALUE,"Required in value: {0}"),I18nErrorCodes.INVALID_VALUE,"Invalid value"),I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN,"Cannot setup vue-devtools plugin"),I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE,'Need to install with `provide` function'),_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_vue_i18n_errorMessag,I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N,'Not compatible legacy VueI18n.'),I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY,'vue-i18n-bridge support Vue 2.x only'),I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION,'Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode'),I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY,'Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly'));var TranslateVNodeSymbol=/* #__PURE__*/shared_makeSymbol('__translateVNode');var DatetimePartsSymbol=/* #__PURE__*/shared_makeSymbol('__datetimeParts');var NumberPartsSymbol=/* #__PURE__*/shared_makeSymbol('__numberParts');var EnableEmitter=/* #__PURE__*//* unused pure expression or super */null&&0;var DisableEmitter=/* #__PURE__*//* unused pure expression or super */null&&0;var SetPluralRulesSymbol=shared_makeSymbol('__setPluralRules');shared_makeSymbol('__intlifyMeta');var InejctWithOptionSymbol=/* #__PURE__*/shared_makeSymbol('__injectWithOption');var DisposeSymbol=/* #__PURE__*/shared_makeSymbol('__dispose');var __VUE_I18N_BRIDGE__='__VUE_I18N_BRIDGE__';/* eslint-disable @typescript-eslint/no-explicit-any *//**
 * Transform flat json in obj to normal json in obj
 */function handleFlatJson(obj){// check obj
if(!shared_isObject(obj)){return obj;}for(var key in obj){// check key
if(!hasOwn(obj,key)){continue;}// handle for normal json
if(!key.includes('.')){// recursive process value if value is also a object
if(shared_isObject(obj[key])){handleFlatJson(obj[key]);}}// handle for flat json, transform to normal json
else{// go to the last object
var subKeys=key.split('.');var lastIndex=subKeys.length-1;var currentObj=obj;var hasStringValue=false;for(var i=0;i<lastIndex;i++){if(!(subKeys[i]in currentObj)){currentObj[subKeys[i]]={};}if(!shared_isObject(currentObj[subKeys[i]])){ false&&0;hasStringValue=true;break;}currentObj=currentObj[subKeys[i]];}// update last object value, delete old property
if(!hasStringValue){currentObj[subKeys[lastIndex]]=obj[key];delete obj[key];}// recursive process value if value is also a object
if(shared_isObject(currentObj[subKeys[lastIndex]])){handleFlatJson(currentObj[subKeys[lastIndex]]);}}}return obj;}function getLocaleMessages(locale,options){var messages=options.messages,__i18n=options.__i18n,messageResolver=options.messageResolver,flatJson=options.flatJson;// prettier-ignore
var ret=shared_isPlainObject(messages)?messages:shared_isArray(__i18n)?{}:_defineProperty2({},locale,{});// merge locale messages of i18n custom block
if(shared_isArray(__i18n)){__i18n.forEach(function(custom){if('locale'in custom&&'resource'in custom){var _locale2=custom.locale,resource=custom.resource;if(_locale2){ret[_locale2]=ret[_locale2]||{};deepCopy(resource,ret[_locale2]);}else{deepCopy(resource,ret);}}else{shared_isString(custom)&&deepCopy(JSON.parse(custom),ret);}});}// handle messages for flat json
if(messageResolver==null&&flatJson){for(var key in ret){if(hasOwn(ret,key)){handleFlatJson(ret[key]);}}}return ret;}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getComponentOptions(instance){return instance.type;}function adjustI18nResources(gl,options,componentOptions// eslint-disable-line @typescript-eslint/no-explicit-any
){var messages=shared_isObject(options.messages)?options.messages:{};if('__i18nGlobal'in componentOptions){messages=getLocaleMessages(gl.locale.value,{messages:messages,__i18n:componentOptions.__i18nGlobal});}// merge locale messages
var locales=Object.keys(messages);if(locales.length){locales.forEach(function(locale){gl.mergeLocaleMessage(locale,messages[locale]);});}{// merge datetime formats
if(shared_isObject(options.datetimeFormats)){var _locales=Object.keys(options.datetimeFormats);if(_locales.length){_locales.forEach(function(locale){gl.mergeDateTimeFormat(locale,options.datetimeFormats[locale]);});}}// merge number formats
if(shared_isObject(options.numberFormats)){var _locales2=Object.keys(options.numberFormats);if(_locales2.length){_locales2.forEach(function(locale){gl.mergeNumberFormat(locale,options.numberFormats[locale]);});}}}}function createTextNode(key){return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createVNode)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Text,null,key,0);}/* eslint-enable @typescript-eslint/no-explicit-any *//* eslint-disable @typescript-eslint/no-explicit-any */// extend VNode interface
var DEVTOOLS_META='__INTLIFY_META__';var NOOP_RETURN_ARRAY=function NOOP_RETURN_ARRAY(){return[];};var NOOP_RETURN_FALSE=function NOOP_RETURN_FALSE(){return false;};var composerID=0;function defineCoreMissingHandler(missing){return function(ctx,locale,key,type){return missing(locale,key,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.getCurrentInstance)()||undefined,type);};}// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */var getMetaInfo=function getMetaInfo(){var instance=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.getCurrentInstance)();var meta=null;// eslint-disable-line @typescript-eslint/no-explicit-any
return instance&&(meta=getComponentOptions(instance)[DEVTOOLS_META])?_defineProperty2({},DEVTOOLS_META,meta)// eslint-disable-line @typescript-eslint/no-explicit-any
:null;};/**
 * Create composer interface factory
 *
 * @internal
 */// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createComposer(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var VueI18nLegacy=arguments.length>1?arguments[1]:undefined;var __root=options.__root,__injectWithOption=options.__injectWithOption;var _isGlobal=__root===undefined;var flatJson=options.flatJson;var _ref=shared_inBrowser?external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref:external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.shallowRef;var translateExistCompatible=!!options.translateExistCompatible;if(false){}var _inheritLocale=shared_isBoolean(options.inheritLocale)?options.inheritLocale:true;var _locale=_ref(// prettier-ignore
__root&&_inheritLocale?__root.locale.value:shared_isString(options.locale)?options.locale:core_base_DEFAULT_LOCALE);var _fallbackLocale=_ref(// prettier-ignore
__root&&_inheritLocale?__root.fallbackLocale.value:shared_isString(options.fallbackLocale)||shared_isArray(options.fallbackLocale)||shared_isPlainObject(options.fallbackLocale)||options.fallbackLocale===false?options.fallbackLocale:_locale.value);var _messages=_ref(getLocaleMessages(_locale.value,options));// prettier-ignore
var _datetimeFormats=_ref(shared_isPlainObject(options.datetimeFormats)?options.datetimeFormats:_defineProperty2({},_locale.value,{}));// prettier-ignore
var _numberFormats=_ref(shared_isPlainObject(options.numberFormats)?options.numberFormats:_defineProperty2({},_locale.value,{}));// warning suppress options
// prettier-ignore
var _missingWarn=__root?__root.missingWarn:shared_isBoolean(options.missingWarn)||shared_isRegExp(options.missingWarn)?options.missingWarn:true;// prettier-ignore
var _fallbackWarn=__root?__root.fallbackWarn:shared_isBoolean(options.fallbackWarn)||shared_isRegExp(options.fallbackWarn)?options.fallbackWarn:true;// prettier-ignore
var _fallbackRoot=__root?__root.fallbackRoot:shared_isBoolean(options.fallbackRoot)?options.fallbackRoot:true;// configure fall back to root
var _fallbackFormat=!!options.fallbackFormat;// runtime missing
var _missing=shared_isFunction(options.missing)?options.missing:null;var _runtimeMissing=shared_isFunction(options.missing)?defineCoreMissingHandler(options.missing):null;// postTranslation handler
var _postTranslation=shared_isFunction(options.postTranslation)?options.postTranslation:null;// prettier-ignore
var _warnHtmlMessage=__root?__root.warnHtmlMessage:shared_isBoolean(options.warnHtmlMessage)?options.warnHtmlMessage:true;var _escapeParameter=!!options.escapeParameter;// custom linked modifiers
// prettier-ignore
var _modifiers=__root?__root.modifiers:shared_isPlainObject(options.modifiers)?options.modifiers:{};// pluralRules
var _pluralRules=options.pluralRules||__root&&__root.pluralRules;// runtime context
// eslint-disable-next-line prefer-const
var _context;var getCoreContext=function getCoreContext(){_isGlobal&&setFallbackContext(null);var ctxOptions={version:vue_i18n_VERSION,locale:_locale.value,fallbackLocale:_fallbackLocale.value,messages:_messages.value,modifiers:_modifiers,pluralRules:_pluralRules,missing:_runtimeMissing===null?undefined:_runtimeMissing,missingWarn:_missingWarn,fallbackWarn:_fallbackWarn,fallbackFormat:_fallbackFormat,unresolving:true,postTranslation:_postTranslation===null?undefined:_postTranslation,warnHtmlMessage:_warnHtmlMessage,escapeParameter:_escapeParameter,messageResolver:options.messageResolver,messageCompiler:options.messageCompiler,__meta:{framework:'vue'}};{ctxOptions.datetimeFormats=_datetimeFormats.value;ctxOptions.numberFormats=_numberFormats.value;ctxOptions.__datetimeFormatters=shared_isPlainObject(_context)?_context.__datetimeFormatters:undefined;ctxOptions.__numberFormatters=shared_isPlainObject(_context)?_context.__numberFormatters:undefined;}if(false){}var ctx=createCoreContext(ctxOptions);_isGlobal&&setFallbackContext(ctx);return ctx;};_context=getCoreContext();updateFallbackLocale(_context,_locale.value,_fallbackLocale.value);// track reactivity
function trackReactivityValues(){return[_locale.value,_fallbackLocale.value,_messages.value,_datetimeFormats.value,_numberFormats.value];}// locale
var locale=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)({get:function get(){return _locale.value;},set:function set(val){_locale.value=val;_context.locale=_locale.value;}});// fallbackLocale
var fallbackLocale=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)({get:function get(){return _fallbackLocale.value;},set:function set(val){_fallbackLocale.value=val;_context.fallbackLocale=_fallbackLocale.value;updateFallbackLocale(_context,_locale.value,val);}});// messages
var messages=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return _messages.value;});// datetimeFormats
var datetimeFormats=/* #__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return _datetimeFormats.value;});// numberFormats
var numberFormats=/* #__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return _numberFormats.value;});// getPostTranslationHandler
function getPostTranslationHandler(){return shared_isFunction(_postTranslation)?_postTranslation:null;}// setPostTranslationHandler
function setPostTranslationHandler(handler){_postTranslation=handler;_context.postTranslation=handler;}// getMissingHandler
function getMissingHandler(){return _missing;}// setMissingHandler
function setMissingHandler(handler){if(handler!==null){_runtimeMissing=defineCoreMissingHandler(handler);}_missing=handler;_context.missing=_runtimeMissing;}function isResolvedTranslateMessage(type,arg// eslint-disable-line @typescript-eslint/no-explicit-any
){return type!=='translate'||!arg.resolvedMessage;}var wrapWithDeps=function wrapWithDeps(fn,argumentParser,warnType,fallbackSuccess,fallbackFail,successCondition){trackReactivityValues();// track reactive dependency
// NOTE: experimental !!
var ret;try{if( false||__INTLIFY_PROD_DEVTOOLS__){setAdditionalMeta(getMetaInfo());}if(!_isGlobal){_context.fallbackContext=__root?getFallbackContext():undefined;}ret=fn(_context);}finally{if( false||__INTLIFY_PROD_DEVTOOLS__){setAdditionalMeta(null);}if(!_isGlobal){_context.fallbackContext=undefined;}}if(warnType!=='translate exists'&&// for not `te` (e.g `t`)
shared_isNumber(ret)&&ret===NOT_REOSLVED||warnType==='translate exists'&&!ret// for `te`
){var _argumentParser=argumentParser(),_argumentParser2=_slicedToArray(_argumentParser,2),key=_argumentParser2[0],arg2=_argumentParser2[1];if(false){}return __root&&_fallbackRoot?fallbackSuccess(__root):fallbackFail(key);}else if(successCondition(ret)){return ret;}else{/* istanbul ignore next */throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);}};// t
function t(){for(var _len16=arguments.length,args=new Array(_len16),_key16=0;_key16<_len16;_key16++){args[_key16]=arguments[_key16];}return wrapWithDeps(function(context){return Reflect.apply(translate,null,[context].concat(args));},function(){return parseTranslateArgs.apply(void 0,args);},'translate',function(root){return Reflect.apply(root.t,root,[].concat(args));},function(key){return key;},function(val){return shared_isString(val);});}// rt
function rt(){for(var _len17=arguments.length,args=new Array(_len17),_key17=0;_key17<_len17;_key17++){args[_key17]=arguments[_key17];}var arg1=args[0],arg2=args[1],arg3=args[2];if(arg3&&!shared_isObject(arg3)){throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);}return t.apply(void 0,[arg1,arg2,shared_assign({resolvedMessage:true},arg3||{})]);}// d
function d(){for(var _len18=arguments.length,args=new Array(_len18),_key18=0;_key18<_len18;_key18++){args[_key18]=arguments[_key18];}return wrapWithDeps(function(context){return Reflect.apply(datetime,null,[context].concat(args));},function(){return parseDateTimeArgs.apply(void 0,args);},'datetime format',function(root){return Reflect.apply(root.d,root,[].concat(args));},function(){return MISSING_RESOLVE_VALUE;},function(val){return shared_isString(val);});}// n
function n(){for(var _len19=arguments.length,args=new Array(_len19),_key19=0;_key19<_len19;_key19++){args[_key19]=arguments[_key19];}return wrapWithDeps(function(context){return Reflect.apply(number,null,[context].concat(args));},function(){return parseNumberArgs.apply(void 0,args);},'number format',function(root){return Reflect.apply(root.n,root,[].concat(args));},function(){return MISSING_RESOLVE_VALUE;},function(val){return shared_isString(val);});}// for custom processor
function normalize(values){return values.map(function(val){return shared_isString(val)||shared_isNumber(val)||shared_isBoolean(val)?createTextNode(String(val)):val;});}var interpolate=function interpolate(val){return val;};var processor={normalize:normalize,interpolate:interpolate,type:'vnode'};// translateVNode, using for `i18n-t` component
function translateVNode(){for(var _len20=arguments.length,args=new Array(_len20),_key20=0;_key20<_len20;_key20++){args[_key20]=arguments[_key20];}return wrapWithDeps(function(context){var ret;var _context=context;try{_context.processor=processor;ret=Reflect.apply(translate,null,[_context].concat(args));}finally{_context.processor=null;}return ret;},function(){return parseTranslateArgs.apply(void 0,args);},'translate',// eslint-disable-next-line @typescript-eslint/no-explicit-any
function(root){return root[TranslateVNodeSymbol].apply(root,args);},function(key){return[createTextNode(key)];},function(val){return shared_isArray(val);});}// numberParts, using for `i18n-n` component
function numberParts(){for(var _len21=arguments.length,args=new Array(_len21),_key21=0;_key21<_len21;_key21++){args[_key21]=arguments[_key21];}return wrapWithDeps(function(context){return Reflect.apply(number,null,[context].concat(args));},function(){return parseNumberArgs.apply(void 0,args);},'number format',// eslint-disable-next-line @typescript-eslint/no-explicit-any
function(root){return root[NumberPartsSymbol].apply(root,args);},NOOP_RETURN_ARRAY,function(val){return shared_isString(val)||shared_isArray(val);});}// datetimeParts, using for `i18n-d` component
function datetimeParts(){for(var _len22=arguments.length,args=new Array(_len22),_key22=0;_key22<_len22;_key22++){args[_key22]=arguments[_key22];}return wrapWithDeps(function(context){return Reflect.apply(datetime,null,[context].concat(args));},function(){return parseDateTimeArgs.apply(void 0,args);},'datetime format',// eslint-disable-next-line @typescript-eslint/no-explicit-any
function(root){return root[DatetimePartsSymbol].apply(root,args);},NOOP_RETURN_ARRAY,function(val){return shared_isString(val)||shared_isArray(val);});}function setPluralRules(rules){_pluralRules=rules;_context.pluralRules=_pluralRules;}// te
function te(key,locale){return wrapWithDeps(function(){if(!key){return false;}var targetLocale=shared_isString(locale)?locale:_locale.value;var message=getLocaleMessage(targetLocale);var resolved=_context.messageResolver(message,key);return!translateExistCompatible?core_base_isMessageAST(resolved)||isMessageFunction(resolved)||shared_isString(resolved):resolved!=null;},function(){return[key];},'translate exists',function(root){return Reflect.apply(root.te,root,[key,locale]);},NOOP_RETURN_FALSE,function(val){return shared_isBoolean(val);});}function resolveMessages(key){var messages=null;var locales=fallbackWithLocaleChain(_context,_fallbackLocale.value,_locale.value);for(var i=0;i<locales.length;i++){var targetLocaleMessages=_messages.value[locales[i]]||{};var messageValue=_context.messageResolver(targetLocaleMessages,key);if(messageValue!=null){messages=messageValue;break;}}return messages;}// tm
function tm(key){var messages=resolveMessages(key);// prettier-ignore
return messages!=null?messages:__root?__root.tm(key)||{}:{};}// getLocaleMessage
function getLocaleMessage(locale){return _messages.value[locale]||{};}// setLocaleMessage
function setLocaleMessage(locale,message){if(flatJson){var _message=_defineProperty2({},locale,message);for(var key in _message){if(hasOwn(_message,key)){handleFlatJson(_message[key]);}}message=_message[locale];}_messages.value[locale]=message;_context.messages=_messages.value;}// mergeLocaleMessage
function mergeLocaleMessage(locale,message){_messages.value[locale]=_messages.value[locale]||{};var _message=_defineProperty2({},locale,message);if(flatJson){for(var key in _message){if(hasOwn(_message,key)){handleFlatJson(_message[key]);}}}message=_message[locale];deepCopy(message,_messages.value[locale]);_context.messages=_messages.value;}// getDateTimeFormat
function getDateTimeFormat(locale){return _datetimeFormats.value[locale]||{};}// setDateTimeFormat
function setDateTimeFormat(locale,format){_datetimeFormats.value[locale]=format;_context.datetimeFormats=_datetimeFormats.value;clearDateTimeFormat(_context,locale,format);}// mergeDateTimeFormat
function mergeDateTimeFormat(locale,format){_datetimeFormats.value[locale]=shared_assign(_datetimeFormats.value[locale]||{},format);_context.datetimeFormats=_datetimeFormats.value;clearDateTimeFormat(_context,locale,format);}// getNumberFormat
function getNumberFormat(locale){return _numberFormats.value[locale]||{};}// setNumberFormat
function setNumberFormat(locale,format){_numberFormats.value[locale]=format;_context.numberFormats=_numberFormats.value;clearNumberFormat(_context,locale,format);}// mergeNumberFormat
function mergeNumberFormat(locale,format){_numberFormats.value[locale]=shared_assign(_numberFormats.value[locale]||{},format);_context.numberFormats=_numberFormats.value;clearNumberFormat(_context,locale,format);}// for debug
composerID++;// watch root locale & fallbackLocale
if(__root&&shared_inBrowser){(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.watch)(__root.locale,function(val){if(_inheritLocale){_locale.value=val;_context.locale=val;updateFallbackLocale(_context,_locale.value,_fallbackLocale.value);}});(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.watch)(__root.fallbackLocale,function(val){if(_inheritLocale){_fallbackLocale.value=val;_context.fallbackLocale=val;updateFallbackLocale(_context,_locale.value,_fallbackLocale.value);}});}// define basic composition API!
var composer=_defineProperty2({id:composerID,locale:locale,fallbackLocale:fallbackLocale,get inheritLocale(){return _inheritLocale;},set inheritLocale(val){_inheritLocale=val;if(val&&__root){_locale.value=__root.locale.value;_fallbackLocale.value=__root.fallbackLocale.value;updateFallbackLocale(_context,_locale.value,_fallbackLocale.value);}},get availableLocales(){return Object.keys(_messages.value).sort();},messages:messages,get modifiers(){return _modifiers;},get pluralRules(){return _pluralRules||{};},get isGlobal(){return _isGlobal;},get missingWarn(){return _missingWarn;},set missingWarn(val){_missingWarn=val;_context.missingWarn=_missingWarn;},get fallbackWarn(){return _fallbackWarn;},set fallbackWarn(val){_fallbackWarn=val;_context.fallbackWarn=_fallbackWarn;},get fallbackRoot(){return _fallbackRoot;},set fallbackRoot(val){_fallbackRoot=val;},get fallbackFormat(){return _fallbackFormat;},set fallbackFormat(val){_fallbackFormat=val;_context.fallbackFormat=_fallbackFormat;},get warnHtmlMessage(){return _warnHtmlMessage;},set warnHtmlMessage(val){_warnHtmlMessage=val;_context.warnHtmlMessage=val;},get escapeParameter(){return _escapeParameter;},set escapeParameter(val){_escapeParameter=val;_context.escapeParameter=val;},t:t,getLocaleMessage:getLocaleMessage,setLocaleMessage:setLocaleMessage,mergeLocaleMessage:mergeLocaleMessage,getPostTranslationHandler:getPostTranslationHandler,setPostTranslationHandler:setPostTranslationHandler,getMissingHandler:getMissingHandler,setMissingHandler:setMissingHandler},SetPluralRulesSymbol,setPluralRules);{composer.datetimeFormats=datetimeFormats;composer.numberFormats=numberFormats;composer.rt=rt;composer.te=te;composer.tm=tm;composer.d=d;composer.n=n;composer.getDateTimeFormat=getDateTimeFormat;composer.setDateTimeFormat=setDateTimeFormat;composer.mergeDateTimeFormat=mergeDateTimeFormat;composer.getNumberFormat=getNumberFormat;composer.setNumberFormat=setNumberFormat;composer.mergeNumberFormat=mergeNumberFormat;composer[InejctWithOptionSymbol]=__injectWithOption;composer[TranslateVNodeSymbol]=translateVNode;composer[DatetimePartsSymbol]=datetimeParts;composer[NumberPartsSymbol]=numberParts;}// for vue-devtools timeline event
if(false){}return composer;}/* eslint-enable @typescript-eslint/no-explicit-any *//* eslint-disable @typescript-eslint/no-explicit-any *//**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */function convertComposerOptions(options){var locale=isString(options.locale)?options.locale:DEFAULT_LOCALE;var fallbackLocale=isString(options.fallbackLocale)||isArray(options.fallbackLocale)||isPlainObject(options.fallbackLocale)||options.fallbackLocale===false?options.fallbackLocale:locale;var missing=isFunction(options.missing)?options.missing:undefined;var missingWarn=isBoolean(options.silentTranslationWarn)||isRegExp(options.silentTranslationWarn)?!options.silentTranslationWarn:true;var fallbackWarn=isBoolean(options.silentFallbackWarn)||isRegExp(options.silentFallbackWarn)?!options.silentFallbackWarn:true;var fallbackRoot=isBoolean(options.fallbackRoot)?options.fallbackRoot:true;var fallbackFormat=!!options.formatFallbackMessages;var modifiers=isPlainObject(options.modifiers)?options.modifiers:{};var pluralizationRules=options.pluralizationRules;var postTranslation=isFunction(options.postTranslation)?options.postTranslation:undefined;var warnHtmlMessage=isString(options.warnHtmlInMessage)?options.warnHtmlInMessage!=='off':true;var escapeParameter=!!options.escapeParameterHtml;var inheritLocale=isBoolean(options.sync)?options.sync:true;if(false){}if(false){}var messages=options.messages;if(isPlainObject(options.sharedMessages)){var sharedMessages=options.sharedMessages;var locales=Object.keys(sharedMessages);messages=locales.reduce(function(messages,locale){var message=messages[locale]||(messages[locale]={});assign(message,sharedMessages[locale]);return messages;},messages||{});}var __i18n=options.__i18n,__root=options.__root,__injectWithOption=options.__injectWithOption;var datetimeFormats=options.datetimeFormats;var numberFormats=options.numberFormats;var flatJson=options.flatJson;var translateExistCompatible=options.translateExistCompatible;return{locale:locale,fallbackLocale:fallbackLocale,messages:messages,flatJson:flatJson,datetimeFormats:datetimeFormats,numberFormats:numberFormats,missing:missing,missingWarn:missingWarn,fallbackWarn:fallbackWarn,fallbackRoot:fallbackRoot,fallbackFormat:fallbackFormat,modifiers:modifiers,pluralRules:pluralizationRules,postTranslation:postTranslation,warnHtmlMessage:warnHtmlMessage,escapeParameter:escapeParameter,messageResolver:options.messageResolver,inheritLocale:inheritLocale,translateExistCompatible:translateExistCompatible,__i18n:__i18n,__root:__root,__injectWithOption:__injectWithOption};}/**
 * create VueI18n interface factory
 *
 * @internal
 */// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createVueI18n(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var VueI18nLegacy=arguments.length>1?arguments[1]:undefined;{var composer=createComposer(convertComposerOptions(options));var __extender=options.__extender;// defines VueI18n
var vueI18n={// id
id:composer.id,// locale
get locale(){return composer.locale.value;},set locale(val){composer.locale.value=val;},// fallbackLocale
get fallbackLocale(){return composer.fallbackLocale.value;},set fallbackLocale(val){composer.fallbackLocale.value=val;},// messages
get messages(){return composer.messages.value;},// datetimeFormats
get datetimeFormats(){return composer.datetimeFormats.value;},// numberFormats
get numberFormats(){return composer.numberFormats.value;},// availableLocales
get availableLocales(){return composer.availableLocales;},// formatter
get formatter(){ false&&0;// dummy
return{interpolate:function interpolate(){return[];}};},set formatter(val){ false&&0;},// missing
get missing(){return composer.getMissingHandler();},set missing(handler){composer.setMissingHandler(handler);},// silentTranslationWarn
get silentTranslationWarn(){return isBoolean(composer.missingWarn)?!composer.missingWarn:composer.missingWarn;},set silentTranslationWarn(val){composer.missingWarn=isBoolean(val)?!val:val;},// silentFallbackWarn
get silentFallbackWarn(){return isBoolean(composer.fallbackWarn)?!composer.fallbackWarn:composer.fallbackWarn;},set silentFallbackWarn(val){composer.fallbackWarn=isBoolean(val)?!val:val;},// modifiers
get modifiers(){return composer.modifiers;},// formatFallbackMessages
get formatFallbackMessages(){return composer.fallbackFormat;},set formatFallbackMessages(val){composer.fallbackFormat=val;},// postTranslation
get postTranslation(){return composer.getPostTranslationHandler();},set postTranslation(handler){composer.setPostTranslationHandler(handler);},// sync
get sync(){return composer.inheritLocale;},set sync(val){composer.inheritLocale=val;},// warnInHtmlMessage
get warnHtmlInMessage(){return composer.warnHtmlMessage?'warn':'off';},set warnHtmlInMessage(val){composer.warnHtmlMessage=val!=='off';},// escapeParameterHtml
get escapeParameterHtml(){return composer.escapeParameter;},set escapeParameterHtml(val){composer.escapeParameter=val;},// preserveDirectiveContent
get preserveDirectiveContent(){ false&&0;return true;},set preserveDirectiveContent(val){ false&&0;},// pluralizationRules
get pluralizationRules(){return composer.pluralRules||{};},// for internal
__composer:composer,// t
t:function t(){for(var _len23=arguments.length,args=new Array(_len23),_key23=0;_key23<_len23;_key23++){args[_key23]=arguments[_key23];}var arg1=args[0],arg2=args[1],arg3=args[2];var options={};var list=null;var named=null;if(!isString(arg1)){throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);}var key=arg1;if(isString(arg2)){options.locale=arg2;}else if(isArray(arg2)){list=arg2;}else if(isPlainObject(arg2)){named=arg2;}if(isArray(arg3)){list=arg3;}else if(isPlainObject(arg3)){named=arg3;}// return composer.t(key, (list || named || {}) as any, options)
return Reflect.apply(composer.t,composer,[key,list||named||{},options]);},rt:function rt(){for(var _len24=arguments.length,args=new Array(_len24),_key24=0;_key24<_len24;_key24++){args[_key24]=arguments[_key24];}return Reflect.apply(composer.rt,composer,[].concat(args));},// tc
tc:function tc(){for(var _len25=arguments.length,args=new Array(_len25),_key25=0;_key25<_len25;_key25++){args[_key25]=arguments[_key25];}var arg1=args[0],arg2=args[1],arg3=args[2];var options={plural:1};var list=null;var named=null;if(!isString(arg1)){throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);}var key=arg1;if(isString(arg2)){options.locale=arg2;}else if(isNumber(arg2)){options.plural=arg2;}else if(isArray(arg2)){list=arg2;}else if(isPlainObject(arg2)){named=arg2;}if(isString(arg3)){options.locale=arg3;}else if(isArray(arg3)){list=arg3;}else if(isPlainObject(arg3)){named=arg3;}// return composer.t(key, (list || named || {}) as any, options)
return Reflect.apply(composer.t,composer,[key,list||named||{},options]);},// te
te:function te(key,locale){return composer.te(key,locale);},// tm
tm:function tm(key){return composer.tm(key);},// getLocaleMessage
getLocaleMessage:function getLocaleMessage(locale){return composer.getLocaleMessage(locale);},// setLocaleMessage
setLocaleMessage:function setLocaleMessage(locale,message){composer.setLocaleMessage(locale,message);},// mergeLocaleMessage
mergeLocaleMessage:function mergeLocaleMessage(locale,message){composer.mergeLocaleMessage(locale,message);},// d
d:function d(){for(var _len26=arguments.length,args=new Array(_len26),_key26=0;_key26<_len26;_key26++){args[_key26]=arguments[_key26];}return Reflect.apply(composer.d,composer,[].concat(args));},// getDateTimeFormat
getDateTimeFormat:function getDateTimeFormat(locale){return composer.getDateTimeFormat(locale);},// setDateTimeFormat
setDateTimeFormat:function setDateTimeFormat(locale,format){composer.setDateTimeFormat(locale,format);},// mergeDateTimeFormat
mergeDateTimeFormat:function mergeDateTimeFormat(locale,format){composer.mergeDateTimeFormat(locale,format);},// n
n:function n(){for(var _len27=arguments.length,args=new Array(_len27),_key27=0;_key27<_len27;_key27++){args[_key27]=arguments[_key27];}return Reflect.apply(composer.n,composer,[].concat(args));},// getNumberFormat
getNumberFormat:function getNumberFormat(locale){return composer.getNumberFormat(locale);},// setNumberFormat
setNumberFormat:function setNumberFormat(locale,format){composer.setNumberFormat(locale,format);},// mergeNumberFormat
mergeNumberFormat:function mergeNumberFormat(locale,format){composer.mergeNumberFormat(locale,format);},// getChoiceIndex
// eslint-disable-next-line @typescript-eslint/no-unused-vars
getChoiceIndex:function getChoiceIndex(choice,choicesLength){ false&&0;return-1;}};vueI18n.__extender=__extender;// for vue-devtools timeline event
if(false){}return vueI18n;}}/* eslint-enable @typescript-eslint/no-explicit-any */var baseFormatProps={tag:{type:[String,Object]},locale:{type:String},scope:{type:String,// NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
validator:function validator(val/* ComponentI18nScope */){return val==='parent'||val==='global';},default:'parent'/* ComponentI18nScope */},i18n:{type:Object}};function getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
_ref11,// SetupContext,
keys){var slots=_ref11.slots;if(keys.length===1&&keys[0]==='default'){// default slot with list
var ret=slots.default?slots.default():[];// eslint-disable-next-line @typescript-eslint/no-explicit-any
return ret.reduce(function(slot,current){return[].concat(_toConsumableArray(slot),_toConsumableArray(current.type===external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment?current.children:[current]));},[]);}else{// named slots
return keys.reduce(function(arg,key){var slot=slots[key];if(slot){arg[key]=slot();}return arg;},{});}}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getFragmentableTag(tag){return external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment;}var TranslationImpl=/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({/* eslint-disable */name:'i18n-t',props:shared_assign({keypath:{type:String,required:true},plural:{type:[Number,String],// eslint-disable-next-line @typescript-eslint/no-explicit-any
validator:function validator(val){return shared_isNumber(val)||!isNaN(val);}}},baseFormatProps),/* eslint-enable */// eslint-disable-next-line @typescript-eslint/no-explicit-any
setup:function setup(props,context){var slots=context.slots,attrs=context.attrs;// NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
var i18n=props.i18n||useI18n({useScope:props.scope,__useComponent:true});return function(){var keys=Object.keys(slots).filter(function(key){return key!=='_';});var options={};if(props.locale){options.locale=props.locale;}if(props.plural!==undefined){options.plural=shared_isString(props.plural)?+props.plural:props.plural;}var arg=getInterpolateArg(context,keys);// eslint-disable-next-line @typescript-eslint/no-explicit-any
var children=i18n[TranslateVNodeSymbol](props.keypath,arg,options);var assignedAttrs=shared_assign({},attrs);var tag=shared_isString(props.tag)||shared_isObject(props.tag)?props.tag:getFragmentableTag();return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.h)(tag,assignedAttrs,children);};}});/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 *//**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */var Translation=/* unused pure expression or super */null&&0;var I18nT=/* unused pure expression or super */null&&0;function isVNode(target){return shared_isArray(target)&&!shared_isString(target[0]);}function renderFormatter(props,context,slotKeys,partFormatter){var slots=context.slots,attrs=context.attrs;return function(){var options={part:true};var overrides={};if(props.locale){options.locale=props.locale;}if(shared_isString(props.format)){options.key=props.format;}else if(shared_isObject(props.format)){// eslint-disable-next-line @typescript-eslint/no-explicit-any
if(shared_isString(props.format.key)){// eslint-disable-next-line @typescript-eslint/no-explicit-any
options.key=props.format.key;}// Filter out number format options only
overrides=Object.keys(props.format).reduce(function(options,prop){return slotKeys.includes(prop)?shared_assign({},options,_defineProperty2({},prop,props.format[prop]))// eslint-disable-line @typescript-eslint/no-explicit-any
:options;},{});}var parts=partFormatter.apply(void 0,[props.value,options,overrides]);var children=[options.key];if(shared_isArray(parts)){children=parts.map(function(part,index){var slot=slots[part.type];var node=slot?slot(_defineProperty2(_defineProperty2(_defineProperty2({},part.type,part.value),"index",index),"parts",parts)):[part.value];if(isVNode(node)){node[0].key="".concat(part.type,"-").concat(index);}return node;});}else if(shared_isString(parts)){children=[parts];}var assignedAttrs=shared_assign({},attrs);var tag=shared_isString(props.tag)||shared_isObject(props.tag)?props.tag:getFragmentableTag();return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.h)(tag,assignedAttrs,children);};}var NumberFormatImpl=/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({/* eslint-disable */name:'i18n-n',props:shared_assign({value:{type:Number,required:true},format:{type:[String,Object]}},baseFormatProps),/* eslint-enable */// eslint-disable-next-line @typescript-eslint/no-explicit-any
setup:function setup(props,context){var i18n=props.i18n||useI18n({useScope:props.scope,__useComponent:true});return renderFormatter(props,context,NUMBER_FORMAT_OPTIONS_KEYS,function(){return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
i18n[NumberPartsSymbol].apply(i18n,arguments));});}});/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 *//**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */var NumberFormat=/* unused pure expression or super */null&&0;var I18nN=/* unused pure expression or super */null&&0;var DatetimeFormatImpl=/* #__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({/* eslint-disable */name:'i18n-d',props:shared_assign({value:{type:[Number,Date],required:true},format:{type:[String,Object]}},baseFormatProps),/* eslint-enable */// eslint-disable-next-line @typescript-eslint/no-explicit-any
setup:function setup(props,context){var i18n=props.i18n||useI18n({useScope:props.scope,__useComponent:true});return renderFormatter(props,context,DATETIME_FORMAT_OPTIONS_KEYS,function(){return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
i18n[DatetimePartsSymbol].apply(i18n,arguments));});}});/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */var DatetimeFormat=/* unused pure expression or super */null&&0;var I18nD=/* unused pure expression or super */null&&0;function getComposer$2(i18n,instance){var i18nInternal=i18n;if(i18n.mode==='composition'){return i18nInternal.__getInstance(instance)||i18n.global;}else{var vueI18n=i18nInternal.__getInstance(instance);return vueI18n!=null?vueI18n.__composer:i18n.global.__composer;}}function vTDirective(i18n){var _process=function _process(binding){var instance=binding.instance,modifiers=binding.modifiers,value=binding.value;/* istanbul ignore if */if(!instance||!instance.$){throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);}var composer=getComposer$2(i18n,instance.$);if(false){}var parsedValue=parseValue(value);return[Reflect.apply(composer.t,composer,_toConsumableArray(makeParams(parsedValue))),composer];};var register=function register(el,binding){var _process2=_process(binding),_process3=_slicedToArray(_process2,2),textContent=_process3[0],composer=_process3[1];if(inBrowser&&i18n.global===composer){// global scope only
el.__i18nWatcher=watch(composer.locale,function(){binding.instance&&binding.instance.$forceUpdate();});}el.__composer=composer;el.textContent=textContent;};var unregister=function unregister(el){if(inBrowser&&el.__i18nWatcher){el.__i18nWatcher();el.__i18nWatcher=undefined;delete el.__i18nWatcher;}if(el.__composer){el.__composer=undefined;delete el.__composer;}};var update=function update(el,_ref12){var value=_ref12.value;if(el.__composer){var composer=el.__composer;var parsedValue=parseValue(value);el.textContent=Reflect.apply(composer.t,composer,_toConsumableArray(makeParams(parsedValue)));}};var getSSRProps=function getSSRProps(binding){var _process4=_process(binding),_process5=_slicedToArray(_process4,1),textContent=_process5[0];return{textContent:textContent};};return{created:register,unmounted:unregister,beforeUpdate:update,getSSRProps:getSSRProps};}function parseValue(value){if(isString(value)){return{path:value};}else if(isPlainObject(value)){if(!('path'in value)){throw createI18nError(I18nErrorCodes.REQUIRED_VALUE,'path');}return value;}else{throw createI18nError(I18nErrorCodes.INVALID_VALUE);}}function makeParams(value){var path=value.path,locale=value.locale,args=value.args,choice=value.choice,plural=value.plural;var options={};var named=args||{};if(isString(locale)){options.locale=locale;}if(isNumber(choice)){options.plural=choice;}if(isNumber(plural)){options.plural=plural;}return[path,named,options];}function apply(app,i18n){var pluginOptions=isPlainObject(arguments.length<=2?undefined:arguments[2])?arguments.length<=2?undefined:arguments[2]:{};var useI18nComponentName=!!pluginOptions.useI18nComponentName;var globalInstall=isBoolean(pluginOptions.globalInstall)?pluginOptions.globalInstall:true;if(false){}if(globalInstall){[!useI18nComponentName?Translation.name:'i18n','I18nT'].forEach(function(name){return app.component(name,Translation);});[NumberFormat.name,'I18nN'].forEach(function(name){return app.component(name,NumberFormat);});[DatetimeFormat.name,'I18nD'].forEach(function(name){return app.component(name,DatetimeFormat);});}// install directive
{app.directive('t',vTDirective(i18n));}}var VueDevToolsLabels=_defineProperty2(_defineProperty2(_defineProperty2({},"vue-devtools-plugin-vue-i18n"/* VueDevToolsIDs.PLUGIN */,'Vue I18n devtools'),"vue-i18n-resource-inspector"/* VueDevToolsIDs.CUSTOM_INSPECTOR */,'I18n Resources'),"vue-i18n-timeline"/* VueDevToolsIDs.TIMELINE */,'Vue I18n');var VueDevToolsPlaceholders=_defineProperty2({},"vue-i18n-resource-inspector"/* VueDevToolsIDs.CUSTOM_INSPECTOR */,'Search for scopes ...');var VueDevToolsTimelineColors=_defineProperty2({},"vue-i18n-timeline"/* VueDevToolsIDs.TIMELINE */,0xffcd19);var VUE_I18N_COMPONENT_TYPES='vue-i18n: composer properties';var devtoolsApi;function enableDevTools(_x,_x2){return _enableDevTools.apply(this,arguments);}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enableDevTools(){_enableDevTools=_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(app,i18n){return _regeneratorRuntime().wrap(function _callee4$(_context5){while(1)switch(_context5.prev=_context5.next){case 0:return _context5.abrupt("return",new Promise(function(resolve,reject){try{setupDevtoolsPlugin({id:"vue-devtools-plugin-vue-i18n"/* VueDevToolsIDs.PLUGIN */,label:VueDevToolsLabels["vue-devtools-plugin-vue-i18n"/* VueDevToolsIDs.PLUGIN */],packageName:'vue-i18n',homepage:'https://vue-i18n.intlify.dev',logo:'https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png',componentStateTypes:[VUE_I18N_COMPONENT_TYPES],app:app// eslint-disable-line @typescript-eslint/no-explicit-any
},function(api){devtoolsApi=api;api.on.visitComponentTree(function(_ref24){var componentInstance=_ref24.componentInstance,treeNode=_ref24.treeNode;updateComponentTreeTags(componentInstance,treeNode,i18n);});api.on.inspectComponent(function(_ref25){var componentInstance=_ref25.componentInstance,instanceData=_ref25.instanceData;if(componentInstance.vnode.el&&componentInstance.vnode.el.__VUE_I18N__&&instanceData){if(i18n.mode==='legacy'){// ignore global scope on legacy mode
if(componentInstance.vnode.el.__VUE_I18N__!==i18n.global.__composer){inspectComposer(instanceData,componentInstance.vnode.el.__VUE_I18N__);}}else{inspectComposer(instanceData,componentInstance.vnode.el.__VUE_I18N__);}}});api.addInspector({id:"vue-i18n-resource-inspector"/* VueDevToolsIDs.CUSTOM_INSPECTOR */,label:VueDevToolsLabels["vue-i18n-resource-inspector"/* VueDevToolsIDs.CUSTOM_INSPECTOR */],icon:'language',treeFilterPlaceholder:VueDevToolsPlaceholders["vue-i18n-resource-inspector"/* VueDevToolsIDs.CUSTOM_INSPECTOR */]});api.on.getInspectorTree(function(payload){if(payload.app===app&&payload.inspectorId==="vue-i18n-resource-inspector"/* VueDevToolsIDs.CUSTOM_INSPECTOR */){registerScope(payload,i18n);}});var roots=new Map();api.on.getInspectorState(/*#__PURE__*/function(){var _ref26=_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(payload){var _yield$api$getCompone,_yield$api$getCompone2,root,instance;return _regeneratorRuntime().wrap(function _callee3$(_context4){while(1)switch(_context4.prev=_context4.next){case 0:if(!(payload.app===app&&payload.inspectorId==="vue-i18n-resource-inspector"/* VueDevToolsIDs.CUSTOM_INSPECTOR */)){_context4.next=16;break;}api.unhighlightElement();inspectScope(payload,i18n);if(!(payload.nodeId==='global')){_context4.next=14;break;}if(roots.has(payload.app)){_context4.next=11;break;}_context4.next=7;return api.getComponentInstances(payload.app);case 7:_yield$api$getCompone=_context4.sent;_yield$api$getCompone2=_slicedToArray(_yield$api$getCompone,1);root=_yield$api$getCompone2[0];roots.set(payload.app,root);case 11:api.highlightElement(roots.get(payload.app));_context4.next=16;break;case 14:instance=getComponentInstance(payload.nodeId,i18n);instance&&api.highlightElement(instance);case 16:case"end":return _context4.stop();}},_callee3);}));return function(_x5){return _ref26.apply(this,arguments);};}());api.on.editInspectorState(function(payload){if(payload.app===app&&payload.inspectorId==="vue-i18n-resource-inspector"/* VueDevToolsIDs.CUSTOM_INSPECTOR */){editScope(payload,i18n);}});api.addTimelineLayer({id:"vue-i18n-timeline"/* VueDevToolsIDs.TIMELINE */,label:VueDevToolsLabels["vue-i18n-timeline"/* VueDevToolsIDs.TIMELINE */],color:VueDevToolsTimelineColors["vue-i18n-timeline"/* VueDevToolsIDs.TIMELINE */]});resolve(true);});}catch(e){reject(false);}}));case 1:case"end":return _context5.stop();}},_callee4);}));return _enableDevTools.apply(this,arguments);}function getI18nScopeLable(instance){return instance.type.name||instance.type.displayName||instance.type.__file||'Anonymous';}function updateComponentTreeTags(instance,// eslint-disable-line @typescript-eslint/no-explicit-any
treeNode,i18n){// prettier-ignore
var global=i18n.mode==='composition'?i18n.global:i18n.global.__composer;if(instance&&instance.vnode.el&&instance.vnode.el.__VUE_I18N__){// add custom tags local scope only
if(instance.vnode.el.__VUE_I18N__!==global){var tag={label:"i18n (".concat(getI18nScopeLable(instance)," Scope)"),textColor:0x000000,backgroundColor:0xffcd19};treeNode.tags.push(tag);}}}function inspectComposer(instanceData,composer){var type=VUE_I18N_COMPONENT_TYPES;instanceData.state.push({type:type,key:'locale',editable:true,value:composer.locale.value});instanceData.state.push({type:type,key:'availableLocales',editable:false,value:composer.availableLocales});instanceData.state.push({type:type,key:'fallbackLocale',editable:true,value:composer.fallbackLocale.value});instanceData.state.push({type:type,key:'inheritLocale',editable:true,value:composer.inheritLocale});instanceData.state.push({type:type,key:'messages',editable:false,value:getLocaleMessageValue(composer.messages.value)});{instanceData.state.push({type:type,key:'datetimeFormats',editable:false,value:composer.datetimeFormats.value});instanceData.state.push({type:type,key:'numberFormats',editable:false,value:composer.numberFormats.value});}}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getLocaleMessageValue(messages){var value={};Object.keys(messages).forEach(function(key){var v=messages[key];if(isFunction(v)&&'source'in v){value[key]=getMessageFunctionDetails(v);}else if(isMessageAST(v)&&v.loc&&v.loc.source){value[key]=v.loc.source;}else if(isObject(v)){value[key]=getLocaleMessageValue(v);}else{value[key]=v;}});return value;}var ESC={'<':'&lt;','>':'&gt;','"':'&quot;','&':'&amp;'};function vue_i18n_escape(s){return s.replace(/[<>"&]/g,escapeChar);}function escapeChar(a){return ESC[a]||a;}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMessageFunctionDetails(func){var argString=func.source?"(\"".concat(vue_i18n_escape(func.source),"\")"):"(?)";return{_custom:{type:'function',display:"<span>\u0192</span> ".concat(argString)}};}function registerScope(payload,i18n){payload.rootNodes.push({id:'global',label:'Global Scope'});// prettier-ignore
var global=i18n.mode==='composition'?i18n.global:i18n.global.__composer;var _iterator=_createForOfIteratorHelper(i18n.__instances),_step;try{for(_iterator.s();!(_step=_iterator.n()).done;){var _step$value=_slicedToArray(_step.value,2),keyInstance=_step$value[0],instance=_step$value[1];// prettier-ignore
var composer=i18n.mode==='composition'?instance:instance.__composer;if(global===composer){continue;}payload.rootNodes.push({id:composer.id.toString(),label:"".concat(getI18nScopeLable(keyInstance)," Scope")});}}catch(err){_iterator.e(err);}finally{_iterator.f();}}function getComponentInstance(nodeId,i18n){var instance=null;if(nodeId!=='global'){var _iterator2=_createForOfIteratorHelper(i18n.__instances.entries()),_step2;try{for(_iterator2.s();!(_step2=_iterator2.n()).done;){var _step2$value=_slicedToArray(_step2.value,2),component=_step2$value[0],composer=_step2$value[1];if(composer.id.toString()===nodeId){instance=component;break;}}}catch(err){_iterator2.e(err);}finally{_iterator2.f();}}return instance;}function getComposer$1(nodeId,i18n){if(nodeId==='global'){return i18n.mode==='composition'?i18n.global:i18n.global.__composer;}else{var instance=Array.from(i18n.__instances.values()).find(function(item){return item.id.toString()===nodeId;});if(instance){return i18n.mode==='composition'?instance:instance.__composer;}else{return null;}}}function inspectScope(payload,i18n// eslint-disable-next-line @typescript-eslint/no-explicit-any
){var composer=getComposer$1(payload.nodeId,i18n);if(composer){// TODO:
// eslint-disable-next-line @typescript-eslint/no-explicit-any
payload.state=makeScopeInspectState(composer);}return null;}function makeScopeInspectState(composer){var state={};var localeType='Locale related info';var localeStates=[{type:localeType,key:'locale',editable:true,value:composer.locale.value},{type:localeType,key:'fallbackLocale',editable:true,value:composer.fallbackLocale.value},{type:localeType,key:'availableLocales',editable:false,value:composer.availableLocales},{type:localeType,key:'inheritLocale',editable:true,value:composer.inheritLocale}];state[localeType]=localeStates;var localeMessagesType='Locale messages info';var localeMessagesStates=[{type:localeMessagesType,key:'messages',editable:false,value:getLocaleMessageValue(composer.messages.value)}];state[localeMessagesType]=localeMessagesStates;{var datetimeFormatsType='Datetime formats info';var datetimeFormatsStates=[{type:datetimeFormatsType,key:'datetimeFormats',editable:false,value:composer.datetimeFormats.value}];state[datetimeFormatsType]=datetimeFormatsStates;var numberFormatsType='Datetime formats info';var numberFormatsStates=[{type:numberFormatsType,key:'numberFormats',editable:false,value:composer.numberFormats.value}];state[numberFormatsType]=numberFormatsStates;}return state;}function addTimelineEvent(event,payload){if(devtoolsApi){var groupId;if(payload&&'groupId'in payload){groupId=payload.groupId;delete payload.groupId;}devtoolsApi.addTimelineEvent({layerId:"vue-i18n-timeline"/* VueDevToolsIDs.TIMELINE */,event:{title:event,groupId:groupId,time:Date.now(),meta:{},data:payload||{},logType:event==="compile-error"/* VueDevToolsTimelineEvents.COMPILE_ERROR */?'error':event==="fallback"/* VueDevToolsTimelineEvents.FALBACK */||event==="missing"/* VueDevToolsTimelineEvents.MISSING */?'warning':'default'}});}}function editScope(payload,i18n){var composer=getComposer$1(payload.nodeId,i18n);if(composer){var _payload$path=_slicedToArray(payload.path,1),field=_payload$path[0];if(field==='locale'&&isString(payload.state.value)){composer.locale.value=payload.state.value;}else if(field==='fallbackLocale'&&(isString(payload.state.value)||isArray(payload.state.value)||isObject(payload.state.value))){composer.fallbackLocale.value=payload.state.value;}else if(field==='inheritLocale'&&isBoolean(payload.state.value)){composer.inheritLocale=payload.state.value;}}}/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */function defineMixin(vuei18n,composer,i18n){return{beforeCreate:function beforeCreate(){var _this2=this;var instance=getCurrentInstance();/* istanbul ignore if */if(!instance){throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);}var options=this.$options;if(options.i18n){var optionsI18n=options.i18n;if(options.__i18n){optionsI18n.__i18n=options.__i18n;}optionsI18n.__root=composer;if(this===this.$root){// merge option and gttach global
this.$i18n=mergeToGlobal(vuei18n,optionsI18n);}else{optionsI18n.__injectWithOption=true;optionsI18n.__extender=i18n.__vueI18nExtend;// atttach local VueI18n instance
this.$i18n=createVueI18n(optionsI18n);// extend VueI18n instance
var _vueI18n=this.$i18n;if(_vueI18n.__extender){_vueI18n.__disposer=_vueI18n.__extender(this.$i18n);}}}else if(options.__i18n){if(this===this.$root){// merge option and gttach global
this.$i18n=mergeToGlobal(vuei18n,options);}else{// atttach local VueI18n instance
this.$i18n=createVueI18n({__i18n:options.__i18n,__injectWithOption:true,__extender:i18n.__vueI18nExtend,__root:composer});// extend VueI18n instance
var _vueI18n2=this.$i18n;if(_vueI18n2.__extender){_vueI18n2.__disposer=_vueI18n2.__extender(this.$i18n);}}}else{// attach global VueI18n instance
this.$i18n=vuei18n;}if(options.__i18nGlobal){adjustI18nResources(composer,options,options);}// defines vue-i18n legacy APIs
this.$t=function(){var _this2$$i18n;return(_this2$$i18n=_this2.$i18n).t.apply(_this2$$i18n,arguments);};this.$rt=function(){var _this2$$i18n2;return(_this2$$i18n2=_this2.$i18n).rt.apply(_this2$$i18n2,arguments);};this.$tc=function(){var _this2$$i18n3;return(_this2$$i18n3=_this2.$i18n).tc.apply(_this2$$i18n3,arguments);};this.$te=function(key,locale){return _this2.$i18n.te(key,locale);};this.$d=function(){var _this2$$i18n4;return(_this2$$i18n4=_this2.$i18n).d.apply(_this2$$i18n4,arguments);};this.$n=function(){var _this2$$i18n5;return(_this2$$i18n5=_this2.$i18n).n.apply(_this2$$i18n5,arguments);};this.$tm=function(key){return _this2.$i18n.tm(key);};i18n.__setInstance(instance,this.$i18n);},mounted:function mounted(){/* istanbul ignore if */if(false){}},unmounted:function unmounted(){var instance=getCurrentInstance();/* istanbul ignore if */if(!instance){throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);}var _vueI18n=this.$i18n;/* istanbul ignore if */if(false){}delete this.$t;delete this.$rt;delete this.$tc;delete this.$te;delete this.$d;delete this.$n;delete this.$tm;if(_vueI18n.__disposer){_vueI18n.__disposer();delete _vueI18n.__disposer;delete _vueI18n.__extender;}i18n.__deleteInstance(instance);delete this.$i18n;}};}function mergeToGlobal(g,options){g.locale=options.locale||g.locale;g.fallbackLocale=options.fallbackLocale||g.fallbackLocale;g.missing=options.missing||g.missing;g.silentTranslationWarn=options.silentTranslationWarn||g.silentFallbackWarn;g.silentFallbackWarn=options.silentFallbackWarn||g.silentFallbackWarn;g.formatFallbackMessages=options.formatFallbackMessages||g.formatFallbackMessages;g.postTranslation=options.postTranslation||g.postTranslation;g.warnHtmlInMessage=options.warnHtmlInMessage||g.warnHtmlInMessage;g.escapeParameterHtml=options.escapeParameterHtml||g.escapeParameterHtml;g.sync=options.sync||g.sync;g.__composer[SetPluralRulesSymbol](options.pluralizationRules||g.pluralizationRules);var messages=getLocaleMessages(g.locale,{messages:options.messages,__i18n:options.__i18n});Object.keys(messages).forEach(function(locale){return g.mergeLocaleMessage(locale,messages[locale]);});if(options.datetimeFormats){Object.keys(options.datetimeFormats).forEach(function(locale){return g.mergeDateTimeFormat(locale,options.datetimeFormats[locale]);});}if(options.numberFormats){Object.keys(options.numberFormats).forEach(function(locale){return g.mergeNumberFormat(locale,options.numberFormats[locale]);});}return g;}/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */var I18nInjectionKey=/* #__PURE__*/shared_makeSymbol('global-vue-i18n');// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function createI18n(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var VueI18nLegacy=arguments.length>1?arguments[1]:undefined;// prettier-ignore
var __legacyMode=__VUE_I18N_LEGACY_API__&&isBoolean(options.legacy)?options.legacy:__VUE_I18N_LEGACY_API__;// prettier-ignore
var __globalInjection=isBoolean(options.globalInjection)?options.globalInjection:true;// prettier-ignore
var __allowComposition=__VUE_I18N_LEGACY_API__&&__legacyMode?!!options.allowComposition:true;var __instances=new Map();var _createGlobal=createGlobal(options,__legacyMode),_createGlobal2=_slicedToArray(_createGlobal,2),globalScope=_createGlobal2[0],__global=_createGlobal2[1];var symbol=/* #__PURE__*/makeSymbol( false?0:'');if(false){}function __getInstance(component){return __instances.get(component)||null;}function __setInstance(component,instance){__instances.set(component,instance);}function __deleteInstance(component){__instances.delete(component);}{var i18n={// mode
get mode(){return __VUE_I18N_LEGACY_API__&&__legacyMode?'legacy':'composition';},// allowComposition
get allowComposition(){return __allowComposition;},// install plugin
install:function install(app){var _arguments=arguments;return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(){var _len28,options,_key28,opts,globalReleaseHandler,unmountApp;return _regeneratorRuntime().wrap(function _callee$(_context2){while(1)switch(_context2.prev=_context2.next){case 0:if(false){}// setup global provider
app.__VUE_I18N_SYMBOL__=symbol;app.provide(app.__VUE_I18N_SYMBOL__,i18n);// set composer & vuei18n extend hook options from plugin options
for(_len28=_arguments.length,options=new Array(_len28>1?_len28-1:0),_key28=1;_key28<_len28;_key28++){options[_key28-1]=_arguments[_key28];}if(isPlainObject(options[0])){opts=options[0];i18n.__composerExtend=opts.__composerExtend;i18n.__vueI18nExtend=opts.__vueI18nExtend;}// global method and properties injection for Composition API
globalReleaseHandler=null;if(!__legacyMode&&__globalInjection){globalReleaseHandler=injectGlobalFields(app,i18n.global);}// install built-in components and directive
if(__VUE_I18N_FULL_INSTALL__){apply.apply(void 0,[app,i18n].concat(options));}// setup mixin for Legacy API
if(__VUE_I18N_LEGACY_API__&&__legacyMode){app.mixin(defineMixin(__global,__global.__composer,i18n));}// release global scope
unmountApp=app.unmount;app.unmount=function(){globalReleaseHandler&&globalReleaseHandler();i18n.dispose();unmountApp();};// setup vue-devtools plugin
if(false){}case 12:case"end":return _context2.stop();}},_callee);}))();},// global accessor
get global(){return __global;},dispose:function dispose(){globalScope.stop();},// @internal
__instances:__instances,// @internal
__getInstance:__getInstance,// @internal
__setInstance:__setInstance,// @internal
__deleteInstance:__deleteInstance};return i18n;}}// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useI18n(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var instance=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.getCurrentInstance)();if(instance==null){throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);}if(!instance.isCE&&instance.appContext.app!=null&&!instance.appContext.app.__VUE_I18N_SYMBOL__){throw createI18nError(I18nErrorCodes.NOT_INSTALLED);}var i18n=getI18nInstance(instance);var gl=getGlobalComposer(i18n);var componentOptions=getComponentOptions(instance);var scope=getScope(options,componentOptions);if(__VUE_I18N_LEGACY_API__){// eslint-disable-next-line @typescript-eslint/no-explicit-any
if(i18n.mode==='legacy'&&!options.__useComponent){if(!i18n.allowComposition){throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);}return useI18nForLegacy(instance,scope,gl,options);}}if(scope==='global'){adjustI18nResources(gl,options,componentOptions);return gl;}if(scope==='parent'){// eslint-disable-next-line @typescript-eslint/no-explicit-any
var _composer3=getComposer(i18n,instance,options.__useComponent);if(_composer3==null){if(false){}_composer3=gl;}return _composer3;}var i18nInternal=i18n;var composer=i18nInternal.__getInstance(instance);if(composer==null){var composerOptions=shared_assign({},options);if('__i18n'in componentOptions){composerOptions.__i18n=componentOptions.__i18n;}if(gl){composerOptions.__root=gl;}composer=createComposer(composerOptions);if(i18nInternal.__composerExtend){composer[DisposeSymbol]=i18nInternal.__composerExtend(composer);}setupLifeCycle(i18nInternal,instance,composer);i18nInternal.__setInstance(instance,composer);}return composer;}/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 *//* #__NO_SIDE_EFFECTS__ */var castToVueI18n=function castToVueI18n(i18n// eslint-disable-next-line @typescript-eslint/no-explicit-any
){if(!(__VUE_I18N_BRIDGE__ in i18n)){throw createI18nError(I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);}return i18n;};function createGlobal(options,legacyMode,VueI18nLegacy// eslint-disable-line @typescript-eslint/no-explicit-any
){var scope=effectScope();{var obj=__VUE_I18N_LEGACY_API__&&legacyMode?scope.run(function(){return createVueI18n(options);}):scope.run(function(){return createComposer(options);});if(obj==null){throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);}return[scope,obj];}}function getI18nInstance(instance){{var i18n=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.inject)(!instance.isCE?instance.appContext.app.__VUE_I18N_SYMBOL__:I18nInjectionKey);/* istanbul ignore if */if(!i18n){throw createI18nError(!instance.isCE?I18nErrorCodes.UNEXPECTED_ERROR:I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);}return i18n;}}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getScope(options,componentOptions){// prettier-ignore
return isEmptyObject(options)?'__i18n'in componentOptions?'local':'global':!options.useScope?'local':options.useScope;}function getGlobalComposer(i18n){// prettier-ignore
return i18n.mode==='composition'?i18n.global:i18n.global.__composer;}function getComposer(i18n,target){var useComponent=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var composer=null;var root=target.root;var current=getParentComponentInstance(target,useComponent);while(current!=null){var i18nInternal=i18n;if(i18n.mode==='composition'){composer=i18nInternal.__getInstance(current);}else{if(__VUE_I18N_LEGACY_API__){var vueI18n=i18nInternal.__getInstance(current);if(vueI18n!=null){composer=vueI18n.__composer;if(useComponent&&composer&&!composer[InejctWithOptionSymbol]// eslint-disable-line @typescript-eslint/no-explicit-any
){composer=null;}}}}if(composer!=null){break;}if(root===current){break;}current=current.parent;}return composer;}function getParentComponentInstance(target){var useComponent=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(target==null){return null;}{// if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
return!useComponent?target.parent:target.vnode.ctx||target.parent;// eslint-disable-line @typescript-eslint/no-explicit-any
}}function setupLifeCycle(i18n,target,composer){var emitter=null;{(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.onMounted)(function(){// inject composer instance to DOM for intlify-devtools
if(false){}},target);(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.onUnmounted)(function(){// eslint-disable-next-line @typescript-eslint/no-explicit-any
var _composer=composer;// remove composer instance from DOM for intlify-devtools
if(false){}i18n.__deleteInstance(target);// dispose extended resources
var dispose=_composer[DisposeSymbol];if(dispose){dispose();delete _composer[DisposeSymbol];}},target);}}function useI18nForLegacy(instance,scope,root){var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var isLocalScope=scope==='local';var _composer=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.shallowRef)(null);if(isLocalScope&&instance.proxy&&!(instance.proxy.$options.i18n||instance.proxy.$options.__i18n)){throw createI18nError(I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);}var _inheritLocale=shared_isBoolean(options.inheritLocale)?options.inheritLocale:!shared_isString(options.locale);var _locale=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(// prettier-ignore
!isLocalScope||_inheritLocale?root.locale.value:shared_isString(options.locale)?options.locale:core_base_DEFAULT_LOCALE);var _fallbackLocale=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(// prettier-ignore
!isLocalScope||_inheritLocale?root.fallbackLocale.value:shared_isString(options.fallbackLocale)||shared_isArray(options.fallbackLocale)||shared_isPlainObject(options.fallbackLocale)||options.fallbackLocale===false?options.fallbackLocale:_locale.value);var _messages=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(getLocaleMessages(_locale.value,options));// prettier-ignore
var _datetimeFormats=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(shared_isPlainObject(options.datetimeFormats)?options.datetimeFormats:_defineProperty2({},_locale.value,{}));// prettier-ignore
var _numberFormats=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(shared_isPlainObject(options.numberFormats)?options.numberFormats:_defineProperty2({},_locale.value,{}));// prettier-ignore
var _missingWarn=isLocalScope?root.missingWarn:shared_isBoolean(options.missingWarn)||shared_isRegExp(options.missingWarn)?options.missingWarn:true;// prettier-ignore
var _fallbackWarn=isLocalScope?root.fallbackWarn:shared_isBoolean(options.fallbackWarn)||shared_isRegExp(options.fallbackWarn)?options.fallbackWarn:true;// prettier-ignore
var _fallbackRoot=isLocalScope?root.fallbackRoot:shared_isBoolean(options.fallbackRoot)?options.fallbackRoot:true;// configure fall back to root
var _fallbackFormat=!!options.fallbackFormat;// runtime missing
var _missing=shared_isFunction(options.missing)?options.missing:null;// postTranslation handler
var _postTranslation=shared_isFunction(options.postTranslation)?options.postTranslation:null;// prettier-ignore
var _warnHtmlMessage=isLocalScope?root.warnHtmlMessage:shared_isBoolean(options.warnHtmlMessage)?options.warnHtmlMessage:true;var _escapeParameter=!!options.escapeParameter;// prettier-ignore
var _modifiers=isLocalScope?root.modifiers:shared_isPlainObject(options.modifiers)?options.modifiers:{};// pluralRules
var _pluralRules=options.pluralRules||isLocalScope&&root.pluralRules;// track reactivity
function trackReactivityValues(){return[_locale.value,_fallbackLocale.value,_messages.value,_datetimeFormats.value,_numberFormats.value];}// locale
var locale=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)({get:function get(){return _composer.value?_composer.value.locale.value:_locale.value;},set:function set(val){if(_composer.value){_composer.value.locale.value=val;}_locale.value=val;}});// fallbackLocale
var fallbackLocale=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)({get:function get(){return _composer.value?_composer.value.fallbackLocale.value:_fallbackLocale.value;},set:function set(val){if(_composer.value){_composer.value.fallbackLocale.value=val;}_fallbackLocale.value=val;}});// messages
var messages=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){if(_composer.value){// eslint-disable-next-line @typescript-eslint/no-explicit-any
return _composer.value.messages.value;}else{// eslint-disable-next-line @typescript-eslint/no-explicit-any
return _messages.value;}});var datetimeFormats=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return _datetimeFormats.value;});var numberFormats=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return _numberFormats.value;});function getPostTranslationHandler(){return _composer.value?_composer.value.getPostTranslationHandler():_postTranslation;}function setPostTranslationHandler(handler){if(_composer.value){_composer.value.setPostTranslationHandler(handler);}}function getMissingHandler(){return _composer.value?_composer.value.getMissingHandler():_missing;}function setMissingHandler(handler){if(_composer.value){_composer.value.setMissingHandler(handler);}}function warpWithDeps(fn){trackReactivityValues();return fn();}function t(){for(var _len29=arguments.length,args=new Array(_len29),_key29=0;_key29<_len29;_key29++){args[_key29]=arguments[_key29];}return _composer.value?warpWithDeps(function(){return Reflect.apply(_composer.value.t,null,[].concat(args));}):warpWithDeps(function(){return'';});}function rt(){for(var _len30=arguments.length,args=new Array(_len30),_key30=0;_key30<_len30;_key30++){args[_key30]=arguments[_key30];}return _composer.value?Reflect.apply(_composer.value.rt,null,[].concat(args)):'';}function d(){for(var _len31=arguments.length,args=new Array(_len31),_key31=0;_key31<_len31;_key31++){args[_key31]=arguments[_key31];}return _composer.value?warpWithDeps(function(){return Reflect.apply(_composer.value.d,null,[].concat(args));}):warpWithDeps(function(){return'';});}function n(){for(var _len32=arguments.length,args=new Array(_len32),_key32=0;_key32<_len32;_key32++){args[_key32]=arguments[_key32];}return _composer.value?warpWithDeps(function(){return Reflect.apply(_composer.value.n,null,[].concat(args));}):warpWithDeps(function(){return'';});}function tm(key){return _composer.value?_composer.value.tm(key):{};}function te(key,locale){return _composer.value?_composer.value.te(key,locale):false;}function getLocaleMessage(locale){return _composer.value?_composer.value.getLocaleMessage(locale):{};}function setLocaleMessage(locale,message){if(_composer.value){_composer.value.setLocaleMessage(locale,message);_messages.value[locale]=message;}}function mergeLocaleMessage(locale,message){if(_composer.value){_composer.value.mergeLocaleMessage(locale,message);}}function getDateTimeFormat(locale){return _composer.value?_composer.value.getDateTimeFormat(locale):{};}function setDateTimeFormat(locale,format){if(_composer.value){_composer.value.setDateTimeFormat(locale,format);_datetimeFormats.value[locale]=format;}}function mergeDateTimeFormat(locale,format){if(_composer.value){_composer.value.mergeDateTimeFormat(locale,format);}}function getNumberFormat(locale){return _composer.value?_composer.value.getNumberFormat(locale):{};}function setNumberFormat(locale,format){if(_composer.value){_composer.value.setNumberFormat(locale,format);_numberFormats.value[locale]=format;}}function mergeNumberFormat(locale,format){if(_composer.value){_composer.value.mergeNumberFormat(locale,format);}}var wrapper={get id(){return _composer.value?_composer.value.id:-1;},locale:locale,fallbackLocale:fallbackLocale,messages:messages,datetimeFormats:datetimeFormats,numberFormats:numberFormats,get inheritLocale(){return _composer.value?_composer.value.inheritLocale:_inheritLocale;},set inheritLocale(val){if(_composer.value){_composer.value.inheritLocale=val;}},get availableLocales(){return _composer.value?_composer.value.availableLocales:Object.keys(_messages.value);},get modifiers(){return _composer.value?_composer.value.modifiers:_modifiers;},get pluralRules(){return _composer.value?_composer.value.pluralRules:_pluralRules;},get isGlobal(){return _composer.value?_composer.value.isGlobal:false;},get missingWarn(){return _composer.value?_composer.value.missingWarn:_missingWarn;},set missingWarn(val){if(_composer.value){_composer.value.missingWarn=val;}},get fallbackWarn(){return _composer.value?_composer.value.fallbackWarn:_fallbackWarn;},set fallbackWarn(val){if(_composer.value){_composer.value.missingWarn=val;}},get fallbackRoot(){return _composer.value?_composer.value.fallbackRoot:_fallbackRoot;},set fallbackRoot(val){if(_composer.value){_composer.value.fallbackRoot=val;}},get fallbackFormat(){return _composer.value?_composer.value.fallbackFormat:_fallbackFormat;},set fallbackFormat(val){if(_composer.value){_composer.value.fallbackFormat=val;}},get warnHtmlMessage(){return _composer.value?_composer.value.warnHtmlMessage:_warnHtmlMessage;},set warnHtmlMessage(val){if(_composer.value){_composer.value.warnHtmlMessage=val;}},get escapeParameter(){return _composer.value?_composer.value.escapeParameter:_escapeParameter;},set escapeParameter(val){if(_composer.value){_composer.value.escapeParameter=val;}},t:t,getPostTranslationHandler:getPostTranslationHandler,setPostTranslationHandler:setPostTranslationHandler,getMissingHandler:getMissingHandler,setMissingHandler:setMissingHandler,rt:rt,d:d,n:n,tm:tm,te:te,getLocaleMessage:getLocaleMessage,setLocaleMessage:setLocaleMessage,mergeLocaleMessage:mergeLocaleMessage,getDateTimeFormat:getDateTimeFormat,setDateTimeFormat:setDateTimeFormat,mergeDateTimeFormat:mergeDateTimeFormat,getNumberFormat:getNumberFormat,setNumberFormat:setNumberFormat,mergeNumberFormat:mergeNumberFormat};function sync(composer){composer.locale.value=_locale.value;composer.fallbackLocale.value=_fallbackLocale.value;Object.keys(_messages.value).forEach(function(locale){composer.mergeLocaleMessage(locale,_messages.value[locale]);});Object.keys(_datetimeFormats.value).forEach(function(locale){composer.mergeDateTimeFormat(locale,_datetimeFormats.value[locale]);});Object.keys(_numberFormats.value).forEach(function(locale){composer.mergeNumberFormat(locale,_numberFormats.value[locale]);});composer.escapeParameter=_escapeParameter;composer.fallbackFormat=_fallbackFormat;composer.fallbackRoot=_fallbackRoot;composer.fallbackWarn=_fallbackWarn;composer.missingWarn=_missingWarn;composer.warnHtmlMessage=_warnHtmlMessage;}(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.onBeforeMount)(function(){if(instance.proxy==null||instance.proxy.$i18n==null){throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);}// eslint-disable-next-line @typescript-eslint/no-explicit-any
var composer=_composer.value=instance.proxy.$i18n.__composer;if(scope==='global'){_locale.value=composer.locale.value;_fallbackLocale.value=composer.fallbackLocale.value;_messages.value=composer.messages.value;_datetimeFormats.value=composer.datetimeFormats.value;_numberFormats.value=composer.numberFormats.value;}else if(isLocalScope){sync(composer);}});return wrapper;}var globalExportProps=/* unused pure expression or super */null&&0;var globalExportMethods=/* unused pure expression or super */null&&0;function injectGlobalFields(app,composer){var i18n=Object.create(null);globalExportProps.forEach(function(prop){var desc=Object.getOwnPropertyDescriptor(composer,prop);if(!desc){throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);}var wrap=isRef(desc.value)// check computed props
?{get:function get(){return desc.value.value;},// eslint-disable-next-line @typescript-eslint/no-explicit-any
set:function set(val){desc.value.value=val;}}:{get:function get(){return desc.get&&desc.get();}};Object.defineProperty(i18n,prop,wrap);});app.config.globalProperties.$i18n=i18n;globalExportMethods.forEach(function(method){var desc=Object.getOwnPropertyDescriptor(composer,method);if(!desc||!desc.value){throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);}Object.defineProperty(app.config.globalProperties,"$".concat(method),desc);});var dispose=function dispose(){// eslint-disable-next-line @typescript-eslint/no-explicit-any
delete app.config.globalProperties.$i18n;globalExportMethods.forEach(function(method){// eslint-disable-next-line @typescript-eslint/no-explicit-any
delete app.config.globalProperties["$".concat(method)];});};return dispose;}{vue_i18n_initFeatureFlags();}// register message compiler at vue-i18n
if(__INTLIFY_JIT_COMPILATION__){registerMessageCompiler(compile);}else{registerMessageCompiler(compileToFunction);}// register message resolver at vue-i18n
registerMessageResolver(resolveValue);// register fallback locale at vue-i18n
registerLocaleFallbacker(fallbackWithLocaleChain);// NOTE: experimental !!
if( false||__INTLIFY_PROD_DEVTOOLS__){var target=getGlobalThis();target.__INTLIFY__=true;setDevToolsHook(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);}if(false){};// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/AccountboxTooltip.vue?vue&type=script&setup=true&lang=ts
var AccountboxTooltipvue_type_script_setup_true_lang_ts_hoisted_1={id:"bonusVisualization",class:"accountbox-tooltip-content"};var _hoisted_2={class:"accountbox-tooltip-real"};var _hoisted_3={class:"accountbox-tooltip-real-value","data-qe-id":"accountbox-tooltip-withdrawable"};var _hoisted_4={class:"accountbox-tooltip-bonus"};var _hoisted_5={class:"accountbox-tooltip-bonus-value","data-qe-id":"accountbox-tooltip-bonus"};/* harmony default export */var AccountboxTooltipvue_type_script_setup_true_lang_ts=/*@__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({__name:'AccountboxTooltip',props:{withdrawAbleAmount:{type:String},lockedAmount:{type:String}},setup:function setup(__props){var _useI18n=useI18n({}),t=_useI18n.t;return function(_ctx,_cache){var _component_t_tooltip=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.resolveComponent)("t-tooltip");return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createBlock)(_component_t_tooltip,{bc:"",class:"accountbox-tooltip"},{text:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withCtx)(function(){return[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div",AccountboxTooltipvue_type_script_setup_true_lang_ts_hoisted_1,[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",_hoisted_2,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(t)('accountbox.main.AccountBox_tooltip_real')),1),_cache[0]||(_cache[0]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("br",null,null,-1)),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",_hoisted_3,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)(__props.withdrawAbleAmount),1),_cache[1]||(_cache[1]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("br",null,null,-1)),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",_hoisted_4,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(t)('accountbox.main.AccountBox_tooltip_bonus')),1),_cache[2]||(_cache[2]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("br",null,null,-1)),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",_hoisted_5,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)(__props.lockedAmount),1)])];}),default:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withCtx)(function(){return[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.renderSlot)(_ctx.$slots,"default")];}),_:3});};}});;// ./src/components/AccountboxTooltip.vue?vue&type=script&setup=true&lang=ts
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/AccountboxTooltip.vue?vue&type=style&index=0&id=0ea865e4&lang=less
// extracted by mini-css-extract-plugin
;// ./src/components/AccountboxTooltip.vue?vue&type=style&index=0&id=0ea865e4&lang=less
;// ./src/components/AccountboxTooltip.vue
;var AccountboxTooltip_exports_=AccountboxTooltipvue_type_script_setup_true_lang_ts;/* harmony default export */var AccountboxTooltip=AccountboxTooltip_exports_;;// ../../node_modules/@gd/currency-converter/dist/lib/GDC_CODES.js
/**
 *
 * @type {{GGBP: {symbol: string, digits: number, locale: string}, GBP: {symbol: string, digits: number, locale: string}, GUSD: {symbol: string, digits: number, locale: string}, USD: {symbol: string, digits: number, locale: string}, GSEK: {symbol: string, digits: number, locale: string}, SEK: {symbol: string, digits: number, locale: string}, GDKK: {symbol: string, digits: number, locale: string}, DKK: {symbol: string, digits: number, locale: string}, EUR: {symbol: string, digits: number, locale: string}, DIA: {symbol: string, symbolShort: string, digits: number, locale: string}, CAD: {symbol: string, digits: number, locale: string}}}
 */var GDC_CODES={GGBP:{symbol:"G\xA3",digits:0,factor:100,locale:'en-GB'},GBP:{symbol:"\xA3",digits:2,factor:1,locale:'en-GB'},GUSD:{symbol:'G$',digits:0,factor:100,locale:'en-US'},USD:{symbol:'$',digits:2,factor:1,locale:'en-US'},GSEK:{symbol:'Gkr',digits:0,factor:100,locale:'sv-SE'},SEK:{symbol:'kr',digits:2,factor:1,locale:'sv-SE'},GDKK:{symbol:'Gkr',digits:0,factor:100,locale:'da-DK'},DKK:{symbol:'kr.',digits:2,factor:1,locale:'da-DK'},EUR:{symbol:"\u20AC",digits:2,factor:1,locale:'de'},DIA:{symbol:'Diamants',// symbolShort: 'D',
digits:0,factor:100,locale:'fr'},CAD:{symbol:'$',digits:2,factor:1,locale:'en-CA'},CRED:{symbol:'Credits',digits:0,factor:100,locale:'en-US'}};var GDC_CODES_FALLBACK={GGBP:{exp:GDC_CODES.GGBP.symbol+"{num}"},GBP:{exp:GDC_CODES.GBP.symbol+"{num}"},GUSD:{exp:GDC_CODES.GUSD.symbol+"{num}"},USD:{exp:GDC_CODES.USD.symbol+"{num}"},GSEK:{exp:"{num}\xA0"+GDC_CODES.GSEK.symbol},SEK:{exp:"{num}\xA0"+GDC_CODES.SEK.symbol},GDKK:{exp:"{num}\xA0"+GDC_CODES.GDKK.symbol},DKK:{exp:"{num}\xA0"+GDC_CODES.DKK.symbol},EUR:{exp:"{num}\xA0"+GDC_CODES.EUR.symbol},DIA:{exp:"{num}\xA0"+GDC_CODES.DIA.symbol},CAD:{exp:GDC_CODES.CAD.symbol+"{num}"},CRED:{exp:"{num}\xA0"+GDC_CODES.CRED.symbol}};/* harmony default export */var lib_GDC_CODES=/* unused pure expression or super */null&&0;;// ../../node_modules/@gd/currency-converter/dist/lib/converter.js
var cutomGDC_CODES=['GUSD','DIA','GDKK','GSEK','GGBP','CRED'];/**
 * cut to 2 maximum digits
 * @param value
 */function digitsCut(value){var lengthToCut=value.length-parseFloat(value).toFixed(2).length;if(lengthToCut>0){return value.slice(0,lengthToCut*-1);}return value;}function convertValue(value,gdc){var v=parseFloat(digitsCut(''+value));return v*GDC_CODES[gdc].factor;}function checkIfBrowserSupportsIntl(locales){var supportsLocale=!!((typeof Intl==="undefined"?"undefined":_typeof2(Intl))==='object'&&Intl&&typeof Intl.NumberFormat==='function'),supportedLocaleList;if(supportsLocale){supportsLocale=false;supportedLocaleList=Intl.NumberFormat.supportedLocalesOf(locales);for(var i=0;i<locales.length;i++){if(supportedLocaleList.indexOf(locales[i])!==-1){supportsLocale=true;}}}return supportsLocale;}function getDelemitter(locale){return 1.1.toLocaleString(locale).split('1')[1];}function handlePrimitivFormatting(value,gdc){var delemitter=getDelemitter(GDC_CODES[gdc].locale);var n=GDC_CODES[gdc].factor===100?parseInt(''+value):parseFloat(''+value);var v=n.toLocaleString(GDC_CODES[gdc].locale);if(GDC_CODES[gdc].factor===1){if(v.indexOf(delemitter)===-1){// no delemitter
v+=delemitter+"00";}else{// make sure we have only 2 digits
var split=v.split(delemitter);if(split[1].length<2){v+='0';}else if(split[1].length>2){v=split[0]+delemitter+split[1].slice(0,2);}}}return GDC_CODES_FALLBACK[gdc].exp.replace('{num}',''+v);}function convert(value,obj){if(!obj)throw new Error('Missing second argument');if(!obj.gdc)throw new Error('Missing gdc property in second argument');if(obj.locale===undefined)obj.locale=GDC_CODES[obj.gdc].locale;if(checkIfBrowserSupportsIntl([obj.locale])){if(cutomGDC_CODES.indexOf(obj.gdc)!==-1){// DIA and CRED are rendered as "currencyDisplay: 'name'" - this is in all languages
var intl=new Intl.NumberFormat(obj.locale,{style:'currency',currency:'EUR',currencyDisplay:obj.gdc==='DIA'||obj.gdc==='CRED'?'name':'symbol',minimumFractionDigits:GDC_CODES[obj.gdc].digits,maximumFractionDigits:GDC_CODES[obj.gdc].digits});return intl.format(convertValue(value,obj.gdc)).replace(/€|EUR|euros|Euro|euro/,GDC_CODES[obj.gdc].symbol).replace(' ',"\xA0")// cut digits - thanks to edge which has a bug which ignores
// the minimumFractionDigits https://github.com/microsoft/ChakraCore/issues/6029
//...so lets cut everything after the delemitter which is a number
.replace(GDC_CODES[obj.gdc].digits===0?new RegExp("\\"+getDelemitter(obj.locale)+"[0-9]*"):'','');}else{var intl=new Intl.NumberFormat(obj.locale,{style:'currency',currency:obj.gdc});return intl.format(convertValue(value,obj.gdc));}}else{// fallback handler
// TODO:jslog if we still need support this
return handlePrimitivFormatting(convertValue(value,obj.gdc),obj.gdc);}};// ../../node_modules/@gd/currency-converter/dist/index.js
/* harmony default export */var dist=/* unused pure expression or super */null&&0;;// ../../node_modules/mitt/dist/mitt.mjs
/* harmony default export */function mitt(n){return{all:n=n||new Map(),on:function on(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e]);},off:function off(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]));},emit:function emit(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e);}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e);});}};};// ../../node_modules/@gd/event-bus/dist/EventBus.js
var emitter=mitt();emitter.once=function(type,fn){emitter.on(type,fn);emitter.on(type,emitter.off.bind(emitter,type,fn));};var eventHandler={$on:emitter.on,$once:emitter.once,$off:emitter.off,$emit:emitter.emit};window.GD=window.GD||{};// register hidden - it's bad practice when we register here directly
// to GD.event (registration on GD will be in the classic-gd module)
var eventBus=window.GD.__eventBus=window.GD.__eventBus||eventHandler;/* harmony default export */var EventBus=eventBus;;// ../../node_modules/@gd/event-bus/dist/index.js
/* harmony default export */var event_bus_dist=EventBus;// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.symbol.js
var es_symbol=__nested_webpack_require_186475__(8070);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description=__nested_webpack_require_186475__(3510);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator=__nested_webpack_require_186475__(2432);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator=__nested_webpack_require_186475__(3873);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator=__nested_webpack_require_186475__(1011);// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator=__nested_webpack_require_186475__(7010);;// ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o;}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o;},_typeof(o);}// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive=__nested_webpack_require_186475__(5307);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause=__nested_webpack_require_186475__(7107);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive=__nested_webpack_require_186475__(595);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor=__nested_webpack_require_186475__(3185);;// ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t,r){if("object"!=_typeof(t)||!t)return t;var e=t[Symbol.toPrimitive];if(void 0!==e){var i=e.call(t,r||"default");if("object"!=_typeof(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return("string"===r?String:Number)(t);};// ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t){var i=toPrimitive(t,"string");return"symbol"==_typeof(i)?i:i+"";};// ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(e,r,t){return(r=toPropertyKey(r))in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e;}// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec=__nested_webpack_require_186475__(8376);// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.string.match.js
var es_string_match=__nested_webpack_require_186475__(9428);;// ../../libs/i18n/node_modules/@intlify/shared/dist/shared.mjs
/*!
  * shared v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  *//**
 * Original Utilities
 * written by kazuya kawaguchi
 */var dist_shared_inBrowser=typeof window!=='undefined';var shared_mark;var shared_measure;if(false){}var shared_RE_ARGS=/\{([0-9a-zA-Z]+)\}/g;/* eslint-disable */function dist_shared_format(message){for(var _len33=arguments.length,args=new Array(_len33>1?_len33-1:0),_key33=1;_key33<_len33;_key33++){args[_key33-1]=arguments[_key33];}if(args.length===1&&dist_shared_isObject(args[0])){args=args[0];}if(!args||!args.hasOwnProperty){args={};}return message.replace(shared_RE_ARGS,function(match,identifier){return args.hasOwnProperty(identifier)?args[identifier]:'';});}var dist_shared_makeSymbol=function dist_shared_makeSymbol(name){var shareable=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return!shareable?Symbol(name):Symbol.for(name);};var shared_generateFormatCacheKey=function shared_generateFormatCacheKey(locale,key,source){return shared_friendlyJSONstringify({l:locale,k:key,s:source});};var shared_friendlyJSONstringify=function shared_friendlyJSONstringify(json){return JSON.stringify(json).replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029").replace(/\u0027/g,"\\u0027");};var dist_shared_isNumber=function dist_shared_isNumber(val){return typeof val==='number'&&isFinite(val);};var shared_isDate=function shared_isDate(val){return shared_toTypeString(val)==='[object Date]';};var dist_shared_isRegExp=function dist_shared_isRegExp(val){return shared_toTypeString(val)==='[object RegExp]';};var shared_isEmptyObject=function shared_isEmptyObject(val){return dist_shared_isPlainObject(val)&&Object.keys(val).length===0;};var dist_shared_assign=Object.assign;var _create=Object.create;var shared_create=function shared_create(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return _create(obj);};var shared_globalThis;var shared_getGlobalThis=function shared_getGlobalThis(){// prettier-ignore
return shared_globalThis||(shared_globalThis=typeof globalThis!=='undefined'?globalThis:typeof self!=='undefined'?self:typeof window!=='undefined'?window:typeof __webpack_require__.g!=='undefined'?__webpack_require__.g:shared_create());};function shared_escapeHtml(rawText){return rawText.replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&apos;');}var dist_shared_hasOwnProperty=Object.prototype.hasOwnProperty;function shared_hasOwn(obj,key){return dist_shared_hasOwnProperty.call(obj,key);}/* eslint-enable *//**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */var dist_shared_isArray=Array.isArray;var dist_shared_isFunction=function dist_shared_isFunction(val){return typeof val==='function';};var dist_shared_isString=function dist_shared_isString(val){return typeof val==='string';};var dist_shared_isBoolean=function dist_shared_isBoolean(val){return typeof val==='boolean';};var shared_isSymbol=function shared_isSymbol(val){return _typeof2(val)==='symbol';};// eslint-disable-next-line @typescript-eslint/no-explicit-any
var dist_shared_isObject=function dist_shared_isObject(val){return val!==null&&_typeof2(val)==='object';};// eslint-disable-next-line @typescript-eslint/no-explicit-any
var shared_isPromise=function shared_isPromise(val){return dist_shared_isObject(val)&&dist_shared_isFunction(val.then)&&dist_shared_isFunction(val.catch);};var shared_objectToString=Object.prototype.toString;var shared_toTypeString=function shared_toTypeString(value){return shared_objectToString.call(value);};var dist_shared_isPlainObject=function dist_shared_isPlainObject(val){return shared_toTypeString(val)==='[object Object]';};// for converting list and named values to displayed strings.
var shared_toDisplayString=function shared_toDisplayString(val){return val==null?'':dist_shared_isArray(val)||dist_shared_isPlainObject(val)&&val.toString===shared_objectToString?JSON.stringify(val,null,2):String(val);};function shared_join(items){var separator=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return items.reduce(function(str,item,index){return index===0?str+item:str+separator+item;},'');}var shared_RANGE=2;function shared_generateCodeFrame(source){var start=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var end=arguments.length>2&&arguments[2]!==undefined?arguments[2]:source.length;var lines=source.split(/\r?\n/);var count=0;var res=[];for(var i=0;i<lines.length;i++){count+=lines[i].length+1;if(count>=start){for(var j=i-shared_RANGE;j<=i+shared_RANGE||end>count;j++){if(j<0||j>=lines.length)continue;var line=j+1;res.push("".concat(line).concat(' '.repeat(3-String(line).length),"|  ").concat(lines[j]));var lineLength=lines[j].length;if(j===i){// push underline
var pad=start-(count-lineLength)+1;var length=Math.max(1,end>count?lineLength-pad:end-start);res.push("   |  "+' '.repeat(pad)+'^'.repeat(length));}else if(j>i){if(end>count){var _length2=Math.max(Math.min(end-count,lineLength),1);res.push("   |  "+'^'.repeat(_length2));}count+=lineLength+1;}}break;}}return res.join('\n');}function dist_shared_warn(msg,err){if(typeof console!=='undefined'){/* istanbul ignore if */if(err){}}}var shared_hasWarned={};function shared_warnOnce(msg){if(!shared_hasWarned[msg]){shared_hasWarned[msg]=true;dist_shared_warn(msg);}}/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 *//**
 * Create a event emitter
 *
 * @returns An event emitter
 */function shared_createEmitter(){var events=new Map();var emitter={events:events,on:function on(event,handler){var handlers=events.get(event);var added=handlers&&handlers.push(handler);if(!added){events.set(event,[handler]);}},off:function off(event,handler){var handlers=events.get(event);if(handlers){handlers.splice(handlers.indexOf(handler)>>>0,1);}},emit:function emit(event,payload){(events.get(event)||[]).slice().map(function(handler){return handler(payload);});(events.get('*')||[]).slice().map(function(handler){return handler(event,payload);});}};return emitter;}var shared_isNotObjectOrIsArray=function shared_isNotObjectOrIsArray(val){return!dist_shared_isObject(val)||dist_shared_isArray(val);};// eslint-disable-next-line @typescript-eslint/no-explicit-any
function shared_deepCopy(src,des){// src and des should both be objects, and none of them can be a array
if(shared_isNotObjectOrIsArray(src)||shared_isNotObjectOrIsArray(des)){throw new Error('Invalid value');}var stack=[{src:src,des:des}];var _loop2=function _loop2(){var _stack$pop2=stack.pop(),src=_stack$pop2.src,des=_stack$pop2.des;// using `Object.keys` which skips prototype properties
Object.keys(src).forEach(function(key){if(key==='__proto__'){return;}// if src[key] is an object/array, set des[key]
// to empty object/array to prevent setting by reference
if(dist_shared_isObject(src[key])&&!dist_shared_isObject(des[key])){des[key]=Array.isArray(src[key])?[]:shared_create();}if(shared_isNotObjectOrIsArray(des[key])||shared_isNotObjectOrIsArray(src[key])){// replace with src[key] when:
// src[key] or des[key] is not an object, or
// src[key] or des[key] is an array
des[key]=src[key];}else{// src[key] and des[key] are both objects, merge them
stack.push({src:src[key],des:des[key]});}});};while(stack.length){_loop2();}};// ../../libs/i18n/node_modules/@intlify/message-compiler/dist/message-compiler.mjs
/*!
  * message-compiler v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */var message_compiler_LOCATION_STUB={start:{line:1,column:1,offset:0},end:{line:1,column:1,offset:0}};function message_compiler_createPosition(line,column,offset){return{line:line,column:column,offset:offset};}function message_compiler_createLocation(start,end,source){var loc={start:start,end:end};if(source!=null){loc.source=source;}return loc;}var message_compiler_CompileErrorCodes={// tokenizer error codes
EXPECTED_TOKEN:1,INVALID_TOKEN_IN_PLACEHOLDER:2,UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER:3,UNKNOWN_ESCAPE_SEQUENCE:4,INVALID_UNICODE_ESCAPE_SEQUENCE:5,UNBALANCED_CLOSING_BRACE:6,UNTERMINATED_CLOSING_BRACE:7,EMPTY_PLACEHOLDER:8,NOT_ALLOW_NEST_PLACEHOLDER:9,INVALID_LINKED_FORMAT:10,// parser error codes
MUST_HAVE_MESSAGES_IN_PLURAL:11,UNEXPECTED_EMPTY_LINKED_MODIFIER:12,UNEXPECTED_EMPTY_LINKED_KEY:13,UNEXPECTED_LEXICAL_ANALYSIS:14,// generator error codes
UNHANDLED_CODEGEN_NODE_TYPE:15,// minifier error codes
UNHANDLED_MINIFIER_NODE_TYPE:16};// Special value for higher-order compilers to pick up the last code
// to avoid collision of error codes.
// This should always be kept as the last item.
var COMPILE_ERROR_CODES_EXTEND_POINT=17;/** @internal */var message_compiler_errorMessages=(_message_compiler_err={},_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_message_compiler_err,message_compiler_CompileErrorCodes.EXPECTED_TOKEN,"Expected token: '{0}'"),message_compiler_CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER,"Invalid token in placeholder: '{0}'"),message_compiler_CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER,"Unterminated single quote in placeholder"),message_compiler_CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE,"Unknown escape sequence: \\{0}"),message_compiler_CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE,"Invalid unicode escape sequence: {0}"),message_compiler_CompileErrorCodes.UNBALANCED_CLOSING_BRACE,"Unbalanced closing brace"),message_compiler_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,"Unterminated closing brace"),message_compiler_CompileErrorCodes.EMPTY_PLACEHOLDER,"Empty placeholder"),message_compiler_CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER,"Not allowed nest placeholder"),message_compiler_CompileErrorCodes.INVALID_LINKED_FORMAT,"Invalid linked format"),_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_message_compiler_err,message_compiler_CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL,"Plural must have messages"),message_compiler_CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER,"Unexpected empty linked modifier"),message_compiler_CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY,"Unexpected empty linked key"),message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,"Unexpected lexical analysis in token: '{0}'"),message_compiler_CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE,"unhandled codegen node type: '{0}'"),message_compiler_CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE,"unhandled mimifier node type: '{0}'"));function message_compiler_createCompileError(code,loc){var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var domain=options.domain,messages=options.messages,args=options.args;var msg= false?0:code;var error=new SyntaxError(String(msg));error.code=code;if(loc){error.location=loc;}error.domain=domain;return error;}/** @internal */function message_compiler_defaultOnError(error){throw error;}// eslint-disable-next-line no-useless-escape
var message_compiler_RE_HTML_TAG=/<\/?[\w\s="/.':;#-\/]+>/;var message_compiler_detectHtmlTag=function message_compiler_detectHtmlTag(source){return message_compiler_RE_HTML_TAG.test(source);};var message_compiler_CHAR_SP=' ';var message_compiler_CHAR_CR='\r';var message_compiler_CHAR_LF='\n';var message_compiler_CHAR_LS=String.fromCharCode(0x2028);var message_compiler_CHAR_PS=String.fromCharCode(0x2029);function message_compiler_createScanner(str){var _buf=str;var _index=0;var _line=1;var _column=1;var _peekOffset=0;var isCRLF=function isCRLF(index){return _buf[index]===message_compiler_CHAR_CR&&_buf[index+1]===message_compiler_CHAR_LF;};var isLF=function isLF(index){return _buf[index]===message_compiler_CHAR_LF;};var isPS=function isPS(index){return _buf[index]===message_compiler_CHAR_PS;};var isLS=function isLS(index){return _buf[index]===message_compiler_CHAR_LS;};var isLineEnd=function isLineEnd(index){return isCRLF(index)||isLF(index)||isPS(index)||isLS(index);};var index=function index(){return _index;};var line=function line(){return _line;};var column=function column(){return _column;};var peekOffset=function peekOffset(){return _peekOffset;};var charAt=function charAt(offset){return isCRLF(offset)||isPS(offset)||isLS(offset)?message_compiler_CHAR_LF:_buf[offset];};var currentChar=function currentChar(){return charAt(_index);};var currentPeek=function currentPeek(){return charAt(_index+_peekOffset);};function next(){_peekOffset=0;if(isLineEnd(_index)){_line++;_column=0;}if(isCRLF(_index)){_index++;}_index++;_column++;return _buf[_index];}function peek(){if(isCRLF(_index+_peekOffset)){_peekOffset++;}_peekOffset++;return _buf[_index+_peekOffset];}function reset(){_index=0;_line=1;_column=1;_peekOffset=0;}function resetPeek(){var offset=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;_peekOffset=offset;}function skipToPeek(){var target=_index+_peekOffset;while(target!==_index){next();}_peekOffset=0;}return{index:index,line:line,column:column,peekOffset:peekOffset,charAt:charAt,currentChar:currentChar,currentPeek:currentPeek,next:next,peek:peek,reset:reset,resetPeek:resetPeek,skipToPeek:skipToPeek};}var message_compiler_EOF=undefined;var message_compiler_DOT='.';var message_compiler_LITERAL_DELIMITER="'";var message_compiler_ERROR_DOMAIN$3='tokenizer';function message_compiler_createTokenizer(source){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var location=options.location!==false;var _scnr=message_compiler_createScanner(source);var currentOffset=function currentOffset(){return _scnr.index();};var currentPosition=function currentPosition(){return message_compiler_createPosition(_scnr.line(),_scnr.column(),_scnr.index());};var _initLoc=currentPosition();var _initOffset=currentOffset();var _context={currentType:13/* TokenTypes.EOF */,offset:_initOffset,startLoc:_initLoc,endLoc:_initLoc,lastType:13/* TokenTypes.EOF */,lastOffset:_initOffset,lastStartLoc:_initLoc,lastEndLoc:_initLoc,braceNest:0,inLinked:false,text:''};var context=function context(){return _context;};var onError=options.onError;function emitError(code,pos,offset){var ctx=context();pos.column+=offset;pos.offset+=offset;if(onError){var loc=location?message_compiler_createLocation(ctx.startLoc,pos):null;for(var _len34=arguments.length,args=new Array(_len34>3?_len34-3:0),_key34=3;_key34<_len34;_key34++){args[_key34-3]=arguments[_key34];}var err=message_compiler_createCompileError(code,loc,{domain:message_compiler_ERROR_DOMAIN$3,args:args});onError(err);}}function getToken(context,type,value){context.endLoc=currentPosition();context.currentType=type;var token={type:type};if(location){token.loc=message_compiler_createLocation(context.startLoc,context.endLoc);}if(value!=null){token.value=value;}return token;}var getEndToken=function getEndToken(context){return getToken(context,13/* TokenTypes.EOF */);};function eat(scnr,ch){if(scnr.currentChar()===ch){scnr.next();return ch;}else{emitError(message_compiler_CompileErrorCodes.EXPECTED_TOKEN,currentPosition(),0,ch);return'';}}function peekSpaces(scnr){var buf='';while(scnr.currentPeek()===message_compiler_CHAR_SP||scnr.currentPeek()===message_compiler_CHAR_LF){buf+=scnr.currentPeek();scnr.peek();}return buf;}function skipSpaces(scnr){var buf=peekSpaces(scnr);scnr.skipToPeek();return buf;}function isIdentifierStart(ch){if(ch===message_compiler_EOF){return false;}var cc=ch.charCodeAt(0);return cc>=97&&cc<=122||// a-z
cc>=65&&cc<=90||// A-Z
cc===95// _
;}function isNumberStart(ch){if(ch===message_compiler_EOF){return false;}var cc=ch.charCodeAt(0);return cc>=48&&cc<=57;// 0-9
}function isNamedIdentifierStart(scnr,context){var currentType=context.currentType;if(currentType!==2/* TokenTypes.BraceLeft */){return false;}peekSpaces(scnr);var ret=isIdentifierStart(scnr.currentPeek());scnr.resetPeek();return ret;}function isListIdentifierStart(scnr,context){var currentType=context.currentType;if(currentType!==2/* TokenTypes.BraceLeft */){return false;}peekSpaces(scnr);var ch=scnr.currentPeek()==='-'?scnr.peek():scnr.currentPeek();var ret=isNumberStart(ch);scnr.resetPeek();return ret;}function isLiteralStart(scnr,context){var currentType=context.currentType;if(currentType!==2/* TokenTypes.BraceLeft */){return false;}peekSpaces(scnr);var ret=scnr.currentPeek()===message_compiler_LITERAL_DELIMITER;scnr.resetPeek();return ret;}function isLinkedDotStart(scnr,context){var currentType=context.currentType;if(currentType!==7/* TokenTypes.LinkedAlias */){return false;}peekSpaces(scnr);var ret=scnr.currentPeek()==="."/* TokenChars.LinkedDot */;scnr.resetPeek();return ret;}function isLinkedModifierStart(scnr,context){var currentType=context.currentType;if(currentType!==8/* TokenTypes.LinkedDot */){return false;}peekSpaces(scnr);var ret=isIdentifierStart(scnr.currentPeek());scnr.resetPeek();return ret;}function isLinkedDelimiterStart(scnr,context){var currentType=context.currentType;if(!(currentType===7/* TokenTypes.LinkedAlias */||currentType===11/* TokenTypes.LinkedModifier */)){return false;}peekSpaces(scnr);var ret=scnr.currentPeek()===":"/* TokenChars.LinkedDelimiter */;scnr.resetPeek();return ret;}function isLinkedReferStart(scnr,context){var currentType=context.currentType;if(currentType!==9/* TokenTypes.LinkedDelimiter */){return false;}var _fn4=function fn(){var ch=scnr.currentPeek();if(ch==="{"/* TokenChars.BraceLeft */){return isIdentifierStart(scnr.peek());}else if(ch==="@"/* TokenChars.LinkedAlias */||ch==="|"/* TokenChars.Pipe */||ch===":"/* TokenChars.LinkedDelimiter */||ch==="."/* TokenChars.LinkedDot */||ch===message_compiler_CHAR_SP||!ch){return false;}else if(ch===message_compiler_CHAR_LF){scnr.peek();return _fn4();}else{// other characters
return isTextStart(scnr,false);}};var ret=_fn4();scnr.resetPeek();return ret;}function isPluralStart(scnr){peekSpaces(scnr);var ret=scnr.currentPeek()==="|"/* TokenChars.Pipe */;scnr.resetPeek();return ret;}function isTextStart(scnr){var reset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var _fn5=function fn(){var hasSpace=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var prev=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var ch=scnr.currentPeek();if(ch==="{"/* TokenChars.BraceLeft */){return hasSpace;}else if(ch==="@"/* TokenChars.LinkedAlias */||!ch){return hasSpace;}else if(ch==="|"/* TokenChars.Pipe */){return!(prev===message_compiler_CHAR_SP||prev===message_compiler_CHAR_LF);}else if(ch===message_compiler_CHAR_SP){scnr.peek();return _fn5(true,message_compiler_CHAR_SP);}else if(ch===message_compiler_CHAR_LF){scnr.peek();return _fn5(true,message_compiler_CHAR_LF);}else{return true;}};var ret=_fn5();reset&&scnr.resetPeek();return ret;}function takeChar(scnr,fn){var ch=scnr.currentChar();if(ch===message_compiler_EOF){return message_compiler_EOF;}if(fn(ch)){scnr.next();return ch;}return null;}function isIdentifier(ch){var cc=ch.charCodeAt(0);return cc>=97&&cc<=122||// a-z
cc>=65&&cc<=90||// A-Z
cc>=48&&cc<=57||// 0-9
cc===95||// _
cc===36// $
;}function takeIdentifierChar(scnr){return takeChar(scnr,isIdentifier);}function isNamedIdentifier(ch){var cc=ch.charCodeAt(0);return cc>=97&&cc<=122||// a-z
cc>=65&&cc<=90||// A-Z
cc>=48&&cc<=57||// 0-9
cc===95||// _
cc===36||// $
cc===45// -
;}function takeNamedIdentifierChar(scnr){return takeChar(scnr,isNamedIdentifier);}function isDigit(ch){var cc=ch.charCodeAt(0);return cc>=48&&cc<=57;// 0-9
}function takeDigit(scnr){return takeChar(scnr,isDigit);}function isHexDigit(ch){var cc=ch.charCodeAt(0);return cc>=48&&cc<=57||// 0-9
cc>=65&&cc<=70||// A-F
cc>=97&&cc<=102;// a-f
}function takeHexDigit(scnr){return takeChar(scnr,isHexDigit);}function getDigits(scnr){var ch='';var num='';while(ch=takeDigit(scnr)){num+=ch;}return num;}function readText(scnr){var buf='';while(true){var ch=scnr.currentChar();if(ch==="{"/* TokenChars.BraceLeft */||ch==="}"/* TokenChars.BraceRight */||ch==="@"/* TokenChars.LinkedAlias */||ch==="|"/* TokenChars.Pipe */||!ch){break;}else if(ch===message_compiler_CHAR_SP||ch===message_compiler_CHAR_LF){if(isTextStart(scnr)){buf+=ch;scnr.next();}else if(isPluralStart(scnr)){break;}else{buf+=ch;scnr.next();}}else{buf+=ch;scnr.next();}}return buf;}function readNamedIdentifier(scnr){skipSpaces(scnr);var ch='';var name='';while(ch=takeNamedIdentifierChar(scnr)){name+=ch;}if(scnr.currentChar()===message_compiler_EOF){emitError(message_compiler_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);}return name;}function readListIdentifier(scnr){skipSpaces(scnr);var value='';if(scnr.currentChar()==='-'){scnr.next();value+="-".concat(getDigits(scnr));}else{value+=getDigits(scnr);}if(scnr.currentChar()===message_compiler_EOF){emitError(message_compiler_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);}return value;}function isLiteral(ch){return ch!==message_compiler_LITERAL_DELIMITER&&ch!==message_compiler_CHAR_LF;}function readLiteral(scnr){skipSpaces(scnr);// eslint-disable-next-line no-useless-escape
eat(scnr,"'");var ch='';var literal='';while(ch=takeChar(scnr,isLiteral)){if(ch==='\\'){literal+=readEscapeSequence(scnr);}else{literal+=ch;}}var current=scnr.currentChar();if(current===message_compiler_CHAR_LF||current===message_compiler_EOF){emitError(message_compiler_CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER,currentPosition(),0);// TODO: Is it correct really?
if(current===message_compiler_CHAR_LF){scnr.next();// eslint-disable-next-line no-useless-escape
eat(scnr,"'");}return literal;}// eslint-disable-next-line no-useless-escape
eat(scnr,"'");return literal;}function readEscapeSequence(scnr){var ch=scnr.currentChar();switch(ch){case'\\':case"'":// eslint-disable-line no-useless-escape
scnr.next();return"\\".concat(ch);case'u':return readUnicodeEscapeSequence(scnr,ch,4);case'U':return readUnicodeEscapeSequence(scnr,ch,6);default:emitError(message_compiler_CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE,currentPosition(),0,ch);return'';}}function readUnicodeEscapeSequence(scnr,unicode,digits){eat(scnr,unicode);var sequence='';for(var i=0;i<digits;i++){var ch=takeHexDigit(scnr);if(!ch){emitError(message_compiler_CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE,currentPosition(),0,"\\".concat(unicode).concat(sequence).concat(scnr.currentChar()));break;}sequence+=ch;}return"\\".concat(unicode).concat(sequence);}function isInvalidIdentifier(ch){return ch!=="{"/* TokenChars.BraceLeft */&&ch!=="}"/* TokenChars.BraceRight */&&ch!==message_compiler_CHAR_SP&&ch!==message_compiler_CHAR_LF;}function readInvalidIdentifier(scnr){skipSpaces(scnr);var ch='';var identifiers='';while(ch=takeChar(scnr,isInvalidIdentifier)){identifiers+=ch;}return identifiers;}function readLinkedModifier(scnr){var ch='';var name='';while(ch=takeIdentifierChar(scnr)){name+=ch;}return name;}function readLinkedRefer(scnr){var _fn6=function fn(buf){var ch=scnr.currentChar();if(ch==="{"/* TokenChars.BraceLeft */||ch==="@"/* TokenChars.LinkedAlias */||ch==="|"/* TokenChars.Pipe */||ch==="("/* TokenChars.ParenLeft */||ch===")"/* TokenChars.ParenRight */||!ch){return buf;}else if(ch===message_compiler_CHAR_SP){return buf;}else if(ch===message_compiler_CHAR_LF||ch===message_compiler_DOT){buf+=ch;scnr.next();return _fn6(buf);}else{buf+=ch;scnr.next();return _fn6(buf);}};return _fn6('');}function readPlural(scnr){skipSpaces(scnr);var plural=eat(scnr,"|"/* TokenChars.Pipe */);skipSpaces(scnr);return plural;}// TODO: We need refactoring of token parsing ...
function readTokenInPlaceholder(scnr,context){var token=null;var ch=scnr.currentChar();switch(ch){case"{"/* TokenChars.BraceLeft */:if(context.braceNest>=1){emitError(message_compiler_CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER,currentPosition(),0);}scnr.next();token=getToken(context,2/* TokenTypes.BraceLeft */,"{"/* TokenChars.BraceLeft */);skipSpaces(scnr);context.braceNest++;return token;case"}"/* TokenChars.BraceRight */:if(context.braceNest>0&&context.currentType===2/* TokenTypes.BraceLeft */){emitError(message_compiler_CompileErrorCodes.EMPTY_PLACEHOLDER,currentPosition(),0);}scnr.next();token=getToken(context,3/* TokenTypes.BraceRight */,"}"/* TokenChars.BraceRight */);context.braceNest--;context.braceNest>0&&skipSpaces(scnr);if(context.inLinked&&context.braceNest===0){context.inLinked=false;}return token;case"@"/* TokenChars.LinkedAlias */:if(context.braceNest>0){emitError(message_compiler_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);}token=readTokenInLinked(scnr,context)||getEndToken(context);context.braceNest=0;return token;default:{var validNamedIdentifier=true;var validListIdentifier=true;var validLiteral=true;if(isPluralStart(scnr)){if(context.braceNest>0){emitError(message_compiler_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);}token=getToken(context,1/* TokenTypes.Pipe */,readPlural(scnr));// reset
context.braceNest=0;context.inLinked=false;return token;}if(context.braceNest>0&&(context.currentType===4/* TokenTypes.Named */||context.currentType===5/* TokenTypes.List */||context.currentType===6/* TokenTypes.Literal */)){emitError(message_compiler_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE,currentPosition(),0);context.braceNest=0;return readToken(scnr,context);}if(validNamedIdentifier=isNamedIdentifierStart(scnr,context)){token=getToken(context,4/* TokenTypes.Named */,readNamedIdentifier(scnr));skipSpaces(scnr);return token;}if(validListIdentifier=isListIdentifierStart(scnr,context)){token=getToken(context,5/* TokenTypes.List */,readListIdentifier(scnr));skipSpaces(scnr);return token;}if(validLiteral=isLiteralStart(scnr,context)){token=getToken(context,6/* TokenTypes.Literal */,readLiteral(scnr));skipSpaces(scnr);return token;}if(!validNamedIdentifier&&!validListIdentifier&&!validLiteral){// TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
token=getToken(context,12/* TokenTypes.InvalidPlace */,readInvalidIdentifier(scnr));emitError(message_compiler_CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER,currentPosition(),0,token.value);skipSpaces(scnr);return token;}break;}}return token;}// TODO: We need refactoring of token parsing ...
function readTokenInLinked(scnr,context){var currentType=context.currentType;var token=null;var ch=scnr.currentChar();if((currentType===7/* TokenTypes.LinkedAlias */||currentType===8/* TokenTypes.LinkedDot */||currentType===11/* TokenTypes.LinkedModifier */||currentType===9/* TokenTypes.LinkedDelimiter */)&&(ch===message_compiler_CHAR_LF||ch===message_compiler_CHAR_SP)){emitError(message_compiler_CompileErrorCodes.INVALID_LINKED_FORMAT,currentPosition(),0);}switch(ch){case"@"/* TokenChars.LinkedAlias */:scnr.next();token=getToken(context,7/* TokenTypes.LinkedAlias */,"@"/* TokenChars.LinkedAlias */);context.inLinked=true;return token;case"."/* TokenChars.LinkedDot */:skipSpaces(scnr);scnr.next();return getToken(context,8/* TokenTypes.LinkedDot */,"."/* TokenChars.LinkedDot */);case":"/* TokenChars.LinkedDelimiter */:skipSpaces(scnr);scnr.next();return getToken(context,9/* TokenTypes.LinkedDelimiter */,":"/* TokenChars.LinkedDelimiter */);default:if(isPluralStart(scnr)){token=getToken(context,1/* TokenTypes.Pipe */,readPlural(scnr));// reset
context.braceNest=0;context.inLinked=false;return token;}if(isLinkedDotStart(scnr,context)||isLinkedDelimiterStart(scnr,context)){skipSpaces(scnr);return readTokenInLinked(scnr,context);}if(isLinkedModifierStart(scnr,context)){skipSpaces(scnr);return getToken(context,11/* TokenTypes.LinkedModifier */,readLinkedModifier(scnr));}if(isLinkedReferStart(scnr,context)){skipSpaces(scnr);if(ch==="{"/* TokenChars.BraceLeft */){// scan the placeholder
return readTokenInPlaceholder(scnr,context)||token;}else{return getToken(context,10/* TokenTypes.LinkedKey */,readLinkedRefer(scnr));}}if(currentType===7/* TokenTypes.LinkedAlias */){emitError(message_compiler_CompileErrorCodes.INVALID_LINKED_FORMAT,currentPosition(),0);}context.braceNest=0;context.inLinked=false;return readToken(scnr,context);}}// TODO: We need refactoring of token parsing ...
function readToken(scnr,context){var token={type:13/* TokenTypes.EOF */};if(context.braceNest>0){return readTokenInPlaceholder(scnr,context)||getEndToken(context);}if(context.inLinked){return readTokenInLinked(scnr,context)||getEndToken(context);}var ch=scnr.currentChar();switch(ch){case"{"/* TokenChars.BraceLeft */:return readTokenInPlaceholder(scnr,context)||getEndToken(context);case"}"/* TokenChars.BraceRight */:emitError(message_compiler_CompileErrorCodes.UNBALANCED_CLOSING_BRACE,currentPosition(),0);scnr.next();return getToken(context,3/* TokenTypes.BraceRight */,"}"/* TokenChars.BraceRight */);case"@"/* TokenChars.LinkedAlias */:return readTokenInLinked(scnr,context)||getEndToken(context);default:{if(isPluralStart(scnr)){token=getToken(context,1/* TokenTypes.Pipe */,readPlural(scnr));// reset
context.braceNest=0;context.inLinked=false;return token;}if(isTextStart(scnr)){return getToken(context,0/* TokenTypes.Text */,readText(scnr));}break;}}return token;}function nextToken(){var currentType=_context.currentType,offset=_context.offset,startLoc=_context.startLoc,endLoc=_context.endLoc;_context.lastType=currentType;_context.lastOffset=offset;_context.lastStartLoc=startLoc;_context.lastEndLoc=endLoc;_context.offset=currentOffset();_context.startLoc=currentPosition();if(_scnr.currentChar()===message_compiler_EOF){return getToken(_context,13/* TokenTypes.EOF */);}return readToken(_scnr,_context);}return{nextToken:nextToken,currentOffset:currentOffset,currentPosition:currentPosition,context:context};}var message_compiler_ERROR_DOMAIN$2='parser';// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
var message_compiler_KNOWN_ESCAPES=/(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;function message_compiler_fromEscapeSequence(match,codePoint4,codePoint6){switch(match){case"\\\\":return"\\";// eslint-disable-next-line no-useless-escape
case"\\'":// eslint-disable-next-line no-useless-escape
return"'";default:{var codePoint=parseInt(codePoint4||codePoint6,16);if(codePoint<=0xd7ff||codePoint>=0xe000){return String.fromCodePoint(codePoint);}// invalid ...
// Replace them with U+FFFD REPLACEMENT CHARACTER.
return'�';}}}function message_compiler_createParser(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var location=options.location!==false;var onError=options.onError;function emitError(tokenzer,code,start,offset){var end=tokenzer.currentPosition();end.offset+=offset;end.column+=offset;if(onError){var loc=location?message_compiler_createLocation(start,end):null;for(var _len35=arguments.length,args=new Array(_len35>4?_len35-4:0),_key35=4;_key35<_len35;_key35++){args[_key35-4]=arguments[_key35];}var err=message_compiler_createCompileError(code,loc,{domain:message_compiler_ERROR_DOMAIN$2,args:args});onError(err);}}function startNode(type,offset,loc){var node={type:type};if(location){node.start=offset;node.end=offset;node.loc={start:loc,end:loc};}return node;}function endNode(node,offset,pos,type){if(location){node.end=offset;if(node.loc){node.loc.end=pos;}}}function parseText(tokenizer,value){var context=tokenizer.context();var node=startNode(3/* NodeTypes.Text */,context.offset,context.startLoc);node.value=value;endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseList(tokenizer,index){var context=tokenizer.context();var offset=context.lastOffset,loc=context.lastStartLoc;// get brace left loc
var node=startNode(5/* NodeTypes.List */,offset,loc);node.index=parseInt(index,10);tokenizer.nextToken();// skip brach right
endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseNamed(tokenizer,key){var context=tokenizer.context();var offset=context.lastOffset,loc=context.lastStartLoc;// get brace left loc
var node=startNode(4/* NodeTypes.Named */,offset,loc);node.key=key;tokenizer.nextToken();// skip brach right
endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseLiteral(tokenizer,value){var context=tokenizer.context();var offset=context.lastOffset,loc=context.lastStartLoc;// get brace left loc
var node=startNode(9/* NodeTypes.Literal */,offset,loc);node.value=value.replace(message_compiler_KNOWN_ESCAPES,message_compiler_fromEscapeSequence);tokenizer.nextToken();// skip brach right
endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseLinkedModifier(tokenizer){var token=tokenizer.nextToken();var context=tokenizer.context();var offset=context.lastOffset,loc=context.lastStartLoc;// get linked dot loc
var node=startNode(8/* NodeTypes.LinkedModifier */,offset,loc);if(token.type!==11/* TokenTypes.LinkedModifier */){// empty modifier
emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER,context.lastStartLoc,0);node.value='';endNode(node,offset,loc);return{nextConsumeToken:token,node:node};}// check token
if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}node.value=token.value||'';endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return{node:node};}function parseLinkedKey(tokenizer,value){var context=tokenizer.context();var node=startNode(7/* NodeTypes.LinkedKey */,context.offset,context.startLoc);node.value=value;endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseLinked(tokenizer){var context=tokenizer.context();var linkedNode=startNode(6/* NodeTypes.Linked */,context.offset,context.startLoc);var token=tokenizer.nextToken();if(token.type===8/* TokenTypes.LinkedDot */){var parsed=parseLinkedModifier(tokenizer);linkedNode.modifier=parsed.node;token=parsed.nextConsumeToken||tokenizer.nextToken();}// asset check token
if(token.type!==9/* TokenTypes.LinkedDelimiter */){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}token=tokenizer.nextToken();// skip brace left
if(token.type===2/* TokenTypes.BraceLeft */){token=tokenizer.nextToken();}switch(token.type){case 10/* TokenTypes.LinkedKey */:if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}linkedNode.key=parseLinkedKey(tokenizer,token.value||'');break;case 4/* TokenTypes.Named */:if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}linkedNode.key=parseNamed(tokenizer,token.value||'');break;case 5/* TokenTypes.List */:if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}linkedNode.key=parseList(tokenizer,token.value||'');break;case 6/* TokenTypes.Literal */:if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}linkedNode.key=parseLiteral(tokenizer,token.value||'');break;default:{// empty key
emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY,context.lastStartLoc,0);var nextContext=tokenizer.context();var emptyLinkedKeyNode=startNode(7/* NodeTypes.LinkedKey */,nextContext.offset,nextContext.startLoc);emptyLinkedKeyNode.value='';endNode(emptyLinkedKeyNode,nextContext.offset,nextContext.startLoc);linkedNode.key=emptyLinkedKeyNode;endNode(linkedNode,nextContext.offset,nextContext.startLoc);return{nextConsumeToken:token,node:linkedNode};}}endNode(linkedNode,tokenizer.currentOffset(),tokenizer.currentPosition());return{node:linkedNode};}function parseMessage(tokenizer){var context=tokenizer.context();var startOffset=context.currentType===1/* TokenTypes.Pipe */?tokenizer.currentOffset():context.offset;var startLoc=context.currentType===1/* TokenTypes.Pipe */?context.endLoc:context.startLoc;var node=startNode(2/* NodeTypes.Message */,startOffset,startLoc);node.items=[];var nextToken=null;do{var token=nextToken||tokenizer.nextToken();nextToken=null;switch(token.type){case 0/* TokenTypes.Text */:if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}node.items.push(parseText(tokenizer,token.value||''));break;case 5/* TokenTypes.List */:if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}node.items.push(parseList(tokenizer,token.value||''));break;case 4/* TokenTypes.Named */:if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}node.items.push(parseNamed(tokenizer,token.value||''));break;case 6/* TokenTypes.Literal */:if(token.value==null){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,message_compiler_getTokenCaption(token));}node.items.push(parseLiteral(tokenizer,token.value||''));break;case 7/* TokenTypes.LinkedAlias */:{var parsed=parseLinked(tokenizer);node.items.push(parsed.node);nextToken=parsed.nextConsumeToken||null;break;}}}while(context.currentType!==13/* TokenTypes.EOF */&&context.currentType!==1/* TokenTypes.Pipe */);// adjust message node loc
var endOffset=context.currentType===1/* TokenTypes.Pipe */?context.lastOffset:tokenizer.currentOffset();var endLoc=context.currentType===1/* TokenTypes.Pipe */?context.lastEndLoc:tokenizer.currentPosition();endNode(node,endOffset,endLoc);return node;}function parsePlural(tokenizer,offset,loc,msgNode){var context=tokenizer.context();var hasEmptyMessage=msgNode.items.length===0;var node=startNode(1/* NodeTypes.Plural */,offset,loc);node.cases=[];node.cases.push(msgNode);do{var msg=parseMessage(tokenizer);if(!hasEmptyMessage){hasEmptyMessage=msg.items.length===0;}node.cases.push(msg);}while(context.currentType!==13/* TokenTypes.EOF */);if(hasEmptyMessage){emitError(tokenizer,message_compiler_CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL,loc,0);}endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}function parseResource(tokenizer){var context=tokenizer.context();var offset=context.offset,startLoc=context.startLoc;var msgNode=parseMessage(tokenizer);if(context.currentType===13/* TokenTypes.EOF */){return msgNode;}else{return parsePlural(tokenizer,offset,startLoc,msgNode);}}function parse(source){var tokenizer=message_compiler_createTokenizer(source,dist_shared_assign({},options));var context=tokenizer.context();var node=startNode(0/* NodeTypes.Resource */,context.offset,context.startLoc);if(location&&node.loc){node.loc.source=source;}node.body=parseResource(tokenizer);if(options.onCacheKey){node.cacheKey=options.onCacheKey(source);}// assert whether achieved to EOF
if(context.currentType!==13/* TokenTypes.EOF */){emitError(tokenizer,message_compiler_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS,context.lastStartLoc,0,source[context.offset]||'');}endNode(node,tokenizer.currentOffset(),tokenizer.currentPosition());return node;}return{parse:parse};}function message_compiler_getTokenCaption(token){if(token.type===13/* TokenTypes.EOF */){return'EOF';}var name=(token.value||'').replace(/\r?\n/g,'\\n');return name.length>10?name.slice(0,9)+'…':name;}function message_compiler_createTransformer(ast){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _context={ast:ast,helpers:new Set()};var context=function context(){return _context;};var helper=function helper(name){_context.helpers.add(name);return name;};return{context:context,helper:helper};}function message_compiler_traverseNodes(nodes,transformer){for(var i=0;i<nodes.length;i++){message_compiler_traverseNode(nodes[i],transformer);}}function message_compiler_traverseNode(node,transformer){// TODO: if we need pre-hook of transform, should be implemented to here
switch(node.type){case 1/* NodeTypes.Plural */:message_compiler_traverseNodes(node.cases,transformer);transformer.helper("plural"/* HelperNameMap.PLURAL */);break;case 2/* NodeTypes.Message */:message_compiler_traverseNodes(node.items,transformer);break;case 6/* NodeTypes.Linked */:{var linked=node;message_compiler_traverseNode(linked.key,transformer);transformer.helper("linked"/* HelperNameMap.LINKED */);transformer.helper("type"/* HelperNameMap.TYPE */);break;}case 5/* NodeTypes.List */:transformer.helper("interpolate"/* HelperNameMap.INTERPOLATE */);transformer.helper("list"/* HelperNameMap.LIST */);break;case 4/* NodeTypes.Named */:transformer.helper("interpolate"/* HelperNameMap.INTERPOLATE */);transformer.helper("named"/* HelperNameMap.NAMED */);break;}// TODO: if we need post-hook of transform, should be implemented to here
}// transform AST
function message_compiler_transform(ast){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var transformer=message_compiler_createTransformer(ast);transformer.helper("normalize"/* HelperNameMap.NORMALIZE */);// traverse
ast.body&&message_compiler_traverseNode(ast.body,transformer);// set meta information
var context=transformer.context();ast.helpers=Array.from(context.helpers);}function message_compiler_optimize(ast){var body=ast.body;if(body.type===2/* NodeTypes.Message */){message_compiler_optimizeMessageNode(body);}else{body.cases.forEach(function(c){return message_compiler_optimizeMessageNode(c);});}return ast;}function message_compiler_optimizeMessageNode(message){if(message.items.length===1){var item=message.items[0];if(item.type===3/* NodeTypes.Text */||item.type===9/* NodeTypes.Literal */){message.static=item.value;delete item.value;// optimization for size
}}else{var values=[];for(var i=0;i<message.items.length;i++){var _item3=message.items[i];if(!(_item3.type===3/* NodeTypes.Text */||_item3.type===9/* NodeTypes.Literal */)){break;}if(_item3.value==null){break;}values.push(_item3.value);}if(values.length===message.items.length){message.static=shared_join(values);for(var _i3=0;_i3<message.items.length;_i3++){var _item4=message.items[_i3];if(_item4.type===3/* NodeTypes.Text */||_item4.type===9/* NodeTypes.Literal */){delete _item4.value;// optimization for size
}}}}}var message_compiler_ERROR_DOMAIN$1='minifier';/* eslint-disable @typescript-eslint/no-explicit-any */function message_compiler_minify(node){node.t=node.type;switch(node.type){case 0/* NodeTypes.Resource */:{var resource=node;message_compiler_minify(resource.body);resource.b=resource.body;delete resource.body;break;}case 1/* NodeTypes.Plural */:{var plural=node;var cases=plural.cases;for(var i=0;i<cases.length;i++){message_compiler_minify(cases[i]);}plural.c=cases;delete plural.cases;break;}case 2/* NodeTypes.Message */:{var message=node;var items=message.items;for(var _i4=0;_i4<items.length;_i4++){message_compiler_minify(items[_i4]);}message.i=items;delete message.items;if(message.static){message.s=message.static;delete message.static;}break;}case 3/* NodeTypes.Text */:case 9/* NodeTypes.Literal */:case 8/* NodeTypes.LinkedModifier */:case 7/* NodeTypes.LinkedKey */:{var valueNode=node;if(valueNode.value){valueNode.v=valueNode.value;delete valueNode.value;}break;}case 6/* NodeTypes.Linked */:{var linked=node;message_compiler_minify(linked.key);linked.k=linked.key;delete linked.key;if(linked.modifier){message_compiler_minify(linked.modifier);linked.m=linked.modifier;delete linked.modifier;}break;}case 5/* NodeTypes.List */:{var list=node;list.i=list.index;delete list.index;break;}case 4/* NodeTypes.Named */:{var named=node;named.k=named.key;delete named.key;break;}default:if(false){}}delete node.type;}/* eslint-enable @typescript-eslint/no-explicit-any */// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
var message_compiler_ERROR_DOMAIN='parser';function message_compiler_createCodeGenerator(ast,options){var sourceMap=options.sourceMap,filename=options.filename,breakLineCode=options.breakLineCode,_needIndent=options.needIndent;var location=options.location!==false;var _context={filename:filename,code:'',column:1,line:1,offset:0,map:undefined,breakLineCode:breakLineCode,needIndent:_needIndent,indentLevel:0};if(location&&ast.loc){_context.source=ast.loc.source;}var context=function context(){return _context;};function push(code,node){_context.code+=code;}function _newline(n){var withBreakLine=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var _breakLineCode=withBreakLine?breakLineCode:'';push(_needIndent?_breakLineCode+"  ".repeat(n):_breakLineCode);}function indent(){var withNewLine=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var level=++_context.indentLevel;withNewLine&&_newline(level);}function deindent(){var withNewLine=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var level=--_context.indentLevel;withNewLine&&_newline(level);}function newline(){_newline(_context.indentLevel);}var helper=function helper(key){return"_".concat(key);};var needIndent=function needIndent(){return _context.needIndent;};return{context:context,push:push,indent:indent,deindent:deindent,newline:newline,helper:helper,needIndent:needIndent};}function message_compiler_generateLinkedNode(generator,node){var helper=generator.helper;generator.push("".concat(helper("linked"/* HelperNameMap.LINKED */),"("));message_compiler_generateNode(generator,node.key);if(node.modifier){generator.push(", ");message_compiler_generateNode(generator,node.modifier);generator.push(", _type");}else{generator.push(", undefined, _type");}generator.push(")");}function message_compiler_generateMessageNode(generator,node){var helper=generator.helper,needIndent=generator.needIndent;generator.push("".concat(helper("normalize"/* HelperNameMap.NORMALIZE */),"(["));generator.indent(needIndent());var length=node.items.length;for(var i=0;i<length;i++){message_compiler_generateNode(generator,node.items[i]);if(i===length-1){break;}generator.push(', ');}generator.deindent(needIndent());generator.push('])');}function message_compiler_generatePluralNode(generator,node){var helper=generator.helper,needIndent=generator.needIndent;if(node.cases.length>1){generator.push("".concat(helper("plural"/* HelperNameMap.PLURAL */),"(["));generator.indent(needIndent());var length=node.cases.length;for(var i=0;i<length;i++){message_compiler_generateNode(generator,node.cases[i]);if(i===length-1){break;}generator.push(', ');}generator.deindent(needIndent());generator.push("])");}}function message_compiler_generateResource(generator,node){if(node.body){message_compiler_generateNode(generator,node.body);}else{generator.push('null');}}function message_compiler_generateNode(generator,node){var helper=generator.helper;switch(node.type){case 0/* NodeTypes.Resource */:message_compiler_generateResource(generator,node);break;case 1/* NodeTypes.Plural */:message_compiler_generatePluralNode(generator,node);break;case 2/* NodeTypes.Message */:message_compiler_generateMessageNode(generator,node);break;case 6/* NodeTypes.Linked */:message_compiler_generateLinkedNode(generator,node);break;case 8/* NodeTypes.LinkedModifier */:generator.push(JSON.stringify(node.value),node);break;case 7/* NodeTypes.LinkedKey */:generator.push(JSON.stringify(node.value),node);break;case 5/* NodeTypes.List */:generator.push("".concat(helper("interpolate"/* HelperNameMap.INTERPOLATE */),"(").concat(helper("list"/* HelperNameMap.LIST */),"(").concat(node.index,"))"),node);break;case 4/* NodeTypes.Named */:generator.push("".concat(helper("interpolate"/* HelperNameMap.INTERPOLATE */),"(").concat(helper("named"/* HelperNameMap.NAMED */),"(").concat(JSON.stringify(node.key),"))"),node);break;case 9/* NodeTypes.Literal */:generator.push(JSON.stringify(node.value),node);break;case 3/* NodeTypes.Text */:generator.push(JSON.stringify(node.value),node);break;default:if(false){}}}// generate code from AST
var message_compiler_generate=function message_compiler_generate(ast){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var mode=dist_shared_isString(options.mode)?options.mode:'normal';var filename=dist_shared_isString(options.filename)?options.filename:'message.intl';var sourceMap=!!options.sourceMap;// prettier-ignore
var breakLineCode=options.breakLineCode!=null?options.breakLineCode:mode==='arrow'?';':'\n';var needIndent=options.needIndent?options.needIndent:mode!=='arrow';var helpers=ast.helpers||[];var generator=message_compiler_createCodeGenerator(ast,{mode:mode,filename:filename,sourceMap:sourceMap,breakLineCode:breakLineCode,needIndent:needIndent});generator.push(mode==='normal'?"function __msg__ (ctx) {":"(ctx) => {");generator.indent(needIndent);if(helpers.length>0){generator.push("const { ".concat(shared_join(helpers.map(function(s){return"".concat(s,": _").concat(s);}),', ')," } = ctx"));generator.newline();}generator.push("return ");message_compiler_generateNode(generator,ast);generator.deindent(needIndent);generator.push("}");delete ast.helpers;var _generator$context2=generator.context(),code=_generator$context2.code,map=_generator$context2.map;return{ast:ast,code:code,map:map?map.toJSON():undefined// eslint-disable-line @typescript-eslint/no-explicit-any
};};function message_compiler_baseCompile(source){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var assignedOptions=dist_shared_assign({},options);var jit=!!assignedOptions.jit;var enalbeMinify=!!assignedOptions.minify;var enambeOptimize=assignedOptions.optimize==null?true:assignedOptions.optimize;// parse source codes
var parser=message_compiler_createParser(assignedOptions);var ast=parser.parse(source);if(!jit){// transform ASTs
message_compiler_transform(ast,assignedOptions);// generate javascript codes
return message_compiler_generate(ast,assignedOptions);}else{// optimize ASTs
enambeOptimize&&message_compiler_optimize(ast);// minimize ASTs
enalbeMinify&&message_compiler_minify(ast);// In JIT mode, no ast transform, no code generation.
return{ast:ast,code:''};}};// ../../libs/i18n/node_modules/@intlify/core-base/dist/core-base.mjs
/*!
  * core-base v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  *//**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */function core_base_initFeatureFlags(){if(typeof __INTLIFY_PROD_DEVTOOLS__!=='boolean'){shared_getGlobalThis().__INTLIFY_PROD_DEVTOOLS__=false;}if(typeof __INTLIFY_DROP_MESSAGE_COMPILER__!=='boolean'){shared_getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__=false;}}function dist_core_base_format(ast){var msg=function msg(ctx){return core_base_formatParts(ctx,ast);};return msg;}function core_base_formatParts(ctx,ast){var body=resolveBody(ast);if(body==null){throw createUnhandleNodeError(0/* NodeTypes.Resource */);}var type=resolveType(body);if(type===1/* NodeTypes.Plural */){var plural=body;var cases=resolveCases(plural);return ctx.plural(cases.reduce(function(messages,c){return[].concat(_toConsumableArray(messages),[core_base_formatMessageParts(ctx,c)]);},[]));}else{return core_base_formatMessageParts(ctx,body);}}var PROPS_BODY=['b','body'];function resolveBody(node){return resolveProps(node,PROPS_BODY);}var PROPS_CASES=['c','cases'];function resolveCases(node){return resolveProps(node,PROPS_CASES,[]);}function core_base_formatMessageParts(ctx,node){var static_=resolveStatic(node);if(static_!=null){return ctx.type==='text'?static_:ctx.normalize([static_]);}else{var messages=resolveItems(node).reduce(function(acm,c){return[].concat(_toConsumableArray(acm),[core_base_formatMessagePart(ctx,c)]);},[]);return ctx.normalize(messages);}}var PROPS_STATIC=['s','static'];function resolveStatic(node){return resolveProps(node,PROPS_STATIC);}var PROPS_ITEMS=['i','items'];function resolveItems(node){return resolveProps(node,PROPS_ITEMS,[]);}function core_base_formatMessagePart(ctx,node){var type=resolveType(node);switch(type){case 3/* NodeTypes.Text */:{return resolveValue$1(node,type);}case 9/* NodeTypes.Literal */:{return resolveValue$1(node,type);}case 4/* NodeTypes.Named */:{var named=node;if(shared_hasOwn(named,'k')&&named.k){return ctx.interpolate(ctx.named(named.k));}if(shared_hasOwn(named,'key')&&named.key){return ctx.interpolate(ctx.named(named.key));}throw createUnhandleNodeError(type);}case 5/* NodeTypes.List */:{var list=node;if(shared_hasOwn(list,'i')&&dist_shared_isNumber(list.i)){return ctx.interpolate(ctx.list(list.i));}if(shared_hasOwn(list,'index')&&dist_shared_isNumber(list.index)){return ctx.interpolate(ctx.list(list.index));}throw createUnhandleNodeError(type);}case 6/* NodeTypes.Linked */:{var linked=node;var modifier=resolveLinkedModifier(linked);var key=resolveLinkedKey(linked);return ctx.linked(core_base_formatMessagePart(ctx,key),modifier?core_base_formatMessagePart(ctx,modifier):undefined,ctx.type);}case 7/* NodeTypes.LinkedKey */:{return resolveValue$1(node,type);}case 8/* NodeTypes.LinkedModifier */:{return resolveValue$1(node,type);}default:throw new Error("unhandled node on format message part: ".concat(type));}}var PROPS_TYPE=['t','type'];function resolveType(node){return resolveProps(node,PROPS_TYPE);}var PROPS_VALUE=['v','value'];function resolveValue$1(node,type){var resolved=resolveProps(node,PROPS_VALUE);if(resolved){return resolved;}else{throw createUnhandleNodeError(type);}}var PROPS_MODIFIER=['m','modifier'];function resolveLinkedModifier(node){return resolveProps(node,PROPS_MODIFIER);}var PROPS_KEY=['k','key'];function resolveLinkedKey(node){var resolved=resolveProps(node,PROPS_KEY);if(resolved){return resolved;}else{throw createUnhandleNodeError(6/* NodeTypes.Linked */);}}function resolveProps(node,props,defaultValue){for(var i=0;i<props.length;i++){var prop=props[i];// eslint-disable-next-line @typescript-eslint/no-explicit-any
if(shared_hasOwn(node,prop)&&node[prop]!=null){// eslint-disable-next-line @typescript-eslint/no-explicit-any
return node[prop];}}return defaultValue;}function createUnhandleNodeError(type){return new Error("unhandled node type: ".concat(type));}var core_base_WARN_MESSAGE=/* unused pure expression or super */null&&0;function core_base_checkHtmlMessage(source,warnHtmlMessage){if(warnHtmlMessage&&detectHtmlTag(source)){warn(format$1(core_base_WARN_MESSAGE,{source:source}));}}var core_base_defaultOnCacheKey=function core_base_defaultOnCacheKey(message){return message;};var core_base_compileCache=shared_create();function core_base_clearCompileCache(){core_base_compileCache=create();}function dist_core_base_isMessageAST(val){return dist_shared_isObject(val)&&resolveType(val)===0&&(shared_hasOwn(val,'b')||shared_hasOwn(val,'body'));}function dist_core_base_baseCompile(message){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// error detecting on compile
var detectError=false;var onError=options.onError||message_compiler_defaultOnError;options.onError=function(err){detectError=true;onError(err);};// compile with mesasge-compiler
return _objectSpread(_objectSpread({},message_compiler_baseCompile(message,options)),{},{detectError:detectError});}/* #__NO_SIDE_EFFECTS__ */function core_base_compile(message,context){if(!__INTLIFY_DROP_MESSAGE_COMPILER__&&dist_shared_isString(message)){// check HTML message
var warnHtmlMessage=dist_shared_isBoolean(context.warnHtmlMessage)?context.warnHtmlMessage:true; false&&0;// check caches
var onCacheKey=context.onCacheKey||core_base_defaultOnCacheKey;var cacheKey=onCacheKey(message);var cached=core_base_compileCache[cacheKey];if(cached){return cached;}// compile with JIT mode
var _dist_core_base_baseC=dist_core_base_baseCompile(message,_objectSpread(_objectSpread({},context),{},{location:"production"!=='production',jit:true})),ast=_dist_core_base_baseC.ast,detectError=_dist_core_base_baseC.detectError;// compose message function from AST
var msg=dist_core_base_format(ast);// if occurred compile error, don't cache
return!detectError?core_base_compileCache[cacheKey]=msg:msg;}else{if(false){}// AST case (passed from bundler)
var _cacheKey2=message.cacheKey;if(_cacheKey2){var _cached2=core_base_compileCache[_cacheKey2];if(_cached2){return _cached2;}// compose message function from message (AST)
return core_base_compileCache[_cacheKey2]=dist_core_base_format(message);}else{return dist_core_base_format(message);}}}var core_base_devtools=null;function core_base_setDevToolsHook(hook){core_base_devtools=hook;}function core_base_getDevToolsHook(){return core_base_devtools;}function core_base_initI18nDevTools(i18n,version,meta){// TODO: queue if devtools is undefined
core_base_devtools&&core_base_devtools.emit('i18n:init',{timestamp:Date.now(),i18n:i18n,version:version,meta:meta});}var core_base_translateDevTools=/* #__PURE__*/core_base_createDevToolsHook('function:translate');function core_base_createDevToolsHook(hook){return function(payloads){return core_base_devtools&&core_base_devtools.emit(hook,payloads);};}var core_base_CoreErrorCodes={INVALID_ARGUMENT:COMPILE_ERROR_CODES_EXTEND_POINT,// 17
INVALID_DATE_ARGUMENT:18,INVALID_ISO_DATE_ARGUMENT:19,NOT_SUPPORT_NON_STRING_MESSAGE:20,NOT_SUPPORT_LOCALE_PROMISE_VALUE:21,NOT_SUPPORT_LOCALE_ASYNC_FUNCTION:22,NOT_SUPPORT_LOCALE_TYPE:23};var CORE_ERROR_CODES_EXTEND_POINT=24;function core_base_createCoreError(code){return message_compiler_createCompileError(code,null, false?0:undefined);}/** @internal */var dist_core_base_errorMessages=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},core_base_CoreErrorCodes.INVALID_ARGUMENT,'Invalid arguments'),core_base_CoreErrorCodes.INVALID_DATE_ARGUMENT,'The date provided is an invalid Date object.'+'Make sure your Date represents a valid date.'),core_base_CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT,'The argument provided is not a valid ISO date string'),core_base_CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE,'Not support non-string message'),core_base_CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE,'cannot support promise value'),core_base_CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION,'cannot support async function'),core_base_CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE,'cannot support locale type');/** @internal */function core_base_getLocale(context,options){return options.locale!=null?dist_core_base_resolveLocale(options.locale):dist_core_base_resolveLocale(context.locale);}var core_base_resolveLocale;/** @internal */function dist_core_base_resolveLocale(locale){if(dist_shared_isString(locale)){return locale;}else{if(dist_shared_isFunction(locale)){if(locale.resolvedOnce&&core_base_resolveLocale!=null){return core_base_resolveLocale;}else if(locale.constructor.name==='Function'){var resolve=locale();if(shared_isPromise(resolve)){throw core_base_createCoreError(core_base_CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE);}return core_base_resolveLocale=resolve;}else{throw core_base_createCoreError(core_base_CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);}}else{throw core_base_createCoreError(core_base_CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE);}}}/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */function core_base_fallbackWithSimple(ctx,fallback,start){// prettier-ignore
return _toConsumableArray(new Set([start].concat(_toConsumableArray(dist_shared_isArray(fallback)?fallback:dist_shared_isObject(fallback)?Object.keys(fallback):dist_shared_isString(fallback)?[fallback]:[start]))));}/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */function core_base_fallbackWithLocaleChain(ctx,fallback,start){var startLocale=dist_shared_isString(start)?start:dist_core_base_DEFAULT_LOCALE;var context=ctx;if(!context.__localeChainCache){context.__localeChainCache=new Map();}var chain=context.__localeChainCache.get(startLocale);if(!chain){chain=[];// first block defined by start
var block=[start];// while any intervening block found
while(dist_shared_isArray(block)){block=core_base_appendBlockToChain(chain,block,fallback);}// prettier-ignore
// last block defined by default
var defaults=dist_shared_isArray(fallback)||!dist_shared_isPlainObject(fallback)?fallback:fallback['default']?fallback['default']:null;// convert defaults to array
block=dist_shared_isString(defaults)?[defaults]:defaults;if(dist_shared_isArray(block)){core_base_appendBlockToChain(chain,block,false);}context.__localeChainCache.set(startLocale,chain);}return chain;}function core_base_appendBlockToChain(chain,block,blocks){var follow=true;for(var i=0;i<block.length&&dist_shared_isBoolean(follow);i++){var locale=block[i];if(dist_shared_isString(locale)){follow=core_base_appendLocaleToChain(chain,block[i],blocks);}}return follow;}function core_base_appendLocaleToChain(chain,locale,blocks){var follow;var tokens=locale.split('-');do{var _target=tokens.join('-');follow=core_base_appendItemToChain(chain,_target,blocks);tokens.splice(-1,1);}while(tokens.length&&follow===true);return follow;}function core_base_appendItemToChain(chain,target,blocks){var follow=false;if(!chain.includes(target)){follow=true;if(target){follow=target[target.length-1]!=='!';var locale=target.replace(/!/g,'');chain.push(locale);if((dist_shared_isArray(blocks)||dist_shared_isPlainObject(blocks))&&blocks[locale]// eslint-disable-line @typescript-eslint/no-explicit-any
){// eslint-disable-next-line @typescript-eslint/no-explicit-any
follow=blocks[locale];}}}return follow;}var core_base_pathStateMachine=[];core_base_pathStateMachine[0/* States.BEFORE_PATH */]=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"w"/* PathCharTypes.WORKSPACE */,[0/* States.BEFORE_PATH */]),"i"/* PathCharTypes.IDENT */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]),"["/* PathCharTypes.LEFT_BRACKET */,[4/* States.IN_SUB_PATH */]),"o"/* PathCharTypes.END_OF_FAIL */,[7/* States.AFTER_PATH */]);core_base_pathStateMachine[1/* States.IN_PATH */]=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"w"/* PathCharTypes.WORKSPACE */,[1/* States.IN_PATH */]),"."/* PathCharTypes.DOT */,[2/* States.BEFORE_IDENT */]),"["/* PathCharTypes.LEFT_BRACKET */,[4/* States.IN_SUB_PATH */]),"o"/* PathCharTypes.END_OF_FAIL */,[7/* States.AFTER_PATH */]);core_base_pathStateMachine[2/* States.BEFORE_IDENT */]=_defineProperty2(_defineProperty2(_defineProperty2({},"w"/* PathCharTypes.WORKSPACE */,[2/* States.BEFORE_IDENT */]),"i"/* PathCharTypes.IDENT */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]),"0"/* PathCharTypes.ZERO */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]);core_base_pathStateMachine[3/* States.IN_IDENT */]=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"i"/* PathCharTypes.IDENT */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]),"0"/* PathCharTypes.ZERO */,[3/* States.IN_IDENT */,0/* Actions.APPEND */]),"w"/* PathCharTypes.WORKSPACE */,[1/* States.IN_PATH */,1/* Actions.PUSH */]),"."/* PathCharTypes.DOT */,[2/* States.BEFORE_IDENT */,1/* Actions.PUSH */]),"["/* PathCharTypes.LEFT_BRACKET */,[4/* States.IN_SUB_PATH */,1/* Actions.PUSH */]),"o"/* PathCharTypes.END_OF_FAIL */,[7/* States.AFTER_PATH */,1/* Actions.PUSH */]);core_base_pathStateMachine[4/* States.IN_SUB_PATH */]=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"'"/* PathCharTypes.SINGLE_QUOTE */,[5/* States.IN_SINGLE_QUOTE */,0/* Actions.APPEND */]),"\""/* PathCharTypes.DOUBLE_QUOTE */,[6/* States.IN_DOUBLE_QUOTE */,0/* Actions.APPEND */]),"["/* PathCharTypes.LEFT_BRACKET */,[4/* States.IN_SUB_PATH */,2/* Actions.INC_SUB_PATH_DEPTH */]),"]"/* PathCharTypes.RIGHT_BRACKET */,[1/* States.IN_PATH */,3/* Actions.PUSH_SUB_PATH */]),"o"/* PathCharTypes.END_OF_FAIL */,8),"l"/* PathCharTypes.ELSE */,[4/* States.IN_SUB_PATH */,0/* Actions.APPEND */]);core_base_pathStateMachine[5/* States.IN_SINGLE_QUOTE */]=_defineProperty2(_defineProperty2(_defineProperty2({},"'"/* PathCharTypes.SINGLE_QUOTE */,[4/* States.IN_SUB_PATH */,0/* Actions.APPEND */]),"o"/* PathCharTypes.END_OF_FAIL */,8),"l"/* PathCharTypes.ELSE */,[5/* States.IN_SINGLE_QUOTE */,0/* Actions.APPEND */]);core_base_pathStateMachine[6/* States.IN_DOUBLE_QUOTE */]=_defineProperty2(_defineProperty2(_defineProperty2({},"\""/* PathCharTypes.DOUBLE_QUOTE */,[4/* States.IN_SUB_PATH */,0/* Actions.APPEND */]),"o"/* PathCharTypes.END_OF_FAIL */,8),"l"/* PathCharTypes.ELSE */,[6/* States.IN_DOUBLE_QUOTE */,0/* Actions.APPEND */]);/**
 * Check if an expression is a literal value.
 */var core_base_literalValueRE=/^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;function core_base_isLiteral(exp){return core_base_literalValueRE.test(exp);}/**
 * Strip quotes from a string
 */function core_base_stripQuotes(str){var a=str.charCodeAt(0);var b=str.charCodeAt(str.length-1);return a===b&&(a===0x22||a===0x27)?str.slice(1,-1):str;}/**
 * Determine the type of a character in a keypath.
 */function core_base_getPathCharType(ch){if(ch===undefined||ch===null){return"o"/* PathCharTypes.END_OF_FAIL */;}var code=ch.charCodeAt(0);switch(code){case 0x5b:// [
case 0x5d:// ]
case 0x2e:// .
case 0x22:// "
case 0x27:// '
return ch;case 0x5f:// _
case 0x24:// $
case 0x2d:// -
return"i"/* PathCharTypes.IDENT */;case 0x09:// Tab (HT)
case 0x0a:// Newline (LF)
case 0x0d:// Return (CR)
case 0xa0:// No-break space (NBSP)
case 0xfeff:// Byte Order Mark (BOM)
case 0x2028:// Line Separator (LS)
case 0x2029:// Paragraph Separator (PS)
return"w"/* PathCharTypes.WORKSPACE */;}return"i"/* PathCharTypes.IDENT */;}/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */function core_base_formatSubPath(path){var trimmed=path.trim();// invalid leading 0
if(path.charAt(0)==='0'&&isNaN(parseInt(path))){return false;}return core_base_isLiteral(trimmed)?core_base_stripQuotes(trimmed):"*"/* PathCharTypes.ASTARISK */+trimmed;}/**
 * Parse a string path into an array of segments
 */function core_base_parse(path){var keys=[];var index=-1;var mode=0/* States.BEFORE_PATH */;var subPathDepth=0;var c;var key;// eslint-disable-line
var newChar;var type;var transition;var action;var typeMap;var actions=[];actions[0/* Actions.APPEND */]=function(){if(key===undefined){key=newChar;}else{key+=newChar;}};actions[1/* Actions.PUSH */]=function(){if(key!==undefined){keys.push(key);key=undefined;}};actions[2/* Actions.INC_SUB_PATH_DEPTH */]=function(){actions[0/* Actions.APPEND */]();subPathDepth++;};actions[3/* Actions.PUSH_SUB_PATH */]=function(){if(subPathDepth>0){subPathDepth--;mode=4/* States.IN_SUB_PATH */;actions[0/* Actions.APPEND */]();}else{subPathDepth=0;if(key===undefined){return false;}key=core_base_formatSubPath(key);if(key===false){return false;}else{actions[1/* Actions.PUSH */]();}}};function maybeUnescapeQuote(){var nextChar=path[index+1];if(mode===5/* States.IN_SINGLE_QUOTE */&&nextChar==="'"/* PathCharTypes.SINGLE_QUOTE */||mode===6/* States.IN_DOUBLE_QUOTE */&&nextChar==="\""/* PathCharTypes.DOUBLE_QUOTE */){index++;newChar='\\'+nextChar;actions[0/* Actions.APPEND */]();return true;}}while(mode!==null){index++;c=path[index];if(c==='\\'&&maybeUnescapeQuote()){continue;}type=core_base_getPathCharType(c);typeMap=core_base_pathStateMachine[mode];transition=typeMap[type]||typeMap["l"/* PathCharTypes.ELSE */]||8/* States.ERROR */;// check parse error
if(transition===8/* States.ERROR */){return;}mode=transition[0];if(transition[1]!==undefined){action=actions[transition[1]];if(action){newChar=c;if(action()===false){return;}}}// check parse finish
if(mode===7/* States.AFTER_PATH */){return keys;}}}// path token cache
var core_base_cache=new Map();/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */function core_base_resolveWithKeyValue(obj,path){return dist_shared_isObject(obj)?obj[path]:null;}/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */function core_base_resolveValue(obj,path){// check object
if(!dist_shared_isObject(obj)){return null;}// parse path
var hit=core_base_cache.get(path);if(!hit){hit=core_base_parse(path);if(hit){core_base_cache.set(path,hit);}}// check hit
if(!hit){return null;}// resolve path value
var len=hit.length;var last=obj;var i=0;while(i<len){var val=last[hit[i]];if(val===undefined){return null;}if(dist_shared_isFunction(last)){return null;}last=val;i++;}return last;}var core_base_CoreWarnCodes={NOT_FOUND_KEY:1,FALLBACK_TO_TRANSLATE:2,CANNOT_FORMAT_NUMBER:3,FALLBACK_TO_NUMBER_FORMAT:4,CANNOT_FORMAT_DATE:5,FALLBACK_TO_DATE_FORMAT:6,EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER:7};var CORE_WARN_CODES_EXTEND_POINT=8;/** @internal */var dist_core_base_warnMessages=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},core_base_CoreWarnCodes.NOT_FOUND_KEY,"Not found '{key}' key in '{locale}' locale messages."),core_base_CoreWarnCodes.FALLBACK_TO_TRANSLATE,"Fall back to translate '{key}' key with '{target}' locale."),core_base_CoreWarnCodes.CANNOT_FORMAT_NUMBER,"Cannot format a number value due to not supported Intl.NumberFormat."),core_base_CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT,"Fall back to number format '{key}' key with '{target}' locale."),core_base_CoreWarnCodes.CANNOT_FORMAT_DATE,"Cannot format a date value due to not supported Intl.DateTimeFormat."),core_base_CoreWarnCodes.FALLBACK_TO_DATE_FORMAT,"Fall back to datetime format '{key}' key with '{target}' locale."),core_base_CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER,"This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.");function core_base_getWarnMessage(code){for(var _len36=arguments.length,args=new Array(_len36>1?_len36-1:0),_key36=1;_key36<_len36;_key36++){args[_key36-1]=arguments[_key36];}return format$1.apply(void 0,[dist_core_base_warnMessages[code]].concat(args));}/* eslint-disable @typescript-eslint/no-explicit-any *//**
 * Intlify core-base version
 * @internal
 */var core_base_VERSION='10.0.5';var core_base_NOT_REOSLVED=-1;var dist_core_base_DEFAULT_LOCALE='en-US';var core_base_MISSING_RESOLVE_VALUE='';var core_base_capitalize=function core_base_capitalize(str){return"".concat(str.charAt(0).toLocaleUpperCase()).concat(str.substr(1));};function core_base_getDefaultLinkedModifiers(){return{upper:function upper(val,type){// prettier-ignore
return type==='text'&&dist_shared_isString(val)?val.toUpperCase():type==='vnode'&&dist_shared_isObject(val)&&'__v_isVNode'in val?val.children.toUpperCase():val;},lower:function lower(val,type){// prettier-ignore
return type==='text'&&dist_shared_isString(val)?val.toLowerCase():type==='vnode'&&dist_shared_isObject(val)&&'__v_isVNode'in val?val.children.toLowerCase():val;},capitalize:function capitalize(val,type){// prettier-ignore
return type==='text'&&dist_shared_isString(val)?core_base_capitalize(val):type==='vnode'&&dist_shared_isObject(val)&&'__v_isVNode'in val?core_base_capitalize(val.children):val;}};}var core_base_compiler;function core_base_registerMessageCompiler(compiler){core_base_compiler=compiler;}var core_base_resolver;/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */function core_base_registerMessageResolver(resolver){core_base_resolver=resolver;}var core_base_fallbacker;/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */function core_base_registerLocaleFallbacker(fallbacker){core_base_fallbacker=fallbacker;}// Additional Meta for Intlify DevTools
var core_base_additionalMeta=null;/* #__NO_SIDE_EFFECTS__ */var core_base_setAdditionalMeta=function core_base_setAdditionalMeta(meta){core_base_additionalMeta=meta;};/* #__NO_SIDE_EFFECTS__ */var core_base_getAdditionalMeta=function core_base_getAdditionalMeta(){return core_base_additionalMeta;};var core_base_fallbackContext=null;var core_base_setFallbackContext=function core_base_setFallbackContext(context){core_base_fallbackContext=context;};var core_base_getFallbackContext=function core_base_getFallbackContext(){return core_base_fallbackContext;};// ID for CoreContext
var core_base_cid=0;function core_base_createCoreContext(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};// setup options
var onWarn=dist_shared_isFunction(options.onWarn)?options.onWarn:dist_shared_warn;var version=dist_shared_isString(options.version)?options.version:core_base_VERSION;var locale=dist_shared_isString(options.locale)||dist_shared_isFunction(options.locale)?options.locale:dist_core_base_DEFAULT_LOCALE;var _locale=dist_shared_isFunction(locale)?dist_core_base_DEFAULT_LOCALE:locale;var fallbackLocale=dist_shared_isArray(options.fallbackLocale)||dist_shared_isPlainObject(options.fallbackLocale)||dist_shared_isString(options.fallbackLocale)||options.fallbackLocale===false?options.fallbackLocale:_locale;var messages=dist_shared_isPlainObject(options.messages)?options.messages:createResources(_locale);var datetimeFormats=dist_shared_isPlainObject(options.datetimeFormats)?options.datetimeFormats:createResources(_locale);var numberFormats=dist_shared_isPlainObject(options.numberFormats)?options.numberFormats:createResources(_locale);var modifiers=dist_shared_assign(shared_create(),options.modifiers,core_base_getDefaultLinkedModifiers());var pluralRules=options.pluralRules||shared_create();var missing=dist_shared_isFunction(options.missing)?options.missing:null;var missingWarn=dist_shared_isBoolean(options.missingWarn)||dist_shared_isRegExp(options.missingWarn)?options.missingWarn:true;var fallbackWarn=dist_shared_isBoolean(options.fallbackWarn)||dist_shared_isRegExp(options.fallbackWarn)?options.fallbackWarn:true;var fallbackFormat=!!options.fallbackFormat;var unresolving=!!options.unresolving;var postTranslation=dist_shared_isFunction(options.postTranslation)?options.postTranslation:null;var processor=dist_shared_isPlainObject(options.processor)?options.processor:null;var warnHtmlMessage=dist_shared_isBoolean(options.warnHtmlMessage)?options.warnHtmlMessage:true;var escapeParameter=!!options.escapeParameter;var messageCompiler=dist_shared_isFunction(options.messageCompiler)?options.messageCompiler:core_base_compiler;if(false){}var messageResolver=dist_shared_isFunction(options.messageResolver)?options.messageResolver:core_base_resolver||core_base_resolveWithKeyValue;var localeFallbacker=dist_shared_isFunction(options.localeFallbacker)?options.localeFallbacker:core_base_fallbacker||core_base_fallbackWithSimple;var fallbackContext=dist_shared_isObject(options.fallbackContext)?options.fallbackContext:undefined;// setup internal options
var internalOptions=options;var __datetimeFormatters=dist_shared_isObject(internalOptions.__datetimeFormatters)?internalOptions.__datetimeFormatters:new Map();var __numberFormatters=dist_shared_isObject(internalOptions.__numberFormatters)?internalOptions.__numberFormatters:new Map();var __meta=dist_shared_isObject(internalOptions.__meta)?internalOptions.__meta:{};core_base_cid++;var context={version:version,cid:core_base_cid,locale:locale,fallbackLocale:fallbackLocale,messages:messages,modifiers:modifiers,pluralRules:pluralRules,missing:missing,missingWarn:missingWarn,fallbackWarn:fallbackWarn,fallbackFormat:fallbackFormat,unresolving:unresolving,postTranslation:postTranslation,processor:processor,warnHtmlMessage:warnHtmlMessage,escapeParameter:escapeParameter,messageCompiler:messageCompiler,messageResolver:messageResolver,localeFallbacker:localeFallbacker,fallbackContext:fallbackContext,onWarn:onWarn,__meta:__meta};{context.datetimeFormats=datetimeFormats;context.numberFormats=numberFormats;context.__datetimeFormatters=__datetimeFormatters;context.__numberFormatters=__numberFormatters;}// for vue-devtools timeline event
if(false){}// NOTE: experimental !!
if( false||__INTLIFY_PROD_DEVTOOLS__){core_base_initI18nDevTools(context,version,__meta);}return context;}var createResources=function createResources(locale){return _defineProperty2({},locale,shared_create());};/** @internal */function core_base_isTranslateFallbackWarn(fallback,key){return fallback instanceof RegExp?fallback.test(key):fallback;}/** @internal */function core_base_isTranslateMissingWarn(missing,key){return missing instanceof RegExp?missing.test(key):missing;}/** @internal */function core_base_handleMissing(context,key,locale,missingWarn,type){var missing=context.missing,onWarn=context.onWarn;// for vue-devtools timeline event
if(false){}if(missing!==null){var ret=missing(context,locale,key,type);return dist_shared_isString(ret)?ret:key;}else{if(false){}return key;}}/** @internal */function core_base_updateFallbackLocale(ctx,locale,fallback){var context=ctx;context.__localeChainCache=new Map();ctx.localeFallbacker(ctx,fallback,locale);}/** @internal */function core_base_isAlmostSameLocale(locale,compareLocale){if(locale===compareLocale)return false;return locale.split('-')[0]===compareLocale.split('-')[0];}/** @internal */function core_base_isImplicitFallback(targetLocale,locales){var index=locales.indexOf(targetLocale);if(index===-1){return false;}for(var i=index+1;i<locales.length;i++){if(core_base_isAlmostSameLocale(targetLocale,locales[i])){return true;}}return false;}/* eslint-enable @typescript-eslint/no-explicit-any */var core_base_intlDefined=typeof Intl!=='undefined';var core_base_Availabilities={dateTimeFormat:core_base_intlDefined&&typeof Intl.DateTimeFormat!=='undefined',numberFormat:core_base_intlDefined&&typeof Intl.NumberFormat!=='undefined'};// implementation of `datetime` function
function core_base_datetime(context){var datetimeFormats=context.datetimeFormats,unresolving=context.unresolving,fallbackLocale=context.fallbackLocale,onWarn=context.onWarn,localeFallbacker=context.localeFallbacker;var __datetimeFormatters=context.__datetimeFormatters;if(false){}for(var _len37=arguments.length,args=new Array(_len37>1?_len37-1:0),_key37=1;_key37<_len37;_key37++){args[_key37-1]=arguments[_key37];}var _core_base_parseDateT=core_base_parseDateTimeArgs.apply(void 0,args),_core_base_parseDateT2=_slicedToArray(_core_base_parseDateT,4),key=_core_base_parseDateT2[0],value=_core_base_parseDateT2[1],options=_core_base_parseDateT2[2],overrides=_core_base_parseDateT2[3];var missingWarn=dist_shared_isBoolean(options.missingWarn)?options.missingWarn:context.missingWarn;var fallbackWarn=dist_shared_isBoolean(options.fallbackWarn)?options.fallbackWarn:context.fallbackWarn;var part=!!options.part;var locale=core_base_getLocale(context,options);var locales=localeFallbacker(context,// eslint-disable-line @typescript-eslint/no-explicit-any
fallbackLocale,locale);if(!dist_shared_isString(key)||key===''){return new Intl.DateTimeFormat(locale,overrides).format(value);}// resolve format
var datetimeFormat={};var targetLocale;var format=null;var from=locale;var to=null;var type='datetime format';for(var i=0;i<locales.length;i++){targetLocale=to=locales[i];if(false){}// for vue-devtools timeline event
if(false){}datetimeFormat=datetimeFormats[targetLocale]||{};format=datetimeFormat[key];if(dist_shared_isPlainObject(format))break;core_base_handleMissing(context,key,targetLocale,missingWarn,type);// eslint-disable-line @typescript-eslint/no-explicit-any
from=to;}// checking format and target locale
if(!dist_shared_isPlainObject(format)||!dist_shared_isString(targetLocale)){return unresolving?core_base_NOT_REOSLVED:key;}var id="".concat(targetLocale,"__").concat(key);if(!shared_isEmptyObject(overrides)){id="".concat(id,"__").concat(JSON.stringify(overrides));}var formatter=__datetimeFormatters.get(id);if(!formatter){formatter=new Intl.DateTimeFormat(targetLocale,dist_shared_assign({},format,overrides));__datetimeFormatters.set(id,formatter);}return!part?formatter.format(value):formatter.formatToParts(value);}/** @internal */var core_base_DATETIME_FORMAT_OPTIONS_KEYS=['localeMatcher','weekday','era','year','month','day','hour','minute','second','timeZoneName','formatMatcher','hour12','timeZone','dateStyle','timeStyle','calendar','dayPeriod','numberingSystem','hourCycle','fractionalSecondDigits'];/** @internal */function core_base_parseDateTimeArgs(){for(var _len38=arguments.length,args=new Array(_len38),_key38=0;_key38<_len38;_key38++){args[_key38]=arguments[_key38];}var arg1=args[0],arg2=args[1],arg3=args[2],arg4=args[3];var options=shared_create();var overrides=shared_create();var value;if(dist_shared_isString(arg1)){// Only allow ISO strings - other date formats are often supported,
// but may cause different results in different browsers.
var matches=arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);if(!matches){throw core_base_createCoreError(core_base_CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);}// Some browsers can not parse the iso datetime separated by space,
// this is a compromise solution by replace the 'T'/' ' with 'T'
var dateTime=matches[3]?matches[3].trim().startsWith('T')?"".concat(matches[1].trim()).concat(matches[3].trim()):"".concat(matches[1].trim(),"T").concat(matches[3].trim()):matches[1].trim();value=new Date(dateTime);try{// This will fail if the date is not valid
value.toISOString();}catch(_unused){throw core_base_createCoreError(core_base_CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);}}else if(shared_isDate(arg1)){if(isNaN(arg1.getTime())){throw core_base_createCoreError(core_base_CoreErrorCodes.INVALID_DATE_ARGUMENT);}value=arg1;}else if(dist_shared_isNumber(arg1)){value=arg1;}else{throw core_base_createCoreError(core_base_CoreErrorCodes.INVALID_ARGUMENT);}if(dist_shared_isString(arg2)){options.key=arg2;}else if(dist_shared_isPlainObject(arg2)){Object.keys(arg2).forEach(function(key){if(core_base_DATETIME_FORMAT_OPTIONS_KEYS.includes(key)){overrides[key]=arg2[key];}else{options[key]=arg2[key];}});}if(dist_shared_isString(arg3)){options.locale=arg3;}else if(dist_shared_isPlainObject(arg3)){overrides=arg3;}if(dist_shared_isPlainObject(arg4)){overrides=arg4;}return[options.key||'',value,options,overrides];}/** @internal */function core_base_clearDateTimeFormat(ctx,locale,format){var context=ctx;for(var key in format){var id="".concat(locale,"__").concat(key);if(!context.__datetimeFormatters.has(id)){continue;}context.__datetimeFormatters.delete(id);}}// implementation of `number` function
function core_base_number(context){var numberFormats=context.numberFormats,unresolving=context.unresolving,fallbackLocale=context.fallbackLocale,onWarn=context.onWarn,localeFallbacker=context.localeFallbacker;var __numberFormatters=context.__numberFormatters;if(false){}for(var _len39=arguments.length,args=new Array(_len39>1?_len39-1:0),_key39=1;_key39<_len39;_key39++){args[_key39-1]=arguments[_key39];}var _core_base_parseNumbe=core_base_parseNumberArgs.apply(void 0,args),_core_base_parseNumbe2=_slicedToArray(_core_base_parseNumbe,4),key=_core_base_parseNumbe2[0],value=_core_base_parseNumbe2[1],options=_core_base_parseNumbe2[2],overrides=_core_base_parseNumbe2[3];var missingWarn=dist_shared_isBoolean(options.missingWarn)?options.missingWarn:context.missingWarn;var fallbackWarn=dist_shared_isBoolean(options.fallbackWarn)?options.fallbackWarn:context.fallbackWarn;var part=!!options.part;var locale=core_base_getLocale(context,options);var locales=localeFallbacker(context,// eslint-disable-line @typescript-eslint/no-explicit-any
fallbackLocale,locale);if(!dist_shared_isString(key)||key===''){return new Intl.NumberFormat(locale,overrides).format(value);}// resolve format
var numberFormat={};var targetLocale;var format=null;var from=locale;var to=null;var type='number format';for(var i=0;i<locales.length;i++){targetLocale=to=locales[i];if(false){}// for vue-devtools timeline event
if(false){}numberFormat=numberFormats[targetLocale]||{};format=numberFormat[key];if(dist_shared_isPlainObject(format))break;core_base_handleMissing(context,key,targetLocale,missingWarn,type);// eslint-disable-line @typescript-eslint/no-explicit-any
from=to;}// checking format and target locale
if(!dist_shared_isPlainObject(format)||!dist_shared_isString(targetLocale)){return unresolving?core_base_NOT_REOSLVED:key;}var id="".concat(targetLocale,"__").concat(key);if(!shared_isEmptyObject(overrides)){id="".concat(id,"__").concat(JSON.stringify(overrides));}var formatter=__numberFormatters.get(id);if(!formatter){formatter=new Intl.NumberFormat(targetLocale,dist_shared_assign({},format,overrides));__numberFormatters.set(id,formatter);}return!part?formatter.format(value):formatter.formatToParts(value);}/** @internal */var core_base_NUMBER_FORMAT_OPTIONS_KEYS=['localeMatcher','style','currency','currencyDisplay','currencySign','useGrouping','minimumIntegerDigits','minimumFractionDigits','maximumFractionDigits','minimumSignificantDigits','maximumSignificantDigits','compactDisplay','notation','signDisplay','unit','unitDisplay','roundingMode','roundingPriority','roundingIncrement','trailingZeroDisplay'];/** @internal */function core_base_parseNumberArgs(){for(var _len40=arguments.length,args=new Array(_len40),_key40=0;_key40<_len40;_key40++){args[_key40]=arguments[_key40];}var arg1=args[0],arg2=args[1],arg3=args[2],arg4=args[3];var options=shared_create();var overrides=shared_create();if(!dist_shared_isNumber(arg1)){throw core_base_createCoreError(core_base_CoreErrorCodes.INVALID_ARGUMENT);}var value=arg1;if(dist_shared_isString(arg2)){options.key=arg2;}else if(dist_shared_isPlainObject(arg2)){Object.keys(arg2).forEach(function(key){if(core_base_NUMBER_FORMAT_OPTIONS_KEYS.includes(key)){overrides[key]=arg2[key];}else{options[key]=arg2[key];}});}if(dist_shared_isString(arg3)){options.locale=arg3;}else if(dist_shared_isPlainObject(arg3)){overrides=arg3;}if(dist_shared_isPlainObject(arg4)){overrides=arg4;}return[options.key||'',value,options,overrides];}/** @internal */function core_base_clearNumberFormat(ctx,locale,format){var context=ctx;for(var key in format){var id="".concat(locale,"__").concat(key);if(!context.__numberFormatters.has(id)){continue;}context.__numberFormatters.delete(id);}}var core_base_DEFAULT_MODIFIER=function core_base_DEFAULT_MODIFIER(str){return str;};var core_base_DEFAULT_MESSAGE=function core_base_DEFAULT_MESSAGE(ctx){return'';};// eslint-disable-line
var core_base_DEFAULT_MESSAGE_DATA_TYPE='text';var core_base_DEFAULT_NORMALIZE=function core_base_DEFAULT_NORMALIZE(values){return values.length===0?'':shared_join(values);};var core_base_DEFAULT_INTERPOLATE=shared_toDisplayString;function core_base_pluralDefault(choice,choicesLength){choice=Math.abs(choice);if(choicesLength===2){// prettier-ignore
return choice?choice>1?1:0:1;}return choice?Math.min(choice,2):0;}function core_base_getPluralIndex(options){// prettier-ignore
var index=dist_shared_isNumber(options.pluralIndex)?options.pluralIndex:-1;// prettier-ignore
return options.named&&(dist_shared_isNumber(options.named.count)||dist_shared_isNumber(options.named.n))?dist_shared_isNumber(options.named.count)?options.named.count:dist_shared_isNumber(options.named.n)?options.named.n:index:index;}function core_base_normalizeNamed(pluralIndex,props){if(!props.count){props.count=pluralIndex;}if(!props.n){props.n=pluralIndex;}}function core_base_createMessageContext(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var locale=options.locale;var pluralIndex=core_base_getPluralIndex(options);var pluralRule=dist_shared_isObject(options.pluralRules)&&dist_shared_isString(locale)&&dist_shared_isFunction(options.pluralRules[locale])?options.pluralRules[locale]:core_base_pluralDefault;var orgPluralRule=dist_shared_isObject(options.pluralRules)&&dist_shared_isString(locale)&&dist_shared_isFunction(options.pluralRules[locale])?core_base_pluralDefault:undefined;var plural=function plural(messages){return messages[pluralRule(pluralIndex,messages.length,orgPluralRule)];};var _list=options.list||[];var list=function list(index){return _list[index];};// eslint-disable-next-line @typescript-eslint/no-explicit-any
var _named=options.named||shared_create();dist_shared_isNumber(options.pluralIndex)&&core_base_normalizeNamed(pluralIndex,_named);var named=function named(key){return _named[key];};function message(key,useLinked){// prettier-ignore
var msg=dist_shared_isFunction(options.messages)?options.messages(key,!!useLinked):dist_shared_isObject(options.messages)?options.messages[key]:false;return!msg?options.parent?options.parent.message(key)// resolve from parent messages
:core_base_DEFAULT_MESSAGE:msg;}var _modifier=function _modifier(name){return options.modifiers?options.modifiers[name]:core_base_DEFAULT_MODIFIER;};var normalize=dist_shared_isPlainObject(options.processor)&&dist_shared_isFunction(options.processor.normalize)?options.processor.normalize:core_base_DEFAULT_NORMALIZE;var interpolate=dist_shared_isPlainObject(options.processor)&&dist_shared_isFunction(options.processor.interpolate)?options.processor.interpolate:core_base_DEFAULT_INTERPOLATE;var type=dist_shared_isPlainObject(options.processor)&&dist_shared_isString(options.processor.type)?options.processor.type:core_base_DEFAULT_MESSAGE_DATA_TYPE;var linked=function linked(key){for(var _len41=arguments.length,args=new Array(_len41>1?_len41-1:0),_key41=1;_key41<_len41;_key41++){args[_key41-1]=arguments[_key41];}var arg1=args[0],arg2=args[1];var type='text';var modifier='';if(args.length===1){if(dist_shared_isObject(arg1)){modifier=arg1.modifier||modifier;type=arg1.type||type;}else if(dist_shared_isString(arg1)){modifier=arg1||modifier;}}else if(args.length===2){if(dist_shared_isString(arg1)){modifier=arg1||modifier;}if(dist_shared_isString(arg2)){type=arg2||type;}}var ret=message(key,true)(ctx);var msg=// The message in vnode resolved with linked are returned as an array by processor.nomalize
type==='vnode'&&dist_shared_isArray(ret)&&modifier?ret[0]:ret;return modifier?_modifier(modifier)(msg,type):msg;};var ctx=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},"list"/* HelperNameMap.LIST */,list),"named"/* HelperNameMap.NAMED */,named),"plural"/* HelperNameMap.PLURAL */,plural),"linked"/* HelperNameMap.LINKED */,linked),"message"/* HelperNameMap.MESSAGE */,message),"type"/* HelperNameMap.TYPE */,type),"interpolate"/* HelperNameMap.INTERPOLATE */,interpolate),"normalize"/* HelperNameMap.NORMALIZE */,normalize),"values"/* HelperNameMap.VALUES */,dist_shared_assign(shared_create(),_list,_named));return ctx;}var core_base_NOOP_MESSAGE_FUNCTION=function core_base_NOOP_MESSAGE_FUNCTION(){return'';};var core_base_isMessageFunction=function core_base_isMessageFunction(val){return dist_shared_isFunction(val);};// implementation of `translate` function
function core_base_translate(context){var fallbackFormat=context.fallbackFormat,postTranslation=context.postTranslation,unresolving=context.unresolving,messageCompiler=context.messageCompiler,fallbackLocale=context.fallbackLocale,messages=context.messages;for(var _len42=arguments.length,args=new Array(_len42>1?_len42-1:0),_key42=1;_key42<_len42;_key42++){args[_key42-1]=arguments[_key42];}var _core_base_parseTrans=core_base_parseTranslateArgs.apply(void 0,args),_core_base_parseTrans2=_slicedToArray(_core_base_parseTrans,2),key=_core_base_parseTrans2[0],options=_core_base_parseTrans2[1];var missingWarn=dist_shared_isBoolean(options.missingWarn)?options.missingWarn:context.missingWarn;var fallbackWarn=dist_shared_isBoolean(options.fallbackWarn)?options.fallbackWarn:context.fallbackWarn;var escapeParameter=dist_shared_isBoolean(options.escapeParameter)?options.escapeParameter:context.escapeParameter;var resolvedMessage=!!options.resolvedMessage;// prettier-ignore
var defaultMsgOrKey=dist_shared_isString(options.default)||dist_shared_isBoolean(options.default)// default by function option
?!dist_shared_isBoolean(options.default)?options.default:!messageCompiler?function(){return key;}:key:fallbackFormat// default by `fallbackFormat` option
?!messageCompiler?function(){return key;}:key:null;var enableDefaultMsg=fallbackFormat||defaultMsgOrKey!=null&&(dist_shared_isString(defaultMsgOrKey)||dist_shared_isFunction(defaultMsgOrKey));var locale=core_base_getLocale(context,options);// escape params
escapeParameter&&core_base_escapeParams(options);// resolve message format
// eslint-disable-next-line prefer-const
var _ref16=!resolvedMessage?core_base_resolveMessageFormat(context,key,locale,fallbackLocale,fallbackWarn,missingWarn):[key,locale,messages[locale]||shared_create()],_ref17=_slicedToArray(_ref16,3),formatScope=_ref17[0],targetLocale=_ref17[1],message=_ref17[2];// NOTE:
//  Fix to work around `ssrTransfrom` bug in Vite.
//  https://github.com/vitejs/vite/issues/4306
//  To get around this, use temporary variables.
//  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
var format=formatScope;// if you use default message, set it as message format!
var cacheBaseKey=key;if(!resolvedMessage&&!(dist_shared_isString(format)||dist_core_base_isMessageAST(format)||core_base_isMessageFunction(format))){if(enableDefaultMsg){format=defaultMsgOrKey;cacheBaseKey=format;}}// checking message format and target locale
if(!resolvedMessage&&(!(dist_shared_isString(format)||dist_core_base_isMessageAST(format)||core_base_isMessageFunction(format))||!dist_shared_isString(targetLocale))){return unresolving?core_base_NOT_REOSLVED:key;}// TODO: refactor
if(false){}// setup compile error detecting
var occurred=false;var onError=function onError(){occurred=true;};// compile message format
var msg=!core_base_isMessageFunction(format)?core_base_compileMessageFormat(context,key,targetLocale,format,cacheBaseKey,onError):format;// if occurred compile error, return the message format
if(occurred){return format;}// evaluate message with context
var ctxOptions=core_base_getMessageContextOptions(context,targetLocale,message,options);var msgContext=core_base_createMessageContext(ctxOptions);var messaged=core_base_evaluateMessage(context,msg,msgContext);// if use post translation option, proceed it with handler
var ret=postTranslation?postTranslation(messaged,key):messaged;// NOTE: experimental !!
if( false||__INTLIFY_PROD_DEVTOOLS__){// prettier-ignore
var payloads={timestamp:Date.now(),key:dist_shared_isString(key)?key:core_base_isMessageFunction(format)?format.key:'',locale:targetLocale||(core_base_isMessageFunction(format)?format.locale:''),format:dist_shared_isString(format)?format:core_base_isMessageFunction(format)?format.source:'',message:ret};payloads.meta=dist_shared_assign({},context.__meta,core_base_getAdditionalMeta()||{});core_base_translateDevTools(payloads);}return ret;}function core_base_escapeParams(options){if(dist_shared_isArray(options.list)){options.list=options.list.map(function(item){return dist_shared_isString(item)?shared_escapeHtml(item):item;});}else if(dist_shared_isObject(options.named)){Object.keys(options.named).forEach(function(key){if(dist_shared_isString(options.named[key])){options.named[key]=shared_escapeHtml(options.named[key]);}});}}function core_base_resolveMessageFormat(context,key,locale,fallbackLocale,fallbackWarn,missingWarn){var messages=context.messages,onWarn=context.onWarn,resolveValue=context.messageResolver,localeFallbacker=context.localeFallbacker;var locales=localeFallbacker(context,fallbackLocale,locale);// eslint-disable-line @typescript-eslint/no-explicit-any
var message=shared_create();var targetLocale;var format=null;var from=locale;var to=null;var type='translate';for(var i=0;i<locales.length;i++){targetLocale=to=locales[i];if(false){}// for vue-devtools timeline event
if(false){}message=messages[targetLocale]||shared_create();// for vue-devtools timeline event
var start=null;var startTag=void 0;var endTag=void 0;if(false){}if((format=resolveValue(message,key))===null){// if null, resolve with object key path
format=message[key];// eslint-disable-line @typescript-eslint/no-explicit-any
}// for vue-devtools timeline event
if(false){}if(dist_shared_isString(format)||dist_core_base_isMessageAST(format)||core_base_isMessageFunction(format)){break;}if(!core_base_isImplicitFallback(targetLocale,locales)){var missingRet=core_base_handleMissing(context,// eslint-disable-line @typescript-eslint/no-explicit-any
key,targetLocale,missingWarn,type);if(missingRet!==key){format=missingRet;}}from=to;}return[format,targetLocale,message];}function core_base_compileMessageFormat(context,key,targetLocale,format,cacheBaseKey,onError){var messageCompiler=context.messageCompiler,warnHtmlMessage=context.warnHtmlMessage;if(core_base_isMessageFunction(format)){var _msg3=format;_msg3.locale=_msg3.locale||targetLocale;_msg3.key=_msg3.key||key;return _msg3;}if(messageCompiler==null){var _msg4=function _msg4(){return format;};_msg4.locale=targetLocale;_msg4.key=key;return _msg4;}// for vue-devtools timeline event
var start=null;var startTag;var endTag;if(false){}var msg=messageCompiler(format,core_base_getCompileContext(context,targetLocale,cacheBaseKey,format,warnHtmlMessage,onError));// for vue-devtools timeline event
if(false){}msg.locale=targetLocale;msg.key=key;msg.source=format;return msg;}function core_base_evaluateMessage(context,msg,msgCtx){// for vue-devtools timeline event
var start=null;var startTag;var endTag;if(false){}var messaged=msg(msgCtx);// for vue-devtools timeline event
if(false){}return messaged;}/** @internal */function core_base_parseTranslateArgs(){for(var _len43=arguments.length,args=new Array(_len43),_key43=0;_key43<_len43;_key43++){args[_key43]=arguments[_key43];}var arg1=args[0],arg2=args[1],arg3=args[2];var options=shared_create();if(!dist_shared_isString(arg1)&&!dist_shared_isNumber(arg1)&&!core_base_isMessageFunction(arg1)&&!dist_core_base_isMessageAST(arg1)){throw core_base_createCoreError(core_base_CoreErrorCodes.INVALID_ARGUMENT);}// prettier-ignore
var key=dist_shared_isNumber(arg1)?String(arg1):core_base_isMessageFunction(arg1)?arg1:arg1;if(dist_shared_isNumber(arg2)){options.plural=arg2;}else if(dist_shared_isString(arg2)){options.default=arg2;}else if(dist_shared_isPlainObject(arg2)&&!shared_isEmptyObject(arg2)){options.named=arg2;}else if(dist_shared_isArray(arg2)){options.list=arg2;}if(dist_shared_isNumber(arg3)){options.plural=arg3;}else if(dist_shared_isString(arg3)){options.default=arg3;}else if(dist_shared_isPlainObject(arg3)){dist_shared_assign(options,arg3);}return[key,options];}function core_base_getCompileContext(context,locale,key,source,warnHtmlMessage,_onError2){return{locale:locale,key:key,warnHtmlMessage:warnHtmlMessage,onError:function onError(err){_onError2&&_onError2(err);if(false){}else{throw err;}},onCacheKey:function onCacheKey(source){return shared_generateFormatCacheKey(locale,key,source);}};}function core_base_getSourceForCodeFrame(source){if(isString(source)){return source;}else{if(source.loc&&source.loc.source){return source.loc.source;}}}function core_base_getMessageContextOptions(context,locale,message,options){var modifiers=context.modifiers,pluralRules=context.pluralRules,resolveValue=context.messageResolver,fallbackLocale=context.fallbackLocale,fallbackWarn=context.fallbackWarn,missingWarn=context.missingWarn,fallbackContext=context.fallbackContext;var resolveMessage=function resolveMessage(key,useLinked){var val=resolveValue(message,key);// fallback
if(val==null&&(fallbackContext||useLinked)){var _core_base_resolveMes=core_base_resolveMessageFormat(fallbackContext||context,// NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
key,locale,fallbackLocale,fallbackWarn,missingWarn),_core_base_resolveMes2=_slicedToArray(_core_base_resolveMes,3),_message5=_core_base_resolveMes2[2];val=resolveValue(_message5,key);}if(dist_shared_isString(val)||dist_core_base_isMessageAST(val)){var occurred=false;var onError=function onError(){occurred=true;};var msg=core_base_compileMessageFormat(context,key,locale,val,key,onError);return!occurred?msg:core_base_NOOP_MESSAGE_FUNCTION;}else if(core_base_isMessageFunction(val)){return val;}else{// TODO: should be implemented warning message
return core_base_NOOP_MESSAGE_FUNCTION;}};var ctxOptions={locale:locale,modifiers:modifiers,pluralRules:pluralRules,messages:resolveMessage};if(context.processor){ctxOptions.processor=context.processor;}if(options.list){ctxOptions.list=options.list;}if(options.named){ctxOptions.named=options.named;}if(dist_shared_isNumber(options.plural)){ctxOptions.pluralIndex=options.plural;}return ctxOptions;}{core_base_initFeatureFlags();};// ../../libs/i18n/node_modules/vue-i18n/dist/vue-i18n.mjs
/*!
  * vue-i18n v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  *//**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */var dist_vue_i18n_VERSION='10.0.5';/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */function dist_vue_i18n_initFeatureFlags(){if(typeof __VUE_I18N_FULL_INSTALL__!=='boolean'){shared_getGlobalThis().__VUE_I18N_FULL_INSTALL__=true;}if(typeof __VUE_I18N_LEGACY_API__!=='boolean'){shared_getGlobalThis().__VUE_I18N_LEGACY_API__=true;}if(typeof __INTLIFY_DROP_MESSAGE_COMPILER__!=='boolean'){shared_getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__=false;}if(typeof __INTLIFY_PROD_DEVTOOLS__!=='boolean'){shared_getGlobalThis().__INTLIFY_PROD_DEVTOOLS__=false;}}var vue_i18n_I18nWarnCodes={FALLBACK_TO_ROOT:CORE_WARN_CODES_EXTEND_POINT,// 8
NOT_FOUND_PARENT_SCOPE:9,IGNORE_OBJ_FLATTEN:10,DEPRECATE_TC:11};var dist_vue_i18n_warnMessages=_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({},vue_i18n_I18nWarnCodes.FALLBACK_TO_ROOT,"Fall back to {type} '{key}' with root locale."),vue_i18n_I18nWarnCodes.NOT_FOUND_PARENT_SCOPE,"Not found parent scope. use the global scope."),vue_i18n_I18nWarnCodes.IGNORE_OBJ_FLATTEN,"Ignore object flatten: '{key}' key has an string value"),vue_i18n_I18nWarnCodes.DEPRECATE_TC,"'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc\u2019 are going to remove in v11.");function dist_vue_i18n_getWarnMessage(code){for(var _len44=arguments.length,args=new Array(_len44>1?_len44-1:0),_key44=1;_key44<_len44;_key44++){args[_key44-1]=arguments[_key44];}return format.apply(void 0,[dist_vue_i18n_warnMessages[code]].concat(args));}var vue_i18n_I18nErrorCodes={// composer module errors
UNEXPECTED_RETURN_TYPE:CORE_ERROR_CODES_EXTEND_POINT,// 24
// legacy module errors
INVALID_ARGUMENT:25,// i18n module errors
MUST_BE_CALL_SETUP_TOP:26,NOT_INSTALLED:27,// directive module errors
REQUIRED_VALUE:28,INVALID_VALUE:29,// vue-devtools errors
CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN:30,NOT_INSTALLED_WITH_PROVIDE:31,// unexpected error
UNEXPECTED_ERROR:32,// not compatible legacy vue-i18n constructor
NOT_COMPATIBLE_LEGACY_VUE_I18N:33,// Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
NOT_AVAILABLE_COMPOSITION_IN_LEGACY:34};function vue_i18n_createI18nError(code){return message_compiler_createCompileError(code,null, false?0:undefined);}var dist_vue_i18n_errorMessages=(_dist_vue_i18n_errorM={},_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_dist_vue_i18n_errorM,vue_i18n_I18nErrorCodes.UNEXPECTED_RETURN_TYPE,'Unexpected return type in composer'),vue_i18n_I18nErrorCodes.INVALID_ARGUMENT,'Invalid argument'),vue_i18n_I18nErrorCodes.MUST_BE_CALL_SETUP_TOP,'Must be called at the top of a `setup` function'),vue_i18n_I18nErrorCodes.NOT_INSTALLED,'Need to install with `app.use` function'),vue_i18n_I18nErrorCodes.UNEXPECTED_ERROR,'Unexpected error'),vue_i18n_I18nErrorCodes.REQUIRED_VALUE,"Required in value: {0}"),vue_i18n_I18nErrorCodes.INVALID_VALUE,"Invalid value"),vue_i18n_I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN,"Cannot setup vue-devtools plugin"),vue_i18n_I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE,'Need to install with `provide` function'),vue_i18n_I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N,'Not compatible legacy VueI18n.'),_defineProperty2(_dist_vue_i18n_errorM,vue_i18n_I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY,'Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly'));var vue_i18n_TranslateVNodeSymbol=/* #__PURE__*/dist_shared_makeSymbol('__translateVNode');var vue_i18n_DatetimePartsSymbol=/* #__PURE__*/dist_shared_makeSymbol('__datetimeParts');var vue_i18n_NumberPartsSymbol=/* #__PURE__*/dist_shared_makeSymbol('__numberParts');var vue_i18n_EnableEmitter=/* #__PURE__*//* unused pure expression or super */null&&0;var vue_i18n_DisableEmitter=/* #__PURE__*//* unused pure expression or super */null&&0;var vue_i18n_SetPluralRulesSymbol=dist_shared_makeSymbol('__setPluralRules');dist_shared_makeSymbol('__intlifyMeta');var vue_i18n_InejctWithOptionSymbol=/* #__PURE__*/dist_shared_makeSymbol('__injectWithOption');var vue_i18n_DisposeSymbol=/* #__PURE__*/dist_shared_makeSymbol('__dispose');/* eslint-disable @typescript-eslint/no-explicit-any *//**
 * Transform flat json in obj to normal json in obj
 */function vue_i18n_handleFlatJson(obj){// check obj
if(!dist_shared_isObject(obj)){return obj;}for(var key in obj){// check key
if(!shared_hasOwn(obj,key)){continue;}// handle for normal json
if(!key.includes('.')){// recursive process value if value is also a object
if(dist_shared_isObject(obj[key])){vue_i18n_handleFlatJson(obj[key]);}}// handle for flat json, transform to normal json
else{// go to the last object
var subKeys=key.split('.');var lastIndex=subKeys.length-1;var currentObj=obj;var hasStringValue=false;for(var i=0;i<lastIndex;i++){if(!(subKeys[i]in currentObj)){currentObj[subKeys[i]]=shared_create();}if(!dist_shared_isObject(currentObj[subKeys[i]])){ false&&0;hasStringValue=true;break;}currentObj=currentObj[subKeys[i]];}// update last object value, delete old property
if(!hasStringValue){currentObj[subKeys[lastIndex]]=obj[key];delete obj[key];}// recursive process value if value is also a object
if(dist_shared_isObject(currentObj[subKeys[lastIndex]])){vue_i18n_handleFlatJson(currentObj[subKeys[lastIndex]]);}}}return obj;}function vue_i18n_getLocaleMessages(locale,options){var messages=options.messages,__i18n=options.__i18n,messageResolver=options.messageResolver,flatJson=options.flatJson;// prettier-ignore
var ret=dist_shared_isPlainObject(messages)?messages:dist_shared_isArray(__i18n)?shared_create():_defineProperty2({},locale,shared_create());// merge locale messages of i18n custom block
if(dist_shared_isArray(__i18n)){__i18n.forEach(function(custom){if('locale'in custom&&'resource'in custom){var _locale3=custom.locale,resource=custom.resource;if(_locale3){ret[_locale3]=ret[_locale3]||shared_create();shared_deepCopy(resource,ret[_locale3]);}else{shared_deepCopy(resource,ret);}}else{dist_shared_isString(custom)&&shared_deepCopy(JSON.parse(custom),ret);}});}// handle messages for flat json
if(messageResolver==null&&flatJson){for(var key in ret){if(shared_hasOwn(ret,key)){vue_i18n_handleFlatJson(ret[key]);}}}return ret;}function vue_i18n_getComponentOptions(instance){return instance.type;}function vue_i18n_adjustI18nResources(gl,options,componentOptions){// prettier-ignore
var messages=dist_shared_isObject(options.messages)?options.messages:shared_create();if('__i18nGlobal'in componentOptions){messages=vue_i18n_getLocaleMessages(gl.locale.value,{messages:messages,__i18n:componentOptions.__i18nGlobal});}// merge locale messages
var locales=Object.keys(messages);if(locales.length){locales.forEach(function(locale){gl.mergeLocaleMessage(locale,messages[locale]);});}{// merge datetime formats
if(dist_shared_isObject(options.datetimeFormats)){var _locales3=Object.keys(options.datetimeFormats);if(_locales3.length){_locales3.forEach(function(locale){gl.mergeDateTimeFormat(locale,options.datetimeFormats[locale]);});}}// merge number formats
if(dist_shared_isObject(options.numberFormats)){var _locales4=Object.keys(options.numberFormats);if(_locales4.length){_locales4.forEach(function(locale){gl.mergeNumberFormat(locale,options.numberFormats[locale]);});}}}}function vue_i18n_createTextNode(key){return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createVNode)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Text,null,key,0);}/* eslint-disable @typescript-eslint/no-explicit-any */// extend VNode interface
var vue_i18n_DEVTOOLS_META='__INTLIFY_META__';var vue_i18n_NOOP_RETURN_ARRAY=function vue_i18n_NOOP_RETURN_ARRAY(){return[];};var vue_i18n_NOOP_RETURN_FALSE=function vue_i18n_NOOP_RETURN_FALSE(){return false;};var vue_i18n_composerID=0;function vue_i18n_defineCoreMissingHandler(missing){return function(ctx,locale,key,type){return missing(locale,key,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.getCurrentInstance)()||undefined,type);};}// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */var vue_i18n_getMetaInfo=function vue_i18n_getMetaInfo(){var instance=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.getCurrentInstance)();var meta=null;return instance&&(meta=vue_i18n_getComponentOptions(instance)[vue_i18n_DEVTOOLS_META])?_defineProperty2({},vue_i18n_DEVTOOLS_META,meta):null;};/**
 * Create composer interface factory
 *
 * @internal
 */function vue_i18n_createComposer(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var __root=options.__root,__injectWithOption=options.__injectWithOption;var _isGlobal=__root===undefined;var flatJson=options.flatJson;var _ref=dist_shared_inBrowser?external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref:external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.shallowRef;var _inheritLocale=dist_shared_isBoolean(options.inheritLocale)?options.inheritLocale:true;var _locale=_ref(// prettier-ignore
__root&&_inheritLocale?__root.locale.value:dist_shared_isString(options.locale)?options.locale:dist_core_base_DEFAULT_LOCALE);var _fallbackLocale=_ref(// prettier-ignore
__root&&_inheritLocale?__root.fallbackLocale.value:dist_shared_isString(options.fallbackLocale)||dist_shared_isArray(options.fallbackLocale)||dist_shared_isPlainObject(options.fallbackLocale)||options.fallbackLocale===false?options.fallbackLocale:_locale.value);var _messages=_ref(vue_i18n_getLocaleMessages(_locale.value,options));// prettier-ignore
var _datetimeFormats=_ref(dist_shared_isPlainObject(options.datetimeFormats)?options.datetimeFormats:_defineProperty2({},_locale.value,{}));// prettier-ignore
var _numberFormats=_ref(dist_shared_isPlainObject(options.numberFormats)?options.numberFormats:_defineProperty2({},_locale.value,{}));// warning suppress options
// prettier-ignore
var _missingWarn=__root?__root.missingWarn:dist_shared_isBoolean(options.missingWarn)||dist_shared_isRegExp(options.missingWarn)?options.missingWarn:true;// prettier-ignore
var _fallbackWarn=__root?__root.fallbackWarn:dist_shared_isBoolean(options.fallbackWarn)||dist_shared_isRegExp(options.fallbackWarn)?options.fallbackWarn:true;// prettier-ignore
var _fallbackRoot=__root?__root.fallbackRoot:dist_shared_isBoolean(options.fallbackRoot)?options.fallbackRoot:true;// configure fall back to root
var _fallbackFormat=!!options.fallbackFormat;// runtime missing
var _missing=dist_shared_isFunction(options.missing)?options.missing:null;var _runtimeMissing=dist_shared_isFunction(options.missing)?vue_i18n_defineCoreMissingHandler(options.missing):null;// postTranslation handler
var _postTranslation=dist_shared_isFunction(options.postTranslation)?options.postTranslation:null;// prettier-ignore
var _warnHtmlMessage=__root?__root.warnHtmlMessage:dist_shared_isBoolean(options.warnHtmlMessage)?options.warnHtmlMessage:true;var _escapeParameter=!!options.escapeParameter;// custom linked modifiers
// prettier-ignore
var _modifiers=__root?__root.modifiers:dist_shared_isPlainObject(options.modifiers)?options.modifiers:{};// pluralRules
var _pluralRules=options.pluralRules||__root&&__root.pluralRules;// runtime context
// eslint-disable-next-line prefer-const
var _context;var getCoreContext=function getCoreContext(){_isGlobal&&core_base_setFallbackContext(null);var ctxOptions={version:dist_vue_i18n_VERSION,locale:_locale.value,fallbackLocale:_fallbackLocale.value,messages:_messages.value,modifiers:_modifiers,pluralRules:_pluralRules,missing:_runtimeMissing===null?undefined:_runtimeMissing,missingWarn:_missingWarn,fallbackWarn:_fallbackWarn,fallbackFormat:_fallbackFormat,unresolving:true,postTranslation:_postTranslation===null?undefined:_postTranslation,warnHtmlMessage:_warnHtmlMessage,escapeParameter:_escapeParameter,messageResolver:options.messageResolver,messageCompiler:options.messageCompiler,__meta:{framework:'vue'}};{ctxOptions.datetimeFormats=_datetimeFormats.value;ctxOptions.numberFormats=_numberFormats.value;ctxOptions.__datetimeFormatters=dist_shared_isPlainObject(_context)?_context.__datetimeFormatters:undefined;ctxOptions.__numberFormatters=dist_shared_isPlainObject(_context)?_context.__numberFormatters:undefined;}if(false){}var ctx=core_base_createCoreContext(ctxOptions);_isGlobal&&core_base_setFallbackContext(ctx);return ctx;};_context=getCoreContext();core_base_updateFallbackLocale(_context,_locale.value,_fallbackLocale.value);// track reactivity
function trackReactivityValues(){return[_locale.value,_fallbackLocale.value,_messages.value,_datetimeFormats.value,_numberFormats.value];}// locale
var locale=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)({get:function get(){return _locale.value;},set:function set(val){_locale.value=val;_context.locale=_locale.value;}});// fallbackLocale
var fallbackLocale=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)({get:function get(){return _fallbackLocale.value;},set:function set(val){_fallbackLocale.value=val;_context.fallbackLocale=_fallbackLocale.value;core_base_updateFallbackLocale(_context,_locale.value,val);}});// messages
var messages=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return _messages.value;});// datetimeFormats
var datetimeFormats=/* #__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return _datetimeFormats.value;});// numberFormats
var numberFormats=/* #__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return _numberFormats.value;});// getPostTranslationHandler
function getPostTranslationHandler(){return dist_shared_isFunction(_postTranslation)?_postTranslation:null;}// setPostTranslationHandler
function setPostTranslationHandler(handler){_postTranslation=handler;_context.postTranslation=handler;}// getMissingHandler
function getMissingHandler(){return _missing;}// setMissingHandler
function setMissingHandler(handler){if(handler!==null){_runtimeMissing=vue_i18n_defineCoreMissingHandler(handler);}_missing=handler;_context.missing=_runtimeMissing;}function isResolvedTranslateMessage(type,arg){return type!=='translate'||!arg.resolvedMessage;}var wrapWithDeps=function wrapWithDeps(fn,argumentParser,warnType,fallbackSuccess,fallbackFail,successCondition){trackReactivityValues();// track reactive dependency
// NOTE: experimental !!
var ret;try{if( false||__INTLIFY_PROD_DEVTOOLS__){core_base_setAdditionalMeta(vue_i18n_getMetaInfo());}if(!_isGlobal){_context.fallbackContext=__root?core_base_getFallbackContext():undefined;}ret=fn(_context);}finally{if( false||__INTLIFY_PROD_DEVTOOLS__){core_base_setAdditionalMeta(null);}if(!_isGlobal){_context.fallbackContext=undefined;}}if(warnType!=='translate exists'&&// for not `te` (e.g `t`)
dist_shared_isNumber(ret)&&ret===core_base_NOT_REOSLVED||warnType==='translate exists'&&!ret// for `te`
){var _argumentParser3=argumentParser(),_argumentParser4=_slicedToArray(_argumentParser3,2),key=_argumentParser4[0],arg2=_argumentParser4[1];if(false){}return __root&&_fallbackRoot?fallbackSuccess(__root):fallbackFail(key);}else if(successCondition(ret)){return ret;}else{/* istanbul ignore next */throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.UNEXPECTED_RETURN_TYPE);}};// t
function t(){for(var _len45=arguments.length,args=new Array(_len45),_key45=0;_key45<_len45;_key45++){args[_key45]=arguments[_key45];}return wrapWithDeps(function(context){return Reflect.apply(core_base_translate,null,[context].concat(args));},function(){return core_base_parseTranslateArgs.apply(void 0,args);},'translate',function(root){return Reflect.apply(root.t,root,[].concat(args));},function(key){return key;},function(val){return dist_shared_isString(val);});}// rt
function rt(){for(var _len46=arguments.length,args=new Array(_len46),_key46=0;_key46<_len46;_key46++){args[_key46]=arguments[_key46];}var arg1=args[0],arg2=args[1],arg3=args[2];if(arg3&&!dist_shared_isObject(arg3)){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.INVALID_ARGUMENT);}return t.apply(void 0,[arg1,arg2,dist_shared_assign({resolvedMessage:true},arg3||{})]);}// d
function d(){for(var _len47=arguments.length,args=new Array(_len47),_key47=0;_key47<_len47;_key47++){args[_key47]=arguments[_key47];}return wrapWithDeps(function(context){return Reflect.apply(core_base_datetime,null,[context].concat(args));},function(){return core_base_parseDateTimeArgs.apply(void 0,args);},'datetime format',function(root){return Reflect.apply(root.d,root,[].concat(args));},function(){return core_base_MISSING_RESOLVE_VALUE;},function(val){return dist_shared_isString(val);});}// n
function n(){for(var _len48=arguments.length,args=new Array(_len48),_key48=0;_key48<_len48;_key48++){args[_key48]=arguments[_key48];}return wrapWithDeps(function(context){return Reflect.apply(core_base_number,null,[context].concat(args));},function(){return core_base_parseNumberArgs.apply(void 0,args);},'number format',function(root){return Reflect.apply(root.n,root,[].concat(args));},function(){return core_base_MISSING_RESOLVE_VALUE;},function(val){return dist_shared_isString(val);});}// for custom processor
function normalize(values){return values.map(function(val){return dist_shared_isString(val)||dist_shared_isNumber(val)||dist_shared_isBoolean(val)?vue_i18n_createTextNode(String(val)):val;});}var interpolate=function interpolate(val){return val;};var processor={normalize:normalize,interpolate:interpolate,type:'vnode'};// translateVNode, using for `i18n-t` component
function translateVNode(){for(var _len49=arguments.length,args=new Array(_len49),_key49=0;_key49<_len49;_key49++){args[_key49]=arguments[_key49];}return wrapWithDeps(function(context){var ret;var _context=context;try{_context.processor=processor;ret=Reflect.apply(core_base_translate,null,[_context].concat(args));}finally{_context.processor=null;}return ret;},function(){return core_base_parseTranslateArgs.apply(void 0,args);},'translate',function(root){return root[vue_i18n_TranslateVNodeSymbol].apply(root,args);},function(key){return[vue_i18n_createTextNode(key)];},function(val){return dist_shared_isArray(val);});}// numberParts, using for `i18n-n` component
function numberParts(){for(var _len50=arguments.length,args=new Array(_len50),_key50=0;_key50<_len50;_key50++){args[_key50]=arguments[_key50];}return wrapWithDeps(function(context){return Reflect.apply(core_base_number,null,[context].concat(args));},function(){return core_base_parseNumberArgs.apply(void 0,args);},'number format',function(root){return root[vue_i18n_NumberPartsSymbol].apply(root,args);},vue_i18n_NOOP_RETURN_ARRAY,function(val){return dist_shared_isString(val)||dist_shared_isArray(val);});}// datetimeParts, using for `i18n-d` component
function datetimeParts(){for(var _len51=arguments.length,args=new Array(_len51),_key51=0;_key51<_len51;_key51++){args[_key51]=arguments[_key51];}return wrapWithDeps(function(context){return Reflect.apply(core_base_datetime,null,[context].concat(args));},function(){return core_base_parseDateTimeArgs.apply(void 0,args);},'datetime format',function(root){return root[vue_i18n_DatetimePartsSymbol].apply(root,args);},vue_i18n_NOOP_RETURN_ARRAY,function(val){return dist_shared_isString(val)||dist_shared_isArray(val);});}function setPluralRules(rules){_pluralRules=rules;_context.pluralRules=_pluralRules;}// te
function te(key,locale){return wrapWithDeps(function(){if(!key){return false;}var targetLocale=dist_shared_isString(locale)?locale:_locale.value;var message=getLocaleMessage(targetLocale);var resolved=_context.messageResolver(message,key);return dist_core_base_isMessageAST(resolved)||core_base_isMessageFunction(resolved)||dist_shared_isString(resolved);},function(){return[key];},'translate exists',function(root){return Reflect.apply(root.te,root,[key,locale]);},vue_i18n_NOOP_RETURN_FALSE,function(val){return dist_shared_isBoolean(val);});}function resolveMessages(key){var messages=null;var locales=core_base_fallbackWithLocaleChain(_context,_fallbackLocale.value,_locale.value);for(var i=0;i<locales.length;i++){var targetLocaleMessages=_messages.value[locales[i]]||{};var messageValue=_context.messageResolver(targetLocaleMessages,key);if(messageValue!=null){messages=messageValue;break;}}return messages;}// tm
function tm(key){var messages=resolveMessages(key);// prettier-ignore
return messages!=null?messages:__root?__root.tm(key)||{}:{};}// getLocaleMessage
function getLocaleMessage(locale){return _messages.value[locale]||{};}// setLocaleMessage
function setLocaleMessage(locale,message){if(flatJson){var _message=_defineProperty2({},locale,message);for(var key in _message){if(shared_hasOwn(_message,key)){vue_i18n_handleFlatJson(_message[key]);}}message=_message[locale];}_messages.value[locale]=message;_context.messages=_messages.value;}// mergeLocaleMessage
function mergeLocaleMessage(locale,message){_messages.value[locale]=_messages.value[locale]||{};var _message=_defineProperty2({},locale,message);if(flatJson){for(var key in _message){if(shared_hasOwn(_message,key)){vue_i18n_handleFlatJson(_message[key]);}}}message=_message[locale];shared_deepCopy(message,_messages.value[locale]);_context.messages=_messages.value;}// getDateTimeFormat
function getDateTimeFormat(locale){return _datetimeFormats.value[locale]||{};}// setDateTimeFormat
function setDateTimeFormat(locale,format){_datetimeFormats.value[locale]=format;_context.datetimeFormats=_datetimeFormats.value;core_base_clearDateTimeFormat(_context,locale,format);}// mergeDateTimeFormat
function mergeDateTimeFormat(locale,format){_datetimeFormats.value[locale]=dist_shared_assign(_datetimeFormats.value[locale]||{},format);_context.datetimeFormats=_datetimeFormats.value;core_base_clearDateTimeFormat(_context,locale,format);}// getNumberFormat
function getNumberFormat(locale){return _numberFormats.value[locale]||{};}// setNumberFormat
function setNumberFormat(locale,format){_numberFormats.value[locale]=format;_context.numberFormats=_numberFormats.value;core_base_clearNumberFormat(_context,locale,format);}// mergeNumberFormat
function mergeNumberFormat(locale,format){_numberFormats.value[locale]=dist_shared_assign(_numberFormats.value[locale]||{},format);_context.numberFormats=_numberFormats.value;core_base_clearNumberFormat(_context,locale,format);}// for debug
vue_i18n_composerID++;// watch root locale & fallbackLocale
if(__root&&dist_shared_inBrowser){(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.watch)(__root.locale,function(val){if(_inheritLocale){_locale.value=val;_context.locale=val;core_base_updateFallbackLocale(_context,_locale.value,_fallbackLocale.value);}});(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.watch)(__root.fallbackLocale,function(val){if(_inheritLocale){_fallbackLocale.value=val;_context.fallbackLocale=val;core_base_updateFallbackLocale(_context,_locale.value,_fallbackLocale.value);}});}// define basic composition API!
var composer=_defineProperty2({id:vue_i18n_composerID,locale:locale,fallbackLocale:fallbackLocale,get inheritLocale(){return _inheritLocale;},set inheritLocale(val){_inheritLocale=val;if(val&&__root){_locale.value=__root.locale.value;_fallbackLocale.value=__root.fallbackLocale.value;core_base_updateFallbackLocale(_context,_locale.value,_fallbackLocale.value);}},get availableLocales(){return Object.keys(_messages.value).sort();},messages:messages,get modifiers(){return _modifiers;},get pluralRules(){return _pluralRules||{};},get isGlobal(){return _isGlobal;},get missingWarn(){return _missingWarn;},set missingWarn(val){_missingWarn=val;_context.missingWarn=_missingWarn;},get fallbackWarn(){return _fallbackWarn;},set fallbackWarn(val){_fallbackWarn=val;_context.fallbackWarn=_fallbackWarn;},get fallbackRoot(){return _fallbackRoot;},set fallbackRoot(val){_fallbackRoot=val;},get fallbackFormat(){return _fallbackFormat;},set fallbackFormat(val){_fallbackFormat=val;_context.fallbackFormat=_fallbackFormat;},get warnHtmlMessage(){return _warnHtmlMessage;},set warnHtmlMessage(val){_warnHtmlMessage=val;_context.warnHtmlMessage=val;},get escapeParameter(){return _escapeParameter;},set escapeParameter(val){_escapeParameter=val;_context.escapeParameter=val;},t:t,getLocaleMessage:getLocaleMessage,setLocaleMessage:setLocaleMessage,mergeLocaleMessage:mergeLocaleMessage,getPostTranslationHandler:getPostTranslationHandler,setPostTranslationHandler:setPostTranslationHandler,getMissingHandler:getMissingHandler,setMissingHandler:setMissingHandler},vue_i18n_SetPluralRulesSymbol,setPluralRules);{composer.datetimeFormats=datetimeFormats;composer.numberFormats=numberFormats;composer.rt=rt;composer.te=te;composer.tm=tm;composer.d=d;composer.n=n;composer.getDateTimeFormat=getDateTimeFormat;composer.setDateTimeFormat=setDateTimeFormat;composer.mergeDateTimeFormat=mergeDateTimeFormat;composer.getNumberFormat=getNumberFormat;composer.setNumberFormat=setNumberFormat;composer.mergeNumberFormat=mergeNumberFormat;composer[vue_i18n_InejctWithOptionSymbol]=__injectWithOption;composer[vue_i18n_TranslateVNodeSymbol]=translateVNode;composer[vue_i18n_DatetimePartsSymbol]=datetimeParts;composer[vue_i18n_NumberPartsSymbol]=numberParts;}// for vue-devtools timeline event
if(false){}return composer;}/* eslint-enable @typescript-eslint/no-explicit-any */var vue_i18n_VUE_I18N_COMPONENT_TYPES='vue-i18n: composer properties';var vue_i18n_VueDevToolsLabels={'vue-devtools-plugin-vue-i18n':'Vue I18n DevTools','vue-i18n-resource-inspector':'Vue I18n DevTools','vue-i18n-timeline':'Vue I18n'};var vue_i18n_VueDevToolsPlaceholders={'vue-i18n-resource-inspector':'Search for scopes ...'};var vue_i18n_VueDevToolsTimelineColors={'vue-i18n-timeline':0xffcd19};var vue_i18n_devtoolsApi;function vue_i18n_enableDevTools(_x3,_x4){return _vue_i18n_enableDevTools.apply(this,arguments);}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _vue_i18n_enableDevTools(){_vue_i18n_enableDevTools=_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(app,i18n){return _regeneratorRuntime().wrap(function _callee6$(_context7){while(1)switch(_context7.prev=_context7.next){case 0:return _context7.abrupt("return",new Promise(function(resolve,reject){try{setupDevtoolsPlugin({id:'vue-devtools-plugin-vue-i18n',label:vue_i18n_VueDevToolsLabels['vue-devtools-plugin-vue-i18n'],packageName:'vue-i18n',homepage:'https://vue-i18n.intlify.dev',logo:'https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png',componentStateTypes:[vue_i18n_VUE_I18N_COMPONENT_TYPES],app:app// eslint-disable-line @typescript-eslint/no-explicit-any
},function(api){vue_i18n_devtoolsApi=api;api.on.visitComponentTree(function(_ref27){var componentInstance=_ref27.componentInstance,treeNode=_ref27.treeNode;vue_i18n_updateComponentTreeTags(componentInstance,treeNode,i18n);});api.on.inspectComponent(function(_ref28){var componentInstance=_ref28.componentInstance,instanceData=_ref28.instanceData;if(componentInstance.vnode.el&&componentInstance.vnode.el.__VUE_I18N__&&instanceData){if(i18n.mode==='legacy'){// ignore global scope on legacy mode
if(componentInstance.vnode.el.__VUE_I18N__!==i18n.global.__composer){vue_i18n_inspectComposer(instanceData,componentInstance.vnode.el.__VUE_I18N__);}}else{vue_i18n_inspectComposer(instanceData,componentInstance.vnode.el.__VUE_I18N__);}}});api.addInspector({id:'vue-i18n-resource-inspector',label:vue_i18n_VueDevToolsLabels['vue-i18n-resource-inspector'],icon:'language',treeFilterPlaceholder:vue_i18n_VueDevToolsPlaceholders['vue-i18n-resource-inspector']});api.on.getInspectorTree(function(payload){if(payload.app===app&&payload.inspectorId==='vue-i18n-resource-inspector'){vue_i18n_registerScope(payload,i18n);}});var roots=new Map();api.on.getInspectorState(/*#__PURE__*/function(){var _ref29=_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(payload){var _yield$api$getCompone3,_yield$api$getCompone4,root,instance;return _regeneratorRuntime().wrap(function _callee5$(_context6){while(1)switch(_context6.prev=_context6.next){case 0:if(!(payload.app===app&&payload.inspectorId==='vue-i18n-resource-inspector')){_context6.next=16;break;}api.unhighlightElement();vue_i18n_inspectScope(payload,i18n);if(!(payload.nodeId==='global')){_context6.next=14;break;}if(roots.has(payload.app)){_context6.next=11;break;}_context6.next=7;return api.getComponentInstances(payload.app);case 7:_yield$api$getCompone3=_context6.sent;_yield$api$getCompone4=_slicedToArray(_yield$api$getCompone3,1);root=_yield$api$getCompone4[0];roots.set(payload.app,root);case 11:api.highlightElement(roots.get(payload.app));_context6.next=16;break;case 14:instance=vue_i18n_getComponentInstance(payload.nodeId,i18n);instance&&api.highlightElement(instance);case 16:case"end":return _context6.stop();}},_callee5);}));return function(_x6){return _ref29.apply(this,arguments);};}());api.on.editInspectorState(function(payload){if(payload.app===app&&payload.inspectorId==='vue-i18n-resource-inspector'){vue_i18n_editScope(payload,i18n);}});api.addTimelineLayer({id:'vue-i18n-timeline',label:vue_i18n_VueDevToolsLabels['vue-i18n-timeline'],color:vue_i18n_VueDevToolsTimelineColors['vue-i18n-timeline']});resolve(true);});}catch(e){// eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
reject(false);}}));case 1:case"end":return _context7.stop();}},_callee6);}));return _vue_i18n_enableDevTools.apply(this,arguments);}function vue_i18n_getI18nScopeLable(instance){return instance.type.name||instance.type.displayName||instance.type.__file||'Anonymous';}function vue_i18n_updateComponentTreeTags(instance,// eslint-disable-line @typescript-eslint/no-explicit-any
treeNode,i18n){// prettier-ignore
var global=i18n.mode==='composition'?i18n.global:i18n.global.__composer;if(instance&&instance.vnode.el&&instance.vnode.el.__VUE_I18N__){// add custom tags local scope only
if(instance.vnode.el.__VUE_I18N__!==global){var tag={label:"i18n (".concat(vue_i18n_getI18nScopeLable(instance)," Scope)"),textColor:0x000000,backgroundColor:0xffcd19};treeNode.tags.push(tag);}}}function vue_i18n_inspectComposer(instanceData,composer){var type=vue_i18n_VUE_I18N_COMPONENT_TYPES;instanceData.state.push({type:type,key:'locale',editable:true,value:composer.locale.value});instanceData.state.push({type:type,key:'availableLocales',editable:false,value:composer.availableLocales});instanceData.state.push({type:type,key:'fallbackLocale',editable:true,value:composer.fallbackLocale.value});instanceData.state.push({type:type,key:'inheritLocale',editable:true,value:composer.inheritLocale});instanceData.state.push({type:type,key:'messages',editable:false,value:vue_i18n_getLocaleMessageValue(composer.messages.value)});{instanceData.state.push({type:type,key:'datetimeFormats',editable:false,value:composer.datetimeFormats.value});instanceData.state.push({type:type,key:'numberFormats',editable:false,value:composer.numberFormats.value});}}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function vue_i18n_getLocaleMessageValue(messages){var value={};Object.keys(messages).forEach(function(key){var v=messages[key];if(isFunction(v)&&'source'in v){value[key]=vue_i18n_getMessageFunctionDetails(v);}else if(isMessageAST(v)&&v.loc&&v.loc.source){value[key]=v.loc.source;}else if(isObject(v)){value[key]=vue_i18n_getLocaleMessageValue(v);}else{value[key]=v;}});return value;}var vue_i18n_ESC={'<':'&lt;','>':'&gt;','"':'&quot;','&':'&amp;'};function dist_vue_i18n_escape(s){return s.replace(/[<>"&]/g,vue_i18n_escapeChar);}function vue_i18n_escapeChar(a){return vue_i18n_ESC[a]||a;}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function vue_i18n_getMessageFunctionDetails(func){var argString=func.source?"(\"".concat(dist_vue_i18n_escape(func.source),"\")"):"(?)";return{_custom:{type:'function',display:"<span>\u0192</span> ".concat(argString)}};}function vue_i18n_registerScope(payload,i18n){payload.rootNodes.push({id:'global',label:'Global Scope'});// prettier-ignore
var global=i18n.mode==='composition'?i18n.global:i18n.global.__composer;var _iterator3=_createForOfIteratorHelper(i18n.__instances),_step3;try{for(_iterator3.s();!(_step3=_iterator3.n()).done;){var _step3$value=_slicedToArray(_step3.value,2),keyInstance=_step3$value[0],instance=_step3$value[1];// prettier-ignore
var composer=i18n.mode==='composition'?instance:instance.__composer;if(global===composer){continue;}payload.rootNodes.push({id:composer.id.toString(),label:"".concat(vue_i18n_getI18nScopeLable(keyInstance)," Scope")});}}catch(err){_iterator3.e(err);}finally{_iterator3.f();}}function vue_i18n_getComponentInstance(nodeId,i18n){var instance=null;if(nodeId!=='global'){var _iterator4=_createForOfIteratorHelper(i18n.__instances.entries()),_step4;try{for(_iterator4.s();!(_step4=_iterator4.n()).done;){var _step4$value=_slicedToArray(_step4.value,2),component=_step4$value[0],composer=_step4$value[1];if(composer.id.toString()===nodeId){instance=component;break;}}}catch(err){_iterator4.e(err);}finally{_iterator4.f();}}return instance;}function vue_i18n_getComposer$2(nodeId,i18n){if(nodeId==='global'){return i18n.mode==='composition'?i18n.global:i18n.global.__composer;}else{var instance=Array.from(i18n.__instances.values()).find(function(item){return item.id.toString()===nodeId;});if(instance){return i18n.mode==='composition'?instance:instance.__composer;}else{return null;}}}function vue_i18n_inspectScope(payload,i18n// eslint-disable-next-line @typescript-eslint/no-explicit-any
){var composer=vue_i18n_getComposer$2(payload.nodeId,i18n);if(composer){// TODO:
// eslint-disable-next-line @typescript-eslint/no-explicit-any
payload.state=vue_i18n_makeScopeInspectState(composer);}return null;}function vue_i18n_makeScopeInspectState(composer){var state={};var localeType='Locale related info';var localeStates=[{type:localeType,key:'locale',editable:true,value:composer.locale.value},{type:localeType,key:'fallbackLocale',editable:true,value:composer.fallbackLocale.value},{type:localeType,key:'availableLocales',editable:false,value:composer.availableLocales},{type:localeType,key:'inheritLocale',editable:true,value:composer.inheritLocale}];state[localeType]=localeStates;var localeMessagesType='Locale messages info';var localeMessagesStates=[{type:localeMessagesType,key:'messages',editable:false,value:vue_i18n_getLocaleMessageValue(composer.messages.value)}];state[localeMessagesType]=localeMessagesStates;{var datetimeFormatsType='Datetime formats info';var datetimeFormatsStates=[{type:datetimeFormatsType,key:'datetimeFormats',editable:false,value:composer.datetimeFormats.value}];state[datetimeFormatsType]=datetimeFormatsStates;var numberFormatsType='Datetime formats info';var numberFormatsStates=[{type:numberFormatsType,key:'numberFormats',editable:false,value:composer.numberFormats.value}];state[numberFormatsType]=numberFormatsStates;}return state;}function vue_i18n_addTimelineEvent(event,payload){if(vue_i18n_devtoolsApi){var groupId;if(payload&&'groupId'in payload){groupId=payload.groupId;delete payload.groupId;}vue_i18n_devtoolsApi.addTimelineEvent({layerId:'vue-i18n-timeline',event:{title:event,groupId:groupId,time:Date.now(),meta:{},data:payload||{},logType:event==='compile-error'?'error':event==='fallback'||event==='missing'?'warning':'default'}});}}function vue_i18n_editScope(payload,i18n){var composer=vue_i18n_getComposer$2(payload.nodeId,i18n);if(composer){var _payload$path2=_slicedToArray(payload.path,1),field=_payload$path2[0];if(field==='locale'&&isString(payload.state.value)){composer.locale.value=payload.state.value;}else if(field==='fallbackLocale'&&(isString(payload.state.value)||isArray(payload.state.value)||isObject(payload.state.value))){composer.fallbackLocale.value=payload.state.value;}else if(field==='inheritLocale'&&isBoolean(payload.state.value)){composer.inheritLocale=payload.state.value;}}}/* eslint-disable @typescript-eslint/no-explicit-any *//**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */function vue_i18n_convertComposerOptions(options){var locale=dist_shared_isString(options.locale)?options.locale:dist_core_base_DEFAULT_LOCALE;var fallbackLocale=dist_shared_isString(options.fallbackLocale)||dist_shared_isArray(options.fallbackLocale)||dist_shared_isPlainObject(options.fallbackLocale)||options.fallbackLocale===false?options.fallbackLocale:locale;var missing=dist_shared_isFunction(options.missing)?options.missing:undefined;var missingWarn=dist_shared_isBoolean(options.silentTranslationWarn)||dist_shared_isRegExp(options.silentTranslationWarn)?!options.silentTranslationWarn:true;var fallbackWarn=dist_shared_isBoolean(options.silentFallbackWarn)||dist_shared_isRegExp(options.silentFallbackWarn)?!options.silentFallbackWarn:true;var fallbackRoot=dist_shared_isBoolean(options.fallbackRoot)?options.fallbackRoot:true;var fallbackFormat=!!options.formatFallbackMessages;var modifiers=dist_shared_isPlainObject(options.modifiers)?options.modifiers:{};var pluralizationRules=options.pluralizationRules;var postTranslation=dist_shared_isFunction(options.postTranslation)?options.postTranslation:undefined;var warnHtmlMessage=dist_shared_isString(options.warnHtmlInMessage)?options.warnHtmlInMessage!=='off':true;var escapeParameter=!!options.escapeParameterHtml;var inheritLocale=dist_shared_isBoolean(options.sync)?options.sync:true;var messages=options.messages;if(dist_shared_isPlainObject(options.sharedMessages)){var sharedMessages=options.sharedMessages;var locales=Object.keys(sharedMessages);messages=locales.reduce(function(messages,locale){var message=messages[locale]||(messages[locale]={});dist_shared_assign(message,sharedMessages[locale]);return messages;},messages||{});}var __i18n=options.__i18n,__root=options.__root,__injectWithOption=options.__injectWithOption;var datetimeFormats=options.datetimeFormats;var numberFormats=options.numberFormats;var flatJson=options.flatJson;return{locale:locale,fallbackLocale:fallbackLocale,messages:messages,flatJson:flatJson,datetimeFormats:datetimeFormats,numberFormats:numberFormats,missing:missing,missingWarn:missingWarn,fallbackWarn:fallbackWarn,fallbackRoot:fallbackRoot,fallbackFormat:fallbackFormat,modifiers:modifiers,pluralRules:pluralizationRules,postTranslation:postTranslation,warnHtmlMessage:warnHtmlMessage,escapeParameter:escapeParameter,messageResolver:options.messageResolver,inheritLocale:inheritLocale,__i18n:__i18n,__root:__root,__injectWithOption:__injectWithOption};}/**
 * create VueI18n interface factory
 *
 * @internal
 */function vue_i18n_createVueI18n(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var composer=vue_i18n_createComposer(vue_i18n_convertComposerOptions(options));var __extender=options.__extender;// defines VueI18n
var vueI18n={// id
id:composer.id,// locale
get locale(){return composer.locale.value;},set locale(val){composer.locale.value=val;},// fallbackLocale
get fallbackLocale(){return composer.fallbackLocale.value;},set fallbackLocale(val){composer.fallbackLocale.value=val;},// messages
get messages(){return composer.messages.value;},// datetimeFormats
get datetimeFormats(){return composer.datetimeFormats.value;},// numberFormats
get numberFormats(){return composer.numberFormats.value;},// availableLocales
get availableLocales(){return composer.availableLocales;},// missing
get missing(){return composer.getMissingHandler();},set missing(handler){composer.setMissingHandler(handler);},// silentTranslationWarn
get silentTranslationWarn(){return dist_shared_isBoolean(composer.missingWarn)?!composer.missingWarn:composer.missingWarn;},set silentTranslationWarn(val){composer.missingWarn=dist_shared_isBoolean(val)?!val:val;},// silentFallbackWarn
get silentFallbackWarn(){return dist_shared_isBoolean(composer.fallbackWarn)?!composer.fallbackWarn:composer.fallbackWarn;},set silentFallbackWarn(val){composer.fallbackWarn=dist_shared_isBoolean(val)?!val:val;},// modifiers
get modifiers(){return composer.modifiers;},// formatFallbackMessages
get formatFallbackMessages(){return composer.fallbackFormat;},set formatFallbackMessages(val){composer.fallbackFormat=val;},// postTranslation
get postTranslation(){return composer.getPostTranslationHandler();},set postTranslation(handler){composer.setPostTranslationHandler(handler);},// sync
get sync(){return composer.inheritLocale;},set sync(val){composer.inheritLocale=val;},// warnInHtmlMessage
get warnHtmlInMessage(){return composer.warnHtmlMessage?'warn':'off';},set warnHtmlInMessage(val){composer.warnHtmlMessage=val!=='off';},// escapeParameterHtml
get escapeParameterHtml(){return composer.escapeParameter;},set escapeParameterHtml(val){composer.escapeParameter=val;},// pluralizationRules
get pluralizationRules(){return composer.pluralRules||{};},// for internal
__composer:composer,// t
t:function t(){for(var _len52=arguments.length,args=new Array(_len52),_key52=0;_key52<_len52;_key52++){args[_key52]=arguments[_key52];}return Reflect.apply(composer.t,composer,[].concat(args));},// rt
rt:function rt(){for(var _len53=arguments.length,args=new Array(_len53),_key53=0;_key53<_len53;_key53++){args[_key53]=arguments[_key53];}return Reflect.apply(composer.rt,composer,[].concat(args));},// tc
tc:function tc(){for(var _len54=arguments.length,args=new Array(_len54),_key54=0;_key54<_len54;_key54++){args[_key54]=arguments[_key54];}var arg1=args[0],arg2=args[1],arg3=args[2];var options={plural:1};var list=null;var named=null;if(false){}if(!dist_shared_isString(arg1)){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.INVALID_ARGUMENT);}var key=arg1;if(dist_shared_isString(arg2)){options.locale=arg2;}else if(dist_shared_isNumber(arg2)){options.plural=arg2;}else if(dist_shared_isArray(arg2)){list=arg2;}else if(dist_shared_isPlainObject(arg2)){named=arg2;}if(dist_shared_isString(arg3)){options.locale=arg3;}else if(dist_shared_isArray(arg3)){list=arg3;}else if(dist_shared_isPlainObject(arg3)){named=arg3;}// return composer.t(key, (list || named || {}) as any, options)
return Reflect.apply(composer.t,composer,[key,list||named||{},options]);},// te
te:function te(key,locale){return composer.te(key,locale);},// tm
tm:function tm(key){return composer.tm(key);},// getLocaleMessage
getLocaleMessage:function getLocaleMessage(locale){return composer.getLocaleMessage(locale);},// setLocaleMessage
setLocaleMessage:function setLocaleMessage(locale,message){composer.setLocaleMessage(locale,message);},// mergeLocaleMessage
mergeLocaleMessage:function mergeLocaleMessage(locale,message){composer.mergeLocaleMessage(locale,message);},// d
d:function d(){for(var _len55=arguments.length,args=new Array(_len55),_key55=0;_key55<_len55;_key55++){args[_key55]=arguments[_key55];}return Reflect.apply(composer.d,composer,[].concat(args));},// getDateTimeFormat
getDateTimeFormat:function getDateTimeFormat(locale){return composer.getDateTimeFormat(locale);},// setDateTimeFormat
setDateTimeFormat:function setDateTimeFormat(locale,format){composer.setDateTimeFormat(locale,format);},// mergeDateTimeFormat
mergeDateTimeFormat:function mergeDateTimeFormat(locale,format){composer.mergeDateTimeFormat(locale,format);},// n
n:function n(){for(var _len56=arguments.length,args=new Array(_len56),_key56=0;_key56<_len56;_key56++){args[_key56]=arguments[_key56];}return Reflect.apply(composer.n,composer,[].concat(args));},// getNumberFormat
getNumberFormat:function getNumberFormat(locale){return composer.getNumberFormat(locale);},// setNumberFormat
setNumberFormat:function setNumberFormat(locale,format){composer.setNumberFormat(locale,format);},// mergeNumberFormat
mergeNumberFormat:function mergeNumberFormat(locale,format){composer.mergeNumberFormat(locale,format);}};vueI18n.__extender=__extender;// for vue-devtools timeline event
if(false){}return vueI18n;}/* eslint-enable @typescript-eslint/no-explicit-any *//**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */function vue_i18n_defineMixin(vuei18n,composer,i18n){return{beforeCreate:function beforeCreate(){var _this3=this;var instance=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.getCurrentInstance)();/* istanbul ignore if */if(!instance){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.UNEXPECTED_ERROR);}var options=this.$options;if(options.i18n){var optionsI18n=options.i18n;if(options.__i18n){optionsI18n.__i18n=options.__i18n;}optionsI18n.__root=composer;if(this===this.$root){// merge option and gttach global
this.$i18n=vue_i18n_mergeToGlobal(vuei18n,optionsI18n);}else{optionsI18n.__injectWithOption=true;optionsI18n.__extender=i18n.__vueI18nExtend;// atttach local VueI18n instance
this.$i18n=vue_i18n_createVueI18n(optionsI18n);// extend VueI18n instance
var _vueI18n=this.$i18n;if(_vueI18n.__extender){_vueI18n.__disposer=_vueI18n.__extender(this.$i18n);}}}else if(options.__i18n){if(this===this.$root){// merge option and gttach global
this.$i18n=vue_i18n_mergeToGlobal(vuei18n,options);}else{// atttach local VueI18n instance
this.$i18n=vue_i18n_createVueI18n({__i18n:options.__i18n,__injectWithOption:true,__extender:i18n.__vueI18nExtend,__root:composer});// extend VueI18n instance
var _vueI18n3=this.$i18n;if(_vueI18n3.__extender){_vueI18n3.__disposer=_vueI18n3.__extender(this.$i18n);}}}else{// attach global VueI18n instance
this.$i18n=vuei18n;}if(options.__i18nGlobal){vue_i18n_adjustI18nResources(composer,options,options);}// defines vue-i18n legacy APIs
this.$t=function(){var _this3$$i18n;return(_this3$$i18n=_this3.$i18n).t.apply(_this3$$i18n,arguments);};this.$rt=function(){var _this3$$i18n2;return(_this3$$i18n2=_this3.$i18n).rt.apply(_this3$$i18n2,arguments);};this.$tc=function(){var _this3$$i18n3;return(_this3$$i18n3=_this3.$i18n).tc.apply(_this3$$i18n3,arguments);};this.$te=function(key,locale){return _this3.$i18n.te(key,locale);};this.$d=function(){var _this3$$i18n4;return(_this3$$i18n4=_this3.$i18n).d.apply(_this3$$i18n4,arguments);};this.$n=function(){var _this3$$i18n5;return(_this3$$i18n5=_this3.$i18n).n.apply(_this3$$i18n5,arguments);};this.$tm=function(key){return _this3.$i18n.tm(key);};i18n.__setInstance(instance,this.$i18n);},mounted:function mounted(){/* istanbul ignore if */if(false){}},unmounted:function unmounted(){var instance=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.getCurrentInstance)();/* istanbul ignore if */if(!instance){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.UNEXPECTED_ERROR);}var _vueI18n=this.$i18n;/* istanbul ignore if */if(false){}delete this.$t;delete this.$rt;delete this.$tc;delete this.$te;delete this.$d;delete this.$n;delete this.$tm;if(_vueI18n.__disposer){_vueI18n.__disposer();delete _vueI18n.__disposer;delete _vueI18n.__extender;}i18n.__deleteInstance(instance);delete this.$i18n;}};}function vue_i18n_mergeToGlobal(g,options){g.locale=options.locale||g.locale;g.fallbackLocale=options.fallbackLocale||g.fallbackLocale;g.missing=options.missing||g.missing;g.silentTranslationWarn=options.silentTranslationWarn||g.silentFallbackWarn;g.silentFallbackWarn=options.silentFallbackWarn||g.silentFallbackWarn;g.formatFallbackMessages=options.formatFallbackMessages||g.formatFallbackMessages;g.postTranslation=options.postTranslation||g.postTranslation;g.warnHtmlInMessage=options.warnHtmlInMessage||g.warnHtmlInMessage;g.escapeParameterHtml=options.escapeParameterHtml||g.escapeParameterHtml;g.sync=options.sync||g.sync;g.__composer[vue_i18n_SetPluralRulesSymbol](options.pluralizationRules||g.pluralizationRules);var messages=vue_i18n_getLocaleMessages(g.locale,{messages:options.messages,__i18n:options.__i18n});Object.keys(messages).forEach(function(locale){return g.mergeLocaleMessage(locale,messages[locale]);});if(options.datetimeFormats){Object.keys(options.datetimeFormats).forEach(function(locale){return g.mergeDateTimeFormat(locale,options.datetimeFormats[locale]);});}if(options.numberFormats){Object.keys(options.numberFormats).forEach(function(locale){return g.mergeNumberFormat(locale,options.numberFormats[locale]);});}return g;}var vue_i18n_baseFormatProps={tag:{type:[String,Object]},locale:{type:String},scope:{type:String,// NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
validator:function validator(val/* ComponentI18nScope */){return val==='parent'||val==='global';},default:'parent'/* ComponentI18nScope */},i18n:{type:Object}};function vue_i18n_getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
_ref22,// SetupContext,
keys){var slots=_ref22.slots;if(keys.length===1&&keys[0]==='default'){// default slot with list
var ret=slots.default?slots.default():[];// eslint-disable-next-line @typescript-eslint/no-explicit-any
return ret.reduce(function(slot,current){return[].concat(_toConsumableArray(slot),_toConsumableArray(current.type===external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment?current.children:[current]));},[]);}else{// named slots
return keys.reduce(function(arg,key){var slot=slots[key];if(slot){arg[key]=slot();}return arg;},shared_create());}}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function vue_i18n_getFragmentableTag(){return external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment;}var vue_i18n_TranslationImpl=/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({/* eslint-disable */name:'i18n-t',props:dist_shared_assign({keypath:{type:String,required:true},plural:{type:[Number,String],validator:function validator(val){return dist_shared_isNumber(val)||!isNaN(val);}}},vue_i18n_baseFormatProps),/* eslint-enable */// eslint-disable-next-line @typescript-eslint/no-explicit-any
setup:function setup(props,context){var slots=context.slots,attrs=context.attrs;// NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
var i18n=props.i18n||vue_i18n_useI18n({useScope:props.scope,__useComponent:true});return function(){var keys=Object.keys(slots).filter(function(key){return key!=='_';});var options=shared_create();if(props.locale){options.locale=props.locale;}if(props.plural!==undefined){options.plural=dist_shared_isString(props.plural)?+props.plural:props.plural;}var arg=vue_i18n_getInterpolateArg(context,keys);// eslint-disable-next-line @typescript-eslint/no-explicit-any
var children=i18n[vue_i18n_TranslateVNodeSymbol](props.keypath,arg,options);var assignedAttrs=dist_shared_assign(shared_create(),attrs);var tag=dist_shared_isString(props.tag)||dist_shared_isObject(props.tag)?props.tag:vue_i18n_getFragmentableTag();return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.h)(tag,assignedAttrs,children);};}});/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 *//**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */var vue_i18n_Translation=vue_i18n_TranslationImpl;var vue_i18n_I18nT=/* unused pure expression or super */null&&0;function vue_i18n_isVNode(target){return dist_shared_isArray(target)&&!dist_shared_isString(target[0]);}function vue_i18n_renderFormatter(props,context,slotKeys,partFormatter){var slots=context.slots,attrs=context.attrs;return function(){var options={part:true};var overrides=shared_create();if(props.locale){options.locale=props.locale;}if(dist_shared_isString(props.format)){options.key=props.format;}else if(dist_shared_isObject(props.format)){// eslint-disable-next-line @typescript-eslint/no-explicit-any
if(dist_shared_isString(props.format.key)){// eslint-disable-next-line @typescript-eslint/no-explicit-any
options.key=props.format.key;}// Filter out number format options only
overrides=Object.keys(props.format).reduce(function(options,prop){return slotKeys.includes(prop)?dist_shared_assign(shared_create(),options,_defineProperty2({},prop,props.format[prop]))// eslint-disable-line @typescript-eslint/no-explicit-any
:options;},shared_create());}var parts=partFormatter.apply(void 0,[props.value,options,overrides]);var children=[options.key];if(dist_shared_isArray(parts)){children=parts.map(function(part,index){var slot=slots[part.type];var node=slot?slot(_defineProperty2(_defineProperty2(_defineProperty2({},part.type,part.value),"index",index),"parts",parts)):[part.value];if(vue_i18n_isVNode(node)){node[0].key="".concat(part.type,"-").concat(index);}return node;});}else if(dist_shared_isString(parts)){children=[parts];}var assignedAttrs=dist_shared_assign(shared_create(),attrs);var tag=dist_shared_isString(props.tag)||dist_shared_isObject(props.tag)?props.tag:vue_i18n_getFragmentableTag();return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.h)(tag,assignedAttrs,children);};}var vue_i18n_NumberFormatImpl=/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({/* eslint-disable */name:'i18n-n',props:dist_shared_assign({value:{type:Number,required:true},format:{type:[String,Object]}},vue_i18n_baseFormatProps),/* eslint-enable */// eslint-disable-next-line @typescript-eslint/no-explicit-any
setup:function setup(props,context){var i18n=props.i18n||vue_i18n_useI18n({useScope:props.scope,__useComponent:true});return vue_i18n_renderFormatter(props,context,core_base_NUMBER_FORMAT_OPTIONS_KEYS,function(){return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
i18n[vue_i18n_NumberPartsSymbol].apply(i18n,arguments));});}});/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 *//**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */var vue_i18n_NumberFormat=vue_i18n_NumberFormatImpl;var vue_i18n_I18nN=/* unused pure expression or super */null&&0;var vue_i18n_DatetimeFormatImpl=/* #__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({/* eslint-disable */name:'i18n-d',props:dist_shared_assign({value:{type:[Number,Date],required:true},format:{type:[String,Object]}},vue_i18n_baseFormatProps),/* eslint-enable */// eslint-disable-next-line @typescript-eslint/no-explicit-any
setup:function setup(props,context){var i18n=props.i18n||vue_i18n_useI18n({useScope:props.scope,__useComponent:true});return vue_i18n_renderFormatter(props,context,core_base_DATETIME_FORMAT_OPTIONS_KEYS,function(){return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
i18n[vue_i18n_DatetimePartsSymbol].apply(i18n,arguments));});}});/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */var vue_i18n_DatetimeFormat=vue_i18n_DatetimeFormatImpl;var vue_i18n_I18nD=/* unused pure expression or super */null&&0;function vue_i18n_getComposer$1(i18n,instance){var i18nInternal=i18n;if(i18n.mode==='composition'){return i18nInternal.__getInstance(instance)||i18n.global;}else{var vueI18n=i18nInternal.__getInstance(instance);return vueI18n!=null?vueI18n.__composer:i18n.global.__composer;}}function vue_i18n_vTDirective(i18n){var _process=function _process(binding){var instance=binding.instance,value=binding.value;/* istanbul ignore if */if(!instance||!instance.$){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.UNEXPECTED_ERROR);}var composer=vue_i18n_getComposer$1(i18n,instance.$);var parsedValue=vue_i18n_parseValue(value);return[Reflect.apply(composer.t,composer,_toConsumableArray(vue_i18n_makeParams(parsedValue))),composer];};var register=function register(el,binding){var _process6=_process(binding),_process7=_slicedToArray(_process6,2),textContent=_process7[0],composer=_process7[1];if(dist_shared_inBrowser&&i18n.global===composer){// global scope only
el.__i18nWatcher=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.watch)(composer.locale,function(){binding.instance&&binding.instance.$forceUpdate();});}el.__composer=composer;el.textContent=textContent;};var unregister=function unregister(el){if(dist_shared_inBrowser&&el.__i18nWatcher){el.__i18nWatcher();el.__i18nWatcher=undefined;delete el.__i18nWatcher;}if(el.__composer){el.__composer=undefined;delete el.__composer;}};var update=function update(el,_ref23){var value=_ref23.value;if(el.__composer){var composer=el.__composer;var parsedValue=vue_i18n_parseValue(value);el.textContent=Reflect.apply(composer.t,composer,_toConsumableArray(vue_i18n_makeParams(parsedValue)));}};var getSSRProps=function getSSRProps(binding){var _process8=_process(binding),_process9=_slicedToArray(_process8,1),textContent=_process9[0];return{textContent:textContent};};return{created:register,unmounted:unregister,beforeUpdate:update,getSSRProps:getSSRProps};}function vue_i18n_parseValue(value){if(dist_shared_isString(value)){return{path:value};}else if(dist_shared_isPlainObject(value)){if(!('path'in value)){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.REQUIRED_VALUE,'path');}return value;}else{throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.INVALID_VALUE);}}function vue_i18n_makeParams(value){var path=value.path,locale=value.locale,args=value.args,choice=value.choice,plural=value.plural;var options={};var named=args||{};if(dist_shared_isString(locale)){options.locale=locale;}if(dist_shared_isNumber(choice)){options.plural=choice;}if(dist_shared_isNumber(plural)){options.plural=plural;}return[path,named,options];}function vue_i18n_apply(app,i18n){var pluginOptions=dist_shared_isPlainObject(arguments.length<=2?undefined:arguments[2])?arguments.length<=2?undefined:arguments[2]:{};var globalInstall=dist_shared_isBoolean(pluginOptions.globalInstall)?pluginOptions.globalInstall:true;if(globalInstall){[vue_i18n_Translation.name,'I18nT'].forEach(function(name){return app.component(name,vue_i18n_Translation);});[vue_i18n_NumberFormat.name,'I18nN'].forEach(function(name){return app.component(name,vue_i18n_NumberFormat);});[vue_i18n_DatetimeFormat.name,'I18nD'].forEach(function(name){return app.component(name,vue_i18n_DatetimeFormat);});}// install directive
{app.directive('t',vue_i18n_vTDirective(i18n));}}/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */var vue_i18n_I18nInjectionKey=/* #__PURE__*/dist_shared_makeSymbol('global-vue-i18n');// eslint-disable-next-line @typescript-eslint/no-explicit-any
function vue_i18n_createI18n(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var VueI18nLegacy=arguments.length>1?arguments[1]:undefined;// prettier-ignore
var __legacyMode=__VUE_I18N_LEGACY_API__&&dist_shared_isBoolean(options.legacy)?options.legacy:__VUE_I18N_LEGACY_API__;// prettier-ignore
var __globalInjection=dist_shared_isBoolean(options.globalInjection)?options.globalInjection:true;var __instances=new Map();var _vue_i18n_createGloba=vue_i18n_createGlobal(options,__legacyMode),_vue_i18n_createGloba2=_slicedToArray(_vue_i18n_createGloba,2),globalScope=_vue_i18n_createGloba2[0],__global=_vue_i18n_createGloba2[1];var symbol=/* #__PURE__*/dist_shared_makeSymbol( false?0:'');function __getInstance(component){return __instances.get(component)||null;}function __setInstance(component,instance){__instances.set(component,instance);}function __deleteInstance(component){__instances.delete(component);}var i18n={// mode
get mode(){return __VUE_I18N_LEGACY_API__&&__legacyMode?'legacy':'composition';},// install plugin
install:function install(app){var _arguments2=arguments;return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(){var _len57,options,_key57,opts,globalReleaseHandler,unmountApp;return _regeneratorRuntime().wrap(function _callee2$(_context3){while(1)switch(_context3.prev=_context3.next){case 0:if(false){}// setup global provider
app.__VUE_I18N_SYMBOL__=symbol;app.provide(app.__VUE_I18N_SYMBOL__,i18n);// set composer & vuei18n extend hook options from plugin options
for(_len57=_arguments2.length,options=new Array(_len57>1?_len57-1:0),_key57=1;_key57<_len57;_key57++){options[_key57-1]=_arguments2[_key57];}if(dist_shared_isPlainObject(options[0])){opts=options[0];i18n.__composerExtend=opts.__composerExtend;i18n.__vueI18nExtend=opts.__vueI18nExtend;}// global method and properties injection for Composition API
globalReleaseHandler=null;if(!__legacyMode&&__globalInjection){globalReleaseHandler=vue_i18n_injectGlobalFields(app,i18n.global);}// install built-in components and directive
if(__VUE_I18N_FULL_INSTALL__){vue_i18n_apply.apply(void 0,[app,i18n].concat(options));}// setup mixin for Legacy API
if(__VUE_I18N_LEGACY_API__&&__legacyMode){app.mixin(vue_i18n_defineMixin(__global,__global.__composer,i18n));}// release global scope
unmountApp=app.unmount;app.unmount=function(){globalReleaseHandler&&globalReleaseHandler();i18n.dispose();unmountApp();};// setup vue-devtools plugin
if(false){}case 12:case"end":return _context3.stop();}},_callee2);}))();},// global accessor
get global(){return __global;},dispose:function dispose(){globalScope.stop();},// @internal
__instances:__instances,// @internal
__getInstance:__getInstance,// @internal
__setInstance:__setInstance,// @internal
__deleteInstance:__deleteInstance};return i18n;}function vue_i18n_useI18n(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var instance=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.getCurrentInstance)();if(instance==null){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);}if(!instance.isCE&&instance.appContext.app!=null&&!instance.appContext.app.__VUE_I18N_SYMBOL__){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.NOT_INSTALLED);}var i18n=vue_i18n_getI18nInstance(instance);var gl=vue_i18n_getGlobalComposer(i18n);var componentOptions=vue_i18n_getComponentOptions(instance);var scope=vue_i18n_getScope(options,componentOptions);if(scope==='global'){vue_i18n_adjustI18nResources(gl,options,componentOptions);return gl;}if(scope==='parent'){// eslint-disable-next-line @typescript-eslint/no-explicit-any
var _composer5=vue_i18n_getComposer(i18n,instance,options.__useComponent);if(_composer5==null){if(false){}_composer5=gl;}return _composer5;}var i18nInternal=i18n;var composer=i18nInternal.__getInstance(instance);if(composer==null){var composerOptions=dist_shared_assign({},options);if('__i18n'in componentOptions){composerOptions.__i18n=componentOptions.__i18n;}if(gl){composerOptions.__root=gl;}composer=vue_i18n_createComposer(composerOptions);if(i18nInternal.__composerExtend){composer[vue_i18n_DisposeSymbol]=i18nInternal.__composerExtend(composer);}vue_i18n_setupLifeCycle(i18nInternal,instance,composer);i18nInternal.__setInstance(instance,composer);}return composer;}function vue_i18n_createGlobal(options,legacyMode,VueI18nLegacy// eslint-disable-line @typescript-eslint/no-explicit-any
){var scope=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.effectScope)();var obj=__VUE_I18N_LEGACY_API__&&legacyMode?scope.run(function(){return vue_i18n_createVueI18n(options);}):scope.run(function(){return vue_i18n_createComposer(options);});if(obj==null){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.UNEXPECTED_ERROR);}return[scope,obj];}function vue_i18n_getI18nInstance(instance){var i18n=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.inject)(!instance.isCE?instance.appContext.app.__VUE_I18N_SYMBOL__:vue_i18n_I18nInjectionKey);/* istanbul ignore if */if(!i18n){throw vue_i18n_createI18nError(!instance.isCE?vue_i18n_I18nErrorCodes.UNEXPECTED_ERROR:vue_i18n_I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);}return i18n;}// eslint-disable-next-line @typescript-eslint/no-explicit-any
function vue_i18n_getScope(options,componentOptions){// prettier-ignore
return shared_isEmptyObject(options)?'__i18n'in componentOptions?'local':'global':!options.useScope?'local':options.useScope;}function vue_i18n_getGlobalComposer(i18n){// prettier-ignore
return i18n.mode==='composition'?i18n.global:i18n.global.__composer;}function vue_i18n_getComposer(i18n,target){var useComponent=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var composer=null;var root=target.root;var current=vue_i18n_getParentComponentInstance(target,useComponent);while(current!=null){var i18nInternal=i18n;if(i18n.mode==='composition'){composer=i18nInternal.__getInstance(current);}else{if(__VUE_I18N_LEGACY_API__){var vueI18n=i18nInternal.__getInstance(current);if(vueI18n!=null){composer=vueI18n.__composer;if(useComponent&&composer&&!composer[vue_i18n_InejctWithOptionSymbol]// eslint-disable-line @typescript-eslint/no-explicit-any
){composer=null;}}}}if(composer!=null){break;}if(root===current){break;}current=current.parent;}return composer;}function vue_i18n_getParentComponentInstance(target){var useComponent=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(target==null){return null;}// if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
return!useComponent?target.parent:target.vnode.ctx||target.parent;// eslint-disable-line @typescript-eslint/no-explicit-any
}function vue_i18n_setupLifeCycle(i18n,target,composer){var emitter=null;(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.onMounted)(function(){// inject composer instance to DOM for intlify-devtools
if(false){}},target);(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.onUnmounted)(function(){// eslint-disable-next-line @typescript-eslint/no-explicit-any
var _composer=composer;// remove composer instance from DOM for intlify-devtools
if(false){}i18n.__deleteInstance(target);// dispose extended resources
var dispose=_composer[vue_i18n_DisposeSymbol];if(dispose){dispose();delete _composer[vue_i18n_DisposeSymbol];}},target);}var vue_i18n_globalExportProps=['locale','fallbackLocale','availableLocales'];var vue_i18n_globalExportMethods=['t','rt','d','n','tm','te'];function vue_i18n_injectGlobalFields(app,composer){var i18n=Object.create(null);vue_i18n_globalExportProps.forEach(function(prop){var desc=Object.getOwnPropertyDescriptor(composer,prop);if(!desc){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.UNEXPECTED_ERROR);}var wrap=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.isRef)(desc.value)// check computed props
?{get:function get(){return desc.value.value;},// eslint-disable-next-line @typescript-eslint/no-explicit-any
set:function set(val){desc.value.value=val;}}:{get:function get(){return desc.get&&desc.get();}};Object.defineProperty(i18n,prop,wrap);});app.config.globalProperties.$i18n=i18n;vue_i18n_globalExportMethods.forEach(function(method){var desc=Object.getOwnPropertyDescriptor(composer,method);if(!desc||!desc.value){throw vue_i18n_createI18nError(vue_i18n_I18nErrorCodes.UNEXPECTED_ERROR);}Object.defineProperty(app.config.globalProperties,"$".concat(method),desc);});var dispose=function dispose(){// eslint-disable-next-line @typescript-eslint/no-explicit-any
delete app.config.globalProperties.$i18n;vue_i18n_globalExportMethods.forEach(function(method){// eslint-disable-next-line @typescript-eslint/no-explicit-any
delete app.config.globalProperties["$".concat(method)];});};return dispose;}{dist_vue_i18n_initFeatureFlags();}// register message compiler at vue-i18n
core_base_registerMessageCompiler(core_base_compile);// register message resolver at vue-i18n
core_base_registerMessageResolver(core_base_resolveValue);// register fallback locale at vue-i18n
core_base_registerLocaleFallbacker(core_base_fallbackWithLocaleChain);// NOTE: experimental !!
if( false||__INTLIFY_PROD_DEVTOOLS__){var _target2=shared_getGlobalThis();_target2.__INTLIFY__=true;core_base_setDevToolsHook(_target2.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);}if(false){}// EXTERNAL MODULE: ../../node_modules/deepmerge/dist/cjs.js
var cjs=__nested_webpack_require_186475__(2743);var cjs_default=/*#__PURE__*/__nested_webpack_require_186475__.n(cjs);;// ../../libs/i18n/dist/DateFormat.js
/**
 * If you need more, please feel free to add them!
 * But keep in mind they should "globaly" make sense.
 * Don't add any custom formats. For custom formatting
 * we need to find a different solution.
 */var DateFormat;(function(DateFormat){DateFormat["MMHHDDMMYYY"]="MMHHDDMMYYY";DateFormat["DDMMYYY"]="DDMMYYY";DateFormat["MMHH"]="MMHH";})(DateFormat||(DateFormat={}));;// ../../libs/i18n/dist/index.js
// import i18n from './locales/i18n.json'
/**
 * maps viewLang and viewCountry to $i18n.locale
 *
 */var mapLang={"en-US":"en","en-GB":"en-GB","nl-NL":"nl","sv-SE":"sv","da-DK":"da","de-DE":"de","de-AT":"de","es-ES":"es","es-US":"es","fr-FR":"fr"};// such in case the country is not available we choose them from the countryMap
var countryMap={en:"US","en-GB":"GB",nl:"NL",sv:"SE",da:"DK",de:"DE",// fallback won't work anymore with es-US and en-US
es:"ES",fr:"FR"};var init=false;var storage=new LocalStore({});function loadLocaleMessages(){// not nice but webpack requires to pass the folder as string literal - variables are not allowed
// the alternative to this is to move out the required.context call to the parent component and pass
// the locales as parameter.
// path out: ./node_modules/@gd/i18n/dist/
// path in: ./src/locales/
// TODO might be a fix for vite (rollup) https://www.npmjs.com/package/rollup-plugin-require-context
var locales=__nested_webpack_require_186475__(5679);var messages={};locales.keys().forEach(function(key){var matched=key.match(/([A-Za-z0-9-_]+)\./i);if(matched&&matched.length>1){var locale=matched[1].split("_")[1];if(locale){// TODO - find out when it's default and when it's not
messages[locale]=locales(key).default||locales(key);if(locale==="de"){messages["de-AT"]=locales(key);}}}});var i18n=locales("./i18n.json");if(i18n){;messages["none"]=i18n.default;}return messages;}/**
 * use this method to setup i18n in components - it expects the locale files be loaded from ./src/locales.
 *
 * @param setupI18n
 * @returns useI18n(...)
 */function setupComponentI18n(setupI18n){if(init===true&&(setupI18n===null||setupI18n===void 0?void 0:setupI18n.useScope)!=="local"){return vue_i18n_useI18n({useScope:(setupI18n===null||setupI18n===void 0?void 0:setupI18n.useScope)||"global"});}init=true;// we can limit the scope to not overwrite keys in other components with: {useScope: 'local'}
// the huge disadvantage here is that the scope of "local" is only available in "this" component (no parent, no children).
// This can be very unpracticable because no other component has access to this keys.
// If you can't use "local" (either parent (use scope of parent component) or global) then your messageKey must
// be kind of unique to not overwrite other component keys
var i18n=vue_i18n_useI18n({useScope:(setupI18n===null||setupI18n===void 0?void 0:setupI18n.useScope)||"global"});var componentMessages=loadLocaleMessages();Object.keys(componentMessages).forEach(function(lang){if(!componentMessages[lang]){}var obj=cjs_default()(i18n.messages.value[lang]||{},componentMessages[lang]||{});i18n.setLocaleMessage(lang,obj);});return i18n;}/**
 * web export for createApp(...).use(i18n)
 *//* harmony default export */var i18n_dist=vue_i18n_createI18n({locale:mapLang[storage.gd.viewLang&&storage.gd.viewLang+"-"+(// fallback won't work anymore with es-US and en-US
storage.gd.viewCountry||countryMap[storage.gd.viewLang])||"en-US"// fallback to viewLang. Should work for most of the "corner case"-countries such as:
// de-CH, es-AR, es-BR, es-CL, es-MX, es-UY, es-VE
]||storage.gd.viewLang,legacy:false,fallbackLocale:"en-US",messages:loadLocaleMessages(),datetimeFormats:{// For endless possibilities to format,
// see http://www.ecma-international.org/ecma-402/2.0/#sec-intl-datetimeformat-constructor
de:_defineProperty(_defineProperty(_defineProperty({},DateFormat.MMHHDDMMYYY,{year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit"}),DateFormat.DDMMYYY,{year:"numeric",month:"2-digit",day:"2-digit"}),DateFormat.MMHH,{hour:"2-digit",minute:"2-digit"}),en:_defineProperty(_defineProperty(_defineProperty({},DateFormat.MMHHDDMMYYY,{year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit"}),DateFormat.DDMMYYY,{year:"numeric",month:"2-digit",day:"2-digit"}),DateFormat.MMHH,{hour:"2-digit",minute:"2-digit"})},silentTranslationWarn:"production"==="development"// YES, you may want to take this out again
});;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/AccountBox.vue?vue&type=script&setup=true&lang=ts
var AccountBoxvue_type_script_setup_true_lang_ts_hoisted_1={class:"avatarCont"};var AccountBoxvue_type_script_setup_true_lang_ts_hoisted_2=["title"];var AccountBoxvue_type_script_setup_true_lang_ts_hoisted_3={class:"detailsCont"};var AccountBoxvue_type_script_setup_true_lang_ts_hoisted_4=["title"];var AccountBoxvue_type_script_setup_true_lang_ts_hoisted_5={class:"statusIcons"};var _hoisted_6=["title"];var _hoisted_7={key:0};var _hoisted_8={key:1};var _hoisted_9=["title"];var _hoisted_10={key:0,class:"statusNumber newMessages"};var _hoisted_11=["title"];var _hoisted_12={key:0,class:"statusNumber challengeCounter"};var _hoisted_13=["name"];var _hoisted_14={key:0,class:"icf-alert"};var _hoisted_15={"data-qe-id":"accountbox-balance",class:"userBalance asterisk"};var _hoisted_16={key:2,"data-qe-id":"accountbox-balance",class:"userBalance"};var _hoisted_17={key:1,class:"banderole"};/**
 * Can be triggered from outside to trigger a accountbox refresh
 *
 *//* harmony default export */var AccountBoxvue_type_script_setup_true_lang_ts=/*@__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.defineComponent)({__name:'AccountBox',props:{forceLoadData:{type:Boolean,default:true}},emits:['onShowProfile','onShowFriends','onShowMessages','onShowChallanges','onPayment','onLoyality'],setup:function setup(__props,_ref){var __emit=_ref.emit;var props=__props;var emit=__emit;var _setupComponentI18n=setupComponentI18n({}),t=_setupComponentI18n.t;var balanceBounce=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(false);var storage=new dist_Storage();var storageAccountbox=new dist_Storage().read(STORE_NAME.ACCOUNTBOX);var avatarUrl=storage.read(STORE_NAME.USER).avatarUrl;/**
     * Holds user relevant userData data either from  storage.user
     * or /gd/rest/me/userData rest call
     */var user=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)({id:'',currency:'EUR',name:'',actorType:'',locale:'',loyalty:'WOOD',bonusVisualization:false,payout:true,forcePayout:false,boku:false,avatarUrl:''});/**
     * Holds user relevant accountbox data either from  storage "accountbox"
     * or /gd/rest/me/accountbox rest call
     */var accountbox=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)({balance:'',bonus:'',challengesCount:0,friendRequestsCount:0,friendsOnlineCount:0,gdCurrency:'EUR',messagesCount:0,withdrawable:''});// be on the safe side
var bonusVisualization=false;var gd=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(storage.read(STORE_NAME.GD));var balance=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return isNaN(parseFloat(accountbox.value.balance))?'-':convert(accountbox.value.balance,{gdc:accountbox.value.gdCurrency,locale:user.value.locale});});var lockedAmount=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return isNaN(parseFloat(accountbox.value.bonus))?'-':convert(accountbox.value.bonus,{gdc:accountbox.value.gdCurrency,locale:user.value.locale});});var withdrawAbleAmount=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return isNaN(parseFloat(accountbox.value.withdrawable))?'-':convert(accountbox.value.withdrawable,{gdc:accountbox.value.gdCurrency,locale:user.value.locale});});var isBalanceIsToLow=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(function(){return parseFloat(accountbox.value.balance)<1;});function loadUserData(){return fetch('/gd/rest/me/userData',{credentials:'same-origin'}).then(function(res){return res.json();}).then(function(data){user.value.id=data.userId;user.value.currency=data.gdCurrency;user.value.name=data.userName;user.value.actorType=data.actorType;// this.user.locale = data.
user.value.loyalty=data.loyalty==='loyalty SILVER'?'SILVER':data.loyalty==='loyalty GOLD'?'GOLD':data.loyalty;storage.write(STORE_NAME.USER,user.value);});}function loadAccountbox(){return fetch('/gd/rest/me/accountbox',{credentials:'same-origin'}).then(function(res){return res.json();}).then(function(data){accountbox.value=data;storage.write(STORE_NAME.ACCOUNTBOX,data);});}// action methods:
function onShowProfileName(event,button){event===null||event===void 0?void 0:event.stopPropagation();emit('onShowProfile',{type:'name',url:"/gd/playerProfile/showProfile.xhtml?cn=".concat(user.value.name),button:button});}function onShowProfileAvatar(event,button){event===null||event===void 0?void 0:event.stopPropagation();emit('onShowProfile',{type:'avatar',url:"/gd/playerProfile/showProfile.xhtml?cn=".concat(user.value.name),button:button});}function onShowFriend(event,button){event===null||event===void 0?void 0:event.stopPropagation();emit('onShowFriends',{type:'friends',url:'/gd/friends/friendlist.xhtml',button:button});}function onShowMessages(event,button){event===null||event===void 0?void 0:event.stopPropagation();emit('onShowMessages',{type:'inbox',url:'/gd/messages/inbox.xhtml',button:button});}function onShowChallanges(event,button){event===null||event===void 0?void 0:event.stopPropagation();emit('onShowChallanges',{type:'challenge',url:user.value.actorType==='g'?'/gd/challenges/challengeOverview.xhtml':'/web/shop-web/index.html#/benefits?src=challenges',button:button});}function onPayment(event,button){event===null||event===void 0?void 0:event.stopPropagation();emit('onPayment',{type:'deposit',button:button});}function onLoyality(event,button){event===null||event===void 0?void 0:event.stopPropagation();// WOOD: /gd/loyalty/loyaltyProgress.xhtml
emit('onLoyality',{type:'loyality',url:'/gd/loyalty/loyalty.xhtml',button:button});}// created:
// check custom storage for data
if(storageAccountbox){accountbox.value=storageAccountbox;}// check user storage for data
user.value=storage.read(STORE_NAME.USER);// disable withdrawl tooltip
if(user.value.bonusVisualization){bonusVisualization=true;}if(props.forceLoadData||!user.value.name||!user.value.loyalty||!user.value.currency||!user.value.actorType){loadUserData().catch(function(err){});loadAccountbox().catch(function(err){});}// trigger load of accountbox data if we can't make sure that data in storage are up2date
// register update-balance listener - this will force the accountbox to udpate the accountbox data
// See rest: "/gd/rest/me/accountbox"
event_bus_dist.$on('update-balance',function(){var oldBlance=accountbox.value.balance;loadAccountbox().then(function(){if(oldBlance!==accountbox.value.balance){balanceBounce.value=true;}setTimeout(function(){balanceBounce.value=false;},1000);});});return function(_ctx,_cache){return(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div",{id:"accountbox",class:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)([(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(user).loyalty,"accountbox"])},[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div",AccountBoxvue_type_script_setup_true_lang_ts_hoisted_1,[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",{tabindex:"0",class:"accountbox-link avatarImage",onClick:_cache[0]||(_cache[0]=function(event){return onShowProfileAvatar(event,0);}),onMouseup:_cache[1]||(_cache[1]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withModifiers)(function(event){return onShowProfileAvatar(event,1);},["middle"])),onKeyup:_cache[2]||(_cache[2]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withKeys)(function($event){return onShowProfileAvatar(undefined,0);},["enter"])),title:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(t)('accountbox.main.myProfile'),"data-qe-id":"accountbox-avatar"},[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createVNode)(AvatarImage,{"avatar-url":(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(avatarUrl)},null,8,["avatar-url"])],40,AccountBoxvue_type_script_setup_true_lang_ts_hoisted_2)]),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div",AccountBoxvue_type_script_setup_true_lang_ts_hoisted_3,[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",{tabindex:"0",class:"accountbox-link playerName",onClick:_cache[3]||(_cache[3]=function(event){return onShowProfileName(event,0);}),onMouseup:_cache[4]||(_cache[4]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withModifiers)(function(event){return onShowProfileName(event,1);},["middle"])),onKeyup:_cache[5]||(_cache[5]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withKeys)(function($event){return onShowProfileName(undefined,1);},["enter"])),title:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(t)('accountbox.main.myProfile'),"data-qe-id":"accountbox-profile"},[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",null,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(user).name),1)],40,AccountBoxvue_type_script_setup_true_lang_ts_hoisted_4),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div",AccountBoxvue_type_script_setup_true_lang_ts_hoisted_5,[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",{tabindex:"0",onClick:_cache[6]||(_cache[6]=function(event){return onShowFriend(event,0);}),onMouseup:_cache[7]||(_cache[7]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withModifiers)(function(event){return onShowFriend(event,1);},["middle"])),onKeyup:_cache[8]||(_cache[8]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withKeys)(function($event){return onShowFriend(undefined,0);},["enter"])),class:"accountbox-link statusIcon icf-community hasNumber",title:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(t)('accountbox.main.myFriends'),"data-qe-id":"friendlistLink"},[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).friendRequestsCount>0||(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).friendsOnlineCount!==undefined?((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span",{key:0,class:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)([(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).friendRequestsCount>0?'newFriendRequests':(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).friendsOnlineCount>0?'onlineFriends':'noFriends',"statusNumber"])},[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).friendRequestsCount>0?((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span",_hoisted_7,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).friendRequestsCount),1)):(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("",true),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).friendRequestsCount<=0?((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span",_hoisted_8,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).friendsOnlineCount),1)):(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("",true)],2)):(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("",true)],40,_hoisted_6),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",{tabindex:"0",id:"accountboxUnreadCount",onClick:_cache[9]||(_cache[9]=function(event){return onShowMessages(event,0);}),onMouseup:_cache[10]||(_cache[10]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withModifiers)(function(event){return onShowMessages(event,1);},["middle"])),onKeyup:_cache[11]||(_cache[11]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withKeys)(function($event){return onShowMessages(undefined,0);},["enter"])),class:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["accountbox-link statusIcon icf-message",(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).messagesCount>0?'hasNumber':'']),title:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(t)('accountbox.main.inbox'),"data-qe-id":"accountbox-inbox"},[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).messagesCount>0?((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span",_hoisted_10,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).messagesCount),1)):(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("",true)],42,_hoisted_9),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",{tabindex:"0",id:"challengeCounter",onClick:_cache[12]||(_cache[12]=function(event){return onShowChallanges(event,0);}),onMouseup:_cache[13]||(_cache[13]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withModifiers)(function(event){return onShowChallanges(event,1);},["middle"])),onKeyup:_cache[14]||(_cache[14]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withKeys)(function($event){return onShowChallanges(undefined,0);},["enter"])),title:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(t)('accountbox.main.myChallenges'),class:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)([(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).challengesCount>0?'hasNumber':'',"accountbox-link statusIcon icf-challenge"]),"data-qe-id":"accountbox-challenges"},[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).challengesCount>0?((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span",_hoisted_12,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(accountbox).challengesCount),1)):(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("",true)],42,_hoisted_11),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("a",{href:"/gd/logout.html",id:"logoutLink","data-qe-id":"accountbox-log-out",class:"logOut",name:gd.value.viewLang+'.clickonlogout'},(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(t)('accountbox.main.logout')),9,_hoisted_13)]),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",{tabindex:"0",onClick:_cache[15]||(_cache[15]=function(event){return onPayment(event,0);}),onKeyup:_cache[16]||(_cache[16]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withKeys)(function($event){return onPayment(undefined,0);},["enter"])),id:"chargeAccountLink","data-qe-id":"chargeAccountLink",trackingParam:"accountboxLink",class:"accountbox-link amountInfo"},[isBalanceIsToLow.value?((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span",_hoisted_14)):(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("",true),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(bonusVisualization)?((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createBlock)(AccountboxTooltip,{key:1,class:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(balanceBounce)?'bounce-animation':''),withdrawAbleAmount:withdrawAbleAmount.value,lockedAmount:lockedAmount.value},{default:(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withCtx)(function(){return[(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",_hoisted_15,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)(balance.value),1)];}),_:1},8,["class","withdrawAbleAmount","lockedAmount"])):((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span",_hoisted_16,(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)(balance.value),1)),_cache[20]||(_cache[20]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span",{"data-qe-id":"accountbox-addMoney",class:"addMoney"},null,-1))],32)]),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(user).loyalty==='GOLD'||(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.unref)(user).loyalty==='SILVER'?((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span",{key:0,"data-qe-id":"loyaltyLink",onClick:_cache[17]||(_cache[17]=function(event){return onLoyality(event,0);}),onMouseup:_cache[18]||(_cache[18]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withModifiers)(function(event){return onLoyality(event,1);},["middle"])),onKeyup:_cache[19]||(_cache[19]=(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withKeys)(function($event){return onLoyality(undefined,0);},["enter"])),class:"accountbox-link banderole"},null,32)):((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(),(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div",_hoisted_17))],2);};}});;// ./src/components/AccountBox.vue?vue&type=script&setup=true&lang=ts
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/AccountBox.vue?vue&type=style&index=0&id=bfe5e4f2&lang=less
// extracted by mini-css-extract-plugin
;// ./src/components/AccountBox.vue?vue&type=style&index=0&id=bfe5e4f2&lang=less
;// ./src/components/AccountBox.vue
;var AccountBox_exports_=AccountBoxvue_type_script_setup_true_lang_ts;/* harmony default export */var AccountBox=AccountBox_exports_;;// ./src/main.ts
/* harmony default export */var main=AccountBox;;// ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
/* harmony default export */var entry_lib=main;}();module.exports=__nested_webpack_exports__;/******/})();

/***/ }),

/***/ 7433:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.A = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 4100:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 4977:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4188);
var tryToString = __webpack_require__(3174);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 1361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__(866);
var tryToString = __webpack_require__(3174);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 4121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPossiblePrototype = __webpack_require__(6712);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 2937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var has = (__webpack_require__(3243).has);

// Perform ? RequireInternalSlot(M, [[SetData]])
module.exports = function (it) {
  has(it);
  return it;
};


/***/ }),

/***/ 5458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(4282);
var create = __webpack_require__(7065);
var defineProperty = (__webpack_require__(4466).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 154:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(4212).charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 286:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__(4578);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 3770:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(831);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 5469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__(5234);

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ 7500:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = (__webpack_require__(4104).forEach);
var arrayMethodIsStrict = __webpack_require__(5397);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 6859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(5821);
var call = __webpack_require__(9944);
var toObject = __webpack_require__(3628);
var callWithSafeIterationClosing = __webpack_require__(4412);
var isArrayIteratorMethod = __webpack_require__(8146);
var isConstructor = __webpack_require__(866);
var lengthOfArrayLike = __webpack_require__(9389);
var createProperty = __webpack_require__(4417);
var getIterator = __webpack_require__(2350);
var getIteratorMethod = __webpack_require__(9874);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    result = IS_CONSTRUCTOR ? new this() : [];
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 1458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(380);
var toAbsoluteIndex = __webpack_require__(675);
var lengthOfArrayLike = __webpack_require__(9389);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 4104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(5821);
var uncurryThis = __webpack_require__(6881);
var IndexedObject = __webpack_require__(7568);
var toObject = __webpack_require__(3628);
var lengthOfArrayLike = __webpack_require__(9389);
var arraySpeciesCreate = __webpack_require__(5022);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(self);
    var boundFunction = bind(callbackfn, that);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);
var wellKnownSymbol = __webpack_require__(4282);
var V8_VERSION = __webpack_require__(3008);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 5397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 4224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var isArray = __webpack_require__(6719);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 7825:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 9295:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySlice = __webpack_require__(7825);

var floor = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor(length / 2);
    var left = sort(arraySlice(array, 0, middle), comparefn);
    var right = sort(arraySlice(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

module.exports = sort;


/***/ }),

/***/ 9980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(6719);
var isConstructor = __webpack_require__(866);
var isObject = __webpack_require__(831);
var wellKnownSymbol = __webpack_require__(4282);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 5022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__(9980);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 4412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(3770);
var iteratorClose = __webpack_require__(8500);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 7283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(4282);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 8689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 5438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(9345);
var isCallable = __webpack_require__(4188);
var classofRaw = __webpack_require__(8689);
var wellKnownSymbol = __webpack_require__(4282);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 3231:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(7065);
var defineBuiltInAccessor = __webpack_require__(997);
var defineBuiltIns = __webpack_require__(4320);
var bind = __webpack_require__(5821);
var anInstance = __webpack_require__(286);
var isNullOrUndefined = __webpack_require__(4318);
var iterate = __webpack_require__(8873);
var defineIterator = __webpack_require__(3217);
var createIterResultObject = __webpack_require__(6224);
var setSpecies = __webpack_require__(3900);
var DESCRIPTORS = __webpack_require__(6893);
var fastKey = (__webpack_require__(8118).fastKey);
var InternalStateModule = __webpack_require__(3086);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: null,
        last: null,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: null,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key === key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = null;
          entry = entry.next;
        }
        state.first = state.last = null;
        state.index = create(null);
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first === entry) state.first = next;
          if (state.last === entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: null
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = null;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind === 'keys') return createIterResultObject(entry.key, false);
      if (kind === 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ 6351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var globalThis = __webpack_require__(9117);
var uncurryThis = __webpack_require__(6881);
var isForced = __webpack_require__(8489);
var defineBuiltIn = __webpack_require__(7509);
var InternalMetadataModule = __webpack_require__(8118);
var iterate = __webpack_require__(8873);
var anInstance = __webpack_require__(286);
var isCallable = __webpack_require__(4188);
var isNullOrUndefined = __webpack_require__(4318);
var isObject = __webpack_require__(831);
var fails = __webpack_require__(5234);
var checkCorrectnessOfIteration = __webpack_require__(7283);
var setToStringTag = __webpack_require__(3754);
var inheritIfRequired = __webpack_require__(4166);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = globalThis[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY === 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY === 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ 8657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(4418);
var ownKeys = __webpack_require__(3168);
var getOwnPropertyDescriptorModule = __webpack_require__(9304);
var definePropertyModule = __webpack_require__(4466);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 6425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(4282);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 6224:
/***/ (function(module) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 8088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var definePropertyModule = __webpack_require__(4466);
var createPropertyDescriptor = __webpack_require__(9123);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9123:
/***/ (function(module) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 4417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var definePropertyModule = __webpack_require__(4466);
var createPropertyDescriptor = __webpack_require__(9123);

module.exports = function (object, key, value) {
  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};


/***/ }),

/***/ 8089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(3770);
var ordinaryToPrimitive = __webpack_require__(2287);

var $TypeError = TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw new $TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),

/***/ 997:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(4530);
var defineProperty = __webpack_require__(4466);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 7509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4188);
var definePropertyModule = __webpack_require__(4466);
var makeBuiltIn = __webpack_require__(4530);
var defineGlobalProperty = __webpack_require__(4798);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 4320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(7509);

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 4798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis[key] = value;
  } return value;
};


/***/ }),

/***/ 1305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(3174);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ 6893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 5926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var isObject = __webpack_require__(831);

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 2197:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 9429:
/***/ (function(module) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 7463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(5926);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 1274:
/***/ (function(module) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 2222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8060);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 4598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var UA = __webpack_require__(8060);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 6168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8060);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ 6347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8060);

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 3940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ENVIRONMENT = __webpack_require__(1078);

module.exports = ENVIRONMENT === 'NODE';


/***/ }),

/***/ 1129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8060);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 8060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';


/***/ }),

/***/ 3008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var userAgent = __webpack_require__(8060);

var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 7340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8060);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 1078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* global Bun, Deno -- detection */
var globalThis = __webpack_require__(9117);
var userAgent = __webpack_require__(8060);
var classof = __webpack_require__(8689);

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

module.exports = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof(globalThis.process) === 'process') return 'NODE';
  if (globalThis.window && globalThis.document) return 'BROWSER';
  return 'REST';
})();


/***/ }),

/***/ 7308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 5382:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__(8088);
var clearErrorStack = __webpack_require__(7308);
var ERROR_STACK_INSTALLABLE = __webpack_require__(4582);

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),

/***/ 4582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);
var createPropertyDescriptor = __webpack_require__(9123);

module.exports = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ 5613:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var getOwnPropertyDescriptor = (__webpack_require__(9304).f);
var createNonEnumerableProperty = __webpack_require__(8088);
var defineBuiltIn = __webpack_require__(7509);
var defineGlobalProperty = __webpack_require__(4798);
var copyConstructorProperties = __webpack_require__(8657);
var isForced = __webpack_require__(8489);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis;
  } else if (STATIC) {
    target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis[TARGET] && globalThis[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 5234:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 467:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(8376);
var call = __webpack_require__(9944);
var defineBuiltIn = __webpack_require__(7509);
var regexpExec = __webpack_require__(9342);
var fails = __webpack_require__(5234);
var wellKnownSymbol = __webpack_require__(4282);
var createNonEnumerableProperty = __webpack_require__(8088);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 9391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ 646:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(9055);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 5821:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(5691);
var aCallable = __webpack_require__(4977);
var NATIVE_BIND = __webpack_require__(9055);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 9055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 9944:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(9055);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 2735:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var hasOwn = __webpack_require__(4418);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var aCallable = __webpack_require__(4977);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 5691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__(8689);
var uncurryThis = __webpack_require__(6881);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 6881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(9055);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var isCallable = __webpack_require__(4188);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};


/***/ }),

/***/ 6002:
/***/ (function(module) {

"use strict";

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
module.exports = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};


/***/ }),

/***/ 9874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(5438);
var getMethod = __webpack_require__(2913);
var isNullOrUndefined = __webpack_require__(4318);
var Iterators = __webpack_require__(9164);
var wellKnownSymbol = __webpack_require__(4282);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 2350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var aCallable = __webpack_require__(4977);
var anObject = __webpack_require__(3770);
var tryToString = __webpack_require__(3174);
var getIteratorMethod = __webpack_require__(9874);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 8254:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var isArray = __webpack_require__(6719);
var isCallable = __webpack_require__(4188);
var classof = __webpack_require__(8689);
var toString = __webpack_require__(2618);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ 2913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(4977);
var isNullOrUndefined = __webpack_require__(4318);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 5558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(4977);
var anObject = __webpack_require__(3770);
var call = __webpack_require__(9944);
var toIntegerOrInfinity = __webpack_require__(6744);
var getIteratorDirect = __webpack_require__(6002);

var INVALID_SIZE = 'Invalid size';
var $RangeError = RangeError;
var $TypeError = TypeError;
var max = Math.max;

var SetRecord = function (set, intSize) {
  this.set = set;
  this.size = max(intSize, 0);
  this.has = aCallable(set.has);
  this.keys = aCallable(set.keys);
};

SetRecord.prototype = {
  getIterator: function () {
    return getIteratorDirect(anObject(call(this.keys, this.set)));
  },
  includes: function (it) {
    return call(this.has, this.set, it);
  }
};

// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
module.exports = function (obj) {
  anObject(obj);
  var numSize = +obj.size;
  // NOTE: If size is undefined, then numSize will be NaN
  // eslint-disable-next-line no-self-compare -- NaN check
  if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
  var intSize = toIntegerOrInfinity(numSize);
  if (intSize < 0) throw new $RangeError(INVALID_SIZE);
  return new SetRecord(obj, intSize);
};


/***/ }),

/***/ 1113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var toObject = __webpack_require__(3628);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 9117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 4418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var toObject = __webpack_require__(3628);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 7588:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 3306:
/***/ (function(module) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 7458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5604);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 9622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var fails = __webpack_require__(5234);
var createElement = __webpack_require__(5926);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 7568:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var fails = __webpack_require__(5234);
var classof = __webpack_require__(8689);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 4166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4188);
var isObject = __webpack_require__(831);
var setPrototypeOf = __webpack_require__(5054);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 3029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var isCallable = __webpack_require__(4188);
var store = __webpack_require__(2694);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 8257:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(831);
var createNonEnumerableProperty = __webpack_require__(8088);

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ 8118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var uncurryThis = __webpack_require__(6881);
var hiddenKeys = __webpack_require__(7588);
var isObject = __webpack_require__(831);
var hasOwn = __webpack_require__(4418);
var defineProperty = (__webpack_require__(4466).f);
var getOwnPropertyNamesModule = __webpack_require__(5629);
var getOwnPropertyNamesExternalModule = __webpack_require__(3701);
var isExtensible = __webpack_require__(1927);
var uid = __webpack_require__(6209);
var FREEZING = __webpack_require__(9391);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ 3086:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(5945);
var globalThis = __webpack_require__(9117);
var isObject = __webpack_require__(831);
var createNonEnumerableProperty = __webpack_require__(8088);
var hasOwn = __webpack_require__(4418);
var shared = __webpack_require__(2694);
var sharedKey = __webpack_require__(168);
var hiddenKeys = __webpack_require__(7588);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 8146:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(4282);
var Iterators = __webpack_require__(9164);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 6719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(8689);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 4188:
/***/ (function(module) {

"use strict";

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var fails = __webpack_require__(5234);
var isCallable = __webpack_require__(4188);
var classof = __webpack_require__(5438);
var getBuiltIn = __webpack_require__(5604);
var inspectSource = __webpack_require__(3029);

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 8489:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);
var isCallable = __webpack_require__(4188);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 4318:
/***/ (function(module) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 831:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4188);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 6712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(831);

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};


/***/ }),

/***/ 1942:
/***/ (function(module) {

"use strict";

module.exports = false;


/***/ }),

/***/ 473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(831);
var classof = __webpack_require__(8689);
var wellKnownSymbol = __webpack_require__(4282);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};


/***/ }),

/***/ 6032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5604);
var isCallable = __webpack_require__(4188);
var isPrototypeOf = __webpack_require__(4578);
var USE_SYMBOL_AS_UID = __webpack_require__(9809);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 7032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);

module.exports = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
  var next = record.next;
  var step, result;
  while (!(step = call(next, iterator)).done) {
    result = fn(step.value);
    if (result !== undefined) return result;
  }
};


/***/ }),

/***/ 8873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(5821);
var call = __webpack_require__(9944);
var anObject = __webpack_require__(3770);
var tryToString = __webpack_require__(3174);
var isArrayIteratorMethod = __webpack_require__(8146);
var lengthOfArrayLike = __webpack_require__(9389);
var isPrototypeOf = __webpack_require__(4578);
var getIterator = __webpack_require__(2350);
var getIteratorMethod = __webpack_require__(9874);
var iteratorClose = __webpack_require__(8500);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 8500:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var anObject = __webpack_require__(3770);
var getMethod = __webpack_require__(2913);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 9383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = (__webpack_require__(2037).IteratorPrototype);
var create = __webpack_require__(7065);
var createPropertyDescriptor = __webpack_require__(9123);
var setToStringTag = __webpack_require__(3754);
var Iterators = __webpack_require__(9164);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 2331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var create = __webpack_require__(7065);
var createNonEnumerableProperty = __webpack_require__(8088);
var defineBuiltIns = __webpack_require__(4320);
var wellKnownSymbol = __webpack_require__(4282);
var InternalStateModule = __webpack_require__(3086);
var getMethod = __webpack_require__(2913);
var IteratorPrototype = (__webpack_require__(2037).IteratorPrototype);
var createIterResultObject = __webpack_require__(6224);
var iteratorClose = __webpack_require__(8500);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var setInternalState = InternalStateModule.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns(create(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      try {
        var result = state.done ? undefined : state.nextHandler();
        return createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod(iterator, 'return');
        return returnMethod ? call(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose(state.inner.iterator, 'normal');
      } catch (error) {
        return iteratorClose(iterator, 'throw', error);
      }
      if (iterator) iteratorClose(iterator, 'normal');
      return createIterResultObject(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');

module.exports = function (nextHandler, IS_ITERATOR) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};


/***/ }),

/***/ 3217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var call = __webpack_require__(9944);
var IS_PURE = __webpack_require__(1942);
var FunctionName = __webpack_require__(2735);
var isCallable = __webpack_require__(4188);
var createIteratorConstructor = __webpack_require__(9383);
var getPrototypeOf = __webpack_require__(1786);
var setPrototypeOf = __webpack_require__(5054);
var setToStringTag = __webpack_require__(3754);
var createNonEnumerableProperty = __webpack_require__(8088);
var defineBuiltIn = __webpack_require__(7509);
var wellKnownSymbol = __webpack_require__(4282);
var Iterators = __webpack_require__(9164);
var IteratorsCore = __webpack_require__(2037);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 6598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var aCallable = __webpack_require__(4977);
var anObject = __webpack_require__(3770);
var getIteratorDirect = __webpack_require__(6002);
var createIteratorProxy = __webpack_require__(2331);
var callWithSafeIterationClosing = __webpack_require__(4412);

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var result = anObject(call(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://github.com/tc39/proposal-iterator-helpers
module.exports = function map(mapper) {
  anObject(this);
  aCallable(mapper);
  return new IteratorProxy(getIteratorDirect(this), {
    mapper: mapper
  });
};


/***/ }),

/***/ 2037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);
var isCallable = __webpack_require__(4188);
var isObject = __webpack_require__(831);
var create = __webpack_require__(7065);
var getPrototypeOf = __webpack_require__(1786);
var defineBuiltIn = __webpack_require__(7509);
var wellKnownSymbol = __webpack_require__(4282);
var IS_PURE = __webpack_require__(1942);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 9164:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 9389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(7611);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 4530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var fails = __webpack_require__(5234);
var isCallable = __webpack_require__(4188);
var hasOwn = __webpack_require__(4418);
var DESCRIPTORS = __webpack_require__(6893);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(2735).CONFIGURABLE);
var inspectSource = __webpack_require__(3029);
var InternalStateModule = __webpack_require__(3086);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 142:
/***/ (function(module) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 1982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var safeGetBuiltIn = __webpack_require__(5268);
var bind = __webpack_require__(5821);
var macrotask = (__webpack_require__(3474).set);
var Queue = __webpack_require__(8648);
var IS_IOS = __webpack_require__(6347);
var IS_IOS_PEBBLE = __webpack_require__(6168);
var IS_WEBOS_WEBKIT = __webpack_require__(1129);
var IS_NODE = __webpack_require__(3940);

var MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver;
var document = globalThis.document;
var process = globalThis.process;
var Promise = globalThis.Promise;
var microtask = safeGetBuiltIn('queueMicrotask');
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, globalThis);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ 9444:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(4977);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 9866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toString = __webpack_require__(2618);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isRegExp = __webpack_require__(473);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 9456:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var uncurryThis = __webpack_require__(6881);
var call = __webpack_require__(9944);
var fails = __webpack_require__(5234);
var objectKeys = __webpack_require__(7137);
var getOwnPropertySymbolsModule = __webpack_require__(156);
var propertyIsEnumerableModule = __webpack_require__(4416);
var toObject = __webpack_require__(3628);
var IndexedObject = __webpack_require__(7568);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 7065:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(3770);
var definePropertiesModule = __webpack_require__(30);
var enumBugKeys = __webpack_require__(1274);
var hiddenKeys = __webpack_require__(7588);
var html = __webpack_require__(7458);
var documentCreateElement = __webpack_require__(5926);
var sharedKey = __webpack_require__(168);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 30:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3315);
var definePropertyModule = __webpack_require__(4466);
var anObject = __webpack_require__(3770);
var toIndexedObject = __webpack_require__(380);
var objectKeys = __webpack_require__(7137);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 4466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var IE8_DOM_DEFINE = __webpack_require__(9622);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3315);
var anObject = __webpack_require__(3770);
var toPropertyKey = __webpack_require__(2344);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 9304:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var call = __webpack_require__(9944);
var propertyIsEnumerableModule = __webpack_require__(4416);
var createPropertyDescriptor = __webpack_require__(9123);
var toIndexedObject = __webpack_require__(380);
var toPropertyKey = __webpack_require__(2344);
var hasOwn = __webpack_require__(4418);
var IE8_DOM_DEFINE = __webpack_require__(9622);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 3701:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(8689);
var toIndexedObject = __webpack_require__(380);
var $getOwnPropertyNames = (__webpack_require__(5629).f);
var arraySlice = __webpack_require__(7825);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 5629:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(1843);
var enumBugKeys = __webpack_require__(1274);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 156:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(4418);
var isCallable = __webpack_require__(4188);
var toObject = __webpack_require__(3628);
var sharedKey = __webpack_require__(168);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(680);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 1927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);
var isObject = __webpack_require__(831);
var classof = __webpack_require__(8689);
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(5469);

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ 4578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 1843:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var hasOwn = __webpack_require__(4418);
var toIndexedObject = __webpack_require__(380);
var indexOf = (__webpack_require__(1458).indexOf);
var hiddenKeys = __webpack_require__(7588);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 7137:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(1843);
var enumBugKeys = __webpack_require__(1274);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 4416:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 5054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(1025);
var isObject = __webpack_require__(831);
var requireObjectCoercible = __webpack_require__(9509);
var aPossiblePrototype = __webpack_require__(4121);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 2244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(9345);
var classof = __webpack_require__(5438);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 2287:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var isCallable = __webpack_require__(4188);
var isObject = __webpack_require__(831);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5604);
var uncurryThis = __webpack_require__(6881);
var getOwnPropertyNamesModule = __webpack_require__(5629);
var getOwnPropertySymbolsModule = __webpack_require__(156);
var anObject = __webpack_require__(3770);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 9120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);

module.exports = globalThis;


/***/ }),

/***/ 6042:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 7301:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var NativePromiseConstructor = __webpack_require__(6453);
var isCallable = __webpack_require__(4188);
var isForced = __webpack_require__(8489);
var inspectSource = __webpack_require__(3029);
var wellKnownSymbol = __webpack_require__(4282);
var ENVIRONMENT = __webpack_require__(1078);
var IS_PURE = __webpack_require__(1942);
var V8_VERSION = __webpack_require__(3008);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 6453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);

module.exports = globalThis.Promise;


/***/ }),

/***/ 8787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(3770);
var isObject = __webpack_require__(831);
var newPromiseCapability = __webpack_require__(9444);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 6292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__(6453);
var checkCorrectnessOfIteration = __webpack_require__(7283);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(7301).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(4466).f);

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ 8648:
/***/ (function(module) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 4721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var anObject = __webpack_require__(3770);
var isCallable = __webpack_require__(4188);
var classof = __webpack_require__(8689);
var regexpExec = __webpack_require__(9342);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw new $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 9342:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(9944);
var uncurryThis = __webpack_require__(6881);
var toString = __webpack_require__(2618);
var regexpFlags = __webpack_require__(4932);
var stickyHelpers = __webpack_require__(5976);
var shared = __webpack_require__(746);
var create = __webpack_require__(7065);
var getInternalState = (__webpack_require__(3086).get);
var UNSUPPORTED_DOT_ALL = __webpack_require__(6676);
var UNSUPPORTED_NCG = __webpack_require__(4609);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 4932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(3770);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 3113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var hasOwn = __webpack_require__(4418);
var isPrototypeOf = __webpack_require__(4578);
var regExpFlags = __webpack_require__(4932);

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ 5976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);
var globalThis = __webpack_require__(9117);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = globalThis.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ 6676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);
var globalThis = __webpack_require__(9117);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = globalThis.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});


/***/ }),

/***/ 4609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(5234);
var globalThis = __webpack_require__(9117);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 9509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(4318);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 5268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var DESCRIPTORS = __webpack_require__(6893);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
module.exports = function (name) {
  if (!DESCRIPTORS) return globalThis[name];
  var descriptor = getOwnPropertyDescriptor(globalThis, name);
  return descriptor && descriptor.value;
};


/***/ }),

/***/ 679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var SetHelpers = __webpack_require__(3243);
var iterate = __webpack_require__(9800);

var Set = SetHelpers.Set;
var add = SetHelpers.add;

module.exports = function (set) {
  var result = new Set();
  iterate(set, function (it) {
    add(result, it);
  });
  return result;
};


/***/ }),

/***/ 7059:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(2937);
var SetHelpers = __webpack_require__(3243);
var clone = __webpack_require__(679);
var size = __webpack_require__(7173);
var getSetRecord = __webpack_require__(5558);
var iterateSet = __webpack_require__(9800);
var iterateSimple = __webpack_require__(7032);

var has = SetHelpers.has;
var remove = SetHelpers.remove;

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
module.exports = function difference(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  var result = clone(O);
  if (size(O) <= otherRec.size) iterateSet(O, function (e) {
    if (otherRec.includes(e)) remove(result, e);
  });
  else iterateSimple(otherRec.getIterator(), function (e) {
    if (has(O, e)) remove(result, e);
  });
  return result;
};


/***/ }),

/***/ 3243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);

// eslint-disable-next-line es/no-set -- safe
var SetPrototype = Set.prototype;

module.exports = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: uncurryThis(SetPrototype.add),
  has: uncurryThis(SetPrototype.has),
  remove: uncurryThis(SetPrototype['delete']),
  proto: SetPrototype
};


/***/ }),

/***/ 3721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(2937);
var SetHelpers = __webpack_require__(3243);
var size = __webpack_require__(7173);
var getSetRecord = __webpack_require__(5558);
var iterateSet = __webpack_require__(9800);
var iterateSimple = __webpack_require__(7032);

var Set = SetHelpers.Set;
var add = SetHelpers.add;
var has = SetHelpers.has;

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
module.exports = function intersection(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  var result = new Set();

  if (size(O) > otherRec.size) {
    iterateSimple(otherRec.getIterator(), function (e) {
      if (has(O, e)) add(result, e);
    });
  } else {
    iterateSet(O, function (e) {
      if (otherRec.includes(e)) add(result, e);
    });
  }

  return result;
};


/***/ }),

/***/ 9978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(2937);
var has = (__webpack_require__(3243).has);
var size = __webpack_require__(7173);
var getSetRecord = __webpack_require__(5558);
var iterateSet = __webpack_require__(9800);
var iterateSimple = __webpack_require__(7032);
var iteratorClose = __webpack_require__(8500);

// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
module.exports = function isDisjointFrom(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (size(O) <= otherRec.size) return iterateSet(O, function (e) {
    if (otherRec.includes(e)) return false;
  }, true) !== false;
  var iterator = otherRec.getIterator();
  return iterateSimple(iterator, function (e) {
    if (has(O, e)) return iteratorClose(iterator, 'normal', false);
  }) !== false;
};


/***/ }),

/***/ 4361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(2937);
var size = __webpack_require__(7173);
var iterate = __webpack_require__(9800);
var getSetRecord = __webpack_require__(5558);

// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
module.exports = function isSubsetOf(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (size(O) > otherRec.size) return false;
  return iterate(O, function (e) {
    if (!otherRec.includes(e)) return false;
  }, true) !== false;
};


/***/ }),

/***/ 7528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(2937);
var has = (__webpack_require__(3243).has);
var size = __webpack_require__(7173);
var getSetRecord = __webpack_require__(5558);
var iterateSimple = __webpack_require__(7032);
var iteratorClose = __webpack_require__(8500);

// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
module.exports = function isSupersetOf(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (size(O) < otherRec.size) return false;
  var iterator = otherRec.getIterator();
  return iterateSimple(iterator, function (e) {
    if (!has(O, e)) return iteratorClose(iterator, 'normal', false);
  }) !== false;
};


/***/ }),

/***/ 9800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var iterateSimple = __webpack_require__(7032);
var SetHelpers = __webpack_require__(3243);

var Set = SetHelpers.Set;
var SetPrototype = SetHelpers.proto;
var forEach = uncurryThis(SetPrototype.forEach);
var keys = uncurryThis(SetPrototype.keys);
var next = keys(new Set()).next;

module.exports = function (set, fn, interruptible) {
  return interruptible ? iterateSimple({ iterator: keys(set), next: next }, fn) : forEach(set, fn);
};


/***/ }),

/***/ 4471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5604);

var createSetLike = function (size) {
  return {
    size: size,
    has: function () {
      return false;
    },
    keys: function () {
      return {
        next: function () {
          return { done: true };
        }
      };
    }
  };
};

module.exports = function (name) {
  var Set = getBuiltIn('Set');
  try {
    new Set()[name](createSetLike(0));
    try {
      // late spec change, early WebKit ~ Safari 17.0 beta implementation does not pass it
      // https://github.com/tc39/proposal-set-methods/pull/88
      new Set()[name](createSetLike(-1));
      return false;
    } catch (error2) {
      return true;
    }
  } catch (error) {
    return false;
  }
};


/***/ }),

/***/ 7173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThisAccessor = __webpack_require__(1025);
var SetHelpers = __webpack_require__(3243);

module.exports = uncurryThisAccessor(SetHelpers.proto, 'size', 'get') || function (set) {
  return set.size;
};


/***/ }),

/***/ 3900:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5604);
var defineBuiltInAccessor = __webpack_require__(997);
var wellKnownSymbol = __webpack_require__(4282);
var DESCRIPTORS = __webpack_require__(6893);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 1657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(2937);
var SetHelpers = __webpack_require__(3243);
var clone = __webpack_require__(679);
var getSetRecord = __webpack_require__(5558);
var iterateSimple = __webpack_require__(7032);

var add = SetHelpers.add;
var has = SetHelpers.has;
var remove = SetHelpers.remove;

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
module.exports = function symmetricDifference(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = clone(O);
  iterateSimple(keysIter, function (e) {
    if (has(O, e)) remove(result, e);
    else add(result, e);
  });
  return result;
};


/***/ }),

/***/ 3754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(4466).f);
var hasOwn = __webpack_require__(4418);
var wellKnownSymbol = __webpack_require__(4282);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 5077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(2937);
var add = (__webpack_require__(3243).add);
var clone = __webpack_require__(679);
var getSetRecord = __webpack_require__(5558);
var iterateSimple = __webpack_require__(7032);

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
module.exports = function union(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = clone(O);
  iterateSimple(keysIter, function (it) {
    add(result, it);
  });
  return result;
};


/***/ }),

/***/ 168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(746);
var uid = __webpack_require__(6209);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 2694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(1942);
var globalThis = __webpack_require__(9117);
var defineGlobalProperty = __webpack_require__(4798);

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.39.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var store = __webpack_require__(2694);

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};


/***/ }),

/***/ 7964:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(3770);
var aConstructor = __webpack_require__(1361);
var isNullOrUndefined = __webpack_require__(4318);
var wellKnownSymbol = __webpack_require__(4282);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 4212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var toIntegerOrInfinity = __webpack_require__(6744);
var toString = __webpack_require__(2618);
var requireObjectCoercible = __webpack_require__(9509);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 9380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(6744);
var toString = __webpack_require__(2618);
var requireObjectCoercible = __webpack_require__(9509);

var $RangeError = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n === Infinity) throw new $RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ 4425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__(2735).PROPER);
var fails = __webpack_require__(5234);
var whitespaces = __webpack_require__(9209);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ 2771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);
var requireObjectCoercible = __webpack_require__(9509);
var toString = __webpack_require__(2618);
var whitespaces = __webpack_require__(9209);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 8944:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(3008);
var fails = __webpack_require__(5234);
var globalThis = __webpack_require__(9117);

var $String = globalThis.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 7093:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var getBuiltIn = __webpack_require__(5604);
var wellKnownSymbol = __webpack_require__(4282);
var defineBuiltIn = __webpack_require__(7509);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 6577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(8944);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 3474:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var apply = __webpack_require__(646);
var bind = __webpack_require__(5821);
var isCallable = __webpack_require__(4188);
var hasOwn = __webpack_require__(4418);
var fails = __webpack_require__(5234);
var html = __webpack_require__(7458);
var arraySlice = __webpack_require__(7825);
var createElement = __webpack_require__(5926);
var validateArgumentsLength = __webpack_require__(9445);
var IS_IOS = __webpack_require__(6347);
var IS_NODE = __webpack_require__(3940);

var set = globalThis.setImmediate;
var clear = globalThis.clearImmediate;
var process = globalThis.process;
var Dispatch = globalThis.Dispatch;
var Function = globalThis.Function;
var MessageChannel = globalThis.MessageChannel;
var String = globalThis.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = globalThis.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  globalThis.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    globalThis.addEventListener &&
    isCallable(globalThis.postMessage) &&
    !globalThis.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    globalThis.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 5881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ 675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(6744);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(7568);
var requireObjectCoercible = __webpack_require__(9509);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 6744:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(142);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(6744);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 3628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(9509);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var isObject = __webpack_require__(831);
var isSymbol = __webpack_require__(6032);
var getMethod = __webpack_require__(2913);
var ordinaryToPrimitive = __webpack_require__(2287);
var wellKnownSymbol = __webpack_require__(4282);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 2344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(290);
var isSymbol = __webpack_require__(6032);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 9345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(4282);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 2618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(5438);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 3174:
/***/ (function(module) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 6209:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(6881);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 9809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(8944);

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3315:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var fails = __webpack_require__(5234);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 9445:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 5945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var isCallable = __webpack_require__(4188);

var WeakMap = globalThis.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 2860:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(9120);
var hasOwn = __webpack_require__(4418);
var wrappedWellKnownSymbolModule = __webpack_require__(346);
var defineProperty = (__webpack_require__(4466).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 346:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(4282);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 4282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var shared = __webpack_require__(746);
var hasOwn = __webpack_require__(4418);
var uid = __webpack_require__(6209);
var NATIVE_SYMBOL = __webpack_require__(8944);
var USE_SYMBOL_AS_UID = __webpack_require__(9809);

var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 9209:
/***/ (function(module) {

"use strict";

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 6208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5604);
var hasOwn = __webpack_require__(4418);
var createNonEnumerableProperty = __webpack_require__(8088);
var isPrototypeOf = __webpack_require__(4578);
var setPrototypeOf = __webpack_require__(5054);
var copyConstructorProperties = __webpack_require__(8657);
var proxyAccessor = __webpack_require__(8679);
var inheritIfRequired = __webpack_require__(4166);
var normalizeStringArgument = __webpack_require__(9866);
var installErrorCause = __webpack_require__(8257);
var installErrorStack = __webpack_require__(5382);
var DESCRIPTORS = __webpack_require__(6893);
var IS_PURE = __webpack_require__(1942);

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ 6411:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var fails = __webpack_require__(5234);
var isArray = __webpack_require__(6719);
var isObject = __webpack_require__(831);
var toObject = __webpack_require__(3628);
var lengthOfArrayLike = __webpack_require__(9389);
var doesNotExceedSafeInteger = __webpack_require__(2197);
var createProperty = __webpack_require__(4417);
var arraySpeciesCreate = __webpack_require__(5022);
var arrayMethodHasSpeciesSupport = __webpack_require__(378);
var wellKnownSymbol = __webpack_require__(4282);
var V8_VERSION = __webpack_require__(3008);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 5305:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var $filter = (__webpack_require__(4104).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(378);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 3252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var $find = (__webpack_require__(4104).find);
var addToUnscopables = __webpack_require__(5458);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 1875:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var from = __webpack_require__(6859);
var checkCorrectnessOfIteration = __webpack_require__(7283);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 2234:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var $includes = (__webpack_require__(1458).includes);
var fails = __webpack_require__(5234);
var addToUnscopables = __webpack_require__(5458);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 3873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(380);
var addToUnscopables = __webpack_require__(5458);
var Iterators = __webpack_require__(9164);
var InternalStateModule = __webpack_require__(3086);
var defineProperty = (__webpack_require__(4466).f);
var defineIterator = __webpack_require__(3217);
var createIterResultObject = __webpack_require__(6224);
var IS_PURE = __webpack_require__(1942);
var DESCRIPTORS = __webpack_require__(6893);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 4147:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var uncurryThis = __webpack_require__(6881);
var IndexedObject = __webpack_require__(7568);
var toIndexedObject = __webpack_require__(380);
var arrayMethodIsStrict = __webpack_require__(5397);

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject !== Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 8981:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var $map = (__webpack_require__(4104).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(378);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 9375:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var toObject = __webpack_require__(3628);
var lengthOfArrayLike = __webpack_require__(9389);
var setArrayLength = __webpack_require__(4224);
var doesNotExceedSafeInteger = __webpack_require__(2197);
var fails = __webpack_require__(5234);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 6569:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var isArray = __webpack_require__(6719);
var isConstructor = __webpack_require__(866);
var isObject = __webpack_require__(831);
var toAbsoluteIndex = __webpack_require__(675);
var lengthOfArrayLike = __webpack_require__(9389);
var toIndexedObject = __webpack_require__(380);
var createProperty = __webpack_require__(4417);
var wellKnownSymbol = __webpack_require__(4282);
var arrayMethodHasSpeciesSupport = __webpack_require__(378);
var nativeSlice = __webpack_require__(7825);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 3975:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var uncurryThis = __webpack_require__(6881);
var aCallable = __webpack_require__(4977);
var toObject = __webpack_require__(3628);
var lengthOfArrayLike = __webpack_require__(9389);
var deletePropertyOrThrow = __webpack_require__(1305);
var toString = __webpack_require__(2618);
var fails = __webpack_require__(5234);
var internalSort = __webpack_require__(9295);
var arrayMethodIsStrict = __webpack_require__(5397);
var FF = __webpack_require__(2222);
var IE_OR_EDGE = __webpack_require__(4598);
var V8 = __webpack_require__(3008);
var WEBKIT = __webpack_require__(7340);

var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});


/***/ }),

/***/ 8803:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var toObject = __webpack_require__(3628);
var toAbsoluteIndex = __webpack_require__(675);
var toIntegerOrInfinity = __webpack_require__(6744);
var lengthOfArrayLike = __webpack_require__(9389);
var setArrayLength = __webpack_require__(4224);
var doesNotExceedSafeInteger = __webpack_require__(2197);
var arraySpeciesCreate = __webpack_require__(5022);
var createProperty = __webpack_require__(4417);
var deletePropertyOrThrow = __webpack_require__(1305);
var arrayMethodHasSpeciesSupport = __webpack_require__(378);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});


/***/ }),

/***/ 595:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(4418);
var defineBuiltIn = __webpack_require__(7509);
var dateToPrimitive = __webpack_require__(8089);
var wellKnownSymbol = __webpack_require__(4282);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ 7107:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__(5613);
var globalThis = __webpack_require__(9117);
var apply = __webpack_require__(646);
var wrapErrorConstructorWithCause = __webpack_require__(6208);

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = globalThis[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ 3277:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var FUNCTION_NAME_EXISTS = (__webpack_require__(2735).EXISTS);
var uncurryThis = __webpack_require__(6881);
var defineBuiltInAccessor = __webpack_require__(997);

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 1402:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var globalThis = __webpack_require__(9117);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true, forced: globalThis.globalThis !== globalThis }, {
  globalThis: globalThis
});


/***/ }),

/***/ 2438:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var globalThis = __webpack_require__(9117);
var anInstance = __webpack_require__(286);
var anObject = __webpack_require__(3770);
var isCallable = __webpack_require__(4188);
var getPrototypeOf = __webpack_require__(1786);
var defineBuiltInAccessor = __webpack_require__(997);
var createProperty = __webpack_require__(4417);
var fails = __webpack_require__(5234);
var hasOwn = __webpack_require__(4418);
var wellKnownSymbol = __webpack_require__(4282);
var IteratorPrototype = (__webpack_require__(2037).IteratorPrototype);
var DESCRIPTORS = __webpack_require__(6893);
var IS_PURE = __webpack_require__(1942);

var CONSTRUCTOR = 'constructor';
var ITERATOR = 'Iterator';
var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var $TypeError = TypeError;
var NativeIterator = globalThis[ITERATOR];

// FF56- have non-standard global helper `Iterator`
var FORCED = IS_PURE
  || !isCallable(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype
  // FF44- non-standard `Iterator` passes previous tests
  || !fails(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype);
  if (getPrototypeOf(this) === IteratorPrototype) throw new $TypeError('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS) {
    defineBuiltInAccessor(IteratorPrototype, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject(this);
        if (this === IteratorPrototype) throw new $TypeError("You can't redefine this property");
        if (hasOwn(this, key)) this[key] = replacement;
        else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype[key] = value;
};

if (!hasOwn(IteratorPrototype, TO_STRING_TAG)) defineIteratorPrototypeAccessor(TO_STRING_TAG, ITERATOR);

if (FORCED || !hasOwn(IteratorPrototype, CONSTRUCTOR) || IteratorPrototype[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$({ global: true, constructor: true, forced: FORCED }, {
  Iterator: IteratorConstructor
});


/***/ }),

/***/ 2266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var call = __webpack_require__(9944);
var aCallable = __webpack_require__(4977);
var anObject = __webpack_require__(3770);
var getIteratorDirect = __webpack_require__(6002);
var createIteratorProxy = __webpack_require__(2331);
var callWithSafeIterationClosing = __webpack_require__(4412);
var IS_PURE = __webpack_require__(1942);

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject(call(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
$({ target: 'Iterator', proto: true, real: true, forced: IS_PURE }, {
  filter: function filter(predicate) {
    anObject(this);
    aCallable(predicate);
    return new IteratorProxy(getIteratorDirect(this), {
      predicate: predicate
    });
  }
});


/***/ }),

/***/ 9819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var iterate = __webpack_require__(8873);
var aCallable = __webpack_require__(4977);
var anObject = __webpack_require__(3770);
var getIteratorDirect = __webpack_require__(6002);

// `Iterator.prototype.find` method
// https://tc39.es/ecma262/#sec-iterator.prototype.find
$({ target: 'Iterator', proto: true, real: true }, {
  find: function find(predicate) {
    anObject(this);
    aCallable(predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, { IS_RECORD: true, INTERRUPTED: true }).result;
  }
});


/***/ }),

/***/ 7327:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var iterate = __webpack_require__(8873);
var aCallable = __webpack_require__(4977);
var anObject = __webpack_require__(3770);
var getIteratorDirect = __webpack_require__(6002);

// `Iterator.prototype.forEach` method
// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
$({ target: 'Iterator', proto: true, real: true }, {
  forEach: function forEach(fn) {
    anObject(this);
    aCallable(fn);
    var record = getIteratorDirect(this);
    var counter = 0;
    iterate(record, function (value) {
      fn(value, counter++);
    }, { IS_RECORD: true });
  }
});


/***/ }),

/***/ 20:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var map = __webpack_require__(6598);
var IS_PURE = __webpack_require__(1942);

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
$({ target: 'Iterator', proto: true, real: true, forced: IS_PURE }, {
  map: map
});


/***/ }),

/***/ 4786:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var iterate = __webpack_require__(8873);
var aCallable = __webpack_require__(4977);
var anObject = __webpack_require__(3770);
var getIteratorDirect = __webpack_require__(6002);

var $TypeError = TypeError;

// `Iterator.prototype.reduce` method
// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
$({ target: 'Iterator', proto: true, real: true }, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject(this);
    aCallable(reducer);
    var record = getIteratorDirect(this);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    var counter = 0;
    iterate(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, { IS_RECORD: true });
    if (noInitial) throw new $TypeError('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});


/***/ }),

/***/ 4727:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var getBuiltIn = __webpack_require__(5604);
var apply = __webpack_require__(646);
var call = __webpack_require__(9944);
var uncurryThis = __webpack_require__(6881);
var fails = __webpack_require__(5234);
var isCallable = __webpack_require__(4188);
var isSymbol = __webpack_require__(6032);
var arraySlice = __webpack_require__(7825);
var getReplacerFunction = __webpack_require__(8254);
var NATIVE_SYMBOL = __webpack_require__(8944);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 8794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var setToStringTag = __webpack_require__(3754);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(globalThis.JSON, 'JSON', true);


/***/ }),

/***/ 7920:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(6351);
var collectionStrong = __webpack_require__(3231);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 8470:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(7920);


/***/ }),

/***/ 1806:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var setToStringTag = __webpack_require__(3754);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ 7324:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var trunc = __webpack_require__(142);

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: trunc
});


/***/ }),

/***/ 3185:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var IS_PURE = __webpack_require__(1942);
var DESCRIPTORS = __webpack_require__(6893);
var globalThis = __webpack_require__(9117);
var path = __webpack_require__(9120);
var uncurryThis = __webpack_require__(6881);
var isForced = __webpack_require__(8489);
var hasOwn = __webpack_require__(4418);
var inheritIfRequired = __webpack_require__(4166);
var isPrototypeOf = __webpack_require__(4578);
var isSymbol = __webpack_require__(6032);
var toPrimitive = __webpack_require__(290);
var fails = __webpack_require__(5234);
var getOwnPropertyNames = (__webpack_require__(5629).f);
var getOwnPropertyDescriptor = (__webpack_require__(9304).f);
var defineProperty = (__webpack_require__(4466).f);
var thisNumberValue = __webpack_require__(5881);
var trim = (__webpack_require__(2771).trim);

var NUMBER = 'Number';
var NativeNumber = globalThis[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = globalThis.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw new TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        // fast equal of /^0b[01]+$/i
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal of /^0o[0-7]+$/i
        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        default:
          return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),

/***/ 7403:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var uncurryThis = __webpack_require__(6881);
var toIntegerOrInfinity = __webpack_require__(6744);
var thisNumberValue = __webpack_require__(5881);
var $repeat = __webpack_require__(9380);
var fails = __webpack_require__(5234);

var $RangeError = RangeError;
var $String = String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var nativeToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ 7050:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var assign = __webpack_require__(9456);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 7678:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var fails = __webpack_require__(5234);
var toIndexedObject = __webpack_require__(380);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(9304).f);
var DESCRIPTORS = __webpack_require__(6893);

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 1909:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var DESCRIPTORS = __webpack_require__(6893);
var ownKeys = __webpack_require__(3168);
var toIndexedObject = __webpack_require__(380);
var getOwnPropertyDescriptorModule = __webpack_require__(9304);
var createProperty = __webpack_require__(4417);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 6963:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var fails = __webpack_require__(5234);
var getOwnPropertyNames = (__webpack_require__(3701).f);

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});


/***/ }),

/***/ 3786:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var NATIVE_SYMBOL = __webpack_require__(8944);
var fails = __webpack_require__(5234);
var getOwnPropertySymbolsModule = __webpack_require__(156);
var toObject = __webpack_require__(3628);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 2380:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var fails = __webpack_require__(5234);
var toObject = __webpack_require__(3628);
var nativeGetPrototypeOf = __webpack_require__(1786);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(680);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 2082:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var hasOwn = __webpack_require__(4418);

// `Object.hasOwn` method
// https://tc39.es/ecma262/#sec-object.hasown
$({ target: 'Object', stat: true }, {
  hasOwn: hasOwn
});


/***/ }),

/***/ 8291:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var toObject = __webpack_require__(3628);
var nativeKeys = __webpack_require__(7137);
var fails = __webpack_require__(5234);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 7265:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var defineBuiltInAccessor = __webpack_require__(997);
var isObject = __webpack_require__(831);
var isPossiblePrototype = __webpack_require__(6712);
var toObject = __webpack_require__(3628);
var requireObjectCoercible = __webpack_require__(9509);

// eslint-disable-next-line es/no-object-getprototypeof -- safe
var getPrototypeOf = Object.getPrototypeOf;
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var setPrototypeOf = Object.setPrototypeOf;
var ObjectPrototype = Object.prototype;
var PROTO = '__proto__';

// `Object.prototype.__proto__` accessor
// https://tc39.es/ecma262/#sec-object.prototype.__proto__
if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
  defineBuiltInAccessor(ObjectPrototype, PROTO, {
    configurable: true,
    get: function __proto__() {
      return getPrototypeOf(toObject(this));
    },
    set: function __proto__(proto) {
      var O = requireObjectCoercible(this);
      if (isPossiblePrototype(proto) && isObject(O)) {
        setPrototypeOf(O, proto);
      }
    }
  });
} catch (error) { /* empty */ }


/***/ }),

/***/ 1280:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var setPrototypeOf = __webpack_require__(5054);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ 630:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(9345);
var defineBuiltIn = __webpack_require__(7509);
var toString = __webpack_require__(2244);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 5528:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var call = __webpack_require__(9944);
var aCallable = __webpack_require__(4977);
var newPromiseCapabilityModule = __webpack_require__(9444);
var perform = __webpack_require__(6042);
var iterate = __webpack_require__(8873);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(6292);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 4348:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var IS_PURE = __webpack_require__(1942);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(7301).CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__(6453);
var getBuiltIn = __webpack_require__(5604);
var isCallable = __webpack_require__(4188);
var defineBuiltIn = __webpack_require__(7509);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ 4267:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var IS_PURE = __webpack_require__(1942);
var IS_NODE = __webpack_require__(3940);
var globalThis = __webpack_require__(9117);
var call = __webpack_require__(9944);
var defineBuiltIn = __webpack_require__(7509);
var setPrototypeOf = __webpack_require__(5054);
var setToStringTag = __webpack_require__(3754);
var setSpecies = __webpack_require__(3900);
var aCallable = __webpack_require__(4977);
var isCallable = __webpack_require__(4188);
var isObject = __webpack_require__(831);
var anInstance = __webpack_require__(286);
var speciesConstructor = __webpack_require__(7964);
var task = (__webpack_require__(3474).set);
var microtask = __webpack_require__(1982);
var hostReportErrors = __webpack_require__(3306);
var perform = __webpack_require__(6042);
var Queue = __webpack_require__(8648);
var InternalStateModule = __webpack_require__(3086);
var NativePromiseConstructor = __webpack_require__(6453);
var PromiseConstructorDetection = __webpack_require__(7301);
var newPromiseCapabilityModule = __webpack_require__(9444);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = globalThis.TypeError;
var document = globalThis.document;
var process = globalThis.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && globalThis.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    globalThis.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, globalThis, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: null
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ 7212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var IS_PURE = __webpack_require__(1942);
var NativePromiseConstructor = __webpack_require__(6453);
var fails = __webpack_require__(5234);
var getBuiltIn = __webpack_require__(5604);
var isCallable = __webpack_require__(4188);
var speciesConstructor = __webpack_require__(7964);
var promiseResolve = __webpack_require__(8787);
var defineBuiltIn = __webpack_require__(7509);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ 865:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(4267);
__webpack_require__(5528);
__webpack_require__(4348);
__webpack_require__(7174);
__webpack_require__(4168);
__webpack_require__(8235);


/***/ }),

/***/ 7174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var call = __webpack_require__(9944);
var aCallable = __webpack_require__(4977);
var newPromiseCapabilityModule = __webpack_require__(9444);
var perform = __webpack_require__(6042);
var iterate = __webpack_require__(8873);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(6292);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 4168:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var newPromiseCapabilityModule = __webpack_require__(9444);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(7301).CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});


/***/ }),

/***/ 8235:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var getBuiltIn = __webpack_require__(5604);
var IS_PURE = __webpack_require__(1942);
var NativePromiseConstructor = __webpack_require__(6453);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(7301).CONSTRUCTOR);
var promiseResolve = __webpack_require__(8787);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ 2283:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var functionApply = __webpack_require__(646);
var aCallable = __webpack_require__(4977);
var anObject = __webpack_require__(3770);
var fails = __webpack_require__(5234);

// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.apply(function () { /* empty */ });
});

// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
  }
});


/***/ }),

/***/ 7087:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var globalThis = __webpack_require__(9117);
var setToStringTag = __webpack_require__(3754);

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(globalThis.Reflect, 'Reflect', true);


/***/ }),

/***/ 8697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var globalThis = __webpack_require__(9117);
var uncurryThis = __webpack_require__(6881);
var isForced = __webpack_require__(8489);
var inheritIfRequired = __webpack_require__(4166);
var createNonEnumerableProperty = __webpack_require__(8088);
var create = __webpack_require__(7065);
var getOwnPropertyNames = (__webpack_require__(5629).f);
var isPrototypeOf = __webpack_require__(4578);
var isRegExp = __webpack_require__(473);
var toString = __webpack_require__(2618);
var getRegExpFlags = __webpack_require__(3113);
var stickyHelpers = __webpack_require__(5976);
var proxyAccessor = __webpack_require__(8679);
var defineBuiltIn = __webpack_require__(7509);
var fails = __webpack_require__(5234);
var hasOwn = __webpack_require__(4418);
var enforceInternalState = (__webpack_require__(3086).enforce);
var setSpecies = __webpack_require__(3900);
var wellKnownSymbol = __webpack_require__(4282);
var UNSUPPORTED_DOT_ALL = __webpack_require__(6676);
var UNSUPPORTED_NCG = __webpack_require__(4609);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = globalThis.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = globalThis.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    // eslint-disable-next-line sonarjs/inconsistent-function-call -- required for testing
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = create(null);
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr += charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        result += chr;
        // ignore non-capturing groups
        if (stringSlice(string, index + 1, index + 3) === '?:') {
          continue;
        }
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(globalThis, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ 8096:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var UNSUPPORTED_DOT_ALL = __webpack_require__(6676);
var classof = __webpack_require__(8689);
var defineBuiltInAccessor = __webpack_require__(997);
var getInternalState = (__webpack_require__(3086).get);

var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineBuiltInAccessor(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }
      throw new $TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ 8376:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var exec = __webpack_require__(9342);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 7146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var DESCRIPTORS = __webpack_require__(6893);
var defineBuiltInAccessor = __webpack_require__(997);
var regExpFlags = __webpack_require__(4932);
var fails = __webpack_require__(5234);

// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp = globalThis.RegExp;
var RegExpPrototype = RegExp.prototype;

var FORCED = DESCRIPTORS && fails(function () {
  var INDICES_SUPPORT = true;
  try {
    RegExp('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {};
  // modern V8 bug
  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function (key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, { get: function () {
      calls += chr;
      return true;
    } });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };

  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) addGetter(key, pairs[key]);

  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  var result = Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call(O);

  return result !== expected || calls !== expected;
});

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED) defineBuiltInAccessor(RegExpPrototype, 'flags', {
  configurable: true,
  get: regExpFlags
});


/***/ }),

/***/ 206:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(6893);
var MISSED_STICKY = (__webpack_require__(5976).MISSED_STICKY);
var classof = __webpack_require__(8689);
var defineBuiltInAccessor = __webpack_require__(997);
var getInternalState = (__webpack_require__(3086).get);

var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && MISSED_STICKY) {
  defineBuiltInAccessor(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function sticky() {
      if (this === RegExpPrototype) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).sticky;
      }
      throw new $TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ 6929:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(8376);
var $ = __webpack_require__(5613);
var call = __webpack_require__(9944);
var isCallable = __webpack_require__(4188);
var anObject = __webpack_require__(3770);
var toString = __webpack_require__(2618);

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject(this);
    var string = toString(S);
    var exec = R.exec;
    if (!isCallable(exec)) return call(nativeTest, R, string);
    var result = call(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});


/***/ }),

/***/ 568:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__(2735).PROPER);
var defineBuiltIn = __webpack_require__(7509);
var anObject = __webpack_require__(3770);
var $toString = __webpack_require__(2618);
var fails = __webpack_require__(5234);
var getRegExpFlags = __webpack_require__(3113);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ 1130:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(6351);
var collectionStrong = __webpack_require__(3231);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 9033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var difference = __webpack_require__(7059);
var setMethodAcceptSetLike = __webpack_require__(4471);

// `Set.prototype.difference` method
// https://tc39.es/ecma262/#sec-set.prototype.difference
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('difference') }, {
  difference: difference
});


/***/ }),

/***/ 8903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var fails = __webpack_require__(5234);
var intersection = __webpack_require__(3721);
var setMethodAcceptSetLike = __webpack_require__(4471);

var INCORRECT = !setMethodAcceptSetLike('intersection') || fails(function () {
  // eslint-disable-next-line es/no-array-from, es/no-set -- testing
  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
});

// `Set.prototype.intersection` method
// https://tc39.es/ecma262/#sec-set.prototype.intersection
$({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
  intersection: intersection
});


/***/ }),

/***/ 1018:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var isDisjointFrom = __webpack_require__(9978);
var setMethodAcceptSetLike = __webpack_require__(4471);

// `Set.prototype.isDisjointFrom` method
// https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isDisjointFrom') }, {
  isDisjointFrom: isDisjointFrom
});


/***/ }),

/***/ 1415:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var isSubsetOf = __webpack_require__(4361);
var setMethodAcceptSetLike = __webpack_require__(4471);

// `Set.prototype.isSubsetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issubsetof
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isSubsetOf') }, {
  isSubsetOf: isSubsetOf
});


/***/ }),

/***/ 4448:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var isSupersetOf = __webpack_require__(7528);
var setMethodAcceptSetLike = __webpack_require__(4471);

// `Set.prototype.isSupersetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issupersetof
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isSupersetOf') }, {
  isSupersetOf: isSupersetOf
});


/***/ }),

/***/ 5668:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(1130);


/***/ }),

/***/ 8871:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var symmetricDifference = __webpack_require__(1657);
var setMethodAcceptSetLike = __webpack_require__(4471);

// `Set.prototype.symmetricDifference` method
// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('symmetricDifference') }, {
  symmetricDifference: symmetricDifference
});


/***/ }),

/***/ 6539:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var union = __webpack_require__(5077);
var setMethodAcceptSetLike = __webpack_require__(4471);

// `Set.prototype.union` method
// https://tc39.es/ecma262/#sec-set.prototype.union
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('union') }, {
  union: union
});


/***/ }),

/***/ 3536:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var uncurryThis = __webpack_require__(6881);
var toAbsoluteIndex = __webpack_require__(675);

var $RangeError = RangeError;
var fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join = uncurryThis([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join(elements, '');
  }
});


/***/ }),

/***/ 7748:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var uncurryThis = __webpack_require__(6881);
var notARegExp = __webpack_require__(836);
var requireObjectCoercible = __webpack_require__(9509);
var toString = __webpack_require__(2618);
var correctIsRegExpLogic = __webpack_require__(6425);

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ 1011:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(4212).charAt);
var toString = __webpack_require__(2618);
var InternalStateModule = __webpack_require__(3086);
var defineIterator = __webpack_require__(3217);
var createIterResultObject = __webpack_require__(6224);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ 9428:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(467);
var anObject = __webpack_require__(3770);
var isNullOrUndefined = __webpack_require__(4318);
var toLength = __webpack_require__(7611);
var toString = __webpack_require__(2618);
var requireObjectCoercible = __webpack_require__(9509);
var getMethod = __webpack_require__(2913);
var advanceStringIndex = __webpack_require__(154);
var regExpExec = __webpack_require__(4721);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 3498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var repeat = __webpack_require__(9380);

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});


/***/ }),

/***/ 4293:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(646);
var call = __webpack_require__(9944);
var uncurryThis = __webpack_require__(6881);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(467);
var fails = __webpack_require__(5234);
var anObject = __webpack_require__(3770);
var isCallable = __webpack_require__(4188);
var isNullOrUndefined = __webpack_require__(4318);
var toIntegerOrInfinity = __webpack_require__(6744);
var toLength = __webpack_require__(7611);
var toString = __webpack_require__(2618);
var requireObjectCoercible = __webpack_require__(9509);
var advanceStringIndex = __webpack_require__(154);
var getMethod = __webpack_require__(2913);
var getSubstitution = __webpack_require__(1113);
var regExpExec = __webpack_require__(4721);
var wellKnownSymbol = __webpack_require__(4282);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 8225:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9944);
var uncurryThis = __webpack_require__(6881);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(467);
var anObject = __webpack_require__(3770);
var isNullOrUndefined = __webpack_require__(4318);
var requireObjectCoercible = __webpack_require__(9509);
var speciesConstructor = __webpack_require__(7964);
var advanceStringIndex = __webpack_require__(154);
var toLength = __webpack_require__(7611);
var toString = __webpack_require__(2618);
var getMethod = __webpack_require__(2913);
var regExpExec = __webpack_require__(4721);
var stickyHelpers = __webpack_require__(5976);
var fails = __webpack_require__(5234);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var push = uncurryThis([].push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length !== 4 ||
  'ab'.split(/(?:ab)*/).length !== 2 ||
  '.'.split(/(.?)(.?)/).length !== 4 ||
  // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 ||
  ''.split(/.?/).length;

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
    return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
  } : nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);

      if (!BUGGY) {
        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
        if (res.done) return res.value;
      }

      var C = speciesConstructor(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');
      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ 6741:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var uncurryThis = __webpack_require__(5691);
var getOwnPropertyDescriptor = (__webpack_require__(9304).f);
var toLength = __webpack_require__(7611);
var toString = __webpack_require__(2618);
var notARegExp = __webpack_require__(836);
var requireObjectCoercible = __webpack_require__(9509);
var correctIsRegExpLogic = __webpack_require__(6425);
var IS_PURE = __webpack_require__(1942);

var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ 2273:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var $trim = (__webpack_require__(2771).trim);
var forcedStringTrimMethod = __webpack_require__(4425);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ 4007:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(2860);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 7152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var globalThis = __webpack_require__(9117);
var call = __webpack_require__(9944);
var uncurryThis = __webpack_require__(6881);
var IS_PURE = __webpack_require__(1942);
var DESCRIPTORS = __webpack_require__(6893);
var NATIVE_SYMBOL = __webpack_require__(8944);
var fails = __webpack_require__(5234);
var hasOwn = __webpack_require__(4418);
var isPrototypeOf = __webpack_require__(4578);
var anObject = __webpack_require__(3770);
var toIndexedObject = __webpack_require__(380);
var toPropertyKey = __webpack_require__(2344);
var $toString = __webpack_require__(2618);
var createPropertyDescriptor = __webpack_require__(9123);
var nativeObjectCreate = __webpack_require__(7065);
var objectKeys = __webpack_require__(7137);
var getOwnPropertyNamesModule = __webpack_require__(5629);
var getOwnPropertyNamesExternal = __webpack_require__(3701);
var getOwnPropertySymbolsModule = __webpack_require__(156);
var getOwnPropertyDescriptorModule = __webpack_require__(9304);
var definePropertyModule = __webpack_require__(4466);
var definePropertiesModule = __webpack_require__(30);
var propertyIsEnumerableModule = __webpack_require__(4416);
var defineBuiltIn = __webpack_require__(7509);
var defineBuiltInAccessor = __webpack_require__(997);
var shared = __webpack_require__(746);
var sharedKey = __webpack_require__(168);
var hiddenKeys = __webpack_require__(7588);
var uid = __webpack_require__(6209);
var wellKnownSymbol = __webpack_require__(4282);
var wrappedWellKnownSymbolModule = __webpack_require__(346);
var defineWellKnownSymbol = __webpack_require__(2860);
var defineSymbolToPrimitive = __webpack_require__(7093);
var setToStringTag = __webpack_require__(3754);
var InternalStateModule = __webpack_require__(3086);
var $forEach = (__webpack_require__(4104).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = globalThis.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = globalThis.RangeError;
var TypeError = globalThis.TypeError;
var QObject = globalThis.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
};

var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      var $this = this === undefined ? globalThis : this;
      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor(1, value);
      try {
        setSymbolDescriptor($this, tag, descriptor);
      } catch (error) {
        if (!(error instanceof RangeError)) throw error;
        fallbackDefineProperty($this, tag, descriptor);
      }
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 3510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(5613);
var DESCRIPTORS = __webpack_require__(6893);
var globalThis = __webpack_require__(9117);
var uncurryThis = __webpack_require__(6881);
var hasOwn = __webpack_require__(4418);
var isCallable = __webpack_require__(4188);
var isPrototypeOf = __webpack_require__(4578);
var toString = __webpack_require__(2618);
var defineBuiltInAccessor = __webpack_require__(997);
var copyConstructorProperties = __webpack_require__(8657);

var NativeSymbol = globalThis.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      // eslint-disable-next-line sonarjs/inconsistent-function-call -- ok
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var getBuiltIn = __webpack_require__(5604);
var hasOwn = __webpack_require__(4418);
var toString = __webpack_require__(2618);
var shared = __webpack_require__(746);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(6577);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 2432:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(2860);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 8070:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(7152);
__webpack_require__(691);
__webpack_require__(6965);
__webpack_require__(4727);
__webpack_require__(3786);


/***/ }),

/***/ 6965:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var hasOwn = __webpack_require__(4418);
var isSymbol = __webpack_require__(6032);
var tryToString = __webpack_require__(3174);
var shared = __webpack_require__(746);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(6577);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 5307:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(2860);
var defineSymbolToPrimitive = __webpack_require__(7093);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();


/***/ }),

/***/ 9392:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5604);
var defineWellKnownSymbol = __webpack_require__(2860);
var setToStringTag = __webpack_require__(3754);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ 1045:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(2438);


/***/ }),

/***/ 163:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(2266);


/***/ }),

/***/ 5950:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(9819);


/***/ }),

/***/ 5350:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(7327);


/***/ }),

/***/ 4915:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(20);


/***/ }),

/***/ 5367:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(4786);


/***/ }),

/***/ 8867:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var DOMIterables = __webpack_require__(9429);
var DOMTokenListPrototype = __webpack_require__(7463);
var forEach = __webpack_require__(7500);
var createNonEnumerableProperty = __webpack_require__(8088);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 7010:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(9117);
var DOMIterables = __webpack_require__(9429);
var DOMTokenListPrototype = __webpack_require__(7463);
var ArrayIteratorMethods = __webpack_require__(3873);
var createNonEnumerableProperty = __webpack_require__(8088);
var setToStringTag = __webpack_require__(3754);
var wellKnownSymbol = __webpack_require__(4282);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 5960:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5613);
var globalThis = __webpack_require__(9117);
var defineBuiltInAccessor = __webpack_require__(997);
var DESCRIPTORS = __webpack_require__(6893);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var INCORRECT_VALUE = globalThis.self !== globalThis;

// `self` getter
// https://html.spec.whatwg.org/multipage/window-object.html#dom-self
try {
  if (DESCRIPTORS) {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var descriptor = Object.getOwnPropertyDescriptor(globalThis, 'self');
    // some engines have `self`, but with incorrect descriptor
    // https://github.com/denoland/deno/issues/15765
    if (INCORRECT_VALUE || !descriptor || !descriptor.get || !descriptor.enumerable) {
      defineBuiltInAccessor(globalThis, 'self', {
        get: function self() {
          return globalThis;
        },
        set: function self(value) {
          if (this !== globalThis) throw new $TypeError('Illegal invocation');
          defineProperty(globalThis, 'self', {
            value: value,
            writable: true,
            configurable: true,
            enumerable: true
          });
        },
        configurable: true,
        enumerable: true
      });
    }
  } else $({ global: true, simple: true, forced: INCORRECT_VALUE }, {
    self: globalThis
  });
} catch (error) { /* empty */ }


/***/ }),

/***/ 5779:
/***/ (function(module) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4935:
/***/ (function(module) {

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 2969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(5779);
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 9049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(630);
__webpack_require__(865);
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(8070);
__webpack_require__(3510);
__webpack_require__(2432);
__webpack_require__(7107);
__webpack_require__(3873);
__webpack_require__(630);
__webpack_require__(1011);
__webpack_require__(7010);
var unsupportedIterableToArray = __webpack_require__(3246);
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3665:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(9572);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3511:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(8070);
__webpack_require__(3510);
__webpack_require__(2432);
__webpack_require__(1875);
__webpack_require__(3873);
__webpack_require__(630);
__webpack_require__(1011);
__webpack_require__(7010);
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(8070);
__webpack_require__(3510);
__webpack_require__(2432);
__webpack_require__(3873);
__webpack_require__(9375);
__webpack_require__(630);
__webpack_require__(1011);
__webpack_require__(7010);
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(7107);
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 9201:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(7107);
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(8070);
__webpack_require__(5305);
__webpack_require__(9375);
__webpack_require__(7678);
__webpack_require__(1909);
__webpack_require__(8291);
__webpack_require__(630);
__webpack_require__(1045);
__webpack_require__(163);
__webpack_require__(5350);
__webpack_require__(8867);
var defineProperty = __webpack_require__(3665);
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(8070);
__webpack_require__(3510);
__webpack_require__(4007);
__webpack_require__(2432);
__webpack_require__(9392);
__webpack_require__(7107);
__webpack_require__(3873);
__webpack_require__(9375);
__webpack_require__(6569);
__webpack_require__(3277);
__webpack_require__(8794);
__webpack_require__(1806);
__webpack_require__(2380);
__webpack_require__(7265);
__webpack_require__(1280);
__webpack_require__(630);
__webpack_require__(865);
__webpack_require__(1011);
__webpack_require__(1045);
__webpack_require__(5350);
__webpack_require__(8867);
__webpack_require__(7010);
var _typeof = (__webpack_require__(6446)["default"]);
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(4935);
var iterableToArrayLimit = __webpack_require__(4528);
var unsupportedIterableToArray = __webpack_require__(3246);
var nonIterableRest = __webpack_require__(8972);
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4728:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(2969);
var iterableToArray = __webpack_require__(3511);
var unsupportedIterableToArray = __webpack_require__(3246);
var nonIterableSpread = __webpack_require__(9201);
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 5265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(5307);
__webpack_require__(7107);
__webpack_require__(595);
__webpack_require__(3185);
var _typeof = (__webpack_require__(6446)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 9572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(6446)["default"]);
var toPrimitive = __webpack_require__(5265);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(8070);
__webpack_require__(3510);
__webpack_require__(2432);
__webpack_require__(3873);
__webpack_require__(630);
__webpack_require__(1011);
__webpack_require__(7010);
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(1875);
__webpack_require__(6569);
__webpack_require__(3277);
__webpack_require__(630);
__webpack_require__(8376);
__webpack_require__(6929);
__webpack_require__(568);
__webpack_require__(1011);
var arrayLikeToArray = __webpack_require__(5779);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6029:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"","placeholder_name":"","placeholder_nameOnly":"","placeholder_password":"","registration_link":""}},"seoFooterLinks":{"nav":{"about":"","accessibility":"","agb":"","contact":"","glossary":"","home":"","impressum":"","jobs":"","partner":"","privacy":"","sitemap":"","withdrawal":""}},"seoNaviLinks":{"login":{"registration":""},"tabNavigation":{"community":"","games":"","home":"","infoAndHelp":"","myGameduell":""}},"tpl":{"footer":{"accessibility":"","copyright":"","flags_at":"","flags_de":"","flags_dk":"","flags_en":"","flags_es":"","flags_es_US":"","flags_fr":"","flags_gb":"","flags_nl":"","flags_sv":"","link_about":"","link_accessibility":"","link_agb":"","link_contact":"","link_glossary":"","link_home":"","link_impressum":"","link_jobs":"","link_mobile":"","link_partner":"","link_privacy":"","link_sitemap":"","link_withdrawal":""},"header":{"copartner":""},"navigationTabs":{"community":"","games":"","home":"","infoAndHelp":"","myGameduell":""}}}');

/***/ }),

/***/ 8917:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"Login","placeholder_name":"Spillernavn eller e-mail adresse","placeholder_nameOnly":"Spillernavn","placeholder_password":"Kodeord","registration_link":"Er du ny her? Prøv gratis!"}},"seoFooterLinks":{"nav":{"about":"https://inside.gameduell.com/#about","accessibility":"/gd/help/accessibility.xhtml","agb":"/gd/hjalp/forretningsvilkar.html","contact":"/gd/kontakt.html","glossary":"/gd/game-info.html","home":"/gd/","impressum":"/gd/hjalp/impressum.html","jobs":"https://inside.gameduell.com/#jobs","partner":"/gd/hjalp/partner.html","privacy":"/gd/hjalp/databeskyttelse.html","sitemap":"/gd/sitemap.html","withdrawal":"/gd/help/withdrawal.xhtml"}},"seoNaviLinks":{"login":{"registration":"/indmeldelse.html"},"tabNavigation":{"community":"/gd/community.html","games":"/gd/spil.html","home":"/gd/","infoAndHelp":"/gd/hjalp.html","myGameduell":"/gd/myGameDuell/playerInfo.xhtml"}},"tpl":{"footer":{"accessibility":"Accessibility","copyright":"© GameDuell 2003-{year}","flags_at":"Österreich","flags_de":"Deutschland","flags_dk":"Danmark","flags_en":"USA","flags_es":"España","flags_es_US":"GameDuell en Español","flags_fr":"France","flags_gb":"UK","flags_nl":"Nederland","flags_sv":"Sverige","link_about":"Om GameDuell","link_accessibility":"Accessibility","link_agb":"Generelle vilkår","link_contact":"Kundeservice","link_glossary":"Game Glossary","link_home":"Hjem","link_impressum":"Aftryk","link_jobs":"Jobs","link_mobile":"mobile version","link_partner":"Partner","link_privacy":"Databeskyttelse","link_sitemap":"Sitemap","link_withdrawal":"Udbetaling"},"header":{"copartner":"presented by"},"navigationTabs":{"community":"Community","games":"Spil","home":"Hjem","infoAndHelp":"Info & Hjælp","myGameduell":"Mit GameDuell"}}}');

/***/ }),

/***/ 6657:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"Einloggen","placeholder_name":"Spielername oder E-Mail-Adresse","placeholder_nameOnly":"Spielername","placeholder_password":"Passwort","registration_link":"Neu hier? Gratis testen!"}},"seoFooterLinks":{"nav":{"about":"https://inside.gameduell.com/#about","accessibility":"/gd/help/accessibility.xhtml","agb":"/gd/hilfe/agb.html","contact":"/gd/kontakt.html","glossary":"/gd/spiele-infos.html","home":"/gd/","impressum":"/gd/hilfe/impressum.html","jobs":"https://inside.gameduell.com/#jobs","partner":"/gd/hilfe/partner.html","privacy":"/gd/hilfe/datenschutz.html","sitemap":"/gd/sitemap.html","withdrawal":"/gd/help/withdrawal.xhtml"}},"seoNaviLinks":{"login":{"registration":"/anmeldung.html"},"tabNavigation":{"community":"/gd/community.html","games":"/gd/spiele.html","home":"/gd/","infoAndHelp":"/gd/hilfe.html","myGameduell":"/gd/mein-konto.html"}},"tpl":{"footer":{"accessibility":"Barrierefreiheit","copyright":"© GameDuell 2003-{year}","flags_at":"Österreich","flags_de":"Deutschland","flags_dk":"Danmark","flags_en":"USA","flags_es":"España","flags_es_US":"GameDuell en Español","flags_fr":"France","flags_gb":"UK","flags_nl":"Nederland","flags_sv":"Sverige","link_about":"Über GameDuell","link_accessibility":"Barrierefreiheit","link_agb":"AGB","link_contact":"Kundenservice","link_glossary":"Spiele-Glossar","link_home":"Home","link_impressum":"Impressum","link_jobs":"Jobs","link_mobile":"Mobile Version","link_partner":"Partner","link_privacy":"Datenschutz","link_sitemap":"Sitemap","link_withdrawal":"Widerrufsrecht"},"header":{"copartner":"präsentiert von"},"navigationTabs":{"community":"Community","games":"Spielen","home":"Home","infoAndHelp":"Info & Hilfe","myGameduell":"Mein GameDuell"}}}');

/***/ }),

/***/ 9789:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"Login","placeholder_name":"Username or email address","placeholder_nameOnly":"Username","placeholder_password":"Password","registration_link":"New here? Test for free!"}},"seoFooterLinks":{"nav":{"about":"https://inside.gameduell.com/#about","accessibility":"/gd/help/accessibility.xhtml","agb":"/gd/help/terms-and-conditions.html","contact":"/gd/contact.html","glossary":"/gd/game-info.html","home":"/gd/","impressum":"/gd/help/company-info.html","jobs":"https://inside.gameduell.com/#jobs","partner":"/gd/help/partner.html","privacy":"/gd/help/privacy.html","sitemap":"/gd/sitemap.html","withdrawal":"/gd/help/withdrawal.xhtml"}},"seoNaviLinks":{"login":{"registration":"/registration.html"},"tabNavigation":{"community":"/gd/community.html","games":"/gd/games.html","home":"/gd/","infoAndHelp":"/gd/help.html","myGameduell":"/gd/my-gameduell.html"}},"tpl":{"footer":{"accessibility":"Accessibility","copyright":"© GameDuell 2003-{year}","flags_at":"Österreich","flags_de":"Deutschland","flags_dk":"Danmark","flags_en":"USA","flags_es":"España","flags_es_US":"GameDuell en Español","flags_fr":"France","flags_gb":"UK","flags_nl":"Nederland","flags_sv":"Sverige","link_about":"About GameDuell","link_accessibility":"Accessibility","link_agb":"Terms and Conditions","link_contact":"Customer Service","link_glossary":"Game Glossary","link_home":"Home","link_impressum":"Company Info","link_jobs":"Jobs","link_mobile":"mobile version","link_partner":"Partner","link_privacy":"Privacy Policy","link_sitemap":"Sitemap","link_withdrawal":"Right of Withdrawal"},"header":{"copartner":"presented by"},"navigationTabs":{"community":"Community","games":"Games","home":"Home","infoAndHelp":"Info & Help","myGameduell":"My GameDuell"}}}');

/***/ }),

/***/ 1445:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"Login","placeholder_name":"Username or email address","placeholder_nameOnly":"Username","placeholder_password":"Password","registration_link":"New here? Test for free!"}},"seoFooterLinks":{"nav":{"about":"https://inside.gameduell.com/#about","accessibility":"/gd/help/accessibility.xhtml","agb":"/gd/help/terms-and-conditions.html","contact":"/gd/contact.html","glossary":"/gd/game-info.html","home":"/gd/","impressum":"/gd/help/company-info.html","jobs":"https://inside.gameduell.com/#jobs","partner":"/gd/help/partner.html","privacy":"/gd/help/privacy.html","sitemap":"/gd/sitemap.html","withdrawal":"/gd/help/withdrawal.xhtml"}},"seoNaviLinks":{"login":{"registration":"/registration.html"},"tabNavigation":{"community":"/gd/community.html","games":"/gd/games.html","home":"/gd/","infoAndHelp":"/gd/help.html","myGameduell":"/gd/my-gameduell.html"}},"tpl":{"footer":{"accessibility":"Accessibility","copyright":"© GameDuell 2003-{year}","flags_at":"Österreich","flags_de":"Deutschland","flags_dk":"Danmark","flags_en":"USA","flags_es":"España","flags_es_US":"GameDuell en Español","flags_fr":"France","flags_gb":"UK","flags_nl":"Nederland","flags_sv":"Sverige","link_about":"About GameDuell","link_accessibility":"Accessibility","link_agb":"Terms and Conditions","link_contact":"Customer Service","link_glossary":"Game Glossary","link_home":"Home","link_impressum":"Company Info","link_jobs":"Jobs","link_mobile":"mobile version","link_partner":"Partner","link_privacy":"Privacy Policy","link_sitemap":"Sitemap","link_withdrawal":"Right of Withdrawal"},"header":{"copartner":"presented by"},"navigationTabs":{"community":"Community","games":"Games","home":"Home","infoAndHelp":"Info & Help","myGameduell":"My GameDuell"}}}');

/***/ }),

/***/ 5246:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"Inicio","placeholder_name":"Nombre de jugador o e-mail","placeholder_nameOnly":"Nombre de jugador","placeholder_password":"Contraseña","registration_link":"¿Nuevo? Prueba gratis"}},"seoFooterLinks":{"nav":{"about":"https://inside.gameduell.com/#about","accessibility":"/gd/help/accessibility.xhtml","agb":"/gd/es/ayuda/tcg.html","contact":"/gd/es/contacto.html","glossary":"/gd/game-info.html","home":"/gd/","impressum":"/gd/es/ayuda/impreso.html","jobs":"https://inside.gameduell.com/#jobs","partner":"/gd/es/ayuda/socios.html","privacy":"/gd/es/ayuda/proteccion-de-datos.html","sitemap":"/gd/es/indice.html","withdrawal":"/gd/help/withdrawal.xhtml"}},"seoNaviLinks":{"login":{"registration":"/es/registro.html"},"tabNavigation":{"community":"/gd/es/comunidad.html","games":"/gd/es/juegos.html","home":"/gd/","infoAndHelp":"/gd/es/ayuda/resumen.html","myGameduell":"/gd/myGameDuell/playerInfo.xhtml"}},"tpl":{"footer":{"accessibility":"Accessibility","copyright":"© GameDuell 2003-{year}","flags_at":"Österreich","flags_de":"Deutschland","flags_dk":"Danmark","flags_en":"USA","flags_es":"España","flags_es_US":"GameDuell en Español","flags_fr":"France","flags_gb":"UK","flags_nl":"Nederland","flags_sv":"Sverige","link_about":"Sobre GameDuell","link_accessibility":"Accessibility","link_agb":"TCG","link_contact":"Servicio al cliente","link_glossary":"Game Glossary","link_home":"Inicio","link_impressum":"Registro","link_jobs":"Empleo","link_mobile":"mobile version","link_partner":"Socios","link_privacy":"Protección de datos","link_sitemap":"Índice","link_withdrawal":"Reintegros"},"header":{"copartner":"presented by"},"navigationTabs":{"community":"Comunidad","games":"Jugar","home":"Inicio","infoAndHelp":"Info y ayuda","myGameduell":"Mi GameDuell"}}}');

/***/ }),

/***/ 8214:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"Connexion","placeholder_name":"Nom de joueur ou adresse e-mail","placeholder_nameOnly":"Nom de joueur","placeholder_password":"Mot de passe","registration_link":"Nouveau ? Testez gratuitement !"}},"seoFooterLinks":{"nav":{"about":"https://inside.gameduell.com/#about","accessibility":"/gd/help/accessibility.xhtml","agb":"/gd/aide/cgv.html","contact":"/gd/contact.html","glossary":"/gd/lexique-des-jeux.html","home":"/gd/","impressum":"/gd/aide/infos-legales.html","jobs":"https://inside.gameduell.com/#jobs","partner":"/gd/aide/partenariat.html","privacy":"/gd/aide/protection-des-donnees.html","sitemap":"/gd/sitemap.html","withdrawal":"/gd/help/withdrawal.xhtml"}},"seoNaviLinks":{"login":{"registration":"/enregistrement.html"},"tabNavigation":{"community":"/gd/communaute.html","games":"/gd/jeux.html","home":"/gd/","infoAndHelp":"/gd/aide.html","myGameduell":"/gd/myGameDuell/playerInfo.xhtml"}},"tpl":{"footer":{"accessibility":"Accessibility","copyright":"© GameDuell 2003-{year}","flags_at":"Österreich","flags_de":"Deutschland","flags_dk":"Danmark","flags_en":"USA","flags_es":"España","flags_es_US":"GameDuell en Español","flags_fr":"France","flags_gb":"UK","flags_nl":"Nederland","flags_sv":"Sverige","link_about":"À propos de GameDuell","link_accessibility":"Accessibility","link_agb":"CGV","link_contact":"Service clients","link_glossary":"Lexique des jeux","link_home":"Accueil","link_impressum":"Infos légales","link_jobs":"Emploi","link_mobile":"Version mobile","link_partner":"Partenariat","link_privacy":"Charte vie privée","link_sitemap":"Plan du site","link_withdrawal":"Droit de rétractation"},"header":{"copartner":"en partenariat avec"},"navigationTabs":{"community":"Communauté","games":"Jouer","home":"Accueil","infoAndHelp":"Info & Aide","myGameduell":"Mon GameDuell"}}}');

/***/ }),

/***/ 4312:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"Login","placeholder_name":"Spelernaam of e-mailadres","placeholder_nameOnly":"Spelernaam","placeholder_password":"Wachtwoord","registration_link":"Nieuw hier? Gratis testen!"}},"seoFooterLinks":{"nav":{"about":"https://inside.gameduell.com/#about","accessibility":"/gd/help/accessibility.xhtml","agb":"/gd/hulp/abv.html","contact":"/gd/contact.html","glossary":"/gd/spellen-informatie.html","home":"/gd/","impressum":"/gd/hulp/impressum.html","jobs":"https://inside.gameduell.com/#jobs","partner":"/gd/hulp/partner.html","privacy":"/gd/hulp/gegevensbescherming.html","sitemap":"/gd/sitemap.html","withdrawal":"/gd/help/withdrawal.xhtml"}},"seoNaviLinks":{"login":{"registration":"/aanmelding.html"},"tabNavigation":{"community":"/gd/community.html","games":"/gd/spellen.html","home":"/gd/","infoAndHelp":"/gd/hulp.html","myGameduell":"/gd/myGameDuell/playerInfo.xhtml"}},"tpl":{"footer":{"accessibility":"Accessibility","copyright":"© GameDuell 2003-{year}","flags_at":"Österreich","flags_de":"Deutschland","flags_dk":"Danmark","flags_en":"USA","flags_es":"España","flags_es_US":"GameDuell en Español","flags_fr":"France","flags_gb":"UK","flags_nl":"Nederland","flags_sv":"Sverige","link_about":"Over GameDuell","link_accessibility":"Accessibility","link_agb":"ABV","link_contact":"Klantenservice","link_glossary":"Spellen informatie","link_home":"Home","link_impressum":"Impressum","link_jobs":"Banen","link_mobile":"mobiele versie","link_partner":"Partner","link_privacy":"Gegevensbescherming","link_sitemap":"Sitemap","link_withdrawal":"Recht op annulering"},"header":{"copartner":"presented by"},"navigationTabs":{"community":"Community","games":"Spelen","home":"Home","infoAndHelp":"Info & Help","myGameduell":"Mijn GameDuell"}}}');

/***/ }),

/***/ 4207:
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"login":{"main":{"button":"Logga in","placeholder_name":"Spelarnamn eller email-adress","placeholder_nameOnly":"Spelarnamn","placeholder_password":"Lösenord","registration_link":"Ny här? Testa gratis!"}},"seoFooterLinks":{"nav":{"about":"https://inside.gameduell.com/#about","accessibility":"/gd/help/accessibility.xhtml","agb":"/gd/hjalp/avtalsvillkor.html","contact":"/gd/kontakt.html","glossary":"/gd/game-info.html","home":"/gd/","impressum":"/gd/hjalp/impressum.html","jobs":"https://inside.gameduell.com/#jobs","partner":"/gd/hjalp/partner.html","privacy":"/gd/hjalp/integritetspolicy.html","sitemap":"/gd/sajtkarta.html","withdrawal":"/gd/help/withdrawal.xhtml"}},"seoNaviLinks":{"login":{"registration":"/registrering.html"},"tabNavigation":{"community":"/gd/community.html","games":"/gd/spela.html","home":"/gd/","infoAndHelp":"/gd/hjalp.html","myGameduell":"/gd/myGameDuell/playerInfo.xhtml"}},"tpl":{"footer":{"accessibility":"Accessibility","copyright":"© GameDuell 2003-{year}","flags_at":"Österreich","flags_de":"Deutschland","flags_dk":"Danmark","flags_en":"USA","flags_es":"España","flags_es_US":"GameDuell en Español","flags_fr":"France","flags_gb":"UK","flags_nl":"Nederland","flags_sv":"Sverige","link_about":"Om GameDuell","link_accessibility":"Accessibility","link_agb":"Avtalsvillkor","link_contact":"Kundtjänst","link_glossary":"Game Glossary","link_home":"Hem","link_impressum":"Avtryck","link_jobs":"Jobb","link_mobile":"mobile version","link_partner":"Partner","link_privacy":"Integritetspolicy","link_sitemap":"Sajtkarta","link_withdrawal":"Återkallande"},"header":{"copartner":"presented by"},"navigationTabs":{"community":"Community","games":"Spela","home":"Hem","infoAndHelp":"Info & Hjälp","myGameduell":"Mitt GameDuell"}}}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  GdFooter: function() { return /* reexport */ entry_lib_no_default_GdFooter; },
  GdFooterLoggedOut: function() { return /* reexport */ entry_lib_no_default_GdFooterLoggedOut; },
  GdHeader: function() { return /* reexport */ entry_lib_no_default_GdHeader; },
  GdLogin: function() { return /* reexport */ entry_lib_no_default_GdLogin; },
  GdNavigationTabs: function() { return /* reexport */ entry_lib_no_default_GdNavigationTabs; },
  GdNavigationTabsLoggedOut: function() { return /* reexport */ entry_lib_no_default_GdNavigationTabsLoggedOut; },
  GdTemplate: function() { return /* reexport */ entry_lib_no_default_GdTemplate; }
});

;// ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var entry_lib_no_default_currentScript = window.document.currentScript
  if (true) {
    var entry_lib_no_default_getCurrentScript = __webpack_require__(904)
    entry_lib_no_default_currentScript = entry_lib_no_default_getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: entry_lib_no_default_getCurrentScript })
    }
  }

  var entry_lib_no_default_src = entry_lib_no_default_currentScript && entry_lib_no_default_currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (entry_lib_no_default_src) {
    __webpack_require__.p = entry_lib_no_default_src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var entry_lib_no_default_setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/url-search-params-polyfill/index.js
var entry_lib_no_default_url_search_params_polyfill = __webpack_require__(8318);
;// ../../node_modules/whatwg-fetch/fetch.js
/* eslint-disable no-prototype-builtins */
var entry_lib_no_default_g =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  // eslint-disable-next-line no-undef
  (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g) ||
  {}

var entry_lib_no_default_support = {
  searchParams: 'URLSearchParams' in entry_lib_no_default_g,
  iterable: 'Symbol' in entry_lib_no_default_g && 'iterator' in Symbol,
  blob:
    'FileReader' in entry_lib_no_default_g &&
    'Blob' in entry_lib_no_default_g &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in entry_lib_no_default_g,
  arrayBuffer: 'ArrayBuffer' in entry_lib_no_default_g
}

function entry_lib_no_default_isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (entry_lib_no_default_support.arrayBuffer) {
  var entry_lib_no_default_viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var entry_lib_no_default_isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && entry_lib_no_default_viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function entry_lib_no_default_normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function entry_lib_no_default_normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function entry_lib_no_default_iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (entry_lib_no_default_support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function entry_lib_no_default_Headers(headers) {
  this.map = {}

  if (headers instanceof entry_lib_no_default_Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      if (header.length != 2) {
        throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
      }
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

entry_lib_no_default_Headers.prototype.append = function(name, value) {
  name = entry_lib_no_default_normalizeName(name)
  value = entry_lib_no_default_normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

entry_lib_no_default_Headers.prototype['delete'] = function(name) {
  delete this.map[entry_lib_no_default_normalizeName(name)]
}

entry_lib_no_default_Headers.prototype.get = function(name) {
  name = entry_lib_no_default_normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

entry_lib_no_default_Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(entry_lib_no_default_normalizeName(name))
}

entry_lib_no_default_Headers.prototype.set = function(name, value) {
  this.map[entry_lib_no_default_normalizeName(name)] = entry_lib_no_default_normalizeValue(value)
}

entry_lib_no_default_Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

entry_lib_no_default_Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return entry_lib_no_default_iteratorFor(items)
}

entry_lib_no_default_Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return entry_lib_no_default_iteratorFor(items)
}

entry_lib_no_default_Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return entry_lib_no_default_iteratorFor(items)
}

if (entry_lib_no_default_support.iterable) {
  entry_lib_no_default_Headers.prototype[Symbol.iterator] = entry_lib_no_default_Headers.prototype.entries
}

function entry_lib_no_default_consumed(body) {
  if (body._noBody) return
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function entry_lib_no_default_fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function entry_lib_no_default_readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = entry_lib_no_default_fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function entry_lib_no_default_readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = entry_lib_no_default_fileReaderReady(reader)
  var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type)
  var encoding = match ? match[1] : 'utf-8'
  reader.readAsText(blob, encoding)
  return promise
}

function entry_lib_no_default_readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function entry_lib_no_default_bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function entry_lib_no_default_Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    // eslint-disable-next-line no-self-assign
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._noBody = true;
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (entry_lib_no_default_support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (entry_lib_no_default_support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (entry_lib_no_default_support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (entry_lib_no_default_support.arrayBuffer && entry_lib_no_default_support.blob && entry_lib_no_default_isDataView(body)) {
      this._bodyArrayBuffer = entry_lib_no_default_bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (entry_lib_no_default_support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || entry_lib_no_default_isArrayBufferView(body))) {
      this._bodyArrayBuffer = entry_lib_no_default_bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (entry_lib_no_default_support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (entry_lib_no_default_support.blob) {
    this.blob = function() {
      var rejected = entry_lib_no_default_consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }
  }

  this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var isConsumed = entry_lib_no_default_consumed(this)
      if (isConsumed) {
        return isConsumed
      } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
        return Promise.resolve(
          this._bodyArrayBuffer.buffer.slice(
            this._bodyArrayBuffer.byteOffset,
            this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
          )
        )
      } else {
        return Promise.resolve(this._bodyArrayBuffer)
      }
    } else if (entry_lib_no_default_support.blob) {
      return this.blob().then(entry_lib_no_default_readBlobAsArrayBuffer)
    } else {
      throw new Error('could not read as ArrayBuffer')
    }
  }

  this.text = function() {
    var rejected = entry_lib_no_default_consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return entry_lib_no_default_readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(entry_lib_no_default_readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (entry_lib_no_default_support.formData) {
    this.formData = function() {
      return this.text().then(entry_lib_no_default_decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var entry_lib_no_default_methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE']

function entry_lib_no_default_normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return entry_lib_no_default_methods.indexOf(upcased) > -1 ? upcased : method
}

function entry_lib_no_default_Request(input, options) {
  if (!(this instanceof entry_lib_no_default_Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof entry_lib_no_default_Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new entry_lib_no_default_Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new entry_lib_no_default_Headers(options.headers)
  }
  this.method = entry_lib_no_default_normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal || (function () {
    if ('AbortController' in entry_lib_no_default_g) {
      var ctrl = new AbortController();
      return ctrl.signal;
    }
  }());
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

entry_lib_no_default_Request.prototype.clone = function() {
  return new entry_lib_no_default_Request(this, {body: this._bodyInit})
}

function entry_lib_no_default_decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function entry_lib_no_default_parseHeaders(rawHeaders) {
  var headers = new entry_lib_no_default_Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        try {
          headers.append(key, value)
        } catch (error) {
          console.warn('Response ' + error.message)
        }
      }
    })
  return headers
}

entry_lib_no_default_Body.call(entry_lib_no_default_Request.prototype)

function entry_lib_no_default_Response(bodyInit, options) {
  if (!(this instanceof entry_lib_no_default_Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  if (this.status < 200 || this.status > 599) {
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
  }
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
  this.headers = new entry_lib_no_default_Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

entry_lib_no_default_Body.call(entry_lib_no_default_Response.prototype)

entry_lib_no_default_Response.prototype.clone = function() {
  return new entry_lib_no_default_Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new entry_lib_no_default_Headers(this.headers),
    url: this.url
  })
}

entry_lib_no_default_Response.error = function() {
  var response = new entry_lib_no_default_Response(null, {status: 200, statusText: ''})
  response.ok = false
  response.status = 0
  response.type = 'error'
  return response
}

var entry_lib_no_default_redirectStatuses = [301, 302, 303, 307, 308]

entry_lib_no_default_Response.redirect = function(url, status) {
  if (entry_lib_no_default_redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new entry_lib_no_default_Response(null, {status: status, headers: {location: url}})
}

var entry_lib_no_default_DOMException = entry_lib_no_default_g.DOMException
try {
  new entry_lib_no_default_DOMException()
} catch (err) {
  entry_lib_no_default_DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  entry_lib_no_default_DOMException.prototype = Object.create(Error.prototype)
  entry_lib_no_default_DOMException.prototype.constructor = entry_lib_no_default_DOMException
}

function entry_lib_no_default_fetch_fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new entry_lib_no_default_Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new entry_lib_no_default_DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        statusText: xhr.statusText,
        headers: entry_lib_no_default_parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      // This check if specifically for when a user fetches a file locally from the file system
      // Only if the status is out of a normal range
      if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
        options.status = 200;
      } else {
        options.status = xhr.status;
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new entry_lib_no_default_Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request timed out'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new entry_lib_no_default_DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && entry_lib_no_default_g.location.href ? entry_lib_no_default_g.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (entry_lib_no_default_support.blob) {
        xhr.responseType = 'blob'
      } else if (
        entry_lib_no_default_support.arrayBuffer
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof entry_lib_no_default_Headers || (entry_lib_no_default_g.Headers && init.headers instanceof entry_lib_no_default_g.Headers))) {
      var names = [];
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        names.push(entry_lib_no_default_normalizeName(name))
        xhr.setRequestHeader(name, entry_lib_no_default_normalizeValue(init.headers[name]))
      })
      request.headers.forEach(function(value, name) {
        if (names.indexOf(name) === -1) {
          xhr.setRequestHeader(name, value)
        }
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

entry_lib_no_default_fetch_fetch.polyfill = true

if (!entry_lib_no_default_g.fetch) {
  entry_lib_no_default_g.fetch = entry_lib_no_default_fetch_fetch
  entry_lib_no_default_g.Headers = entry_lib_no_default_Headers
  entry_lib_no_default_g.Request = entry_lib_no_default_Request
  entry_lib_no_default_g.Response = entry_lib_no_default_Response
}

// EXTERNAL MODULE: ../../node_modules/abortcontroller-polyfill/dist/polyfill-patch-fetch.js
var entry_lib_no_default_polyfill_patch_fetch = __webpack_require__(3076);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.includes.js
var entry_lib_no_default_es_array_includes = __webpack_require__(2234);
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(4100);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.symbol.js
var entry_lib_no_default_es_symbol = __webpack_require__(8070);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.symbol.description.js
var entry_lib_no_default_es_symbol_description = __webpack_require__(3510);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.symbol.iterator.js
var entry_lib_no_default_es_symbol_iterator = __webpack_require__(2432);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.iterator.js
var entry_lib_no_default_es_array_iterator = __webpack_require__(3873);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.to-string.js
var entry_lib_no_default_es_object_to_string = __webpack_require__(630);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.string.iterator.js
var entry_lib_no_default_es_string_iterator = __webpack_require__(1011);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.dom-collections.iterator.js
var entry_lib_no_default_web_dom_collections_iterator = __webpack_require__(7010);
;// ../../node_modules/@babel/runtime/helpers/esm/typeof.js







function entry_lib_no_default_typeof(o) {
  "@babel/helpers - typeof";

  return entry_lib_no_default_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, entry_lib_no_default_typeof(o);
}

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.symbol.to-primitive.js
var entry_lib_no_default_es_symbol_to_primitive = __webpack_require__(5307);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var entry_lib_no_default_es_error_cause = __webpack_require__(7107);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.date.to-primitive.js
var entry_lib_no_default_es_date_to_primitive = __webpack_require__(595);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.number.constructor.js
var entry_lib_no_default_es_number_constructor = __webpack_require__(3185);
;// ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js





function entry_lib_no_default_toPrimitive(t, r) {
  if ("object" != entry_lib_no_default_typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != entry_lib_no_default_typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function entry_lib_no_default_toPropertyKey(t) {
  var i = entry_lib_no_default_toPrimitive(t, "string");
  return "symbol" == entry_lib_no_default_typeof(i) ? i : i + "";
}

;// ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js

function entry_lib_no_default_defineProperty(e, r, t) {
  return (r = entry_lib_no_default_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.keys.js
var entry_lib_no_default_es_object_keys = __webpack_require__(8291);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.regexp.exec.js
var entry_lib_no_default_es_regexp_exec = __webpack_require__(8376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.string.match.js
var entry_lib_no_default_es_string_match = __webpack_require__(9428);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var entry_lib_no_default_esnext_iterator_constructor = __webpack_require__(1045);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var entry_lib_no_default_esnext_iterator_for_each = __webpack_require__(5350);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.dom-collections.for-each.js
var entry_lib_no_default_web_dom_collections_for_each = __webpack_require__(8867);
;// ../../libs/i18n/node_modules/@intlify/shared/dist/shared.mjs
/*!
  * shared v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
/**
 * Original Utilities
 * written by kazuya kawaguchi
 */
const entry_lib_no_default_inBrowser = typeof window !== 'undefined';
let entry_lib_no_default_mark;
let entry_lib_no_default_measure;
if ((false)) {}
const entry_lib_no_default_RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */
function entry_lib_no_default_shared_format(message, ...args) {
    if (args.length === 1 && entry_lib_no_default_shared_isObject(args[0])) {
        args = args[0];
    }
    if (!args || !args.hasOwnProperty) {
        args = {};
    }
    return message.replace(entry_lib_no_default_RE_ARGS, (match, identifier) => {
        return args.hasOwnProperty(identifier) ? args[identifier] : '';
    });
}
const entry_lib_no_default_shared_makeSymbol = (name, shareable = false) => !shareable ? Symbol(name) : Symbol.for(name);
const entry_lib_no_default_generateFormatCacheKey = (locale, key, source) => entry_lib_no_default_friendlyJSONstringify({ l: locale, k: key, s: source });
const entry_lib_no_default_friendlyJSONstringify = (json) => JSON.stringify(json)
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
    .replace(/\u0027/g, '\\u0027');
const entry_lib_no_default_isNumber = (val) => typeof val === 'number' && isFinite(val);
const entry_lib_no_default_isDate = (val) => entry_lib_no_default_toTypeString(val) === '[object Date]';
const entry_lib_no_default_isRegExp = (val) => entry_lib_no_default_toTypeString(val) === '[object RegExp]';
const entry_lib_no_default_isEmptyObject = (val) => entry_lib_no_default_isPlainObject(val) && Object.keys(val).length === 0;
const entry_lib_no_default_shared_assign = Object.assign;
const entry_lib_no_default_create = Object.create;
const entry_lib_no_default_shared_create = (obj = null) => entry_lib_no_default_create(obj);
let entry_lib_no_default_globalThis;
const entry_lib_no_default_getGlobalThis = () => {
    // prettier-ignore
    return (entry_lib_no_default_globalThis ||
        (entry_lib_no_default_globalThis =
            typeof globalThis !== 'undefined'
                ? globalThis
                : typeof self !== 'undefined'
                    ? self
                    : typeof window !== 'undefined'
                        ? window
                        : typeof global !== 'undefined'
                            ? global
                            : entry_lib_no_default_shared_create()));
};
function entry_lib_no_default_escapeHtml(rawText) {
    return rawText
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}
const entry_lib_no_default_shared_hasOwnProperty = Object.prototype.hasOwnProperty;
function entry_lib_no_default_hasOwn(obj, key) {
    return entry_lib_no_default_shared_hasOwnProperty.call(obj, key);
}
/* eslint-enable */
/**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */
const entry_lib_no_default_shared_isArray = Array.isArray;
const entry_lib_no_default_shared_isFunction = (val) => typeof val === 'function';
const entry_lib_no_default_shared_isString = (val) => typeof val === 'string';
const entry_lib_no_default_shared_isBoolean = (val) => typeof val === 'boolean';
const entry_lib_no_default_isSymbol = (val) => typeof val === 'symbol';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const entry_lib_no_default_shared_isObject = (val) => val !== null && typeof val === 'object';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const entry_lib_no_default_isPromise = (val) => {
    return entry_lib_no_default_shared_isObject(val) && entry_lib_no_default_shared_isFunction(val.then) && entry_lib_no_default_shared_isFunction(val.catch);
};
const entry_lib_no_default_objectToString = Object.prototype.toString;
const entry_lib_no_default_toTypeString = (value) => entry_lib_no_default_objectToString.call(value);
const entry_lib_no_default_isPlainObject = (val) => entry_lib_no_default_toTypeString(val) === '[object Object]';
// for converting list and named values to displayed strings.
const entry_lib_no_default_toDisplayString = (val) => {
    return val == null
        ? ''
        : entry_lib_no_default_shared_isArray(val) || (entry_lib_no_default_isPlainObject(val) && val.toString === entry_lib_no_default_objectToString)
            ? JSON.stringify(val, null, 2)
            : String(val);
};
function entry_lib_no_default_join(items, separator = '') {
    return items.reduce((str, item, index) => (index === 0 ? str + item : str + separator + item), '');
}
const entry_lib_no_default_RANGE = 2;
function entry_lib_no_default_generateCodeFrame(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for (let i = 0; i < lines.length; i++) {
        count += lines[i].length + 1;
        if (count >= start) {
            for (let j = i - entry_lib_no_default_RANGE; j <= i + entry_lib_no_default_RANGE || end > count; j++) {
                if (j < 0 || j >= lines.length)
                    continue;
                const line = j + 1;
                res.push(`${line}${' '.repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + ' '.repeat(pad) + '^'.repeat(length));
                }
                else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + '^'.repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}

function entry_lib_no_default_shared_warn(msg, err) {
    if (typeof console !== 'undefined') {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */
        if (err) {
            console.warn(err.stack);
        }
    }
}
const entry_lib_no_default_hasWarned = {};
function entry_lib_no_default_warnOnce(msg) {
    if (!entry_lib_no_default_hasWarned[msg]) {
        entry_lib_no_default_hasWarned[msg] = true;
        entry_lib_no_default_shared_warn(msg);
    }
}

/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */
/**
 * Create a event emitter
 *
 * @returns An event emitter
 */
function entry_lib_no_default_createEmitter() {
    const events = new Map();
    const emitter = {
        events,
        on(event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) {
                events.set(event, [handler]);
            }
        },
        off(event, handler) {
            const handlers = events.get(event);
            if (handlers) {
                handlers.splice(handlers.indexOf(handler) >>> 0, 1);
            }
        },
        emit(event, payload) {
            (events.get(event) || [])
                .slice()
                .map(handler => handler(payload));
            (events.get('*') || [])
                .slice()
                .map(handler => handler(event, payload));
        }
    };
    return emitter;
}

const entry_lib_no_default_isNotObjectOrIsArray = (val) => !entry_lib_no_default_shared_isObject(val) || entry_lib_no_default_shared_isArray(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function entry_lib_no_default_deepCopy(src, des) {
    // src and des should both be objects, and none of them can be a array
    if (entry_lib_no_default_isNotObjectOrIsArray(src) || entry_lib_no_default_isNotObjectOrIsArray(des)) {
        throw new Error('Invalid value');
    }
    const stack = [{ src, des }];
    while (stack.length) {
        const { src, des } = stack.pop();
        // using `Object.keys` which skips prototype properties
        Object.keys(src).forEach(key => {
            if (key === '__proto__') {
                return;
            }
            // if src[key] is an object/array, set des[key]
            // to empty object/array to prevent setting by reference
            if (entry_lib_no_default_shared_isObject(src[key]) && !entry_lib_no_default_shared_isObject(des[key])) {
                des[key] = Array.isArray(src[key]) ? [] : entry_lib_no_default_shared_create();
            }
            if (entry_lib_no_default_isNotObjectOrIsArray(des[key]) || entry_lib_no_default_isNotObjectOrIsArray(src[key])) {
                // replace with src[key] when:
                // src[key] or des[key] is not an object, or
                // src[key] or des[key] is an array
                des[key] = src[key];
            }
            else {
                // src[key] and des[key] are both objects, merge them
                stack.push({ src: src[key], des: des[key] });
            }
        });
    }
}



;// ../../libs/i18n/node_modules/@intlify/message-compiler/dist/message-compiler.mjs
/*!
  * message-compiler v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */


const entry_lib_no_default_LOCATION_STUB = {
    start: { line: 1, column: 1, offset: 0 },
    end: { line: 1, column: 1, offset: 0 }
};
function entry_lib_no_default_createPosition(line, column, offset) {
    return { line, column, offset };
}
function entry_lib_no_default_createLocation(start, end, source) {
    const loc = { start, end };
    if (source != null) {
        loc.source = source;
    }
    return loc;
}

const entry_lib_no_default_CompileErrorCodes = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // generator error codes
    UNHANDLED_CODEGEN_NODE_TYPE: 15,
    // minifier error codes
    UNHANDLED_MINIFIER_NODE_TYPE: 16
};
// Special value for higher-order compilers to pick up the last code
// to avoid collision of error codes.
// This should always be kept as the last item.
const entry_lib_no_default_COMPILE_ERROR_CODES_EXTEND_POINT = 17;
/** @internal */
const entry_lib_no_default_errorMessages = {
    // tokenizer error messages
    [entry_lib_no_default_CompileErrorCodes.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [entry_lib_no_default_CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [entry_lib_no_default_CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [entry_lib_no_default_CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [entry_lib_no_default_CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [entry_lib_no_default_CompileErrorCodes.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [entry_lib_no_default_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [entry_lib_no_default_CompileErrorCodes.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [entry_lib_no_default_CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [entry_lib_no_default_CompileErrorCodes.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [entry_lib_no_default_CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [entry_lib_no_default_CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [entry_lib_no_default_CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
    // generator error messages
    [entry_lib_no_default_CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
    // minimizer error messages
    [entry_lib_no_default_CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function entry_lib_no_default_createCompileError(code, loc, options = {}) {
    const { domain, messages, args } = options;
    const msg = ( false)
        ? 0
        : code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) {
        error.location = loc;
    }
    error.domain = domain;
    return error;
}
/** @internal */
function entry_lib_no_default_defaultOnError(error) {
    throw error;
}

// eslint-disable-next-line no-useless-escape
const entry_lib_no_default_RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const entry_lib_no_default_message_compiler_detectHtmlTag = (source) => entry_lib_no_default_RE_HTML_TAG.test(source);

const entry_lib_no_default_CHAR_SP = ' ';
const entry_lib_no_default_CHAR_CR = '\r';
const entry_lib_no_default_CHAR_LF = '\n';
const entry_lib_no_default_CHAR_LS = String.fromCharCode(0x2028);
const entry_lib_no_default_CHAR_PS = String.fromCharCode(0x2029);
function entry_lib_no_default_createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index) => _buf[index] === entry_lib_no_default_CHAR_CR && _buf[index + 1] === entry_lib_no_default_CHAR_LF;
    const isLF = (index) => _buf[index] === entry_lib_no_default_CHAR_LF;
    const isPS = (index) => _buf[index] === entry_lib_no_default_CHAR_PS;
    const isLS = (index) => _buf[index] === entry_lib_no_default_CHAR_LS;
    const isLineEnd = (index) => isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = () => _index;
    const line = () => _line;
    const column = () => _column;
    const peekOffset = () => _peekOffset;
    const charAt = (offset) => isCRLF(offset) || isPS(offset) || isLS(offset) ? entry_lib_no_default_CHAR_LF : _buf[offset];
    const currentChar = () => charAt(_index);
    const currentPeek = () => charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) {
            _index++;
        }
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) {
            _peekOffset++;
        }
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        while (target !== _index) {
            next();
        }
        _peekOffset = 0;
    }
    return {
        index,
        line,
        column,
        peekOffset,
        charAt,
        currentChar,
        currentPeek,
        next,
        peek,
        reset,
        resetPeek,
        skipToPeek
    };
}

const entry_lib_no_default_EOF = undefined;
const entry_lib_no_default_DOT = '.';
const entry_lib_no_default_LITERAL_DELIMITER = "'";
const entry_lib_no_default_ERROR_DOMAIN$3 = 'tokenizer';
function entry_lib_no_default_createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = entry_lib_no_default_createScanner(source);
    const currentOffset = () => _scnr.index();
    const currentPosition = () => entry_lib_no_default_createPosition(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 13 /* TokenTypes.EOF */,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 13 /* TokenTypes.EOF */,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ''
    };
    const context = () => _context;
    const { onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = location ? entry_lib_no_default_createLocation(ctx.startLoc, pos) : null;
            const err = entry_lib_no_default_createCompileError(code, loc, {
                domain: entry_lib_no_default_ERROR_DOMAIN$3,
                args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = { type };
        if (location) {
            token.loc = entry_lib_no_default_createLocation(context.startLoc, context.endLoc);
        }
        if (value != null) {
            token.value = value;
        }
        return token;
    }
    const getEndToken = (context) => getToken(context, 13 /* TokenTypes.EOF */);
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        }
        else {
            emitError(entry_lib_no_default_CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return '';
        }
    }
    function peekSpaces(scnr) {
        let buf = '';
        while (scnr.currentPeek() === entry_lib_no_default_CHAR_SP || scnr.currentPeek() === entry_lib_no_default_CHAR_LF) {
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === entry_lib_no_default_EOF) {
            return false;
        }
        const cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90) || // A-Z
            cc === 95 // _
        );
    }
    function isNumberStart(ch) {
        if (ch === entry_lib_no_default_EOF) {
            return false;
        }
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === '-' ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === entry_lib_no_default_LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 7 /* TokenTypes.LinkedAlias */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* TokenChars.LinkedDot */;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 8 /* TokenTypes.LinkedDot */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType } = context;
        if (!(currentType === 7 /* TokenTypes.LinkedAlias */ ||
            currentType === 11 /* TokenTypes.LinkedModifier */)) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* TokenChars.LinkedDelimiter */;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 9 /* TokenTypes.LinkedDelimiter */) {
            return false;
        }
        const fn = () => {
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */) {
                return isIdentifierStart(scnr.peek());
            }
            else if (ch === "@" /* TokenChars.LinkedAlias */ ||
                ch === "|" /* TokenChars.Pipe */ ||
                ch === ":" /* TokenChars.LinkedDelimiter */ ||
                ch === "." /* TokenChars.LinkedDot */ ||
                ch === entry_lib_no_default_CHAR_SP ||
                !ch) {
                return false;
            }
            else if (ch === entry_lib_no_default_CHAR_LF) {
                scnr.peek();
                return fn();
            }
            else {
                // other characters
                return isTextStart(scnr, false);
            }
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* TokenChars.Pipe */;
        scnr.resetPeek();
        return ret;
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = '') => {
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */) {
                return hasSpace;
            }
            else if (ch === "@" /* TokenChars.LinkedAlias */ || !ch) {
                return hasSpace;
            }
            else if (ch === "|" /* TokenChars.Pipe */) {
                return !(prev === entry_lib_no_default_CHAR_SP || prev === entry_lib_no_default_CHAR_LF);
            }
            else if (ch === entry_lib_no_default_CHAR_SP) {
                scnr.peek();
                return fn(true, entry_lib_no_default_CHAR_SP);
            }
            else if (ch === entry_lib_no_default_CHAR_LF) {
                scnr.peek();
                return fn(true, entry_lib_no_default_CHAR_LF);
            }
            else {
                return true;
            }
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === entry_lib_no_default_EOF) {
            return entry_lib_no_default_EOF;
        }
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function isIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90) || // A-Z
            (cc >= 48 && cc <= 57) || // 0-9
            cc === 95 || // _
            cc === 36 // $
        );
    }
    function takeIdentifierChar(scnr) {
        return takeChar(scnr, isIdentifier);
    }
    function isNamedIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90) || // A-Z
            (cc >= 48 && cc <= 57) || // 0-9
            cc === 95 || // _
            cc === 36 || // $
            cc === 45 // -
        );
    }
    function takeNamedIdentifierChar(scnr) {
        return takeChar(scnr, isNamedIdentifier);
    }
    function isDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function takeDigit(scnr) {
        return takeChar(scnr, isDigit);
    }
    function isHexDigit(ch) {
        const cc = ch.charCodeAt(0);
        return ((cc >= 48 && cc <= 57) || // 0-9
            (cc >= 65 && cc <= 70) || // A-F
            (cc >= 97 && cc <= 102)); // a-f
    }
    function takeHexDigit(scnr) {
        return takeChar(scnr, isHexDigit);
    }
    function getDigits(scnr) {
        let ch = '';
        let num = '';
        while ((ch = takeDigit(scnr))) {
            num += ch;
        }
        return num;
    }
    function readText(scnr) {
        let buf = '';
        while (true) {
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */ ||
                ch === "}" /* TokenChars.BraceRight */ ||
                ch === "@" /* TokenChars.LinkedAlias */ ||
                ch === "|" /* TokenChars.Pipe */ ||
                !ch) {
                break;
            }
            else if (ch === entry_lib_no_default_CHAR_SP || ch === entry_lib_no_default_CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                }
                else if (isPluralStart(scnr)) {
                    break;
                }
                else {
                    buf += ch;
                    scnr.next();
                }
            }
            else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let name = '';
        while ((ch = takeNamedIdentifierChar(scnr))) {
            name += ch;
        }
        if (scnr.currentChar() === entry_lib_no_default_EOF) {
            emitError(entry_lib_no_default_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = '';
        if (scnr.currentChar() === '-') {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        }
        else {
            value += getDigits(scnr);
        }
        if (scnr.currentChar() === entry_lib_no_default_EOF) {
            emitError(entry_lib_no_default_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        return value;
    }
    function isLiteral(ch) {
        return ch !== entry_lib_no_default_LITERAL_DELIMITER && ch !== entry_lib_no_default_CHAR_LF;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        let ch = '';
        let literal = '';
        while ((ch = takeChar(scnr, isLiteral))) {
            if (ch === '\\') {
                literal += readEscapeSequence(scnr);
            }
            else {
                literal += ch;
            }
        }
        const current = scnr.currentChar();
        if (current === entry_lib_no_default_CHAR_LF || current === entry_lib_no_default_EOF) {
            emitError(entry_lib_no_default_CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === entry_lib_no_default_CHAR_LF) {
                scnr.next();
                // eslint-disable-next-line no-useless-escape
                eat(scnr, `\'`);
            }
            return literal;
        }
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch (ch) {
            case '\\':
            case `\'`: // eslint-disable-line no-useless-escape
                scnr.next();
                return `\\${ch}`;
            case 'u':
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case 'U':
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError(entry_lib_no_default_CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return '';
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = '';
        for (let i = 0; i < digits; i++) {
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError(entry_lib_no_default_CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function isInvalidIdentifier(ch) {
        return (ch !== "{" /* TokenChars.BraceLeft */ &&
            ch !== "}" /* TokenChars.BraceRight */ &&
            ch !== entry_lib_no_default_CHAR_SP &&
            ch !== entry_lib_no_default_CHAR_LF);
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let identifiers = '';
        while ((ch = takeChar(scnr, isInvalidIdentifier))) {
            identifiers += ch;
        }
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = '';
        let name = '';
        while ((ch = takeIdentifierChar(scnr))) {
            name += ch;
        }
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (buf) => {
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */ ||
                ch === "@" /* TokenChars.LinkedAlias */ ||
                ch === "|" /* TokenChars.Pipe */ ||
                ch === "(" /* TokenChars.ParenLeft */ ||
                ch === ")" /* TokenChars.ParenRight */ ||
                !ch) {
                return buf;
            }
            else if (ch === entry_lib_no_default_CHAR_SP) {
                return buf;
            }
            else if (ch === entry_lib_no_default_CHAR_LF || ch === entry_lib_no_default_DOT) {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
            else {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
        };
        return fn('');
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* TokenChars.Pipe */);
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch (ch) {
            case "{" /* TokenChars.BraceLeft */:
                if (context.braceNest >= 1) {
                    emitError(entry_lib_no_default_CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                }
                scnr.next();
                token = getToken(context, 2 /* TokenTypes.BraceLeft */, "{" /* TokenChars.BraceLeft */);
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* TokenChars.BraceRight */:
                if (context.braceNest > 0 &&
                    context.currentType === 2 /* TokenTypes.BraceLeft */) {
                    emitError(entry_lib_no_default_CompileErrorCodes.EMPTY_PLACEHOLDER, currentPosition(), 0);
                }
                scnr.next();
                token = getToken(context, 3 /* TokenTypes.BraceRight */, "}" /* TokenChars.BraceRight */);
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) {
                    context.inLinked = false;
                }
                return token;
            case "@" /* TokenChars.LinkedAlias */:
                if (context.braceNest > 0) {
                    emitError(entry_lib_no_default_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                }
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default: {
                let validNamedIdentifier = true;
                let validListIdentifier = true;
                let validLiteral = true;
                if (isPluralStart(scnr)) {
                    if (context.braceNest > 0) {
                        emitError(entry_lib_no_default_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    }
                    token = getToken(context, 1 /* TokenTypes.Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (context.braceNest > 0 &&
                    (context.currentType === 4 /* TokenTypes.Named */ ||
                        context.currentType === 5 /* TokenTypes.List */ ||
                        context.currentType === 6 /* TokenTypes.Literal */)) {
                    emitError(entry_lib_no_default_CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    context.braceNest = 0;
                    return readToken(scnr, context);
                }
                if ((validNamedIdentifier = isNamedIdentifierStart(scnr, context))) {
                    token = getToken(context, 4 /* TokenTypes.Named */, readNamedIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if ((validListIdentifier = isListIdentifierStart(scnr, context))) {
                    token = getToken(context, 5 /* TokenTypes.List */, readListIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if ((validLiteral = isLiteralStart(scnr, context))) {
                    token = getToken(context, 6 /* TokenTypes.Literal */, readLiteral(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                    // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                    token = getToken(context, 12 /* TokenTypes.InvalidPlace */, readInvalidIdentifier(scnr));
                    emitError(entry_lib_no_default_CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                    skipSpaces(scnr);
                    return token;
                }
                break;
            }
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 7 /* TokenTypes.LinkedAlias */ ||
            currentType === 8 /* TokenTypes.LinkedDot */ ||
            currentType === 11 /* TokenTypes.LinkedModifier */ ||
            currentType === 9 /* TokenTypes.LinkedDelimiter */) &&
            (ch === entry_lib_no_default_CHAR_LF || ch === entry_lib_no_default_CHAR_SP)) {
            emitError(entry_lib_no_default_CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
        }
        switch (ch) {
            case "@" /* TokenChars.LinkedAlias */:
                scnr.next();
                token = getToken(context, 7 /* TokenTypes.LinkedAlias */, "@" /* TokenChars.LinkedAlias */);
                context.inLinked = true;
                return token;
            case "." /* TokenChars.LinkedDot */:
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 8 /* TokenTypes.LinkedDot */, "." /* TokenChars.LinkedDot */);
            case ":" /* TokenChars.LinkedDelimiter */:
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* TokenTypes.LinkedDelimiter */, ":" /* TokenChars.LinkedDelimiter */);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) ||
                    isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 11 /* TokenTypes.LinkedModifier */, readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* TokenChars.BraceLeft */) {
                        // scan the placeholder
                        return readTokenInPlaceholder(scnr, context) || token;
                    }
                    else {
                        return getToken(context, 10 /* TokenTypes.LinkedKey */, readLinkedRefer(scnr));
                    }
                }
                if (currentType === 7 /* TokenTypes.LinkedAlias */) {
                    emitError(entry_lib_no_default_CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
                }
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = { type: 13 /* TokenTypes.EOF */ };
        if (context.braceNest > 0) {
            return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        }
        if (context.inLinked) {
            return readTokenInLinked(scnr, context) || getEndToken(context);
        }
        const ch = scnr.currentChar();
        switch (ch) {
            case "{" /* TokenChars.BraceLeft */:
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* TokenChars.BraceRight */:
                emitError(entry_lib_no_default_CompileErrorCodes.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* TokenTypes.BraceRight */, "}" /* TokenChars.BraceRight */);
            case "@" /* TokenChars.LinkedAlias */:
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default: {
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isTextStart(scnr)) {
                    return getToken(context, 0 /* TokenTypes.Text */, readText(scnr));
                }
                break;
            }
        }
        return token;
    }
    function nextToken() {
        const { currentType, offset, startLoc, endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === entry_lib_no_default_EOF) {
            return getToken(_context, 13 /* TokenTypes.EOF */);
        }
        return readToken(_scnr, _context);
    }
    return {
        nextToken,
        currentOffset,
        currentPosition,
        context
    };
}

const entry_lib_no_default_ERROR_DOMAIN$2 = 'parser';
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const entry_lib_no_default_KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function entry_lib_no_default_fromEscapeSequence(match, codePoint4, codePoint6) {
    switch (match) {
        case `\\\\`:
            return `\\`;
        // eslint-disable-next-line no-useless-escape
        case `\\\'`:
            // eslint-disable-next-line no-useless-escape
            return `\'`;
        default: {
            const codePoint = parseInt(codePoint4 || codePoint6, 16);
            if (codePoint <= 0xd7ff || codePoint >= 0xe000) {
                return String.fromCodePoint(codePoint);
            }
            // invalid ...
            // Replace them with U+FFFD REPLACEMENT CHARACTER.
            return '�';
        }
    }
}
function entry_lib_no_default_createParser(options = {}) {
    const location = options.location !== false;
    const { onError } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = location ? entry_lib_no_default_createLocation(start, end) : null;
            const err = entry_lib_no_default_createCompileError(code, loc, {
                domain: entry_lib_no_default_ERROR_DOMAIN$2,
                args
            });
            onError(err);
        }
    }
    function startNode(type, offset, loc) {
        const node = { type };
        if (location) {
            node.start = offset;
            node.end = offset;
            node.loc = { start: loc, end: loc };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        if (location) {
            node.end = offset;
            if (node.loc) {
                node.loc.end = pos;
            }
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* NodeTypes.Text */, context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* NodeTypes.List */, offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* NodeTypes.Named */, offset, loc);
        node.key = key;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* NodeTypes.Literal */, offset, loc);
        node.value = value.replace(entry_lib_no_default_KNOWN_ESCAPES, entry_lib_no_default_fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* NodeTypes.LinkedModifier */, offset, loc);
        if (token.type !== 11 /* TokenTypes.LinkedModifier */) {
            // empty modifier
            emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = '';
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node
            };
        }
        // check token
        if (token.value == null) {
            emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
        }
        node.value = token.value || '';
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* NodeTypes.LinkedKey */, context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* NodeTypes.Linked */, context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 8 /* TokenTypes.LinkedDot */) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 9 /* TokenTypes.LinkedDelimiter */) {
            emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
        }
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* TokenTypes.BraceLeft */) {
            token = tokenizer.nextToken();
        }
        switch (token.type) {
            case 10 /* TokenTypes.LinkedKey */:
                if (token.value == null) {
                    emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
                }
                linkedNode.key = parseLinkedKey(tokenizer, token.value || '');
                break;
            case 4 /* TokenTypes.Named */:
                if (token.value == null) {
                    emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
                }
                linkedNode.key = parseNamed(tokenizer, token.value || '');
                break;
            case 5 /* TokenTypes.List */:
                if (token.value == null) {
                    emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
                }
                linkedNode.key = parseList(tokenizer, token.value || '');
                break;
            case 6 /* TokenTypes.Literal */:
                if (token.value == null) {
                    emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
                }
                linkedNode.key = parseLiteral(tokenizer, token.value || '');
                break;
            default: {
                // empty key
                emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                const nextContext = tokenizer.context();
                const emptyLinkedKeyNode = startNode(7 /* NodeTypes.LinkedKey */, nextContext.offset, nextContext.startLoc);
                emptyLinkedKeyNode.value = '';
                endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                linkedNode.key = emptyLinkedKeyNode;
                endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                return {
                    nextConsumeToken: token,
                    node: linkedNode
                };
            }
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* TokenTypes.Pipe */
            ? tokenizer.currentOffset()
            : context.offset;
        const startLoc = context.currentType === 1 /* TokenTypes.Pipe */
            ? context.endLoc
            : context.startLoc;
        const node = startNode(2 /* NodeTypes.Message */, startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch (token.type) {
                case 0 /* TokenTypes.Text */:
                    if (token.value == null) {
                        emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
                    }
                    node.items.push(parseText(tokenizer, token.value || ''));
                    break;
                case 5 /* TokenTypes.List */:
                    if (token.value == null) {
                        emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
                    }
                    node.items.push(parseList(tokenizer, token.value || ''));
                    break;
                case 4 /* TokenTypes.Named */:
                    if (token.value == null) {
                        emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
                    }
                    node.items.push(parseNamed(tokenizer, token.value || ''));
                    break;
                case 6 /* TokenTypes.Literal */:
                    if (token.value == null) {
                        emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, entry_lib_no_default_getTokenCaption(token));
                    }
                    node.items.push(parseLiteral(tokenizer, token.value || ''));
                    break;
                case 7 /* TokenTypes.LinkedAlias */: {
                    const parsed = parseLinked(tokenizer);
                    node.items.push(parsed.node);
                    nextToken = parsed.nextConsumeToken || null;
                    break;
                }
            }
        } while (context.currentType !== 13 /* TokenTypes.EOF */ &&
            context.currentType !== 1 /* TokenTypes.Pipe */);
        // adjust message node loc
        const endOffset = context.currentType === 1 /* TokenTypes.Pipe */
            ? context.lastOffset
            : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* TokenTypes.Pipe */
            ? context.lastEndLoc
            : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* NodeTypes.Plural */, offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) {
                hasEmptyMessage = msg.items.length === 0;
            }
            node.cases.push(msg);
        } while (context.currentType !== 13 /* TokenTypes.EOF */);
        if (hasEmptyMessage) {
            emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        }
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset, startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 13 /* TokenTypes.EOF */) {
            return msgNode;
        }
        else {
            return parsePlural(tokenizer, offset, startLoc, msgNode);
        }
    }
    function parse(source) {
        const tokenizer = entry_lib_no_default_createTokenizer(source, entry_lib_no_default_shared_assign({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* NodeTypes.Resource */, context.offset, context.startLoc);
        if (location && node.loc) {
            node.loc.source = source;
        }
        node.body = parseResource(tokenizer);
        if (options.onCacheKey) {
            node.cacheKey = options.onCacheKey(source);
        }
        // assert whether achieved to EOF
        if (context.currentType !== 13 /* TokenTypes.EOF */) {
            emitError(tokenizer, entry_lib_no_default_CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || '');
        }
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return { parse };
}
function entry_lib_no_default_getTokenCaption(token) {
    if (token.type === 13 /* TokenTypes.EOF */) {
        return 'EOF';
    }
    const name = (token.value || '').replace(/\r?\n/gu, '\\n');
    return name.length > 10 ? name.slice(0, 9) + '…' : name;
}

function entry_lib_no_default_createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast,
        helpers: new Set()
    };
    const context = () => _context;
    const helper = (name) => {
        _context.helpers.add(name);
        return name;
    };
    return { context, helper };
}
function entry_lib_no_default_traverseNodes(nodes, transformer) {
    for (let i = 0; i < nodes.length; i++) {
        entry_lib_no_default_traverseNode(nodes[i], transformer);
    }
}
function entry_lib_no_default_traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch (node.type) {
        case 1 /* NodeTypes.Plural */:
            entry_lib_no_default_traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* HelperNameMap.PLURAL */);
            break;
        case 2 /* NodeTypes.Message */:
            entry_lib_no_default_traverseNodes(node.items, transformer);
            break;
        case 6 /* NodeTypes.Linked */: {
            const linked = node;
            entry_lib_no_default_traverseNode(linked.key, transformer);
            transformer.helper("linked" /* HelperNameMap.LINKED */);
            transformer.helper("type" /* HelperNameMap.TYPE */);
            break;
        }
        case 5 /* NodeTypes.List */:
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */);
            transformer.helper("list" /* HelperNameMap.LIST */);
            break;
        case 4 /* NodeTypes.Named */:
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */);
            transformer.helper("named" /* HelperNameMap.NAMED */);
            break;
    }
    // TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function entry_lib_no_default_transform(ast, options = {} // eslint-disable-line
) {
    const transformer = entry_lib_no_default_createTransformer(ast);
    transformer.helper("normalize" /* HelperNameMap.NORMALIZE */);
    // traverse
    ast.body && entry_lib_no_default_traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}

function entry_lib_no_default_optimize(ast) {
    const body = ast.body;
    if (body.type === 2 /* NodeTypes.Message */) {
        entry_lib_no_default_optimizeMessageNode(body);
    }
    else {
        body.cases.forEach(c => entry_lib_no_default_optimizeMessageNode(c));
    }
    return ast;
}
function entry_lib_no_default_optimizeMessageNode(message) {
    if (message.items.length === 1) {
        const item = message.items[0];
        if (item.type === 3 /* NodeTypes.Text */ || item.type === 9 /* NodeTypes.Literal */) {
            message.static = item.value;
            delete item.value; // optimization for size
        }
    }
    else {
        const values = [];
        for (let i = 0; i < message.items.length; i++) {
            const item = message.items[i];
            if (!(item.type === 3 /* NodeTypes.Text */ || item.type === 9 /* NodeTypes.Literal */)) {
                break;
            }
            if (item.value == null) {
                break;
            }
            values.push(item.value);
        }
        if (values.length === message.items.length) {
            message.static = entry_lib_no_default_join(values);
            for (let i = 0; i < message.items.length; i++) {
                const item = message.items[i];
                if (item.type === 3 /* NodeTypes.Text */ || item.type === 9 /* NodeTypes.Literal */) {
                    delete item.value; // optimization for size
                }
            }
        }
    }
}

const entry_lib_no_default_ERROR_DOMAIN$1 = 'minifier';
/* eslint-disable @typescript-eslint/no-explicit-any */
function entry_lib_no_default_minify(node) {
    node.t = node.type;
    switch (node.type) {
        case 0 /* NodeTypes.Resource */: {
            const resource = node;
            entry_lib_no_default_minify(resource.body);
            resource.b = resource.body;
            delete resource.body;
            break;
        }
        case 1 /* NodeTypes.Plural */: {
            const plural = node;
            const cases = plural.cases;
            for (let i = 0; i < cases.length; i++) {
                entry_lib_no_default_minify(cases[i]);
            }
            plural.c = cases;
            delete plural.cases;
            break;
        }
        case 2 /* NodeTypes.Message */: {
            const message = node;
            const items = message.items;
            for (let i = 0; i < items.length; i++) {
                entry_lib_no_default_minify(items[i]);
            }
            message.i = items;
            delete message.items;
            if (message.static) {
                message.s = message.static;
                delete message.static;
            }
            break;
        }
        case 3 /* NodeTypes.Text */:
        case 9 /* NodeTypes.Literal */:
        case 8 /* NodeTypes.LinkedModifier */:
        case 7 /* NodeTypes.LinkedKey */: {
            const valueNode = node;
            if (valueNode.value) {
                valueNode.v = valueNode.value;
                delete valueNode.value;
            }
            break;
        }
        case 6 /* NodeTypes.Linked */: {
            const linked = node;
            entry_lib_no_default_minify(linked.key);
            linked.k = linked.key;
            delete linked.key;
            if (linked.modifier) {
                entry_lib_no_default_minify(linked.modifier);
                linked.m = linked.modifier;
                delete linked.modifier;
            }
            break;
        }
        case 5 /* NodeTypes.List */: {
            const list = node;
            list.i = list.index;
            delete list.index;
            break;
        }
        case 4 /* NodeTypes.Named */: {
            const named = node;
            named.k = named.key;
            delete named.key;
            break;
        }
        default:
            if ((false)) {}
    }
    delete node.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
const entry_lib_no_default_ERROR_DOMAIN = 'parser';
function entry_lib_no_default_createCodeGenerator(ast, options) {
    const { sourceMap, filename, breakLineCode, needIndent: _needIndent } = options;
    const location = options.location !== false;
    const _context = {
        filename,
        code: '',
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    if (location && ast.loc) {
        _context.source = ast.loc.source;
    }
    const context = () => _context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : '';
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key) => `_${key}`;
    const needIndent = () => _context.needIndent;
    return {
        context,
        push,
        indent,
        deindent,
        newline,
        helper,
        needIndent
    };
}
function entry_lib_no_default_generateLinkedNode(generator, node) {
    const { helper } = generator;
    generator.push(`${helper("linked" /* HelperNameMap.LINKED */)}(`);
    entry_lib_no_default_generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        entry_lib_no_default_generateNode(generator, node.modifier);
        generator.push(`, _type`);
    }
    else {
        generator.push(`, undefined, _type`);
    }
    generator.push(`)`);
}
function entry_lib_no_default_generateMessageNode(generator, node) {
    const { helper, needIndent } = generator;
    generator.push(`${helper("normalize" /* HelperNameMap.NORMALIZE */)}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for (let i = 0; i < length; i++) {
        entry_lib_no_default_generateNode(generator, node.items[i]);
        if (i === length - 1) {
            break;
        }
        generator.push(', ');
    }
    generator.deindent(needIndent());
    generator.push('])');
}
function entry_lib_no_default_generatePluralNode(generator, node) {
    const { helper, needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* HelperNameMap.PLURAL */)}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for (let i = 0; i < length; i++) {
            entry_lib_no_default_generateNode(generator, node.cases[i]);
            if (i === length - 1) {
                break;
            }
            generator.push(', ');
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function entry_lib_no_default_generateResource(generator, node) {
    if (node.body) {
        entry_lib_no_default_generateNode(generator, node.body);
    }
    else {
        generator.push('null');
    }
}
function entry_lib_no_default_generateNode(generator, node) {
    const { helper } = generator;
    switch (node.type) {
        case 0 /* NodeTypes.Resource */:
            entry_lib_no_default_generateResource(generator, node);
            break;
        case 1 /* NodeTypes.Plural */:
            entry_lib_no_default_generatePluralNode(generator, node);
            break;
        case 2 /* NodeTypes.Message */:
            entry_lib_no_default_generateMessageNode(generator, node);
            break;
        case 6 /* NodeTypes.Linked */:
            entry_lib_no_default_generateLinkedNode(generator, node);
            break;
        case 8 /* NodeTypes.LinkedModifier */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* NodeTypes.LinkedKey */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* NodeTypes.List */:
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */)}(${helper("list" /* HelperNameMap.LIST */)}(${node.index}))`, node);
            break;
        case 4 /* NodeTypes.Named */:
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */)}(${helper("named" /* HelperNameMap.NAMED */)}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* NodeTypes.Literal */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* NodeTypes.Text */:
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
            if ((false)) {}
    }
}
// generate code from AST
const entry_lib_no_default_generate = (ast, options = {}) => {
    const mode = entry_lib_no_default_shared_isString(options.mode) ? options.mode : 'normal';
    const filename = entry_lib_no_default_shared_isString(options.filename)
        ? options.filename
        : 'message.intl';
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null
        ? options.breakLineCode
        : mode === 'arrow'
            ? ';'
            : '\n';
    const needIndent = options.needIndent ? options.needIndent : mode !== 'arrow';
    const helpers = ast.helpers || [];
    const generator = entry_lib_no_default_createCodeGenerator(ast, {
        mode,
        filename,
        sourceMap,
        breakLineCode,
        needIndent
    });
    generator.push(mode === 'normal' ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${entry_lib_no_default_join(helpers.map(s => `${s}: _${s}`), ', ')} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    entry_lib_no_default_generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    delete ast.helpers;
    const { code, map } = generator.context();
    return {
        ast,
        code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};

function entry_lib_no_default_baseCompile(source, options = {}) {
    const assignedOptions = entry_lib_no_default_shared_assign({}, options);
    const jit = !!assignedOptions.jit;
    const enalbeMinify = !!assignedOptions.minify;
    const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
    // parse source codes
    const parser = entry_lib_no_default_createParser(assignedOptions);
    const ast = parser.parse(source);
    if (!jit) {
        // transform ASTs
        entry_lib_no_default_transform(ast, assignedOptions);
        // generate javascript codes
        return entry_lib_no_default_generate(ast, assignedOptions);
    }
    else {
        // optimize ASTs
        enambeOptimize && entry_lib_no_default_optimize(ast);
        // minimize ASTs
        enalbeMinify && entry_lib_no_default_minify(ast);
        // In JIT mode, no ast transform, no code generation.
        return { ast, code: '' };
    }
}



;// ../../libs/i18n/node_modules/@intlify/core-base/dist/core-base.mjs
/*!
  * core-base v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */




/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */
function entry_lib_no_default_initFeatureFlags() {
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') {
        entry_lib_no_default_getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== 'boolean') {
        entry_lib_no_default_getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    }
}

function entry_lib_no_default_core_base_format(ast) {
    const msg = (ctx) => entry_lib_no_default_formatParts(ctx, ast);
    return msg;
}
function entry_lib_no_default_formatParts(ctx, ast) {
    const body = entry_lib_no_default_resolveBody(ast);
    if (body == null) {
        throw entry_lib_no_default_createUnhandleNodeError(0 /* NodeTypes.Resource */);
    }
    const type = entry_lib_no_default_resolveType(body);
    if (type === 1 /* NodeTypes.Plural */) {
        const plural = body;
        const cases = entry_lib_no_default_resolveCases(plural);
        return ctx.plural(cases.reduce((messages, c) => [
            ...messages,
            entry_lib_no_default_formatMessageParts(ctx, c)
        ], []));
    }
    else {
        return entry_lib_no_default_formatMessageParts(ctx, body);
    }
}
const entry_lib_no_default_PROPS_BODY = ['b', 'body'];
function entry_lib_no_default_resolveBody(node) {
    return entry_lib_no_default_resolveProps(node, entry_lib_no_default_PROPS_BODY);
}
const entry_lib_no_default_PROPS_CASES = ['c', 'cases'];
function entry_lib_no_default_resolveCases(node) {
    return entry_lib_no_default_resolveProps(node, entry_lib_no_default_PROPS_CASES, []);
}
function entry_lib_no_default_formatMessageParts(ctx, node) {
    const static_ = entry_lib_no_default_resolveStatic(node);
    if (static_ != null) {
        return ctx.type === 'text'
            ? static_
            : ctx.normalize([static_]);
    }
    else {
        const messages = entry_lib_no_default_resolveItems(node).reduce((acm, c) => [...acm, entry_lib_no_default_formatMessagePart(ctx, c)], []);
        return ctx.normalize(messages);
    }
}
const entry_lib_no_default_PROPS_STATIC = ['s', 'static'];
function entry_lib_no_default_resolveStatic(node) {
    return entry_lib_no_default_resolveProps(node, entry_lib_no_default_PROPS_STATIC);
}
const entry_lib_no_default_PROPS_ITEMS = ['i', 'items'];
function entry_lib_no_default_resolveItems(node) {
    return entry_lib_no_default_resolveProps(node, entry_lib_no_default_PROPS_ITEMS, []);
}
function entry_lib_no_default_formatMessagePart(ctx, node) {
    const type = entry_lib_no_default_resolveType(node);
    switch (type) {
        case 3 /* NodeTypes.Text */: {
            return entry_lib_no_default_resolveValue$1(node, type);
        }
        case 9 /* NodeTypes.Literal */: {
            return entry_lib_no_default_resolveValue$1(node, type);
        }
        case 4 /* NodeTypes.Named */: {
            const named = node;
            if (entry_lib_no_default_hasOwn(named, 'k') && named.k) {
                return ctx.interpolate(ctx.named(named.k));
            }
            if (entry_lib_no_default_hasOwn(named, 'key') && named.key) {
                return ctx.interpolate(ctx.named(named.key));
            }
            throw entry_lib_no_default_createUnhandleNodeError(type);
        }
        case 5 /* NodeTypes.List */: {
            const list = node;
            if (entry_lib_no_default_hasOwn(list, 'i') && entry_lib_no_default_isNumber(list.i)) {
                return ctx.interpolate(ctx.list(list.i));
            }
            if (entry_lib_no_default_hasOwn(list, 'index') && entry_lib_no_default_isNumber(list.index)) {
                return ctx.interpolate(ctx.list(list.index));
            }
            throw entry_lib_no_default_createUnhandleNodeError(type);
        }
        case 6 /* NodeTypes.Linked */: {
            const linked = node;
            const modifier = entry_lib_no_default_resolveLinkedModifier(linked);
            const key = entry_lib_no_default_resolveLinkedKey(linked);
            return ctx.linked(entry_lib_no_default_formatMessagePart(ctx, key), modifier ? entry_lib_no_default_formatMessagePart(ctx, modifier) : undefined, ctx.type);
        }
        case 7 /* NodeTypes.LinkedKey */: {
            return entry_lib_no_default_resolveValue$1(node, type);
        }
        case 8 /* NodeTypes.LinkedModifier */: {
            return entry_lib_no_default_resolveValue$1(node, type);
        }
        default:
            throw new Error(`unhandled node on format message part: ${type}`);
    }
}
const entry_lib_no_default_PROPS_TYPE = ['t', 'type'];
function entry_lib_no_default_resolveType(node) {
    return entry_lib_no_default_resolveProps(node, entry_lib_no_default_PROPS_TYPE);
}
const entry_lib_no_default_PROPS_VALUE = ['v', 'value'];
function entry_lib_no_default_resolveValue$1(node, type) {
    const resolved = entry_lib_no_default_resolveProps(node, entry_lib_no_default_PROPS_VALUE);
    if (resolved) {
        return resolved;
    }
    else {
        throw entry_lib_no_default_createUnhandleNodeError(type);
    }
}
const entry_lib_no_default_PROPS_MODIFIER = ['m', 'modifier'];
function entry_lib_no_default_resolveLinkedModifier(node) {
    return entry_lib_no_default_resolveProps(node, entry_lib_no_default_PROPS_MODIFIER);
}
const entry_lib_no_default_PROPS_KEY = ['k', 'key'];
function entry_lib_no_default_resolveLinkedKey(node) {
    const resolved = entry_lib_no_default_resolveProps(node, entry_lib_no_default_PROPS_KEY);
    if (resolved) {
        return resolved;
    }
    else {
        throw entry_lib_no_default_createUnhandleNodeError(6 /* NodeTypes.Linked */);
    }
}
function entry_lib_no_default_resolveProps(node, props, defaultValue) {
    for (let i = 0; i < props.length; i++) {
        const prop = props[i];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (entry_lib_no_default_hasOwn(node, prop) && node[prop] != null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return node[prop];
        }
    }
    return defaultValue;
}
function entry_lib_no_default_createUnhandleNodeError(type) {
    return new Error(`unhandled node type: ${type}`);
}

const entry_lib_no_default_WARN_MESSAGE = (/* unused pure expression or super */ null && (`Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`));
function entry_lib_no_default_checkHtmlMessage(source, warnHtmlMessage) {
    if (warnHtmlMessage && detectHtmlTag(source)) {
        warn(format$1(entry_lib_no_default_WARN_MESSAGE, { source }));
    }
}
const entry_lib_no_default_defaultOnCacheKey = (message) => message;
let entry_lib_no_default_compileCache = entry_lib_no_default_shared_create();
function entry_lib_no_default_clearCompileCache() {
    entry_lib_no_default_compileCache = create();
}
function entry_lib_no_default_core_base_isMessageAST(val) {
    return (entry_lib_no_default_shared_isObject(val) &&
        entry_lib_no_default_resolveType(val) === 0 &&
        (entry_lib_no_default_hasOwn(val, 'b') || entry_lib_no_default_hasOwn(val, 'body')));
}
function entry_lib_no_default_core_base_baseCompile(message, options = {}) {
    // error detecting on compile
    let detectError = false;
    const onError = options.onError || entry_lib_no_default_defaultOnError;
    options.onError = (err) => {
        detectError = true;
        onError(err);
    };
    // compile with mesasge-compiler
    return { ...entry_lib_no_default_baseCompile(message, options), detectError };
}
/* #__NO_SIDE_EFFECTS__ */
function entry_lib_no_default_compile(message, context) {
    if ((!__INTLIFY_DROP_MESSAGE_COMPILER__) &&
        entry_lib_no_default_shared_isString(message)) {
        // check HTML message
        const warnHtmlMessage = entry_lib_no_default_shared_isBoolean(context.warnHtmlMessage)
            ? context.warnHtmlMessage
            : true;
        ( false) && 0;
        // check caches
        const onCacheKey = context.onCacheKey || entry_lib_no_default_defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = entry_lib_no_default_compileCache[cacheKey];
        if (cached) {
            return cached;
        }
        // compile with JIT mode
        const { ast, detectError } = entry_lib_no_default_core_base_baseCompile(message, {
            ...context,
            location: ("production" !== 'production'),
            jit: true
        });
        // compose message function from AST
        const msg = entry_lib_no_default_core_base_format(ast);
        // if occurred compile error, don't cache
        return !detectError
            ? (entry_lib_no_default_compileCache[cacheKey] = msg)
            : msg;
    }
    else {
        if (false) {}
        // AST case (passed from bundler)
        const cacheKey = message.cacheKey;
        if (cacheKey) {
            const cached = entry_lib_no_default_compileCache[cacheKey];
            if (cached) {
                return cached;
            }
            // compose message function from message (AST)
            return (entry_lib_no_default_compileCache[cacheKey] =
                entry_lib_no_default_core_base_format(message));
        }
        else {
            return entry_lib_no_default_core_base_format(message);
        }
    }
}

let entry_lib_no_default_devtools = null;
function entry_lib_no_default_setDevToolsHook(hook) {
    entry_lib_no_default_devtools = hook;
}
function entry_lib_no_default_getDevToolsHook() {
    return entry_lib_no_default_devtools;
}
function entry_lib_no_default_initI18nDevTools(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    entry_lib_no_default_devtools &&
        entry_lib_no_default_devtools.emit('i18n:init', {
            timestamp: Date.now(),
            i18n,
            version,
            meta
        });
}
const entry_lib_no_default_translateDevTools = 
/* #__PURE__*/ entry_lib_no_default_createDevToolsHook('function:translate');
function entry_lib_no_default_createDevToolsHook(hook) {
    return (payloads) => entry_lib_no_default_devtools && entry_lib_no_default_devtools.emit(hook, payloads);
}

const entry_lib_no_default_CoreErrorCodes = {
    INVALID_ARGUMENT: entry_lib_no_default_COMPILE_ERROR_CODES_EXTEND_POINT, // 17
    INVALID_DATE_ARGUMENT: 18,
    INVALID_ISO_DATE_ARGUMENT: 19,
    NOT_SUPPORT_NON_STRING_MESSAGE: 20,
    NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
    NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
    NOT_SUPPORT_LOCALE_TYPE: 23
};
const entry_lib_no_default_CORE_ERROR_CODES_EXTEND_POINT = 24;
function entry_lib_no_default_createCoreError(code) {
    return entry_lib_no_default_createCompileError(code, null, ( false) ? 0 : undefined);
}
/** @internal */
const entry_lib_no_default_core_base_errorMessages = {
    [entry_lib_no_default_CoreErrorCodes.INVALID_ARGUMENT]: 'Invalid arguments',
    [entry_lib_no_default_CoreErrorCodes.INVALID_DATE_ARGUMENT]: 'The date provided is an invalid Date object.' +
        'Make sure your Date represents a valid date.',
    [entry_lib_no_default_CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT]: 'The argument provided is not a valid ISO date string',
    [entry_lib_no_default_CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE]: 'Not support non-string message',
    [entry_lib_no_default_CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: 'cannot support promise value',
    [entry_lib_no_default_CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: 'cannot support async function',
    [entry_lib_no_default_CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE]: 'cannot support locale type'
};

/** @internal */
function entry_lib_no_default_getLocale(context, options) {
    return options.locale != null
        ? build_entry_lib_no_default_resolveLocale(options.locale)
        : build_entry_lib_no_default_resolveLocale(context.locale);
}
let entry_lib_no_default_resolveLocale;
/** @internal */
function build_entry_lib_no_default_resolveLocale(locale) {
    if (entry_lib_no_default_shared_isString(locale)) {
        return locale;
    }
    else {
        if (entry_lib_no_default_shared_isFunction(locale)) {
            if (locale.resolvedOnce && entry_lib_no_default_resolveLocale != null) {
                return entry_lib_no_default_resolveLocale;
            }
            else if (locale.constructor.name === 'Function') {
                const resolve = locale();
                if (entry_lib_no_default_isPromise(resolve)) {
                    throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
                }
                return (entry_lib_no_default_resolveLocale = resolve);
            }
            else {
                throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
            }
        }
        else {
            throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE);
        }
    }
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */
function entry_lib_no_default_fallbackWithSimple(ctx, fallback, start) {
    // prettier-ignore
    return [...new Set([
            start,
            ...(entry_lib_no_default_shared_isArray(fallback)
                ? fallback
                : entry_lib_no_default_shared_isObject(fallback)
                    ? Object.keys(fallback)
                    : entry_lib_no_default_shared_isString(fallback)
                        ? [fallback]
                        : [start])
        ])];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */
function entry_lib_no_default_fallbackWithLocaleChain(ctx, fallback, start) {
    const startLocale = entry_lib_no_default_shared_isString(start) ? start : entry_lib_no_default_DEFAULT_LOCALE;
    const context = ctx;
    if (!context.__localeChainCache) {
        context.__localeChainCache = new Map();
    }
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [start];
        // while any intervening block found
        while (entry_lib_no_default_shared_isArray(block)) {
            block = entry_lib_no_default_appendBlockToChain(chain, block, fallback);
        }
        // prettier-ignore
        // last block defined by default
        const defaults = entry_lib_no_default_shared_isArray(fallback) || !entry_lib_no_default_isPlainObject(fallback)
            ? fallback
            : fallback['default']
                ? fallback['default']
                : null;
        // convert defaults to array
        block = entry_lib_no_default_shared_isString(defaults) ? [defaults] : defaults;
        if (entry_lib_no_default_shared_isArray(block)) {
            entry_lib_no_default_appendBlockToChain(chain, block, false);
        }
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function entry_lib_no_default_appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for (let i = 0; i < block.length && entry_lib_no_default_shared_isBoolean(follow); i++) {
        const locale = block[i];
        if (entry_lib_no_default_shared_isString(locale)) {
            follow = entry_lib_no_default_appendLocaleToChain(chain, block[i], blocks);
        }
    }
    return follow;
}
function entry_lib_no_default_appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split('-');
    do {
        const target = tokens.join('-');
        follow = entry_lib_no_default_appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    } while (tokens.length && follow === true);
    return follow;
}
function entry_lib_no_default_appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== '!';
            const locale = target.replace(/!/g, '');
            chain.push(locale);
            if ((entry_lib_no_default_shared_isArray(blocks) || entry_lib_no_default_isPlainObject(blocks)) &&
                blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                follow = blocks[locale];
            }
        }
    }
    return follow;
}

const entry_lib_no_default_pathStateMachine = [];
entry_lib_no_default_pathStateMachine[0 /* States.BEFORE_PATH */] = {
    ["w" /* PathCharTypes.WORKSPACE */]: [0 /* States.BEFORE_PATH */],
    ["i" /* PathCharTypes.IDENT */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */],
    ["[" /* PathCharTypes.LEFT_BRACKET */]: [4 /* States.IN_SUB_PATH */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: [7 /* States.AFTER_PATH */]
};
entry_lib_no_default_pathStateMachine[1 /* States.IN_PATH */] = {
    ["w" /* PathCharTypes.WORKSPACE */]: [1 /* States.IN_PATH */],
    ["." /* PathCharTypes.DOT */]: [2 /* States.BEFORE_IDENT */],
    ["[" /* PathCharTypes.LEFT_BRACKET */]: [4 /* States.IN_SUB_PATH */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: [7 /* States.AFTER_PATH */]
};
entry_lib_no_default_pathStateMachine[2 /* States.BEFORE_IDENT */] = {
    ["w" /* PathCharTypes.WORKSPACE */]: [2 /* States.BEFORE_IDENT */],
    ["i" /* PathCharTypes.IDENT */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */],
    ["0" /* PathCharTypes.ZERO */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */]
};
entry_lib_no_default_pathStateMachine[3 /* States.IN_IDENT */] = {
    ["i" /* PathCharTypes.IDENT */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */],
    ["0" /* PathCharTypes.ZERO */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */],
    ["w" /* PathCharTypes.WORKSPACE */]: [1 /* States.IN_PATH */, 1 /* Actions.PUSH */],
    ["." /* PathCharTypes.DOT */]: [2 /* States.BEFORE_IDENT */, 1 /* Actions.PUSH */],
    ["[" /* PathCharTypes.LEFT_BRACKET */]: [4 /* States.IN_SUB_PATH */, 1 /* Actions.PUSH */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: [7 /* States.AFTER_PATH */, 1 /* Actions.PUSH */]
};
entry_lib_no_default_pathStateMachine[4 /* States.IN_SUB_PATH */] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */]: [5 /* States.IN_SINGLE_QUOTE */, 0 /* Actions.APPEND */],
    ["\"" /* PathCharTypes.DOUBLE_QUOTE */]: [6 /* States.IN_DOUBLE_QUOTE */, 0 /* Actions.APPEND */],
    ["[" /* PathCharTypes.LEFT_BRACKET */]: [
        4 /* States.IN_SUB_PATH */,
        2 /* Actions.INC_SUB_PATH_DEPTH */
    ],
    ["]" /* PathCharTypes.RIGHT_BRACKET */]: [1 /* States.IN_PATH */, 3 /* Actions.PUSH_SUB_PATH */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: 8 /* States.ERROR */,
    ["l" /* PathCharTypes.ELSE */]: [4 /* States.IN_SUB_PATH */, 0 /* Actions.APPEND */]
};
entry_lib_no_default_pathStateMachine[5 /* States.IN_SINGLE_QUOTE */] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */]: [4 /* States.IN_SUB_PATH */, 0 /* Actions.APPEND */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: 8 /* States.ERROR */,
    ["l" /* PathCharTypes.ELSE */]: [5 /* States.IN_SINGLE_QUOTE */, 0 /* Actions.APPEND */]
};
entry_lib_no_default_pathStateMachine[6 /* States.IN_DOUBLE_QUOTE */] = {
    ["\"" /* PathCharTypes.DOUBLE_QUOTE */]: [4 /* States.IN_SUB_PATH */, 0 /* Actions.APPEND */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: 8 /* States.ERROR */,
    ["l" /* PathCharTypes.ELSE */]: [6 /* States.IN_DOUBLE_QUOTE */, 0 /* Actions.APPEND */]
};
/**
 * Check if an expression is a literal value.
 */
const entry_lib_no_default_literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function entry_lib_no_default_isLiteral(exp) {
    return entry_lib_no_default_literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */
function entry_lib_no_default_stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */
function entry_lib_no_default_getPathCharType(ch) {
    if (ch === undefined || ch === null) {
        return "o" /* PathCharTypes.END_OF_FAIL */;
    }
    const code = ch.charCodeAt(0);
    switch (code) {
        case 0x5b: // [
        case 0x5d: // ]
        case 0x2e: // .
        case 0x22: // "
        case 0x27: // '
            return ch;
        case 0x5f: // _
        case 0x24: // $
        case 0x2d: // -
            return "i" /* PathCharTypes.IDENT */;
        case 0x09: // Tab (HT)
        case 0x0a: // Newline (LF)
        case 0x0d: // Return (CR)
        case 0xa0: // No-break space (NBSP)
        case 0xfeff: // Byte Order Mark (BOM)
        case 0x2028: // Line Separator (LS)
        case 0x2029: // Paragraph Separator (PS)
            return "w" /* PathCharTypes.WORKSPACE */;
    }
    return "i" /* PathCharTypes.IDENT */;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */
function entry_lib_no_default_formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(parseInt(path))) {
        return false;
    }
    return entry_lib_no_default_isLiteral(trimmed)
        ? entry_lib_no_default_stripQuotes(trimmed)
        : "*" /* PathCharTypes.ASTARISK */ + trimmed;
}
/**
 * Parse a string path into an array of segments
 */
function entry_lib_no_default_parse(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* States.BEFORE_PATH */;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* Actions.APPEND */] = () => {
        if (key === undefined) {
            key = newChar;
        }
        else {
            key += newChar;
        }
    };
    actions[1 /* Actions.PUSH */] = () => {
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* Actions.INC_SUB_PATH_DEPTH */] = () => {
        actions[0 /* Actions.APPEND */]();
        subPathDepth++;
    };
    actions[3 /* Actions.PUSH_SUB_PATH */] = () => {
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* States.IN_SUB_PATH */;
            actions[0 /* Actions.APPEND */]();
        }
        else {
            subPathDepth = 0;
            if (key === undefined) {
                return false;
            }
            key = entry_lib_no_default_formatSubPath(key);
            if (key === false) {
                return false;
            }
            else {
                actions[1 /* Actions.PUSH */]();
            }
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if ((mode === 5 /* States.IN_SINGLE_QUOTE */ &&
            nextChar === "'" /* PathCharTypes.SINGLE_QUOTE */) ||
            (mode === 6 /* States.IN_DOUBLE_QUOTE */ &&
                nextChar === "\"" /* PathCharTypes.DOUBLE_QUOTE */)) {
            index++;
            newChar = '\\' + nextChar;
            actions[0 /* Actions.APPEND */]();
            return true;
        }
    }
    while (mode !== null) {
        index++;
        c = path[index];
        if (c === '\\' && maybeUnescapeQuote()) {
            continue;
        }
        type = entry_lib_no_default_getPathCharType(c);
        typeMap = entry_lib_no_default_pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* PathCharTypes.ELSE */] || 8 /* States.ERROR */;
        // check parse error
        if (transition === 8 /* States.ERROR */) {
            return;
        }
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) {
                    return;
                }
            }
        }
        // check parse finish
        if (mode === 7 /* States.AFTER_PATH */) {
            return keys;
        }
    }
}
// path token cache
const entry_lib_no_default_cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */
function entry_lib_no_default_resolveWithKeyValue(obj, path) {
    return entry_lib_no_default_shared_isObject(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */
function entry_lib_no_default_resolveValue(obj, path) {
    // check object
    if (!entry_lib_no_default_shared_isObject(obj)) {
        return null;
    }
    // parse path
    let hit = entry_lib_no_default_cache.get(path);
    if (!hit) {
        hit = entry_lib_no_default_parse(path);
        if (hit) {
            entry_lib_no_default_cache.set(path, hit);
        }
    }
    // check hit
    if (!hit) {
        return null;
    }
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while (i < len) {
        const val = last[hit[i]];
        if (val === undefined) {
            return null;
        }
        if (entry_lib_no_default_shared_isFunction(last)) {
            return null;
        }
        last = val;
        i++;
    }
    return last;
}

const entry_lib_no_default_CoreWarnCodes = {
    NOT_FOUND_KEY: 1,
    FALLBACK_TO_TRANSLATE: 2,
    CANNOT_FORMAT_NUMBER: 3,
    FALLBACK_TO_NUMBER_FORMAT: 4,
    CANNOT_FORMAT_DATE: 5,
    FALLBACK_TO_DATE_FORMAT: 6,
    EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
};
const entry_lib_no_default_CORE_WARN_CODES_EXTEND_POINT = 8;
/** @internal */
const entry_lib_no_default_warnMessages = {
    [entry_lib_no_default_CoreWarnCodes.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [entry_lib_no_default_CoreWarnCodes.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [entry_lib_no_default_CoreWarnCodes.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [entry_lib_no_default_CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [entry_lib_no_default_CoreWarnCodes.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [entry_lib_no_default_CoreWarnCodes.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`,
    [entry_lib_no_default_CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: `This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.`
};
function entry_lib_no_default_getWarnMessage(code, ...args) {
    return format$1(entry_lib_no_default_warnMessages[code], ...args);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Intlify core-base version
 * @internal
 */
const entry_lib_no_default_VERSION = '10.0.5';
const entry_lib_no_default_NOT_REOSLVED = -1;
const entry_lib_no_default_DEFAULT_LOCALE = 'en-US';
const entry_lib_no_default_MISSING_RESOLVE_VALUE = '';
const entry_lib_no_default_capitalize = (str) => `${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function entry_lib_no_default_getDefaultLinkedModifiers() {
    return {
        upper: (val, type) => {
            // prettier-ignore
            return type === 'text' && entry_lib_no_default_shared_isString(val)
                ? val.toUpperCase()
                : type === 'vnode' && entry_lib_no_default_shared_isObject(val) && '__v_isVNode' in val
                    ? val.children.toUpperCase()
                    : val;
        },
        lower: (val, type) => {
            // prettier-ignore
            return type === 'text' && entry_lib_no_default_shared_isString(val)
                ? val.toLowerCase()
                : type === 'vnode' && entry_lib_no_default_shared_isObject(val) && '__v_isVNode' in val
                    ? val.children.toLowerCase()
                    : val;
        },
        capitalize: (val, type) => {
            // prettier-ignore
            return (type === 'text' && entry_lib_no_default_shared_isString(val)
                ? entry_lib_no_default_capitalize(val)
                : type === 'vnode' && entry_lib_no_default_shared_isObject(val) && '__v_isVNode' in val
                    ? entry_lib_no_default_capitalize(val.children)
                    : val);
        }
    };
}
let entry_lib_no_default_compiler;
function entry_lib_no_default_registerMessageCompiler(compiler) {
    entry_lib_no_default_compiler = compiler;
}
let entry_lib_no_default_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */
function entry_lib_no_default_registerMessageResolver(resolver) {
    entry_lib_no_default_resolver = resolver;
}
let entry_lib_no_default_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */
function entry_lib_no_default_registerLocaleFallbacker(fallbacker) {
    entry_lib_no_default_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let entry_lib_no_default_additionalMeta = null;
/* #__NO_SIDE_EFFECTS__ */
const entry_lib_no_default_setAdditionalMeta = (meta) => {
    entry_lib_no_default_additionalMeta = meta;
};
/* #__NO_SIDE_EFFECTS__ */
const entry_lib_no_default_getAdditionalMeta = () => entry_lib_no_default_additionalMeta;
let entry_lib_no_default_fallbackContext = null;
const entry_lib_no_default_setFallbackContext = (context) => {
    entry_lib_no_default_fallbackContext = context;
};
const entry_lib_no_default_getFallbackContext = () => entry_lib_no_default_fallbackContext;
// ID for CoreContext
let entry_lib_no_default_cid = 0;
function entry_lib_no_default_createCoreContext(options = {}) {
    // setup options
    const onWarn = entry_lib_no_default_shared_isFunction(options.onWarn) ? options.onWarn : entry_lib_no_default_shared_warn;
    const version = entry_lib_no_default_shared_isString(options.version) ? options.version : entry_lib_no_default_VERSION;
    const locale = entry_lib_no_default_shared_isString(options.locale) || entry_lib_no_default_shared_isFunction(options.locale)
        ? options.locale
        : entry_lib_no_default_DEFAULT_LOCALE;
    const _locale = entry_lib_no_default_shared_isFunction(locale) ? entry_lib_no_default_DEFAULT_LOCALE : locale;
    const fallbackLocale = entry_lib_no_default_shared_isArray(options.fallbackLocale) ||
        entry_lib_no_default_isPlainObject(options.fallbackLocale) ||
        entry_lib_no_default_shared_isString(options.fallbackLocale) ||
        options.fallbackLocale === false
        ? options.fallbackLocale
        : _locale;
    const messages = entry_lib_no_default_isPlainObject(options.messages)
        ? options.messages
        : entry_lib_no_default_createResources(_locale);
    const datetimeFormats = entry_lib_no_default_isPlainObject(options.datetimeFormats)
            ? options.datetimeFormats
            : entry_lib_no_default_createResources(_locale)
        ;
    const numberFormats = entry_lib_no_default_isPlainObject(options.numberFormats)
            ? options.numberFormats
            : entry_lib_no_default_createResources(_locale)
        ;
    const modifiers = entry_lib_no_default_shared_assign(entry_lib_no_default_shared_create(), options.modifiers, entry_lib_no_default_getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || entry_lib_no_default_shared_create();
    const missing = entry_lib_no_default_shared_isFunction(options.missing) ? options.missing : null;
    const missingWarn = entry_lib_no_default_shared_isBoolean(options.missingWarn) || entry_lib_no_default_isRegExp(options.missingWarn)
        ? options.missingWarn
        : true;
    const fallbackWarn = entry_lib_no_default_shared_isBoolean(options.fallbackWarn) || entry_lib_no_default_isRegExp(options.fallbackWarn)
        ? options.fallbackWarn
        : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = entry_lib_no_default_shared_isFunction(options.postTranslation)
        ? options.postTranslation
        : null;
    const processor = entry_lib_no_default_isPlainObject(options.processor) ? options.processor : null;
    const warnHtmlMessage = entry_lib_no_default_shared_isBoolean(options.warnHtmlMessage)
        ? options.warnHtmlMessage
        : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = entry_lib_no_default_shared_isFunction(options.messageCompiler)
        ? options.messageCompiler
        : entry_lib_no_default_compiler;
    if (false) {}
    const messageResolver = entry_lib_no_default_shared_isFunction(options.messageResolver)
        ? options.messageResolver
        : entry_lib_no_default_resolver || entry_lib_no_default_resolveWithKeyValue;
    const localeFallbacker = entry_lib_no_default_shared_isFunction(options.localeFallbacker)
        ? options.localeFallbacker
        : entry_lib_no_default_fallbacker || entry_lib_no_default_fallbackWithSimple;
    const fallbackContext = entry_lib_no_default_shared_isObject(options.fallbackContext)
        ? options.fallbackContext
        : undefined;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = entry_lib_no_default_shared_isObject(internalOptions.__datetimeFormatters)
            ? internalOptions.__datetimeFormatters
            : new Map()
        ;
    const __numberFormatters = entry_lib_no_default_shared_isObject(internalOptions.__numberFormatters)
            ? internalOptions.__numberFormatters
            : new Map()
        ;
    const __meta = entry_lib_no_default_shared_isObject(internalOptions.__meta) ? internalOptions.__meta : {};
    entry_lib_no_default_cid++;
    const context = {
        version,
        cid: entry_lib_no_default_cid,
        locale,
        fallbackLocale,
        messages,
        modifiers,
        pluralRules,
        missing,
        missingWarn,
        fallbackWarn,
        fallbackFormat,
        unresolving,
        postTranslation,
        processor,
        warnHtmlMessage,
        escapeParameter,
        messageCompiler,
        messageResolver,
        localeFallbacker,
        fallbackContext,
        onWarn,
        __meta
    };
    {
        context.datetimeFormats = datetimeFormats;
        context.numberFormats = numberFormats;
        context.__datetimeFormatters = __datetimeFormatters;
        context.__numberFormatters = __numberFormatters;
    }
    // for vue-devtools timeline event
    if ((false)) {}
    // NOTE: experimental !!
    if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
        entry_lib_no_default_initI18nDevTools(context, version, __meta);
    }
    return context;
}
const entry_lib_no_default_createResources = (locale) => ({ [locale]: entry_lib_no_default_shared_create() });
/** @internal */
function entry_lib_no_default_isTranslateFallbackWarn(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */
function entry_lib_no_default_isTranslateMissingWarn(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */
function entry_lib_no_default_handleMissing(context, key, locale, missingWarn, type) {
    const { missing, onWarn } = context;
    // for vue-devtools timeline event
    if ((false)) {}
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return entry_lib_no_default_shared_isString(ret) ? ret : key;
    }
    else {
        if (false) {}
        return key;
    }
}
/** @internal */
function entry_lib_no_default_updateFallbackLocale(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/** @internal */
function entry_lib_no_default_isAlmostSameLocale(locale, compareLocale) {
    if (locale === compareLocale)
        return false;
    return locale.split('-')[0] === compareLocale.split('-')[0];
}
/** @internal */
function entry_lib_no_default_isImplicitFallback(targetLocale, locales) {
    const index = locales.indexOf(targetLocale);
    if (index === -1) {
        return false;
    }
    for (let i = index + 1; i < locales.length; i++) {
        if (entry_lib_no_default_isAlmostSameLocale(targetLocale, locales[i])) {
            return true;
        }
    }
    return false;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const entry_lib_no_default_intlDefined = typeof Intl !== 'undefined';
const entry_lib_no_default_Availabilities = {
    dateTimeFormat: entry_lib_no_default_intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
    numberFormat: entry_lib_no_default_intlDefined && typeof Intl.NumberFormat !== 'undefined'
};

// implementation of `datetime` function
function entry_lib_no_default_datetime(context, ...args) {
    const { datetimeFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
    const { __datetimeFormatters } = context;
    if (false) {}
    const [key, value, options, overrides] = entry_lib_no_default_parseDateTimeArgs(...args);
    const missingWarn = entry_lib_no_default_shared_isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = entry_lib_no_default_shared_isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const part = !!options.part;
    const locale = entry_lib_no_default_getLocale(context, options);
    const locales = localeFallbacker(context, // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale, locale);
    if (!entry_lib_no_default_shared_isString(key) || key === '') {
        return new Intl.DateTimeFormat(locale, overrides).format(value);
    }
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'datetime format';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if (false) {}
        // for vue-devtools timeline event
        if (false) {}
        datetimeFormat =
            datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if (entry_lib_no_default_isPlainObject(format))
            break;
        entry_lib_no_default_handleMissing(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!entry_lib_no_default_isPlainObject(format) || !entry_lib_no_default_shared_isString(targetLocale)) {
        return unresolving ? entry_lib_no_default_NOT_REOSLVED : key;
    }
    let id = `${targetLocale}__${key}`;
    if (!entry_lib_no_default_isEmptyObject(overrides)) {
        id = `${id}__${JSON.stringify(overrides)}`;
    }
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, entry_lib_no_default_shared_assign({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */
const entry_lib_no_default_DATETIME_FORMAT_OPTIONS_KEYS = [
    'localeMatcher',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'formatMatcher',
    'hour12',
    'timeZone',
    'dateStyle',
    'timeStyle',
    'calendar',
    'dayPeriod',
    'numberingSystem',
    'hourCycle',
    'fractionalSecondDigits'
];
/** @internal */
function entry_lib_no_default_parseDateTimeArgs(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = entry_lib_no_default_shared_create();
    let overrides = entry_lib_no_default_shared_create();
    let value;
    if (entry_lib_no_default_shared_isString(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) {
            throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
        }
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3]
            ? matches[3].trim().startsWith('T')
                ? `${matches[1].trim()}${matches[3].trim()}`
                : `${matches[1].trim()}T${matches[3].trim()}`
            : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        }
        catch {
            throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
        }
    }
    else if (entry_lib_no_default_isDate(arg1)) {
        if (isNaN(arg1.getTime())) {
            throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.INVALID_DATE_ARGUMENT);
        }
        value = arg1;
    }
    else if (entry_lib_no_default_isNumber(arg1)) {
        value = arg1;
    }
    else {
        throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.INVALID_ARGUMENT);
    }
    if (entry_lib_no_default_shared_isString(arg2)) {
        options.key = arg2;
    }
    else if (entry_lib_no_default_isPlainObject(arg2)) {
        Object.keys(arg2).forEach(key => {
            if (entry_lib_no_default_DATETIME_FORMAT_OPTIONS_KEYS.includes(key)) {
                overrides[key] = arg2[key];
            }
            else {
                options[key] = arg2[key];
            }
        });
    }
    if (entry_lib_no_default_shared_isString(arg3)) {
        options.locale = arg3;
    }
    else if (entry_lib_no_default_isPlainObject(arg3)) {
        overrides = arg3;
    }
    if (entry_lib_no_default_isPlainObject(arg4)) {
        overrides = arg4;
    }
    return [options.key || '', value, options, overrides];
}
/** @internal */
function entry_lib_no_default_clearDateTimeFormat(ctx, locale, format) {
    const context = ctx;
    for (const key in format) {
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) {
            continue;
        }
        context.__datetimeFormatters.delete(id);
    }
}

// implementation of `number` function
function entry_lib_no_default_number(context, ...args) {
    const { numberFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
    const { __numberFormatters } = context;
    if (false) {}
    const [key, value, options, overrides] = entry_lib_no_default_parseNumberArgs(...args);
    const missingWarn = entry_lib_no_default_shared_isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = entry_lib_no_default_shared_isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const part = !!options.part;
    const locale = entry_lib_no_default_getLocale(context, options);
    const locales = localeFallbacker(context, // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale, locale);
    if (!entry_lib_no_default_shared_isString(key) || key === '') {
        return new Intl.NumberFormat(locale, overrides).format(value);
    }
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'number format';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if (false) {}
        // for vue-devtools timeline event
        if (false) {}
        numberFormat =
            numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if (entry_lib_no_default_isPlainObject(format))
            break;
        entry_lib_no_default_handleMissing(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!entry_lib_no_default_isPlainObject(format) || !entry_lib_no_default_shared_isString(targetLocale)) {
        return unresolving ? entry_lib_no_default_NOT_REOSLVED : key;
    }
    let id = `${targetLocale}__${key}`;
    if (!entry_lib_no_default_isEmptyObject(overrides)) {
        id = `${id}__${JSON.stringify(overrides)}`;
    }
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, entry_lib_no_default_shared_assign({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */
const entry_lib_no_default_NUMBER_FORMAT_OPTIONS_KEYS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'currencySign',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'compactDisplay',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'roundingMode',
    'roundingPriority',
    'roundingIncrement',
    'trailingZeroDisplay'
];
/** @internal */
function entry_lib_no_default_parseNumberArgs(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = entry_lib_no_default_shared_create();
    let overrides = entry_lib_no_default_shared_create();
    if (!entry_lib_no_default_isNumber(arg1)) {
        throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.INVALID_ARGUMENT);
    }
    const value = arg1;
    if (entry_lib_no_default_shared_isString(arg2)) {
        options.key = arg2;
    }
    else if (entry_lib_no_default_isPlainObject(arg2)) {
        Object.keys(arg2).forEach(key => {
            if (entry_lib_no_default_NUMBER_FORMAT_OPTIONS_KEYS.includes(key)) {
                overrides[key] = arg2[key];
            }
            else {
                options[key] = arg2[key];
            }
        });
    }
    if (entry_lib_no_default_shared_isString(arg3)) {
        options.locale = arg3;
    }
    else if (entry_lib_no_default_isPlainObject(arg3)) {
        overrides = arg3;
    }
    if (entry_lib_no_default_isPlainObject(arg4)) {
        overrides = arg4;
    }
    return [options.key || '', value, options, overrides];
}
/** @internal */
function entry_lib_no_default_clearNumberFormat(ctx, locale, format) {
    const context = ctx;
    for (const key in format) {
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) {
            continue;
        }
        context.__numberFormatters.delete(id);
    }
}

const entry_lib_no_default_DEFAULT_MODIFIER = (str) => str;
const entry_lib_no_default_DEFAULT_MESSAGE = (ctx) => ''; // eslint-disable-line
const entry_lib_no_default_DEFAULT_MESSAGE_DATA_TYPE = 'text';
const entry_lib_no_default_DEFAULT_NORMALIZE = (values) => values.length === 0 ? '' : entry_lib_no_default_join(values);
const entry_lib_no_default_DEFAULT_INTERPOLATE = entry_lib_no_default_toDisplayString;
function entry_lib_no_default_pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) {
        // prettier-ignore
        return choice
            ? choice > 1
                ? 1
                : 0
            : 1;
    }
    return choice ? Math.min(choice, 2) : 0;
}
function entry_lib_no_default_getPluralIndex(options) {
    // prettier-ignore
    const index = entry_lib_no_default_isNumber(options.pluralIndex)
        ? options.pluralIndex
        : -1;
    // prettier-ignore
    return options.named && (entry_lib_no_default_isNumber(options.named.count) || entry_lib_no_default_isNumber(options.named.n))
        ? entry_lib_no_default_isNumber(options.named.count)
            ? options.named.count
            : entry_lib_no_default_isNumber(options.named.n)
                ? options.named.n
                : index
        : index;
}
function entry_lib_no_default_normalizeNamed(pluralIndex, props) {
    if (!props.count) {
        props.count = pluralIndex;
    }
    if (!props.n) {
        props.n = pluralIndex;
    }
}
function entry_lib_no_default_createMessageContext(options = {}) {
    const locale = options.locale;
    const pluralIndex = entry_lib_no_default_getPluralIndex(options);
    const pluralRule = entry_lib_no_default_shared_isObject(options.pluralRules) &&
        entry_lib_no_default_shared_isString(locale) &&
        entry_lib_no_default_shared_isFunction(options.pluralRules[locale])
        ? options.pluralRules[locale]
        : entry_lib_no_default_pluralDefault;
    const orgPluralRule = entry_lib_no_default_shared_isObject(options.pluralRules) &&
        entry_lib_no_default_shared_isString(locale) &&
        entry_lib_no_default_shared_isFunction(options.pluralRules[locale])
        ? entry_lib_no_default_pluralDefault
        : undefined;
    const plural = (messages) => {
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index) => _list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || entry_lib_no_default_shared_create();
    entry_lib_no_default_isNumber(options.pluralIndex) && entry_lib_no_default_normalizeNamed(pluralIndex, _named);
    const named = (key) => _named[key];
    function message(key, useLinked) {
        // prettier-ignore
        const msg = entry_lib_no_default_shared_isFunction(options.messages)
            ? options.messages(key, !!useLinked)
            : entry_lib_no_default_shared_isObject(options.messages)
                ? options.messages[key]
                : false;
        return !msg
            ? options.parent
                ? options.parent.message(key) // resolve from parent messages
                : entry_lib_no_default_DEFAULT_MESSAGE
            : msg;
    }
    const _modifier = (name) => options.modifiers
        ? options.modifiers[name]
        : entry_lib_no_default_DEFAULT_MODIFIER;
    const normalize = entry_lib_no_default_isPlainObject(options.processor) && entry_lib_no_default_shared_isFunction(options.processor.normalize)
        ? options.processor.normalize
        : entry_lib_no_default_DEFAULT_NORMALIZE;
    const interpolate = entry_lib_no_default_isPlainObject(options.processor) &&
        entry_lib_no_default_shared_isFunction(options.processor.interpolate)
        ? options.processor.interpolate
        : entry_lib_no_default_DEFAULT_INTERPOLATE;
    const type = entry_lib_no_default_isPlainObject(options.processor) && entry_lib_no_default_shared_isString(options.processor.type)
        ? options.processor.type
        : entry_lib_no_default_DEFAULT_MESSAGE_DATA_TYPE;
    const linked = (key, ...args) => {
        const [arg1, arg2] = args;
        let type = 'text';
        let modifier = '';
        if (args.length === 1) {
            if (entry_lib_no_default_shared_isObject(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            }
            else if (entry_lib_no_default_shared_isString(arg1)) {
                modifier = arg1 || modifier;
            }
        }
        else if (args.length === 2) {
            if (entry_lib_no_default_shared_isString(arg1)) {
                modifier = arg1 || modifier;
            }
            if (entry_lib_no_default_shared_isString(arg2)) {
                type = arg2 || type;
            }
        }
        const ret = message(key, true)(ctx);
        const msg = 
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type === 'vnode' && entry_lib_no_default_shared_isArray(ret) && modifier
            ? ret[0]
            : ret;
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* HelperNameMap.LIST */]: list,
        ["named" /* HelperNameMap.NAMED */]: named,
        ["plural" /* HelperNameMap.PLURAL */]: plural,
        ["linked" /* HelperNameMap.LINKED */]: linked,
        ["message" /* HelperNameMap.MESSAGE */]: message,
        ["type" /* HelperNameMap.TYPE */]: type,
        ["interpolate" /* HelperNameMap.INTERPOLATE */]: interpolate,
        ["normalize" /* HelperNameMap.NORMALIZE */]: normalize,
        ["values" /* HelperNameMap.VALUES */]: entry_lib_no_default_shared_assign(entry_lib_no_default_shared_create(), _list, _named)
    };
    return ctx;
}

const entry_lib_no_default_NOOP_MESSAGE_FUNCTION = () => '';
const entry_lib_no_default_isMessageFunction = (val) => entry_lib_no_default_shared_isFunction(val);
// implementation of `translate` function
function entry_lib_no_default_translate(context, ...args) {
    const { fallbackFormat, postTranslation, unresolving, messageCompiler, fallbackLocale, messages } = context;
    const [key, options] = entry_lib_no_default_parseTranslateArgs(...args);
    const missingWarn = entry_lib_no_default_shared_isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = entry_lib_no_default_shared_isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const escapeParameter = entry_lib_no_default_shared_isBoolean(options.escapeParameter)
        ? options.escapeParameter
        : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = entry_lib_no_default_shared_isString(options.default) || entry_lib_no_default_shared_isBoolean(options.default) // default by function option
        ? !entry_lib_no_default_shared_isBoolean(options.default)
            ? options.default
            : (!messageCompiler ? () => key : key)
        : fallbackFormat // default by `fallbackFormat` option
            ? (!messageCompiler ? () => key : key)
            : null;
    const enableDefaultMsg = fallbackFormat ||
        (defaultMsgOrKey != null &&
            (entry_lib_no_default_shared_isString(defaultMsgOrKey) || entry_lib_no_default_shared_isFunction(defaultMsgOrKey)));
    const locale = entry_lib_no_default_getLocale(context, options);
    // escape params
    escapeParameter && entry_lib_no_default_escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage
        ? entry_lib_no_default_resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn)
        : [
            key,
            locale,
            messages[locale] || entry_lib_no_default_shared_create()
        ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage &&
        !(entry_lib_no_default_shared_isString(format) ||
            entry_lib_no_default_core_base_isMessageAST(format) ||
            entry_lib_no_default_isMessageFunction(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage &&
        (!(entry_lib_no_default_shared_isString(format) ||
            entry_lib_no_default_core_base_isMessageAST(format) ||
            entry_lib_no_default_isMessageFunction(format)) ||
            !entry_lib_no_default_shared_isString(targetLocale))) {
        return unresolving ? entry_lib_no_default_NOT_REOSLVED : key;
    }
    // TODO: refactor
    if (false) {}
    // setup compile error detecting
    let occurred = false;
    const onError = () => {
        occurred = true;
    };
    // compile message format
    const msg = !entry_lib_no_default_isMessageFunction(format)
        ? entry_lib_no_default_compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError)
        : format;
    // if occurred compile error, return the message format
    if (occurred) {
        return format;
    }
    // evaluate message with context
    const ctxOptions = entry_lib_no_default_getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = entry_lib_no_default_createMessageContext(ctxOptions);
    const messaged = entry_lib_no_default_evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation
        ? postTranslation(messaged, key)
        : messaged;
    // NOTE: experimental !!
    if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: entry_lib_no_default_shared_isString(key)
                ? key
                : entry_lib_no_default_isMessageFunction(format)
                    ? format.key
                    : '',
            locale: targetLocale || (entry_lib_no_default_isMessageFunction(format)
                ? format.locale
                : ''),
            format: entry_lib_no_default_shared_isString(format)
                ? format
                : entry_lib_no_default_isMessageFunction(format)
                    ? format.source
                    : '',
            message: ret
        };
        payloads.meta = entry_lib_no_default_shared_assign({}, context.__meta, entry_lib_no_default_getAdditionalMeta() || {});
        entry_lib_no_default_translateDevTools(payloads);
    }
    return ret;
}
function entry_lib_no_default_escapeParams(options) {
    if (entry_lib_no_default_shared_isArray(options.list)) {
        options.list = options.list.map(item => entry_lib_no_default_shared_isString(item) ? entry_lib_no_default_escapeHtml(item) : item);
    }
    else if (entry_lib_no_default_shared_isObject(options.named)) {
        Object.keys(options.named).forEach(key => {
            if (entry_lib_no_default_shared_isString(options.named[key])) {
                options.named[key] = entry_lib_no_default_escapeHtml(options.named[key]);
            }
        });
    }
}
function entry_lib_no_default_resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages, onWarn, messageResolver: resolveValue, localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = entry_lib_no_default_shared_create();
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'translate';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if (false) {}
        // for vue-devtools timeline event
        if (false) {}
        message =
            messages[targetLocale] || entry_lib_no_default_shared_create();
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if (false) {}
        if ((format = resolveValue(message, key)) === null) {
            // if null, resolve with object key path
            format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        }
        // for vue-devtools timeline event
        if (false) {}
        if (entry_lib_no_default_shared_isString(format) || entry_lib_no_default_core_base_isMessageAST(format) || entry_lib_no_default_isMessageFunction(format)) {
            break;
        }
        if (!entry_lib_no_default_isImplicitFallback(targetLocale, locales)) {
            const missingRet = entry_lib_no_default_handleMissing(context, // eslint-disable-line @typescript-eslint/no-explicit-any
            key, targetLocale, missingWarn, type);
            if (missingRet !== key) {
                format = missingRet;
            }
        }
        from = to;
    }
    return [format, targetLocale, message];
}
function entry_lib_no_default_compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) {
    const { messageCompiler, warnHtmlMessage } = context;
    if (entry_lib_no_default_isMessageFunction(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = (() => format);
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    if (false) {}
    const msg = messageCompiler(format, entry_lib_no_default_getCompileContext(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, onError));
    // for vue-devtools timeline event
    if (false) {}
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function entry_lib_no_default_evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    if (false) {}
    const messaged = msg(msgCtx);
    // for vue-devtools timeline event
    if (false) {}
    return messaged;
}
/** @internal */
function entry_lib_no_default_parseTranslateArgs(...args) {
    const [arg1, arg2, arg3] = args;
    const options = entry_lib_no_default_shared_create();
    if (!entry_lib_no_default_shared_isString(arg1) &&
        !entry_lib_no_default_isNumber(arg1) &&
        !entry_lib_no_default_isMessageFunction(arg1) &&
        !entry_lib_no_default_core_base_isMessageAST(arg1)) {
        throw entry_lib_no_default_createCoreError(entry_lib_no_default_CoreErrorCodes.INVALID_ARGUMENT);
    }
    // prettier-ignore
    const key = entry_lib_no_default_isNumber(arg1)
        ? String(arg1)
        : entry_lib_no_default_isMessageFunction(arg1)
            ? arg1
            : arg1;
    if (entry_lib_no_default_isNumber(arg2)) {
        options.plural = arg2;
    }
    else if (entry_lib_no_default_shared_isString(arg2)) {
        options.default = arg2;
    }
    else if (entry_lib_no_default_isPlainObject(arg2) && !entry_lib_no_default_isEmptyObject(arg2)) {
        options.named = arg2;
    }
    else if (entry_lib_no_default_shared_isArray(arg2)) {
        options.list = arg2;
    }
    if (entry_lib_no_default_isNumber(arg3)) {
        options.plural = arg3;
    }
    else if (entry_lib_no_default_shared_isString(arg3)) {
        options.default = arg3;
    }
    else if (entry_lib_no_default_isPlainObject(arg3)) {
        entry_lib_no_default_shared_assign(options, arg3);
    }
    return [key, options];
}
function entry_lib_no_default_getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
    return {
        locale,
        key,
        warnHtmlMessage,
        onError: (err) => {
            onError && onError(err);
            if ((false)) {}
            else {
                throw err;
            }
        },
        onCacheKey: (source) => entry_lib_no_default_generateFormatCacheKey(locale, key, source)
    };
}
function entry_lib_no_default_getSourceForCodeFrame(source) {
    if (isString(source)) {
        return source;
    }
    else {
        if (source.loc && source.loc.source) {
            return source.loc.source;
        }
    }
}
function entry_lib_no_default_getMessageContextOptions(context, locale, message, options) {
    const { modifiers, pluralRules, messageResolver: resolveValue, fallbackLocale, fallbackWarn, missingWarn, fallbackContext } = context;
    const resolveMessage = (key, useLinked) => {
        let val = resolveValue(message, key);
        // fallback
        if (val == null && (fallbackContext || useLinked)) {
            const [, , message] = entry_lib_no_default_resolveMessageFormat(fallbackContext || context, // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
            key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if (entry_lib_no_default_shared_isString(val) || entry_lib_no_default_core_base_isMessageAST(val)) {
            let occurred = false;
            const onError = () => {
                occurred = true;
            };
            const msg = entry_lib_no_default_compileMessageFormat(context, key, locale, val, key, onError);
            return !occurred
                ? msg
                : entry_lib_no_default_NOOP_MESSAGE_FUNCTION;
        }
        else if (entry_lib_no_default_isMessageFunction(val)) {
            return val;
        }
        else {
            // TODO: should be implemented warning message
            return entry_lib_no_default_NOOP_MESSAGE_FUNCTION;
        }
    };
    const ctxOptions = {
        locale,
        modifiers,
        pluralRules,
        messages: resolveMessage
    };
    if (context.processor) {
        ctxOptions.processor = context.processor;
    }
    if (options.list) {
        ctxOptions.list = options.list;
    }
    if (options.named) {
        ctxOptions.named = options.named;
    }
    if (entry_lib_no_default_isNumber(options.plural)) {
        ctxOptions.pluralIndex = options.plural;
    }
    return ctxOptions;
}

{
    entry_lib_no_default_initFeatureFlags();
}



;// ../../libs/i18n/node_modules/vue-i18n/dist/vue-i18n.mjs
/*!
  * vue-i18n v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */





/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */
const entry_lib_no_default_vue_i18n_VERSION = '10.0.5';
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */
function entry_lib_no_default_vue_i18n_initFeatureFlags() {
    if (typeof __VUE_I18N_FULL_INSTALL__ !== 'boolean') {
        entry_lib_no_default_getGlobalThis().__VUE_I18N_FULL_INSTALL__ = true;
    }
    if (typeof __VUE_I18N_LEGACY_API__ !== 'boolean') {
        entry_lib_no_default_getGlobalThis().__VUE_I18N_LEGACY_API__ = true;
    }
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== 'boolean') {
        entry_lib_no_default_getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    }
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') {
        entry_lib_no_default_getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
}

const entry_lib_no_default_I18nWarnCodes = {
    FALLBACK_TO_ROOT: entry_lib_no_default_CORE_WARN_CODES_EXTEND_POINT, // 8
    NOT_FOUND_PARENT_SCOPE: 9,
    IGNORE_OBJ_FLATTEN: 10,
    DEPRECATE_TC: 11
};
const entry_lib_no_default_vue_i18n_warnMessages = {
    [entry_lib_no_default_I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [entry_lib_no_default_I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`,
    [entry_lib_no_default_I18nWarnCodes.IGNORE_OBJ_FLATTEN]: `Ignore object flatten: '{key}' key has an string value`,
    [entry_lib_no_default_I18nWarnCodes.DEPRECATE_TC]: `'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc’ are going to remove in v11.`
};
function entry_lib_no_default_vue_i18n_getWarnMessage(code, ...args) {
    return format(entry_lib_no_default_vue_i18n_warnMessages[code], ...args);
}

const entry_lib_no_default_I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: entry_lib_no_default_CORE_ERROR_CODES_EXTEND_POINT, // 24
    // legacy module errors
    INVALID_ARGUMENT: 25,
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: 26,
    NOT_INSTALLED: 27,
    // directive module errors
    REQUIRED_VALUE: 28,
    INVALID_VALUE: 29,
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
    NOT_INSTALLED_WITH_PROVIDE: 31,
    // unexpected error
    UNEXPECTED_ERROR: 32,
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function entry_lib_no_default_createI18nError(code, ...args) {
    return entry_lib_no_default_createCompileError(code, null, ( false) ? 0 : undefined);
}
const entry_lib_no_default_vue_i18n_errorMessages = {
    [entry_lib_no_default_I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: 'Unexpected return type in composer',
    [entry_lib_no_default_I18nErrorCodes.INVALID_ARGUMENT]: 'Invalid argument',
    [entry_lib_no_default_I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: 'Must be called at the top of a `setup` function',
    [entry_lib_no_default_I18nErrorCodes.NOT_INSTALLED]: 'Need to install with `app.use` function',
    [entry_lib_no_default_I18nErrorCodes.UNEXPECTED_ERROR]: 'Unexpected error',
    [entry_lib_no_default_I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [entry_lib_no_default_I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [entry_lib_no_default_I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [entry_lib_no_default_I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: 'Need to install with `provide` function',
    [entry_lib_no_default_I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: 'Not compatible legacy VueI18n.',
    [entry_lib_no_default_I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: 'Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly'
};

const entry_lib_no_default_TranslateVNodeSymbol = 
/* #__PURE__*/ entry_lib_no_default_shared_makeSymbol('__translateVNode');
const entry_lib_no_default_DatetimePartsSymbol = /* #__PURE__*/ entry_lib_no_default_shared_makeSymbol('__datetimeParts');
const entry_lib_no_default_NumberPartsSymbol = /* #__PURE__*/ entry_lib_no_default_shared_makeSymbol('__numberParts');
const entry_lib_no_default_EnableEmitter = /* #__PURE__*/ (/* unused pure expression or super */ null && (makeSymbol('__enableEmitter')));
const entry_lib_no_default_DisableEmitter = /* #__PURE__*/ (/* unused pure expression or super */ null && (makeSymbol('__disableEmitter')));
const entry_lib_no_default_SetPluralRulesSymbol = entry_lib_no_default_shared_makeSymbol('__setPluralRules');
entry_lib_no_default_shared_makeSymbol('__intlifyMeta');
const entry_lib_no_default_InejctWithOptionSymbol = 
/* #__PURE__*/ entry_lib_no_default_shared_makeSymbol('__injectWithOption');
const entry_lib_no_default_DisposeSymbol = /* #__PURE__*/ entry_lib_no_default_shared_makeSymbol('__dispose');

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Transform flat json in obj to normal json in obj
 */
function entry_lib_no_default_handleFlatJson(obj) {
    // check obj
    if (!entry_lib_no_default_shared_isObject(obj)) {
        return obj;
    }
    for (const key in obj) {
        // check key
        if (!entry_lib_no_default_hasOwn(obj, key)) {
            continue;
        }
        // handle for normal json
        if (!key.includes('.')) {
            // recursive process value if value is also a object
            if (entry_lib_no_default_shared_isObject(obj[key])) {
                entry_lib_no_default_handleFlatJson(obj[key]);
            }
        }
        // handle for flat json, transform to normal json
        else {
            // go to the last object
            const subKeys = key.split('.');
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            let hasStringValue = false;
            for (let i = 0; i < lastIndex; i++) {
                if (!(subKeys[i] in currentObj)) {
                    currentObj[subKeys[i]] = entry_lib_no_default_shared_create();
                }
                if (!entry_lib_no_default_shared_isObject(currentObj[subKeys[i]])) {
                    ( false) &&
                        0;
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                currentObj[subKeys[lastIndex]] = obj[key];
                delete obj[key];
            }
            // recursive process value if value is also a object
            if (entry_lib_no_default_shared_isObject(currentObj[subKeys[lastIndex]])) {
                entry_lib_no_default_handleFlatJson(currentObj[subKeys[lastIndex]]);
            }
        }
    }
    return obj;
}
function entry_lib_no_default_getLocaleMessages(locale, options) {
    const { messages, __i18n, messageResolver, flatJson } = options;
    // prettier-ignore
    const ret = (entry_lib_no_default_isPlainObject(messages)
        ? messages
        : entry_lib_no_default_shared_isArray(__i18n)
            ? entry_lib_no_default_shared_create()
            : { [locale]: entry_lib_no_default_shared_create() });
    // merge locale messages of i18n custom block
    if (entry_lib_no_default_shared_isArray(__i18n)) {
        __i18n.forEach(custom => {
            if ('locale' in custom && 'resource' in custom) {
                const { locale, resource } = custom;
                if (locale) {
                    ret[locale] = ret[locale] || entry_lib_no_default_shared_create();
                    entry_lib_no_default_deepCopy(resource, ret[locale]);
                }
                else {
                    entry_lib_no_default_deepCopy(resource, ret);
                }
            }
            else {
                entry_lib_no_default_shared_isString(custom) && entry_lib_no_default_deepCopy(JSON.parse(custom), ret);
            }
        });
    }
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for (const key in ret) {
            if (entry_lib_no_default_hasOwn(ret, key)) {
                entry_lib_no_default_handleFlatJson(ret[key]);
            }
        }
    }
    return ret;
}
function entry_lib_no_default_getComponentOptions(instance) {
    return instance.type;
}
function entry_lib_no_default_adjustI18nResources(gl, options, componentOptions) {
    // prettier-ignore
    let messages = entry_lib_no_default_shared_isObject(options.messages)
        ? options.messages
        : entry_lib_no_default_shared_create();
    if ('__i18nGlobal' in componentOptions) {
        messages = entry_lib_no_default_getLocaleMessages(gl.locale.value, {
            messages,
            __i18n: componentOptions.__i18nGlobal
        });
    }
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) {
        locales.forEach(locale => {
            gl.mergeLocaleMessage(locale, messages[locale]);
        });
    }
    {
        // merge datetime formats
        if (entry_lib_no_default_shared_isObject(options.datetimeFormats)) {
            const locales = Object.keys(options.datetimeFormats);
            if (locales.length) {
                locales.forEach(locale => {
                    gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
                });
            }
        }
        // merge number formats
        if (entry_lib_no_default_shared_isObject(options.numberFormats)) {
            const locales = Object.keys(options.numberFormats);
            if (locales.length) {
                locales.forEach(locale => {
                    gl.mergeNumberFormat(locale, options.numberFormats[locale]);
                });
            }
        }
    }
}
function entry_lib_no_default_createTextNode(key) {
    return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.Text, null, key, 0);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
// extend VNode interface
const entry_lib_no_default_DEVTOOLS_META = '__INTLIFY_META__';
const entry_lib_no_default_NOOP_RETURN_ARRAY = () => [];
const entry_lib_no_default_NOOP_RETURN_FALSE = () => false;
let entry_lib_no_default_composerID = 0;
function entry_lib_no_default_defineCoreMissingHandler(missing) {
    return ((ctx, locale, key, type) => {
        return missing(locale, key, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentInstance)() || undefined, type);
    });
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */
const entry_lib_no_default_getMetaInfo = () => {
    const instance = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentInstance)();
    let meta = null;
    return instance && (meta = entry_lib_no_default_getComponentOptions(instance)[entry_lib_no_default_DEVTOOLS_META])
        ? { [entry_lib_no_default_DEVTOOLS_META]: meta }
        : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */
function entry_lib_no_default_createComposer(options = {}) {
    const { __root, __injectWithOption } = options;
    const _isGlobal = __root === undefined;
    const flatJson = options.flatJson;
    const _ref = entry_lib_no_default_inBrowser ? entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.ref : entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.shallowRef;
    let _inheritLocale = entry_lib_no_default_shared_isBoolean(options.inheritLocale)
        ? options.inheritLocale
        : true;
    const _locale = _ref(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.locale.value
        : entry_lib_no_default_shared_isString(options.locale)
            ? options.locale
            : entry_lib_no_default_DEFAULT_LOCALE);
    const _fallbackLocale = _ref(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.fallbackLocale.value
        : entry_lib_no_default_shared_isString(options.fallbackLocale) ||
            entry_lib_no_default_shared_isArray(options.fallbackLocale) ||
            entry_lib_no_default_isPlainObject(options.fallbackLocale) ||
            options.fallbackLocale === false
            ? options.fallbackLocale
            : _locale.value);
    const _messages = _ref(entry_lib_no_default_getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = _ref(entry_lib_no_default_isPlainObject(options.datetimeFormats)
            ? options.datetimeFormats
            : { [_locale.value]: {} })
        ;
    // prettier-ignore
    const _numberFormats = _ref(entry_lib_no_default_isPlainObject(options.numberFormats)
            ? options.numberFormats
            : { [_locale.value]: {} })
        ;
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root
        ? __root.missingWarn
        : entry_lib_no_default_shared_isBoolean(options.missingWarn) || entry_lib_no_default_isRegExp(options.missingWarn)
            ? options.missingWarn
            : true;
    // prettier-ignore
    let _fallbackWarn = __root
        ? __root.fallbackWarn
        : entry_lib_no_default_shared_isBoolean(options.fallbackWarn) || entry_lib_no_default_isRegExp(options.fallbackWarn)
            ? options.fallbackWarn
            : true;
    // prettier-ignore
    let _fallbackRoot = __root
        ? __root.fallbackRoot
        : entry_lib_no_default_shared_isBoolean(options.fallbackRoot)
            ? options.fallbackRoot
            : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = entry_lib_no_default_shared_isFunction(options.missing) ? options.missing : null;
    let _runtimeMissing = entry_lib_no_default_shared_isFunction(options.missing)
        ? entry_lib_no_default_defineCoreMissingHandler(options.missing)
        : null;
    // postTranslation handler
    let _postTranslation = entry_lib_no_default_shared_isFunction(options.postTranslation)
        ? options.postTranslation
        : null;
    // prettier-ignore
    let _warnHtmlMessage = __root
        ? __root.warnHtmlMessage
        : entry_lib_no_default_shared_isBoolean(options.warnHtmlMessage)
            ? options.warnHtmlMessage
            : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root
        ? __root.modifiers
        : entry_lib_no_default_isPlainObject(options.modifiers)
            ? options.modifiers
            : {};
    // pluralRules
    let _pluralRules = options.pluralRules || (__root && __root.pluralRules);
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = () => {
        _isGlobal && entry_lib_no_default_setFallbackContext(null);
        const ctxOptions = {
            version: entry_lib_no_default_vue_i18n_VERSION,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: { framework: 'vue' }
        };
        {
            ctxOptions.datetimeFormats = _datetimeFormats.value;
            ctxOptions.numberFormats = _numberFormats.value;
            ctxOptions.__datetimeFormatters = entry_lib_no_default_isPlainObject(_context)
                ? _context.__datetimeFormatters
                : undefined;
            ctxOptions.__numberFormatters = entry_lib_no_default_isPlainObject(_context)
                ? _context.__numberFormatters
                : undefined;
        }
        if ((false)) {}
        const ctx = entry_lib_no_default_createCoreContext(ctxOptions);
        _isGlobal && entry_lib_no_default_setFallbackContext(ctx);
        return ctx;
    };
    _context = getCoreContext();
    entry_lib_no_default_updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
                _locale.value,
                _fallbackLocale.value,
                _messages.value,
                _datetimeFormats.value,
                _numberFormats.value
            ]
            ;
    }
    // locale
    const locale = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
        get: () => _locale.value,
        set: val => {
            _locale.value = val;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)({
        get: () => _fallbackLocale.value,
        set: val => {
            _fallbackLocale.value = val;
            _context.fallbackLocale = _fallbackLocale.value;
            entry_lib_no_default_updateFallbackLocale(_context, _locale.value, val);
        }
    });
    // messages
    const messages = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => _messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => _datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => _numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return entry_lib_no_default_shared_isFunction(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler) {
        _postTranslation = handler;
        _context.postTranslation = handler;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler) {
        if (handler !== null) {
            _runtimeMissing = entry_lib_no_default_defineCoreMissingHandler(handler);
        }
        _missing = handler;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg) {
        return type !== 'translate' || !arg.resolvedMessage;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) => {
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        try {
            if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
                entry_lib_no_default_setAdditionalMeta(entry_lib_no_default_getMetaInfo());
            }
            if (!_isGlobal) {
                _context.fallbackContext = __root
                    ? entry_lib_no_default_getFallbackContext()
                    : undefined;
            }
            ret = fn(_context);
        }
        finally {
            if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
                entry_lib_no_default_setAdditionalMeta(null);
            }
            if (!_isGlobal) {
                _context.fallbackContext = undefined;
            }
        }
        if ((warnType !== 'translate exists' && // for not `te` (e.g `t`)
            entry_lib_no_default_isNumber(ret) &&
            ret === entry_lib_no_default_NOT_REOSLVED) ||
            (warnType === 'translate exists' && !ret) // for `te`
        ) {
            const [key, arg2] = argumentParser();
            if (false) {}
            return __root && _fallbackRoot
                ? fallbackSuccess(__root)
                : fallbackFail(key);
        }
        else if (successCondition(ret)) {
            return ret;
        }
        else {
            /* istanbul ignore next */
            throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
        }
    };
    // t
    function t(...args) {
        return wrapWithDeps(context => Reflect.apply(entry_lib_no_default_translate, null, [context, ...args]), () => entry_lib_no_default_parseTranslateArgs(...args), 'translate', root => Reflect.apply(root.t, root, [...args]), key => key, val => entry_lib_no_default_shared_isString(val));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !entry_lib_no_default_shared_isObject(arg3)) {
            throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.INVALID_ARGUMENT);
        }
        return t(...[arg1, arg2, entry_lib_no_default_shared_assign({ resolvedMessage: true }, arg3 || {})]);
    }
    // d
    function d(...args) {
        return wrapWithDeps(context => Reflect.apply(entry_lib_no_default_datetime, null, [context, ...args]), () => entry_lib_no_default_parseDateTimeArgs(...args), 'datetime format', root => Reflect.apply(root.d, root, [...args]), () => entry_lib_no_default_MISSING_RESOLVE_VALUE, val => entry_lib_no_default_shared_isString(val));
    }
    // n
    function n(...args) {
        return wrapWithDeps(context => Reflect.apply(entry_lib_no_default_number, null, [context, ...args]), () => entry_lib_no_default_parseNumberArgs(...args), 'number format', root => Reflect.apply(root.n, root, [...args]), () => entry_lib_no_default_MISSING_RESOLVE_VALUE, val => entry_lib_no_default_shared_isString(val));
    }
    // for custom processor
    function normalize(values) {
        return values.map(val => entry_lib_no_default_shared_isString(val) || entry_lib_no_default_isNumber(val) || entry_lib_no_default_shared_isBoolean(val)
            ? entry_lib_no_default_createTextNode(String(val))
            : val);
    }
    const interpolate = (val) => val;
    const processor = {
        normalize,
        interpolate,
        type: 'vnode'
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode(...args) {
        return wrapWithDeps(context => {
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply(entry_lib_no_default_translate, null, [_context, ...args]);
            }
            finally {
                _context.processor = null;
            }
            return ret;
        }, () => entry_lib_no_default_parseTranslateArgs(...args), 'translate', root => root[entry_lib_no_default_TranslateVNodeSymbol](...args), key => [entry_lib_no_default_createTextNode(key)], val => entry_lib_no_default_shared_isArray(val));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps(context => Reflect.apply(entry_lib_no_default_number, null, [context, ...args]), () => entry_lib_no_default_parseNumberArgs(...args), 'number format', root => root[entry_lib_no_default_NumberPartsSymbol](...args), entry_lib_no_default_NOOP_RETURN_ARRAY, val => entry_lib_no_default_shared_isString(val) || entry_lib_no_default_shared_isArray(val));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps(context => Reflect.apply(entry_lib_no_default_datetime, null, [context, ...args]), () => entry_lib_no_default_parseDateTimeArgs(...args), 'datetime format', root => root[entry_lib_no_default_DatetimePartsSymbol](...args), entry_lib_no_default_NOOP_RETURN_ARRAY, val => entry_lib_no_default_shared_isString(val) || entry_lib_no_default_shared_isArray(val));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(() => {
            if (!key) {
                return false;
            }
            const targetLocale = entry_lib_no_default_shared_isString(locale) ? locale : _locale.value;
            const message = getLocaleMessage(targetLocale);
            const resolved = _context.messageResolver(message, key);
            return (entry_lib_no_default_core_base_isMessageAST(resolved) ||
                entry_lib_no_default_isMessageFunction(resolved) ||
                entry_lib_no_default_shared_isString(resolved));
        }, () => [key], 'translate exists', root => {
            return Reflect.apply(root.te, root, [key, locale]);
        }, entry_lib_no_default_NOOP_RETURN_FALSE, val => entry_lib_no_default_shared_isBoolean(val));
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = entry_lib_no_default_fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
        for (let i = 0; i < locales.length; i++) {
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null
            ? messages
            : __root
                ? __root.tm(key) || {}
                : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return (_messages.value[locale] || {});
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        if (flatJson) {
            const _message = { [locale]: message };
            for (const key in _message) {
                if (entry_lib_no_default_hasOwn(_message, key)) {
                    entry_lib_no_default_handleFlatJson(_message[key]);
                }
            }
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        const _message = { [locale]: message };
        if (flatJson) {
            for (const key in _message) {
                if (entry_lib_no_default_hasOwn(_message, key)) {
                    entry_lib_no_default_handleFlatJson(_message[key]);
                }
            }
        }
        message = _message[locale];
        entry_lib_no_default_deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        entry_lib_no_default_clearDateTimeFormat(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = entry_lib_no_default_shared_assign(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        entry_lib_no_default_clearDateTimeFormat(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        entry_lib_no_default_clearNumberFormat(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = entry_lib_no_default_shared_assign(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        entry_lib_no_default_clearNumberFormat(_context, locale, format);
    }
    // for debug
    entry_lib_no_default_composerID++;
    // watch root locale & fallbackLocale
    if (__root && entry_lib_no_default_inBrowser) {
        (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(__root.locale, (val) => {
            if (_inheritLocale) {
                _locale.value = val;
                _context.locale = val;
                entry_lib_no_default_updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(__root.fallbackLocale, (val) => {
            if (_inheritLocale) {
                _fallbackLocale.value = val;
                _context.fallbackLocale = val;
                entry_lib_no_default_updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: entry_lib_no_default_composerID,
        locale,
        fallbackLocale,
        get inheritLocale() {
            return _inheritLocale;
        },
        set inheritLocale(val) {
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                entry_lib_no_default_updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales() {
            return Object.keys(_messages.value).sort();
        },
        messages,
        get modifiers() {
            return _modifiers;
        },
        get pluralRules() {
            return _pluralRules || {};
        },
        get isGlobal() {
            return _isGlobal;
        },
        get missingWarn() {
            return _missingWarn;
        },
        set missingWarn(val) {
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn() {
            return _fallbackWarn;
        },
        set fallbackWarn(val) {
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot() {
            return _fallbackRoot;
        },
        set fallbackRoot(val) {
            _fallbackRoot = val;
        },
        get fallbackFormat() {
            return _fallbackFormat;
        },
        set fallbackFormat(val) {
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage() {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage(val) {
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter() {
            return _escapeParameter;
        },
        set escapeParameter(val) {
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t,
        getLocaleMessage,
        setLocaleMessage,
        mergeLocaleMessage,
        getPostTranslationHandler,
        setPostTranslationHandler,
        getMissingHandler,
        setMissingHandler,
        [entry_lib_no_default_SetPluralRulesSymbol]: setPluralRules
    };
    {
        composer.datetimeFormats = datetimeFormats;
        composer.numberFormats = numberFormats;
        composer.rt = rt;
        composer.te = te;
        composer.tm = tm;
        composer.d = d;
        composer.n = n;
        composer.getDateTimeFormat = getDateTimeFormat;
        composer.setDateTimeFormat = setDateTimeFormat;
        composer.mergeDateTimeFormat = mergeDateTimeFormat;
        composer.getNumberFormat = getNumberFormat;
        composer.setNumberFormat = setNumberFormat;
        composer.mergeNumberFormat = mergeNumberFormat;
        composer[entry_lib_no_default_InejctWithOptionSymbol] = __injectWithOption;
        composer[entry_lib_no_default_TranslateVNodeSymbol] = translateVNode;
        composer[entry_lib_no_default_DatetimePartsSymbol] = datetimeParts;
        composer[entry_lib_no_default_NumberPartsSymbol] = numberParts;
    }
    // for vue-devtools timeline event
    if ((false)) {}
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const entry_lib_no_default_VUE_I18N_COMPONENT_TYPES = 'vue-i18n: composer properties';
const entry_lib_no_default_VueDevToolsLabels = {
    'vue-devtools-plugin-vue-i18n': 'Vue I18n DevTools',
    'vue-i18n-resource-inspector': 'Vue I18n DevTools',
    'vue-i18n-timeline': 'Vue I18n'
};
const entry_lib_no_default_VueDevToolsPlaceholders = {
    'vue-i18n-resource-inspector': 'Search for scopes ...'
};
const entry_lib_no_default_VueDevToolsTimelineColors = {
    'vue-i18n-timeline': 0xffcd19
};
let entry_lib_no_default_devtoolsApi;
async function entry_lib_no_default_enableDevTools(app, i18n) {
    return new Promise((resolve, reject) => {
        try {
            setupDevtoolsPlugin({
                id: 'vue-devtools-plugin-vue-i18n',
                label: entry_lib_no_default_VueDevToolsLabels['vue-devtools-plugin-vue-i18n'],
                packageName: 'vue-i18n',
                homepage: 'https://vue-i18n.intlify.dev',
                logo: 'https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png',
                componentStateTypes: [entry_lib_no_default_VUE_I18N_COMPONENT_TYPES],
                app: app // eslint-disable-line @typescript-eslint/no-explicit-any
            }, api => {
                entry_lib_no_default_devtoolsApi = api;
                api.on.visitComponentTree(({ componentInstance, treeNode }) => {
                    entry_lib_no_default_updateComponentTreeTags(componentInstance, treeNode, i18n);
                });
                api.on.inspectComponent(({ componentInstance, instanceData }) => {
                    if (componentInstance.vnode.el &&
                        componentInstance.vnode.el.__VUE_I18N__ &&
                        instanceData) {
                        if (i18n.mode === 'legacy') {
                            // ignore global scope on legacy mode
                            if (componentInstance.vnode.el.__VUE_I18N__ !==
                                i18n.global.__composer) {
                                entry_lib_no_default_inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                            }
                        }
                        else {
                            entry_lib_no_default_inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                        }
                    }
                });
                api.addInspector({
                    id: 'vue-i18n-resource-inspector',
                    label: entry_lib_no_default_VueDevToolsLabels['vue-i18n-resource-inspector'],
                    icon: 'language',
                    treeFilterPlaceholder: entry_lib_no_default_VueDevToolsPlaceholders['vue-i18n-resource-inspector']
                });
                api.on.getInspectorTree(payload => {
                    if (payload.app === app &&
                        payload.inspectorId === 'vue-i18n-resource-inspector') {
                        entry_lib_no_default_registerScope(payload, i18n);
                    }
                });
                const roots = new Map();
                api.on.getInspectorState(async (payload) => {
                    if (payload.app === app &&
                        payload.inspectorId === 'vue-i18n-resource-inspector') {
                        api.unhighlightElement();
                        entry_lib_no_default_inspectScope(payload, i18n);
                        if (payload.nodeId === 'global') {
                            if (!roots.has(payload.app)) {
                                const [root] = await api.getComponentInstances(payload.app);
                                roots.set(payload.app, root);
                            }
                            api.highlightElement(roots.get(payload.app));
                        }
                        else {
                            const instance = entry_lib_no_default_getComponentInstance(payload.nodeId, i18n);
                            instance && api.highlightElement(instance);
                        }
                    }
                });
                api.on.editInspectorState(payload => {
                    if (payload.app === app &&
                        payload.inspectorId === 'vue-i18n-resource-inspector') {
                        entry_lib_no_default_editScope(payload, i18n);
                    }
                });
                api.addTimelineLayer({
                    id: 'vue-i18n-timeline',
                    label: entry_lib_no_default_VueDevToolsLabels['vue-i18n-timeline'],
                    color: entry_lib_no_default_VueDevToolsTimelineColors['vue-i18n-timeline']
                });
                resolve(true);
            });
        }
        catch (e) {
            console.error(e);
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            reject(false);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function entry_lib_no_default_getI18nScopeLable(instance) {
    return (instance.type.name ||
        instance.type.displayName ||
        instance.type.__file ||
        'Anonymous');
}
function entry_lib_no_default_updateComponentTreeTags(instance, // eslint-disable-line @typescript-eslint/no-explicit-any
treeNode, i18n) {
    // prettier-ignore
    const global = i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) {
        // add custom tags local scope only
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            const tag = {
                label: `i18n (${entry_lib_no_default_getI18nScopeLable(instance)} Scope)`,
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function entry_lib_no_default_inspectComposer(instanceData, composer) {
    const type = entry_lib_no_default_VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type,
        key: 'locale',
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type,
        key: 'availableLocales',
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type,
        key: 'fallbackLocale',
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type,
        key: 'inheritLocale',
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type,
        key: 'messages',
        editable: false,
        value: entry_lib_no_default_getLocaleMessageValue(composer.messages.value)
    });
    {
        instanceData.state.push({
            type,
            key: 'datetimeFormats',
            editable: false,
            value: composer.datetimeFormats.value
        });
        instanceData.state.push({
            type,
            key: 'numberFormats',
            editable: false,
            value: composer.numberFormats.value
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function entry_lib_no_default_getLocaleMessageValue(messages) {
    const value = {};
    Object.keys(messages).forEach((key) => {
        const v = messages[key];
        if (isFunction(v) && 'source' in v) {
            value[key] = entry_lib_no_default_getMessageFunctionDetails(v);
        }
        else if (isMessageAST(v) && v.loc && v.loc.source) {
            value[key] = v.loc.source;
        }
        else if (isObject(v)) {
            value[key] = entry_lib_no_default_getLocaleMessageValue(v);
        }
        else {
            value[key] = v;
        }
    });
    return value;
}
const entry_lib_no_default_ESC = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '&': '&amp;'
};
function entry_lib_no_default_vue_i18n_escape(s) {
    return s.replace(/[<>"&]/g, entry_lib_no_default_escapeChar);
}
function entry_lib_no_default_escapeChar(a) {
    return entry_lib_no_default_ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function entry_lib_no_default_getMessageFunctionDetails(func) {
    const argString = func.source ? `("${entry_lib_no_default_vue_i18n_escape(func.source)}")` : `(?)`;
    return {
        _custom: {
            type: 'function',
            display: `<span>ƒ</span> ${argString}`
        }
    };
}
function entry_lib_no_default_registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: 'global',
        label: 'Global Scope'
    });
    // prettier-ignore
    const global = i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
    for (const [keyInstance, instance] of i18n.__instances) {
        // prettier-ignore
        const composer = i18n.mode === 'composition'
            ? instance
            : instance.__composer;
        if (global === composer) {
            continue;
        }
        payload.rootNodes.push({
            id: composer.id.toString(),
            label: `${entry_lib_no_default_getI18nScopeLable(keyInstance)} Scope`
        });
    }
}
function entry_lib_no_default_getComponentInstance(nodeId, i18n) {
    let instance = null;
    if (nodeId !== 'global') {
        for (const [component, composer] of i18n.__instances.entries()) {
            if (composer.id.toString() === nodeId) {
                instance = component;
                break;
            }
        }
    }
    return instance;
}
function entry_lib_no_default_getComposer$2(nodeId, i18n) {
    if (nodeId === 'global') {
        return i18n.mode === 'composition'
            ? i18n.global
            : i18n.global.__composer;
    }
    else {
        const instance = Array.from(i18n.__instances.values()).find(item => item.id.toString() === nodeId);
        if (instance) {
            return i18n.mode === 'composition'
                ? instance
                : instance.__composer;
        }
        else {
            return null;
        }
    }
}
function entry_lib_no_default_inspectScope(payload, i18n
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
    const composer = entry_lib_no_default_getComposer$2(payload.nodeId, i18n);
    if (composer) {
        // TODO:
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        payload.state = entry_lib_no_default_makeScopeInspectState(composer);
    }
    return null;
}
function entry_lib_no_default_makeScopeInspectState(composer) {
    const state = {};
    const localeType = 'Locale related info';
    const localeStates = [
        {
            type: localeType,
            key: 'locale',
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: 'fallbackLocale',
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: 'availableLocales',
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: 'inheritLocale',
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    const localeMessagesType = 'Locale messages info';
    const localeMessagesStates = [
        {
            type: localeMessagesType,
            key: 'messages',
            editable: false,
            value: entry_lib_no_default_getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        const datetimeFormatsType = 'Datetime formats info';
        const datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: 'datetimeFormats',
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        const numberFormatsType = 'Datetime formats info';
        const numberFormatsStates = [
            {
                type: numberFormatsType,
                key: 'numberFormats',
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function entry_lib_no_default_addTimelineEvent(event, payload) {
    if (entry_lib_no_default_devtoolsApi) {
        let groupId;
        if (payload && 'groupId' in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        entry_lib_no_default_devtoolsApi.addTimelineEvent({
            layerId: 'vue-i18n-timeline',
            event: {
                title: event,
                groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === 'compile-error'
                    ? 'error'
                    : event === 'fallback' || event === 'missing'
                        ? 'warning'
                        : 'default'
            }
        });
    }
}
function entry_lib_no_default_editScope(payload, i18n) {
    const composer = entry_lib_no_default_getComposer$2(payload.nodeId, i18n);
    if (composer) {
        const [field] = payload.path;
        if (field === 'locale' && isString(payload.state.value)) {
            composer.locale.value = payload.state.value;
        }
        else if (field === 'fallbackLocale' &&
            (isString(payload.state.value) ||
                isArray(payload.state.value) ||
                isObject(payload.state.value))) {
            composer.fallbackLocale.value = payload.state.value;
        }
        else if (field === 'inheritLocale' && isBoolean(payload.state.value)) {
            composer.inheritLocale = payload.state.value;
        }
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */
function entry_lib_no_default_convertComposerOptions(options) {
    const locale = entry_lib_no_default_shared_isString(options.locale) ? options.locale : entry_lib_no_default_DEFAULT_LOCALE;
    const fallbackLocale = entry_lib_no_default_shared_isString(options.fallbackLocale) ||
        entry_lib_no_default_shared_isArray(options.fallbackLocale) ||
        entry_lib_no_default_isPlainObject(options.fallbackLocale) ||
        options.fallbackLocale === false
        ? options.fallbackLocale
        : locale;
    const missing = entry_lib_no_default_shared_isFunction(options.missing) ? options.missing : undefined;
    const missingWarn = entry_lib_no_default_shared_isBoolean(options.silentTranslationWarn) ||
        entry_lib_no_default_isRegExp(options.silentTranslationWarn)
        ? !options.silentTranslationWarn
        : true;
    const fallbackWarn = entry_lib_no_default_shared_isBoolean(options.silentFallbackWarn) ||
        entry_lib_no_default_isRegExp(options.silentFallbackWarn)
        ? !options.silentFallbackWarn
        : true;
    const fallbackRoot = entry_lib_no_default_shared_isBoolean(options.fallbackRoot)
        ? options.fallbackRoot
        : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = entry_lib_no_default_isPlainObject(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = entry_lib_no_default_shared_isFunction(options.postTranslation)
        ? options.postTranslation
        : undefined;
    const warnHtmlMessage = entry_lib_no_default_shared_isString(options.warnHtmlInMessage)
        ? options.warnHtmlInMessage !== 'off'
        : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = entry_lib_no_default_shared_isBoolean(options.sync) ? options.sync : true;
    let messages = options.messages;
    if (entry_lib_no_default_isPlainObject(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale) => {
            const message = messages[locale] || (messages[locale] = {});
            entry_lib_no_default_shared_assign(message, sharedMessages[locale]);
            return messages;
        }, (messages || {}));
    }
    const { __i18n, __root, __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    return {
        locale,
        fallbackLocale,
        messages,
        flatJson,
        datetimeFormats,
        numberFormats,
        missing,
        missingWarn,
        fallbackWarn,
        fallbackRoot,
        fallbackFormat,
        modifiers,
        pluralRules: pluralizationRules,
        postTranslation,
        warnHtmlMessage,
        escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale,
        __i18n,
        __root,
        __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */
function entry_lib_no_default_createVueI18n(options = {}) {
    const composer = entry_lib_no_default_createComposer(entry_lib_no_default_convertComposerOptions(options));
    const { __extender } = options;
    // defines VueI18n
    const vueI18n = {
        // id
        id: composer.id,
        // locale
        get locale() {
            return composer.locale.value;
        },
        set locale(val) {
            composer.locale.value = val;
        },
        // fallbackLocale
        get fallbackLocale() {
            return composer.fallbackLocale.value;
        },
        set fallbackLocale(val) {
            composer.fallbackLocale.value = val;
        },
        // messages
        get messages() {
            return composer.messages.value;
        },
        // datetimeFormats
        get datetimeFormats() {
            return composer.datetimeFormats.value;
        },
        // numberFormats
        get numberFormats() {
            return composer.numberFormats.value;
        },
        // availableLocales
        get availableLocales() {
            return composer.availableLocales;
        },
        // missing
        get missing() {
            return composer.getMissingHandler();
        },
        set missing(handler) {
            composer.setMissingHandler(handler);
        },
        // silentTranslationWarn
        get silentTranslationWarn() {
            return entry_lib_no_default_shared_isBoolean(composer.missingWarn)
                ? !composer.missingWarn
                : composer.missingWarn;
        },
        set silentTranslationWarn(val) {
            composer.missingWarn = entry_lib_no_default_shared_isBoolean(val) ? !val : val;
        },
        // silentFallbackWarn
        get silentFallbackWarn() {
            return entry_lib_no_default_shared_isBoolean(composer.fallbackWarn)
                ? !composer.fallbackWarn
                : composer.fallbackWarn;
        },
        set silentFallbackWarn(val) {
            composer.fallbackWarn = entry_lib_no_default_shared_isBoolean(val) ? !val : val;
        },
        // modifiers
        get modifiers() {
            return composer.modifiers;
        },
        // formatFallbackMessages
        get formatFallbackMessages() {
            return composer.fallbackFormat;
        },
        set formatFallbackMessages(val) {
            composer.fallbackFormat = val;
        },
        // postTranslation
        get postTranslation() {
            return composer.getPostTranslationHandler();
        },
        set postTranslation(handler) {
            composer.setPostTranslationHandler(handler);
        },
        // sync
        get sync() {
            return composer.inheritLocale;
        },
        set sync(val) {
            composer.inheritLocale = val;
        },
        // warnInHtmlMessage
        get warnHtmlInMessage() {
            return composer.warnHtmlMessage ? 'warn' : 'off';
        },
        set warnHtmlInMessage(val) {
            composer.warnHtmlMessage = val !== 'off';
        },
        // escapeParameterHtml
        get escapeParameterHtml() {
            return composer.escapeParameter;
        },
        set escapeParameterHtml(val) {
            composer.escapeParameter = val;
        },
        // pluralizationRules
        get pluralizationRules() {
            return composer.pluralRules || {};
        },
        // for internal
        __composer: composer,
        // t
        t(...args) {
            return Reflect.apply(composer.t, composer, [...args]);
        },
        // rt
        rt(...args) {
            return Reflect.apply(composer.rt, composer, [...args]);
        },
        // tc
        tc(...args) {
            const [arg1, arg2, arg3] = args;
            const options = { plural: 1 };
            let list = null;
            let named = null;
            if ((false)) {}
            if (!entry_lib_no_default_shared_isString(arg1)) {
                throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.INVALID_ARGUMENT);
            }
            const key = arg1;
            if (entry_lib_no_default_shared_isString(arg2)) {
                options.locale = arg2;
            }
            else if (entry_lib_no_default_isNumber(arg2)) {
                options.plural = arg2;
            }
            else if (entry_lib_no_default_shared_isArray(arg2)) {
                list = arg2;
            }
            else if (entry_lib_no_default_isPlainObject(arg2)) {
                named = arg2;
            }
            if (entry_lib_no_default_shared_isString(arg3)) {
                options.locale = arg3;
            }
            else if (entry_lib_no_default_shared_isArray(arg3)) {
                list = arg3;
            }
            else if (entry_lib_no_default_isPlainObject(arg3)) {
                named = arg3;
            }
            // return composer.t(key, (list || named || {}) as any, options)
            return Reflect.apply(composer.t, composer, [
                key,
                (list || named || {}),
                options
            ]);
        },
        // te
        te(key, locale) {
            return composer.te(key, locale);
        },
        // tm
        tm(key) {
            return composer.tm(key);
        },
        // getLocaleMessage
        getLocaleMessage(locale) {
            return composer.getLocaleMessage(locale);
        },
        // setLocaleMessage
        setLocaleMessage(locale, message) {
            composer.setLocaleMessage(locale, message);
        },
        // mergeLocaleMessage
        mergeLocaleMessage(locale, message) {
            composer.mergeLocaleMessage(locale, message);
        },
        // d
        d(...args) {
            return Reflect.apply(composer.d, composer, [...args]);
        },
        // getDateTimeFormat
        getDateTimeFormat(locale) {
            return composer.getDateTimeFormat(locale);
        },
        // setDateTimeFormat
        setDateTimeFormat(locale, format) {
            composer.setDateTimeFormat(locale, format);
        },
        // mergeDateTimeFormat
        mergeDateTimeFormat(locale, format) {
            composer.mergeDateTimeFormat(locale, format);
        },
        // n
        n(...args) {
            return Reflect.apply(composer.n, composer, [...args]);
        },
        // getNumberFormat
        getNumberFormat(locale) {
            return composer.getNumberFormat(locale);
        },
        // setNumberFormat
        setNumberFormat(locale, format) {
            composer.setNumberFormat(locale, format);
        },
        // mergeNumberFormat
        mergeNumberFormat(locale, format) {
            composer.mergeNumberFormat(locale, format);
        }
    };
    vueI18n.__extender = __extender;
    // for vue-devtools timeline event
    if ((false)) {}
    return vueI18n;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */
function entry_lib_no_default_defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate() {
            const instance = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentInstance)();
            /* istanbul ignore if */
            if (!instance) {
                throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.UNEXPECTED_ERROR);
            }
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) {
                    optionsI18n.__i18n = options.__i18n;
                }
                optionsI18n.__root = composer;
                if (this === this.$root) {
                    // merge option and gttach global
                    this.$i18n = entry_lib_no_default_mergeToGlobal(vuei18n, optionsI18n);
                }
                else {
                    optionsI18n.__injectWithOption = true;
                    optionsI18n.__extender = i18n.__vueI18nExtend;
                    // atttach local VueI18n instance
                    this.$i18n = entry_lib_no_default_createVueI18n(optionsI18n);
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) {
                        _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                    }
                }
            }
            else if (options.__i18n) {
                if (this === this.$root) {
                    // merge option and gttach global
                    this.$i18n = entry_lib_no_default_mergeToGlobal(vuei18n, options);
                }
                else {
                    // atttach local VueI18n instance
                    this.$i18n = entry_lib_no_default_createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __extender: i18n.__vueI18nExtend,
                        __root: composer
                    });
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) {
                        _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                    }
                }
            }
            else {
                // attach global VueI18n instance
                this.$i18n = vuei18n;
            }
            if (options.__i18nGlobal) {
                entry_lib_no_default_adjustI18nResources(composer, options, options);
            }
            // defines vue-i18n legacy APIs
            this.$t = (...args) => this.$i18n.t(...args);
            this.$rt = (...args) => this.$i18n.rt(...args);
            this.$tc = (...args) => this.$i18n.tc(...args);
            this.$te = (key, locale) => this.$i18n.te(key, locale);
            this.$d = (...args) => this.$i18n.d(...args);
            this.$n = (...args) => this.$i18n.n(...args);
            this.$tm = (key) => this.$i18n.tm(key);
            i18n.__setInstance(instance, this.$i18n);
        },
        mounted() {
            /* istanbul ignore if */
            if (false) {}
        },
        unmounted() {
            const instance = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentInstance)();
            /* istanbul ignore if */
            if (!instance) {
                throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.UNEXPECTED_ERROR);
            }
            const _vueI18n = this.$i18n;
            /* istanbul ignore if */
            if (false) {}
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            if (_vueI18n.__disposer) {
                _vueI18n.__disposer();
                delete _vueI18n.__disposer;
                delete _vueI18n.__extender;
            }
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function entry_lib_no_default_mergeToGlobal(g, options) {
    g.locale = options.locale || g.locale;
    g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
    g.missing = options.missing || g.missing;
    g.silentTranslationWarn =
        options.silentTranslationWarn || g.silentFallbackWarn;
    g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
    g.formatFallbackMessages =
        options.formatFallbackMessages || g.formatFallbackMessages;
    g.postTranslation = options.postTranslation || g.postTranslation;
    g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
    g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
    g.sync = options.sync || g.sync;
    g.__composer[entry_lib_no_default_SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
    const messages = entry_lib_no_default_getLocaleMessages(g.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach(locale => g.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) {
        Object.keys(options.datetimeFormats).forEach(locale => g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    }
    if (options.numberFormats) {
        Object.keys(options.numberFormats).forEach(locale => g.mergeNumberFormat(locale, options.numberFormats[locale]));
    }
    return g;
}

const entry_lib_no_default_baseFormatProps = {
    tag: {
        type: [String, Object]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val /* ComponentI18nScope */) => val === 'parent' || val === 'global',
        default: 'parent' /* ComponentI18nScope */
    },
    i18n: {
        type: Object
    }
};

function entry_lib_no_default_getInterpolateArg(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots }, // SetupContext,
keys) {
    if (keys.length === 1 && keys[0] === 'default') {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current) => {
            return [
                ...slot,
                // prettier-ignore
                ...(current.type === entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment ? current.children : [current])
            ];
        }, []);
    }
    else {
        // named slots
        return keys.reduce((arg, key) => {
            const slot = slots[key];
            if (slot) {
                arg[key] = slot();
            }
            return arg;
        }, entry_lib_no_default_shared_create());
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function entry_lib_no_default_getFragmentableTag() {
    return entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment;
}

const entry_lib_no_default_TranslationImpl = /*#__PURE__*/ (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    /* eslint-disable */
    name: 'i18n-t',
    props: entry_lib_no_default_shared_assign({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [Number, String],
            validator: (val) => entry_lib_no_default_isNumber(val) || !isNaN(val)
        }
    }, entry_lib_no_default_baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const { slots, attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n ||
            entry_lib_no_default_useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return () => {
            const keys = Object.keys(slots).filter(key => key !== '_');
            const options = entry_lib_no_default_shared_create();
            if (props.locale) {
                options.locale = props.locale;
            }
            if (props.plural !== undefined) {
                options.plural = entry_lib_no_default_shared_isString(props.plural) ? +props.plural : props.plural;
            }
            const arg = entry_lib_no_default_getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[entry_lib_no_default_TranslateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = entry_lib_no_default_shared_assign(entry_lib_no_default_shared_create(), attrs);
            const tag = entry_lib_no_default_shared_isString(props.tag) || entry_lib_no_default_shared_isObject(props.tag)
                ? props.tag
                : entry_lib_no_default_getFragmentableTag();
            return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.h)(tag, assignedAttrs, children);
        };
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */
/**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */
const entry_lib_no_default_Translation = entry_lib_no_default_TranslationImpl;
const entry_lib_no_default_I18nT = (/* unused pure expression or super */ null && (entry_lib_no_default_Translation));

function entry_lib_no_default_isVNode(target) {
    return entry_lib_no_default_shared_isArray(target) && !entry_lib_no_default_shared_isString(target[0]);
}
function entry_lib_no_default_renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots, attrs } = context;
    return () => {
        const options = { part: true };
        let overrides = entry_lib_no_default_shared_create();
        if (props.locale) {
            options.locale = props.locale;
        }
        if (entry_lib_no_default_shared_isString(props.format)) {
            options.key = props.format;
        }
        else if (entry_lib_no_default_shared_isObject(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (entry_lib_no_default_shared_isString(props.format.key)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                options.key = props.format.key;
            }
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop) => {
                return slotKeys.includes(prop)
                    ? entry_lib_no_default_shared_assign(entry_lib_no_default_shared_create(), options, { [prop]: props.format[prop] }) // eslint-disable-line @typescript-eslint/no-explicit-any
                    : options;
            }, entry_lib_no_default_shared_create());
        }
        const parts = partFormatter(...[props.value, options, overrides]);
        let children = [options.key];
        if (entry_lib_no_default_shared_isArray(parts)) {
            children = parts.map((part, index) => {
                const slot = slots[part.type];
                const node = slot
                    ? slot({ [part.type]: part.value, index, parts })
                    : [part.value];
                if (entry_lib_no_default_isVNode(node)) {
                    node[0].key = `${part.type}-${index}`;
                }
                return node;
            });
        }
        else if (entry_lib_no_default_shared_isString(parts)) {
            children = [parts];
        }
        const assignedAttrs = entry_lib_no_default_shared_assign(entry_lib_no_default_shared_create(), attrs);
        const tag = entry_lib_no_default_shared_isString(props.tag) || entry_lib_no_default_shared_isObject(props.tag)
            ? props.tag
            : entry_lib_no_default_getFragmentableTag();
        return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.h)(tag, assignedAttrs, children);
    };
}

const entry_lib_no_default_NumberFormatImpl = /*#__PURE__*/ (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    /* eslint-disable */
    name: 'i18n-n',
    props: entry_lib_no_default_shared_assign({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, entry_lib_no_default_baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const i18n = props.i18n ||
            entry_lib_no_default_useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return entry_lib_no_default_renderFormatter(props, context, entry_lib_no_default_NUMBER_FORMAT_OPTIONS_KEYS, (...args) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n[entry_lib_no_default_NumberPartsSymbol](...args));
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */
/**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */
const entry_lib_no_default_NumberFormat = entry_lib_no_default_NumberFormatImpl;
const entry_lib_no_default_I18nN = (/* unused pure expression or super */ null && (entry_lib_no_default_NumberFormat));

const entry_lib_no_default_DatetimeFormatImpl = /* #__PURE__*/ (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
    /* eslint-disable */
    name: 'i18n-d',
    props: entry_lib_no_default_shared_assign({
        value: {
            type: [Number, Date],
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, entry_lib_no_default_baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const i18n = props.i18n ||
            entry_lib_no_default_useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return entry_lib_no_default_renderFormatter(props, context, entry_lib_no_default_DATETIME_FORMAT_OPTIONS_KEYS, (...args) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n[entry_lib_no_default_DatetimePartsSymbol](...args));
    }
});
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */
const entry_lib_no_default_DatetimeFormat = entry_lib_no_default_DatetimeFormatImpl;
const entry_lib_no_default_I18nD = (/* unused pure expression or super */ null && (entry_lib_no_default_DatetimeFormat));

function entry_lib_no_default_getComposer$1(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === 'composition') {
        return (i18nInternal.__getInstance(instance) || i18n.global);
    }
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null
            ? vueI18n.__composer
            : i18n.global.__composer;
    }
}
function entry_lib_no_default_vTDirective(i18n) {
    const _process = (binding) => {
        const { instance, value } = binding;
        /* istanbul ignore if */
        if (!instance || !instance.$) {
            throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.UNEXPECTED_ERROR);
        }
        const composer = entry_lib_no_default_getComposer$1(i18n, instance.$);
        const parsedValue = entry_lib_no_default_parseValue(value);
        return [
            Reflect.apply(composer.t, composer, [...entry_lib_no_default_makeParams(parsedValue)]),
            composer
        ];
    };
    const register = (el, binding) => {
        const [textContent, composer] = _process(binding);
        if (entry_lib_no_default_inBrowser && i18n.global === composer) {
            // global scope only
            el.__i18nWatcher = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(composer.locale, () => {
                binding.instance && binding.instance.$forceUpdate();
            });
        }
        el.__composer = composer;
        el.textContent = textContent;
    };
    const unregister = (el) => {
        if (entry_lib_no_default_inBrowser && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    const update = (el, { value }) => {
        if (el.__composer) {
            const composer = el.__composer;
            const parsedValue = entry_lib_no_default_parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, [
                ...entry_lib_no_default_makeParams(parsedValue)
            ]);
        }
    };
    const getSSRProps = (binding) => {
        const [textContent] = _process(binding);
        return { textContent };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps
    };
}
function entry_lib_no_default_parseValue(value) {
    if (entry_lib_no_default_shared_isString(value)) {
        return { path: value };
    }
    else if (entry_lib_no_default_isPlainObject(value)) {
        if (!('path' in value)) {
            throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.REQUIRED_VALUE, 'path');
        }
        return value;
    }
    else {
        throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.INVALID_VALUE);
    }
}
function entry_lib_no_default_makeParams(value) {
    const { path, locale, args, choice, plural } = value;
    const options = {};
    const named = args || {};
    if (entry_lib_no_default_shared_isString(locale)) {
        options.locale = locale;
    }
    if (entry_lib_no_default_isNumber(choice)) {
        options.plural = choice;
    }
    if (entry_lib_no_default_isNumber(plural)) {
        options.plural = plural;
    }
    return [path, named, options];
}

function entry_lib_no_default_apply(app, i18n, ...options) {
    const pluginOptions = entry_lib_no_default_isPlainObject(options[0])
        ? options[0]
        : {};
    const globalInstall = entry_lib_no_default_shared_isBoolean(pluginOptions.globalInstall)
        ? pluginOptions.globalInstall
        : true;
    if (globalInstall) {
        [entry_lib_no_default_Translation.name, 'I18nT'].forEach(name => app.component(name, entry_lib_no_default_Translation));
        [entry_lib_no_default_NumberFormat.name, 'I18nN'].forEach(name => app.component(name, entry_lib_no_default_NumberFormat));
        [entry_lib_no_default_DatetimeFormat.name, 'I18nD'].forEach(name => app.component(name, entry_lib_no_default_DatetimeFormat));
    }
    // install directive
    {
        app.directive('t', entry_lib_no_default_vTDirective(i18n));
    }
}

/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */
const entry_lib_no_default_I18nInjectionKey = 
/* #__PURE__*/ entry_lib_no_default_shared_makeSymbol('global-vue-i18n');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function entry_lib_no_default_createI18n(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __legacyMode = __VUE_I18N_LEGACY_API__ && entry_lib_no_default_shared_isBoolean(options.legacy)
            ? options.legacy
            : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    const __globalInjection = entry_lib_no_default_shared_isBoolean(options.globalInjection)
        ? options.globalInjection
        : true;
    const __instances = new Map();
    const [globalScope, __global] = entry_lib_no_default_createGlobal(options, __legacyMode);
    const symbol = /* #__PURE__*/ entry_lib_no_default_shared_makeSymbol(( false) ? 0 : '');
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    const i18n = {
        // mode
        get mode() {
            return __VUE_I18N_LEGACY_API__ && __legacyMode
                ? 'legacy'
                : 'composition';
        },
        // install plugin
        async install(app, ...options) {
            if (false) {}
            // setup global provider
            app.__VUE_I18N_SYMBOL__ = symbol;
            app.provide(app.__VUE_I18N_SYMBOL__, i18n);
            // set composer & vuei18n extend hook options from plugin options
            if (entry_lib_no_default_isPlainObject(options[0])) {
                const opts = options[0];
                i18n.__composerExtend =
                    opts.__composerExtend;
                i18n.__vueI18nExtend =
                    opts.__vueI18nExtend;
            }
            // global method and properties injection for Composition API
            let globalReleaseHandler = null;
            if (!__legacyMode && __globalInjection) {
                globalReleaseHandler = entry_lib_no_default_injectGlobalFields(app, i18n.global);
            }
            // install built-in components and directive
            if (__VUE_I18N_FULL_INSTALL__) {
                entry_lib_no_default_apply(app, i18n, ...options);
            }
            // setup mixin for Legacy API
            if (__VUE_I18N_LEGACY_API__ && __legacyMode) {
                app.mixin(entry_lib_no_default_defineMixin(__global, __global.__composer, i18n));
            }
            // release global scope
            const unmountApp = app.unmount;
            app.unmount = () => {
                globalReleaseHandler && globalReleaseHandler();
                i18n.dispose();
                unmountApp();
            };
            // setup vue-devtools plugin
            if (false) {}
        },
        // global accessor
        get global() {
            return __global;
        },
        dispose() {
            globalScope.stop();
        },
        // @internal
        __instances,
        // @internal
        __getInstance,
        // @internal
        __setInstance,
        // @internal
        __deleteInstance
    };
    return i18n;
}
function entry_lib_no_default_useI18n(options = {}) {
    const instance = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.getCurrentInstance)();
    if (instance == null) {
        throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    }
    if (!instance.isCE &&
        instance.appContext.app != null &&
        !instance.appContext.app.__VUE_I18N_SYMBOL__) {
        throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.NOT_INSTALLED);
    }
    const i18n = entry_lib_no_default_getI18nInstance(instance);
    const gl = entry_lib_no_default_getGlobalComposer(i18n);
    const componentOptions = entry_lib_no_default_getComponentOptions(instance);
    const scope = entry_lib_no_default_getScope(options, componentOptions);
    if (scope === 'global') {
        entry_lib_no_default_adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === 'parent') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = entry_lib_no_default_getComposer(i18n, instance, options.__useComponent);
        if (composer == null) {
            if ((false)) {}
            composer = gl;
        }
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = entry_lib_no_default_shared_assign({}, options);
        if ('__i18n' in componentOptions) {
            composerOptions.__i18n = componentOptions.__i18n;
        }
        if (gl) {
            composerOptions.__root = gl;
        }
        composer = entry_lib_no_default_createComposer(composerOptions);
        if (i18nInternal.__composerExtend) {
            composer[entry_lib_no_default_DisposeSymbol] =
                i18nInternal.__composerExtend(composer);
        }
        entry_lib_no_default_setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
function entry_lib_no_default_createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.effectScope)();
    const obj = __VUE_I18N_LEGACY_API__ && legacyMode
        ? scope.run(() => entry_lib_no_default_createVueI18n(options))
        : scope.run(() => entry_lib_no_default_createComposer(options));
    if (obj == null) {
        throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.UNEXPECTED_ERROR);
    }
    return [scope, obj];
}
function entry_lib_no_default_getI18nInstance(instance) {
    const i18n = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.inject)(!instance.isCE
        ? instance.appContext.app.__VUE_I18N_SYMBOL__
        : entry_lib_no_default_I18nInjectionKey);
    /* istanbul ignore if */
    if (!i18n) {
        throw entry_lib_no_default_createI18nError(!instance.isCE
            ? entry_lib_no_default_I18nErrorCodes.UNEXPECTED_ERROR
            : entry_lib_no_default_I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
    }
    return i18n;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function entry_lib_no_default_getScope(options, componentOptions) {
    // prettier-ignore
    return entry_lib_no_default_isEmptyObject(options)
        ? ('__i18n' in componentOptions)
            ? 'local'
            : 'global'
        : !options.useScope
            ? 'local'
            : options.useScope;
}
function entry_lib_no_default_getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
}
function entry_lib_no_default_getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = entry_lib_no_default_getParentComponentInstance(target, useComponent);
    while (current != null) {
        const i18nInternal = i18n;
        if (i18n.mode === 'composition') {
            composer = i18nInternal.__getInstance(current);
        }
        else {
            if (__VUE_I18N_LEGACY_API__) {
                const vueI18n = i18nInternal.__getInstance(current);
                if (vueI18n != null) {
                    composer = vueI18n
                        .__composer;
                    if (useComponent &&
                        composer &&
                        !composer[entry_lib_no_default_InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                    ) {
                        composer = null;
                    }
                }
            }
        }
        if (composer != null) {
            break;
        }
        if (root === current) {
            break;
        }
        current = current.parent;
    }
    return composer;
}
function entry_lib_no_default_getParentComponentInstance(target, useComponent = false) {
    if (target == null) {
        return null;
    }
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent
        ? target.parent
        : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function entry_lib_no_default_setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
        // inject composer instance to DOM for intlify-devtools
        if (false) {}
    }, target);
    (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _composer = composer;
        // remove composer instance from DOM for intlify-devtools
        if (false) {}
        i18n.__deleteInstance(target);
        // dispose extended resources
        const dispose = _composer[entry_lib_no_default_DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[entry_lib_no_default_DisposeSymbol];
        }
    }, target);
}
const entry_lib_no_default_globalExportProps = [
    'locale',
    'fallbackLocale',
    'availableLocales'
];
const entry_lib_no_default_globalExportMethods = ['t', 'rt', 'd', 'n', 'tm', 'te']
    ;
function entry_lib_no_default_injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    entry_lib_no_default_globalExportProps.forEach(prop => {
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) {
            throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.UNEXPECTED_ERROR);
        }
        const wrap = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(desc.value) // check computed props
            ? {
                get() {
                    return desc.value.value;
                },
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                set(val) {
                    desc.value.value = val;
                }
            }
            : {
                get() {
                    return desc.get && desc.get();
                }
            };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    entry_lib_no_default_globalExportMethods.forEach(method => {
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) {
            throw entry_lib_no_default_createI18nError(entry_lib_no_default_I18nErrorCodes.UNEXPECTED_ERROR);
        }
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
    const dispose = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete app.config.globalProperties.$i18n;
        entry_lib_no_default_globalExportMethods.forEach(method => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete app.config.globalProperties[`$${method}`];
        });
    };
    return dispose;
}

{
    entry_lib_no_default_vue_i18n_initFeatureFlags();
}
// register message compiler at vue-i18n
entry_lib_no_default_registerMessageCompiler(entry_lib_no_default_compile);
// register message resolver at vue-i18n
entry_lib_no_default_registerMessageResolver(entry_lib_no_default_resolveValue);
// register fallback locale at vue-i18n
entry_lib_no_default_registerLocaleFallbacker(entry_lib_no_default_fallbackWithLocaleChain);
// NOTE: experimental !!
if (( false) || __INTLIFY_PROD_DEVTOOLS__) {
    const target = entry_lib_no_default_getGlobalThis();
    target.__INTLIFY__ = true;
    entry_lib_no_default_setDevToolsHook(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
if ((false)) {}



// EXTERNAL MODULE: ../../node_modules/deepmerge/dist/cjs.js
var entry_lib_no_default_cjs = __webpack_require__(2743);
var entry_lib_no_default_cjs_default = /*#__PURE__*/__webpack_require__.n(entry_lib_no_default_cjs);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.json.stringify.js
var entry_lib_no_default_es_json_stringify = __webpack_require__(4727);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.assign.js
var entry_lib_no_default_es_object_assign = __webpack_require__(7050);
;// ../../libs/storage/dist/SessionStore.js



var entry_lib_no_default_SessionStore = /** @class */function () {
  function SessionStore(_a) {
    var customId = _a.customId;
    if (customId) {
      this.custom = JSON.parse(sessionStorage.getItem(customId) || '{}');
    }
  }
  SessionStore.prototype.storeCustom = function (id, data) {
    this.custom = Object.assign({}, this.custom, data);
    sessionStorage.setItem(id, JSON.stringify(this.custom));
  };
  return SessionStore;
}();
/* harmony default export */ var entry_lib_no_default_dist_SessionStore = (entry_lib_no_default_SessionStore);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.function.name.js
var entry_lib_no_default_es_function_name = __webpack_require__(3277);
;// ../../libs/storage/dist/STORE.js
var entry_lib_no_default_STORE_NAME;
(function (STORE_NAME) {
  // essential
  STORE_NAME["ACCESS_TOKEN"] = "access_token";
  STORE_NAME["ACCOUNTBOX"] = "accountbox";
  STORE_NAME["CID"] = "cid";
  STORE_NAME["COOKIE_CONSENT"] = "cookieConsent";
  STORE_NAME["GD"] = "gd";
  STORE_NAME["HOME_ESSENTIAL"] = "home-essential";
  STORE_NAME["JSESSIONID"] = "JSESSIONID";
  STORE_NAME["PHONITAIRE"] = "phonitaire";
  STORE_NAME["SHOP_WEB"] = "shop-web";
  STORE_NAME["SHOP_ESSENTIAL"] = "shop-essential";
  STORE_NAME["SESSION_HOST"] = "SESSION_HOST";
  STORE_NAME["USER"] = "user";
  // functional
  STORE_NAME["LOBBY"] = "lobby";
  STORE_NAME["SHOP"] = "shop";
})(entry_lib_no_default_STORE_NAME || (entry_lib_no_default_STORE_NAME = {}));
;// ../../libs/storage/dist/GD.js



/*
 *  Copyright (c) 2003-2019 GameDuell GmbH, All Rights Reserved
 *  This document is strictly confidential and sole property of GameDuell GmbH, Berlin, Germany
 */
/**
 * localStorage scope GD
 */
var entry_lib_no_default_GD = /** @class */function () {
  function GD() {
    var gd = JSON.parse(localStorage.getItem('gd') || '{}');
    this.viewLang = gd.viewLang;
    this.viewCountry = gd.viewCountry;
    this.webCtxPath = gd.webCtxPath || '/web';
    this.mediaUrl = gd.mediaUrl || '//assets.gameduell.de/res/moduleMedia/';
    this.avatarUrl = gd.avatarUrl || '//assets.gameduell.de/avatar/';
    this.partner = {
      name: gd.partner && gd.partner.name || '',
      url: gd.partner && gd.partner.url || ''
    };
    this.supportedLocales = gd.supportedLocales || ['en-US', 'en-GB',
    // 'es-ES',
    // 'fr-FR',
    'nl-NL', 'se-SV', 'da-DK', 'de-DE', 'de-AT'];
    this.supportedTechs = gd.supportedTechs || ['html5_dom'];
    this.blackRibbon = gd.blackRibbon || false;
    this.theme = gd.theme || '';
    this.cookieConsent = {
      consented: gd.cookieConsent && gd.cookieConsent.consented || false,
      auto: gd.cookieConsent && gd.cookieConsent.auto || false,
      functional: gd.cookieConsent && gd.cookieConsent.functional || false,
      marketing: gd.cookieConsent && gd.cookieConsent.marketing || false,
      names: gd.cookieConsent && gd.cookieConsent.names || [entry_lib_no_default_STORE_NAME.ACCESS_TOKEN, entry_lib_no_default_STORE_NAME.ACCOUNTBOX, entry_lib_no_default_STORE_NAME.CID, entry_lib_no_default_STORE_NAME.COOKIE_CONSENT, entry_lib_no_default_STORE_NAME.GD, entry_lib_no_default_STORE_NAME.HOME_ESSENTIAL, entry_lib_no_default_STORE_NAME.JSESSIONID, entry_lib_no_default_STORE_NAME.PHONITAIRE, entry_lib_no_default_STORE_NAME.SHOP_WEB, entry_lib_no_default_STORE_NAME.SHOP_ESSENTIAL, entry_lib_no_default_STORE_NAME.SESSION_HOST, entry_lib_no_default_STORE_NAME.USER]
    };
    this.decisions = gd.decisions || [];
    this.mobileDevice = gd.mobileDevice || false;
    this.betaMobil = gd.betaMobil || false;
    this.deviceType = gd.deviceType || 'desktop';
    this.trackingConfig = gd.trackingConfig || [];
    this.gameNightGametype = gd.gameNightGametype || '';
  }
  return GD;
}();

;// ../../libs/storage/dist/User.js


/*
 *  Copyright (c) 2003-2019 GameDuell GmbH, All Rights Reserved
 *  This document is strictly confidential and sole property of GameDuell GmbH, Berlin, Germany
 */
/**
 * localStorage scope GD
 */
var entry_lib_no_default_User = /** @class */function () {
  function User() {
    var user = JSON.parse(localStorage.getItem('user') || '{}');
    this.id = user.id;
    this.currency = user.currency;
    this.name = user.name;
    this.actorType = user.actorType;
    this.locale = user.locale;
    this.loyalty = user.loyalty;
    this.bonusVisualization = user.bonusVisualization;
    this.payout = user.payout;
    this.forcePayout = user.forcePayout || false;
    this.avatarUrl = user.avatarUrl;
  }
  return User;
}();

;// ../../libs/storage/dist/LocalStore.js





var entry_lib_no_default_LocaleStore = /** @class */function () {
  function LocaleStore(_a) {
    var customId = _a.customId;
    this.gd = new entry_lib_no_default_GD();
    this.user = new entry_lib_no_default_User();
    if (customId) {
      this.custom = JSON.parse(localStorage.getItem(customId) || '{}');
    }
  }
  LocaleStore.prototype.storeGD = function (gd) {
    this.gd = Object.assign({}, this.gd, gd);
    localStorage.setItem('gd', JSON.stringify(this.gd));
  };
  LocaleStore.prototype.storeUser = function (user) {
    this.user = Object.assign({}, this.user, user);
    localStorage.setItem('user', JSON.stringify(this.user));
  };
  LocaleStore.prototype.storeCustom = function (id, data) {
    this.custom = Object.assign({}, this.custom, data);
    localStorage.setItem(id, JSON.stringify(this.custom));
  };
  return LocaleStore;
}();
/* harmony default export */ var entry_lib_no_default_LocalStore = (entry_lib_no_default_LocaleStore);
;// ../../libs/storage/dist/Storage.js










/**
 * Supports read/write localStorage - write works only for cookie consent allowed names (see gd.cookieConsent.names)
 * TODO: refactor too much read and write when creating a instance. The problem on lazy loading/saving the data is
 * too support multiple instances of this Storage object.
 */
var entry_lib_no_default_Storage = /** @class */function () {
  /**
   * Initialize defaults
   */
  function Storage() {
    this.defaults = {};
    this.defaults.gd = new entry_lib_no_default_GD();
    this.defaults.user = new entry_lib_no_default_User();
  }
  /**
   * Returns a object from localStorage (already JSON parsed).
   *
   * Will handle default values for GD and User.
   * @param store
   */
  Storage.prototype.read = function (store) {
    var _this = this;
    var data = localStorage.getItem(store);
    var dataObj = JSON.parse(data || '{}');
    if (this.defaults[store]) {
      Object.keys(this.defaults[store]).forEach(function (key) {
        if (dataObj[key] === undefined) {
          dataObj[key] = _this.defaults[store][key];
        }
      });
    }
    return dataObj;
  };
  /**
   * writes data to locale storage. Only cookies which are accepted in cookieConsent will be saved
   * @param store
   * @param data
   */
  Storage.prototype.write = function (store, data) {
    // would be great to cache this but if we create multiple instance from Storage it will not work ;)
    var gd = this.read(entry_lib_no_default_STORE_NAME.GD);
    if (gd.cookieConsent.names.indexOf(store) === -1) {
      // skip write if cookie names are not part of the cookie consent

      return;
    }
    var custom = Object.assign({}, this.read(store) || {}, data);
    localStorage.setItem(store, JSON.stringify(custom));
  };
  return Storage;
}();
/* harmony default export */ var entry_lib_no_default_dist_Storage = (entry_lib_no_default_Storage);
;// ../../libs/storage/dist/vuexSessionStore.js



// initial state
var entry_lib_no_default_state = {
  storageSessionCustom: {},
  customSessionId: ''
};
// getters
var entry_lib_no_default_getters = {
  storageSessionCustom: function storageSessionCustom(state) {
    return state.storageSessionCustom;
  }
};
// actions
var entry_lib_no_default_actions = {
  storageSessionInit: function storageSessionInit(_a, _b) {
    var commit = _a.commit;
    var customId = _b.customId;
    var sessionStorage = new entry_lib_no_default_dist_SessionStore({
      customId: customId
    });
    commit('storageSessionCustom', {
      id: customId,
      data: sessionStorage.custom
    });
    commit('storageSessionSetCustomId', customId);
  }
};
// mutations
var entry_lib_no_default_mutations = {
  storageSessionSetCustomId: function storageSessionSetCustomId(state, id) {
    state.customSessionId = id;
  },
  /**
   * id is optional - it's using the id from the storageInit: customId as default
   */
  storageSessionCustom: function storageSessionCustom(state, _a) {
    var id = _a.id,
      data = _a.data;
    // TODO: apply deep merge of objects
    state.storageSessionCustom = Object.assign({}, state.storageSessionCustom, data);
    sessionStorage.setItem(id || state.customSessionId, JSON.stringify(state.storageSessionCustom));
  }
};
/* harmony default export */ var entry_lib_no_default_vuexSessionStore = ({
  state: entry_lib_no_default_state,
  getters: entry_lib_no_default_getters,
  actions: entry_lib_no_default_actions,
  mutations: entry_lib_no_default_mutations
});
;// ../../libs/storage/dist/vuexLocalStore.js



// initial state
var entry_lib_no_default_vuexLocalStore_state = {
  storageGD: new entry_lib_no_default_LocalStore({}).gd,
  storageUser: new entry_lib_no_default_LocalStore({}).user,
  storageCustom: {},
  customId: ''
};
// getters
var entry_lib_no_default_vuexLocalStore_getters = {
  storageGD: function storageGD(state) {
    return state.storageGD;
  },
  storageUser: function storageUser(state) {
    return state.storageUser;
  },
  storageCustom: function storageCustom(state) {
    return state.storageCustom;
  },
  webPath: function webPath(state) {
    return state.storageGD.webCtxPath;
  }
};
// actions
var entry_lib_no_default_vuexLocalStore_actions = {
  storageInit: function storageInit(_a, _b) {
    var commit = _a.commit;
    var customId = _b.customId;
    var localStorage = new entry_lib_no_default_LocalStore({
      customId: customId
    });
    commit('storageCustom', {
      id: customId,
      data: localStorage.custom
    });
    commit('storageSetCustomId', customId);
  }
};
// mutations
var entry_lib_no_default_vuexLocalStore_mutations = {
  storageSetCustomId: function storageSetCustomId(state, id) {
    state.customId = id;
  },
  storageGD: function storageGD(state, gdInt) {
    state.storageGD = Object.assign({}, state.storageGD, gdInt);
    localStorage.setItem('gd', JSON.stringify(state.storageGD));
  },
  storageUser: function storageUser(state, userInt) {
    state.storageUser = Object.assign({}, state.storageUser, userInt);
    localStorage.setItem('user', JSON.stringify(state.storageUser));
  },
  /**
   * id is optional - it's using the id from the storageInit: customId as default
   */
  storageCustom: function storageCustom(state, _a) {
    var id = _a.id,
      data = _a.data;
    // TODO: apply deep merge of objects
    state.storageCustom = Object.assign({}, state.storageCustom, data);
    localStorage.setItem(id || state.customId, JSON.stringify(state.storageCustom));
  }
};
/* harmony default export */ var entry_lib_no_default_vuexLocalStore = ({
  state: entry_lib_no_default_vuexLocalStore_state,
  getters: entry_lib_no_default_vuexLocalStore_getters,
  actions: entry_lib_no_default_vuexLocalStore_actions,
  mutations: entry_lib_no_default_vuexLocalStore_mutations
});
;// ../../libs/storage/dist/index.js








/**
 * Make all of them public
 */







;// ../../libs/i18n/dist/DateFormat.js
/**
 * If you need more, please feel free to add them!
 * But keep in mind they should "globaly" make sense.
 * Don't add any custom formats. For custom formatting
 * we need to find a different solution.
 */
var entry_lib_no_default_DateFormat;
(function (DateFormat) {
  DateFormat["MMHHDDMMYYY"] = "MMHHDDMMYYY";
  DateFormat["DDMMYYY"] = "DDMMYYY";
  DateFormat["MMHH"] = "MMHH";
})(entry_lib_no_default_DateFormat || (entry_lib_no_default_DateFormat = {}));
;// ../../libs/i18n/dist/index.js











// import i18n from './locales/i18n.json'




/**
 * maps viewLang and viewCountry to $i18n.locale
 *
 */
var entry_lib_no_default_mapLang = {
  "en-US": "en",
  "en-GB": "en-GB",
  "nl-NL": "nl",
  "sv-SE": "sv",
  "da-DK": "da",
  "de-DE": "de",
  "de-AT": "de",
  "es-ES": "es",
  "es-US": "es",
  "fr-FR": "fr"
};
// such in case the country is not available we choose them from the countryMap
var entry_lib_no_default_countryMap = {
  en: "US",
  "en-GB": "GB",
  nl: "NL",
  sv: "SE",
  da: "DK",
  de: "DE",
  // fallback won't work anymore with es-US and en-US
  es: "ES",
  fr: "FR"
};
var entry_lib_no_default_init = false;
var entry_lib_no_default_storage = new entry_lib_no_default_LocalStore({});
function entry_lib_no_default_loadLocaleMessages() {
  // not nice but webpack requires to pass the folder as string literal - variables are not allowed
  // the alternative to this is to move out the required.context call to the parent component and pass
  // the locales as parameter.
  // path out: ./node_modules/@gd/i18n/dist/
  // path in: ./src/locales/
  // TODO might be a fix for vite (rollup) https://www.npmjs.com/package/rollup-plugin-require-context
  var locales = __webpack_require__(5679);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1].split("_")[1];
      if (locale) {
        // TODO - find out when it's default and when it's not
        messages[locale] = locales(key).default || locales(key);
        if (locale === "de") {
          messages["de-AT"] = locales(key);
        }
      }
    }
  });
  var i18n = locales("./i18n.json");
  if (i18n) {
    ;
    messages["none"] = i18n.default;
  }
  return messages;
}
/**
 * use this method to setup i18n in components - it expects the locale files be loaded from ./src/locales.
 *
 * @param setupI18n
 * @returns useI18n(...)
 */
function entry_lib_no_default_setupComponentI18n(setupI18n) {
  if (entry_lib_no_default_init === true && (setupI18n === null || setupI18n === void 0 ? void 0 : setupI18n.useScope) !== "local") {
    return entry_lib_no_default_useI18n({
      useScope: (setupI18n === null || setupI18n === void 0 ? void 0 : setupI18n.useScope) || "global"
    });
  }
  entry_lib_no_default_init = true;
  // we can limit the scope to not overwrite keys in other components with: {useScope: 'local'}
  // the huge disadvantage here is that the scope of "local" is only available in "this" component (no parent, no children).
  // This can be very unpracticable because no other component has access to this keys.
  // If you can't use "local" (either parent (use scope of parent component) or global) then your messageKey must
  // be kind of unique to not overwrite other component keys
  var i18n = entry_lib_no_default_useI18n({
    useScope: (setupI18n === null || setupI18n === void 0 ? void 0 : setupI18n.useScope) || "global"
  });
  var componentMessages = entry_lib_no_default_loadLocaleMessages();
  Object.keys(componentMessages).forEach(function (lang) {
    if (!componentMessages[lang]) {}
    var obj = entry_lib_no_default_cjs_default()(i18n.messages.value[lang] || {}, componentMessages[lang] || {});
    i18n.setLocaleMessage(lang, obj);
  });
  return i18n;
}


/**
 * web export for createApp(...).use(i18n)
 */
/* harmony default export */ var entry_lib_no_default_dist = (entry_lib_no_default_createI18n({
  locale: entry_lib_no_default_mapLang[entry_lib_no_default_storage.gd.viewLang && entry_lib_no_default_storage.gd.viewLang + "-" + (
  // fallback won't work anymore with es-US and en-US
  entry_lib_no_default_storage.gd.viewCountry || entry_lib_no_default_countryMap[entry_lib_no_default_storage.gd.viewLang]) || "en-US"
  // fallback to viewLang. Should work for most of the "corner case"-countries such as:
  // de-CH, es-AR, es-BR, es-CL, es-MX, es-UY, es-VE
  ] || entry_lib_no_default_storage.gd.viewLang,
  legacy: false,
  fallbackLocale: "en-US",
  messages: entry_lib_no_default_loadLocaleMessages(),
  datetimeFormats: {
    // For endless possibilities to format,
    // see http://www.ecma-international.org/ecma-402/2.0/#sec-intl-datetimeformat-constructor
    de: entry_lib_no_default_defineProperty(entry_lib_no_default_defineProperty(entry_lib_no_default_defineProperty({}, entry_lib_no_default_DateFormat.MMHHDDMMYYY, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    }), entry_lib_no_default_DateFormat.DDMMYYY, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }), entry_lib_no_default_DateFormat.MMHH, {
      hour: "2-digit",
      minute: "2-digit"
    }),
    en: entry_lib_no_default_defineProperty(entry_lib_no_default_defineProperty(entry_lib_no_default_defineProperty({}, entry_lib_no_default_DateFormat.MMHHDDMMYYY, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    }), entry_lib_no_default_DateFormat.DDMMYYY, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }), entry_lib_no_default_DateFormat.MMHH, {
      hour: "2-digit",
      minute: "2-digit"
    })
  },
  silentTranslationWarn: "production" === "development" // YES, you may want to take this out again
}));
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdFooter.vue?vue&type=script&setup=true&lang=ts



var entry_lib_no_default_hoisted_1 = {
  id: "sectionFooterNavigation"
};
var entry_lib_no_default_hoisted_2 = {
  id: "bottomnav"
};
var entry_lib_no_default_hoisted_3 = {
  key: 0
};
var entry_lib_no_default_hoisted_4 = {
  key: 1
};
var entry_lib_no_default_hoisted_5 = {
  id: "gdfooterContainer"
};
var entry_lib_no_default_hoisted_6 = {
  key: 0,
  id: "locales"
};
var entry_lib_no_default_hoisted_7 = {
  class: "footerflags"
};
var entry_lib_no_default_hoisted_8 = {
  key: 0
};
var entry_lib_no_default_hoisted_9 = {
  key: 1
};
var entry_lib_no_default_hoisted_10 = {
  key: 2
};
var entry_lib_no_default_hoisted_11 = {
  key: 3
};
var entry_lib_no_default_hoisted_12 = {
  key: 4
};
var entry_lib_no_default_hoisted_13 = {
  key: 5
};
var entry_lib_no_default_hoisted_14 = {
  key: 6
};
var entry_lib_no_default_hoisted_15 = {
  key: 7
};
var entry_lib_no_default_hoisted_16 = {
  key: 8
};
var entry_lib_no_default_hoisted_17 = {
  key: 9
};
var entry_lib_no_default_hoisted_18 = {
  class: "copyright"
};



var entry_lib_no_default_footerMarginTop = 40;
/* harmony default export */ var entry_lib_no_default_GdFootervue_type_script_setup_true_lang_ts = (/*@__PURE__*/(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'GdFooter',
  props: {
    flags: {
      type: Boolean,
      default: false
    },
    locales: {
      default: function _default() {
        return [];
      }
    },
    show: {
      type: Boolean,
      default: true
    },
    blank: {
      type: Boolean,
      default: false
    },
    userCountry: {
      default: ''
    },
    payoutUser: {
      type: Boolean,
      default: true
    }
  },
  emits: ['link', 'flag'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    entry_lib_no_default_setupComponentI18n({});
    var props = __props;
    var footer = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    var availableLocales = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.locales || [];
    });
    var withdrawal = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var _props$userCountry;
      var countries = ['DE', 'AT', 'GB', 'FR', 'NL', 'DK', 'SE', 'ES'];
      return countries.includes((_props$userCountry = props.userCountry) !== null && _props$userCountry !== void 0 ? _props$userCountry : '');
    });
    var accessibility = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var gd = new entry_lib_no_default_dist_Storage().read(entry_lib_no_default_STORE_NAME.GD);
      return gd.decisions.indexOf('fe-accessibility-page') > -1;
    });
    var emit = __emit;
    var link = function link(page) {
      emit('link', page);
    };
    var flag = function flag(locale) {
      emit('flag', locale);
    };
    var setBodyBottomPadding = function setBodyBottomPadding() {
      if (footer.value && props.show) {
        var height = footer.value.clientHeight;
        document.body.style.paddingBottom = height + entry_lib_no_default_footerMarginTop + 'px';
      }
      if (!props.show) {
        document.body.style.paddingBottom = '0';
      }
    };
    (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(function () {
      window.addEventListener('resize', setBodyBottomPadding);
      setBodyBottomPadding();
    });
    (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(function () {
      return props.show;
    }, function (to) {
      (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.nextTick)(function () {
        setBodyBottomPadding();
      });
    });
    return function (_ctx, _cache) {
      return _ctx.show ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("footer", {
        key: 0,
        ref_key: "footer",
        ref: footer,
        id: "footer"
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        id: "gdfooter",
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.blank ? 'tpl-minimal' : '')
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_hoisted_1, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", entry_lib_no_default_hoisted_2, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return link('home');
        }),
        name: "footer",
        "data-qe-id": "footer_home"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_home')), 1)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return link('impressum');
        }),
        name: "footer",
        "data-qe-id": "footer_impressum"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_impressum')), 1)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return link('contact');
        }),
        name: "footer",
        "data-qe-id": "footer_contact"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_contact')), 1)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return link('about');
        }),
        name: "footer",
        target: "_blank",
        rel: "noopener",
        "data-qe-id": "footer_about"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_about')), 1)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return link('sitemap');
        }),
        name: "footer",
        "data-qe-id": "footer_sitemap"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_sitemap')), 1)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return link('agb');
        }),
        name: "footer",
        "data-qe-id": "footer_agb"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_agb')), 1)]), withdrawal.value ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_3, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return link('withdrawal');
        }),
        "data-qe-id": "footer_withdrawal"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_withdrawal')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return link('privacy');
        }),
        name: "footer",
        "data-qe-id": "footer_privacy"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_privacy')), 1)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return link('partner');
        }),
        name: "footer",
        "data-qe-id": "footer_partner"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_partner')), 1)]), accessibility.value ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_4, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[9] || (_cache[9] = function ($event) {
          return link('accessibility');
        }),
        "data-qe-id": "footer_accessibility"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_accessibility')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return link('jobs');
        }),
        target: "_blank",
        name: "footer",
        rel: "noopener",
        "data-qe-id": "footer_jobs"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_jobs')), 1)])])])]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_hoisted_5, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [availableLocales.value.length > 0 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_hoisted_6, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", entry_lib_no_default_hoisted_7, [availableLocales.value.indexOf('en-US') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_8, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return flag('en');
        }),
        class: "us_flag",
        "data-qe-id": "footer_flag_en"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_en')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('en-GB') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_9, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[12] || (_cache[12] = function ($event) {
          return flag('en-GB');
        }),
        class: "uk_flag",
        "data-qe-id": "footer_flag_en_gb"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_gb')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('es-US') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_10, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[13] || (_cache[13] = function ($event) {
          return flag('es-US');
        }),
        class: "us_flag",
        "data-qe-id": "footer_flag_es_US"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_es_US')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('es-ES') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_11, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[14] || (_cache[14] = function ($event) {
          return flag('es');
        }),
        class: "es_flag",
        "data-qe-id": "footer_flag_es"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_es')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('fr-FR') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_12, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[15] || (_cache[15] = function ($event) {
          return flag('fr');
        }),
        class: "fr_flag",
        "data-qe-id": "footer_flag_fr"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_fr')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('nl-NL') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_13, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[16] || (_cache[16] = function ($event) {
          return flag('nl');
        }),
        class: "nl_flag",
        "data-qe-id": "footer_flag_nl"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_nl')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('sv-SE') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_14, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[17] || (_cache[17] = function ($event) {
          return flag('sv');
        }),
        class: "se_flag",
        "data-qe-id": "footer_flag_sv"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_sv')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('da-DK') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_15, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[18] || (_cache[18] = function ($event) {
          return flag('da');
        }),
        class: "dk_flag",
        "data-qe-id": "footer_flag_da"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_dk')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('de-DE') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_16, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[19] || (_cache[19] = function ($event) {
          return flag('de');
        }),
        class: "de_flag",
        "data-qe-id": "footer_flag_de"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_de')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('de-AT') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_17, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[20] || (_cache[20] = function ($event) {
          return flag('de');
        }),
        class: "at_flag",
        "data-qe-id": "footer_flag_de_at"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_at')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_hoisted_18, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.copyright', {
        year: new Date().getFullYear()
      })), 1)])], 2)], 512)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
    };
  }
}));
;// ./src/components/GdFooter.vue?vue&type=script&setup=true&lang=ts
 
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdFooter.vue?vue&type=style&index=0&id=0c958638&scoped=true&lang=less
// extracted by mini-css-extract-plugin

;// ./src/components/GdFooter.vue?vue&type=style&index=0&id=0c958638&scoped=true&lang=less

// EXTERNAL MODULE: ../../node_modules/vue-loader/dist/exportHelper.js
var entry_lib_no_default_exportHelper = __webpack_require__(7433);
;// ./src/components/GdFooter.vue



;


const entry_lib_no_default_exports_ = /*#__PURE__*/(0,entry_lib_no_default_exportHelper/* default */.A)(entry_lib_no_default_GdFootervue_type_script_setup_true_lang_ts, [['__scopeId',"data-v-0c958638"]])

/* harmony default export */ var entry_lib_no_default_GdFooter = (entry_lib_no_default_exports_);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdFooterLoggedOut.vue?vue&type=script&setup=true&lang=ts



var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_1 = {
  id: "sectionFooterNavigation"
};
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_2 = {
  id: "bottomnav"
};
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_3 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_4 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_5 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_6 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_7 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_8 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_9 = {
  key: 0
};
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_10 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_11 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_12 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_13 = {
  key: 1
};
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_14 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_15 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_16 = {
  key: 2
};
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_17 = ["href"];
var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_18 = {
  id: "gdfooterContainer"
};
var entry_lib_no_default_hoisted_19 = {
  key: 0,
  id: "locales"
};
var entry_lib_no_default_hoisted_20 = {
  class: "footerflags"
};
var entry_lib_no_default_hoisted_21 = {
  key: 0
};
var entry_lib_no_default_hoisted_22 = {
  key: 1
};
var entry_lib_no_default_hoisted_23 = {
  key: 2
};
var entry_lib_no_default_hoisted_24 = {
  key: 3
};
var entry_lib_no_default_hoisted_25 = {
  key: 4
};
var entry_lib_no_default_hoisted_26 = {
  key: 5
};
var entry_lib_no_default_hoisted_27 = {
  key: 6
};
var entry_lib_no_default_hoisted_28 = {
  key: 7
};
var entry_lib_no_default_hoisted_29 = {
  key: 8
};
var entry_lib_no_default_hoisted_30 = {
  key: 9
};
var entry_lib_no_default_hoisted_31 = {
  class: "copyright"
};



// call setupComponentI18n - otherwise the footer has no texts in "blank" -mode
/* harmony default export */ var entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts = (/*@__PURE__*/(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'GdFooterLoggedOut',
  props: {
    flags: Boolean,
    locales: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    blank: Boolean,
    viewCountry: String,
    viewLang: String
  },
  emits: ['link', 'flag'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    entry_lib_no_default_setupComponentI18n({});
    var props = __props;
    var footer = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    var availableLocales = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.locales || [];
    });
    var emit = __emit;
    var withdrawal = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var countries = ['DE', 'AT', 'GB', 'FR', 'NL', 'DK', 'SE', 'ES'];
      return countries.includes(props.viewCountry);
    });
    var accessibility = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var gd = new entry_lib_no_default_dist_Storage().read(entry_lib_no_default_STORE_NAME.GD);
      return gd.decisions.indexOf('fe-accessibility-page') > -1;
    });
    var glossary = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var _props$viewCountry, _props$viewLang;
      return ['DE', 'US'].indexOf((_props$viewCountry = props.viewCountry) !== null && _props$viewCountry !== void 0 ? _props$viewCountry : '') !== -1 || ['fr', 'nl'].indexOf((_props$viewLang = props.viewLang) !== null && _props$viewLang !== void 0 ? _props$viewLang : '') !== -1;
    });
    var link = function link(page) {
      emit('link', page);
    };
    var setBodyBottomPadding = function setBodyBottomPadding() {
      if (footer.value) {
        var height = footer.value.clientHeight;
        document.body.style.paddingBottom = "".concat(height, "px");
      }
    };
    (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(function () {
      window.addEventListener('resize', setBodyBottomPadding);
      setBodyBottomPadding();
    });
    return function (_ctx, _cache) {
      return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("footer", {
        ref_key: "footer",
        ref: footer,
        id: "footer"
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        id: "gdfooter",
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(__props.blank ? 'tpl-minimal' : '')
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_1, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_2, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.home'),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return link('home');
        }),
        name: "footer",
        "data-qe-id": "footer_home"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_home')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_3)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.impressum'),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return link('impressum');
        }),
        name: "footer",
        "data-qe-id": "footer_impressum"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_impressum')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_4)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.contact'),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return link('contact');
        }),
        name: "footer",
        "data-qe-id": "footer_contact"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_contact')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_5)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.about'),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return link('about');
        }),
        name: "footer",
        target: "_blank",
        rel: "noopener",
        "data-qe-id": "footer_about"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_about')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_6)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.sitemap'),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return link('sitemap');
        }),
        name: "footer",
        "data-qe-id": "footer_sitemap"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_sitemap')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_7)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.agb'),
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return link('agb');
        }),
        name: "footer",
        "data-qe-id": "footer_agb"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_agb')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_8)]), withdrawal.value ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_9, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.withdrawal'),
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return link('withdrawal');
        }),
        "data-qe-id": "footer_withdrawal"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_withdrawal')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_10)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.privacy'),
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return link('privacy');
        }),
        name: "footer",
        "data-qe-id": "footer_privacy"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_privacy')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_11)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.partner'),
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return link('partner');
        }),
        name: "footer",
        "data-qe-id": "footer_partner"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_partner')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_12)]), accessibility.value ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_13, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.accessibility'),
        onClick: _cache[9] || (_cache[9] = function ($event) {
          return link('accessibility');
        }),
        "data-qe-id": "footer_accessibility"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_accessibility')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_14)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("li", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.jobs'),
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return link('jobs');
        }),
        target: "_blank",
        rel: "noopener",
        name: "footer",
        "data-qe-id": "footer_jobs"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_jobs')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_15)]), glossary.value ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_16, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        href: _ctx.$t('seoFooterLinks.nav.glossary'),
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return link('jobs');
        }),
        target: "_blank",
        rel: "noopener",
        name: "footer",
        "data-qe-id": "footer_jobs"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.link_glossary')), 9, entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_17)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts_hoisted_18, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [availableLocales.value.length > 0 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_hoisted_19, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", entry_lib_no_default_hoisted_20, [availableLocales.value.indexOf('en-US') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_21, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[12] || (_cache[12] = function ($event) {
          return _ctx.$emit('flag', 'en');
        }),
        href: "/gd/switchLanguage?lang=en_US",
        class: "us_flag",
        "data-qe-id": "footer_flag_en"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_en')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('en-GB') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_22, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[13] || (_cache[13] = function ($event) {
          return _ctx.$emit('flag', 'en-GB');
        }),
        href: "/gd/switchLanguage?lang=en_GB",
        class: "uk_flag",
        "data-qe-id": "footer_flag_en_gb"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_gb')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('es-US') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_23, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[14] || (_cache[14] = function ($event) {
          return _ctx.$emit('flag', 'es-US');
        }),
        href: "/gd/switchLanguage?lang=es_US",
        class: "us_flag",
        "data-qe-id": "footer_flag_es_US"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_es_US')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('es-ES') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_24, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[15] || (_cache[15] = function ($event) {
          return _ctx.$emit('flag', 'es');
        }),
        href: "/gd/switchLanguage?lang=es_ES",
        class: "es_flag",
        "data-qe-id": "footer_flag_es"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_es')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('fr-FR') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_25, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[16] || (_cache[16] = function ($event) {
          return _ctx.$emit('flag', 'fr');
        }),
        href: "/gd/switchLanguage?lang=fr_FR",
        class: "fr_flag",
        "data-qe-id": "footer_flag_fr"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_fr')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('nl-NL') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_26, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[17] || (_cache[17] = function ($event) {
          return _ctx.$emit('flag', 'nl');
        }),
        href: "/gd/switchLanguage?lang=nl_NL",
        class: "nl_flag",
        "data-qe-id": "footer_flag_nl"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_nl')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('sv-SE') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_27, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[18] || (_cache[18] = function ($event) {
          return _ctx.$emit('flag', 'sv');
        }),
        href: "/gd/switchLanguage?lang=sv_SE",
        class: "se_flag",
        "data-qe-id": "footer_flag_sv"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_sv')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('da-DK') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_28, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[19] || (_cache[19] = function ($event) {
          return _ctx.$emit('flag', 'da');
        }),
        href: "/gd/switchLanguage?lang=da_DK",
        class: "dk_flag",
        "data-qe-id": "footer_flag_da"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_dk')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('de-DE') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_29, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[20] || (_cache[20] = function ($event) {
          return _ctx.$emit('flag', 'de');
        }),
        href: "/gd/switchLanguage?lang=de_DE",
        class: "de_flag",
        "data-qe-id": "footer_flag_de"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_de')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), availableLocales.value.indexOf('de-AT') !== -1 ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", entry_lib_no_default_hoisted_30, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        onClick: _cache[21] || (_cache[21] = function ($event) {
          return _ctx.$emit('flag', 'de');
        }),
        href: "/gd/switchLanguage?lang=de_AT",
        class: "at_flag",
        "data-qe-id": "footer_flag_de_at"
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.flags_at')), 1)])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_hoisted_31, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('tpl.footer.copyright', {
        year: new Date().getFullYear()
      })), 1)])], 2)], 512);
    };
  }
}));
;// ./src/components/GdFooterLoggedOut.vue?vue&type=script&setup=true&lang=ts
 
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdFooterLoggedOut.vue?vue&type=style&index=0&id=33ef2422&scoped=true&lang=less
// extracted by mini-css-extract-plugin

;// ./src/components/GdFooterLoggedOut.vue?vue&type=style&index=0&id=33ef2422&scoped=true&lang=less

;// ./src/components/GdFooterLoggedOut.vue



;


const entry_lib_no_default_GdFooterLoggedOut_exports_ = /*#__PURE__*/(0,entry_lib_no_default_exportHelper/* default */.A)(entry_lib_no_default_GdFooterLoggedOutvue_type_script_setup_true_lang_ts, [['__scopeId',"data-v-33ef2422"]])

/* harmony default export */ var entry_lib_no_default_GdFooterLoggedOut = (entry_lib_no_default_GdFooterLoggedOut_exports_);
;// ./src/lib/textUtils.ts
/**
 * removes all spaces from given string and returns the string without spaces
 * @param s
 * @returns
 */
function entry_lib_no_default_removeSpace(s) {
  var sReturn = '';
  for (var i = 0; i < s.length; i++) {
    if ([' ', ' ', '  '].indexOf(s[i]) === -1) sReturn += s[i];
  }
  return sReturn;
}
/**
 * register this in @beforeinput to avoid any space input
 * @param event
 * @returns
 */
function entry_lib_no_default_beforeInputIgnoreSpace(event) {
  if ([' ', ' ', '  '].indexOf(event.data) !== -1) {
    event.preventDefault();
  }
  return;
}

;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdLogin.vue?vue&type=script&setup=true&lang=ts


var entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_1 = {
  id: "accountbox",
  class: "gd-login"
};
var entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_2 = ["href"];
var entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_3 = ["placeholder"];
var entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_4 = ["placeholder"];
var entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_5 = ["value"];


var entry_lib_no_default_loginUrl = '/gd/j_security_check';
/* harmony default export */ var entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts = (/*@__PURE__*/(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'GdLogin',
  setup: function setup(__props) {
    var buttonProgress = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var username = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    var password = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    // beforeInputIgnoreSpace = (e) => {
    //   // Your implementation of beforeInputIgnoreSpace
    // }
    // removeSpace = (val) => {
    //   // Your implementation of removeSpace
    // }
    var onUsernameInput = function onUsernameInput(value) {
      username.value = entry_lib_no_default_removeSpace(value);
    };
    var action = function action() {
      if (!password.value) password.value = '';
      buttonProgress.value = true;
      setTimeout(function () {
        // in case of trouble reset the button after some seconds
        buttonProgress.value = false;
      }, 10000);
    };
    var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return function (_ctx, _cache) {
      var _component_t_button = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("t-button");
      return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_1, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "newHereLink",
        "data-qe-id": "registration-link",
        class: "newHere",
        href: _ctx.$t('seoNaviLinks.login.registration')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('login.main.registration_link')), 9, entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_2)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("form", {
        action: entry_lib_no_default_loginUrl,
        onSubmit: action,
        method: "POST"
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
        "data-qe-id": "input-name",
        type: "text",
        name: "j_username",
        tabindex: "7",
        maxlength: "60",
        placeholder: _ctx.$t('login.main.placeholder_nameOnly'),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return username.value = $event;
        }),
        onInput: _cache[1] || (_cache[1] = function ($event) {
          return onUsernameInput($event.target.value);
        }),
        onBeforeinput: _cache[2] || (_cache[2] =
        //@ts-ignore
        function () {
          return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(entry_lib_no_default_beforeInputIgnoreSpace) && (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(entry_lib_no_default_beforeInputIgnoreSpace).apply(void 0, arguments);
        })
      }, null, 40, entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_3), [[entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.vModelText, username.value]])]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
        id: "ct-login-password",
        "data-qe-id": "input-password",
        type: "password",
        name: "j_password",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return password.value = $event;
        }),
        tabindex: "8",
        maxlength: "100",
        placeholder: _ctx.$t('login.main.placeholder_password')
      }, null, 8, entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_4), [[entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.vModelText, password.value]]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
        "data-qe-id": "input-password-score",
        name: "tz",
        type: "hidden",
        value: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(userTimeZone)
      }, null, 8, entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts_hoisted_5), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_t_button, {
        disabled: buttonProgress.value,
        id: "loginLink",
        "data-qe-id": "login",
        s: "",
        midGreen: "",
        progress: buttonProgress.value
      }, {
        default: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.$t('login.main.button')), 1)];
        }),
        _: 1
      }, 8, ["disabled", "progress"])])], 32)]);
    };
  }
}));
;// ./src/components/GdLogin.vue?vue&type=script&setup=true&lang=ts
 
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdLogin.vue?vue&type=style&index=0&id=e56c8fe4&scoped=true&lang=less
// extracted by mini-css-extract-plugin

;// ./src/components/GdLogin.vue?vue&type=style&index=0&id=e56c8fe4&scoped=true&lang=less

;// ./src/components/GdLogin.vue



;


const entry_lib_no_default_GdLogin_exports_ = /*#__PURE__*/(0,entry_lib_no_default_exportHelper/* default */.A)(entry_lib_no_default_GdLoginvue_type_script_setup_true_lang_ts, [['__scopeId',"data-v-e56c8fe4"]])

/* harmony default export */ var entry_lib_no_default_GdLogin = (entry_lib_no_default_GdLogin_exports_);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.concat.js
var entry_lib_no_default_es_array_concat = __webpack_require__(6411);
;// ../../node_modules/@gd/jslog/dist/lib/sendTrace.js
function entry_lib_no_default_getDeviceInfo() {
    return {
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        touchPoints: window.navigator.maxTouchPoints,
        pixelratio: window.devicePixelRatio,
        mouseSupport: matchMedia('(pointer:fine)').matches,
        mobileFlag: navigator.userAgentData && navigator.userAgentData.mobile,
    };
}
function entry_lib_no_default_sendErrorTrace(_a) {
    var error = _a.error, data = _a.data;
    return fetch('/gd/rest/jslog/error', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            device: entry_lib_no_default_getDeviceInfo(),
            name: error.name,
            message: error.message,
            stack: error.stack,
            url: document.location.href,
            data: data,
        }),
    });
}
function entry_lib_no_default_sendTrace(_a) {
    var name = _a.name, data = _a.data;
    return fetch('/gd/rest/jslog/log', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            device: entry_lib_no_default_getDeviceInfo(),
            name: name,
            url: document.location.href,
            data: data,
        }),
    });
}
//# sourceMappingURL=sendTrace.js.map
;// ../../node_modules/@gd/jslog/dist/Jslog.js

var entry_lib_no_default_Stacktrace = /** @class */ (function () {
    /**
     *
     * @param data
     */
    function Stacktrace() {
        // avoid double registration
        // if ((window as any).__error_handling) {
        //   return
        // }
        // (window as any).__error_handling = true
        window.onerror = function (message, source, lineno, colno, error) {
            var err = error;
            if (!err) {
                err = {
                    message: message || '',
                    name: 'ERROR',
                    stack: 'NO_STACK_AVAILABLE',
                };
            }
            entry_lib_no_default_sendErrorTrace({
                error: err,
                data: {
                    path: window.location.pathname,
                    source: source || '',
                    line: lineno || '',
                    message: message || '',
                    colno: colno || '',
                },
            });
            // When the function returns true, this prevents the firing of the default event handler.
            return false;
        };
        // window.onunhandledrejection = event => {
        //   console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`, event);
        // }
    }
    /**
     * Send error trace
     */
    Stacktrace.prototype.send = function (conf) {
        if (conf && conf.error) {
            return entry_lib_no_default_sendErrorTrace({ error: conf.error, data: conf.data || {} });
        }
        else if (conf) {
            return entry_lib_no_default_sendTrace({ name: conf.name || 'DEFAULT_LOG', data: conf.data || {} });
        }
        else {
            return entry_lib_no_default_sendTrace({ name: 'DEFAULT_LOG', data: {} });
        }
    };
    return Stacktrace;
}());
/* harmony default export */ var entry_lib_no_default_Jslog = (entry_lib_no_default_Stacktrace);
//# sourceMappingURL=Jslog.js.map
;// ../../node_modules/@gd/jslog/dist/index.js

// initialize standard tracking
var entry_lib_no_default_jslog = new entry_lib_no_default_Jslog();

//# sourceMappingURL=index.js.map
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdHeader.vue?vue&type=script&setup=true&lang=ts




var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_1 = {
  id: "navigation_top"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_2 = {
  id: "gdLogos"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_3 = {
  key: 0,
  class: "flake flake1"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_4 = {
  key: 1,
  class: "flake flake2"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_5 = {
  key: 2,
  class: "flake flake3"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_6 = {
  key: 3,
  class: "flake flake4"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_7 = {
  key: 4,
  class: "flake flake5"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_8 = {
  key: 5,
  class: "lightChain"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_9 = {
  key: 6,
  class: "chainAnim"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_10 = ["href"];
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_11 = {
  key: 2,
  class: "black-ribbon-logo"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_12 = ["href"];
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_13 = {
  id: "sectionAccountBox"
};
var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_14 = {
  id: "sectionNavigation"
};



/* harmony default export */ var entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts = (/*@__PURE__*/(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'GdHeader',
  props: {
    minimal: {
      type: Boolean,
      default: true
    },
    theme: String,
    headerBlank: {
      type: Boolean,
      default: true
    },
    partner: Object,
    blackRibbon: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var themeProp = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.blackRibbon || !props.headerBlank ? '' : props.theme;
    });
    var knownPartners = ['dsk', 'skt', 'bec', 'mpu'];
    var coPartner = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var partner = props.partner;
      if (partner && knownPartners.indexOf(partner.name) === -1) {
        if (partner !== null && partner !== void 0 && partner.name) {
          entry_lib_no_default_jslog.send({
            name: 'classic-template-unknown-copartner',
            data: {
              partner: partner
            }
          });
        }
        return {
          name: '',
          url: ''
        };
      }
      return partner;
    });
    var gameNightGametype = new entry_lib_no_default_dist_Storage().read(entry_lib_no_default_STORE_NAME.GD).gameNightGametype;
    return function (_ctx, _cache) {
      return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("header", {
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["gd-header", [themeProp.value, __props.headerBlank ? '' : 'gd-header--blank']])
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_1, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_2, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.Transition, {
        name: "fade"
      }, {
        default: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [__props.headerBlank && themeProp.value === 'gd20' ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
            key: 0,
            class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(['animCont', {
              partner: coPartner.value.name
            }])
          }, _cache[0] || (_cache[0] = [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            class: "flagsAnim"
          }, null, -1), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            class: "balloonAnim"
          }, null, -1)]), 2)) : themeProp.value === 'spring' || themeProp.value === 'summer' || themeProp.value === 'autumn' || themeProp.value === 'winter' || themeProp.value === 'climate' || themeProp.value === 'silvester' || themeProp.value === 'christmas' || themeProp.value === 'easter' || themeProp.value === 'gameNight' ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
            key: 1,
            class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(['animCont', {
              partner: coPartner.value.name
            }])
          }, [_cache[1] || (_cache[1] = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            class: "glow"
          }, null, -1)), __props.headerBlank ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_3)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), __props.headerBlank ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_4)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), __props.headerBlank ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_5)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), __props.headerBlank ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_6)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), __props.headerBlank ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_7)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), __props.headerBlank ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_8)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), __props.headerBlank ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_9)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
        }),
        _: 1
      }), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(gameNightGametype) ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("a", {
        key: 0,
        href: "/gd/s03.do?gametype=".concat((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(gameNightGametype), "&ref=gameNightLogo"),
        target: "_top",
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({
          disabled: !__props.headerBlank
        })
      }, _cache[2] || (_cache[2] = [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        id: "poweredByLogo",
        class: "gameduell-brand"
      }, null, -1)]), 10, entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_10)) : ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("a", {
        key: 1,
        href: "/gd/",
        target: "_top",
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({
          disabled: !__props.headerBlank
        })
      }, _cache[3] || (_cache[3] = [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        id: "poweredByLogo",
        class: "gameduell-brand"
      }, null, -1)]), 2)), __props.blackRibbon ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_11)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), coPartner.value.name && !__props.blackRibbon ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("a", {
        key: 3,
        href: coPartner.value.url || '/gd/'
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        id: "partnerLogo",
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["gameduell-brand", "partner_".concat(coPartner.value.name, " ").concat(coPartner.value.name ? 'partner' : '')])
      }, null, 2)], 8, entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_12)) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_13, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.Transition, {
        name: "fade-nav"
      }, {
        default: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [__props.headerBlank ? (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "accountbox", {
            key: 0
          }) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
        }),
        _: 3
      })]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts_hoisted_14, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.Transition, {
        name: "fade-nav"
      }, {
        default: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [__props.headerBlank ? (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "navigation-tabs", {
            key: 0
          }) : (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
        }),
        _: 3
      })])])], 2);
    };
  }
}));
;// ./src/components/GdHeader.vue?vue&type=script&setup=true&lang=ts
 
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdHeader.vue?vue&type=style&index=0&id=4a64d8ee&scoped=true&lang=less
// extracted by mini-css-extract-plugin

;// ./src/components/GdHeader.vue?vue&type=style&index=0&id=4a64d8ee&scoped=true&lang=less

;// ./src/components/GdHeader.vue



;


const entry_lib_no_default_GdHeader_exports_ = /*#__PURE__*/(0,entry_lib_no_default_exportHelper/* default */.A)(entry_lib_no_default_GdHeadervue_type_script_setup_true_lang_ts, [['__scopeId',"data-v-4a64d8ee"]])

/* harmony default export */ var entry_lib_no_default_GdHeader = (entry_lib_no_default_GdHeader_exports_);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdNavigationTabs.vue?vue&type=script&setup=true&lang=ts


var entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_1 = ["data-title"];
var entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_2 = ["data-title"];
var entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_3 = ["data-title"];
var entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_4 = ["data-title"];
var entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_5 = ["data-title"];


/* harmony default export */ var entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts = (/*@__PURE__*/(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'GdNavigationTabs',
  props: {
    loyalty: {
      type: String,
      default: ''
    },
    tab: {
      type: String,
      default: 'home'
    }
  },
  emits: ['link'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _setupComponentI18n = entry_lib_no_default_setupComponentI18n({}),
      t = _setupComponentI18n.t;
    var props = __props;
    var loyaltyClass = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return 'loyalty-' + props.loyalty.toUpperCase();
    });
    var emit = __emit;
    // onMounted(() => {
    //   Object.keys(i18n.messages).forEach((lang) => {
    //     $i18n.setLocaleMessage(lang, merge($i18n.messages[lang] || {}, i18n.messages[lang]))
    //   })
    // })
    var link = function link(tab, event) {
      emit('link', tab, event);
    };
    return function (_ctx, _cache) {
      return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        id: "navigationTabs",
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(loyaltyClass.value)
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviHomeLink",
        "data-qe-id": "navigation_home",
        href: "/gd/homepage/home.xhtml",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return link('home', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'home' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.home')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.home')), 11, entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_1), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviGamesLink",
        "data-qe-id": "navigation_games",
        href: "/gd/gamesPage/gamespage.xhtml",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return link('games', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'games' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.games')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.games')), 11, entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_2), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviMygdLink",
        "data-qe-id": "navigation_myGameduell",
        href: "/gd/myGameDuell/playerInfo.xhtml",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return link('myGameduell', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'myGameduell' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.myGameduell')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.myGameduell')), 11, entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_3), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviCommunityLink",
        "data-qe-id": "navigation_community",
        href: "/gd/playerProfile/showProfile.xhtml",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return link('community', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'community' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.community')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.community')), 11, entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_4), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviInfoHelpLink",
        "data-qe-id": "navigation_help",
        href: "/gd/help/help.xhtml",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return link('infoAndHelp', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'infoAndHelp' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.infoAndHelp')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.infoAndHelp')), 11, entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts_hoisted_5)], 2);
    };
  }
}));
;// ./src/components/GdNavigationTabs.vue?vue&type=script&setup=true&lang=ts
 
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdNavigationTabs.vue?vue&type=style&index=0&id=f8138d06&scoped=true&lang=less
// extracted by mini-css-extract-plugin

;// ./src/components/GdNavigationTabs.vue?vue&type=style&index=0&id=f8138d06&scoped=true&lang=less

;// ./src/components/GdNavigationTabs.vue



;


const entry_lib_no_default_GdNavigationTabs_exports_ = /*#__PURE__*/(0,entry_lib_no_default_exportHelper/* default */.A)(entry_lib_no_default_GdNavigationTabsvue_type_script_setup_true_lang_ts, [['__scopeId',"data-v-f8138d06"]])

/* harmony default export */ var entry_lib_no_default_GdNavigationTabs = (entry_lib_no_default_GdNavigationTabs_exports_);
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdNavigationTabsLoggedOut.vue?vue&type=script&setup=true&lang=ts


var entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_1 = ["href", "data-title"];
var entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_2 = ["href", "data-title"];
var entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_3 = ["href", "data-title"];
var entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_4 = ["href", "data-title"];
var entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_5 = ["href", "data-title"];


/* harmony default export */ var entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts = (/*@__PURE__*/(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'GdNavigationTabsLoggedOut',
  props: {
    loyalty: {
      type: String,
      default: ''
    },
    tab: {
      type: String,
      default: 'home'
    }
  },
  emits: ['link'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _setupComponentI18n = entry_lib_no_default_setupComponentI18n({}),
      t = _setupComponentI18n.t;
    var props = __props;
    var loyaltyClass = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return 'loyalty-' + props.loyalty.toUpperCase();
    });
    var emit = __emit;
    var link = function link(tab, event) {
      emit('link', tab, event);
    };
    return function (_ctx, _cache) {
      return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        id: "navigationTabs",
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(loyaltyClass.value)
      }, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviHomeLink",
        "data-qe-id": "navigation_home",
        href: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('seoNaviLinks.tabNavigation.home'),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return link('home', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'home' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.home')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.home')), 11, entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_1), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviGamesLink",
        "data-qe-id": "navigation_games",
        href: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('seoNaviLinks.tabNavigation.games'),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return link('games', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'games' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.games')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.games')), 11, entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_2), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviMygdLink",
        "data-qe-id": "navigation_myGameduell",
        href: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('seoNaviLinks.tabNavigation.myGameduell'),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return link('myGameduell', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'myGameduell' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.myGameduell')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.myGameduell')), 11, entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_3), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviCommunityLink",
        "data-qe-id": "navigation_community",
        href: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('seoNaviLinks.tabNavigation.community'),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return link('community', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'community' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.community')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.community')), 11, entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_4), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
        id: "topNaviInfoHelpLink",
        "data-qe-id": "navigation_help",
        href: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('seoNaviLinks.tabNavigation.infoAndHelp'),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return link('infoAndHelp', $event);
        }),
        class: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([__props.tab === 'infoAndHelp' ? 'active' : '', "navigation_tab"]),
        "data-title": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.infoAndHelp')
      }, (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tpl.navigationTabs.infoAndHelp')), 11, entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts_hoisted_5)], 2);
    };
  }
}));
;// ./src/components/GdNavigationTabsLoggedOut.vue?vue&type=script&setup=true&lang=ts
 
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/GdNavigationTabsLoggedOut.vue?vue&type=style&index=0&id=054f68b3&scoped=true&lang=less
// extracted by mini-css-extract-plugin

;// ./src/components/GdNavigationTabsLoggedOut.vue?vue&type=style&index=0&id=054f68b3&scoped=true&lang=less

;// ./src/components/GdNavigationTabsLoggedOut.vue



;


const entry_lib_no_default_GdNavigationTabsLoggedOut_exports_ = /*#__PURE__*/(0,entry_lib_no_default_exportHelper/* default */.A)(entry_lib_no_default_GdNavigationTabsLoggedOutvue_type_script_setup_true_lang_ts, [['__scopeId',"data-v-054f68b3"]])

/* harmony default export */ var entry_lib_no_default_GdNavigationTabsLoggedOut = (entry_lib_no_default_GdNavigationTabsLoggedOut_exports_);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.promise.js
var entry_lib_no_default_es_promise = __webpack_require__(865);
;// ../../node_modules/mitt/dist/mitt.mjs
/* harmony default export */ function entry_lib_no_default_mitt(n){return{all:n=n||new Map,on:function(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e])},off:function(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]))},emit:function(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e)}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e)})}}}
//# sourceMappingURL=mitt.mjs.map

;// ../../node_modules/@gd/event-bus/dist/EventBus.js

var entry_lib_no_default_emitter = entry_lib_no_default_mitt();
entry_lib_no_default_emitter.once = function (type, fn) {
    entry_lib_no_default_emitter.on(type, fn);
    entry_lib_no_default_emitter.on(type, entry_lib_no_default_emitter.off.bind(entry_lib_no_default_emitter, type, fn));
};
var entry_lib_no_default_eventHandler = {
    $on: entry_lib_no_default_emitter.on,
    $once: entry_lib_no_default_emitter.once,
    $off: entry_lib_no_default_emitter.off,
    $emit: entry_lib_no_default_emitter.emit,
};
window.GD = window.GD || {};
// register hidden - it's bad practice when we register here directly
// to GD.event (registration on GD will be in the classic-gd module)
var entry_lib_no_default_eventBus = (window.GD.__eventBus = window.GD.__eventBus || entry_lib_no_default_eventHandler);
/* harmony default export */ var entry_lib_no_default_EventBus = (entry_lib_no_default_eventBus);
//# sourceMappingURL=EventBus.js.map
;// ../../node_modules/@gd/event-bus/dist/index.js

/* harmony default export */ var entry_lib_no_default_event_bus_dist = (entry_lib_no_default_EventBus);

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../accountbox/dist/accountbox.common.js
var entry_lib_no_default_accountbox_common = __webpack_require__(1743);
var entry_lib_no_default_accountbox_common_default = /*#__PURE__*/__webpack_require__.n(entry_lib_no_default_accountbox_common);
;// ../../node_modules/@gd/tracking/dist/track.js
/**
 *
 * @param object Transform object to a request parameter string
 */
function entry_lib_no_default_transformRequestParams(object) {
    if (object) {
        return ('?' +
            Object.keys(object)
                .map(function (key) { return key + '=' + object[key]; })
                .join('&'));
    }
    return '';
}
/**
 * Before doing changes in here please see the DOC in README.md. If you made changes please keep the doc up2date!!!
 *
 * @param key - main identifier e.g. the web application name
 * @param id - secondary identifier e.g. the module name
 * @param elem - the element short descriptive name e.g. play_button, terms_link...
 * @param action - if elem has special action
 * @param data - use this to pass any additional data
 */
function entry_lib_no_default_track(options, config) {
    var contextPath = config && config.stealthy === true ? '/gd/schellfisch' : '/gd/tracking';
    if (!options.key) {
        return new Promise(function () {
            throw 'INVALID TRACKING CALL - required property key is missing!';
        });
    }
    // TODO remove warnings if we have refactored tournaments-web, shop-web, shop-settings, shop-express
    // type (enum TYPE) and userType are not required to track anymore
    if (options.type || options.userType) {
        console.warn("deprecated tracking property ".concat(options.type ? '"type"' : '', " ").concat(options.userType ? '"userType"' : '', " detected"));
    }
    if (!options.id) {
        options.id = options.key;
    }
    if (config && config.beacon === true) {
        var succeeded = navigator.sendBeacon(contextPath + entry_lib_no_default_transformRequestParams(options));
        return Promise.resolve(succeeded);
    }
    else {
        return fetch(contextPath + entry_lib_no_default_transformRequestParams(options), {
            credentials: 'same-origin',
        });
    }
}
//# sourceMappingURL=track.js.map
;// ../../node_modules/@gd/tracking/dist/ACTION.js
/**
 * Enum for the ACTIONS - feel free to add some more if you need
 */
var entry_lib_no_default_ACTION;
(function (ACTION) {
    ACTION["close"] = "close";
    ACTION["show"] = "show";
    ACTION["click"] = "click";
    ACTION["delete"] = "delete";
    ACTION["check"] = "check";
    ACTION["uncheck"] = "uncheck";
    ACTION["clear"] = "clear";
    ACTION["change"] = "change";
    ACTION["changeView"] = "change_view";
    ACTION["callback"] = "callback";
    ACTION["play"] = "play";
    ACTION["startGame"] = "startGame";
    ACTION["startMatching"] = "startMatching";
    ACTION["cancelMatching"] = "cancelMatching";
    ACTION["demoGameResult"] = "demoGameResult";
    ACTION["autoCookieConsent"] = "consent";
    ACTION["autoCookieContinued"] = "continued";
})(entry_lib_no_default_ACTION || (entry_lib_no_default_ACTION = {}));
//# sourceMappingURL=ACTION.js.map
;// ../../node_modules/@gd/tracking/dist/index.js


/**
 * Make all of them public
 */
// export the function

// export the ACTION enum

//# sourceMappingURL=index.js.map
;// ../../node_modules/thread-loader/dist/cjs.js!../../node_modules/babel-loader/lib/index.js!../../node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/templates/GdTemplate.vue?vue&type=script&setup=true&lang=ts




var entry_lib_no_default_GdTemplatevue_type_script_setup_true_lang_ts_hoisted_1 = {
  class: "gd-template"
};









// defineOptions({
//   inheritAttrs: false,
// })
/**
 * @events: @onTabNav - if this is defined the default tab navigation will be disabled and instead the given handler is called with the url
 */
/* harmony default export */ var entry_lib_no_default_GdTemplatevue_type_script_setup_true_lang_ts = (/*@__PURE__*/(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  __name: 'GdTemplate',
  props: {
    loggedIn: {
      type: Boolean,
      default: true
    },
    tab: {
      type: String,
      default: 'games'
    },
    loyalty: String,
    blackRibbon: Boolean,
    theme: String,
    footerFlags: Array,
    footerBlank: {
      type: Boolean,
      default: false
    },
    footerShow: {
      type: Boolean,
      default: true
    },
    headerBlank: {
      type: Boolean,
      default: false
    },
    viewCountry: String,
    userCountry: String,
    viewLang: String,
    payoutUser: Boolean,
    partner: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          url: ''
        };
      }
    },
    onTabNav: Function
  },
  emits: ['flag', 'tabNav'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    // import i18n from '../i18n'
    var props = __props;
    var emit = __emit;
    var storage = new entry_lib_no_default_LocalStore({});
    var loggi = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var selectedTab = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(function () {
      return props.loggedIn;
    }, function (to) {
      loggi.value = to;
    });
    (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(function () {
      selectedTab.value = props.tab;
    });
    var footerViewCountry = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.viewCountry || storage.gd.viewCountry;
    });
    var footerLang = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.viewLang || storage.gd.viewLang;
    });
    var payout = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      if (props.payoutUser !== undefined) {
        return props.payoutUser;
      }
      if (storage.user) return storage.user.payout;
      return true;
    });
    var footerUserCountry = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var _storage$user;
      if (props.userCountry) {
        return props.userCountry;
      }
      if (storage !== null && storage !== void 0 && (_storage$user = storage.user) !== null && _storage$user !== void 0 && _storage$user.locale) return storage.user.locale.split('-')[1];
      return '';
    });
    var flags = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.footerFlags || storage.gd.supportedLocales;
    });
    var propLoyalty = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.loyalty || storage.user.loyalty;
    });
    var propTheme = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.theme || storage.gd.theme;
    });
    var coPartner = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.partner || storage.gd.partner;
    });
    var getBlackRibbon = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return props.blackRibbon || storage.gd.blackRibbon;
    });
    var navTab = (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return selectedTab;
    });
    var accountboxNavigationHandler = function accountboxNavigationHandler(nav) {
      var storage = new entry_lib_no_default_LocalStore({});
      entry_lib_no_default_track({
        key: 'accountbox',
        userId: storage.user.id,
        to: nav.type,
        data: storage.user.actorType === 'g' ? 'moneyplayer' : 'practiceplayer'
      }).then(function () {
        if (nav.button === 1) {
          window.open(nav.url, undefined, 'noopener');
        } else {
          location.href = nav.url;
        }
      });
    };
    var accountboxNavigationPaymentHandler = function accountboxNavigationPaymentHandler() {
      var storage = new entry_lib_no_default_LocalStore({});
      entry_lib_no_default_track({
        key: 'accountbox',
        userId: storage.user.id,
        to: 'deposit',
        data: storage.user.actorType === 'g' ? 'moneyplayer' : 'practiceplayer'
      }).then(function () {
        entry_lib_no_default_event_bus_dist.$emit('deposit', {
          trackingId: 'accountbox'
        });
      });
    };
    var loggedOutClickHandler = function loggedOutClickHandler(name, e) {
      // do default dev navigation
      onNavTab(name, e);
    };
    var onNavTab = function onNavTab(name, e) {
      selectedTab.value = name;
      e.preventDefault();
      var url = '';
      switch (name) {
        case 'home':
          url = '/gd/homepage/home.xhtml';
          break;
        case 'games':
          url = '/gd/gamesPage/gamespage.xhtml';
          break;
        case 'community':
          url = '/gd/playerProfile/showProfile.xhtml';
          break;
        case 'myGameduell':
          url = '/gd/myGameDuell/playerInfo.xhtml';
          break;
        case 'infoAndHelp':
          url = '/gd/help/help.xhtml';
          break;
      }
      if (props.onTabNav) {
        emit('tabNav', {
          url: url,
          name: name
        });
      } else {
        location.href = url || '#';
      }
    };
    var footerLink = function footerLink(name) {
      var url;
      switch (name) {
        case 'home':
          url = '/gd/homepage/home.xhtml';
          break;
        case 'impressum':
          url = '/gd/help/help.xhtml?page=help.impressum';
          break;
        case 'contact':
          url = '/gd/support/contact.xhtml';
          break;
        case 'about':
          url = 'https://inside.gameduell.com/#about';
          window.open(url, '_blank', 'noopener');
          return;
        case 'sitemap':
          url = '/gd/sitemap/index.xhtml';
          break;
        case 'agb':
          url = '/gd/help/agb.xhtml';
          break;
        case 'withdrawal':
          url = '/gd/help/withdrawal.xhtml';
          break;
        case 'privacy':
          url = '/gd/help/privacy.xhtml';
          break;
        case 'partner':
          url = '/gd/help/help.xhtml?page=help.partner';
          break;
        case 'accessibility':
          url = '/gd/help/accessibility.xhtml';
          break;
        case 'jobs':
          url = 'https://inside.gameduell.com/#jobs';
          window.open(url, '_blank', 'noopener');
          return;
        case 'mobile':
          url = '/gd/mobile/uiswitch/?desktop=false';
          break;
      }
      location.href = url || '#';
    };
    var languageSelect = function languageSelect(lang) {
      var l = '';
      // map languages to classic footer
      switch (lang) {
        case 'en':
          l = 'en_US';
          break;
        case 'en-GB':
          l = 'en_GB';
          break;
        case 'es':
          l = 'es_ES';
          break;
        case 'es-US':
          l = 'es_US';
          break;
        case 'fr':
          l = 'fr_FR';
          break;
        case 'nl':
          l = 'nl_NL';
          break;
        case 'sv':
          l = 'sv_SE';
          break;
        case 'da':
          l = 'da_DK';
          break;
        case 'de':
          l = 'de_DE';
          break;
        case 'de-AT':
          l = 'de_AT';
          break;
      }
      // this.$i18n.locale = lang // TODO: Is this safe to just comment out?
      // TODO udpate localeStorage
      var viewLang = l.split('_')[0];
      var viewCountry = l.split('_')[1];
      storage.storeGD({
        viewLang: viewLang,
        viewCountry: viewCountry
      });
      // send language switch to frontend
      fetch('/gd/switchLanguage?lang=' + l).then(function (res) {
        emit('flag', lang);
      }).catch(function (err) {
        emit('flag', lang);
      });
    };
    return function (_ctx, _cache) {
      return (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", entry_lib_no_default_GdTemplatevue_type_script_setup_true_lang_ts_hoisted_1, [(0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(entry_lib_no_default_GdHeader, {
        theme: propTheme.value,
        "header-blank": !__props.headerBlank,
        partner: coPartner.value,
        "black-ribbon": getBlackRibbon.value
      }, {
        accountbox: (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [__props.loggedIn ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((entry_lib_no_default_accountbox_common_default())), {
            key: 0,
            onOnShowProfile: accountboxNavigationHandler,
            onOnShowFriends: accountboxNavigationHandler,
            onOnShowMessages: accountboxNavigationHandler,
            onOnShowChallanges: accountboxNavigationHandler,
            onOnPayment: accountboxNavigationPaymentHandler,
            onOnLoyality: accountboxNavigationHandler,
            class: "accountbox-wrap"
          })) : ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(entry_lib_no_default_GdLogin, {
            key: 1,
            class: "gd-login-wrap"
          }))];
        }),
        "navigation-tabs": (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [__props.loggedIn ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(entry_lib_no_default_GdNavigationTabs), {
            key: 0,
            loyalty: propLoyalty.value,
            tab: navTab.value.value,
            onLink: onNavTab
          }, null, 8, ["loyalty", "tab"])) : ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(entry_lib_no_default_GdNavigationTabsLoggedOut), {
            key: 1,
            loyalty: propLoyalty.value,
            tab: navTab.value.value,
            onLink: loggedOutClickHandler
          }, null, 8, ["loyalty", "tab"]))];
        }),
        _: 1
      }, 8, ["theme", "header-blank", "partner", "black-ribbon"]), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default"), __props.loggedIn ? ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(entry_lib_no_default_GdFooter), {
        key: 0,
        blank: __props.footerBlank,
        show: __props.footerShow,
        locales: flags.value,
        "user-country": footerUserCountry.value,
        "payout-user": payout.value,
        onFlag: languageSelect,
        onLink: footerLink,
        class: "gd-footer"
      }, null, 8, ["blank", "show", "locales", "user-country", "payout-user"])) : ((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,entry_lib_no_default_external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(entry_lib_no_default_GdFooterLoggedOut), {
        key: 1,
        class: "gd-footer",
        "view-country": footerViewCountry.value,
        "view-lang": footerLang.value,
        blank: __props.footerBlank,
        locales: flags.value
      }, null, 8, ["view-country", "view-lang", "blank", "locales"]))]);
    };
  }
}));
;// ./src/templates/GdTemplate.vue?vue&type=script&setup=true&lang=ts
 
;// ../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-32.use[0]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-32.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-32.use[2]!../../node_modules/less-loader/dist/cjs.js??clonedRuleSet-32.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/templates/GdTemplate.vue?vue&type=style&index=0&id=23d8c301&lang=less
// extracted by mini-css-extract-plugin

;// ./src/templates/GdTemplate.vue?vue&type=style&index=0&id=23d8c301&lang=less

;// ./src/templates/GdTemplate.vue



;

const entry_lib_no_default_GdTemplate_exports_ = entry_lib_no_default_GdTemplatevue_type_script_setup_true_lang_ts;

/* harmony default export */ var entry_lib_no_default_GdTemplate = (entry_lib_no_default_GdTemplate_exports_);
;// ./src/main.ts














;// ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=classic-template.common.js.map